//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import moment from 'moment';

export const ApiBaseUrl = new InjectionToken<string>('ApiBaseUrl');

@Injectable({
    providedIn: 'root'
})
export class ActiveDirectoryMappingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getActiveDirectoryTagMappings(searchText?: string | null | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined, offset?: number | undefined, limit?: number | undefined): Observable<LimitedResultOfActiveDirectoryTagMappingViewModel> {
        let url_ = this.baseUrl + "/client/v1/ad-mapping/tag?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveDirectoryTagMappings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveDirectoryTagMappings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfActiveDirectoryTagMappingViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfActiveDirectoryTagMappingViewModel>;
        }));
    }

    protected processGetActiveDirectoryTagMappings(response: HttpResponseBase): Observable<LimitedResultOfActiveDirectoryTagMappingViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfActiveDirectoryTagMappingViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfActiveDirectoryTagMappingViewModel>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BlobClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    retrieveAsset(path: string): Observable<void> {
        let url_ = this.baseUrl + "/public/v1/assets/{path}";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRetrieveAsset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    retrieveBlobAsset(container: string, path: string): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/assets/{container}/{path}";
        if (container === undefined || container === null)
            throw new globalThis.Error("The parameter 'container' must be defined.");
        url_ = url_.replace("{container}", encodeURIComponent("" + container));
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveBlobAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveBlobAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRetrieveBlobAsset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    downloadAsset(container?: string | null | undefined, path?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/download?";
        if (container !== undefined && container !== null)
            url_ += "container=" + encodeURIComponent("" + container) + "&";
        if (path !== undefined && path !== null)
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadAsset(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getSasToken(container?: string | null | undefined, path?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/client/v1/sas?";
        if (container !== undefined && container !== null)
            url_ += "container=" + encodeURIComponent("" + container) + "&";
        if (path !== undefined && path !== null)
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSasToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSasToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetSasToken(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    retrieveBlobInformation(container: string, path: string): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/meta/{container}/{path}";
        if (container === undefined || container === null)
            throw new globalThis.Error("The parameter 'container' must be defined.");
        url_ = url_.replace("{container}", encodeURIComponent("" + container));
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveBlobInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveBlobInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRetrieveBlobInformation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CultureClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getSupportedCultures(): Observable<VoltCulture[]> {
        let url_ = this.baseUrl + "/public/v1/supported";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupportedCultures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupportedCultures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoltCulture[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoltCulture[]>;
        }));
    }

    protected processGetSupportedCultures(response: HttpResponseBase): Observable<VoltCulture[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VoltCulture.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VoltCulture[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ResendEmailClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    resendConfirmation(emailNotificationId: string, cultureName: string): Observable<void> {
        let url_ = this.baseUrl + "/public/v1/email/resend/{emailNotificationId}/{cultureName}";
        if (emailNotificationId === undefined || emailNotificationId === null)
            throw new globalThis.Error("The parameter 'emailNotificationId' must be defined.");
        url_ = url_.replace("{emailNotificationId}", encodeURIComponent("" + emailNotificationId));
        if (cultureName === undefined || cultureName === null)
            throw new globalThis.Error("The parameter 'cultureName' must be defined.");
        url_ = url_.replace("{cultureName}", encodeURIComponent("" + cultureName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendConfirmation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendConfirmation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResendConfirmation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    resend(emailNotificationId?: string | null | undefined, cultureName?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/public/v1/email/resend";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (emailNotificationId !== null && emailNotificationId !== undefined)
            content_.append("emailNotificationId", emailNotificationId.toString());
        if (cultureName !== null && cultureName !== undefined)
            content_.append("cultureName", cultureName.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResend(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResend(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TestClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    import(fileName?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/public/v1/test?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    importSupplier(): Observable<void> {
        let url_ = this.baseUrl + "/public/v1/test/importsupplier";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportSupplier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportSupplier(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportSupplier(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AccountCourseClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getAllAssignedCertifications(accountId?: number | undefined): Observable<CertificationViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/accountcourse/getallassignedcertifications?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAssignedCertifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAssignedCertifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CertificationViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CertificationViewModel[]>;
        }));
    }

    protected processGetAllAssignedCertifications(response: HttpResponseBase): Observable<CertificationViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CertificationViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CertificationViewModel[]>(null as any);
    }

    setCertifications(accountId?: number | undefined, certificationIds?: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/accountcourse/setcertifications?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        if (certificationIds !== undefined && certificationIds !== null)
            certificationIds && certificationIds.forEach(item => { url_ += "certificationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetCertifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetCertifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetCertifications(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AccountHierarchyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    add(addRequest?: AddRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/accounthierarchy/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getRelationsForAccountDetailsPage(sort?: string | null | undefined, accountId?: number | undefined, limit?: number | null | undefined, offset?: number | null | undefined, ascending?: boolean | undefined): Observable<LimitedResultOfGetResponse> {
        let url_ = this.baseUrl + "/client/v1/accounthierarchy/accountdetailsrelations?";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (ascending === null)
            throw new globalThis.Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "Ascending=" + encodeURIComponent("" + ascending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRelationsForAccountDetailsPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelationsForAccountDetailsPage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfGetResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfGetResponse>;
        }));
    }

    protected processGetRelationsForAccountDetailsPage(response: HttpResponseBase): Observable<LimitedResultOfGetResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfGetResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfGetResponse>(null as any);
    }

    getRelationsForMyAccountPage(sort?: string | null | undefined, accountId?: number | undefined, limit?: number | null | undefined, offset?: number | null | undefined, ascending?: boolean | undefined): Observable<LimitedResultOfGetResponse> {
        let url_ = this.baseUrl + "/client/v1/accounthierarchy/myaccountrelations?";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (ascending === null)
            throw new globalThis.Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "Ascending=" + encodeURIComponent("" + ascending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRelationsForMyAccountPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelationsForMyAccountPage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfGetResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfGetResponse>;
        }));
    }

    protected processGetRelationsForMyAccountPage(response: HttpResponseBase): Observable<LimitedResultOfGetResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfGetResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfGetResponse>(null as any);
    }

    getAllAccountsExceptServiceChannel(): Observable<AccountResponse[]> {
        let url_ = this.baseUrl + "/client/v1/accounthierarchy/getallaccountsexceptservicechannel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAccountsExceptServiceChannel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAccountsExceptServiceChannel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountResponse[]>;
        }));
    }

    protected processGetAllAccountsExceptServiceChannel(response: HttpResponseBase): Observable<AccountResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountResponse[]>(null as any);
    }

    getAllRelationships(): Observable<string[]> {
        let url_ = this.baseUrl + "/client/v1/accounthierarchy/getallrelationships";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRelationships(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRelationships(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllRelationships(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    delete(id?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/accounthierarchy/delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AccountsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getEula(accountId?: number | undefined, languageCode?: string | null | undefined): Observable<AccountEula> {
        let url_ = this.baseUrl + "/client/v1/accounts/eula?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        if (languageCode !== undefined && languageCode !== null)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEula(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEula(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountEula>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountEula>;
        }));
    }

    protected processGetEula(response: HttpResponseBase): Observable<AccountEula> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountEula.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ApiErrorOfRequestTokenErrors.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountEula>(null as any);
    }

    getAccountsFromParams(accountIds?: number[] | null | undefined, fieldGroupTypes?: string[] | null | undefined, supplierNumbers?: string[] | null | undefined, status?: StatusTypes | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined, offset?: number | undefined, limit?: number | undefined): Observable<LimitedResultOfAccountsPage> {
        let url_ = this.baseUrl + "/client/v1/accounts/from-params?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (fieldGroupTypes !== undefined && fieldGroupTypes !== null)
            fieldGroupTypes && fieldGroupTypes.forEach(item => { url_ += "FieldGroupTypes=" + encodeURIComponent("" + item) + "&"; });
        if (supplierNumbers !== undefined && supplierNumbers !== null)
            supplierNumbers && supplierNumbers.forEach(item => { url_ += "SupplierNumbers=" + encodeURIComponent("" + item) + "&"; });
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountsFromParams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountsFromParams(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfAccountsPage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfAccountsPage>;
        }));
    }

    protected processGetAccountsFromParams(response: HttpResponseBase): Observable<LimitedResultOfAccountsPage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfAccountsPage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfAccountsPage>(null as any);
    }

    getAccountsExportFromParams(accountIds?: number[] | null | undefined, fieldGroupTypes?: string[] | null | undefined, supplierNumbers?: string[] | null | undefined, status?: StatusTypes | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined, offset?: number | undefined, limit?: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/accounts/export/from-params?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (fieldGroupTypes !== undefined && fieldGroupTypes !== null)
            fieldGroupTypes && fieldGroupTypes.forEach(item => { url_ += "FieldGroupTypes=" + encodeURIComponent("" + item) + "&"; });
        if (supplierNumbers !== undefined && supplierNumbers !== null)
            supplierNumbers && supplierNumbers.forEach(item => { url_ += "SupplierNumbers=" + encodeURIComponent("" + item) + "&"; });
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountsExportFromParams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountsExportFromParams(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetAccountsExportFromParams(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getStoreSupportList(activity?: EActivityNames | undefined, locationNumber?: string | null | undefined): Observable<StoreSupportAccount[]> {
        let url_ = this.baseUrl + "/client/v1/accounts/store-support-list?";
        if (activity === null)
            throw new globalThis.Error("The parameter 'activity' cannot be null.");
        else if (activity !== undefined)
            url_ += "activity=" + encodeURIComponent("" + activity) + "&";
        if (locationNumber !== undefined && locationNumber !== null)
            url_ += "locationNumber=" + encodeURIComponent("" + locationNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStoreSupportList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStoreSupportList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreSupportAccount[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreSupportAccount[]>;
        }));
    }

    protected processGetStoreSupportList(response: HttpResponseBase): Observable<StoreSupportAccount[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoreSupportAccount.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ApiErrorOfRequestTokenErrors.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StoreSupportAccount[]>(null as any);
    }

    getFieldGroupTypeList(): Observable<FieldGroupTypeViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/accounts/fieldgrouptypelist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFieldGroupTypeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFieldGroupTypeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FieldGroupTypeViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FieldGroupTypeViewModel[]>;
        }));
    }

    protected processGetFieldGroupTypeList(response: HttpResponseBase): Observable<FieldGroupTypeViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FieldGroupTypeViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FieldGroupTypeViewModel[]>(null as any);
    }

    getAccountNumberList(): Observable<string[]> {
        let url_ = this.baseUrl + "/client/v1/accounts/getaccountnumberlist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountNumberList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountNumberList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAccountNumberList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    getAccountsListByStatusId(id?: number | undefined, sortField?: string | null | undefined, offset?: number | undefined, limit?: number | undefined): Observable<AccountViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/accounts/getaccountslistbystatusid?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountsListByStatusId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountsListByStatusId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountViewModel[]>;
        }));
    }

    protected processGetAccountsListByStatusId(response: HttpResponseBase): Observable<AccountViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountViewModel[]>(null as any);
    }

    getAccountsListBySearchFilter(statusId?: number | undefined, filterText?: string | null | undefined, sortField?: string | null | undefined, offset?: number | undefined, limit?: number | undefined): Observable<AccountViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/accounts/getaccountslistbysearchfilter?";
        if (statusId === null)
            throw new globalThis.Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "statusId=" + encodeURIComponent("" + statusId) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountsListBySearchFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountsListBySearchFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountViewModel[]>;
        }));
    }

    protected processGetAccountsListBySearchFilter(response: HttpResponseBase): Observable<AccountViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountViewModel[]>(null as any);
    }

    getAccountById(id?: string | null | undefined): Observable<Account> {
        let url_ = this.baseUrl + "/client/v1/accounts/getaccountbyid?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Account>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Account>;
        }));
    }

    protected processGetAccountById(response: HttpResponseBase): Observable<Account> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Account.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Account>(null as any);
    }

    getAccountDropDown(isAll?: boolean | undefined): Observable<DropDownModel[]> {
        let url_ = this.baseUrl + "/client/v1/accounts/accountdropdown?";
        if (isAll === null)
            throw new globalThis.Error("The parameter 'isAll' cannot be null.");
        else if (isAll !== undefined)
            url_ += "isAll=" + encodeURIComponent("" + isAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountDropDown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountDropDown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDownModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDownModel[]>;
        }));
    }

    protected processGetAccountDropDown(response: HttpResponseBase): Observable<DropDownModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownModel[]>(null as any);
    }

    getAccountByAccountId(id?: number | undefined): Observable<Account> {
        let url_ = this.baseUrl + "/client/v1/accounts/getaccountbyaccountid?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountByAccountId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountByAccountId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Account>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Account>;
        }));
    }

    protected processGetAccountByAccountId(response: HttpResponseBase): Observable<Account> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Account.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Account>(null as any);
    }

    getRetailerAccount(): Observable<AccountModel[]> {
        let url_ = this.baseUrl + "/client/v1/accounts/getretaileraccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRetailerAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRetailerAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountModel[]>;
        }));
    }

    protected processGetRetailerAccount(response: HttpResponseBase): Observable<AccountModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountModel[]>(null as any);
    }

    getNonFieldRolesList(id?: string | null | undefined): Observable<PersonListViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/accounts/getnonfieldroleslist?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNonFieldRolesList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNonFieldRolesList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonListViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonListViewModel[]>;
        }));
    }

    protected processGetNonFieldRolesList(response: HttpResponseBase): Observable<PersonListViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonListViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PersonListViewModel[]>(null as any);
    }

    getNonFieldRolesListForAccount(accountId?: number | undefined): Observable<PersonListViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/accounts/getnonfieldroleslistforaccount?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNonFieldRolesListForAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNonFieldRolesListForAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonListViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonListViewModel[]>;
        }));
    }

    protected processGetNonFieldRolesListForAccount(response: HttpResponseBase): Observable<PersonListViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonListViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PersonListViewModel[]>(null as any);
    }

    getAccountAppLinkListByAccountId(id?: string | null | undefined): Observable<AccountAppLinkModel[]> {
        let url_ = this.baseUrl + "/client/v1/accounts/getaccountapplinklistbyaccountid?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountAppLinkListByAccountId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountAppLinkListByAccountId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountAppLinkModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountAppLinkModel[]>;
        }));
    }

    protected processGetAccountAppLinkListByAccountId(response: HttpResponseBase): Observable<AccountAppLinkModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountAppLinkModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountAppLinkModel[]>(null as any);
    }

    getAccountAppLinkListForAccount(accountId?: number | undefined): Observable<AccountAppLinkModel[]> {
        let url_ = this.baseUrl + "/client/v1/accounts/getaccountapplinklistforaccount?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountAppLinkListForAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountAppLinkListForAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountAppLinkModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountAppLinkModel[]>;
        }));
    }

    protected processGetAccountAppLinkListForAccount(response: HttpResponseBase): Observable<AccountAppLinkModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountAppLinkModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountAppLinkModel[]>(null as any);
    }

    getAccountAppLinkListById(id?: number | undefined): Observable<AccountAppLinkModel[]> {
        let url_ = this.baseUrl + "/client/v1/accounts/getaccountapplinklistbyid?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountAppLinkListById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountAppLinkListById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountAppLinkModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountAppLinkModel[]>;
        }));
    }

    protected processGetAccountAppLinkListById(response: HttpResponseBase): Observable<AccountAppLinkModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountAppLinkModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountAppLinkModel[]>(null as any);
    }

    saveAccountAppLink(model?: AccountAppLinkModel | null | undefined): Observable<AccountAppLinkModel> {
        let url_ = this.baseUrl + "/client/v1/accounts/saveaccountapplink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAccountAppLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAccountAppLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountAppLinkModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountAppLinkModel>;
        }));
    }

    protected processSaveAccountAppLink(response: HttpResponseBase): Observable<AccountAppLinkModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountAppLinkModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountAppLinkModel>(null as any);
    }

    deleteAccountAppLinkById(id?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/client/v1/accounts/deleteaccountapplinkbyid?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAccountAppLinkById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAccountAppLinkById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteAccountAppLinkById(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    getAccountList(): Observable<DropDownModel[]> {
        let url_ = this.baseUrl + "/client/v1/accounts/accountlist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDownModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDownModel[]>;
        }));
    }

    protected processGetAccountList(response: HttpResponseBase): Observable<DropDownModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownModel[]>(null as any);
    }

    getAccountDropDownList(): Observable<DropDownModel[]> {
        let url_ = this.baseUrl + "/client/v1/accounts/accountdropdownlist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountDropDownList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountDropDownList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDownModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDownModel[]>;
        }));
    }

    protected processGetAccountDropDownList(response: HttpResponseBase): Observable<DropDownModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownModel[]>(null as any);
    }

    getLinkTypeList(): Observable<DropDownModel[]> {
        let url_ = this.baseUrl + "/client/v1/accounts/linktypelist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLinkTypeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLinkTypeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDownModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDownModel[]>;
        }));
    }

    protected processGetLinkTypeList(response: HttpResponseBase): Observable<DropDownModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownModel[]>(null as any);
    }

    getProviderAdminList(id?: string | null | undefined): Observable<DropDownModel[]> {
        let url_ = this.baseUrl + "/client/v1/accounts/provideradminlist?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProviderAdminList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProviderAdminList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDownModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDownModel[]>;
        }));
    }

    protected processGetProviderAdminList(response: HttpResponseBase): Observable<DropDownModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownModel[]>(null as any);
    }

    checkAccountHideTransaction(accountId?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/client/v1/accounts/checkaccounthidetransaction?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckAccountHideTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckAccountHideTransaction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckAccountHideTransaction(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    getPSPAccountNameList(): Observable<DropDownModel[]> {
        let url_ = this.baseUrl + "/client/v1/accounts/getpspaccountnames";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPSPAccountNameList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPSPAccountNameList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDownModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDownModel[]>;
        }));
    }

    protected processGetPSPAccountNameList(response: HttpResponseBase): Observable<DropDownModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownModel[]>(null as any);
    }

    getAllAccounts(): Observable<UserAccountViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/accounts/getallaccounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAccounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAccountViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAccountViewModel[]>;
        }));
    }

    protected processGetAllAccounts(response: HttpResponseBase): Observable<UserAccountViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserAccountViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserAccountViewModel[]>(null as any);
    }

    getAllPSPAccountsInfo(accountId?: number | null | undefined): Observable<AccountModel[]> {
        let url_ = this.baseUrl + "/client/v1/accounts/getallpspaccountsinfo?";
        if (accountId !== undefined && accountId !== null)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPSPAccountsInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPSPAccountsInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountModel[]>;
        }));
    }

    protected processGetAllPSPAccountsInfo(response: HttpResponseBase): Observable<AccountModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountModel[]>(null as any);
    }

    uploadAccountImage(accountId?: number | undefined, imageFile?: FileParameter | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/client/v1/accounts/uploadaccountimage?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (imageFile !== null && imageFile !== undefined)
            content_.append("imageFile", imageFile.data, imageFile.fileName ? imageFile.fileName : "imageFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadAccountImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadAccountImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadAccountImage(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    update(accountId: number, accountPatch?: Operation[] | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/client/v1/accounts/update/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accountPatch);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getAccountInfo(accountId?: number | undefined): Observable<AccountInfoViewModel> {
        let url_ = this.baseUrl + "/client/v1/accounts/getaccountinfo?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountInfoViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountInfoViewModel>;
        }));
    }

    protected processGetAccountInfo(response: HttpResponseBase): Observable<AccountInfoViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountInfoViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountInfoViewModel>(null as any);
    }

    getAccountsDropdown(): Observable<AccountModel[]> {
        let url_ = this.baseUrl + "/client/v1/accounts/getaccountsdropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountsDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountsDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountModel[]>;
        }));
    }

    protected processGetAccountsDropdown(response: HttpResponseBase): Observable<AccountModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountModel[]>(null as any);
    }

    generateApiKey(accountId: number): Observable<string> {
        let url_ = this.baseUrl + "/client/v1/accounts/{accountId}/api-key";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateApiKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateApiKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGenerateApiKey(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    getAccountSupport(): Observable<AccountSupport> {
        let url_ = this.baseUrl + "/client/v1/accounts/getaccountsupport";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountSupport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountSupport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountSupport>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountSupport>;
        }));
    }

    protected processGetAccountSupport(response: HttpResponseBase): Observable<AccountSupport> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountSupport.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountSupport>(null as any);
    }

    getWirelessProviders(): Observable<DropDownModel[]> {
        let url_ = this.baseUrl + "/client/v1/accounts/getwirelessproviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWirelessProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWirelessProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDownModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDownModel[]>;
        }));
    }

    protected processGetWirelessProviders(response: HttpResponseBase): Observable<DropDownModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ApiErrorOfRequestTokenErrors.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownModel[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ActivityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getFilteredActivityList(parameters?: PagedFilterOfActivityFilterParams | null | undefined): Observable<LimitedResultOfActivityModel> {
        let url_ = this.baseUrl + "/client/v1/activity/getactivitylist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilteredActivityList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilteredActivityList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfActivityModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfActivityModel>;
        }));
    }

    protected processGetFilteredActivityList(response: HttpResponseBase): Observable<LimitedResultOfActivityModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfActivityModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfActivityModel>(null as any);
    }

    getActivitiesForAccount(accountId?: number | undefined): Observable<ActivityModel[]> {
        let url_ = this.baseUrl + "/client/v1/activity/getactivitiesforaccount?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivitiesForAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivitiesForAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityModel[]>;
        }));
    }

    protected processGetActivitiesForAccount(response: HttpResponseBase): Observable<ActivityModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityModel[]>(null as any);
    }

    getFilteredActivityListDw(parameters?: PagedFilterOfActivityFilterParams | null | undefined): Observable<LimitedResultOfActivityModel> {
        let url_ = this.baseUrl + "/client/v1/activity/getactivitylistdw";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilteredActivityListDw(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilteredActivityListDw(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfActivityModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfActivityModel>;
        }));
    }

    protected processGetFilteredActivityListDw(response: HttpResponseBase): Observable<LimitedResultOfActivityModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfActivityModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfActivityModel>(null as any);
    }

    getActivityTaskSummary(accountId?: number | null | undefined, activities?: string[] | null | undefined, taskStartDate?: moment.Moment | null | undefined, taskEndDate?: moment.Moment | null | undefined): Observable<ActivityTaskSummaryModel[]> {
        let url_ = this.baseUrl + "/client/v1/activity/getactivitytasksummary?";
        if (accountId !== undefined && accountId !== null)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (activities !== undefined && activities !== null)
            activities && activities.forEach(item => { url_ += "Activities=" + encodeURIComponent("" + item) + "&"; });
        if (taskStartDate !== undefined && taskStartDate !== null)
            url_ += "TaskStartDate=" + encodeURIComponent(taskStartDate ? "" + taskStartDate.toISOString() : "") + "&";
        if (taskEndDate !== undefined && taskEndDate !== null)
            url_ += "TaskEndDate=" + encodeURIComponent(taskEndDate ? "" + taskEndDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivityTaskSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivityTaskSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityTaskSummaryModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityTaskSummaryModel[]>;
        }));
    }

    protected processGetActivityTaskSummary(response: HttpResponseBase): Observable<ActivityTaskSummaryModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityTaskSummaryModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityTaskSummaryModel[]>(null as any);
    }

    getAllActivities(): Observable<ActivityViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/activities/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActivities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityViewModel[]>;
        }));
    }

    protected processGetAllActivities(response: HttpResponseBase): Observable<ActivityViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityViewModel[]>(null as any);
    }

    accountActivities(): Observable<ActivityModel[]> {
        let url_ = this.baseUrl + "/client/v1/activities/accountactivities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccountActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccountActivities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityModel[]>;
        }));
    }

    protected processAccountActivities(response: HttpResponseBase): Observable<ActivityModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityModel[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ActivityResponsibilityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getAll(): Observable<ActivityResponsibility[]> {
        let url_ = this.baseUrl + "/client/v1/activityresponsibility";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityResponsibility[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityResponsibility[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ActivityResponsibility[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityResponsibility.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityResponsibility[]>(null as any);
    }

    download(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/activityresponsibility/download";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownload(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    upload(pageName?: string | null | undefined, file?: FileParameter | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/client/v1/activityresponsibility/upload?";
        if (pageName !== undefined && pageName !== null)
            url_ += "pageName=" + encodeURIComponent("" + pageName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AlertNotificationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    deleteAlertNotification(id: string): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/alertnotification/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAlertNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAlertNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAlertNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AlternativeNumbersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getAlternativeNumbers(accountId: number): Observable<GetAlternativeNumbersResponse> {
        let url_ = this.baseUrl + "/client/v1/accounts/{accountId}/alternative-numbers";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlternativeNumbers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlternativeNumbers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAlternativeNumbersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAlternativeNumbersResponse>;
        }));
    }

    protected processGetAlternativeNumbers(response: HttpResponseBase): Observable<GetAlternativeNumbersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAlternativeNumbersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAlternativeNumbersResponse>(null as any);
    }

    getMyAlternativeNumbers(): Observable<GetAlternativeNumbersResponse> {
        let url_ = this.baseUrl + "/client/v1/accounts/my-alternative-numbers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyAlternativeNumbers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyAlternativeNumbers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAlternativeNumbersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAlternativeNumbersResponse>;
        }));
    }

    protected processGetMyAlternativeNumbers(response: HttpResponseBase): Observable<GetAlternativeNumbersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAlternativeNumbersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAlternativeNumbersResponse>(null as any);
    }

    getSupplierNumber(number?: string | null | undefined, excludeAccount?: number | null | undefined): Observable<GetSupplierNumberResponse> {
        let url_ = this.baseUrl + "/client/v1/accounts/supplier-numbers?";
        if (number !== undefined && number !== null)
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        if (excludeAccount !== undefined && excludeAccount !== null)
            url_ += "excludeAccount=" + encodeURIComponent("" + excludeAccount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplierNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplierNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSupplierNumberResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSupplierNumberResponse>;
        }));
    }

    protected processGetSupplierNumber(response: HttpResponseBase): Observable<GetSupplierNumberResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSupplierNumberResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSupplierNumberResponse>(null as any);
    }

    updateAlternativeNumbers(accountId: number, request?: AlternativeNumbersBatch | null | undefined): Observable<GetAlternativeNumbersResponse> {
        let url_ = this.baseUrl + "/client/v1/accounts/{accountId}/batch";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAlternativeNumbers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAlternativeNumbers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAlternativeNumbersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAlternativeNumbersResponse>;
        }));
    }

    protected processUpdateAlternativeNumbers(response: HttpResponseBase): Observable<GetAlternativeNumbersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAlternativeNumbersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAlternativeNumbersResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BadgeReplacementClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getPersonPreviousBadgeReprintHistory(personId: string): Observable<BadgeReplacementModel[]> {
        let url_ = this.baseUrl + "/client/v1/badgereplacement/previousreprints/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonPreviousBadgeReprintHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonPreviousBadgeReprintHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BadgeReplacementModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BadgeReplacementModel[]>;
        }));
    }

    protected processGetPersonPreviousBadgeReprintHistory(response: HttpResponseBase): Observable<BadgeReplacementModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BadgeReplacementModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BadgeReplacementModel[]>(null as any);
    }

    getPersonPendingBadgeReprint(personId: string): Observable<BadgeReplacementModel> {
        let url_ = this.baseUrl + "/client/v1/badgereplacement/latestpending/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonPendingBadgeReprint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonPendingBadgeReprint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BadgeReplacementModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BadgeReplacementModel>;
        }));
    }

    protected processGetPersonPendingBadgeReprint(response: HttpResponseBase): Observable<BadgeReplacementModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BadgeReplacementModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BadgeReplacementModel>(null as any);
    }

    getPersonPreviousBadgeReprintHistoryCount(personId: string): Observable<number> {
        let url_ = this.baseUrl + "/client/v1/badgereplacement/previousreprintscount/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonPreviousBadgeReprintHistoryCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonPreviousBadgeReprintHistoryCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetPersonPreviousBadgeReprintHistoryCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getPendingBadgeReplacements(badgeStatus?: number | undefined): Observable<BadgeReplacementModel[]> {
        let url_ = this.baseUrl + "/client/v1/badgereplacement/pending?";
        if (badgeStatus === null)
            throw new globalThis.Error("The parameter 'badgeStatus' cannot be null.");
        else if (badgeStatus !== undefined)
            url_ += "badgeStatus=" + encodeURIComponent("" + badgeStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingBadgeReplacements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingBadgeReplacements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BadgeReplacementModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BadgeReplacementModel[]>;
        }));
    }

    protected processGetPendingBadgeReplacements(response: HttpResponseBase): Observable<BadgeReplacementModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BadgeReplacementModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BadgeReplacementModel[]>(null as any);
    }

    approveBadgeReplacement(badgeReplacementIds?: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/badgereplacement/approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(badgeReplacementIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveBadgeReplacement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveBadgeReplacement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApproveBadgeReplacement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    denyBadgeReplacement(badgeReplacementId: number, reason?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/badgereplacement/deny/{badgeReplacementId}?";
        if (badgeReplacementId === undefined || badgeReplacementId === null)
            throw new globalThis.Error("The parameter 'badgeReplacementId' must be defined.");
        url_ = url_.replace("{badgeReplacementId}", encodeURIComponent("" + badgeReplacementId));
        if (reason !== undefined && reason !== null)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDenyBadgeReplacement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDenyBadgeReplacement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDenyBadgeReplacement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CapabilityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getRoleCapabilities(): Observable<CapabilityViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/capability/getrolecapabilities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleCapabilities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleCapabilities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CapabilityViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CapabilityViewModel[]>;
        }));
    }

    protected processGetRoleCapabilities(response: HttpResponseBase): Observable<CapabilityViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CapabilityViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CapabilityViewModel[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CertificationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getCertificationList(accountId?: number | undefined): Observable<CourseModel[]> {
        let url_ = this.baseUrl + "/client/v1/certification/certificationlist?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificationList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificationList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CourseModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CourseModel[]>;
        }));
    }

    protected processGetCertificationList(response: HttpResponseBase): Observable<CourseModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CourseModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CourseModel[]>(null as any);
    }

    getRetailerCertificationList(): Observable<CourseModel[]> {
        let url_ = this.baseUrl + "/client/v1/certification/getretailercertificationlist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRetailerCertificationList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRetailerCertificationList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CourseModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CourseModel[]>;
        }));
    }

    protected processGetRetailerCertificationList(response: HttpResponseBase): Observable<CourseModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CourseModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CourseModel[]>(null as any);
    }

    getAccountRetailerCertificationList(accountId?: number | undefined): Observable<CourseModel[]> {
        let url_ = this.baseUrl + "/client/v1/certification/getcourselist?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountRetailerCertificationList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountRetailerCertificationList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CourseModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CourseModel[]>;
        }));
    }

    protected processGetAccountRetailerCertificationList(response: HttpResponseBase): Observable<CourseModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CourseModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CourseModel[]>(null as any);
    }

    getCertification(certificationId?: number | undefined): Observable<CourseModel> {
        let url_ = this.baseUrl + "/client/v1/certification/getcertification?";
        if (certificationId === null)
            throw new globalThis.Error("The parameter 'certificationId' cannot be null.");
        else if (certificationId !== undefined)
            url_ += "certificationId=" + encodeURIComponent("" + certificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CourseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CourseModel>;
        }));
    }

    protected processGetCertification(response: HttpResponseBase): Observable<CourseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CourseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CourseModel>(null as any);
    }

    getCourseIdByCourseName(course?: string | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/client/v1/certification/getcourseidbycoursename?";
        if (course !== undefined && course !== null)
            url_ += "course=" + encodeURIComponent("" + course) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCourseIdByCourseName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCourseIdByCourseName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetCourseIdByCourseName(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getAccountCertifications(accountId?: number | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/client/v1/getaccountcertifications?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountCertifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountCertifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAccountCertifications(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    addCertification(retailerCertification?: RetailerCertificationViewModel | null | undefined): Observable<Certification> {
        let url_ = this.baseUrl + "/client/v1/certification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(retailerCertification);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCertification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCertification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Certification>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Certification>;
        }));
    }

    protected processAddCertification(response: HttpResponseBase): Observable<Certification> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Certification.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Certification>(null as any);
    }

    saveCertification(certificationId: number, retailerCertification?: RetailerCertificationViewModel | null | undefined): Observable<Certification> {
        let url_ = this.baseUrl + "/client/v1/certification/{certificationId}";
        if (certificationId === undefined || certificationId === null)
            throw new globalThis.Error("The parameter 'certificationId' must be defined.");
        url_ = url_.replace("{certificationId}", encodeURIComponent("" + certificationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(retailerCertification);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveCertification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveCertification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Certification>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Certification>;
        }));
    }

    protected processSaveCertification(response: HttpResponseBase): Observable<Certification> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Certification.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Certification>(null as any);
    }

    getCoursesList(): Observable<CertificationCourseModel[]> {
        let url_ = this.baseUrl + "/client/v1/certification/getcertificationcourseslist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoursesList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoursesList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CertificationCourseModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CertificationCourseModel[]>;
        }));
    }

    protected processGetCoursesList(response: HttpResponseBase): Observable<CertificationCourseModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CertificationCourseModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CertificationCourseModel[]>(null as any);
    }

    getCertificationCoursesList(certificationId?: number | undefined): Observable<CertificationCourseModel[]> {
        let url_ = this.baseUrl + "/client/v1/certification/getcourseslist?";
        if (certificationId === null)
            throw new globalThis.Error("The parameter 'certificationId' cannot be null.");
        else if (certificationId !== undefined)
            url_ += "certificationId=" + encodeURIComponent("" + certificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificationCoursesList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificationCoursesList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CertificationCourseModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CertificationCourseModel[]>;
        }));
    }

    protected processGetCertificationCoursesList(response: HttpResponseBase): Observable<CertificationCourseModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CertificationCourseModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CertificationCourseModel[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CheckinByAccountClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getRealtimeCheckinByAccount(accountIds?: number[] | null | undefined, fieldGroupTypeIds?: number[] | null | undefined, wattLocationID?: string | null | undefined, locationGroupId?: number | null | undefined, locationGroupValues?: string[] | null | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined, offset?: number | undefined, limit?: number | undefined): Observable<LimitedResultOfCheckinByAccountRealtimeViewModel> {
        let url_ = this.baseUrl + "/client/v1/realtime/accounts?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (fieldGroupTypeIds !== undefined && fieldGroupTypeIds !== null)
            fieldGroupTypeIds && fieldGroupTypeIds.forEach(item => { url_ += "FieldGroupTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (wattLocationID !== undefined && wattLocationID !== null)
            url_ += "WattLocationID=" + encodeURIComponent("" + wattLocationID) + "&";
        if (locationGroupId !== undefined && locationGroupId !== null)
            url_ += "LocationGroupId=" + encodeURIComponent("" + locationGroupId) + "&";
        if (locationGroupValues !== undefined && locationGroupValues !== null)
            locationGroupValues && locationGroupValues.forEach(item => { url_ += "LocationGroupValues=" + encodeURIComponent("" + item) + "&"; });
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRealtimeCheckinByAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRealtimeCheckinByAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfCheckinByAccountRealtimeViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfCheckinByAccountRealtimeViewModel>;
        }));
    }

    protected processGetRealtimeCheckinByAccount(response: HttpResponseBase): Observable<LimitedResultOfCheckinByAccountRealtimeViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfCheckinByAccountRealtimeViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfCheckinByAccountRealtimeViewModel>(null as any);
    }

    exportRealtimeCheckinByAccount(accountIds?: number[] | null | undefined, fieldGroupTypeIds?: number[] | null | undefined, wattLocationID?: string | null | undefined, locationGroupId?: number | null | undefined, locationGroupValues?: string[] | null | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/realtime/accounts/export?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (fieldGroupTypeIds !== undefined && fieldGroupTypeIds !== null)
            fieldGroupTypeIds && fieldGroupTypeIds.forEach(item => { url_ += "FieldGroupTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (wattLocationID !== undefined && wattLocationID !== null)
            url_ += "WattLocationID=" + encodeURIComponent("" + wattLocationID) + "&";
        if (locationGroupId !== undefined && locationGroupId !== null)
            url_ += "LocationGroupId=" + encodeURIComponent("" + locationGroupId) + "&";
        if (locationGroupValues !== undefined && locationGroupValues !== null)
            locationGroupValues && locationGroupValues.forEach(item => { url_ += "LocationGroupValues=" + encodeURIComponent("" + item) + "&"; });
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportRealtimeCheckinByAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportRealtimeCheckinByAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportRealtimeCheckinByAccount(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getHistoricalCheckinByAccount(accountIds?: number[] | null | undefined, fieldGroupTypeIds?: number[] | null | undefined, locationGroupId?: number | null | undefined, wattLocationID?: string | null | undefined, locationGroupValues?: string[] | null | undefined, onlyDistinctCheckins?: boolean | undefined, excludeWeekends?: boolean | undefined, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined, utcOffset?: number | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined, nonCheckInsInDays?: number | null | undefined, personTagIds?: number[] | null | undefined, wattLocationIDs?: string[] | null | undefined, offset?: number | undefined, limit?: number | undefined, dayPart?: string | null | undefined): Observable<LimitedResultOfCheckinByAccountHistoricalViewModel> {
        let url_ = this.baseUrl + "/client/v1/historical/accounts?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (fieldGroupTypeIds !== undefined && fieldGroupTypeIds !== null)
            fieldGroupTypeIds && fieldGroupTypeIds.forEach(item => { url_ += "FieldGroupTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (locationGroupId !== undefined && locationGroupId !== null)
            url_ += "LocationGroupId=" + encodeURIComponent("" + locationGroupId) + "&";
        if (wattLocationID !== undefined && wattLocationID !== null)
            url_ += "WattLocationID=" + encodeURIComponent("" + wattLocationID) + "&";
        if (locationGroupValues !== undefined && locationGroupValues !== null)
            locationGroupValues && locationGroupValues.forEach(item => { url_ += "LocationGroupValues=" + encodeURIComponent("" + item) + "&"; });
        if (onlyDistinctCheckins === null)
            throw new globalThis.Error("The parameter 'onlyDistinctCheckins' cannot be null.");
        else if (onlyDistinctCheckins !== undefined)
            url_ += "OnlyDistinctCheckins=" + encodeURIComponent("" + onlyDistinctCheckins) + "&";
        if (excludeWeekends === null)
            throw new globalThis.Error("The parameter 'excludeWeekends' cannot be null.");
        else if (excludeWeekends !== undefined)
            url_ += "ExcludeWeekends=" + encodeURIComponent("" + excludeWeekends) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (utcOffset === null)
            throw new globalThis.Error("The parameter 'utcOffset' cannot be null.");
        else if (utcOffset !== undefined)
            url_ += "UtcOffset=" + encodeURIComponent("" + utcOffset) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (nonCheckInsInDays !== undefined && nonCheckInsInDays !== null)
            url_ += "NonCheckInsInDays=" + encodeURIComponent("" + nonCheckInsInDays) + "&";
        if (personTagIds !== undefined && personTagIds !== null)
            personTagIds && personTagIds.forEach(item => { url_ += "PersonTagIds=" + encodeURIComponent("" + item) + "&"; });
        if (wattLocationIDs !== undefined && wattLocationIDs !== null)
            wattLocationIDs && wattLocationIDs.forEach(item => { url_ += "WattLocationIDs=" + encodeURIComponent("" + item) + "&"; });
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (dayPart !== undefined && dayPart !== null)
            url_ += "dayPart=" + encodeURIComponent("" + dayPart) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistoricalCheckinByAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistoricalCheckinByAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfCheckinByAccountHistoricalViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfCheckinByAccountHistoricalViewModel>;
        }));
    }

    protected processGetHistoricalCheckinByAccount(response: HttpResponseBase): Observable<LimitedResultOfCheckinByAccountHistoricalViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfCheckinByAccountHistoricalViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfCheckinByAccountHistoricalViewModel>(null as any);
    }

    exportHistoricalCheckinByAccount(accountIds?: number[] | null | undefined, fieldGroupTypeIds?: number[] | null | undefined, locationGroupId?: number | null | undefined, wattLocationID?: string | null | undefined, locationGroupValues?: string[] | null | undefined, onlyDistinctCheckins?: boolean | undefined, excludeWeekends?: boolean | undefined, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined, utcOffset?: number | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined, nonCheckInsInDays?: number | null | undefined, personTagIds?: number[] | null | undefined, wattLocationIDs?: string[] | null | undefined, dayPart?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/historical/accounts/export?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (fieldGroupTypeIds !== undefined && fieldGroupTypeIds !== null)
            fieldGroupTypeIds && fieldGroupTypeIds.forEach(item => { url_ += "FieldGroupTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (locationGroupId !== undefined && locationGroupId !== null)
            url_ += "LocationGroupId=" + encodeURIComponent("" + locationGroupId) + "&";
        if (wattLocationID !== undefined && wattLocationID !== null)
            url_ += "WattLocationID=" + encodeURIComponent("" + wattLocationID) + "&";
        if (locationGroupValues !== undefined && locationGroupValues !== null)
            locationGroupValues && locationGroupValues.forEach(item => { url_ += "LocationGroupValues=" + encodeURIComponent("" + item) + "&"; });
        if (onlyDistinctCheckins === null)
            throw new globalThis.Error("The parameter 'onlyDistinctCheckins' cannot be null.");
        else if (onlyDistinctCheckins !== undefined)
            url_ += "OnlyDistinctCheckins=" + encodeURIComponent("" + onlyDistinctCheckins) + "&";
        if (excludeWeekends === null)
            throw new globalThis.Error("The parameter 'excludeWeekends' cannot be null.");
        else if (excludeWeekends !== undefined)
            url_ += "ExcludeWeekends=" + encodeURIComponent("" + excludeWeekends) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (utcOffset === null)
            throw new globalThis.Error("The parameter 'utcOffset' cannot be null.");
        else if (utcOffset !== undefined)
            url_ += "UtcOffset=" + encodeURIComponent("" + utcOffset) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (nonCheckInsInDays !== undefined && nonCheckInsInDays !== null)
            url_ += "NonCheckInsInDays=" + encodeURIComponent("" + nonCheckInsInDays) + "&";
        if (personTagIds !== undefined && personTagIds !== null)
            personTagIds && personTagIds.forEach(item => { url_ += "PersonTagIds=" + encodeURIComponent("" + item) + "&"; });
        if (wattLocationIDs !== undefined && wattLocationIDs !== null)
            wattLocationIDs && wattLocationIDs.forEach(item => { url_ += "WattLocationIDs=" + encodeURIComponent("" + item) + "&"; });
        if (dayPart !== undefined && dayPart !== null)
            url_ += "dayPart=" + encodeURIComponent("" + dayPart) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportHistoricalCheckinByAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportHistoricalCheckinByAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportHistoricalCheckinByAccount(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getHistoricalCheckinByAccountUser(accountIds?: number[] | null | undefined, personTagIds?: number[] | null | undefined, fieldGroupTypeIds?: number[] | null | undefined, wattLocationID?: string | null | undefined, locationGroupId?: number | null | undefined, locationGroupValues?: string[] | null | undefined, onlyDistinctCheckins?: boolean | undefined, excludeWeekends?: boolean | undefined, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined, utcOffset?: number | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined, offset?: number | undefined, limit?: number | undefined): Observable<LimitedResultOfCheckinByAccountUserHistoricalViewModel> {
        let url_ = this.baseUrl + "/client/v1/historical/users?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (personTagIds !== undefined && personTagIds !== null)
            personTagIds && personTagIds.forEach(item => { url_ += "PersonTagIds=" + encodeURIComponent("" + item) + "&"; });
        if (fieldGroupTypeIds !== undefined && fieldGroupTypeIds !== null)
            fieldGroupTypeIds && fieldGroupTypeIds.forEach(item => { url_ += "FieldGroupTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (wattLocationID !== undefined && wattLocationID !== null)
            url_ += "WattLocationID=" + encodeURIComponent("" + wattLocationID) + "&";
        if (locationGroupId !== undefined && locationGroupId !== null)
            url_ += "LocationGroupId=" + encodeURIComponent("" + locationGroupId) + "&";
        if (locationGroupValues !== undefined && locationGroupValues !== null)
            locationGroupValues && locationGroupValues.forEach(item => { url_ += "LocationGroupValues=" + encodeURIComponent("" + item) + "&"; });
        if (onlyDistinctCheckins === null)
            throw new globalThis.Error("The parameter 'onlyDistinctCheckins' cannot be null.");
        else if (onlyDistinctCheckins !== undefined)
            url_ += "OnlyDistinctCheckins=" + encodeURIComponent("" + onlyDistinctCheckins) + "&";
        if (excludeWeekends === null)
            throw new globalThis.Error("The parameter 'excludeWeekends' cannot be null.");
        else if (excludeWeekends !== undefined)
            url_ += "ExcludeWeekends=" + encodeURIComponent("" + excludeWeekends) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (utcOffset === null)
            throw new globalThis.Error("The parameter 'utcOffset' cannot be null.");
        else if (utcOffset !== undefined)
            url_ += "UtcOffset=" + encodeURIComponent("" + utcOffset) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistoricalCheckinByAccountUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistoricalCheckinByAccountUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfCheckinByAccountUserHistoricalViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfCheckinByAccountUserHistoricalViewModel>;
        }));
    }

    protected processGetHistoricalCheckinByAccountUser(response: HttpResponseBase): Observable<LimitedResultOfCheckinByAccountUserHistoricalViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfCheckinByAccountUserHistoricalViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfCheckinByAccountUserHistoricalViewModel>(null as any);
    }

    exportHistoricalCheckinByAccountUser(accountIds?: number[] | null | undefined, personTagIds?: number[] | null | undefined, fieldGroupTypeIds?: number[] | null | undefined, wattLocationID?: string | null | undefined, locationGroupId?: number | null | undefined, locationGroupValues?: string[] | null | undefined, onlyDistinctCheckins?: boolean | undefined, excludeWeekends?: boolean | undefined, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined, utcOffset?: number | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/historical/users/export?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (personTagIds !== undefined && personTagIds !== null)
            personTagIds && personTagIds.forEach(item => { url_ += "PersonTagIds=" + encodeURIComponent("" + item) + "&"; });
        if (fieldGroupTypeIds !== undefined && fieldGroupTypeIds !== null)
            fieldGroupTypeIds && fieldGroupTypeIds.forEach(item => { url_ += "FieldGroupTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (wattLocationID !== undefined && wattLocationID !== null)
            url_ += "WattLocationID=" + encodeURIComponent("" + wattLocationID) + "&";
        if (locationGroupId !== undefined && locationGroupId !== null)
            url_ += "LocationGroupId=" + encodeURIComponent("" + locationGroupId) + "&";
        if (locationGroupValues !== undefined && locationGroupValues !== null)
            locationGroupValues && locationGroupValues.forEach(item => { url_ += "LocationGroupValues=" + encodeURIComponent("" + item) + "&"; });
        if (onlyDistinctCheckins === null)
            throw new globalThis.Error("The parameter 'onlyDistinctCheckins' cannot be null.");
        else if (onlyDistinctCheckins !== undefined)
            url_ += "OnlyDistinctCheckins=" + encodeURIComponent("" + onlyDistinctCheckins) + "&";
        if (excludeWeekends === null)
            throw new globalThis.Error("The parameter 'excludeWeekends' cannot be null.");
        else if (excludeWeekends !== undefined)
            url_ += "ExcludeWeekends=" + encodeURIComponent("" + excludeWeekends) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (utcOffset === null)
            throw new globalThis.Error("The parameter 'utcOffset' cannot be null.");
        else if (utcOffset !== undefined)
            url_ += "UtcOffset=" + encodeURIComponent("" + utcOffset) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportHistoricalCheckinByAccountUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportHistoricalCheckinByAccountUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportHistoricalCheckinByAccountUser(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getRealtimeCheckinByAccountUser(accountIds?: number[] | null | undefined, personTagIds?: number[] | null | undefined, fieldGroupTypeIds?: number[] | null | undefined, wattLocationID?: string | null | undefined, locationGroupId?: number | null | undefined, locationGroupValues?: string[] | null | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined, offset?: number | undefined, limit?: number | undefined): Observable<LimitedResultOfCheckinByAccountUserRealtimeViewModel> {
        let url_ = this.baseUrl + "/client/v1/realtime/users?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (personTagIds !== undefined && personTagIds !== null)
            personTagIds && personTagIds.forEach(item => { url_ += "PersonTagIds=" + encodeURIComponent("" + item) + "&"; });
        if (fieldGroupTypeIds !== undefined && fieldGroupTypeIds !== null)
            fieldGroupTypeIds && fieldGroupTypeIds.forEach(item => { url_ += "FieldGroupTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (wattLocationID !== undefined && wattLocationID !== null)
            url_ += "WattLocationID=" + encodeURIComponent("" + wattLocationID) + "&";
        if (locationGroupId !== undefined && locationGroupId !== null)
            url_ += "LocationGroupId=" + encodeURIComponent("" + locationGroupId) + "&";
        if (locationGroupValues !== undefined && locationGroupValues !== null)
            locationGroupValues && locationGroupValues.forEach(item => { url_ += "LocationGroupValues=" + encodeURIComponent("" + item) + "&"; });
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRealtimeCheckinByAccountUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRealtimeCheckinByAccountUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfCheckinByAccountUserRealtimeViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfCheckinByAccountUserRealtimeViewModel>;
        }));
    }

    protected processGetRealtimeCheckinByAccountUser(response: HttpResponseBase): Observable<LimitedResultOfCheckinByAccountUserRealtimeViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfCheckinByAccountUserRealtimeViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfCheckinByAccountUserRealtimeViewModel>(null as any);
    }

    exportRealtimeCheckinByAccountUser(accountIds?: number[] | null | undefined, personTagIds?: number[] | null | undefined, fieldGroupTypeIds?: number[] | null | undefined, wattLocationID?: string | null | undefined, locationGroupId?: number | null | undefined, locationGroupValues?: string[] | null | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/realtime/users/export?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (personTagIds !== undefined && personTagIds !== null)
            personTagIds && personTagIds.forEach(item => { url_ += "PersonTagIds=" + encodeURIComponent("" + item) + "&"; });
        if (fieldGroupTypeIds !== undefined && fieldGroupTypeIds !== null)
            fieldGroupTypeIds && fieldGroupTypeIds.forEach(item => { url_ += "FieldGroupTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (wattLocationID !== undefined && wattLocationID !== null)
            url_ += "WattLocationID=" + encodeURIComponent("" + wattLocationID) + "&";
        if (locationGroupId !== undefined && locationGroupId !== null)
            url_ += "LocationGroupId=" + encodeURIComponent("" + locationGroupId) + "&";
        if (locationGroupValues !== undefined && locationGroupValues !== null)
            locationGroupValues && locationGroupValues.forEach(item => { url_ += "LocationGroupValues=" + encodeURIComponent("" + item) + "&"; });
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportRealtimeCheckinByAccountUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportRealtimeCheckinByAccountUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportRealtimeCheckinByAccountUser(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getHistoricalCheckinByAccountUserChart(chartParams_DatePart?: string | null | undefined, chartParams_Interval?: number | undefined, accountIds?: number[] | null | undefined, personTagIds?: number[] | null | undefined, fieldGroupTypeIds?: number[] | null | undefined, wattLocationID?: string | null | undefined, locationGroupId?: number | null | undefined, locationGroupValues?: string[] | null | undefined, onlyDistinctCheckins?: boolean | undefined, excludeWeekends?: boolean | undefined, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined, utcOffset?: number | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined): Observable<CheckinByAccountHistoricalCheckinChartViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/historical/users/chart?";
        if (chartParams_DatePart !== undefined && chartParams_DatePart !== null)
            url_ += "ChartParams.DatePart=" + encodeURIComponent("" + chartParams_DatePart) + "&";
        if (chartParams_Interval === null)
            throw new globalThis.Error("The parameter 'chartParams_Interval' cannot be null.");
        else if (chartParams_Interval !== undefined)
            url_ += "ChartParams.Interval=" + encodeURIComponent("" + chartParams_Interval) + "&";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (personTagIds !== undefined && personTagIds !== null)
            personTagIds && personTagIds.forEach(item => { url_ += "PersonTagIds=" + encodeURIComponent("" + item) + "&"; });
        if (fieldGroupTypeIds !== undefined && fieldGroupTypeIds !== null)
            fieldGroupTypeIds && fieldGroupTypeIds.forEach(item => { url_ += "FieldGroupTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (wattLocationID !== undefined && wattLocationID !== null)
            url_ += "WattLocationID=" + encodeURIComponent("" + wattLocationID) + "&";
        if (locationGroupId !== undefined && locationGroupId !== null)
            url_ += "LocationGroupId=" + encodeURIComponent("" + locationGroupId) + "&";
        if (locationGroupValues !== undefined && locationGroupValues !== null)
            locationGroupValues && locationGroupValues.forEach(item => { url_ += "LocationGroupValues=" + encodeURIComponent("" + item) + "&"; });
        if (onlyDistinctCheckins === null)
            throw new globalThis.Error("The parameter 'onlyDistinctCheckins' cannot be null.");
        else if (onlyDistinctCheckins !== undefined)
            url_ += "OnlyDistinctCheckins=" + encodeURIComponent("" + onlyDistinctCheckins) + "&";
        if (excludeWeekends === null)
            throw new globalThis.Error("The parameter 'excludeWeekends' cannot be null.");
        else if (excludeWeekends !== undefined)
            url_ += "ExcludeWeekends=" + encodeURIComponent("" + excludeWeekends) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (utcOffset === null)
            throw new globalThis.Error("The parameter 'utcOffset' cannot be null.");
        else if (utcOffset !== undefined)
            url_ += "UtcOffset=" + encodeURIComponent("" + utcOffset) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistoricalCheckinByAccountUserChart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistoricalCheckinByAccountUserChart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckinByAccountHistoricalCheckinChartViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckinByAccountHistoricalCheckinChartViewModel[]>;
        }));
    }

    protected processGetHistoricalCheckinByAccountUserChart(response: HttpResponseBase): Observable<CheckinByAccountHistoricalCheckinChartViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckinByAccountHistoricalCheckinChartViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckinByAccountHistoricalCheckinChartViewModel[]>(null as any);
    }

    getHistoricalCheckinByAccountChart(chartParams_DatePart?: string | null | undefined, chartParams_Interval?: number | undefined, accountIds?: number[] | null | undefined, fieldGroupTypeIds?: number[] | null | undefined, locationGroupId?: number | null | undefined, wattLocationID?: string | null | undefined, locationGroupValues?: string[] | null | undefined, onlyDistinctCheckins?: boolean | undefined, excludeWeekends?: boolean | undefined, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined, utcOffset?: number | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined, nonCheckInsInDays?: number | null | undefined, personTagIds?: number[] | null | undefined, wattLocationIDs?: string[] | null | undefined): Observable<CheckinByAccountHistoricalCheckinChartViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/historical/account/chart?";
        if (chartParams_DatePart !== undefined && chartParams_DatePart !== null)
            url_ += "ChartParams.DatePart=" + encodeURIComponent("" + chartParams_DatePart) + "&";
        if (chartParams_Interval === null)
            throw new globalThis.Error("The parameter 'chartParams_Interval' cannot be null.");
        else if (chartParams_Interval !== undefined)
            url_ += "ChartParams.Interval=" + encodeURIComponent("" + chartParams_Interval) + "&";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (fieldGroupTypeIds !== undefined && fieldGroupTypeIds !== null)
            fieldGroupTypeIds && fieldGroupTypeIds.forEach(item => { url_ += "FieldGroupTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (locationGroupId !== undefined && locationGroupId !== null)
            url_ += "LocationGroupId=" + encodeURIComponent("" + locationGroupId) + "&";
        if (wattLocationID !== undefined && wattLocationID !== null)
            url_ += "WattLocationID=" + encodeURIComponent("" + wattLocationID) + "&";
        if (locationGroupValues !== undefined && locationGroupValues !== null)
            locationGroupValues && locationGroupValues.forEach(item => { url_ += "LocationGroupValues=" + encodeURIComponent("" + item) + "&"; });
        if (onlyDistinctCheckins === null)
            throw new globalThis.Error("The parameter 'onlyDistinctCheckins' cannot be null.");
        else if (onlyDistinctCheckins !== undefined)
            url_ += "OnlyDistinctCheckins=" + encodeURIComponent("" + onlyDistinctCheckins) + "&";
        if (excludeWeekends === null)
            throw new globalThis.Error("The parameter 'excludeWeekends' cannot be null.");
        else if (excludeWeekends !== undefined)
            url_ += "ExcludeWeekends=" + encodeURIComponent("" + excludeWeekends) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (utcOffset === null)
            throw new globalThis.Error("The parameter 'utcOffset' cannot be null.");
        else if (utcOffset !== undefined)
            url_ += "UtcOffset=" + encodeURIComponent("" + utcOffset) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (nonCheckInsInDays !== undefined && nonCheckInsInDays !== null)
            url_ += "NonCheckInsInDays=" + encodeURIComponent("" + nonCheckInsInDays) + "&";
        if (personTagIds !== undefined && personTagIds !== null)
            personTagIds && personTagIds.forEach(item => { url_ += "PersonTagIds=" + encodeURIComponent("" + item) + "&"; });
        if (wattLocationIDs !== undefined && wattLocationIDs !== null)
            wattLocationIDs && wattLocationIDs.forEach(item => { url_ += "WattLocationIDs=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistoricalCheckinByAccountChart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistoricalCheckinByAccountChart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckinByAccountHistoricalCheckinChartViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckinByAccountHistoricalCheckinChartViewModel[]>;
        }));
    }

    protected processGetHistoricalCheckinByAccountChart(response: HttpResponseBase): Observable<CheckinByAccountHistoricalCheckinChartViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckinByAccountHistoricalCheckinChartViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckinByAccountHistoricalCheckinChartViewModel[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CheckInCheckOutLocationReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getCheckInCheckOutLocationList(accountId?: number | null | undefined, dateRange_StartDate?: moment.Moment | null | undefined, dateRange_EndDate?: moment.Moment | null | undefined, wattLocationIDs?: string[] | null | undefined, minDistance?: number | undefined, roleID?: number | null | undefined, search?: string | null | undefined, banners?: string[] | null | undefined, sortColumn?: string | null | undefined, ascending?: boolean | undefined, limit?: number | undefined, offset?: number | undefined): Observable<LimitedResultOfCheckInCheckOutLocationReportViewModel> {
        let url_ = this.baseUrl + "/client/v1/checkincheckoutlocationreport/getcheckincheckoutlocationlist?";
        if (accountId !== undefined && accountId !== null)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (dateRange_StartDate !== undefined && dateRange_StartDate !== null)
            url_ += "DateRange.StartDate=" + encodeURIComponent(dateRange_StartDate ? "" + dateRange_StartDate.toISOString() : "") + "&";
        if (dateRange_EndDate !== undefined && dateRange_EndDate !== null)
            url_ += "DateRange.EndDate=" + encodeURIComponent(dateRange_EndDate ? "" + dateRange_EndDate.toISOString() : "") + "&";
        if (wattLocationIDs !== undefined && wattLocationIDs !== null)
            wattLocationIDs && wattLocationIDs.forEach(item => { url_ += "WattLocationIDs=" + encodeURIComponent("" + item) + "&"; });
        if (minDistance === null)
            throw new globalThis.Error("The parameter 'minDistance' cannot be null.");
        else if (minDistance !== undefined)
            url_ += "MinDistance=" + encodeURIComponent("" + minDistance) + "&";
        if (roleID !== undefined && roleID !== null)
            url_ += "RoleID=" + encodeURIComponent("" + roleID) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (banners !== undefined && banners !== null)
            banners && banners.forEach(item => { url_ += "Banners=" + encodeURIComponent("" + item) + "&"; });
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (ascending === null)
            throw new globalThis.Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "Ascending=" + encodeURIComponent("" + ascending) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCheckInCheckOutLocationList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCheckInCheckOutLocationList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfCheckInCheckOutLocationReportViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfCheckInCheckOutLocationReportViewModel>;
        }));
    }

    protected processGetCheckInCheckOutLocationList(response: HttpResponseBase): Observable<LimitedResultOfCheckInCheckOutLocationReportViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfCheckInCheckOutLocationReportViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfCheckInCheckOutLocationReportViewModel>(null as any);
    }

    exportAll(accountId?: number | null | undefined, dateRange_StartDate?: moment.Moment | null | undefined, dateRange_EndDate?: moment.Moment | null | undefined, wattLocationIDs?: string[] | null | undefined, minDistance?: number | undefined, roleID?: number | null | undefined, search?: string | null | undefined, banners?: string[] | null | undefined, sortColumn?: string | null | undefined, ascending?: boolean | undefined, limit?: number | undefined, offset?: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/checkincheckoutlocationreport/exportall?";
        if (accountId !== undefined && accountId !== null)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (dateRange_StartDate !== undefined && dateRange_StartDate !== null)
            url_ += "DateRange.StartDate=" + encodeURIComponent(dateRange_StartDate ? "" + dateRange_StartDate.toISOString() : "") + "&";
        if (dateRange_EndDate !== undefined && dateRange_EndDate !== null)
            url_ += "DateRange.EndDate=" + encodeURIComponent(dateRange_EndDate ? "" + dateRange_EndDate.toISOString() : "") + "&";
        if (wattLocationIDs !== undefined && wattLocationIDs !== null)
            wattLocationIDs && wattLocationIDs.forEach(item => { url_ += "WattLocationIDs=" + encodeURIComponent("" + item) + "&"; });
        if (minDistance === null)
            throw new globalThis.Error("The parameter 'minDistance' cannot be null.");
        else if (minDistance !== undefined)
            url_ += "MinDistance=" + encodeURIComponent("" + minDistance) + "&";
        if (roleID !== undefined && roleID !== null)
            url_ += "RoleID=" + encodeURIComponent("" + roleID) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (banners !== undefined && banners !== null)
            banners && banners.forEach(item => { url_ += "Banners=" + encodeURIComponent("" + item) + "&"; });
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (ascending === null)
            throw new globalThis.Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "Ascending=" + encodeURIComponent("" + ascending) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportAll(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getDwCheckInCheckOutLocationList(accountId?: number | null | undefined, dateRange_StartDate?: moment.Moment | null | undefined, dateRange_EndDate?: moment.Moment | null | undefined, wattLocationIDs?: string[] | null | undefined, minDistance?: number | undefined, roleID?: number | null | undefined, search?: string | null | undefined, banners?: string[] | null | undefined, sortColumn?: string | null | undefined, ascending?: boolean | undefined, limit?: number | undefined, offset?: number | undefined): Observable<LimitedResultOfCheckInCheckOutLocationReportViewModel> {
        let url_ = this.baseUrl + "/client/v1/checkincheckoutlocationreport/getdwcheckincheckoutlocationlist?";
        if (accountId !== undefined && accountId !== null)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (dateRange_StartDate !== undefined && dateRange_StartDate !== null)
            url_ += "DateRange.StartDate=" + encodeURIComponent(dateRange_StartDate ? "" + dateRange_StartDate.toISOString() : "") + "&";
        if (dateRange_EndDate !== undefined && dateRange_EndDate !== null)
            url_ += "DateRange.EndDate=" + encodeURIComponent(dateRange_EndDate ? "" + dateRange_EndDate.toISOString() : "") + "&";
        if (wattLocationIDs !== undefined && wattLocationIDs !== null)
            wattLocationIDs && wattLocationIDs.forEach(item => { url_ += "WattLocationIDs=" + encodeURIComponent("" + item) + "&"; });
        if (minDistance === null)
            throw new globalThis.Error("The parameter 'minDistance' cannot be null.");
        else if (minDistance !== undefined)
            url_ += "MinDistance=" + encodeURIComponent("" + minDistance) + "&";
        if (roleID !== undefined && roleID !== null)
            url_ += "RoleID=" + encodeURIComponent("" + roleID) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (banners !== undefined && banners !== null)
            banners && banners.forEach(item => { url_ += "Banners=" + encodeURIComponent("" + item) + "&"; });
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (ascending === null)
            throw new globalThis.Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "Ascending=" + encodeURIComponent("" + ascending) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDwCheckInCheckOutLocationList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDwCheckInCheckOutLocationList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfCheckInCheckOutLocationReportViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfCheckInCheckOutLocationReportViewModel>;
        }));
    }

    protected processGetDwCheckInCheckOutLocationList(response: HttpResponseBase): Observable<LimitedResultOfCheckInCheckOutLocationReportViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfCheckInCheckOutLocationReportViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfCheckInCheckOutLocationReportViewModel>(null as any);
    }

    getDwCheckInCheckOutLocationExportAll(accountId?: number | null | undefined, dateRange_StartDate?: moment.Moment | null | undefined, dateRange_EndDate?: moment.Moment | null | undefined, wattLocationIDs?: string[] | null | undefined, minDistance?: number | undefined, roleID?: number | null | undefined, search?: string | null | undefined, banners?: string[] | null | undefined, sortColumn?: string | null | undefined, ascending?: boolean | undefined, limit?: number | undefined, offset?: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/checkincheckoutlocationreport/getdwcheckincheckoutlocationexportall?";
        if (accountId !== undefined && accountId !== null)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (dateRange_StartDate !== undefined && dateRange_StartDate !== null)
            url_ += "DateRange.StartDate=" + encodeURIComponent(dateRange_StartDate ? "" + dateRange_StartDate.toISOString() : "") + "&";
        if (dateRange_EndDate !== undefined && dateRange_EndDate !== null)
            url_ += "DateRange.EndDate=" + encodeURIComponent(dateRange_EndDate ? "" + dateRange_EndDate.toISOString() : "") + "&";
        if (wattLocationIDs !== undefined && wattLocationIDs !== null)
            wattLocationIDs && wattLocationIDs.forEach(item => { url_ += "WattLocationIDs=" + encodeURIComponent("" + item) + "&"; });
        if (minDistance === null)
            throw new globalThis.Error("The parameter 'minDistance' cannot be null.");
        else if (minDistance !== undefined)
            url_ += "MinDistance=" + encodeURIComponent("" + minDistance) + "&";
        if (roleID !== undefined && roleID !== null)
            url_ += "RoleID=" + encodeURIComponent("" + roleID) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (banners !== undefined && banners !== null)
            banners && banners.forEach(item => { url_ += "Banners=" + encodeURIComponent("" + item) + "&"; });
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (ascending === null)
            throw new globalThis.Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "Ascending=" + encodeURIComponent("" + ascending) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDwCheckInCheckOutLocationExportAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDwCheckInCheckOutLocationExportAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetDwCheckInCheckOutLocationExportAll(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CheckInClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    fieldGroupCounts(banners?: string[] | null | undefined): Observable<AccountCheckInCount[]> {
        let url_ = this.baseUrl + "/client/v1/checkin/current/account-counts?";
        if (banners !== undefined && banners !== null)
            banners && banners.forEach(item => { url_ += "Banners=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFieldGroupCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFieldGroupCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountCheckInCount[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountCheckInCount[]>;
        }));
    }

    protected processFieldGroupCounts(response: HttpResponseBase): Observable<AccountCheckInCount[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountCheckInCount.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountCheckInCount[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CommunicationLogClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getCommunicationLogList(accountId?: number | null | undefined, changeSource?: string | null | undefined, dateRange_StartDate?: moment.Moment | null | undefined, dateRange_EndDate?: moment.Moment | null | undefined, sort?: string | null | undefined, ascending?: boolean | undefined, limit?: number | undefined, offset?: number | undefined, searchText?: string | null | undefined): Observable<LimitedResultOfCommunicationLogViewModel> {
        let url_ = this.baseUrl + "/client/v1/communicationlog?";
        if (accountId !== undefined && accountId !== null)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (changeSource !== undefined && changeSource !== null)
            url_ += "ChangeSource=" + encodeURIComponent("" + changeSource) + "&";
        if (dateRange_StartDate !== undefined && dateRange_StartDate !== null)
            url_ += "DateRange.StartDate=" + encodeURIComponent(dateRange_StartDate ? "" + dateRange_StartDate.toISOString() : "") + "&";
        if (dateRange_EndDate !== undefined && dateRange_EndDate !== null)
            url_ += "DateRange.EndDate=" + encodeURIComponent(dateRange_EndDate ? "" + dateRange_EndDate.toISOString() : "") + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (ascending === null)
            throw new globalThis.Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "Ascending=" + encodeURIComponent("" + ascending) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommunicationLogList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommunicationLogList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfCommunicationLogViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfCommunicationLogViewModel>;
        }));
    }

    protected processGetCommunicationLogList(response: HttpResponseBase): Observable<LimitedResultOfCommunicationLogViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfCommunicationLogViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfCommunicationLogViewModel>(null as any);
    }

    exportCommunicationLog(accountId?: number | null | undefined, changeSource?: string | null | undefined, dateRange_StartDate?: moment.Moment | null | undefined, dateRange_EndDate?: moment.Moment | null | undefined, sort?: string | null | undefined, ascending?: boolean | undefined, limit?: number | undefined, offset?: number | undefined, searchText?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/communicationlog/export?";
        if (accountId !== undefined && accountId !== null)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (changeSource !== undefined && changeSource !== null)
            url_ += "ChangeSource=" + encodeURIComponent("" + changeSource) + "&";
        if (dateRange_StartDate !== undefined && dateRange_StartDate !== null)
            url_ += "DateRange.StartDate=" + encodeURIComponent(dateRange_StartDate ? "" + dateRange_StartDate.toISOString() : "") + "&";
        if (dateRange_EndDate !== undefined && dateRange_EndDate !== null)
            url_ += "DateRange.EndDate=" + encodeURIComponent(dateRange_EndDate ? "" + dateRange_EndDate.toISOString() : "") + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (ascending === null)
            throw new globalThis.Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "Ascending=" + encodeURIComponent("" + ascending) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCommunicationLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCommunicationLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportCommunicationLog(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getCommunicationLogDetails(id: string): Observable<CommunicationLogDetailsViewModel> {
        let url_ = this.baseUrl + "/client/v1/communicationlog/{id}/details";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommunicationLogDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommunicationLogDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommunicationLogDetailsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommunicationLogDetailsViewModel>;
        }));
    }

    protected processGetCommunicationLogDetails(response: HttpResponseBase): Observable<CommunicationLogDetailsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommunicationLogDetailsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommunicationLogDetailsViewModel>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CountClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    repsCurrentlyInStore(banners?: string[] | null | undefined, isDemo?: boolean | null | undefined, locationNumber?: string | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/client/v1/count/reps-currently-in-store?";
        if (banners !== undefined && banners !== null)
            banners && banners.forEach(item => { url_ += "Banners=" + encodeURIComponent("" + item) + "&"; });
        if (isDemo !== undefined && isDemo !== null)
            url_ += "isDemo=" + encodeURIComponent("" + isDemo) + "&";
        if (locationNumber !== undefined && locationNumber !== null)
            url_ += "locationNumber=" + encodeURIComponent("" + locationNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRepsCurrentlyInStore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRepsCurrentlyInStore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processRepsCurrentlyInStore(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    totalInStoreTime(banners?: string[] | null | undefined, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/client/v1/count/total-instore-time?";
        if (banners !== undefined && banners !== null)
            banners && banners.forEach(item => { url_ += "Banners=" + encodeURIComponent("" + item) + "&"; });
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTotalInStoreTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTotalInStoreTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processTotalInStoreTime(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    certificationCount(banners?: string[] | null | undefined, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/client/v1/count/certification?";
        if (banners !== undefined && banners !== null)
            banners && banners.forEach(item => { url_ += "Banners=" + encodeURIComponent("" + item) + "&"; });
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCertificationCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCertificationCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCertificationCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    completedVisits(banners?: string[] | null | undefined, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/client/v1/count/completed-visits?";
        if (banners !== undefined && banners !== null)
            banners && banners.forEach(item => { url_ += "Banners=" + encodeURIComponent("" + item) + "&"; });
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompletedVisits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompletedVisits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCompletedVisits(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    recentCheckInCount(startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/client/v1/count/recent-checkin?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecentCheckInCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecentCheckInCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processRecentCheckInCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    scheduledTasksCount(filter?: DashboardFilter | null | undefined, isDemo?: boolean | undefined): Observable<number> {
        let url_ = this.baseUrl + "/client/v1/count/scheduled-tasks?";
        if (isDemo === null)
            throw new globalThis.Error("The parameter 'isDemo' cannot be null.");
        else if (isDemo !== undefined)
            url_ += "isDemo=" + encodeURIComponent("" + isDemo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduledTasksCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduledTasksCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processScheduledTasksCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CountryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getAllCountries(): Observable<CountryViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/country/getallcountries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryViewModel[]>;
        }));
    }

    protected processGetAllCountries(response: HttpResponseBase): Observable<CountryViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CountryViewModel[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CoverageReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getHistoricalReport(accountIds?: number[] | null | undefined, fieldGroupTypeIds?: number[] | null | undefined, locationGroupId?: number | null | undefined, wattLocationID?: string | null | undefined, locationGroupValues?: string[] | null | undefined, onlyDistinctCheckins?: boolean | undefined, excludeWeekends?: boolean | undefined, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined, utcOffset?: number | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined, nonCheckInsInDays?: number | null | undefined, personTagIds?: number[] | null | undefined, wattLocationIDs?: string[] | null | undefined, offset?: number | undefined, limit?: number | undefined): Observable<LimitedResultOfCheckinByAccountHistoricalViewModel> {
        let url_ = this.baseUrl + "/client/v1/coverage_report/historical?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (fieldGroupTypeIds !== undefined && fieldGroupTypeIds !== null)
            fieldGroupTypeIds && fieldGroupTypeIds.forEach(item => { url_ += "FieldGroupTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (locationGroupId !== undefined && locationGroupId !== null)
            url_ += "LocationGroupId=" + encodeURIComponent("" + locationGroupId) + "&";
        if (wattLocationID !== undefined && wattLocationID !== null)
            url_ += "WattLocationID=" + encodeURIComponent("" + wattLocationID) + "&";
        if (locationGroupValues !== undefined && locationGroupValues !== null)
            locationGroupValues && locationGroupValues.forEach(item => { url_ += "LocationGroupValues=" + encodeURIComponent("" + item) + "&"; });
        if (onlyDistinctCheckins === null)
            throw new globalThis.Error("The parameter 'onlyDistinctCheckins' cannot be null.");
        else if (onlyDistinctCheckins !== undefined)
            url_ += "OnlyDistinctCheckins=" + encodeURIComponent("" + onlyDistinctCheckins) + "&";
        if (excludeWeekends === null)
            throw new globalThis.Error("The parameter 'excludeWeekends' cannot be null.");
        else if (excludeWeekends !== undefined)
            url_ += "ExcludeWeekends=" + encodeURIComponent("" + excludeWeekends) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (utcOffset === null)
            throw new globalThis.Error("The parameter 'utcOffset' cannot be null.");
        else if (utcOffset !== undefined)
            url_ += "UtcOffset=" + encodeURIComponent("" + utcOffset) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (nonCheckInsInDays !== undefined && nonCheckInsInDays !== null)
            url_ += "NonCheckInsInDays=" + encodeURIComponent("" + nonCheckInsInDays) + "&";
        if (personTagIds !== undefined && personTagIds !== null)
            personTagIds && personTagIds.forEach(item => { url_ += "PersonTagIds=" + encodeURIComponent("" + item) + "&"; });
        if (wattLocationIDs !== undefined && wattLocationIDs !== null)
            wattLocationIDs && wattLocationIDs.forEach(item => { url_ += "WattLocationIDs=" + encodeURIComponent("" + item) + "&"; });
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistoricalReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistoricalReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfCheckinByAccountHistoricalViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfCheckinByAccountHistoricalViewModel>;
        }));
    }

    protected processGetHistoricalReport(response: HttpResponseBase): Observable<LimitedResultOfCheckinByAccountHistoricalViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfCheckinByAccountHistoricalViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(item);
            }
            else {
                result400 = null as any;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfCheckinByAccountHistoricalViewModel>(null as any);
    }

    exportHistoricalCheckinByAccount(accountIds?: number[] | null | undefined, fieldGroupTypeIds?: number[] | null | undefined, locationGroupId?: number | null | undefined, wattLocationID?: string | null | undefined, locationGroupValues?: string[] | null | undefined, onlyDistinctCheckins?: boolean | undefined, excludeWeekends?: boolean | undefined, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined, utcOffset?: number | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined, nonCheckInsInDays?: number | null | undefined, personTagIds?: number[] | null | undefined, wattLocationIDs?: string[] | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/coverage_report/historical/export?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (fieldGroupTypeIds !== undefined && fieldGroupTypeIds !== null)
            fieldGroupTypeIds && fieldGroupTypeIds.forEach(item => { url_ += "FieldGroupTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (locationGroupId !== undefined && locationGroupId !== null)
            url_ += "LocationGroupId=" + encodeURIComponent("" + locationGroupId) + "&";
        if (wattLocationID !== undefined && wattLocationID !== null)
            url_ += "WattLocationID=" + encodeURIComponent("" + wattLocationID) + "&";
        if (locationGroupValues !== undefined && locationGroupValues !== null)
            locationGroupValues && locationGroupValues.forEach(item => { url_ += "LocationGroupValues=" + encodeURIComponent("" + item) + "&"; });
        if (onlyDistinctCheckins === null)
            throw new globalThis.Error("The parameter 'onlyDistinctCheckins' cannot be null.");
        else if (onlyDistinctCheckins !== undefined)
            url_ += "OnlyDistinctCheckins=" + encodeURIComponent("" + onlyDistinctCheckins) + "&";
        if (excludeWeekends === null)
            throw new globalThis.Error("The parameter 'excludeWeekends' cannot be null.");
        else if (excludeWeekends !== undefined)
            url_ += "ExcludeWeekends=" + encodeURIComponent("" + excludeWeekends) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (utcOffset === null)
            throw new globalThis.Error("The parameter 'utcOffset' cannot be null.");
        else if (utcOffset !== undefined)
            url_ += "UtcOffset=" + encodeURIComponent("" + utcOffset) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (nonCheckInsInDays !== undefined && nonCheckInsInDays !== null)
            url_ += "NonCheckInsInDays=" + encodeURIComponent("" + nonCheckInsInDays) + "&";
        if (personTagIds !== undefined && personTagIds !== null)
            personTagIds && personTagIds.forEach(item => { url_ += "PersonTagIds=" + encodeURIComponent("" + item) + "&"; });
        if (wattLocationIDs !== undefined && wattLocationIDs !== null)
            wattLocationIDs && wattLocationIDs.forEach(item => { url_ += "WattLocationIDs=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportHistoricalCheckinByAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportHistoricalCheckinByAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportHistoricalCheckinByAccount(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(item);
            }
            else {
                result400 = null as any;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getCoverageExceptions(accountIds?: number[] | null | undefined, fieldGroupTypeIds?: number[] | null | undefined, locationGroupId?: number | null | undefined, wattLocationID?: string | null | undefined, locationGroupValues?: string[] | null | undefined, onlyDistinctCheckins?: boolean | undefined, excludeWeekends?: boolean | undefined, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined, utcOffset?: number | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined, nonCheckInsInDays?: number | null | undefined, personTagIds?: number[] | null | undefined, wattLocationIDs?: string[] | null | undefined, offset?: number | undefined, limit?: number | undefined): Observable<LimitedResultOfCoverageCheckInExceptionsViewModel> {
        let url_ = this.baseUrl + "/client/v1/coverage_report/exceptions?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (fieldGroupTypeIds !== undefined && fieldGroupTypeIds !== null)
            fieldGroupTypeIds && fieldGroupTypeIds.forEach(item => { url_ += "FieldGroupTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (locationGroupId !== undefined && locationGroupId !== null)
            url_ += "LocationGroupId=" + encodeURIComponent("" + locationGroupId) + "&";
        if (wattLocationID !== undefined && wattLocationID !== null)
            url_ += "WattLocationID=" + encodeURIComponent("" + wattLocationID) + "&";
        if (locationGroupValues !== undefined && locationGroupValues !== null)
            locationGroupValues && locationGroupValues.forEach(item => { url_ += "LocationGroupValues=" + encodeURIComponent("" + item) + "&"; });
        if (onlyDistinctCheckins === null)
            throw new globalThis.Error("The parameter 'onlyDistinctCheckins' cannot be null.");
        else if (onlyDistinctCheckins !== undefined)
            url_ += "OnlyDistinctCheckins=" + encodeURIComponent("" + onlyDistinctCheckins) + "&";
        if (excludeWeekends === null)
            throw new globalThis.Error("The parameter 'excludeWeekends' cannot be null.");
        else if (excludeWeekends !== undefined)
            url_ += "ExcludeWeekends=" + encodeURIComponent("" + excludeWeekends) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (utcOffset === null)
            throw new globalThis.Error("The parameter 'utcOffset' cannot be null.");
        else if (utcOffset !== undefined)
            url_ += "UtcOffset=" + encodeURIComponent("" + utcOffset) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (nonCheckInsInDays !== undefined && nonCheckInsInDays !== null)
            url_ += "NonCheckInsInDays=" + encodeURIComponent("" + nonCheckInsInDays) + "&";
        if (personTagIds !== undefined && personTagIds !== null)
            personTagIds && personTagIds.forEach(item => { url_ += "PersonTagIds=" + encodeURIComponent("" + item) + "&"; });
        if (wattLocationIDs !== undefined && wattLocationIDs !== null)
            wattLocationIDs && wattLocationIDs.forEach(item => { url_ += "WattLocationIDs=" + encodeURIComponent("" + item) + "&"; });
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoverageExceptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoverageExceptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfCoverageCheckInExceptionsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfCoverageCheckInExceptionsViewModel>;
        }));
    }

    protected processGetCoverageExceptions(response: HttpResponseBase): Observable<LimitedResultOfCoverageCheckInExceptionsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfCoverageCheckInExceptionsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfCoverageCheckInExceptionsViewModel>(null as any);
    }

    getCheckInExceptionsChart(accountIds?: number[] | null | undefined, fieldGroupTypeIds?: number[] | null | undefined, locationGroupId?: number | null | undefined, wattLocationID?: string | null | undefined, locationGroupValues?: string[] | null | undefined, onlyDistinctCheckins?: boolean | undefined, excludeWeekends?: boolean | undefined, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined, utcOffset?: number | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined, nonCheckInsInDays?: number | null | undefined, personTagIds?: number[] | null | undefined, wattLocationIDs?: string[] | null | undefined): Observable<CoverageCheckInExceptionsChart> {
        let url_ = this.baseUrl + "/client/v1?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (fieldGroupTypeIds !== undefined && fieldGroupTypeIds !== null)
            fieldGroupTypeIds && fieldGroupTypeIds.forEach(item => { url_ += "FieldGroupTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (locationGroupId !== undefined && locationGroupId !== null)
            url_ += "LocationGroupId=" + encodeURIComponent("" + locationGroupId) + "&";
        if (wattLocationID !== undefined && wattLocationID !== null)
            url_ += "WattLocationID=" + encodeURIComponent("" + wattLocationID) + "&";
        if (locationGroupValues !== undefined && locationGroupValues !== null)
            locationGroupValues && locationGroupValues.forEach(item => { url_ += "LocationGroupValues=" + encodeURIComponent("" + item) + "&"; });
        if (onlyDistinctCheckins === null)
            throw new globalThis.Error("The parameter 'onlyDistinctCheckins' cannot be null.");
        else if (onlyDistinctCheckins !== undefined)
            url_ += "OnlyDistinctCheckins=" + encodeURIComponent("" + onlyDistinctCheckins) + "&";
        if (excludeWeekends === null)
            throw new globalThis.Error("The parameter 'excludeWeekends' cannot be null.");
        else if (excludeWeekends !== undefined)
            url_ += "ExcludeWeekends=" + encodeURIComponent("" + excludeWeekends) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (utcOffset === null)
            throw new globalThis.Error("The parameter 'utcOffset' cannot be null.");
        else if (utcOffset !== undefined)
            url_ += "UtcOffset=" + encodeURIComponent("" + utcOffset) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (nonCheckInsInDays !== undefined && nonCheckInsInDays !== null)
            url_ += "NonCheckInsInDays=" + encodeURIComponent("" + nonCheckInsInDays) + "&";
        if (personTagIds !== undefined && personTagIds !== null)
            personTagIds && personTagIds.forEach(item => { url_ += "PersonTagIds=" + encodeURIComponent("" + item) + "&"; });
        if (wattLocationIDs !== undefined && wattLocationIDs !== null)
            wattLocationIDs && wattLocationIDs.forEach(item => { url_ += "WattLocationIDs=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCheckInExceptionsChart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCheckInExceptionsChart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoverageCheckInExceptionsChart>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoverageCheckInExceptionsChart>;
        }));
    }

    protected processGetCheckInExceptionsChart(response: HttpResponseBase): Observable<CoverageCheckInExceptionsChart> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoverageCheckInExceptionsChart.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CoverageCheckInExceptionsChart>(null as any);
    }

    getHistoricalCheckinByAccountUser(accountIds?: number[] | null | undefined, personTagIds?: number[] | null | undefined, fieldGroupTypeIds?: number[] | null | undefined, wattLocationID?: string | null | undefined, locationGroupId?: number | null | undefined, locationGroupValues?: string[] | null | undefined, onlyDistinctCheckins?: boolean | undefined, excludeWeekends?: boolean | undefined, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined, utcOffset?: number | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined, offset?: number | undefined, limit?: number | undefined): Observable<LimitedResultOfCheckinByAccountUserHistoricalViewModel> {
        let url_ = this.baseUrl + "/client/v1/coverage_report/historical/users?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (personTagIds !== undefined && personTagIds !== null)
            personTagIds && personTagIds.forEach(item => { url_ += "PersonTagIds=" + encodeURIComponent("" + item) + "&"; });
        if (fieldGroupTypeIds !== undefined && fieldGroupTypeIds !== null)
            fieldGroupTypeIds && fieldGroupTypeIds.forEach(item => { url_ += "FieldGroupTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (wattLocationID !== undefined && wattLocationID !== null)
            url_ += "WattLocationID=" + encodeURIComponent("" + wattLocationID) + "&";
        if (locationGroupId !== undefined && locationGroupId !== null)
            url_ += "LocationGroupId=" + encodeURIComponent("" + locationGroupId) + "&";
        if (locationGroupValues !== undefined && locationGroupValues !== null)
            locationGroupValues && locationGroupValues.forEach(item => { url_ += "LocationGroupValues=" + encodeURIComponent("" + item) + "&"; });
        if (onlyDistinctCheckins === null)
            throw new globalThis.Error("The parameter 'onlyDistinctCheckins' cannot be null.");
        else if (onlyDistinctCheckins !== undefined)
            url_ += "OnlyDistinctCheckins=" + encodeURIComponent("" + onlyDistinctCheckins) + "&";
        if (excludeWeekends === null)
            throw new globalThis.Error("The parameter 'excludeWeekends' cannot be null.");
        else if (excludeWeekends !== undefined)
            url_ += "ExcludeWeekends=" + encodeURIComponent("" + excludeWeekends) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (utcOffset === null)
            throw new globalThis.Error("The parameter 'utcOffset' cannot be null.");
        else if (utcOffset !== undefined)
            url_ += "UtcOffset=" + encodeURIComponent("" + utcOffset) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistoricalCheckinByAccountUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistoricalCheckinByAccountUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfCheckinByAccountUserHistoricalViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfCheckinByAccountUserHistoricalViewModel>;
        }));
    }

    protected processGetHistoricalCheckinByAccountUser(response: HttpResponseBase): Observable<LimitedResultOfCheckinByAccountUserHistoricalViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfCheckinByAccountUserHistoricalViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfCheckinByAccountUserHistoricalViewModel>(null as any);
    }

    exportExceptions(accountIds?: number[] | null | undefined, fieldGroupTypeIds?: number[] | null | undefined, locationGroupId?: number | null | undefined, wattLocationID?: string | null | undefined, locationGroupValues?: string[] | null | undefined, onlyDistinctCheckins?: boolean | undefined, excludeWeekends?: boolean | undefined, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined, utcOffset?: number | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined, nonCheckInsInDays?: number | null | undefined, personTagIds?: number[] | null | undefined, wattLocationIDs?: string[] | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/coverage_report/exceptions/export?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (fieldGroupTypeIds !== undefined && fieldGroupTypeIds !== null)
            fieldGroupTypeIds && fieldGroupTypeIds.forEach(item => { url_ += "FieldGroupTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (locationGroupId !== undefined && locationGroupId !== null)
            url_ += "LocationGroupId=" + encodeURIComponent("" + locationGroupId) + "&";
        if (wattLocationID !== undefined && wattLocationID !== null)
            url_ += "WattLocationID=" + encodeURIComponent("" + wattLocationID) + "&";
        if (locationGroupValues !== undefined && locationGroupValues !== null)
            locationGroupValues && locationGroupValues.forEach(item => { url_ += "LocationGroupValues=" + encodeURIComponent("" + item) + "&"; });
        if (onlyDistinctCheckins === null)
            throw new globalThis.Error("The parameter 'onlyDistinctCheckins' cannot be null.");
        else if (onlyDistinctCheckins !== undefined)
            url_ += "OnlyDistinctCheckins=" + encodeURIComponent("" + onlyDistinctCheckins) + "&";
        if (excludeWeekends === null)
            throw new globalThis.Error("The parameter 'excludeWeekends' cannot be null.");
        else if (excludeWeekends !== undefined)
            url_ += "ExcludeWeekends=" + encodeURIComponent("" + excludeWeekends) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (utcOffset === null)
            throw new globalThis.Error("The parameter 'utcOffset' cannot be null.");
        else if (utcOffset !== undefined)
            url_ += "UtcOffset=" + encodeURIComponent("" + utcOffset) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (nonCheckInsInDays !== undefined && nonCheckInsInDays !== null)
            url_ += "NonCheckInsInDays=" + encodeURIComponent("" + nonCheckInsInDays) + "&";
        if (personTagIds !== undefined && personTagIds !== null)
            personTagIds && personTagIds.forEach(item => { url_ += "PersonTagIds=" + encodeURIComponent("" + item) + "&"; });
        if (wattLocationIDs !== undefined && wattLocationIDs !== null)
            wattLocationIDs && wattLocationIDs.forEach(item => { url_ += "WattLocationIDs=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportExceptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExceptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportExceptions(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DashboardSupplierClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    filterSuppliers(filter?: string | null | undefined, limit?: number | undefined): Observable<LimitedResultOfSupplier> {
        let url_ = this.baseUrl + "/client/v1/suppliers/filter?";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilterSuppliers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilterSuppliers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfSupplier>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfSupplier>;
        }));
    }

    protected processFilterSuppliers(response: HttpResponseBase): Observable<LimitedResultOfSupplier> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfSupplier.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfSupplier>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DepartmentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getDepartmentList(): Observable<DepartmentModel[]> {
        let url_ = this.baseUrl + "/client/v1/departments/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDepartmentList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDepartmentList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DepartmentModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DepartmentModel[]>;
        }));
    }

    protected processGetDepartmentList(response: HttpResponseBase): Observable<DepartmentModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DepartmentModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DepartmentModel[]>(null as any);
    }

    getStrategicBusinessUnits(): Observable<StrategicBusinessUnitModel[]> {
        let url_ = this.baseUrl + "/client/v1/departments/sbus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStrategicBusinessUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStrategicBusinessUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StrategicBusinessUnitModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StrategicBusinessUnitModel[]>;
        }));
    }

    protected processGetStrategicBusinessUnits(response: HttpResponseBase): Observable<StrategicBusinessUnitModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StrategicBusinessUnitModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StrategicBusinessUnitModel[]>(null as any);
    }

    getSupplierSignageList(): Observable<SupplierSignageDepartmentViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/departments/suppliersignagelist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplierSignageList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplierSignageList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplierSignageDepartmentViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplierSignageDepartmentViewModel[]>;
        }));
    }

    protected processGetSupplierSignageList(response: HttpResponseBase): Observable<SupplierSignageDepartmentViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SupplierSignageDepartmentViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplierSignageDepartmentViewModel[]>(null as any);
    }

    getDepartments(strategicBusinessUnits?: string[] | null | undefined, departmentGroups?: string[] | null | undefined, status?: StatusTypes | null | undefined, searchText?: string | null | undefined, sortKey?: string | null | undefined, isAscending?: boolean | undefined): Observable<DepartmentModel[]> {
        let url_ = this.baseUrl + "/client/v1/departments/filtereddepartments?";
        if (strategicBusinessUnits !== undefined && strategicBusinessUnits !== null)
            strategicBusinessUnits && strategicBusinessUnits.forEach(item => { url_ += "StrategicBusinessUnits=" + encodeURIComponent("" + item) + "&"; });
        if (departmentGroups !== undefined && departmentGroups !== null)
            departmentGroups && departmentGroups.forEach(item => { url_ += "DepartmentGroups=" + encodeURIComponent("" + item) + "&"; });
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortKey !== undefined && sortKey !== null)
            url_ += "SortKey=" + encodeURIComponent("" + sortKey) + "&";
        if (isAscending === null)
            throw new globalThis.Error("The parameter 'isAscending' cannot be null.");
        else if (isAscending !== undefined)
            url_ += "IsAscending=" + encodeURIComponent("" + isAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDepartments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDepartments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DepartmentModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DepartmentModel[]>;
        }));
    }

    protected processGetDepartments(response: HttpResponseBase): Observable<DepartmentModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DepartmentModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DepartmentModel[]>(null as any);
    }

    export(strategicBusinessUnits?: string[] | null | undefined, departmentGroups?: string[] | null | undefined, status?: StatusTypes | null | undefined, searchText?: string | null | undefined, sortKey?: string | null | undefined, isAscending?: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/departments/export?";
        if (strategicBusinessUnits !== undefined && strategicBusinessUnits !== null)
            strategicBusinessUnits && strategicBusinessUnits.forEach(item => { url_ += "StrategicBusinessUnits=" + encodeURIComponent("" + item) + "&"; });
        if (departmentGroups !== undefined && departmentGroups !== null)
            departmentGroups && departmentGroups.forEach(item => { url_ += "DepartmentGroups=" + encodeURIComponent("" + item) + "&"; });
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortKey !== undefined && sortKey !== null)
            url_ += "SortKey=" + encodeURIComponent("" + sortKey) + "&";
        if (isAscending === null)
            throw new globalThis.Error("The parameter 'isAscending' cannot be null.");
        else if (isAscending !== undefined)
            url_ += "IsAscending=" + encodeURIComponent("" + isAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getDepartmentTaskCount(accountId?: number | null | undefined, start?: moment.Moment | undefined, end?: moment.Moment | undefined, strategicBusinessUnits?: string[] | null | undefined, departmentGroups?: string[] | null | undefined, status?: StatusTypes | null | undefined, searchText?: string | null | undefined): Observable<DepartmentTaskCountViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/departments/task-count?";
        if (accountId !== undefined && accountId !== null)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "Start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new globalThis.Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "End=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (strategicBusinessUnits !== undefined && strategicBusinessUnits !== null)
            strategicBusinessUnits && strategicBusinessUnits.forEach(item => { url_ += "StrategicBusinessUnits=" + encodeURIComponent("" + item) + "&"; });
        if (departmentGroups !== undefined && departmentGroups !== null)
            departmentGroups && departmentGroups.forEach(item => { url_ += "DepartmentGroups=" + encodeURIComponent("" + item) + "&"; });
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDepartmentTaskCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDepartmentTaskCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DepartmentTaskCountViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DepartmentTaskCountViewModel[]>;
        }));
    }

    protected processGetDepartmentTaskCount(response: HttpResponseBase): Observable<DepartmentTaskCountViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DepartmentTaskCountViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DepartmentTaskCountViewModel[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DiagnosticsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getDiagnostics(): Observable<DiagnosticsViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/diagnostics";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiagnostics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiagnostics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiagnosticsViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiagnosticsViewModel[]>;
        }));
    }

    protected processGetDiagnostics(response: HttpResponseBase): Observable<DiagnosticsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiagnosticsViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DiagnosticsViewModel[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DownloadReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    downloadReport(reportId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/downloadreport/{reportId}";
        if (reportId === undefined || reportId === null)
            throw new globalThis.Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DueDatePerformanceReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getLocationCompletedByProvider(accountIds?: number[] | null | undefined, locationFormats?: string[] | null | undefined, hierarchyType?: number | null | undefined, hierarchyNames?: string[] | null | undefined, wmtWeeks?: string[] | null | undefined, activities?: string[] | null | undefined, serviceModels?: string[] | null | undefined, departments?: string[] | null | undefined): Observable<LocationCompletedByProvider[]> {
        let url_ = this.baseUrl + "/client/v1/duedateperformancereport/getlocationcompletedbyprovider?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (locationFormats !== undefined && locationFormats !== null)
            locationFormats && locationFormats.forEach(item => { url_ += "LocationFormats=" + encodeURIComponent("" + item) + "&"; });
        if (hierarchyType !== undefined && hierarchyType !== null)
            url_ += "HierarchyType=" + encodeURIComponent("" + hierarchyType) + "&";
        if (hierarchyNames !== undefined && hierarchyNames !== null)
            hierarchyNames && hierarchyNames.forEach(item => { url_ += "HierarchyNames=" + encodeURIComponent("" + item) + "&"; });
        if (wmtWeeks !== undefined && wmtWeeks !== null)
            wmtWeeks && wmtWeeks.forEach(item => { url_ += "WmtWeeks=" + encodeURIComponent("" + item) + "&"; });
        if (activities !== undefined && activities !== null)
            activities && activities.forEach(item => { url_ += "Activities=" + encodeURIComponent("" + item) + "&"; });
        if (serviceModels !== undefined && serviceModels !== null)
            serviceModels && serviceModels.forEach(item => { url_ += "ServiceModels=" + encodeURIComponent("" + item) + "&"; });
        if (departments !== undefined && departments !== null)
            departments && departments.forEach(item => { url_ += "Departments=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationCompletedByProvider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationCompletedByProvider(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationCompletedByProvider[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationCompletedByProvider[]>;
        }));
    }

    protected processGetLocationCompletedByProvider(response: HttpResponseBase): Observable<LocationCompletedByProvider[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationCompletedByProvider.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 408) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result408: any = null;
            let resultData408 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result408 = ProblemDetails.fromJS(resultData408);
            return throwException("A server side error occurred.", status, _responseText, _headers, result408);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationCompletedByProvider[]>(null as any);
    }

    getLocationCompletedByActivity(accountIds?: number[] | null | undefined, locationFormats?: string[] | null | undefined, hierarchyType?: number | null | undefined, hierarchyNames?: string[] | null | undefined, wmtWeeks?: string[] | null | undefined, activities?: string[] | null | undefined, serviceModels?: string[] | null | undefined, departments?: string[] | null | undefined): Observable<LocationCompletedActivity[]> {
        let url_ = this.baseUrl + "/client/v1/duedateperformancereport/getlocationcompletedbyactivity?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (locationFormats !== undefined && locationFormats !== null)
            locationFormats && locationFormats.forEach(item => { url_ += "LocationFormats=" + encodeURIComponent("" + item) + "&"; });
        if (hierarchyType !== undefined && hierarchyType !== null)
            url_ += "HierarchyType=" + encodeURIComponent("" + hierarchyType) + "&";
        if (hierarchyNames !== undefined && hierarchyNames !== null)
            hierarchyNames && hierarchyNames.forEach(item => { url_ += "HierarchyNames=" + encodeURIComponent("" + item) + "&"; });
        if (wmtWeeks !== undefined && wmtWeeks !== null)
            wmtWeeks && wmtWeeks.forEach(item => { url_ += "WmtWeeks=" + encodeURIComponent("" + item) + "&"; });
        if (activities !== undefined && activities !== null)
            activities && activities.forEach(item => { url_ += "Activities=" + encodeURIComponent("" + item) + "&"; });
        if (serviceModels !== undefined && serviceModels !== null)
            serviceModels && serviceModels.forEach(item => { url_ += "ServiceModels=" + encodeURIComponent("" + item) + "&"; });
        if (departments !== undefined && departments !== null)
            departments && departments.forEach(item => { url_ += "Departments=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationCompletedByActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationCompletedByActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationCompletedActivity[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationCompletedActivity[]>;
        }));
    }

    protected processGetLocationCompletedByActivity(response: HttpResponseBase): Observable<LocationCompletedActivity[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationCompletedActivity.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 408) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result408: any = null;
            let resultData408 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result408 = ProblemDetails.fromJS(resultData408);
            return throwException("A server side error occurred.", status, _responseText, _headers, result408);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationCompletedActivity[]>(null as any);
    }

    getLocationOnTimeByWeek(accountIds?: number[] | null | undefined, locationFormats?: string[] | null | undefined, hierarchyType?: number | null | undefined, hierarchyNames?: string[] | null | undefined, wmtWeeks?: string[] | null | undefined, activities?: string[] | null | undefined, serviceModels?: string[] | null | undefined, departments?: string[] | null | undefined): Observable<LocationOnTime[]> {
        let url_ = this.baseUrl + "/client/v1/duedateperformancereport/getlocationontimebyweek?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (locationFormats !== undefined && locationFormats !== null)
            locationFormats && locationFormats.forEach(item => { url_ += "LocationFormats=" + encodeURIComponent("" + item) + "&"; });
        if (hierarchyType !== undefined && hierarchyType !== null)
            url_ += "HierarchyType=" + encodeURIComponent("" + hierarchyType) + "&";
        if (hierarchyNames !== undefined && hierarchyNames !== null)
            hierarchyNames && hierarchyNames.forEach(item => { url_ += "HierarchyNames=" + encodeURIComponent("" + item) + "&"; });
        if (wmtWeeks !== undefined && wmtWeeks !== null)
            wmtWeeks && wmtWeeks.forEach(item => { url_ += "WmtWeeks=" + encodeURIComponent("" + item) + "&"; });
        if (activities !== undefined && activities !== null)
            activities && activities.forEach(item => { url_ += "Activities=" + encodeURIComponent("" + item) + "&"; });
        if (serviceModels !== undefined && serviceModels !== null)
            serviceModels && serviceModels.forEach(item => { url_ += "ServiceModels=" + encodeURIComponent("" + item) + "&"; });
        if (departments !== undefined && departments !== null)
            departments && departments.forEach(item => { url_ += "Departments=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationOnTimeByWeek(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationOnTimeByWeek(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationOnTime[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationOnTime[]>;
        }));
    }

    protected processGetLocationOnTimeByWeek(response: HttpResponseBase): Observable<LocationOnTime[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationOnTime.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 408) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result408: any = null;
            let resultData408 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result408 = ProblemDetails.fromJS(resultData408);
            return throwException("A server side error occurred.", status, _responseText, _headers, result408);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationOnTime[]>(null as any);
    }

    getTaskLocationDueInWeeks(accountIds?: number[] | null | undefined, locationFormats?: string[] | null | undefined, hierarchyType?: number | null | undefined, hierarchyNames?: string[] | null | undefined, wmtWeeks?: string[] | null | undefined, activities?: string[] | null | undefined, serviceModels?: string[] | null | undefined, departments?: string[] | null | undefined): Observable<TaskLocationDue[]> {
        let url_ = this.baseUrl + "/client/v1/duedateperformancereport/gettasklocationdueinweeks?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (locationFormats !== undefined && locationFormats !== null)
            locationFormats && locationFormats.forEach(item => { url_ += "LocationFormats=" + encodeURIComponent("" + item) + "&"; });
        if (hierarchyType !== undefined && hierarchyType !== null)
            url_ += "HierarchyType=" + encodeURIComponent("" + hierarchyType) + "&";
        if (hierarchyNames !== undefined && hierarchyNames !== null)
            hierarchyNames && hierarchyNames.forEach(item => { url_ += "HierarchyNames=" + encodeURIComponent("" + item) + "&"; });
        if (wmtWeeks !== undefined && wmtWeeks !== null)
            wmtWeeks && wmtWeeks.forEach(item => { url_ += "WmtWeeks=" + encodeURIComponent("" + item) + "&"; });
        if (activities !== undefined && activities !== null)
            activities && activities.forEach(item => { url_ += "Activities=" + encodeURIComponent("" + item) + "&"; });
        if (serviceModels !== undefined && serviceModels !== null)
            serviceModels && serviceModels.forEach(item => { url_ += "ServiceModels=" + encodeURIComponent("" + item) + "&"; });
        if (departments !== undefined && departments !== null)
            departments && departments.forEach(item => { url_ += "Departments=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskLocationDueInWeeks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskLocationDueInWeeks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskLocationDue[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskLocationDue[]>;
        }));
    }

    protected processGetTaskLocationDueInWeeks(response: HttpResponseBase): Observable<TaskLocationDue[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskLocationDue.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 408) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result408: any = null;
            let resultData408 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result408 = ProblemDetails.fromJS(resultData408);
            return throwException("A server side error occurred.", status, _responseText, _headers, result408);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskLocationDue[]>(null as any);
    }

    getTaskLocationDueAtLeastTwoWeeks(accountIds?: number[] | null | undefined, locationFormats?: string[] | null | undefined, hierarchyType?: number | null | undefined, hierarchyNames?: string[] | null | undefined, wmtWeeks?: string[] | null | undefined, activities?: string[] | null | undefined, serviceModels?: string[] | null | undefined, departments?: string[] | null | undefined): Observable<TaskLocationPercentageReport[]> {
        let url_ = this.baseUrl + "/client/v1/duedateperformancereport/gettasklocationdueatleasttwoweeks?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (locationFormats !== undefined && locationFormats !== null)
            locationFormats && locationFormats.forEach(item => { url_ += "LocationFormats=" + encodeURIComponent("" + item) + "&"; });
        if (hierarchyType !== undefined && hierarchyType !== null)
            url_ += "HierarchyType=" + encodeURIComponent("" + hierarchyType) + "&";
        if (hierarchyNames !== undefined && hierarchyNames !== null)
            hierarchyNames && hierarchyNames.forEach(item => { url_ += "HierarchyNames=" + encodeURIComponent("" + item) + "&"; });
        if (wmtWeeks !== undefined && wmtWeeks !== null)
            wmtWeeks && wmtWeeks.forEach(item => { url_ += "WmtWeeks=" + encodeURIComponent("" + item) + "&"; });
        if (activities !== undefined && activities !== null)
            activities && activities.forEach(item => { url_ += "Activities=" + encodeURIComponent("" + item) + "&"; });
        if (serviceModels !== undefined && serviceModels !== null)
            serviceModels && serviceModels.forEach(item => { url_ += "ServiceModels=" + encodeURIComponent("" + item) + "&"; });
        if (departments !== undefined && departments !== null)
            departments && departments.forEach(item => { url_ += "Departments=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskLocationDueAtLeastTwoWeeks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskLocationDueAtLeastTwoWeeks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskLocationPercentageReport[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskLocationPercentageReport[]>;
        }));
    }

    protected processGetTaskLocationDueAtLeastTwoWeeks(response: HttpResponseBase): Observable<TaskLocationPercentageReport[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskLocationPercentageReport.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 408) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result408: any = null;
            let resultData408 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result408 = ProblemDetails.fromJS(resultData408);
            return throwException("A server side error occurred.", status, _responseText, _headers, result408);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskLocationPercentageReport[]>(null as any);
    }

    getTaskLocationWithUpdatedDueDate(accountIds?: number[] | null | undefined, locationFormats?: string[] | null | undefined, hierarchyType?: number | null | undefined, hierarchyNames?: string[] | null | undefined, wmtWeeks?: string[] | null | undefined, activities?: string[] | null | undefined, serviceModels?: string[] | null | undefined, departments?: string[] | null | undefined): Observable<TaskLocationMovementChangedPercentage[]> {
        let url_ = this.baseUrl + "/client/v1/duedateperformancereport/gettasklocationwithupdatedduedate?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (locationFormats !== undefined && locationFormats !== null)
            locationFormats && locationFormats.forEach(item => { url_ += "LocationFormats=" + encodeURIComponent("" + item) + "&"; });
        if (hierarchyType !== undefined && hierarchyType !== null)
            url_ += "HierarchyType=" + encodeURIComponent("" + hierarchyType) + "&";
        if (hierarchyNames !== undefined && hierarchyNames !== null)
            hierarchyNames && hierarchyNames.forEach(item => { url_ += "HierarchyNames=" + encodeURIComponent("" + item) + "&"; });
        if (wmtWeeks !== undefined && wmtWeeks !== null)
            wmtWeeks && wmtWeeks.forEach(item => { url_ += "WmtWeeks=" + encodeURIComponent("" + item) + "&"; });
        if (activities !== undefined && activities !== null)
            activities && activities.forEach(item => { url_ += "Activities=" + encodeURIComponent("" + item) + "&"; });
        if (serviceModels !== undefined && serviceModels !== null)
            serviceModels && serviceModels.forEach(item => { url_ += "ServiceModels=" + encodeURIComponent("" + item) + "&"; });
        if (departments !== undefined && departments !== null)
            departments && departments.forEach(item => { url_ += "Departments=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskLocationWithUpdatedDueDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskLocationWithUpdatedDueDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskLocationMovementChangedPercentage[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskLocationMovementChangedPercentage[]>;
        }));
    }

    protected processGetTaskLocationWithUpdatedDueDate(response: HttpResponseBase): Observable<TaskLocationMovementChangedPercentage[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskLocationMovementChangedPercentage.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 408) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result408: any = null;
            let resultData408 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result408 = ProblemDetails.fromJS(resultData408);
            return throwException("A server side error occurred.", status, _responseText, _headers, result408);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskLocationMovementChangedPercentage[]>(null as any);
    }

    exportLocationOnTimeByWeek(accountIds?: number[] | null | undefined, locationFormats?: string[] | null | undefined, hierarchyType?: number | null | undefined, hierarchyNames?: string[] | null | undefined, wmtWeeks?: string[] | null | undefined, activities?: string[] | null | undefined, serviceModels?: string[] | null | undefined, departments?: string[] | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/duedateperformancereport/exportlocationontimebyweek?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (locationFormats !== undefined && locationFormats !== null)
            locationFormats && locationFormats.forEach(item => { url_ += "LocationFormats=" + encodeURIComponent("" + item) + "&"; });
        if (hierarchyType !== undefined && hierarchyType !== null)
            url_ += "HierarchyType=" + encodeURIComponent("" + hierarchyType) + "&";
        if (hierarchyNames !== undefined && hierarchyNames !== null)
            hierarchyNames && hierarchyNames.forEach(item => { url_ += "HierarchyNames=" + encodeURIComponent("" + item) + "&"; });
        if (wmtWeeks !== undefined && wmtWeeks !== null)
            wmtWeeks && wmtWeeks.forEach(item => { url_ += "WmtWeeks=" + encodeURIComponent("" + item) + "&"; });
        if (activities !== undefined && activities !== null)
            activities && activities.forEach(item => { url_ += "Activities=" + encodeURIComponent("" + item) + "&"; });
        if (serviceModels !== undefined && serviceModels !== null)
            serviceModels && serviceModels.forEach(item => { url_ += "ServiceModels=" + encodeURIComponent("" + item) + "&"; });
        if (departments !== undefined && departments !== null)
            departments && departments.forEach(item => { url_ += "Departments=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportLocationOnTimeByWeek(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportLocationOnTimeByWeek(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportLocationOnTimeByWeek(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 408) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result408: any = null;
            let resultData408 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result408 = ProblemDetails.fromJS(resultData408);
            return throwException("A server side error occurred.", status, _responseText, _headers, result408);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    exportLocationCompleted(filters?: DueDatePerformanceFilterParams | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/duedateperformancereport/exportlocationcompleted";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportLocationCompleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportLocationCompleted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportLocationCompleted(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 408) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result408: any = null;
            let resultData408 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result408 = ProblemDetails.fromJS(resultData408);
            return throwException("A server side error occurred.", status, _responseText, _headers, result408);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    exportLocationCompletedByActivity(filters?: DueDatePerformanceFilterParams | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/duedateperformancereport/exportlocationcompletedbyactivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportLocationCompletedByActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportLocationCompletedByActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportLocationCompletedByActivity(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 408) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result408: any = null;
            let resultData408 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result408 = ProblemDetails.fromJS(resultData408);
            return throwException("A server side error occurred.", status, _responseText, _headers, result408);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    exportMovementDetails(filters?: DueDatePerformanceFilterParams | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/duedateperformancereport/exportmovementdetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportMovementDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportMovementDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportMovementDetails(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 408) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result408: any = null;
            let resultData408 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result408 = ProblemDetails.fromJS(resultData408);
            return throwException("A server side error occurred.", status, _responseText, _headers, result408);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EOCStoreStatusClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    addStoreStatus(operationalStatus?: string | null | undefined, powerStatus?: string | null | undefined, receivingFreight?: string | null | undefined, reasonforChange?: string | null | undefined, communicationStatus?: string | null | undefined, pharmacyStatus?: string | null | undefined, expectedclosureDateandTime?: moment.Moment | null | undefined, expectedReopenDateTime?: moment.Moment | null | undefined, storeExpectedClosureDateandTime?: moment.Moment | null | undefined, storeExpectedReopenDateTime?: moment.Moment | null | undefined, storeNumber?: string | null | undefined, storeTimeZone?: string | null | undefined, iVRMessage?: string | null | undefined, eventName?: string | null | undefined, expectedclosure?: string | null | undefined, expectedReopen?: string | null | undefined, storeExpectedclosure?: string | null | undefined, storeExpectedReopen?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/eocstorestatus?";
        if (operationalStatus !== undefined && operationalStatus !== null)
            url_ += "OperationalStatus=" + encodeURIComponent("" + operationalStatus) + "&";
        if (powerStatus !== undefined && powerStatus !== null)
            url_ += "PowerStatus=" + encodeURIComponent("" + powerStatus) + "&";
        if (receivingFreight !== undefined && receivingFreight !== null)
            url_ += "ReceivingFreight=" + encodeURIComponent("" + receivingFreight) + "&";
        if (reasonforChange !== undefined && reasonforChange !== null)
            url_ += "ReasonforChange=" + encodeURIComponent("" + reasonforChange) + "&";
        if (communicationStatus !== undefined && communicationStatus !== null)
            url_ += "CommunicationStatus=" + encodeURIComponent("" + communicationStatus) + "&";
        if (pharmacyStatus !== undefined && pharmacyStatus !== null)
            url_ += "PharmacyStatus=" + encodeURIComponent("" + pharmacyStatus) + "&";
        if (expectedclosureDateandTime !== undefined && expectedclosureDateandTime !== null)
            url_ += "ExpectedclosureDateandTime=" + encodeURIComponent(expectedclosureDateandTime ? "" + expectedclosureDateandTime.toISOString() : "") + "&";
        if (expectedReopenDateTime !== undefined && expectedReopenDateTime !== null)
            url_ += "ExpectedReopenDateTime=" + encodeURIComponent(expectedReopenDateTime ? "" + expectedReopenDateTime.toISOString() : "") + "&";
        if (storeExpectedClosureDateandTime !== undefined && storeExpectedClosureDateandTime !== null)
            url_ += "StoreExpectedClosureDateandTime=" + encodeURIComponent(storeExpectedClosureDateandTime ? "" + storeExpectedClosureDateandTime.toISOString() : "") + "&";
        if (storeExpectedReopenDateTime !== undefined && storeExpectedReopenDateTime !== null)
            url_ += "StoreExpectedReopenDateTime=" + encodeURIComponent(storeExpectedReopenDateTime ? "" + storeExpectedReopenDateTime.toISOString() : "") + "&";
        if (storeNumber !== undefined && storeNumber !== null)
            url_ += "StoreNumber=" + encodeURIComponent("" + storeNumber) + "&";
        if (storeTimeZone !== undefined && storeTimeZone !== null)
            url_ += "StoreTimeZone=" + encodeURIComponent("" + storeTimeZone) + "&";
        if (iVRMessage !== undefined && iVRMessage !== null)
            url_ += "IVRMessage=" + encodeURIComponent("" + iVRMessage) + "&";
        if (eventName !== undefined && eventName !== null)
            url_ += "EventName=" + encodeURIComponent("" + eventName) + "&";
        if (expectedclosure !== undefined && expectedclosure !== null)
            url_ += "Expectedclosure=" + encodeURIComponent("" + expectedclosure) + "&";
        if (expectedReopen !== undefined && expectedReopen !== null)
            url_ += "ExpectedReopen=" + encodeURIComponent("" + expectedReopen) + "&";
        if (storeExpectedclosure !== undefined && storeExpectedclosure !== null)
            url_ += "StoreExpectedclosure=" + encodeURIComponent("" + storeExpectedclosure) + "&";
        if (storeExpectedReopen !== undefined && storeExpectedReopen !== null)
            url_ += "StoreExpectedReopen=" + encodeURIComponent("" + storeExpectedReopen) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddStoreStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddStoreStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddStoreStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getStoreStatus(storeNumber?: string | null | undefined, eventName?: string | null | undefined): Observable<StoreStatusViewModel> {
        let url_ = this.baseUrl + "/client/v1/eocstorestatus?";
        if (storeNumber !== undefined && storeNumber !== null)
            url_ += "storeNumber=" + encodeURIComponent("" + storeNumber) + "&";
        if (eventName !== undefined && eventName !== null)
            url_ += "eventName=" + encodeURIComponent("" + eventName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStoreStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStoreStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreStatusViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreStatusViewModel>;
        }));
    }

    protected processGetStoreStatus(response: HttpResponseBase): Observable<StoreStatusViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreStatusViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StoreStatusViewModel>(null as any);
    }

    getFile(includeCompleted?: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/eocstorestatus/download?";
        if (includeCompleted === null)
            throw new globalThis.Error("The parameter 'includeCompleted' cannot be null.");
        else if (includeCompleted !== undefined)
            url_ += "includeCompleted=" + encodeURIComponent("" + includeCompleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FeatureClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getAllFeatures(): Observable<FeatureViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/feature/getallfeatures";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFeatures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeatureViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeatureViewModel[]>;
        }));
    }

    protected processGetAllFeatures(response: HttpResponseBase): Observable<FeatureViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FeatureViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeatureViewModel[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FeatureTroubleshootingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getUserMetadata(email?: string | null | undefined): Observable<UserMetadata> {
        let url_ = this.baseUrl + "/client/v1/feature-troubleshooting/user-metadata?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserMetadata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserMetadata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserMetadata>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserMetadata>;
        }));
    }

    protected processGetUserMetadata(response: HttpResponseBase): Observable<UserMetadata> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserMetadata.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserMetadata>(null as any);
    }

    clearFeatureTroubleshootingAlert(featureId?: string | null | undefined, userId?: number | undefined, accountId?: number | undefined, storeNumber?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/feature-troubleshooting/alert?";
        if (featureId !== undefined && featureId !== null)
            url_ += "featureId=" + encodeURIComponent("" + featureId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        if (storeNumber !== undefined && storeNumber !== null)
            url_ += "storeNumber=" + encodeURIComponent("" + storeNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearFeatureTroubleshootingAlert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearFeatureTroubleshootingAlert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearFeatureTroubleshootingAlert(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getUserMetadataByPersonId(personId: number): Observable<UserMetadata> {
        let url_ = this.baseUrl + "/client/v1/feature-troubleshooting/user-metadata/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserMetadataByPersonId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserMetadataByPersonId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserMetadata>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserMetadata>;
        }));
    }

    protected processGetUserMetadataByPersonId(response: HttpResponseBase): Observable<UserMetadata> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserMetadata.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserMetadata>(null as any);
    }

    isUserExists(email?: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/client/v1/feature-troubleshooting/is-user-exists?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsUserExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsUserExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsUserExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    isUserExistsForGivenAccount(email?: string | null | undefined, accountId?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/client/v1/feature-troubleshooting/is-user-exists-for-account?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsUserExistsForGivenAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsUserExistsForGivenAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsUserExistsForGivenAccount(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    getRetailerLocations(): Observable<RetailerLocation[]> {
        let url_ = this.baseUrl + "/client/v1/feature-troubleshooting/retailer-locations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRetailerLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRetailerLocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RetailerLocation[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RetailerLocation[]>;
        }));
    }

    protected processGetRetailerLocations(response: HttpResponseBase): Observable<RetailerLocation[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RetailerLocation.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RetailerLocation[]>(null as any);
    }

    getRetailerLocation(storeNumber: string): Observable<RetailerLocation> {
        let url_ = this.baseUrl + "/client/v1/feature-troubleshooting/retailer-locations/{storeNumber}";
        if (storeNumber === undefined || storeNumber === null)
            throw new globalThis.Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRetailerLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRetailerLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RetailerLocation>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RetailerLocation>;
        }));
    }

    protected processGetRetailerLocation(response: HttpResponseBase): Observable<RetailerLocation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RetailerLocation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RetailerLocation>(null as any);
    }

    searchUser(accountId?: number | undefined, searchText?: string | null | undefined): Observable<DropDownModel[]> {
        let url_ = this.baseUrl + "/client/v1/feature-troubleshooting/search-user?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDownModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDownModel[]>;
        }));
    }

    protected processSearchUser(response: HttpResponseBase): Observable<DropDownModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownModel[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FieldGroupTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getFieldGroupTypeSummary(fieldGroupTypeIds?: number[] | null | undefined, status?: StatusTypes | null | undefined): Observable<FieldGroupTypeSummaryViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/fieldgrouptype/get-fieldgrouptype-summary?";
        if (fieldGroupTypeIds !== undefined && fieldGroupTypeIds !== null)
            fieldGroupTypeIds && fieldGroupTypeIds.forEach(item => { url_ += "fieldGroupTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFieldGroupTypeSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFieldGroupTypeSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FieldGroupTypeSummaryViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FieldGroupTypeSummaryViewModel[]>;
        }));
    }

    protected processGetFieldGroupTypeSummary(response: HttpResponseBase): Observable<FieldGroupTypeSummaryViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FieldGroupTypeSummaryViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FieldGroupTypeSummaryViewModel[]>(null as any);
    }

    getFieldGroups(): Observable<string[]> {
        let url_ = this.baseUrl + "/client/v1/fieldgroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFieldGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFieldGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetFieldGroups(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class InvoiceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getInvoices(accountId?: number | null | undefined, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined, invoiceNumber?: string | null | undefined, sort?: string | null | undefined, limit?: number | null | undefined, offset?: number | null | undefined, ascending?: boolean | undefined): Observable<LimitedResultOfInvoiceViewModel> {
        let url_ = this.baseUrl + "/client/v1/invoice/getinvoices?";
        if (accountId !== undefined && accountId !== null)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (invoiceNumber !== undefined && invoiceNumber !== null)
            url_ += "invoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (ascending === null)
            throw new globalThis.Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "Ascending=" + encodeURIComponent("" + ascending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfInvoiceViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfInvoiceViewModel>;
        }));
    }

    protected processGetInvoices(response: HttpResponseBase): Observable<LimitedResultOfInvoiceViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfInvoiceViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfInvoiceViewModel>(null as any);
    }

    exportInvoices(accountId?: number | null | undefined, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined, invoiceNumber?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/invoice/exportinvoices?";
        if (accountId !== undefined && accountId !== null)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (invoiceNumber !== undefined && invoiceNumber !== null)
            url_ += "invoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportInvoices(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getInvoice(hashedInvoiceId: string): Observable<InvoiceSummaryViewModel> {
        let url_ = this.baseUrl + "/client/v1/invoice/{hashedInvoiceId}";
        if (hashedInvoiceId === undefined || hashedInvoiceId === null)
            throw new globalThis.Error("The parameter 'hashedInvoiceId' must be defined.");
        url_ = url_.replace("{hashedInvoiceId}", encodeURIComponent("" + hashedInvoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceSummaryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceSummaryViewModel>;
        }));
    }

    protected processGetInvoice(response: HttpResponseBase): Observable<InvoiceSummaryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceSummaryViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceSummaryViewModel>(null as any);
    }

    exportInvoiceDetails(hashedInvoiceId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/invoice/{hashedInvoiceId}/exportinvoicedetails";
        if (hashedInvoiceId === undefined || hashedInvoiceId === null)
            throw new globalThis.Error("The parameter 'hashedInvoiceId' must be defined.");
        url_ = url_.replace("{hashedInvoiceId}", encodeURIComponent("" + hashedInvoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportInvoiceDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportInvoiceDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportInvoiceDetails(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LicensesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getLicensesDetailsForAccount(accountId: number): Observable<LicenseDetailsViewModel> {
        let url_ = this.baseUrl + "/client/v1/licenses/details/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLicensesDetailsForAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLicensesDetailsForAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LicenseDetailsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LicenseDetailsViewModel>;
        }));
    }

    protected processGetLicensesDetailsForAccount(response: HttpResponseBase): Observable<LicenseDetailsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenseDetailsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LicenseDetailsViewModel>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LimitedAccountOverviewClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getOverview(accountId: number): Observable<LimitedAccountOverviewViewModel> {
        let url_ = this.baseUrl + "/client/v1/limitedaccountoverview/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedAccountOverviewViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedAccountOverviewViewModel>;
        }));
    }

    protected processGetOverview(response: HttpResponseBase): Observable<LimitedAccountOverviewViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedAccountOverviewViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedAccountOverviewViewModel>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LocationFeatureClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    upload(pageName?: string | null | undefined, file?: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/locationfeature/upload?";
        if (pageName !== undefined && pageName !== null)
            url_ += "pageName=" + encodeURIComponent("" + pageName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    export(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/locationfeature/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OnBoardingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getOnBoardingInformation(personId: number): Observable<OnBoardingViewModel> {
        let url_ = this.baseUrl + "/client/v1/onboarding/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnBoardingInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnBoardingInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnBoardingViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnBoardingViewModel>;
        }));
    }

    protected processGetOnBoardingInformation(response: HttpResponseBase): Observable<OnBoardingViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnBoardingViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenParameters.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OnBoardingViewModel>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PersonClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    eula(personId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/person/eularead?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEula(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEula(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEula(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    generate(notificaitonEmails?: string[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/person/createbadgespdfs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notificaitonEmails);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenerate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getBadgesToApprove(providerId?: number | null | undefined): Observable<PersonBadgeModel[]> {
        let url_ = this.baseUrl + "/client/v1/person/badges?";
        if (providerId !== undefined && providerId !== null)
            url_ += "providerId=" + encodeURIComponent("" + providerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBadgesToApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBadgesToApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonBadgeModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonBadgeModel[]>;
        }));
    }

    protected processGetBadgesToApprove(response: HttpResponseBase): Observable<PersonBadgeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonBadgeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PersonBadgeModel[]>(null as any);
    }

    getBadgesNeedingApprovalCounts(): Observable<AccountBadgeCountModel[]> {
        let url_ = this.baseUrl + "/client/v1/person/badges/count";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBadgesNeedingApprovalCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBadgesNeedingApprovalCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountBadgeCountModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountBadgeCountModel[]>;
        }));
    }

    protected processGetBadgesNeedingApprovalCounts(response: HttpResponseBase): Observable<AccountBadgeCountModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountBadgeCountModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountBadgeCountModel[]>(null as any);
    }

    setBadgeApproved(personId: number): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/person/approvebadge/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetBadgeApproved(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetBadgeApproved(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetBadgeApproved(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    setBadgeDenied(denyBadgeRequest?: DenyBadgeRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/person/denybadge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(denyBadgeRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetBadgeDenied(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetBadgeDenied(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetBadgeDenied(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    resetBadgeApproval(personId: number): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/person/resetbadgeapproval/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetBadgeApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetBadgeApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetBadgeApproval(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    isEmployeeNumberAlreadyExists(employeeNumber?: string | null | undefined, accountId?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/client/v1/person/isemployeenumberalreadyexists?";
        if (employeeNumber !== undefined && employeeNumber !== null)
            url_ += "employeeNumber=" + encodeURIComponent("" + employeeNumber) + "&";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsEmployeeNumberAlreadyExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsEmployeeNumberAlreadyExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsEmployeeNumberAlreadyExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    isEmailAddressAlreadyExists(emailAddress?: string | null | undefined, accountId?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/client/v1/person/isemailaddressalreadyexists?";
        if (emailAddress !== undefined && emailAddress !== null)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsEmailAddressAlreadyExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsEmailAddressAlreadyExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsEmailAddressAlreadyExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    isMobileAlreadyExists(mobile?: string | null | undefined, accountId?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/client/v1/person/ismobilealreadyexists?";
        if (mobile !== undefined && mobile !== null)
            url_ += "mobile=" + encodeURIComponent("" + mobile) + "&";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsMobileAlreadyExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsMobileAlreadyExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsMobileAlreadyExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    isUsernameAlreadyExists(userName?: string | null | undefined, accountId?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/client/v1/person/isusernamealreadyexists?";
        if (userName !== undefined && userName !== null)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsUsernameAlreadyExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsUsernameAlreadyExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsUsernameAlreadyExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    createUser(savePersonModel?: SavePersonModel | null | undefined): Observable<UpsertUserResponse> {
        let url_ = this.baseUrl + "/client/v1/person/createuser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(savePersonModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpsertUserResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpsertUserResponse>;
        }));
    }

    protected processCreateUser(response: HttpResponseBase): Observable<UpsertUserResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertUserResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfString.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertUserResponse>(null as any);
    }

    update(personId: number, personPatch?: Operation[] | null | undefined): Observable<UpsertUserResponse> {
        let url_ = this.baseUrl + "/client/v1/person/update/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(personPatch);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpsertUserResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpsertUserResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpsertUserResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertUserResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertUserResponse>(null as any);
    }

    editUser(savePersonModel?: SavePersonModel | null | undefined): Observable<UpsertUserResponse> {
        let url_ = this.baseUrl + "/client/v1/person/edituser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(savePersonModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpsertUserResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpsertUserResponse>;
        }));
    }

    protected processEditUser(response: HttpResponseBase): Observable<UpsertUserResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertUserResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfString.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertUserResponse>(null as any);
    }

    updateUserStatus(personId: number, isCurrentActive?: boolean | undefined): Observable<UserDetail> {
        let url_ = this.baseUrl + "/client/v1/person/updateuserstatus/{personId}?";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        if (isCurrentActive === null)
            throw new globalThis.Error("The parameter 'isCurrentActive' cannot be null.");
        else if (isCurrentActive !== undefined)
            url_ += "isCurrentActive=" + encodeURIComponent("" + isCurrentActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDetail>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDetail>;
        }));
    }

    protected processUpdateUserStatus(response: HttpResponseBase): Observable<UserDetail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDetail.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDetail>(null as any);
    }

    requestBadgeReprint(personId: number): Observable<UserDetail> {
        let url_ = this.baseUrl + "/client/v1/person/requestbadgereprint/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestBadgeReprint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestBadgeReprint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDetail>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDetail>;
        }));
    }

    protected processRequestBadgeReprint(response: HttpResponseBase): Observable<UserDetail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDetail.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDetail>(null as any);
    }

    requestBadgeReprintNoFee(personId: number, reprintBadgeForFree?: boolean | undefined, reprintLetterForFree?: boolean | undefined): Observable<UserDetail> {
        let url_ = this.baseUrl + "/client/v1/person/requestbadgereprintnofee/{personId}?";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        if (reprintBadgeForFree === null)
            throw new globalThis.Error("The parameter 'reprintBadgeForFree' cannot be null.");
        else if (reprintBadgeForFree !== undefined)
            url_ += "reprintBadgeForFree=" + encodeURIComponent("" + reprintBadgeForFree) + "&";
        if (reprintLetterForFree === null)
            throw new globalThis.Error("The parameter 'reprintLetterForFree' cannot be null.");
        else if (reprintLetterForFree !== undefined)
            url_ += "reprintLetterForFree=" + encodeURIComponent("" + reprintLetterForFree) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestBadgeReprintNoFee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestBadgeReprintNoFee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDetail>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDetail>;
        }));
    }

    protected processRequestBadgeReprintNoFee(response: HttpResponseBase): Observable<UserDetail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDetail.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDetail>(null as any);
    }

    resendInvitation(personId: number): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/person/resendinvitation/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendInvitation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendInvitation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResendInvitation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getPrimaryAdminsForAccount(accountId?: number | undefined): Observable<PrimaryAdminsViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/person/getprimaryadminsforaccount?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrimaryAdminsForAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrimaryAdminsForAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrimaryAdminsViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrimaryAdminsViewModel[]>;
        }));
    }

    protected processGetPrimaryAdminsForAccount(response: HttpResponseBase): Observable<PrimaryAdminsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PrimaryAdminsViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PrimaryAdminsViewModel[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PfsManagementClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    upload(pageName?: string | null | undefined, file?: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/pfs-inventory-upload?";
        if (pageName !== undefined && pageName !== null)
            url_ += "pageName=" + encodeURIComponent("" + pageName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = IncidentException.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PhotoClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    uploadImage(personId: number, changeSource?: UserAuditChangeSource | undefined, imageFile?: FileParameter | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/client/v1/photo/uploadimage/{personId}?";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        if (changeSource === null)
            throw new globalThis.Error("The parameter 'changeSource' cannot be null.");
        else if (changeSource !== undefined)
            url_ += "changeSource=" + encodeURIComponent("" + changeSource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (imageFile !== null && imageFile !== undefined)
            content_.append("imageFile", imageFile.data, imageFile.fileName ? imageFile.fileName : "imageFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadImage(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    removeBadgeBackgroundFromImage(imageFile?: FileParameter | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/photo/removebadgebackgroundfromimage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (imageFile !== null && imageFile !== undefined)
            content_.append("imageFile", imageFile.data, imageFile.fileName ? imageFile.fileName : "imageFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveBadgeBackgroundFromImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveBadgeBackgroundFromImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processRemoveBadgeBackgroundFromImage(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    setBadgeImageCropRectangle(personId: number, cropRectangle?: CropRectangle | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/photo/setbadgeimagecroprectangle/{personId}";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cropRectangle);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetBadgeImageCropRectangle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetBadgeImageCropRectangle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetBadgeImageCropRectangle(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getBadgeImageMetadata(personId: number, originalImage?: boolean | undefined): Observable<BadgeImageMetadata> {
        let url_ = this.baseUrl + "/client/v1/photo/getbadgeimagemetadata/{personId}?";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        if (originalImage === null)
            throw new globalThis.Error("The parameter 'originalImage' cannot be null.");
        else if (originalImage !== undefined)
            url_ += "originalImage=" + encodeURIComponent("" + originalImage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBadgeImageMetadata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBadgeImageMetadata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BadgeImageMetadata>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BadgeImageMetadata>;
        }));
    }

    protected processGetBadgeImageMetadata(response: HttpResponseBase): Observable<BadgeImageMetadata> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BadgeImageMetadata.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BadgeImageMetadata>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PhotoDenialReasonClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getPhotoDenialReasons(): Observable<PhotoDenialReasonModel[]> {
        let url_ = this.baseUrl + "/client/v1/photodenialreason";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPhotoDenialReasons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPhotoDenialReasons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhotoDenialReasonModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhotoDenialReasonModel[]>;
        }));
    }

    protected processGetPhotoDenialReasons(response: HttpResponseBase): Observable<PhotoDenialReasonModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PhotoDenialReasonModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PhotoDenialReasonModel[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PosAccessReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getPosAccessUserReport(accountIds?: number[] | null | undefined, wattLocationIDs?: string[] | null | undefined, usersSearch?: string | null | undefined, userMustBeActive?: boolean | undefined, userMustBeCheckedIn?: boolean | undefined, maximumCheckInDate?: moment.Moment | null | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined, offset?: number | undefined, limit?: number | undefined, accountId?: number | null | undefined, date?: moment.Moment | undefined): Observable<PosAccessReport> {
        let url_ = this.baseUrl + "/client/v1/posaccess/getuserreport?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (wattLocationIDs !== undefined && wattLocationIDs !== null)
            wattLocationIDs && wattLocationIDs.forEach(item => { url_ += "WattLocationIDs=" + encodeURIComponent("" + item) + "&"; });
        if (usersSearch !== undefined && usersSearch !== null)
            url_ += "UsersSearch=" + encodeURIComponent("" + usersSearch) + "&";
        if (userMustBeActive === null)
            throw new globalThis.Error("The parameter 'userMustBeActive' cannot be null.");
        else if (userMustBeActive !== undefined)
            url_ += "UserMustBeActive=" + encodeURIComponent("" + userMustBeActive) + "&";
        if (userMustBeCheckedIn === null)
            throw new globalThis.Error("The parameter 'userMustBeCheckedIn' cannot be null.");
        else if (userMustBeCheckedIn !== undefined)
            url_ += "UserMustBeCheckedIn=" + encodeURIComponent("" + userMustBeCheckedIn) + "&";
        if (maximumCheckInDate !== undefined && maximumCheckInDate !== null)
            url_ += "MaximumCheckInDate=" + encodeURIComponent(maximumCheckInDate ? "" + maximumCheckInDate.toISOString() : "") + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (accountId !== undefined && accountId !== null)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPosAccessUserReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPosAccessUserReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PosAccessReport>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PosAccessReport>;
        }));
    }

    protected processGetPosAccessUserReport(response: HttpResponseBase): Observable<PosAccessReport> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PosAccessReport.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PosAccessReport>(null as any);
    }

    export(accountIds?: number[] | null | undefined, wattLocationIDs?: string[] | null | undefined, usersSearch?: string | null | undefined, userMustBeActive?: boolean | undefined, userMustBeCheckedIn?: boolean | undefined, maximumCheckInDate?: moment.Moment | null | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined, offset?: number | undefined, limit?: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/posaccess/export?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (wattLocationIDs !== undefined && wattLocationIDs !== null)
            wattLocationIDs && wattLocationIDs.forEach(item => { url_ += "WattLocationIDs=" + encodeURIComponent("" + item) + "&"; });
        if (usersSearch !== undefined && usersSearch !== null)
            url_ += "UsersSearch=" + encodeURIComponent("" + usersSearch) + "&";
        if (userMustBeActive === null)
            throw new globalThis.Error("The parameter 'userMustBeActive' cannot be null.");
        else if (userMustBeActive !== undefined)
            url_ += "UserMustBeActive=" + encodeURIComponent("" + userMustBeActive) + "&";
        if (userMustBeCheckedIn === null)
            throw new globalThis.Error("The parameter 'userMustBeCheckedIn' cannot be null.");
        else if (userMustBeCheckedIn !== undefined)
            url_ += "UserMustBeCheckedIn=" + encodeURIComponent("" + userMustBeCheckedIn) + "&";
        if (maximumCheckInDate !== undefined && maximumCheckInDate !== null)
            url_ += "MaximumCheckInDate=" + encodeURIComponent(maximumCheckInDate ? "" + maximumCheckInDate.toISOString() : "") + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ProviderAdminDashboardClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getRepsInStoreCount(): Observable<number> {
        let url_ = this.baseUrl + "/client/v1/provideradmindashboard/getrepsinstorecount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRepsInStoreCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRepsInStoreCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetRepsInStoreCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getProviderAdminDashboardRepsInStoreDetails(): Observable<RepsInStoreDetailsViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/provideradmindashboard/getprovideradmindashboardrepsinstoredetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProviderAdminDashboardRepsInStoreDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProviderAdminDashboardRepsInStoreDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RepsInStoreDetailsViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RepsInStoreDetailsViewModel[]>;
        }));
    }

    protected processGetProviderAdminDashboardRepsInStoreDetails(response: HttpResponseBase): Observable<RepsInStoreDetailsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RepsInStoreDetailsViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RepsInStoreDetailsViewModel[]>(null as any);
    }

    getVisitsByDay(startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined): Observable<DailyVisitsSummary[]> {
        let url_ = this.baseUrl + "/client/v1/provideradmindashboard/getvisitsbyday?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVisitsByDay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVisitsByDay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DailyVisitsSummary[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DailyVisitsSummary[]>;
        }));
    }

    protected processGetVisitsByDay(response: HttpResponseBase): Observable<DailyVisitsSummary[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DailyVisitsSummary.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DailyVisitsSummary[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RealTimeCheckinReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getRealTimeCheckinReport(accountIds?: number[] | null | undefined, fieldGroupTypes?: string[] | null | undefined, personTags?: string[] | null | undefined, locationNumber?: string[] | null | undefined, bannerNames?: string[] | null | undefined, hierarchyType?: number | null | undefined, hierarchyNames?: string[] | null | undefined, page?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, reportType?: RealTimeCheckinFilterReportType | undefined, checkOutStart?: moment.Moment | null | undefined, checkOutEnd?: moment.Moment | null | undefined): Observable<RealTimeCheckinReportLimitedResultsOfRealTimeCheckinReportItemViewModel> {
        let url_ = this.baseUrl + "/client/v1/events/realtimecheckinreport?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (fieldGroupTypes !== undefined && fieldGroupTypes !== null)
            fieldGroupTypes && fieldGroupTypes.forEach(item => { url_ += "FieldGroupTypes=" + encodeURIComponent("" + item) + "&"; });
        if (personTags !== undefined && personTags !== null)
            personTags && personTags.forEach(item => { url_ += "PersonTags=" + encodeURIComponent("" + item) + "&"; });
        if (locationNumber !== undefined && locationNumber !== null)
            locationNumber && locationNumber.forEach(item => { url_ += "LocationNumber=" + encodeURIComponent("" + item) + "&"; });
        if (bannerNames !== undefined && bannerNames !== null)
            bannerNames && bannerNames.forEach(item => { url_ += "BannerNames=" + encodeURIComponent("" + item) + "&"; });
        if (hierarchyType !== undefined && hierarchyType !== null)
            url_ += "HierarchyType=" + encodeURIComponent("" + hierarchyType) + "&";
        if (hierarchyNames !== undefined && hierarchyNames !== null)
            hierarchyNames && hierarchyNames.forEach(item => { url_ += "HierarchyNames=" + encodeURIComponent("" + item) + "&"; });
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (reportType === null)
            throw new globalThis.Error("The parameter 'reportType' cannot be null.");
        else if (reportType !== undefined)
            url_ += "ReportType=" + encodeURIComponent("" + reportType) + "&";
        if (checkOutStart !== undefined && checkOutStart !== null)
            url_ += "CheckOutStart=" + encodeURIComponent(checkOutStart ? "" + checkOutStart.toISOString() : "") + "&";
        if (checkOutEnd !== undefined && checkOutEnd !== null)
            url_ += "CheckOutEnd=" + encodeURIComponent(checkOutEnd ? "" + checkOutEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRealTimeCheckinReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRealTimeCheckinReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RealTimeCheckinReportLimitedResultsOfRealTimeCheckinReportItemViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RealTimeCheckinReportLimitedResultsOfRealTimeCheckinReportItemViewModel>;
        }));
    }

    protected processGetRealTimeCheckinReport(response: HttpResponseBase): Observable<RealTimeCheckinReportLimitedResultsOfRealTimeCheckinReportItemViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RealTimeCheckinReportLimitedResultsOfRealTimeCheckinReportItemViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RealTimeCheckinReportLimitedResultsOfRealTimeCheckinReportItemViewModel>(null as any);
    }

    exportRealTimeCheckinReport(accountIds?: number[] | null | undefined, fieldGroupTypes?: string[] | null | undefined, personTags?: string[] | null | undefined, locationNumber?: string[] | null | undefined, bannerNames?: string[] | null | undefined, hierarchyType?: number | null | undefined, hierarchyNames?: string[] | null | undefined, page?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, reportType?: RealTimeCheckinFilterReportType | undefined, checkOutStart?: moment.Moment | null | undefined, checkOutEnd?: moment.Moment | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/events/realtimecheckinreportexport?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (fieldGroupTypes !== undefined && fieldGroupTypes !== null)
            fieldGroupTypes && fieldGroupTypes.forEach(item => { url_ += "FieldGroupTypes=" + encodeURIComponent("" + item) + "&"; });
        if (personTags !== undefined && personTags !== null)
            personTags && personTags.forEach(item => { url_ += "PersonTags=" + encodeURIComponent("" + item) + "&"; });
        if (locationNumber !== undefined && locationNumber !== null)
            locationNumber && locationNumber.forEach(item => { url_ += "LocationNumber=" + encodeURIComponent("" + item) + "&"; });
        if (bannerNames !== undefined && bannerNames !== null)
            bannerNames && bannerNames.forEach(item => { url_ += "BannerNames=" + encodeURIComponent("" + item) + "&"; });
        if (hierarchyType !== undefined && hierarchyType !== null)
            url_ += "HierarchyType=" + encodeURIComponent("" + hierarchyType) + "&";
        if (hierarchyNames !== undefined && hierarchyNames !== null)
            hierarchyNames && hierarchyNames.forEach(item => { url_ += "HierarchyNames=" + encodeURIComponent("" + item) + "&"; });
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (reportType === null)
            throw new globalThis.Error("The parameter 'reportType' cannot be null.");
        else if (reportType !== undefined)
            url_ += "ReportType=" + encodeURIComponent("" + reportType) + "&";
        if (checkOutStart !== undefined && checkOutStart !== null)
            url_ += "CheckOutStart=" + encodeURIComponent(checkOutStart ? "" + checkOutStart.toISOString() : "") + "&";
        if (checkOutEnd !== undefined && checkOutEnd !== null)
            url_ += "CheckOutEnd=" + encodeURIComponent(checkOutEnd ? "" + checkOutEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportRealTimeCheckinReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportRealTimeCheckinReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportRealTimeCheckinReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getVisitsByDay(accountIds?: number[] | null | undefined, fieldGroupTypes?: string[] | null | undefined, personTags?: string[] | null | undefined, locationNumber?: string[] | null | undefined, bannerNames?: string[] | null | undefined, hierarchyType?: number | null | undefined, hierarchyNames?: string[] | null | undefined, checkOutStart?: moment.Moment | null | undefined, checkOutEnd?: moment.Moment | null | undefined): Observable<DailyVisitsSummary[]> {
        let url_ = this.baseUrl + "/client/v1/events/dailyvisits?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (fieldGroupTypes !== undefined && fieldGroupTypes !== null)
            fieldGroupTypes && fieldGroupTypes.forEach(item => { url_ += "FieldGroupTypes=" + encodeURIComponent("" + item) + "&"; });
        if (personTags !== undefined && personTags !== null)
            personTags && personTags.forEach(item => { url_ += "PersonTags=" + encodeURIComponent("" + item) + "&"; });
        if (locationNumber !== undefined && locationNumber !== null)
            locationNumber && locationNumber.forEach(item => { url_ += "LocationNumber=" + encodeURIComponent("" + item) + "&"; });
        if (bannerNames !== undefined && bannerNames !== null)
            bannerNames && bannerNames.forEach(item => { url_ += "BannerNames=" + encodeURIComponent("" + item) + "&"; });
        if (hierarchyType !== undefined && hierarchyType !== null)
            url_ += "HierarchyType=" + encodeURIComponent("" + hierarchyType) + "&";
        if (hierarchyNames !== undefined && hierarchyNames !== null)
            hierarchyNames && hierarchyNames.forEach(item => { url_ += "HierarchyNames=" + encodeURIComponent("" + item) + "&"; });
        if (checkOutStart !== undefined && checkOutStart !== null)
            url_ += "CheckOutStart=" + encodeURIComponent(checkOutStart ? "" + checkOutStart.toISOString() : "") + "&";
        if (checkOutEnd !== undefined && checkOutEnd !== null)
            url_ += "CheckOutEnd=" + encodeURIComponent(checkOutEnd ? "" + checkOutEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVisitsByDay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVisitsByDay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DailyVisitsSummary[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DailyVisitsSummary[]>;
        }));
    }

    protected processGetVisitsByDay(response: HttpResponseBase): Observable<DailyVisitsSummary[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DailyVisitsSummary.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DailyVisitsSummary[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ReCaptchaClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    validate(token?: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/client/v1/recaptcha/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(token);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processValidate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RedirectClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    triggerRemoteRedirectRequest(requestedUrl?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/client/v1/redirectrequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestedUrl);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTriggerRemoteRedirectRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTriggerRemoteRedirectRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processTriggerRemoteRedirectRequest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfString.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    confirmRedirectRequest(id: string): Observable<RedirectConfirmation> {
        let url_ = this.baseUrl + "/client/v1/confirmredirectrequest/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmRedirectRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmRedirectRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RedirectConfirmation>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RedirectConfirmation>;
        }));
    }

    protected processConfirmRedirectRequest(response: HttpResponseBase): Observable<RedirectConfirmation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RedirectConfirmation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfString.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RedirectConfirmation>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ReportOverviewClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    reportOverviews(searchTerm?: string | null | undefined, banners?: string[] | null | undefined, offset?: number | undefined, limit?: number | undefined): Observable<LimitedResultOfReportOverview> {
        let url_ = this.baseUrl + "/client/v1/report-overviews?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (banners !== undefined && banners !== null)
            banners && banners.forEach(item => { url_ += "banners=" + encodeURIComponent("" + item) + "&"; });
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportOverviews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportOverviews(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfReportOverview>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfReportOverview>;
        }));
    }

    protected processReportOverviews(response: HttpResponseBase): Observable<LimitedResultOfReportOverview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfReportOverview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfReportOverview>(null as any);
    }

    reportOverview(reportKey: string): Observable<ReportOverview> {
        let url_ = this.baseUrl + "/client/v1/report-overview/{reportKey}";
        if (reportKey === undefined || reportKey === null)
            throw new globalThis.Error("The parameter 'reportKey' must be defined.");
        url_ = url_.replace("{reportKey}", encodeURIComponent("" + reportKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportOverview>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportOverview>;
        }));
    }

    protected processReportOverview(response: HttpResponseBase): Observable<ReportOverview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportOverview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportOverview>(null as any);
    }

    updateReportOverview(reportKey: string, description?: string | null | undefined, iconClass?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/report-overview/{reportKey}?";
        if (reportKey === undefined || reportKey === null)
            throw new globalThis.Error("The parameter 'reportKey' must be defined.");
        url_ = url_.replace("{reportKey}", encodeURIComponent("" + reportKey));
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (iconClass !== undefined && iconClass !== null)
            url_ += "iconClass=" + encodeURIComponent("" + iconClass) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReportOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReportOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateReportOverview(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SecurityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    sendPasswordReset(syncId?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/security/sendpasswordreset?";
        if (syncId !== undefined && syncId !== null)
            url_ += "syncId=" + encodeURIComponent("" + syncId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPasswordReset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPasswordReset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendPasswordReset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    sendMobilePasswordReset(mobile?: string | null | undefined, accountId?: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/security/sendmobilepasswordreset?";
        if (mobile !== undefined && mobile !== null)
            url_ += "mobile=" + encodeURIComponent("" + mobile) + "&";
        if (accountId !== undefined && accountId !== null)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMobilePasswordReset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMobilePasswordReset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendMobilePasswordReset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getPowerBiToken(): Observable<PowerBiToken> {
        let url_ = this.baseUrl + "/client/v1/security/powerbi";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPowerBiToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPowerBiToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PowerBiToken>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PowerBiToken>;
        }));
    }

    protected processGetPowerBiToken(response: HttpResponseBase): Observable<PowerBiToken> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PowerBiToken.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PowerBiToken>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceDeploymentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    /**
     * Get the visit count per service deployment activity for one or all locations
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param locationNumber (optional) 
     */
    serviceDeploymentVisitCounts(startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined, locationNumber?: string | null | undefined): Observable<ActivityVisitCount[]> {
        let url_ = this.baseUrl + "/client/v1/service-deployments/visit-counts?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (locationNumber !== undefined && locationNumber !== null)
            url_ += "locationNumber=" + encodeURIComponent("" + locationNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceDeploymentVisitCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceDeploymentVisitCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityVisitCount[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityVisitCount[]>;
        }));
    }

    protected processServiceDeploymentVisitCounts(response: HttpResponseBase): Observable<ActivityVisitCount[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityVisitCount.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityVisitCount[]>(null as any);
    }

    /**
     * Get Service Model Types
     */
    getServiceModelTypes(): Observable<string[]> {
        let url_ = this.baseUrl + "/client/v1/service-model-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceModelTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceModelTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetServiceModelTypes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * Get Service Model Types
     */
    getServiceModels(): Observable<DropDownModel[]> {
        let url_ = this.baseUrl + "/client/v1/service-models";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceModels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceModels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDownModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDownModel[]>;
        }));
    }

    protected processGetServiceModels(response: HttpResponseBase): Observable<DropDownModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownModel[]>(null as any);
    }

    getServiceDeployments(offset?: number | undefined, limit?: number | undefined, sort?: string | null | undefined, accountIds?: number[] | null | undefined, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined, anameSearch?: string | null | undefined, nameSearch?: string | null | undefined, noteSearch?: string | null | undefined, referenceNumberSearch?: string | null | undefined, visitorOverviewSearch?: string | null | undefined, serviceDeploymentRefId?: string | null | undefined, statusSearch?: string | null | undefined): Observable<GenericTableReportOfServiceDeploymentViewModel> {
        let url_ = this.baseUrl + "/client/v1/servicedeployments?";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (anameSearch !== undefined && anameSearch !== null)
            url_ += "AnameSearch=" + encodeURIComponent("" + anameSearch) + "&";
        if (nameSearch !== undefined && nameSearch !== null)
            url_ += "NameSearch=" + encodeURIComponent("" + nameSearch) + "&";
        if (noteSearch !== undefined && noteSearch !== null)
            url_ += "NoteSearch=" + encodeURIComponent("" + noteSearch) + "&";
        if (referenceNumberSearch !== undefined && referenceNumberSearch !== null)
            url_ += "ReferenceNumberSearch=" + encodeURIComponent("" + referenceNumberSearch) + "&";
        if (visitorOverviewSearch !== undefined && visitorOverviewSearch !== null)
            url_ += "VisitorOverviewSearch=" + encodeURIComponent("" + visitorOverviewSearch) + "&";
        if (serviceDeploymentRefId !== undefined && serviceDeploymentRefId !== null)
            url_ += "ServiceDeploymentRefId=" + encodeURIComponent("" + serviceDeploymentRefId) + "&";
        if (statusSearch !== undefined && statusSearch !== null)
            url_ += "StatusSearch=" + encodeURIComponent("" + statusSearch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceDeployments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceDeployments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericTableReportOfServiceDeploymentViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericTableReportOfServiceDeploymentViewModel>;
        }));
    }

    protected processGetServiceDeployments(response: HttpResponseBase): Observable<GenericTableReportOfServiceDeploymentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericTableReportOfServiceDeploymentViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericTableReportOfServiceDeploymentViewModel>(null as any);
    }

    createServiceDeployment(accountId: number, model?: ServiceDeploymentInput | null | undefined): Observable<Log> {
        let url_ = this.baseUrl + "/client/v1/servicedeployments/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateServiceDeployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateServiceDeployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Log>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Log>;
        }));
    }

    protected processCreateServiceDeployment(response: HttpResponseBase): Observable<Log> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Log.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Log>(null as any);
    }

    updateServiceDeployment(accountId: number, model?: ServiceDeploymentInput | null | undefined): Observable<Log> {
        let url_ = this.baseUrl + "/client/v1/servicedeployments/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateServiceDeployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateServiceDeployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Log>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Log>;
        }));
    }

    protected processUpdateServiceDeployment(response: HttpResponseBase): Observable<Log> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Log.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Log>(null as any);
    }

    checkServiceDepRefNumberAlreadyExist(referenceNumber?: string | null | undefined, accountId?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/client/v1/servicedeployments/checkservicedeprefnumberalreadyexist?";
        if (referenceNumber !== undefined && referenceNumber !== null)
            url_ += "referenceNumber=" + encodeURIComponent("" + referenceNumber) + "&";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckServiceDepRefNumberAlreadyExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckServiceDepRefNumberAlreadyExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckServiceDepRefNumberAlreadyExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    getFile(accountIds?: number[] | null | undefined, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined, anameSearch?: string | null | undefined, nameSearch?: string | null | undefined, noteSearch?: string | null | undefined, referenceNumberSearch?: string | null | undefined, visitorOverviewSearch?: string | null | undefined, serviceDeploymentRefId?: string | null | undefined, statusSearch?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/servicedeployments/download?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (anameSearch !== undefined && anameSearch !== null)
            url_ += "AnameSearch=" + encodeURIComponent("" + anameSearch) + "&";
        if (nameSearch !== undefined && nameSearch !== null)
            url_ += "NameSearch=" + encodeURIComponent("" + nameSearch) + "&";
        if (noteSearch !== undefined && noteSearch !== null)
            url_ += "NoteSearch=" + encodeURIComponent("" + noteSearch) + "&";
        if (referenceNumberSearch !== undefined && referenceNumberSearch !== null)
            url_ += "ReferenceNumberSearch=" + encodeURIComponent("" + referenceNumberSearch) + "&";
        if (visitorOverviewSearch !== undefined && visitorOverviewSearch !== null)
            url_ += "VisitorOverviewSearch=" + encodeURIComponent("" + visitorOverviewSearch) + "&";
        if (serviceDeploymentRefId !== undefined && serviceDeploymentRefId !== null)
            url_ += "ServiceDeploymentRefId=" + encodeURIComponent("" + serviceDeploymentRefId) + "&";
        if (statusSearch !== undefined && statusSearch !== null)
            url_ += "StatusSearch=" + encodeURIComponent("" + statusSearch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    /**
     * Retrieves a log for a service deployment, service task or task location request
     */
    retrieveServiceDeploymentLog(accountId: number, transactionId: string): Observable<ServiceDeploymentApiLog> {
        let url_ = this.baseUrl + "/client/v1/log/servicedeployments/{transactionId}/account/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (transactionId === undefined || transactionId === null)
            throw new globalThis.Error("The parameter 'transactionId' must be defined.");
        url_ = url_.replace("{transactionId}", encodeURIComponent("" + transactionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveServiceDeploymentLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveServiceDeploymentLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDeploymentApiLog>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDeploymentApiLog>;
        }));
    }

    protected processRetrieveServiceDeploymentLog(response: HttpResponseBase): Observable<ServiceDeploymentApiLog> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDeploymentApiLog.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceDeploymentApiLog>(null as any);
    }

    /**
     * Retrieves the paged details of a log for a service deployment, service task or task location request
     * @param statusFilter (optional) 
     * @param referenceNumber (optional) 
     * @param limit (optional) 
     * @param offset (optional) 
     * @param ascending (optional) 
     */
    retrieveServiceDeploymentDetails(transactionId: string, accountId: number, statusFilter?: ImportStatusFilter | undefined, referenceNumber?: string | null | undefined, limit?: number | null | undefined, offset?: number | null | undefined, ascending?: boolean | undefined): Observable<LimitedResultOflog> {
        let url_ = this.baseUrl + "/client/v1/log/servicedeployments/{transactionId}/account/{accountId}/details?";
        if (transactionId === undefined || transactionId === null)
            throw new globalThis.Error("The parameter 'transactionId' must be defined.");
        url_ = url_.replace("{transactionId}", encodeURIComponent("" + transactionId));
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (statusFilter === null)
            throw new globalThis.Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (referenceNumber !== undefined && referenceNumber !== null)
            url_ += "ReferenceNumber=" + encodeURIComponent("" + referenceNumber) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (ascending === null)
            throw new globalThis.Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "Ascending=" + encodeURIComponent("" + ascending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveServiceDeploymentDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveServiceDeploymentDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOflog>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOflog>;
        }));
    }

    protected processRetrieveServiceDeploymentDetails(response: HttpResponseBase): Observable<LimitedResultOflog> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOflog.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOflog>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceTaskEventClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    types(): Observable<ServiceTaskEventTypeValueBase[]> {
        let url_ = this.baseUrl + "/client/v1/servicetaskevent/types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceTaskEventTypeValueBase[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceTaskEventTypeValueBase[]>;
        }));
    }

    protected processTypes(response: HttpResponseBase): Observable<ServiceTaskEventTypeValueBase[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceTaskEventTypeValueBase.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceTaskEventTypeValueBase[]>(null as any);
    }

    fundingStatus(): Observable<ServiceTaskEventTypeValueBase[]> {
        let url_ = this.baseUrl + "/client/v1/servicetaskevent/fundingstatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFundingStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFundingStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceTaskEventTypeValueBase[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceTaskEventTypeValueBase[]>;
        }));
    }

    protected processFundingStatus(response: HttpResponseBase): Observable<ServiceTaskEventTypeValueBase[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceTaskEventTypeValueBase.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceTaskEventTypeValueBase[]>(null as any);
    }

    location(): Observable<ServiceTaskEventTypeValueBase[]> {
        let url_ = this.baseUrl + "/client/v1/servicetaskevent/location";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceTaskEventTypeValueBase[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceTaskEventTypeValueBase[]>;
        }));
    }

    protected processLocation(response: HttpResponseBase): Observable<ServiceTaskEventTypeValueBase[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceTaskEventTypeValueBase.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceTaskEventTypeValueBase[]>(null as any);
    }

    uploadDocument(file?: FileParameter | null | undefined): Observable<UploadResponse> {
        let url_ = this.baseUrl + "/client/v1/servicetaskevent/uploaddocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadResponse>;
        }));
    }

    protected processUploadDocument(response: HttpResponseBase): Observable<UploadResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UploadResponse>(null as any);
    }

    create(accountId: number, serviceDeploymentReferenceNumber: string, createServiceTaskEventDto?: CreateServiceTaskEventDto | null | undefined): Observable<Log> {
        let url_ = this.baseUrl + "/client/v1/{accountId}/{serviceDeploymentReferenceNumber}/servicetaskevent";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (serviceDeploymentReferenceNumber === undefined || serviceDeploymentReferenceNumber === null)
            throw new globalThis.Error("The parameter 'serviceDeploymentReferenceNumber' must be defined.");
        url_ = url_.replace("{serviceDeploymentReferenceNumber}", encodeURIComponent("" + serviceDeploymentReferenceNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createServiceTaskEventDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Log>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Log>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<Log> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Log.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Log>(null as any);
    }

    approve(accountId: number, serviceDeploymentReferenceNumber: string, serviceTaskReferenceNumber: string, queryServiceTaskEventDto?: ApproveDenyServiceTaskEventDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/{accountId}/{serviceDeploymentReferenceNumber}/servicetaskevent/{serviceTaskReferenceNumber}/approve";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (serviceDeploymentReferenceNumber === undefined || serviceDeploymentReferenceNumber === null)
            throw new globalThis.Error("The parameter 'serviceDeploymentReferenceNumber' must be defined.");
        url_ = url_.replace("{serviceDeploymentReferenceNumber}", encodeURIComponent("" + serviceDeploymentReferenceNumber));
        if (serviceTaskReferenceNumber === undefined || serviceTaskReferenceNumber === null)
            throw new globalThis.Error("The parameter 'serviceTaskReferenceNumber' must be defined.");
        url_ = url_.replace("{serviceTaskReferenceNumber}", encodeURIComponent("" + serviceTaskReferenceNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryServiceTaskEventDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApprove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    sendFoodSamplingFeedback(accountId: number, serviceDeploymentReferenceNumber: string, serviceTaskReferenceNumber: string, foodSamplingFeedbackEmailDto?: FoodSamplingFeedbackEmailDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/{accountId}/{serviceDeploymentReferenceNumber}/servicetaskevent/{serviceTaskReferenceNumber}/sendfoodsamplingfeedback";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (serviceDeploymentReferenceNumber === undefined || serviceDeploymentReferenceNumber === null)
            throw new globalThis.Error("The parameter 'serviceDeploymentReferenceNumber' must be defined.");
        url_ = url_.replace("{serviceDeploymentReferenceNumber}", encodeURIComponent("" + serviceDeploymentReferenceNumber));
        if (serviceTaskReferenceNumber === undefined || serviceTaskReferenceNumber === null)
            throw new globalThis.Error("The parameter 'serviceTaskReferenceNumber' must be defined.");
        url_ = url_.replace("{serviceTaskReferenceNumber}", encodeURIComponent("" + serviceTaskReferenceNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(foodSamplingFeedbackEmailDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendFoodSamplingFeedback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendFoodSamplingFeedback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendFoodSamplingFeedback(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    deny(accountId: number, serviceDeploymentReferenceNumber: string, serviceTaskReferenceNumber: string, queryServiceTaskEventDto?: ApproveDenyServiceTaskEventDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/{accountId}/{serviceDeploymentReferenceNumber}/servicetaskevent/{serviceTaskReferenceNumber}/deny";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (serviceDeploymentReferenceNumber === undefined || serviceDeploymentReferenceNumber === null)
            throw new globalThis.Error("The parameter 'serviceDeploymentReferenceNumber' must be defined.");
        url_ = url_.replace("{serviceDeploymentReferenceNumber}", encodeURIComponent("" + serviceDeploymentReferenceNumber));
        if (serviceTaskReferenceNumber === undefined || serviceTaskReferenceNumber === null)
            throw new globalThis.Error("The parameter 'serviceTaskReferenceNumber' must be defined.");
        url_ = url_.replace("{serviceTaskReferenceNumber}", encodeURIComponent("" + serviceTaskReferenceNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryServiceTaskEventDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeny(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeny(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeny(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    updateFoodSamplingApprovalStatus(accountId: number, serviceDeploymentReferenceNumber: string, serviceTaskReferenceNumber: string, foodSamplingApprovalStatus: boolean): Observable<boolean> {
        let url_ = this.baseUrl + "/client/v1/{accountId}/{serviceDeploymentReferenceNumber}/servicetaskevent/{serviceTaskReferenceNumber}/updatefoodsamplingapprovalstatus/{foodSamplingApprovalStatus}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (serviceDeploymentReferenceNumber === undefined || serviceDeploymentReferenceNumber === null)
            throw new globalThis.Error("The parameter 'serviceDeploymentReferenceNumber' must be defined.");
        url_ = url_.replace("{serviceDeploymentReferenceNumber}", encodeURIComponent("" + serviceDeploymentReferenceNumber));
        if (serviceTaskReferenceNumber === undefined || serviceTaskReferenceNumber === null)
            throw new globalThis.Error("The parameter 'serviceTaskReferenceNumber' must be defined.");
        url_ = url_.replace("{serviceTaskReferenceNumber}", encodeURIComponent("" + serviceTaskReferenceNumber));
        if (foodSamplingApprovalStatus === undefined || foodSamplingApprovalStatus === null)
            throw new globalThis.Error("The parameter 'foodSamplingApprovalStatus' must be defined.");
        url_ = url_.replace("{foodSamplingApprovalStatus}", encodeURIComponent("" + foodSamplingApprovalStatus));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFoodSamplingApprovalStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFoodSamplingApprovalStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateFoodSamplingApprovalStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    update(accountId: number, serviceDeploymentReferenceNumber: string, serviceTaskReferenceNumber: string, queryServiceTaskEventDto?: UpdateServiceTaskEventDto | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/client/v1/{accountId}/{serviceDeploymentReferenceNumber}/servicetaskevent/{serviceTaskReferenceNumber}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (serviceDeploymentReferenceNumber === undefined || serviceDeploymentReferenceNumber === null)
            throw new globalThis.Error("The parameter 'serviceDeploymentReferenceNumber' must be defined.");
        url_ = url_.replace("{serviceDeploymentReferenceNumber}", encodeURIComponent("" + serviceDeploymentReferenceNumber));
        if (serviceTaskReferenceNumber === undefined || serviceTaskReferenceNumber === null)
            throw new globalThis.Error("The parameter 'serviceTaskReferenceNumber' must be defined.");
        url_ = url_.replace("{serviceTaskReferenceNumber}", encodeURIComponent("" + serviceTaskReferenceNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryServiceTaskEventDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    get(approvalStatus?: ServiceTaskEventStatus | null | undefined, limitedToFoodSampled?: boolean | undefined, sortColumn?: string | null | undefined, ascending?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, filterText?: string | null | undefined): Observable<LimitedResultOfServiceEventTaskInfoDto> {
        let url_ = this.baseUrl + "/client/v1/servicetaskevent?";
        if (approvalStatus !== undefined && approvalStatus !== null)
            url_ += "ApprovalStatus=" + encodeURIComponent("" + approvalStatus) + "&";
        if (limitedToFoodSampled === null)
            throw new globalThis.Error("The parameter 'limitedToFoodSampled' cannot be null.");
        else if (limitedToFoodSampled !== undefined)
            url_ += "LimitedToFoodSampled=" + encodeURIComponent("" + limitedToFoodSampled) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (ascending === null)
            throw new globalThis.Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "Ascending=" + encodeURIComponent("" + ascending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfServiceEventTaskInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfServiceEventTaskInfoDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<LimitedResultOfServiceEventTaskInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfServiceEventTaskInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfServiceEventTaskInfoDto>(null as any);
    }

    getSingleEvent(serviceEventId: string): Observable<RetailtainmentServiceEventTaskDto> {
        let url_ = this.baseUrl + "/client/v1/servicetaskevent/{serviceEventId}";
        if (serviceEventId === undefined || serviceEventId === null)
            throw new globalThis.Error("The parameter 'serviceEventId' must be defined.");
        url_ = url_.replace("{serviceEventId}", encodeURIComponent("" + serviceEventId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSingleEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSingleEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RetailtainmentServiceEventTaskDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RetailtainmentServiceEventTaskDto>;
        }));
    }

    protected processGetSingleEvent(response: HttpResponseBase): Observable<RetailtainmentServiceEventTaskDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RetailtainmentServiceEventTaskDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RetailtainmentServiceEventTaskDto>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceTaskLocationRetrievalClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    /**
     * Retrieves a paged collection service task locations by reference numbers
     * @param offset (optional) 
     * @param limit (optional) 
     * @param sort (optional) 
     * @param numberSearch (optional) 
     * @param referenceNumberSearch (optional) 
     * @param employeeNumbersSearch (optional) 
     * @param status (optional) 
     * @param serviceStartDate (optional) 
     * @param serviceEndDate (optional) 
     */
    getServiceDeploymentTaskLocationbyRefNumber(referenceid: string, taskReferenceid: string, offset?: number | undefined, limit?: number | undefined, sort?: string | null | undefined, numberSearch?: string | null | undefined, referenceNumberSearch?: string | null | undefined, employeeNumbersSearch?: string | null | undefined, status?: string | null | undefined, serviceStartDate?: moment.Moment | null | undefined, serviceEndDate?: moment.Moment | null | undefined): Observable<GenericTableReportOfServiceDeploymentTaskLocationViewModel> {
        let url_ = this.baseUrl + "/client/v1/servicedeployments/{referenceid}/tasks/{taskReferenceid}/locations?";
        if (referenceid === undefined || referenceid === null)
            throw new globalThis.Error("The parameter 'referenceid' must be defined.");
        url_ = url_.replace("{referenceid}", encodeURIComponent("" + referenceid));
        if (taskReferenceid === undefined || taskReferenceid === null)
            throw new globalThis.Error("The parameter 'taskReferenceid' must be defined.");
        url_ = url_.replace("{taskReferenceid}", encodeURIComponent("" + taskReferenceid));
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (numberSearch !== undefined && numberSearch !== null)
            url_ += "NumberSearch=" + encodeURIComponent("" + numberSearch) + "&";
        if (referenceNumberSearch !== undefined && referenceNumberSearch !== null)
            url_ += "ReferenceNumberSearch=" + encodeURIComponent("" + referenceNumberSearch) + "&";
        if (employeeNumbersSearch !== undefined && employeeNumbersSearch !== null)
            url_ += "EmployeeNumbersSearch=" + encodeURIComponent("" + employeeNumbersSearch) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (serviceStartDate !== undefined && serviceStartDate !== null)
            url_ += "ServiceStartDate=" + encodeURIComponent(serviceStartDate ? "" + serviceStartDate.toISOString() : "") + "&";
        if (serviceEndDate !== undefined && serviceEndDate !== null)
            url_ += "ServiceEndDate=" + encodeURIComponent(serviceEndDate ? "" + serviceEndDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceDeploymentTaskLocationbyRefNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceDeploymentTaskLocationbyRefNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericTableReportOfServiceDeploymentTaskLocationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericTableReportOfServiceDeploymentTaskLocationViewModel>;
        }));
    }

    protected processGetServiceDeploymentTaskLocationbyRefNumber(response: HttpResponseBase): Observable<GenericTableReportOfServiceDeploymentTaskLocationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericTableReportOfServiceDeploymentTaskLocationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericTableReportOfServiceDeploymentTaskLocationViewModel>(null as any);
    }

    getFile(serviceDeploymentId?: string | null | undefined, taskId?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/tasklocations/download?";
        if (serviceDeploymentId !== undefined && serviceDeploymentId !== null)
            url_ += "serviceDeploymentId=" + encodeURIComponent("" + serviceDeploymentId) + "&";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    saveServiceTaskLocation(model?: ServiceDeploymentTaskLocationViewModel | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/client/v1/tasklocations/saveservicetasklocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveServiceTaskLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveServiceTaskLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSaveServiceTaskLocation(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    checkStoreNumberAlreadyExist(storeNumber?: string | null | undefined, accountId?: number | undefined, serviceDeploymentRefNumber?: string | null | undefined, taskRefNumber?: string | null | undefined, id?: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/client/v1/tasklocations/checkstorenumberalreadyexist?";
        if (storeNumber !== undefined && storeNumber !== null)
            url_ += "storeNumber=" + encodeURIComponent("" + storeNumber) + "&";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        if (serviceDeploymentRefNumber !== undefined && serviceDeploymentRefNumber !== null)
            url_ += "serviceDeploymentRefNumber=" + encodeURIComponent("" + serviceDeploymentRefNumber) + "&";
        if (taskRefNumber !== undefined && taskRefNumber !== null)
            url_ += "taskRefNumber=" + encodeURIComponent("" + taskRefNumber) + "&";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckStoreNumberAlreadyExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckStoreNumberAlreadyExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckStoreNumberAlreadyExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    checkTaskLocationRefNumberAlreadyExist(taskLocationRefNumber?: string | null | undefined, accountId?: number | undefined, serviceDeploymentRefNumber?: string | null | undefined, taskRefNumber?: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/client/v1/tasklocations/checktasklocationrefnumberalreadyexist?";
        if (taskLocationRefNumber !== undefined && taskLocationRefNumber !== null)
            url_ += "taskLocationRefNumber=" + encodeURIComponent("" + taskLocationRefNumber) + "&";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        if (serviceDeploymentRefNumber !== undefined && serviceDeploymentRefNumber !== null)
            url_ += "serviceDeploymentRefNumber=" + encodeURIComponent("" + serviceDeploymentRefNumber) + "&";
        if (taskRefNumber !== undefined && taskRefNumber !== null)
            url_ += "taskRefNumber=" + encodeURIComponent("" + taskRefNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckTaskLocationRefNumberAlreadyExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckTaskLocationRefNumberAlreadyExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckTaskLocationRefNumberAlreadyExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    failedImportTaskLocation(errorMsg?: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/client/v1/tasklocations/emailfailedimporttasklocation?";
        if (errorMsg !== undefined && errorMsg !== null)
            url_ += "errorMsg=" + encodeURIComponent("" + errorMsg) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFailedImportTaskLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFailedImportTaskLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processFailedImportTaskLocation(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceTaskRetrievalClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    /**
     * Retrieves a paged collection of service tasks for a service deployment by reference number
     * @param offset (optional) 
     * @param limit (optional) 
     * @param sort (optional) 
     * @param nameSearch (optional) 
     * @param activitySearch (optional) 
     * @param referenceNumberSearch (optional) 
     * @param suppliersSearch (optional) 
     * @param departmentsSearch (optional) 
     * @param noteSearch (optional) 
     * @param serviceModelSearch (optional) 
     * @param statusSearch (optional) 
     * @param accountId (optional) 
     */
    retrieveTasks(referenceId: string, offset?: number | undefined, limit?: number | undefined, sort?: string | null | undefined, nameSearch?: string | null | undefined, activitySearch?: string | null | undefined, referenceNumberSearch?: string | null | undefined, suppliersSearch?: string | null | undefined, departmentsSearch?: string | null | undefined, noteSearch?: string | null | undefined, serviceModelSearch?: string | null | undefined, statusSearch?: string | null | undefined, accountId?: number | null | undefined): Observable<GenericTableReportOfServiceDeploymentTasksViewModel> {
        let url_ = this.baseUrl + "/client/v1/servicedeployments/{referenceId}/tasks?";
        if (referenceId === undefined || referenceId === null)
            throw new globalThis.Error("The parameter 'referenceId' must be defined.");
        url_ = url_.replace("{referenceId}", encodeURIComponent("" + referenceId));
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (nameSearch !== undefined && nameSearch !== null)
            url_ += "NameSearch=" + encodeURIComponent("" + nameSearch) + "&";
        if (activitySearch !== undefined && activitySearch !== null)
            url_ += "ActivitySearch=" + encodeURIComponent("" + activitySearch) + "&";
        if (referenceNumberSearch !== undefined && referenceNumberSearch !== null)
            url_ += "ReferenceNumberSearch=" + encodeURIComponent("" + referenceNumberSearch) + "&";
        if (suppliersSearch !== undefined && suppliersSearch !== null)
            url_ += "SuppliersSearch=" + encodeURIComponent("" + suppliersSearch) + "&";
        if (departmentsSearch !== undefined && departmentsSearch !== null)
            url_ += "DepartmentsSearch=" + encodeURIComponent("" + departmentsSearch) + "&";
        if (noteSearch !== undefined && noteSearch !== null)
            url_ += "NoteSearch=" + encodeURIComponent("" + noteSearch) + "&";
        if (serviceModelSearch !== undefined && serviceModelSearch !== null)
            url_ += "ServiceModelSearch=" + encodeURIComponent("" + serviceModelSearch) + "&";
        if (statusSearch !== undefined && statusSearch !== null)
            url_ += "StatusSearch=" + encodeURIComponent("" + statusSearch) + "&";
        if (accountId !== undefined && accountId !== null)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericTableReportOfServiceDeploymentTasksViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericTableReportOfServiceDeploymentTasksViewModel>;
        }));
    }

    protected processRetrieveTasks(response: HttpResponseBase): Observable<GenericTableReportOfServiceDeploymentTasksViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericTableReportOfServiceDeploymentTasksViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericTableReportOfServiceDeploymentTasksViewModel>(null as any);
    }

    getFile(serviceDeploymentId?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/servicetasks/download?";
        if (serviceDeploymentId !== undefined && serviceDeploymentId !== null)
            url_ += "serviceDeploymentId=" + encodeURIComponent("" + serviceDeploymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceTasksClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    serviceTasksForLocation(locationNumber?: string | null | undefined, dateTime?: moment.Moment | undefined, repAccountNumber?: string | null | undefined, repPersonNumber?: string | null | undefined): Observable<ServiceTaskModel[]> {
        let url_ = this.baseUrl + "/client/v1/service-tasks?";
        if (locationNumber !== undefined && locationNumber !== null)
            url_ += "locationNumber=" + encodeURIComponent("" + locationNumber) + "&";
        if (dateTime === null)
            throw new globalThis.Error("The parameter 'dateTime' cannot be null.");
        else if (dateTime !== undefined)
            url_ += "dateTime=" + encodeURIComponent(dateTime ? "" + dateTime.toISOString() : "") + "&";
        if (repAccountNumber !== undefined && repAccountNumber !== null)
            url_ += "repAccountNumber=" + encodeURIComponent("" + repAccountNumber) + "&";
        if (repPersonNumber !== undefined && repPersonNumber !== null)
            url_ += "repPersonNumber=" + encodeURIComponent("" + repPersonNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceTasksForLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceTasksForLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceTaskModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceTaskModel[]>;
        }));
    }

    protected processServiceTasksForLocation(response: HttpResponseBase): Observable<ServiceTaskModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceTaskModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceTaskModel[]>(null as any);
    }

    serviceTaskSummaryForLocation(locationNumber: string, showAll?: boolean | undefined, includeCompleted?: boolean | undefined, includeContinuity?: boolean | undefined, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined, activityGroup?: EActivityNames | undefined, departments?: string[] | null | undefined, activityNames?: string[] | null | undefined): Observable<TaskLocationSummary[]> {
        let url_ = this.baseUrl + "/client/v1/service-tasks/summary/{locationNumber}?";
        if (locationNumber === undefined || locationNumber === null)
            throw new globalThis.Error("The parameter 'locationNumber' must be defined.");
        url_ = url_.replace("{locationNumber}", encodeURIComponent("" + locationNumber));
        if (showAll === null)
            throw new globalThis.Error("The parameter 'showAll' cannot be null.");
        else if (showAll !== undefined)
            url_ += "showAll=" + encodeURIComponent("" + showAll) + "&";
        if (includeCompleted === null)
            throw new globalThis.Error("The parameter 'includeCompleted' cannot be null.");
        else if (includeCompleted !== undefined)
            url_ += "includeCompleted=" + encodeURIComponent("" + includeCompleted) + "&";
        if (includeContinuity === null)
            throw new globalThis.Error("The parameter 'includeContinuity' cannot be null.");
        else if (includeContinuity !== undefined)
            url_ += "includeContinuity=" + encodeURIComponent("" + includeContinuity) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (activityGroup === null)
            throw new globalThis.Error("The parameter 'activityGroup' cannot be null.");
        else if (activityGroup !== undefined)
            url_ += "activityGroup=" + encodeURIComponent("" + activityGroup) + "&";
        if (departments !== undefined && departments !== null)
            departments && departments.forEach(item => { url_ += "department=" + encodeURIComponent("" + item) + "&"; });
        if (activityNames !== undefined && activityNames !== null)
            activityNames && activityNames.forEach(item => { url_ += "activity=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceTaskSummaryForLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceTaskSummaryForLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskLocationSummary[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskLocationSummary[]>;
        }));
    }

    protected processServiceTaskSummaryForLocation(response: HttpResponseBase): Observable<TaskLocationSummary[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskLocationSummary.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskLocationSummary[]>(null as any);
    }

    upcomingVisitsForLocation(locationNumber: string, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined, departments?: string[] | null | undefined, activities?: string[] | null | undefined): Observable<TaskLocationSummary[]> {
        let url_ = this.baseUrl + "/client/v1/service-tasks/summary/upcoming-visits/{locationNumber}?";
        if (locationNumber === undefined || locationNumber === null)
            throw new globalThis.Error("The parameter 'locationNumber' must be defined.");
        url_ = url_.replace("{locationNumber}", encodeURIComponent("" + locationNumber));
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (departments !== undefined && departments !== null)
            departments && departments.forEach(item => { url_ += "department=" + encodeURIComponent("" + item) + "&"; });
        if (activities !== undefined && activities !== null)
            activities && activities.forEach(item => { url_ += "activity=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpcomingVisitsForLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpcomingVisitsForLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskLocationSummary[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskLocationSummary[]>;
        }));
    }

    protected processUpcomingVisitsForLocation(response: HttpResponseBase): Observable<TaskLocationSummary[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskLocationSummary.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskLocationSummary[]>(null as any);
    }

    upcomingVisitsForUser(accountId?: number | undefined, personId?: number | undefined, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined): Observable<TaskLocationSummary[]> {
        let url_ = this.baseUrl + "/client/v1/service-tasks/summary/upcoming-visits?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpcomingVisitsForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpcomingVisitsForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskLocationSummary[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskLocationSummary[]>;
        }));
    }

    protected processUpcomingVisitsForUser(response: HttpResponseBase): Observable<TaskLocationSummary[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskLocationSummary.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskLocationSummary[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param isDemo (optional) 
     * @deprecated
     */
    serviceTaskSummaryForRetailer(filter?: ServiceTaskDashboardFilter | null | undefined, isDemo?: boolean | undefined): Observable<ServiceTaskSummary[]> {
        let url_ = this.baseUrl + "/client/v1/service-tasks/retailer/summary?";
        if (isDemo === null)
            throw new globalThis.Error("The parameter 'isDemo' cannot be null.");
        else if (isDemo !== undefined)
            url_ += "isDemo=" + encodeURIComponent("" + isDemo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceTaskSummaryForRetailer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceTaskSummaryForRetailer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceTaskSummary[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceTaskSummary[]>;
        }));
    }

    protected processServiceTaskSummaryForRetailer(response: HttpResponseBase): Observable<ServiceTaskSummary[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceTaskSummary.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceTaskSummary[]>(null as any);
    }

    serviceTaskChartForRetailerByPsp(filter?: DashboardFilter | null | undefined, isDemo?: boolean | undefined): Observable<ServiceTaskByPspModel[]> {
        let url_ = this.baseUrl + "/client/v1/service-tasks/retailer-by-psp?";
        if (isDemo === null)
            throw new globalThis.Error("The parameter 'isDemo' cannot be null.");
        else if (isDemo !== undefined)
            url_ += "isDemo=" + encodeURIComponent("" + isDemo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceTaskChartForRetailerByPsp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceTaskChartForRetailerByPsp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceTaskByPspModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceTaskByPspModel[]>;
        }));
    }

    protected processServiceTaskChartForRetailerByPsp(response: HttpResponseBase): Observable<ServiceTaskByPspModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceTaskByPspModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceTaskByPspModel[]>(null as any);
    }

    drillDownDataServiceTaskChartForRetailerByPsp(filter?: DashboardFilter | null | undefined, accountId?: number | undefined, isDemo?: boolean | undefined, isOther?: boolean | undefined): Observable<ServiceTaskPspBreakdown[]> {
        let url_ = this.baseUrl + "/client/v1/service-tasks/drilldown-retailer-by-psp?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        if (isDemo === null)
            throw new globalThis.Error("The parameter 'isDemo' cannot be null.");
        else if (isDemo !== undefined)
            url_ += "isDemo=" + encodeURIComponent("" + isDemo) + "&";
        if (isOther === null)
            throw new globalThis.Error("The parameter 'isOther' cannot be null.");
        else if (isOther !== undefined)
            url_ += "isOther=" + encodeURIComponent("" + isOther) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDrillDownDataServiceTaskChartForRetailerByPsp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDrillDownDataServiceTaskChartForRetailerByPsp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceTaskPspBreakdown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceTaskPspBreakdown[]>;
        }));
    }

    protected processDrillDownDataServiceTaskChartForRetailerByPsp(response: HttpResponseBase): Observable<ServiceTaskPspBreakdown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceTaskPspBreakdown.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceTaskPspBreakdown[]>(null as any);
    }

    /**
     * @deprecated
     */
    getServiceTask(id: string): Observable<ServiceTaskModel> {
        let url_ = this.baseUrl + "/client/v1/service-tasks/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceTaskModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceTaskModel>;
        }));
    }

    protected processGetServiceTask(response: HttpResponseBase): Observable<ServiceTaskModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceTaskModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceTaskModel>(null as any);
    }

    getServiceTaskForLocation(id: string): Observable<ServiceTaskModel> {
        let url_ = this.baseUrl + "/client/v1/service-task-location/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceTaskForLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceTaskForLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceTaskModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceTaskModel>;
        }));
    }

    protected processGetServiceTaskForLocation(response: HttpResponseBase): Observable<ServiceTaskModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceTaskModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceTaskModel>(null as any);
    }

    /**
     * For supplier admin/exec get reported minutes for your account
     * @param startDate (optional) 
     * @param endDate (optional) 
     */
    getActualReportedMinutes(startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/client/v1/service-tasks/actual-reported-minutes?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActualReportedMinutes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActualReportedMinutes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetActualReportedMinutes(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * For supplier admin/exec get reported minutes for your account
     * @param startDate (optional) 
     * @param endDate (optional) 
     */
    getEstimatedMinutes(startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/client/v1/service-tasks/estimated-minutes?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEstimatedMinutes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEstimatedMinutes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetEstimatedMinutes(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * For supplier admin/exec get reported time by activity for your account
     * @param startDate (optional) 
     * @param endDate (optional) 
     */
    getReportedTimeByActivity(startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined): Observable<SupplierTasksTimeByActivity[]> {
        let url_ = this.baseUrl + "/client/v1/service-tasks/time-by-activity?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportedTimeByActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportedTimeByActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplierTasksTimeByActivity[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplierTasksTimeByActivity[]>;
        }));
    }

    protected processGetReportedTimeByActivity(response: HttpResponseBase): Observable<SupplierTasksTimeByActivity[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SupplierTasksTimeByActivity.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplierTasksTimeByActivity[]>(null as any);
    }

    /**
     * For supplier admin/exec get reported completed visits
     * @param startDate (optional) 
     * @param endDate (optional) 
     */
    getCompletedCountForSupplier(startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/client/v1/service-tasks/completed-tasks?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompletedCountForSupplier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompletedCountForSupplier(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetCompletedCountForSupplier(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    saveServiceTask(serviceTask?: ServiceDeploymentTasksViewModel | null | undefined): Observable<ServiceTask> {
        let url_ = this.baseUrl + "/client/v1/service-tasks/saveservicetask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(serviceTask);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveServiceTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveServiceTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceTask>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceTask>;
        }));
    }

    protected processSaveServiceTask(response: HttpResponseBase): Observable<ServiceTask> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceTask.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceTask>(null as any);
    }

    serviceTaskFileUpload(file?: FileParameter | null | undefined): Observable<UploadResponse> {
        let url_ = this.baseUrl + "/client/v1/service-tasks/servicetaskfileupload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceTaskFileUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceTaskFileUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadResponse>;
        }));
    }

    protected processServiceTaskFileUpload(response: HttpResponseBase): Observable<UploadResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UploadResponse>(null as any);
    }

    deleteServiceTaskFile(fileName?: string | null | undefined, taskReferenceNumber?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/service-tasks/deleteservicetaskfileupload?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (taskReferenceNumber !== undefined && taskReferenceNumber !== null)
            url_ += "taskReferenceNumber=" + encodeURIComponent("" + taskReferenceNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteServiceTaskFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteServiceTaskFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteServiceTaskFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    checkServiceDepTaskRefNumberAlreadyExist(referenceNumber?: string | null | undefined, accountId?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/client/v1/service-tasks/checkservicedeptaskrefnumberalreadyexist?";
        if (referenceNumber !== undefined && referenceNumber !== null)
            url_ += "referenceNumber=" + encodeURIComponent("" + referenceNumber) + "&";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckServiceDepTaskRefNumberAlreadyExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckServiceDepTaskRefNumberAlreadyExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckServiceDepTaskRefNumberAlreadyExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * Adds or updates tasks for a service deployment
     * @param tasks (optional) 
     */
    addTask(serviceDeploymentReferenceNumber: string, accountId: number, tasks?: ServiceTaskInput[] | null | undefined): Observable<Log> {
        let url_ = this.baseUrl + "/client/v1/servicedeployments/{accountId}/{serviceDeploymentReferenceNumber}/tasks";
        if (serviceDeploymentReferenceNumber === undefined || serviceDeploymentReferenceNumber === null)
            throw new globalThis.Error("The parameter 'serviceDeploymentReferenceNumber' must be defined.");
        url_ = url_.replace("{serviceDeploymentReferenceNumber}", encodeURIComponent("" + serviceDeploymentReferenceNumber));
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tasks);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Log>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Log>;
        }));
    }

    protected processAddTask(response: HttpResponseBase): Observable<Log> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Log.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Log>(null as any);
    }

    /**
     * Gets information about retailtainemnt events
     * @param taskLocationId (optional) 
     */
    getRetailtainmentServiceTaskInfoForLocation(taskLocationId?: string | null | undefined): Observable<RetailtainmentServiceTaskViewModel> {
        let url_ = this.baseUrl + "/client/v1/servicetasks/getretailtainmentservicetaskinfoforlocation?";
        if (taskLocationId !== undefined && taskLocationId !== null)
            url_ += "taskLocationId=" + encodeURIComponent("" + taskLocationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRetailtainmentServiceTaskInfoForLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRetailtainmentServiceTaskInfoForLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RetailtainmentServiceTaskViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RetailtainmentServiceTaskViewModel>;
        }));
    }

    protected processGetRetailtainmentServiceTaskInfoForLocation(response: HttpResponseBase): Observable<RetailtainmentServiceTaskViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RetailtainmentServiceTaskViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RetailtainmentServiceTaskViewModel>(null as any);
    }

    /**
     * Gets information about retailtainemnt events
     * @param serviceTaskId (optional) 
     */
    getRetailtainmentTaskInfo(serviceTaskId?: string | null | undefined): Observable<RetailtainmentServiceTaskViewModel> {
        let url_ = this.baseUrl + "/client/v1/servicetasks/getretailtainmenttaskinfo?";
        if (serviceTaskId !== undefined && serviceTaskId !== null)
            url_ += "serviceTaskId=" + encodeURIComponent("" + serviceTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRetailtainmentTaskInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRetailtainmentTaskInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RetailtainmentServiceTaskViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RetailtainmentServiceTaskViewModel>;
        }));
    }

    protected processGetRetailtainmentTaskInfo(response: HttpResponseBase): Observable<RetailtainmentServiceTaskViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RetailtainmentServiceTaskViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RetailtainmentServiceTaskViewModel>(null as any);
    }

    taskLocationCount(serviceTaskId: string): Observable<number> {
        let url_ = this.baseUrl + "/client/v1/servicetasks/{serviceTaskId}/tasklocationcount";
        if (serviceTaskId === undefined || serviceTaskId === null)
            throw new globalThis.Error("The parameter 'serviceTaskId' must be defined.");
        url_ = url_.replace("{serviceTaskId}", encodeURIComponent("" + serviceTaskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaskLocationCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaskLocationCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processTaskLocationCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    download(serviceTaskId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/servicetasks/{serviceTaskId}/download";
        if (serviceTaskId === undefined || serviceTaskId === null)
            throw new globalThis.Error("The parameter 'serviceTaskId' must be defined.");
        url_ = url_.replace("{serviceTaskId}", encodeURIComponent("" + serviceTaskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownload(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    activeTaskLocationCount(serviceTaskId: string): Observable<number> {
        let url_ = this.baseUrl + "/client/v1/servicetasks/{serviceTaskId}/activetasklocationcount";
        if (serviceTaskId === undefined || serviceTaskId === null)
            throw new globalThis.Error("The parameter 'serviceTaskId' must be defined.");
        url_ = url_.replace("{serviceTaskId}", encodeURIComponent("" + serviceTaskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActiveTaskLocationCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActiveTaskLocationCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processActiveTaskLocationCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    downloadActive(serviceTaskId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/servicetasks/{serviceTaskId}/downloadactive";
        if (serviceTaskId === undefined || serviceTaskId === null)
            throw new globalThis.Error("The parameter 'serviceTaskId' must be defined.");
        url_ = url_.replace("{serviceTaskId}", encodeURIComponent("" + serviceTaskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadActive(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SsrUsageClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getByCompany(accountIds?: number[] | null | undefined, tagIds?: number[] | null | undefined, startDate?: moment.Moment | undefined, endDate?: moment.Moment | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined, offset?: number | undefined, limit?: number | undefined): Observable<SsrByCompanyPage> {
        let url_ = this.baseUrl + "/client/v1/company?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (tagIds !== undefined && tagIds !== null)
            tagIds && tagIds.forEach(item => { url_ += "TagIds=" + encodeURIComponent("" + item) + "&"; });
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SsrByCompanyPage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SsrByCompanyPage>;
        }));
    }

    protected processGetByCompany(response: HttpResponseBase): Observable<SsrByCompanyPage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SsrByCompanyPage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SsrByCompanyPage>(null as any);
    }

    exportByCompany(accountIds?: number[] | null | undefined, tagIds?: number[] | null | undefined, startDate?: moment.Moment | undefined, endDate?: moment.Moment | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/company/export?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (tagIds !== undefined && tagIds !== null)
            tagIds && tagIds.forEach(item => { url_ += "TagIds=" + encodeURIComponent("" + item) + "&"; });
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportByCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportByCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportByCompany(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getByStore(accountIds?: number[] | null | undefined, tagIds?: number[] | null | undefined, locationIds?: number[] | null | undefined, startDate?: moment.Moment | undefined, endDate?: moment.Moment | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined, offset?: number | undefined, limit?: number | undefined): Observable<SsrByStorePage> {
        let url_ = this.baseUrl + "/client/v1/store?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (tagIds !== undefined && tagIds !== null)
            tagIds && tagIds.forEach(item => { url_ += "TagIds=" + encodeURIComponent("" + item) + "&"; });
        if (locationIds !== undefined && locationIds !== null)
            locationIds && locationIds.forEach(item => { url_ += "LocationIds=" + encodeURIComponent("" + item) + "&"; });
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByStore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByStore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SsrByStorePage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SsrByStorePage>;
        }));
    }

    protected processGetByStore(response: HttpResponseBase): Observable<SsrByStorePage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SsrByStorePage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SsrByStorePage>(null as any);
    }

    exportByStore(accountIds?: number[] | null | undefined, tagIds?: number[] | null | undefined, locationIds?: number[] | null | undefined, startDate?: moment.Moment | undefined, endDate?: moment.Moment | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/store/export?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (tagIds !== undefined && tagIds !== null)
            tagIds && tagIds.forEach(item => { url_ += "TagIds=" + encodeURIComponent("" + item) + "&"; });
        if (locationIds !== undefined && locationIds !== null)
            locationIds && locationIds.forEach(item => { url_ += "LocationIds=" + encodeURIComponent("" + item) + "&"; });
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportByStore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportByStore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportByStore(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getByStoreDetails(accountIds?: number[] | null | undefined, tagIds?: number[] | null | undefined, locationIds?: number[] | null | undefined, startDate?: moment.Moment | undefined, endDate?: moment.Moment | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined, offset?: number | undefined, limit?: number | undefined): Observable<LimitedResultOfStoreSsrUsageDetailsViewModel> {
        let url_ = this.baseUrl + "/client/v1/store/details?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (tagIds !== undefined && tagIds !== null)
            tagIds && tagIds.forEach(item => { url_ += "TagIds=" + encodeURIComponent("" + item) + "&"; });
        if (locationIds !== undefined && locationIds !== null)
            locationIds && locationIds.forEach(item => { url_ += "LocationIds=" + encodeURIComponent("" + item) + "&"; });
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByStoreDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByStoreDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfStoreSsrUsageDetailsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfStoreSsrUsageDetailsViewModel>;
        }));
    }

    protected processGetByStoreDetails(response: HttpResponseBase): Observable<LimitedResultOfStoreSsrUsageDetailsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfStoreSsrUsageDetailsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfStoreSsrUsageDetailsViewModel>(null as any);
    }

    getByUser(accountIds?: number[] | null | undefined, tagIds?: number[] | null | undefined, nameSearch?: string | null | undefined, startDate?: moment.Moment | undefined, endDate?: moment.Moment | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined, offset?: number | undefined, limit?: number | undefined): Observable<SsrByUserPage> {
        let url_ = this.baseUrl + "/client/v1/user?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (tagIds !== undefined && tagIds !== null)
            tagIds && tagIds.forEach(item => { url_ += "TagIds=" + encodeURIComponent("" + item) + "&"; });
        if (nameSearch !== undefined && nameSearch !== null)
            url_ += "NameSearch=" + encodeURIComponent("" + nameSearch) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SsrByUserPage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SsrByUserPage>;
        }));
    }

    protected processGetByUser(response: HttpResponseBase): Observable<SsrByUserPage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SsrByUserPage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SsrByUserPage>(null as any);
    }

    exportByUser(accountIds?: number[] | null | undefined, tagIds?: number[] | null | undefined, nameSearch?: string | null | undefined, startDate?: moment.Moment | undefined, endDate?: moment.Moment | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/user/export?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (tagIds !== undefined && tagIds !== null)
            tagIds && tagIds.forEach(item => { url_ += "TagIds=" + encodeURIComponent("" + item) + "&"; });
        if (nameSearch !== undefined && nameSearch !== null)
            url_ += "NameSearch=" + encodeURIComponent("" + nameSearch) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportByUser(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getByUserDetails(accountIds?: number[] | null | undefined, tagIds?: number[] | null | undefined, nameSearch?: string | null | undefined, startDate?: moment.Moment | undefined, endDate?: moment.Moment | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined, personId?: number | undefined, offset?: number | undefined, limit?: number | undefined): Observable<LimitedResultOfSsrUsageByUserDetailsViewModel> {
        let url_ = this.baseUrl + "/client/v1/user/details?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (tagIds !== undefined && tagIds !== null)
            tagIds && tagIds.forEach(item => { url_ += "TagIds=" + encodeURIComponent("" + item) + "&"; });
        if (nameSearch !== undefined && nameSearch !== null)
            url_ += "NameSearch=" + encodeURIComponent("" + nameSearch) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByUserDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByUserDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfSsrUsageByUserDetailsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfSsrUsageByUserDetailsViewModel>;
        }));
    }

    protected processGetByUserDetails(response: HttpResponseBase): Observable<LimitedResultOfSsrUsageByUserDetailsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfSsrUsageByUserDetailsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfSsrUsageByUserDetailsViewModel>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class StatesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getAllStatesWithCodes(): Observable<StatesTableViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/states/getallstateswithcodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStatesWithCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStatesWithCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatesTableViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatesTableViewModel[]>;
        }));
    }

    protected processGetAllStatesWithCodes(response: HttpResponseBase): Observable<StatesTableViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StatesTableViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StatesTableViewModel[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class StatusClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getStatus(): Observable<Status2[]> {
        let url_ = this.baseUrl + "/client/v1/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Status2[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Status2[]>;
        }));
    }

    protected processGetStatus(response: HttpResponseBase): Observable<Status2[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Status2.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Status2[]>(null as any);
    }

    getAllStatus(): Observable<StatusViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/status/getallstatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusViewModel[]>;
        }));
    }

    protected processGetAllStatus(response: HttpResponseBase): Observable<StatusViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StatusViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StatusViewModel[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class StoreClosureClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getCurrentStoreClosures(): Observable<StoreClosureViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/current-store-closures";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentStoreClosures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentStoreClosures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreClosureViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreClosureViewModel[]>;
        }));
    }

    protected processGetCurrentStoreClosures(response: HttpResponseBase): Observable<StoreClosureViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoreClosureViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StoreClosureViewModel[]>(null as any);
    }

    getHistoricalStoreClosures(sort?: string | null | undefined, limit?: number | null | undefined, offset?: number | null | undefined): Observable<LimitedResultOfStoreClosureViewModel> {
        let url_ = this.baseUrl + "/client/v1/historical-store-closures?";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistoricalStoreClosures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistoricalStoreClosures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfStoreClosureViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfStoreClosureViewModel>;
        }));
    }

    protected processGetHistoricalStoreClosures(response: HttpResponseBase): Observable<LimitedResultOfStoreClosureViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfStoreClosureViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfStoreClosureViewModel>(null as any);
    }

    getLatestImportDate(): Observable<moment.Moment> {
        let url_ = this.baseUrl + "/client/v1/latest-import-date";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestImportDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestImportDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<moment.Moment>;
                }
            } else
                return _observableThrow(response_) as any as Observable<moment.Moment>;
        }));
    }

    protected processGetLatestImportDate(response: HttpResponseBase): Observable<moment.Moment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? moment(resultData200.toString()) : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<moment.Moment>(null as any);
    }

    getTopClosureReasons(): Observable<string[]> {
        let url_ = this.baseUrl + "/client/v1/top-closure-reasons";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopClosureReasons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopClosureReasons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetTopClosureReasons(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    update(storeClosure?: StoreClosureViewModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/update-reason-message";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeClosure);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SupplierClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getSupplierFilterList(supplierName?: string | null | undefined, updatedStartDate?: moment.Moment | null | undefined, updatedEndDate?: moment.Moment | null | undefined, status?: StatusTypes | null | undefined, resale?: ResaleOptions | null | undefined, duns?: string | null | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined, offset?: number | undefined, limit?: number | undefined): Observable<SupplierPage> {
        let url_ = this.baseUrl + "/client/v1/supplier/getsupplierfilterlist?";
        if (supplierName !== undefined && supplierName !== null)
            url_ += "SupplierName=" + encodeURIComponent("" + supplierName) + "&";
        if (updatedStartDate !== undefined && updatedStartDate !== null)
            url_ += "UpdatedStartDate=" + encodeURIComponent(updatedStartDate ? "" + updatedStartDate.toISOString() : "") + "&";
        if (updatedEndDate !== undefined && updatedEndDate !== null)
            url_ += "UpdatedEndDate=" + encodeURIComponent(updatedEndDate ? "" + updatedEndDate.toISOString() : "") + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (resale !== undefined && resale !== null)
            url_ += "Resale=" + encodeURIComponent("" + resale) + "&";
        if (duns !== undefined && duns !== null)
            url_ += "Duns=" + encodeURIComponent("" + duns) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplierFilterList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplierFilterList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplierPage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplierPage>;
        }));
    }

    protected processGetSupplierFilterList(response: HttpResponseBase): Observable<SupplierPage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplierPage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplierPage>(null as any);
    }

    /**
     * For supplier roles gets the supplier account information
     */
    getSupplier(): Observable<SupplierViewModel> {
        let url_ = this.baseUrl + "/client/v1/supplier";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplier(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplierViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplierViewModel>;
        }));
    }

    protected processGetSupplier(response: HttpResponseBase): Observable<SupplierViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplierViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplierViewModel>(null as any);
    }

    getSupplierByNumber(supplierNo?: string | null | undefined): Observable<SupplierModel> {
        let url_ = this.baseUrl + "/client/v1/supplier/getsupplierbynumber?";
        if (supplierNo !== undefined && supplierNo !== null)
            url_ += "supplierNo=" + encodeURIComponent("" + supplierNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplierByNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplierByNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplierModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplierModel>;
        }));
    }

    protected processGetSupplierByNumber(response: HttpResponseBase): Observable<SupplierModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplierModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplierModel>(null as any);
    }

    getSupplierListByFilterText(searchFilterText?: string | null | undefined): Observable<DropDownModel[]> {
        let url_ = this.baseUrl + "/client/v1/supplier/supplierlistbyfiltertext?";
        if (searchFilterText !== undefined && searchFilterText !== null)
            url_ += "searchFilterText=" + encodeURIComponent("" + searchFilterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplierListByFilterText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplierListByFilterText(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDownModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDownModel[]>;
        }));
    }

    protected processGetSupplierListByFilterText(response: HttpResponseBase): Observable<DropDownModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownModel[]>(null as any);
    }

    getSupplierTopList(filter?: DashboardFilter | null | undefined, isDemo?: boolean | undefined): Observable<TopSupplierModel[]> {
        let url_ = this.baseUrl + "/client/v1/supplier/top-list?";
        if (isDemo === null)
            throw new globalThis.Error("The parameter 'isDemo' cannot be null.");
        else if (isDemo !== undefined)
            url_ += "isDemo=" + encodeURIComponent("" + isDemo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplierTopList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplierTopList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TopSupplierModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TopSupplierModel[]>;
        }));
    }

    protected processGetSupplierTopList(response: HttpResponseBase): Observable<TopSupplierModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TopSupplierModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TopSupplierModel[]>(null as any);
    }

    getSupplierList(searchString?: string | null | undefined): Observable<SupplierListPhotoGallery[]> {
        let url_ = this.baseUrl + "/client/v1/supplierlist?";
        if (searchString !== undefined && searchString !== null)
            url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplierList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplierList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplierListPhotoGallery[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplierListPhotoGallery[]>;
        }));
    }

    protected processGetSupplierList(response: HttpResponseBase): Observable<SupplierListPhotoGallery[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SupplierListPhotoGallery.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplierListPhotoGallery[]>(null as any);
    }

    exportSuppliers(supplierName?: string | null | undefined, updatedStartDate?: moment.Moment | null | undefined, updatedEndDate?: moment.Moment | null | undefined, status?: StatusTypes | null | undefined, resale?: ResaleOptions | null | undefined, duns?: string | null | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined, offset?: number | undefined, limit?: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/supplier/exportsuppliers?";
        if (supplierName !== undefined && supplierName !== null)
            url_ += "SupplierName=" + encodeURIComponent("" + supplierName) + "&";
        if (updatedStartDate !== undefined && updatedStartDate !== null)
            url_ += "UpdatedStartDate=" + encodeURIComponent(updatedStartDate ? "" + updatedStartDate.toISOString() : "") + "&";
        if (updatedEndDate !== undefined && updatedEndDate !== null)
            url_ += "UpdatedEndDate=" + encodeURIComponent(updatedEndDate ? "" + updatedEndDate.toISOString() : "") + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (resale !== undefined && resale !== null)
            url_ += "Resale=" + encodeURIComponent("" + resale) + "&";
        if (duns !== undefined && duns !== null)
            url_ += "Duns=" + encodeURIComponent("" + duns) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportSuppliers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportSuppliers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportSuppliers(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getSupplierTaskCountList(accountId?: number | null | undefined, suppliers?: string[] | null | undefined, status?: StatusTypes | null | undefined, taskStartDate?: moment.Moment | null | undefined, taskEndDate?: moment.Moment | null | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined, offset?: number | undefined, limit?: number | undefined): Observable<TopSupplierModel[]> {
        let url_ = this.baseUrl + "/client/v1/supplier/getsuppliertaskcountlist?";
        if (accountId !== undefined && accountId !== null)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (suppliers !== undefined && suppliers !== null)
            suppliers && suppliers.forEach(item => { url_ += "Suppliers=" + encodeURIComponent("" + item) + "&"; });
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (taskStartDate !== undefined && taskStartDate !== null)
            url_ += "TaskStartDate=" + encodeURIComponent(taskStartDate ? "" + taskStartDate.toISOString() : "") + "&";
        if (taskEndDate !== undefined && taskEndDate !== null)
            url_ += "TaskEndDate=" + encodeURIComponent(taskEndDate ? "" + taskEndDate.toISOString() : "") + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplierTaskCountList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplierTaskCountList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TopSupplierModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TopSupplierModel[]>;
        }));
    }

    protected processGetSupplierTaskCountList(response: HttpResponseBase): Observable<TopSupplierModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TopSupplierModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TopSupplierModel[]>(null as any);
    }

    getSupplierTaskHoursList(accountId?: number | null | undefined, suppliers?: string[] | null | undefined, taskStartDate?: moment.Moment | undefined, taskEndDate?: moment.Moment | undefined): Observable<TopSupplierHoursModel[]> {
        let url_ = this.baseUrl + "/client/v1/supplier/getsuppliertaskhourslist?";
        if (accountId !== undefined && accountId !== null)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (suppliers !== undefined && suppliers !== null)
            suppliers && suppliers.forEach(item => { url_ += "Suppliers=" + encodeURIComponent("" + item) + "&"; });
        if (taskStartDate === null)
            throw new globalThis.Error("The parameter 'taskStartDate' cannot be null.");
        else if (taskStartDate !== undefined)
            url_ += "TaskStartDate=" + encodeURIComponent(taskStartDate ? "" + taskStartDate.toISOString() : "") + "&";
        if (taskEndDate === null)
            throw new globalThis.Error("The parameter 'taskEndDate' cannot be null.");
        else if (taskEndDate !== undefined)
            url_ += "TaskEndDate=" + encodeURIComponent(taskEndDate ? "" + taskEndDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplierTaskHoursList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplierTaskHoursList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TopSupplierHoursModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TopSupplierHoursModel[]>;
        }));
    }

    protected processGetSupplierTaskHoursList(response: HttpResponseBase): Observable<TopSupplierHoursModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TopSupplierHoursModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TopSupplierHoursModel[]>(null as any);
    }

    getSupplierAutoCompleteSuggestions(searchFilterText?: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/client/v1/supplier/getsupplierautocompletesuggestions?";
        if (searchFilterText !== undefined && searchFilterText !== null)
            url_ += "searchFilterText=" + encodeURIComponent("" + searchFilterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplierAutoCompleteSuggestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplierAutoCompleteSuggestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetSupplierAutoCompleteSuggestions(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SupportBotClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    requestToken(): Observable<string> {
        let url_ = this.baseUrl + "/client/v1/supportbot/token";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRequestToken(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SupportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    support(message?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/support?";
        if (message !== undefined && message !== null)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSupport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SurveyResultClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getSurveyResponseCount(templateId?: string | null | undefined, accountIds?: number[] | null | undefined, dateRange_StartDate?: moment.Moment | null | undefined, dateRange_EndDate?: moment.Moment | null | undefined, regionType?: number | null | undefined, regionNames?: string[] | null | undefined, locationTypes?: string[] | null | undefined, fieldGroupType?: EFieldGroupType | null | undefined, surveyStatus?: SurveyStatus | null | undefined, allowedInvalidStatistics?: string[] | null | undefined): Observable<SurveyResponseCount[]> {
        let url_ = this.baseUrl + "/client/v1/surveyresult/getsurveyresponsecount?";
        if (templateId !== undefined && templateId !== null)
            url_ += "TemplateId=" + encodeURIComponent("" + templateId) + "&";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (dateRange_StartDate !== undefined && dateRange_StartDate !== null)
            url_ += "DateRange.StartDate=" + encodeURIComponent(dateRange_StartDate ? "" + dateRange_StartDate.toISOString() : "") + "&";
        if (dateRange_EndDate !== undefined && dateRange_EndDate !== null)
            url_ += "DateRange.EndDate=" + encodeURIComponent(dateRange_EndDate ? "" + dateRange_EndDate.toISOString() : "") + "&";
        if (regionType !== undefined && regionType !== null)
            url_ += "RegionType=" + encodeURIComponent("" + regionType) + "&";
        if (regionNames !== undefined && regionNames !== null)
            regionNames && regionNames.forEach(item => { url_ += "RegionNames=" + encodeURIComponent("" + item) + "&"; });
        if (locationTypes !== undefined && locationTypes !== null)
            locationTypes && locationTypes.forEach(item => { url_ += "LocationTypes=" + encodeURIComponent("" + item) + "&"; });
        if (fieldGroupType !== undefined && fieldGroupType !== null)
            url_ += "FieldGroupType=" + encodeURIComponent("" + fieldGroupType) + "&";
        if (surveyStatus !== undefined && surveyStatus !== null)
            url_ += "SurveyStatus=" + encodeURIComponent("" + surveyStatus) + "&";
        if (allowedInvalidStatistics !== undefined && allowedInvalidStatistics !== null)
            allowedInvalidStatistics && allowedInvalidStatistics.forEach(item => { url_ += "AllowedInvalidStatistics=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSurveyResponseCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyResponseCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyResponseCount[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyResponseCount[]>;
        }));
    }

    protected processGetSurveyResponseCount(response: HttpResponseBase): Observable<SurveyResponseCount[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SurveyResponseCount.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfCurrentUserErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SurveyResponseCount[]>(null as any);
    }

    getSurveyCompletionStatus(templateId?: string | null | undefined, accountIds?: number[] | null | undefined, dateRange_StartDate?: moment.Moment | null | undefined, dateRange_EndDate?: moment.Moment | null | undefined, regionType?: number | null | undefined, regionNames?: string[] | null | undefined, locationTypes?: string[] | null | undefined, fieldGroupType?: EFieldGroupType | null | undefined, surveyStatus?: SurveyStatus | null | undefined, allowedInvalidStatistics?: string[] | null | undefined): Observable<QuestionAnswerCount[]> {
        let url_ = this.baseUrl + "/client/v1/surveyresult/getsurveycompletionstatus?";
        if (templateId !== undefined && templateId !== null)
            url_ += "TemplateId=" + encodeURIComponent("" + templateId) + "&";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (dateRange_StartDate !== undefined && dateRange_StartDate !== null)
            url_ += "DateRange.StartDate=" + encodeURIComponent(dateRange_StartDate ? "" + dateRange_StartDate.toISOString() : "") + "&";
        if (dateRange_EndDate !== undefined && dateRange_EndDate !== null)
            url_ += "DateRange.EndDate=" + encodeURIComponent(dateRange_EndDate ? "" + dateRange_EndDate.toISOString() : "") + "&";
        if (regionType !== undefined && regionType !== null)
            url_ += "RegionType=" + encodeURIComponent("" + regionType) + "&";
        if (regionNames !== undefined && regionNames !== null)
            regionNames && regionNames.forEach(item => { url_ += "RegionNames=" + encodeURIComponent("" + item) + "&"; });
        if (locationTypes !== undefined && locationTypes !== null)
            locationTypes && locationTypes.forEach(item => { url_ += "LocationTypes=" + encodeURIComponent("" + item) + "&"; });
        if (fieldGroupType !== undefined && fieldGroupType !== null)
            url_ += "FieldGroupType=" + encodeURIComponent("" + fieldGroupType) + "&";
        if (surveyStatus !== undefined && surveyStatus !== null)
            url_ += "SurveyStatus=" + encodeURIComponent("" + surveyStatus) + "&";
        if (allowedInvalidStatistics !== undefined && allowedInvalidStatistics !== null)
            allowedInvalidStatistics && allowedInvalidStatistics.forEach(item => { url_ += "AllowedInvalidStatistics=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSurveyCompletionStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyCompletionStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuestionAnswerCount[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuestionAnswerCount[]>;
        }));
    }

    protected processGetSurveyCompletionStatus(response: HttpResponseBase): Observable<QuestionAnswerCount[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuestionAnswerCount.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfCurrentUserErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuestionAnswerCount[]>(null as any);
    }

    getSurveyStructure(surveyTemplateId?: string | null | undefined): Observable<CardTemplate[]> {
        let url_ = this.baseUrl + "/client/v1/surveyresult/getsurveystructure?";
        if (surveyTemplateId !== undefined && surveyTemplateId !== null)
            url_ += "surveyTemplateId=" + encodeURIComponent("" + surveyTemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSurveyStructure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyStructure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CardTemplate[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CardTemplate[]>;
        }));
    }

    protected processGetSurveyStructure(response: HttpResponseBase): Observable<CardTemplate[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CardTemplate.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfCurrentUserErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CardTemplate[]>(null as any);
    }

    getQuestionAverage(templateId?: string | null | undefined, accountIds?: number[] | null | undefined, dateRange_StartDate?: moment.Moment | null | undefined, dateRange_EndDate?: moment.Moment | null | undefined, regionType?: number | null | undefined, regionNames?: string[] | null | undefined, locationTypes?: string[] | null | undefined, fieldGroupType?: EFieldGroupType | null | undefined, surveyStatus?: SurveyStatus | null | undefined, allowedInvalidStatistics?: string[] | null | undefined, questionKey?: string | null | undefined): Observable<QuestionAverage> {
        let url_ = this.baseUrl + "/client/v1/surveyresult/getquestionaverage?";
        if (templateId !== undefined && templateId !== null)
            url_ += "TemplateId=" + encodeURIComponent("" + templateId) + "&";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (dateRange_StartDate !== undefined && dateRange_StartDate !== null)
            url_ += "DateRange.StartDate=" + encodeURIComponent(dateRange_StartDate ? "" + dateRange_StartDate.toISOString() : "") + "&";
        if (dateRange_EndDate !== undefined && dateRange_EndDate !== null)
            url_ += "DateRange.EndDate=" + encodeURIComponent(dateRange_EndDate ? "" + dateRange_EndDate.toISOString() : "") + "&";
        if (regionType !== undefined && regionType !== null)
            url_ += "RegionType=" + encodeURIComponent("" + regionType) + "&";
        if (regionNames !== undefined && regionNames !== null)
            regionNames && regionNames.forEach(item => { url_ += "RegionNames=" + encodeURIComponent("" + item) + "&"; });
        if (locationTypes !== undefined && locationTypes !== null)
            locationTypes && locationTypes.forEach(item => { url_ += "LocationTypes=" + encodeURIComponent("" + item) + "&"; });
        if (fieldGroupType !== undefined && fieldGroupType !== null)
            url_ += "FieldGroupType=" + encodeURIComponent("" + fieldGroupType) + "&";
        if (surveyStatus !== undefined && surveyStatus !== null)
            url_ += "SurveyStatus=" + encodeURIComponent("" + surveyStatus) + "&";
        if (allowedInvalidStatistics !== undefined && allowedInvalidStatistics !== null)
            allowedInvalidStatistics && allowedInvalidStatistics.forEach(item => { url_ += "AllowedInvalidStatistics=" + encodeURIComponent("" + item) + "&"; });
        if (questionKey !== undefined && questionKey !== null)
            url_ += "questionKey=" + encodeURIComponent("" + questionKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuestionAverage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuestionAverage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuestionAverage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuestionAverage>;
        }));
    }

    protected processGetQuestionAverage(response: HttpResponseBase): Observable<QuestionAverage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionAverage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfCurrentUserErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuestionAverage>(null as any);
    }

    getQuestionAnswerSum(questionParam?: SurveyResultQuestionParams | null | undefined): Observable<QuestionAnswerSum[]> {
        let url_ = this.baseUrl + "/client/v1/surveyresult/getquestionanswersum";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(questionParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuestionAnswerSum(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuestionAnswerSum(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuestionAnswerSum[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuestionAnswerSum[]>;
        }));
    }

    protected processGetQuestionAnswerSum(response: HttpResponseBase): Observable<QuestionAnswerSum[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuestionAnswerSum.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfCurrentUserErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuestionAnswerSum[]>(null as any);
    }

    getQuestionAnswersAsBuckets(param?: SurveyResultQuestionParams | null | undefined): Observable<NumericQuestionBucket[]> {
        let url_ = this.baseUrl + "/client/v1/surveyresult/getquestionanswersasbuckets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuestionAnswersAsBuckets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuestionAnswersAsBuckets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NumericQuestionBucket[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NumericQuestionBucket[]>;
        }));
    }

    protected processGetQuestionAnswersAsBuckets(response: HttpResponseBase): Observable<NumericQuestionBucket[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NumericQuestionBucket.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfCurrentUserErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NumericQuestionBucket[]>(null as any);
    }

    getTodoListStatistics(questionParam?: SurveyResultQuestionParams | null | undefined): Observable<TodoListStatistics> {
        let url_ = this.baseUrl + "/client/v1/surveyresult/gettodoliststatistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(questionParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTodoListStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTodoListStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TodoListStatistics>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TodoListStatistics>;
        }));
    }

    protected processGetTodoListStatistics(response: HttpResponseBase): Observable<TodoListStatistics> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TodoListStatistics.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfCurrentUserErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TodoListStatistics>(null as any);
    }

    getQuestionExistenceCount(questionParam?: SurveyResultQuestionParams | null | undefined): Observable<QuestionExistenceCount> {
        let url_ = this.baseUrl + "/client/v1/surveyresult/getquestionexistencecount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(questionParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuestionExistenceCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuestionExistenceCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuestionExistenceCount>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuestionExistenceCount>;
        }));
    }

    protected processGetQuestionExistenceCount(response: HttpResponseBase): Observable<QuestionExistenceCount> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionExistenceCount.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfCurrentUserErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuestionExistenceCount>(null as any);
    }

    getQuestionAnswerCount(templateId?: string | null | undefined, accountIds?: number[] | null | undefined, dateRange_StartDate?: moment.Moment | null | undefined, dateRange_EndDate?: moment.Moment | null | undefined, regionType?: number | null | undefined, regionNames?: string[] | null | undefined, locationTypes?: string[] | null | undefined, fieldGroupType?: EFieldGroupType | null | undefined, surveyStatus?: SurveyStatus | null | undefined, allowedInvalidStatistics?: string[] | null | undefined, questionKey?: string | null | undefined, limit?: number | null | undefined): Observable<QuestionAnswerCount[]> {
        let url_ = this.baseUrl + "/client/v1/surveyresult/getquestionanswercount?";
        if (templateId !== undefined && templateId !== null)
            url_ += "TemplateId=" + encodeURIComponent("" + templateId) + "&";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (dateRange_StartDate !== undefined && dateRange_StartDate !== null)
            url_ += "DateRange.StartDate=" + encodeURIComponent(dateRange_StartDate ? "" + dateRange_StartDate.toISOString() : "") + "&";
        if (dateRange_EndDate !== undefined && dateRange_EndDate !== null)
            url_ += "DateRange.EndDate=" + encodeURIComponent(dateRange_EndDate ? "" + dateRange_EndDate.toISOString() : "") + "&";
        if (regionType !== undefined && regionType !== null)
            url_ += "RegionType=" + encodeURIComponent("" + regionType) + "&";
        if (regionNames !== undefined && regionNames !== null)
            regionNames && regionNames.forEach(item => { url_ += "RegionNames=" + encodeURIComponent("" + item) + "&"; });
        if (locationTypes !== undefined && locationTypes !== null)
            locationTypes && locationTypes.forEach(item => { url_ += "LocationTypes=" + encodeURIComponent("" + item) + "&"; });
        if (fieldGroupType !== undefined && fieldGroupType !== null)
            url_ += "FieldGroupType=" + encodeURIComponent("" + fieldGroupType) + "&";
        if (surveyStatus !== undefined && surveyStatus !== null)
            url_ += "SurveyStatus=" + encodeURIComponent("" + surveyStatus) + "&";
        if (allowedInvalidStatistics !== undefined && allowedInvalidStatistics !== null)
            allowedInvalidStatistics && allowedInvalidStatistics.forEach(item => { url_ += "AllowedInvalidStatistics=" + encodeURIComponent("" + item) + "&"; });
        if (questionKey !== undefined && questionKey !== null)
            url_ += "questionKey=" + encodeURIComponent("" + questionKey) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuestionAnswerCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuestionAnswerCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuestionAnswerCount[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuestionAnswerCount[]>;
        }));
    }

    protected processGetQuestionAnswerCount(response: HttpResponseBase): Observable<QuestionAnswerCount[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuestionAnswerCount.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfCurrentUserErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuestionAnswerCount[]>(null as any);
    }

    export(filters?: SurveyResultFilterParams | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/surveyresult/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SurveyTemplateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getSurveyTemplateByKey(key?: string | null | undefined): Observable<SurveyTemplate> {
        let url_ = this.baseUrl + "/client/v1/surveytemplate/getsurveytemplatebykey?";
        if (key !== undefined && key !== null)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSurveyTemplateByKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyTemplateByKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyTemplate>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyTemplate>;
        }));
    }

    protected processGetSurveyTemplateByKey(response: HttpResponseBase): Observable<SurveyTemplate> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyTemplate.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfCurrentUserErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SurveyTemplate>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TagClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getFilteredTags(search?: string | null | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined, isReserved?: boolean | undefined, offset?: number | undefined, limit?: number | undefined): Observable<LimitedResultOfTag> {
        let url_ = this.baseUrl + "/client/v1/tags/tags?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (isReserved === null)
            throw new globalThis.Error("The parameter 'isReserved' cannot be null.");
        else if (isReserved !== undefined)
            url_ += "IsReserved=" + encodeURIComponent("" + isReserved) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilteredTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilteredTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfTag>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfTag>;
        }));
    }

    protected processGetFilteredTags(response: HttpResponseBase): Observable<LimitedResultOfTag> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfTag.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfTag>(null as any);
    }

    getTagList(): Observable<Tag3[]> {
        let url_ = this.baseUrl + "/client/v1/tags/gettaglist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTagList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTagList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Tag3[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Tag3[]>;
        }));
    }

    protected processGetTagList(response: HttpResponseBase): Observable<Tag3[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Tag3.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tag3[]>(null as any);
    }

    getPersonAndReservedTags(accountId: number): Observable<Tag3[]> {
        let url_ = this.baseUrl + "/client/v1/getpersonandreservedtags/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonAndReservedTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonAndReservedTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Tag3[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Tag3[]>;
        }));
    }

    protected processGetPersonAndReservedTags(response: HttpResponseBase): Observable<Tag3[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Tag3.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tag3[]>(null as any);
    }

    getAssignedPersonTags(): Observable<Tag3[]> {
        let url_ = this.baseUrl + "/client/v1/getassignedpersontags";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignedPersonTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignedPersonTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Tag3[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Tag3[]>;
        }));
    }

    protected processGetAssignedPersonTags(response: HttpResponseBase): Observable<Tag3[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Tag3.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tag3[]>(null as any);
    }

    getReservedTags(): Observable<Tag3[]> {
        let url_ = this.baseUrl + "/client/v1/getreservedtags";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReservedTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReservedTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Tag3[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Tag3[]>;
        }));
    }

    protected processGetReservedTags(response: HttpResponseBase): Observable<Tag3[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Tag3.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tag3[]>(null as any);
    }

    getReservedTagsForAccount(accountId: number): Observable<Tag3[]> {
        let url_ = this.baseUrl + "/client/v1/getreservedtags/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReservedTagsForAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReservedTagsForAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Tag3[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Tag3[]>;
        }));
    }

    protected processGetReservedTagsForAccount(response: HttpResponseBase): Observable<Tag3[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Tag3.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tag3[]>(null as any);
    }

    getAccountTags(accountIds?: number[] | null | undefined): Observable<Tag3[]> {
        let url_ = this.baseUrl + "/client/v1/getaccounttags?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "accountIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Tag3[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Tag3[]>;
        }));
    }

    protected processGetAccountTags(response: HttpResponseBase): Observable<Tag3[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Tag3.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tag3[]>(null as any);
    }

    setAccountTags(accountId?: number | undefined, tagIds?: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/setaccounttags?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        if (tagIds !== undefined && tagIds !== null)
            tagIds && tagIds.forEach(item => { url_ += "tagIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAccountTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAccountTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAccountTags(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TaskDetailAnalyticsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getServiceTaskDropdownDw(taskNameQuery?: string | null | undefined): Observable<ServiceTaskDropdownItem[]> {
        let url_ = this.baseUrl + "/client/v1/taskdetailanalytics/getservicetaskdropdowndw?";
        if (taskNameQuery !== undefined && taskNameQuery !== null)
            url_ += "taskNameQuery=" + encodeURIComponent("" + taskNameQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceTaskDropdownDw(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceTaskDropdownDw(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceTaskDropdownItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceTaskDropdownItem[]>;
        }));
    }

    protected processGetServiceTaskDropdownDw(response: HttpResponseBase): Observable<ServiceTaskDropdownItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceTaskDropdownItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceTaskDropdownItem[]>(null as any);
    }

    getServiceTaskDropdownDwByIds(ids?: string[] | null | undefined): Observable<ServiceTaskDropdownItem[]> {
        let url_ = this.baseUrl + "/client/v1/taskdetailanalytics/getservicetaskdropdowndwbyids?";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceTaskDropdownDwByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceTaskDropdownDwByIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceTaskDropdownItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceTaskDropdownItem[]>;
        }));
    }

    protected processGetServiceTaskDropdownDwByIds(response: HttpResponseBase): Observable<ServiceTaskDropdownItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceTaskDropdownItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceTaskDropdownItem[]>(null as any);
    }

    getTasksDetails(accountIds?: number[] | null | undefined, dateRange_StartDate?: moment.Moment | null | undefined, dateRange_EndDate?: moment.Moment | null | undefined, hierarchyType?: number | null | undefined, hierarchyNames?: string[] | null | undefined, activities?: string[] | null | undefined, serviceModels?: string[] | null | undefined, departments?: string[] | null | undefined, taskName?: string | null | undefined, sortColumn?: string | null | undefined, ascending?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, filterText?: string | null | undefined): Observable<LimitedResultOfTaskDetailViewModel> {
        let url_ = this.baseUrl + "/client/v1/taskdetailanalytics/gettasksdetails?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (dateRange_StartDate !== undefined && dateRange_StartDate !== null)
            url_ += "DateRange.StartDate=" + encodeURIComponent(dateRange_StartDate ? "" + dateRange_StartDate.toISOString() : "") + "&";
        if (dateRange_EndDate !== undefined && dateRange_EndDate !== null)
            url_ += "DateRange.EndDate=" + encodeURIComponent(dateRange_EndDate ? "" + dateRange_EndDate.toISOString() : "") + "&";
        if (hierarchyType !== undefined && hierarchyType !== null)
            url_ += "HierarchyType=" + encodeURIComponent("" + hierarchyType) + "&";
        if (hierarchyNames !== undefined && hierarchyNames !== null)
            hierarchyNames && hierarchyNames.forEach(item => { url_ += "HierarchyNames=" + encodeURIComponent("" + item) + "&"; });
        if (activities !== undefined && activities !== null)
            activities && activities.forEach(item => { url_ += "Activities=" + encodeURIComponent("" + item) + "&"; });
        if (serviceModels !== undefined && serviceModels !== null)
            serviceModels && serviceModels.forEach(item => { url_ += "ServiceModels=" + encodeURIComponent("" + item) + "&"; });
        if (departments !== undefined && departments !== null)
            departments && departments.forEach(item => { url_ += "Departments=" + encodeURIComponent("" + item) + "&"; });
        if (taskName !== undefined && taskName !== null)
            url_ += "TaskName=" + encodeURIComponent("" + taskName) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (ascending === null)
            throw new globalThis.Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "Ascending=" + encodeURIComponent("" + ascending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTasksDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTasksDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfTaskDetailViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfTaskDetailViewModel>;
        }));
    }

    protected processGetTasksDetails(response: HttpResponseBase): Observable<LimitedResultOfTaskDetailViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfTaskDetailViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfTaskDetailViewModel>(null as any);
    }

    getTaskDetailCompareChartDetails(serviceTaskIds?: string[] | null | undefined): Observable<TaskDetailsCompareChartsViewModel> {
        let url_ = this.baseUrl + "/client/v1/taskdetailanalytics/gettaskdetailcomparechartdetails?";
        if (serviceTaskIds !== undefined && serviceTaskIds !== null)
            serviceTaskIds && serviceTaskIds.forEach(item => { url_ += "serviceTaskIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskDetailCompareChartDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskDetailCompareChartDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskDetailsCompareChartsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskDetailsCompareChartsViewModel>;
        }));
    }

    protected processGetTaskDetailCompareChartDetails(response: HttpResponseBase): Observable<TaskDetailsCompareChartsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskDetailsCompareChartsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskDetailsCompareChartsViewModel>(null as any);
    }

    getTaskDetailCombineChartDetails(serviceTaskIds?: string[] | null | undefined): Observable<TaskDetailsCombineChartsViewModel> {
        let url_ = this.baseUrl + "/client/v1/taskdetailanalytics/gettaskdetailcombinechartdetails?";
        if (serviceTaskIds !== undefined && serviceTaskIds !== null)
            serviceTaskIds && serviceTaskIds.forEach(item => { url_ += "serviceTaskIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskDetailCombineChartDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskDetailCombineChartDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskDetailsCombineChartsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskDetailsCombineChartsViewModel>;
        }));
    }

    protected processGetTaskDetailCombineChartDetails(response: HttpResponseBase): Observable<TaskDetailsCombineChartsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskDetailsCombineChartsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskDetailsCombineChartsViewModel>(null as any);
    }

    exportChartDetails(serviceTaskIds?: string[] | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/taskdetailanalytics/exportchartdetails?";
        if (serviceTaskIds !== undefined && serviceTaskIds !== null)
            serviceTaskIds && serviceTaskIds.forEach(item => { url_ += "serviceTaskIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportChartDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportChartDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportChartDetails(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    exportTaskDetails(accountIds?: number[] | null | undefined, dateRange_StartDate?: moment.Moment | null | undefined, dateRange_EndDate?: moment.Moment | null | undefined, hierarchyType?: number | null | undefined, hierarchyNames?: string[] | null | undefined, activities?: string[] | null | undefined, serviceModels?: string[] | null | undefined, departments?: string[] | null | undefined, taskName?: string | null | undefined, serviceTaskIds?: string[] | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/taskdetailanalytics/exporttaskdetails?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (dateRange_StartDate !== undefined && dateRange_StartDate !== null)
            url_ += "DateRange.StartDate=" + encodeURIComponent(dateRange_StartDate ? "" + dateRange_StartDate.toISOString() : "") + "&";
        if (dateRange_EndDate !== undefined && dateRange_EndDate !== null)
            url_ += "DateRange.EndDate=" + encodeURIComponent(dateRange_EndDate ? "" + dateRange_EndDate.toISOString() : "") + "&";
        if (hierarchyType !== undefined && hierarchyType !== null)
            url_ += "HierarchyType=" + encodeURIComponent("" + hierarchyType) + "&";
        if (hierarchyNames !== undefined && hierarchyNames !== null)
            hierarchyNames && hierarchyNames.forEach(item => { url_ += "HierarchyNames=" + encodeURIComponent("" + item) + "&"; });
        if (activities !== undefined && activities !== null)
            activities && activities.forEach(item => { url_ += "Activities=" + encodeURIComponent("" + item) + "&"; });
        if (serviceModels !== undefined && serviceModels !== null)
            serviceModels && serviceModels.forEach(item => { url_ += "ServiceModels=" + encodeURIComponent("" + item) + "&"; });
        if (departments !== undefined && departments !== null)
            departments && departments.forEach(item => { url_ += "Departments=" + encodeURIComponent("" + item) + "&"; });
        if (taskName !== undefined && taskName !== null)
            url_ += "TaskName=" + encodeURIComponent("" + taskName) + "&";
        if (serviceTaskIds !== undefined && serviceTaskIds !== null)
            serviceTaskIds && serviceTaskIds.forEach(item => { url_ += "serviceTaskIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportTaskDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportTaskDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportTaskDetails(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TaskExportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    queueReport(taskReportParameters?: TaskReportParameters | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/taskexport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(taskReportParameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueueReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueueReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processQueueReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TaskLocationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    /**
     * Adds or updates locations for a service deployment
     * @param location (optional) 
     */
    addLocation(serviceDeploymentReferenceNumber: string, accountId: number, taskReferenceNumber: string, location?: TaskLocationInput | null | undefined): Observable<Log> {
        let url_ = this.baseUrl + "/client/v1/servicedeployments/{accountId}/{serviceDeploymentReferenceNumber}/tasks/{taskReferenceNumber}/locations";
        if (serviceDeploymentReferenceNumber === undefined || serviceDeploymentReferenceNumber === null)
            throw new globalThis.Error("The parameter 'serviceDeploymentReferenceNumber' must be defined.");
        url_ = url_.replace("{serviceDeploymentReferenceNumber}", encodeURIComponent("" + serviceDeploymentReferenceNumber));
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (taskReferenceNumber === undefined || taskReferenceNumber === null)
            throw new globalThis.Error("The parameter 'taskReferenceNumber' must be defined.");
        url_ = url_.replace("{taskReferenceNumber}", encodeURIComponent("" + taskReferenceNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(location);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Log>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Log>;
        }));
    }

    protected processAddLocation(response: HttpResponseBase): Observable<Log> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Log.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Log>(null as any);
    }

    /**
     * Adds or updates locations for a service deployment
     * @param location (optional) 
     */
    updateLocation(serviceDeploymentReferenceNumber: string, accountId: number, taskReferenceNumber: string, taskLocationId: string, location?: TaskLocationInput | null | undefined): Observable<Log> {
        let url_ = this.baseUrl + "/client/v1/servicedeployments/{accountId}/{serviceDeploymentReferenceNumber}/tasks/{taskReferenceNumber}/locations/{taskLocationId}";
        if (serviceDeploymentReferenceNumber === undefined || serviceDeploymentReferenceNumber === null)
            throw new globalThis.Error("The parameter 'serviceDeploymentReferenceNumber' must be defined.");
        url_ = url_.replace("{serviceDeploymentReferenceNumber}", encodeURIComponent("" + serviceDeploymentReferenceNumber));
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (taskReferenceNumber === undefined || taskReferenceNumber === null)
            throw new globalThis.Error("The parameter 'taskReferenceNumber' must be defined.");
        url_ = url_.replace("{taskReferenceNumber}", encodeURIComponent("" + taskReferenceNumber));
        if (taskLocationId === undefined || taskLocationId === null)
            throw new globalThis.Error("The parameter 'taskLocationId' must be defined.");
        url_ = url_.replace("{taskLocationId}", encodeURIComponent("" + taskLocationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(location);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Log>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Log>;
        }));
    }

    protected processUpdateLocation(response: HttpResponseBase): Observable<Log> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Log.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Log>(null as any);
    }

    uploadTaskLocation(serviceDeploymentReferenceNumber?: string | null | undefined, accountId?: number | undefined, taskReferenceNumber?: string | null | undefined, file?: FileParameter | null | undefined): Observable<TaskLocationImportViewModel> {
        let url_ = this.baseUrl + "/client/v1/tasklocations/uploadtasklocation?";
        if (serviceDeploymentReferenceNumber !== undefined && serviceDeploymentReferenceNumber !== null)
            url_ += "serviceDeploymentReferenceNumber=" + encodeURIComponent("" + serviceDeploymentReferenceNumber) + "&";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        if (taskReferenceNumber !== undefined && taskReferenceNumber !== null)
            url_ += "taskReferenceNumber=" + encodeURIComponent("" + taskReferenceNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadTaskLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadTaskLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskLocationImportViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskLocationImportViewModel>;
        }));
    }

    protected processUploadTaskLocation(response: HttpResponseBase): Observable<TaskLocationImportViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskLocationImportViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskLocationImportViewModel>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TaskResultClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    /**
     * Retrieves a paged collection of task results for a location using respective reference ids
     * @param accountId (optional) 
     */
    retrieveTaskResultsByLocation(serviceDeploymentRefId: string, taskRefId: string, taskLocationRefId: string, accountId?: number | undefined): Observable<TaskResult[]> {
        let url_ = this.baseUrl + "/client/v1/servicedeployments/{serviceDeploymentRefId}/tasks/{taskRefId}/results/{taskLocationRefId}?";
        if (serviceDeploymentRefId === undefined || serviceDeploymentRefId === null)
            throw new globalThis.Error("The parameter 'serviceDeploymentRefId' must be defined.");
        url_ = url_.replace("{serviceDeploymentRefId}", encodeURIComponent("" + serviceDeploymentRefId));
        if (taskRefId === undefined || taskRefId === null)
            throw new globalThis.Error("The parameter 'taskRefId' must be defined.");
        url_ = url_.replace("{taskRefId}", encodeURIComponent("" + taskRefId));
        if (taskLocationRefId === undefined || taskLocationRefId === null)
            throw new globalThis.Error("The parameter 'taskLocationRefId' must be defined.");
        url_ = url_.replace("{taskLocationRefId}", encodeURIComponent("" + taskLocationRefId));
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveTaskResultsByLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveTaskResultsByLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskResult[]>;
        }));
    }

    protected processRetrieveTaskResultsByLocation(response: HttpResponseBase): Observable<TaskResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskResult[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ToDoListClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getAll(sort?: string | null | undefined, storeSearch?: string | null | undefined, limit?: number | null | undefined, offset?: number | null | undefined): Observable<LimitedResultOfToDoList> {
        let url_ = this.baseUrl + "/client/v1/todolist?";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (storeSearch !== undefined && storeSearch !== null)
            url_ += "storeSearch=" + encodeURIComponent("" + storeSearch) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfToDoList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfToDoList>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<LimitedResultOfToDoList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfToDoList.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfToDoList>(null as any);
    }

    upload(pageName?: string | null | undefined, file?: FileParameter | null | undefined): Observable<UploadStatus> {
        let url_ = this.baseUrl + "/client/v1/todolist/upload?";
        if (pageName !== undefined && pageName !== null)
            url_ += "pageName=" + encodeURIComponent("" + pageName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadStatus>;
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<UploadStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadStatus.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UploadStatus>(null as any);
    }

    download(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/todolist/download";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownload(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserAccessReviewClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getUserAccessReviewList(accountIds?: number[] | null | undefined, userReviewed?: boolean | undefined, roleCapabilityCapabilityId?: number | null | undefined, usersSearch?: string | null | undefined, maximumCheckinDate?: moment.Moment | null | undefined, onlyTestUsers?: boolean | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined, offset?: number | undefined, limit?: number | undefined): Observable<UserAccessReviewReport> {
        let url_ = this.baseUrl + "/client/v1/useraccessreview/getuserreport?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (userReviewed === null)
            throw new globalThis.Error("The parameter 'userReviewed' cannot be null.");
        else if (userReviewed !== undefined)
            url_ += "UserReviewed=" + encodeURIComponent("" + userReviewed) + "&";
        if (roleCapabilityCapabilityId !== undefined && roleCapabilityCapabilityId !== null)
            url_ += "RoleCapabilityCapabilityId=" + encodeURIComponent("" + roleCapabilityCapabilityId) + "&";
        if (usersSearch !== undefined && usersSearch !== null)
            url_ += "UsersSearch=" + encodeURIComponent("" + usersSearch) + "&";
        if (maximumCheckinDate !== undefined && maximumCheckinDate !== null)
            url_ += "MaximumCheckinDate=" + encodeURIComponent(maximumCheckinDate ? "" + maximumCheckinDate.toISOString() : "") + "&";
        if (onlyTestUsers === null)
            throw new globalThis.Error("The parameter 'onlyTestUsers' cannot be null.");
        else if (onlyTestUsers !== undefined)
            url_ += "OnlyTestUsers=" + encodeURIComponent("" + onlyTestUsers) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAccessReviewList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAccessReviewList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAccessReviewReport>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAccessReviewReport>;
        }));
    }

    protected processGetUserAccessReviewList(response: HttpResponseBase): Observable<UserAccessReviewReport> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAccessReviewReport.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserAccessReviewReport>(null as any);
    }

    export(accountIds?: number[] | null | undefined, userReviewed?: boolean | undefined, roleCapabilityCapabilityId?: number | null | undefined, usersSearch?: string | null | undefined, maximumCheckinDate?: moment.Moment | null | undefined, onlyTestUsers?: boolean | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined, offset?: number | undefined, limit?: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/useraccessreview/export?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (userReviewed === null)
            throw new globalThis.Error("The parameter 'userReviewed' cannot be null.");
        else if (userReviewed !== undefined)
            url_ += "UserReviewed=" + encodeURIComponent("" + userReviewed) + "&";
        if (roleCapabilityCapabilityId !== undefined && roleCapabilityCapabilityId !== null)
            url_ += "RoleCapabilityCapabilityId=" + encodeURIComponent("" + roleCapabilityCapabilityId) + "&";
        if (usersSearch !== undefined && usersSearch !== null)
            url_ += "UsersSearch=" + encodeURIComponent("" + usersSearch) + "&";
        if (maximumCheckinDate !== undefined && maximumCheckinDate !== null)
            url_ += "MaximumCheckinDate=" + encodeURIComponent(maximumCheckinDate ? "" + maximumCheckinDate.toISOString() : "") + "&";
        if (onlyTestUsers === null)
            throw new globalThis.Error("The parameter 'onlyTestUsers' cannot be null.");
        else if (onlyTestUsers !== undefined)
            url_ += "OnlyTestUsers=" + encodeURIComponent("" + onlyTestUsers) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    approve(userId: string): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/useraccessreview/{userId}/approve";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApprove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    deactivate(userId: string): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/useraccessreview/{userId}/deactivate";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeactivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    lowerPrivilege(userId: string): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/useraccessreview/{userId}/lower-privilege";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLowerPrivilege(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLowerPrivilege(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLowerPrivilege(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    hasAccessToReport(): Observable<boolean> {
        let url_ = this.baseUrl + "/client/v1/useraccessreview/hasaccess";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasAccessToReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasAccessToReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processHasAccessToReport(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    retrieveCurrentUser(): Observable<UserInformation> {
        let url_ = this.baseUrl + "/client/v1/users/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInformation>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInformation>;
        }));
    }

    protected processRetrieveCurrentUser(response: HttpResponseBase): Observable<UserInformation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInformation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfCurrentUserErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserInformation>(null as any);
    }

    getFieldRep(accountNumber: string, repNumber: string): Observable<UserInformation> {
        let url_ = this.baseUrl + "/client/v1/users/rep/{accountNumber}/{repNumber}";
        if (accountNumber === undefined || accountNumber === null)
            throw new globalThis.Error("The parameter 'accountNumber' must be defined.");
        url_ = url_.replace("{accountNumber}", encodeURIComponent("" + accountNumber));
        if (repNumber === undefined || repNumber === null)
            throw new globalThis.Error("The parameter 'repNumber' must be defined.");
        url_ = url_.replace("{repNumber}", encodeURIComponent("" + repNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFieldRep(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFieldRep(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInformation>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInformation>;
        }));
    }

    protected processGetFieldRep(response: HttpResponseBase): Observable<UserInformation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInformation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfCurrentUserErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserInformation>(null as any);
    }

    getUserList(accountId?: number | undefined, rolesId?: number | undefined, includeInactive?: boolean | undefined, certificationStatus?: string | null | undefined, approvalStatusId?: number | null | undefined, isAwaitingBadge?: boolean | null | undefined, personTags?: string[] | null | undefined, isNotCertified?: boolean | undefined, fieldGroupType?: string[] | null | undefined, sortColumn?: string | null | undefined, ascending?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, filterText?: string | null | undefined): Observable<LimitedResultOfUserListItem> {
        let url_ = this.baseUrl + "/client/v1/users/list?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (rolesId === null)
            throw new globalThis.Error("The parameter 'rolesId' cannot be null.");
        else if (rolesId !== undefined)
            url_ += "RolesId=" + encodeURIComponent("" + rolesId) + "&";
        if (includeInactive === null)
            throw new globalThis.Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "IncludeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (certificationStatus !== undefined && certificationStatus !== null)
            url_ += "CertificationStatus=" + encodeURIComponent("" + certificationStatus) + "&";
        if (approvalStatusId !== undefined && approvalStatusId !== null)
            url_ += "ApprovalStatusId=" + encodeURIComponent("" + approvalStatusId) + "&";
        if (isAwaitingBadge !== undefined && isAwaitingBadge !== null)
            url_ += "IsAwaitingBadge=" + encodeURIComponent("" + isAwaitingBadge) + "&";
        if (personTags !== undefined && personTags !== null)
            personTags && personTags.forEach(item => { url_ += "PersonTags=" + encodeURIComponent("" + item) + "&"; });
        if (isNotCertified === null)
            throw new globalThis.Error("The parameter 'isNotCertified' cannot be null.");
        else if (isNotCertified !== undefined)
            url_ += "IsNotCertified=" + encodeURIComponent("" + isNotCertified) + "&";
        if (fieldGroupType !== undefined && fieldGroupType !== null)
            fieldGroupType && fieldGroupType.forEach(item => { url_ += "FieldGroupType=" + encodeURIComponent("" + item) + "&"; });
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (ascending === null)
            throw new globalThis.Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "Ascending=" + encodeURIComponent("" + ascending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfUserListItem>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfUserListItem>;
        }));
    }

    protected processGetUserList(response: HttpResponseBase): Observable<LimitedResultOfUserListItem> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfUserListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfCurrentUserErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfUserListItem>(null as any);
    }

    exportUsers(accountId?: number | undefined, rolesId?: number | undefined, includeInactive?: boolean | undefined, certificationStatus?: string | null | undefined, approvalStatusId?: number | null | undefined, isAwaitingBadge?: boolean | null | undefined, personTags?: string[] | null | undefined, isNotCertified?: boolean | undefined, fieldGroupType?: string[] | null | undefined, sortColumn?: string | null | undefined, ascending?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, filterText?: string | null | undefined, isAdvancedFilter?: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/users/list/export?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (rolesId === null)
            throw new globalThis.Error("The parameter 'rolesId' cannot be null.");
        else if (rolesId !== undefined)
            url_ += "RolesId=" + encodeURIComponent("" + rolesId) + "&";
        if (includeInactive === null)
            throw new globalThis.Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "IncludeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (certificationStatus !== undefined && certificationStatus !== null)
            url_ += "CertificationStatus=" + encodeURIComponent("" + certificationStatus) + "&";
        if (approvalStatusId !== undefined && approvalStatusId !== null)
            url_ += "ApprovalStatusId=" + encodeURIComponent("" + approvalStatusId) + "&";
        if (isAwaitingBadge !== undefined && isAwaitingBadge !== null)
            url_ += "IsAwaitingBadge=" + encodeURIComponent("" + isAwaitingBadge) + "&";
        if (personTags !== undefined && personTags !== null)
            personTags && personTags.forEach(item => { url_ += "PersonTags=" + encodeURIComponent("" + item) + "&"; });
        if (isNotCertified === null)
            throw new globalThis.Error("The parameter 'isNotCertified' cannot be null.");
        else if (isNotCertified !== undefined)
            url_ += "IsNotCertified=" + encodeURIComponent("" + isNotCertified) + "&";
        if (fieldGroupType !== undefined && fieldGroupType !== null)
            fieldGroupType && fieldGroupType.forEach(item => { url_ += "FieldGroupType=" + encodeURIComponent("" + item) + "&"; });
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (ascending === null)
            throw new globalThis.Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "Ascending=" + encodeURIComponent("" + ascending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (isAdvancedFilter === null)
            throw new globalThis.Error("The parameter 'isAdvancedFilter' cannot be null.");
        else if (isAdvancedFilter !== undefined)
            url_ += "isAdvancedFilter=" + encodeURIComponent("" + isAdvancedFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportUsers(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfCurrentUserErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getActiveFieldEmployeeCount(): Observable<ActiveFieldEmployeeCount> {
        let url_ = this.baseUrl + "/client/v1/users/list/field-rep-count";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveFieldEmployeeCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveFieldEmployeeCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActiveFieldEmployeeCount>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActiveFieldEmployeeCount>;
        }));
    }

    protected processGetActiveFieldEmployeeCount(response: HttpResponseBase): Observable<ActiveFieldEmployeeCount> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActiveFieldEmployeeCount.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfCurrentUserErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActiveFieldEmployeeCount>(null as any);
    }

    getUser(id: string, locationNumber?: string | null | undefined): Observable<UserDetail> {
        let url_ = this.baseUrl + "/client/v1/users/{id}/details?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (locationNumber !== undefined && locationNumber !== null)
            url_ += "locationNumber=" + encodeURIComponent("" + locationNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDetail>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDetail>;
        }));
    }

    protected processGetUser(response: HttpResponseBase): Observable<UserDetail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDetail.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfCurrentUserErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDetail>(null as any);
    }

    getStoresVisited(userId?: string | null | undefined, locationIds?: number[] | null | undefined, dateRange_StartDate?: moment.Moment | null | undefined, dateRange_EndDate?: moment.Moment | null | undefined, minDistance?: number | null | undefined): Observable<StoreVisited[]> {
        let url_ = this.baseUrl + "/client/v1/users/details/storesvisited?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (locationIds !== undefined && locationIds !== null)
            locationIds && locationIds.forEach(item => { url_ += "LocationIds=" + encodeURIComponent("" + item) + "&"; });
        if (dateRange_StartDate !== undefined && dateRange_StartDate !== null)
            url_ += "DateRange.StartDate=" + encodeURIComponent(dateRange_StartDate ? "" + dateRange_StartDate.toISOString() : "") + "&";
        if (dateRange_EndDate !== undefined && dateRange_EndDate !== null)
            url_ += "DateRange.EndDate=" + encodeURIComponent(dateRange_EndDate ? "" + dateRange_EndDate.toISOString() : "") + "&";
        if (minDistance !== undefined && minDistance !== null)
            url_ += "MinDistance=" + encodeURIComponent("" + minDistance) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStoresVisited(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStoresVisited(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreVisited[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreVisited[]>;
        }));
    }

    protected processGetStoresVisited(response: HttpResponseBase): Observable<StoreVisited[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoreVisited.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfCurrentUserErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StoreVisited[]>(null as any);
    }

    getStoresVisitedExport(userId?: string | null | undefined, locationIds?: number[] | null | undefined, dateRange_StartDate?: moment.Moment | null | undefined, dateRange_EndDate?: moment.Moment | null | undefined, minDistance?: number | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/users/details/storesvisitedexport?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (locationIds !== undefined && locationIds !== null)
            locationIds && locationIds.forEach(item => { url_ += "LocationIds=" + encodeURIComponent("" + item) + "&"; });
        if (dateRange_StartDate !== undefined && dateRange_StartDate !== null)
            url_ += "DateRange.StartDate=" + encodeURIComponent(dateRange_StartDate ? "" + dateRange_StartDate.toISOString() : "") + "&";
        if (dateRange_EndDate !== undefined && dateRange_EndDate !== null)
            url_ += "DateRange.EndDate=" + encodeURIComponent(dateRange_EndDate ? "" + dateRange_EndDate.toISOString() : "") + "&";
        if (minDistance !== undefined && minDistance !== null)
            url_ += "MinDistance=" + encodeURIComponent("" + minDistance) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStoresVisitedExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStoresVisitedExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetStoresVisitedExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfCurrentUserErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    updateCourseStatus(personId?: number | undefined, courseId?: number | undefined, status?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/users/details/course-status?";
        if (personId === null)
            throw new globalThis.Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (courseId === null)
            throw new globalThis.Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(status);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCourseStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCourseStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCourseStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfCurrentUserErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    updateBadgeShippingAddress(id: string, address?: BadgeShipping | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/users/{id}/details/badge-shipping-address";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(address);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBadgeShippingAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBadgeShippingAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateBadgeShippingAddress(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfCurrentUserErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    assignCertification(personId: number, certificationId: number): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/users/{personId}/certifications/{certificationId}/assign";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        if (certificationId === undefined || certificationId === null)
            throw new globalThis.Error("The parameter 'certificationId' must be defined.");
        url_ = url_.replace("{certificationId}", encodeURIComponent("" + certificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignCertification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignCertification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignCertification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfCurrentUserErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    unassignCertification(personId: number, certificationId: number): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/users/{personId}/certifications/{certificationId}/unassign";
        if (personId === undefined || personId === null)
            throw new globalThis.Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        if (certificationId === undefined || certificationId === null)
            throw new globalThis.Error("The parameter 'certificationId' must be defined.");
        url_ = url_.replace("{certificationId}", encodeURIComponent("" + certificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnassignCertification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassignCertification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnassignCertification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfCurrentUserErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getEmployeeListByFilter(searchFilterText?: string | null | undefined, accountId?: number | undefined): Observable<DropDownModel[]> {
        let url_ = this.baseUrl + "/client/v1/users/getemployeelistbyfilter?";
        if (searchFilterText !== undefined && searchFilterText !== null)
            url_ += "searchFilterText=" + encodeURIComponent("" + searchFilterText) + "&";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeListByFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeListByFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDownModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDownModel[]>;
        }));
    }

    protected processGetEmployeeListByFilter(response: HttpResponseBase): Observable<DropDownModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfCurrentUserErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownModel[]>(null as any);
    }

    getEmployeeNumberListByFilter(searchFilterText?: string | null | undefined, accountId?: number | undefined): Observable<DropDownModel[]> {
        let url_ = this.baseUrl + "/client/v1/users/getemployeenumberlistbyfilter?";
        if (searchFilterText !== undefined && searchFilterText !== null)
            url_ += "searchFilterText=" + encodeURIComponent("" + searchFilterText) + "&";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeNumberListByFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeNumberListByFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDownModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDownModel[]>;
        }));
    }

    protected processGetEmployeeNumberListByFilter(response: HttpResponseBase): Observable<DropDownModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfCurrentUserErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownModel[]>(null as any);
    }

    getUserIdsBySearchString(searchText?: string | null | undefined, accountId?: number | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/client/v1/userids/searchstring?";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserIdsBySearchString(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserIdsBySearchString(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetUserIdsBySearchString(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfCurrentUserErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number[]>(null as any);
    }

    accountTransfer(transferRequest?: PersonAccountTransferRequest | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/client/v1/users/accounttransfer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transferRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccountTransfer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccountTransfer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAccountTransfer(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfCurrentUserErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    updateCulture(cultureName?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/client/v1/users/me/culture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cultureName);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCulture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCulture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateCulture(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    resetTwoFactorAuth(userId?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/users/resettwofactorauth?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetTwoFactorAuth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetTwoFactorAuth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetTwoFactorAuth(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfCurrentUserErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UtilitiesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getWalmartWeek(date?: moment.Moment | undefined): Observable<WalmartWeek> {
        let url_ = this.baseUrl + "/client/v1/utilities/walmart-week?";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWalmartWeek(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWalmartWeek(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WalmartWeek>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WalmartWeek>;
        }));
    }

    protected processGetWalmartWeek(response: HttpResponseBase): Observable<WalmartWeek> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalmartWeek.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WalmartWeek>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WirelessServiceProviderCoverageReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getStoresWithNoWirelessRepVisits(wirelessServiceProviderAccountIds?: number[] | null | undefined, startDate?: moment.Moment | undefined, endDate?: moment.Moment | undefined): Observable<StoreWithNoWirelessVisitsViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/wireless-service-provider-coverage-report/stores-with-no-wireless-rep-visits?";
        if (wirelessServiceProviderAccountIds !== undefined && wirelessServiceProviderAccountIds !== null)
            wirelessServiceProviderAccountIds && wirelessServiceProviderAccountIds.forEach(item => { url_ += "wirelessServiceProviderAccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStoresWithNoWirelessRepVisits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStoresWithNoWirelessRepVisits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreWithNoWirelessVisitsViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreWithNoWirelessVisitsViewModel[]>;
        }));
    }

    protected processGetStoresWithNoWirelessRepVisits(response: HttpResponseBase): Observable<StoreWithNoWirelessVisitsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoreWithNoWirelessVisitsViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StoreWithNoWirelessVisitsViewModel[]>(null as any);
    }

    getWirelessProviders(): Observable<DropDownModel[]> {
        let url_ = this.baseUrl + "/client/v1/wireless-service-provider-coverage-report/get-wireless-providers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWirelessProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWirelessProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDownModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDownModel[]>;
        }));
    }

    protected processGetWirelessProviders(response: HttpResponseBase): Observable<DropDownModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownModel[]>(null as any);
    }

    exportStoresWithNoWirelessRepVisits(wirelessServiceProviderAccountIds?: number[] | null | undefined, startDate?: moment.Moment | undefined, endDate?: moment.Moment | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/wireless-service-provider-coverage-report/export-stores-with-no-wireless-rep-visits?";
        if (wirelessServiceProviderAccountIds !== undefined && wirelessServiceProviderAccountIds !== null)
            wirelessServiceProviderAccountIds && wirelessServiceProviderAccountIds.forEach(item => { url_ += "wirelessServiceProviderAccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportStoresWithNoWirelessRepVisits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportStoresWithNoWirelessRepVisits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportStoresWithNoWirelessRepVisits(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getStoresWithLastWirelessRepVisit(wirelessServiceProviderAccountId?: number | undefined, startDate?: moment.Moment | undefined, endDate?: moment.Moment | undefined): Observable<StoresWithLastWirelessRepVisitViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/wireless-service-provider-coverage-report/stores-with-last-wireless-rep-visits?";
        if (wirelessServiceProviderAccountId === null)
            throw new globalThis.Error("The parameter 'wirelessServiceProviderAccountId' cannot be null.");
        else if (wirelessServiceProviderAccountId !== undefined)
            url_ += "wirelessServiceProviderAccountId=" + encodeURIComponent("" + wirelessServiceProviderAccountId) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStoresWithLastWirelessRepVisit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStoresWithLastWirelessRepVisit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoresWithLastWirelessRepVisitViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoresWithLastWirelessRepVisitViewModel[]>;
        }));
    }

    protected processGetStoresWithLastWirelessRepVisit(response: HttpResponseBase): Observable<StoresWithLastWirelessRepVisitViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoresWithLastWirelessRepVisitViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StoresWithLastWirelessRepVisitViewModel[]>(null as any);
    }

    getWspStoreNumbers(): Observable<string[]> {
        let url_ = this.baseUrl + "/client/v1/wireless-service-provider-coverage-report/storesids";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWspStoreNumbers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWspStoreNumbers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetWspStoreNumbers(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    getStoresWithNoWirelessRepVisitsByNoCheckinDays(wirelessServiceProviderAccountIds?: number[] | null | undefined, storeNumbers?: string[] | null | undefined, numberOfCheckedInDays?: number | undefined, personName?: string | null | undefined, operatorName?: string | null | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined, offset?: number | undefined, limit?: number | undefined): Observable<LimitedResultOfStoresWithNoWirelessVisitsViewModel> {
        let url_ = this.baseUrl + "/client/v1/wireless-service-provider-coverage-report/stores?";
        if (wirelessServiceProviderAccountIds !== undefined && wirelessServiceProviderAccountIds !== null)
            wirelessServiceProviderAccountIds && wirelessServiceProviderAccountIds.forEach(item => { url_ += "wirelessServiceProviderAccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (storeNumbers !== undefined && storeNumbers !== null)
            storeNumbers && storeNumbers.forEach(item => { url_ += "storeNumbers=" + encodeURIComponent("" + item) + "&"; });
        if (numberOfCheckedInDays === null)
            throw new globalThis.Error("The parameter 'numberOfCheckedInDays' cannot be null.");
        else if (numberOfCheckedInDays !== undefined)
            url_ += "numberOfCheckedInDays=" + encodeURIComponent("" + numberOfCheckedInDays) + "&";
        if (personName !== undefined && personName !== null)
            url_ += "personName=" + encodeURIComponent("" + personName) + "&";
        if (operatorName !== undefined && operatorName !== null)
            url_ += "operatorName=" + encodeURIComponent("" + operatorName) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStoresWithNoWirelessRepVisitsByNoCheckinDays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStoresWithNoWirelessRepVisitsByNoCheckinDays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfStoresWithNoWirelessVisitsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfStoresWithNoWirelessVisitsViewModel>;
        }));
    }

    protected processGetStoresWithNoWirelessRepVisitsByNoCheckinDays(response: HttpResponseBase): Observable<LimitedResultOfStoresWithNoWirelessVisitsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfStoresWithNoWirelessVisitsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfStoresWithNoWirelessVisitsViewModel>(null as any);
    }

    exportStoresWithNoWirelessRepVisitsByNoCheckinDays(wirelessServiceProviderAccountIds?: number[] | null | undefined, storeNumbers?: string[] | null | undefined, numberOfCheckedInDays?: number | undefined, personName?: string | null | undefined, operatorName?: string | null | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/wireless-service-provider-coverage-report/export-stores?";
        if (wirelessServiceProviderAccountIds !== undefined && wirelessServiceProviderAccountIds !== null)
            wirelessServiceProviderAccountIds && wirelessServiceProviderAccountIds.forEach(item => { url_ += "wirelessServiceProviderAccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (storeNumbers !== undefined && storeNumbers !== null)
            storeNumbers && storeNumbers.forEach(item => { url_ += "storeNumbers=" + encodeURIComponent("" + item) + "&"; });
        if (numberOfCheckedInDays === null)
            throw new globalThis.Error("The parameter 'numberOfCheckedInDays' cannot be null.");
        else if (numberOfCheckedInDays !== undefined)
            url_ += "numberOfCheckedInDays=" + encodeURIComponent("" + numberOfCheckedInDays) + "&";
        if (personName !== undefined && personName !== null)
            url_ += "personName=" + encodeURIComponent("" + personName) + "&";
        if (operatorName !== undefined && operatorName !== null)
            url_ += "operatorName=" + encodeURIComponent("" + operatorName) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportStoresWithNoWirelessRepVisitsByNoCheckinDays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportStoresWithNoWirelessRepVisitsByNoCheckinDays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportStoresWithNoWirelessRepVisitsByNoCheckinDays(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserImportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    uploadUsers(accountId: number, pageName?: string | null | undefined, file?: FileParameter | null | undefined): Observable<ImportLog> {
        let url_ = this.baseUrl + "/client/v1/userimport/{accountId}?";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (pageName !== undefined && pageName !== null)
            url_ += "pageName=" + encodeURIComponent("" + pageName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportLog>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportLog>;
        }));
    }

    protected processUploadUsers(response: HttpResponseBase): Observable<ImportLog> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportLog.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImportLog>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class StoreManagerLocationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    retrieveLocationsByStoreManager(): Observable<LocationDropdown[]> {
        let url_ = this.baseUrl + "/client/v1/storemanagers/locations/current";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveLocationsByStoreManager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveLocationsByStoreManager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationDropdown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationDropdown[]>;
        }));
    }

    protected processRetrieveLocationsByStoreManager(response: HttpResponseBase): Observable<LocationDropdown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationDropdown.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationDropdown[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PermissionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    retrievePermissionsForUser(): Observable<EffectivePermissionViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/permissions/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrievePermissionsForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrievePermissionsForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EffectivePermissionViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EffectivePermissionViewModel[]>;
        }));
    }

    protected processRetrievePermissionsForUser(response: HttpResponseBase): Observable<EffectivePermissionViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EffectivePermissionViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EffectivePermissionViewModel[]>(null as any);
    }

    retrieveEffectivePermissionsForUser(permissionId: string): Observable<EffectivePermissionViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/permissions/me/{permissionId}";
        if (permissionId === undefined || permissionId === null)
            throw new globalThis.Error("The parameter 'permissionId' must be defined.");
        url_ = url_.replace("{permissionId}", encodeURIComponent("" + permissionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveEffectivePermissionsForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveEffectivePermissionsForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EffectivePermissionViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EffectivePermissionViewModel[]>;
        }));
    }

    protected processRetrieveEffectivePermissionsForUser(response: HttpResponseBase): Observable<EffectivePermissionViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EffectivePermissionViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EffectivePermissionViewModel[]>(null as any);
    }

    retrievePermissionsByRole(roleId: number): Observable<EffectivePermissionViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/permissions/roles/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrievePermissionsByRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrievePermissionsByRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EffectivePermissionViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EffectivePermissionViewModel[]>;
        }));
    }

    protected processRetrievePermissionsByRole(response: HttpResponseBase): Observable<EffectivePermissionViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EffectivePermissionViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EffectivePermissionViewModel[]>(null as any);
    }

    updatePermissionsForRole(roleId: number, permissionId: string, request?: RolePermissionUpdate | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/permissions/roles/{roleId}/{permissionId}";
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        if (permissionId === undefined || permissionId === null)
            throw new globalThis.Error("The parameter 'permissionId' must be defined.");
        url_ = url_.replace("{permissionId}", encodeURIComponent("" + permissionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePermissionsForRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePermissionsForRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePermissionsForRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    retrieveMasterPermissions(): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/permissions/master";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveMasterPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveMasterPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRetrieveMasterPermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    test1(locationId: number): Observable<EffectivePermissionViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/permissions/test/route/{locationId}";
        if (locationId === undefined || locationId === null)
            throw new globalThis.Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest1(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EffectivePermissionViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EffectivePermissionViewModel[]>;
        }));
    }

    protected processTest1(response: HttpResponseBase): Observable<EffectivePermissionViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EffectivePermissionViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EffectivePermissionViewModel[]>(null as any);
    }

    test2(locationId: number, testObject?: NestedClass | null | undefined): Observable<EffectivePermissionViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/permissions/test/locationid/{locationId}";
        if (locationId === undefined || locationId === null)
            throw new globalThis.Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(testObject);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EffectivePermissionViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EffectivePermissionViewModel[]>;
        }));
    }

    protected processTest2(response: HttpResponseBase): Observable<EffectivePermissionViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EffectivePermissionViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EffectivePermissionViewModel[]>(null as any);
    }

    test3(locationId: number, testObject?: NestedClass | null | undefined): Observable<EffectivePermissionViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/permissions/test/locationnumber/{locationId}";
        if (locationId === undefined || locationId === null)
            throw new globalThis.Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(testObject);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EffectivePermissionViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EffectivePermissionViewModel[]>;
        }));
    }

    protected processTest3(response: HttpResponseBase): Observable<EffectivePermissionViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EffectivePermissionViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EffectivePermissionViewModel[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RoleAdministrationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getAllRoles(): Observable<RoleViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/administration/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleViewModel[]>;
        }));
    }

    protected processGetAllRoles(response: HttpResponseBase): Observable<RoleViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleViewModel[]>(null as any);
    }

    getRole(roleId: number): Observable<RoleViewModel> {
        let url_ = this.baseUrl + "/client/v1/administration/roles/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleViewModel>;
        }));
    }

    protected processGetRole(response: HttpResponseBase): Observable<RoleViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleViewModel>(null as any);
    }

    updateRole(roleId: number, data?: RoleViewModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/administration/roles/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    cloneRole(roleId: number, data?: RoleViewModel | null | undefined): Observable<RoleViewModel> {
        let url_ = this.baseUrl + "/client/v1/administration/roles/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloneRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloneRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleViewModel>;
        }));
    }

    protected processCloneRole(response: HttpResponseBase): Observable<RoleViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleViewModel>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RoleClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getRolesList(role?: string | null | undefined): Observable<DropDownModel[]> {
        let url_ = this.baseUrl + "/client/v1/roles/getroleslist?";
        if (role !== undefined && role !== null)
            url_ += "role=" + encodeURIComponent("" + role) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRolesList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRolesList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDownModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDownModel[]>;
        }));
    }

    protected processGetRolesList(response: HttpResponseBase): Observable<DropDownModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownModel[]>(null as any);
    }

    getLandingPage(role?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/client/v1/roles/getlandingpage?";
        if (role !== undefined && role !== null)
            url_ += "role=" + encodeURIComponent("" + role) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLandingPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLandingPage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetLandingPage(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    getRolesFromRoleTypes(): Observable<RolesViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/role/getrolesfromroletypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRolesFromRoleTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRolesFromRoleTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RolesViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RolesViewModel[]>;
        }));
    }

    protected processGetRolesFromRoleTypes(response: HttpResponseBase): Observable<RolesViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RolesViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RolesViewModel[]>(null as any);
    }

    getNumberOfUsersWithRoleForAccount(role: string, accountId: number): Observable<number> {
        let url_ = this.baseUrl + "/client/v1/roles/{role}/count/{accountId}";
        if (role === undefined || role === null)
            throw new globalThis.Error("The parameter 'role' must be defined.");
        url_ = url_.replace("{role}", encodeURIComponent("" + role));
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumberOfUsersWithRoleForAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberOfUsersWithRoleForAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetNumberOfUsersWithRoleForAccount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getActiveDirectoryRoles(): Observable<ActiveDirectoryRoleMappingViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/roles/getactivedirectoryroles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveDirectoryRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveDirectoryRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActiveDirectoryRoleMappingViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActiveDirectoryRoleMappingViewModel[]>;
        }));
    }

    protected processGetActiveDirectoryRoles(response: HttpResponseBase): Observable<ActiveDirectoryRoleMappingViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActiveDirectoryRoleMappingViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActiveDirectoryRoleMappingViewModel[]>(null as any);
    }

    getRetailerRoles(): Observable<RolesViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/roles/getretailerroles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRetailerRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRetailerRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RolesViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RolesViewModel[]>;
        }));
    }

    protected processGetRetailerRoles(response: HttpResponseBase): Observable<RolesViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RolesViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RolesViewModel[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RoleNotificationAdministrationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    updateNotificationsForPerson(notificationId: string, request?: PersonNotificationUpdate | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/notifications/person/{notificationId}";
        if (notificationId === undefined || notificationId === null)
            throw new globalThis.Error("The parameter 'notificationId' must be defined.");
        url_ = url_.replace("{notificationId}", encodeURIComponent("" + notificationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNotificationsForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNotificationsForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateNotificationsForPerson(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    updateNotificationsForRole(roleId: number, notificationId: string, request?: RoleNotificationUpdate | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/notifications/roles/{roleId}/{notificationId}";
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        if (notificationId === undefined || notificationId === null)
            throw new globalThis.Error("The parameter 'notificationId' must be defined.");
        url_ = url_.replace("{notificationId}", encodeURIComponent("" + notificationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNotificationsForRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNotificationsForRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateNotificationsForRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    retrieveNotificationsByRole(roleId: number): Observable<EffectiveNotificationViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/notifications/roles/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveNotificationsByRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveNotificationsByRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EffectiveNotificationViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EffectiveNotificationViewModel[]>;
        }));
    }

    protected processRetrieveNotificationsByRole(response: HttpResponseBase): Observable<EffectiveNotificationViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EffectiveNotificationViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EffectiveNotificationViewModel[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RoleTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getRoleTypes(): Observable<RoleTypeViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/roletype/getroletypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleTypeViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleTypeViewModel[]>;
        }));
    }

    protected processGetRoleTypes(response: HttpResponseBase): Observable<RoleTypeViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleTypeViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleTypeViewModel[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class InvitedAccountClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    saveInvitedAccount(model?: InvitedAccountModel | null | undefined): Observable<InvitedAccountModel> {
        let url_ = this.baseUrl + "/client/v1/registration/supplierinvitation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveInvitedAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveInvitedAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvitedAccountModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvitedAccountModel>;
        }));
    }

    protected processSaveInvitedAccount(response: HttpResponseBase): Observable<InvitedAccountModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvitedAccountModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvitedAccountModel>(null as any);
    }

    getInvitedAccountById(id: string): Observable<InvitedAccountModel> {
        let url_ = this.baseUrl + "/client/v1/registration/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvitedAccountById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvitedAccountById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvitedAccountModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvitedAccountModel>;
        }));
    }

    protected processGetInvitedAccountById(response: HttpResponseBase): Observable<InvitedAccountModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvitedAccountModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvitedAccountModel>(null as any);
    }

    getInvitedAccountByAccountId(id: string): Observable<InvitedAccountModel> {
        let url_ = this.baseUrl + "/client/v1/registration/invitedaccountbyaccountid/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvitedAccountByAccountId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvitedAccountByAccountId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvitedAccountModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvitedAccountModel>;
        }));
    }

    protected processGetInvitedAccountByAccountId(response: HttpResponseBase): Observable<InvitedAccountModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvitedAccountModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvitedAccountModel>(null as any);
    }

    registerInvitedAccount(model?: InvitedAccountModel | null | undefined): Observable<InvitedAccountModel> {
        let url_ = this.baseUrl + "/client/v1/registration/registerinvitedaccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterInvitedAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterInvitedAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvitedAccountModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvitedAccountModel>;
        }));
    }

    protected processRegisterInvitedAccount(response: HttpResponseBase): Observable<InvitedAccountModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvitedAccountModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvitedAccountModel>(null as any);
    }

    registerFileUpload(file?: FileParameter | null | undefined): Observable<UploadResponse> {
        let url_ = this.baseUrl + "/client/v1/registration/registerfileupload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterFileUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterFileUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadResponse>;
        }));
    }

    protected processRegisterFileUpload(response: HttpResponseBase): Observable<UploadResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UploadResponse>(null as any);
    }

    getStateList(): Observable<DropDownModel[]> {
        let url_ = this.baseUrl + "/client/v1/registration/statelist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStateList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDownModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDownModel[]>;
        }));
    }

    protected processGetStateList(response: HttpResponseBase): Observable<DropDownModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownModel[]>(null as any);
    }

    getCountryList(): Observable<DropDownModel[]> {
        let url_ = this.baseUrl + "/client/v1/registration/countrylist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountryList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountryList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDownModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDownModel[]>;
        }));
    }

    protected processGetCountryList(response: HttpResponseBase): Observable<DropDownModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownModel[]>(null as any);
    }

    approvedOrRejectInvitedAccount(model?: InvitedAccountModel | null | undefined): Observable<InvitedAccountModel> {
        let url_ = this.baseUrl + "/client/v1/registration/approvedorrejectinvitedaccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprovedOrRejectInvitedAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprovedOrRejectInvitedAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvitedAccountModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvitedAccountModel>;
        }));
    }

    protected processApprovedOrRejectInvitedAccount(response: HttpResponseBase): Observable<InvitedAccountModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvitedAccountModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvitedAccountModel>(null as any);
    }

    checkInvitedEmailAlreadyExist(email?: string | null | undefined, id?: number | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/client/v1/registration/checkinvitedemailalreadyexist?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckInvitedEmailAlreadyExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckInvitedEmailAlreadyExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckInvitedEmailAlreadyExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    checkEmailAlreadyExist(email?: string | null | undefined, id?: number | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/client/v1/registration/checkemailalreadyexist?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckEmailAlreadyExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckEmailAlreadyExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckEmailAlreadyExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    checkAccountNoAlreadyExist(accountNo?: string | null | undefined, id?: number | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/client/v1/registration/checkaccountnoalreadyexist?";
        if (accountNo !== undefined && accountNo !== null)
            url_ += "accountNo=" + encodeURIComponent("" + accountNo) + "&";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckAccountNoAlreadyExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckAccountNoAlreadyExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckAccountNoAlreadyExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    checkEmailDomainInPerson(email?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/client/v1/registration/checkemaildomaininperson?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckEmailDomainInPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckEmailDomainInPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCheckEmailDomainInPerson(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    checkAccountNameAlreadyExist(accountName?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/client/v1/registration/checkaccountnamealreadyexist?";
        if (accountName !== undefined && accountName !== null)
            url_ += "accountName=" + encodeURIComponent("" + accountName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckAccountNameAlreadyExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckAccountNameAlreadyExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCheckAccountNameAlreadyExist(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    checkEmailExistInPerson(email?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/client/v1/registration/checkemailexistinperson?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckEmailExistInPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckEmailExistInPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCheckEmailExistInPerson(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    saveInvitedAccountANote(model?: InvitedAccountModel | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/client/v1/registration/saveinvitedaccountanote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveInvitedAccountANote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveInvitedAccountANote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSaveInvitedAccountANote(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    resendInvitationAccountEmail(id?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/client/v1/registration/resendinvitationaccountemail?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendInvitationAccountEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendInvitationAccountEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processResendInvitationAccountEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    getSelectedAccountDetailByAccountId(accountId?: number | undefined): Observable<AccountDetailViewModel> {
        let url_ = this.baseUrl + "/client/v1/registration/getselectedaccountdetailbyaccountid?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSelectedAccountDetailByAccountId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSelectedAccountDetailByAccountId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountDetailViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountDetailViewModel>;
        }));
    }

    protected processGetSelectedAccountDetailByAccountId(response: HttpResponseBase): Observable<AccountDetailViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountDetailViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountDetailViewModel>(null as any);
    }

    getStatusList(): Observable<DropDownModel[]> {
        let url_ = this.baseUrl + "/client/v1/registration/statuslist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatusList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatusList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDownModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDownModel[]>;
        }));
    }

    protected processGetStatusList(response: HttpResponseBase): Observable<DropDownModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownModel[]>(null as any);
    }

    getInvitedAccounts(search?: string | null | undefined, statusId?: number | null | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined, offset?: number | undefined, limit?: number | undefined): Observable<LimitedResultOfInvitedAccountViewModel> {
        let url_ = this.baseUrl + "/client/v1/registration/getinvitedaccounts?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (statusId !== undefined && statusId !== null)
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvitedAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvitedAccounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfInvitedAccountViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfInvitedAccountViewModel>;
        }));
    }

    protected processGetInvitedAccounts(response: HttpResponseBase): Observable<LimitedResultOfInvitedAccountViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfInvitedAccountViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfInvitedAccountViewModel>(null as any);
    }

    currentUserCanReviewRegistration(invitedAccountId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/client/v1/can-review-registration/{invitedAccountId}";
        if (invitedAccountId === undefined || invitedAccountId === null)
            throw new globalThis.Error("The parameter 'invitedAccountId' must be defined.");
        url_ = url_.replace("{invitedAccountId}", encodeURIComponent("" + invitedAccountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCurrentUserCanReviewRegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCurrentUserCanReviewRegistration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCurrentUserCanReviewRegistration(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    approve(model?: InvitedAccountModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/registration/approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApprove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    reject(model?: InvitedAccountModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/registration/reject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReject(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    saveRegistration(model?: InvitedAccountModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/registration/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveRegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveRegistration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveRegistration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ProductClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    get(sort?: string | null | undefined, sortColumn?: string | null | undefined, ascending?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, filterText?: string | null | undefined): Observable<ProductModel[]> {
        let url_ = this.baseUrl + "/client/v1/products?";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (ascending === null)
            throw new globalThis.Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "Ascending=" + encodeURIComponent("" + ascending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductModel[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProductModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductModel[]>(null as any);
    }

    uploadProducts(pageName?: string | null | undefined, file?: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/products?";
        if (pageName !== undefined && pageName !== null)
            url_ += "pageName=" + encodeURIComponent("" + pageName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadProducts(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    addProduct(product?: ProductInput | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/client/v1/products/addproduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(product);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAddProduct(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    addProductImage(productId?: string | undefined, imageFile?: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/products/addproductimage?";
        if (productId === null)
            throw new globalThis.Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (imageFile !== null && imageFile !== undefined)
            content_.append("imageFile", imageFile.data, imageFile.fileName ? imageFile.fileName : "imageFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddProductImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddProductImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddProductImage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getProductList(): Observable<ProductsModel[]> {
        let url_ = this.baseUrl + "/client/v1/products/getproductlist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductsModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductsModel[]>;
        }));
    }

    protected processGetProductList(response: HttpResponseBase): Observable<ProductsModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductsModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductsModel[]>(null as any);
    }

    validatePartNumber(partNumber?: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/client/v1/products/validatepartnumber?";
        if (partNumber !== undefined && partNumber !== null)
            url_ += "partNumber=" + encodeURIComponent("" + partNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidatePartNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatePartNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processValidatePartNumber(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    getProduct(productId?: string | null | undefined): Observable<ProductModel> {
        let url_ = this.baseUrl + "/client/v1/product?";
        if (productId !== undefined && productId !== null)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductModel>;
        }));
    }

    protected processGetProduct(response: HttpResponseBase): Observable<ProductModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductModel>(null as any);
    }

    getAccountProducts(accountId?: number | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/client/v1/accountproducts?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAccountProducts(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    setAccountProducts(accountId?: number | undefined, productIds?: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/setaccountproducts?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        if (productIds !== undefined && productIds !== null)
            productIds && productIds.forEach(item => { url_ += "productIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAccountProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAccountProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAccountProducts(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PhotosClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    uploadPhoto(file?: FileParameter | null | undefined): Observable<UploadResponse> {
        let url_ = this.baseUrl + "/client/v1/photos/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadPhoto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadPhoto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadResponse>;
        }));
    }

    protected processUploadPhoto(response: HttpResponseBase): Observable<UploadResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UploadResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class InventoryNotificationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    uploadInventoryNotifications(pageName?: string | null | undefined, file?: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/inventorynotification?";
        if (pageName !== undefined && pageName !== null)
            url_ += "pageName=" + encodeURIComponent("" + pageName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadInventoryNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadInventoryNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadInventoryNotifications(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getFile(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/inventorynotification/download";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class NotificationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getLocationNotifications(locationNumber: string, status?: NotificationStatus | null | undefined): Observable<LocationNotification[]> {
        let url_ = this.baseUrl + "/client/v1/notifications/site/{locationNumber}?";
        if (locationNumber === undefined || locationNumber === null)
            throw new globalThis.Error("The parameter 'locationNumber' must be defined.");
        url_ = url_.replace("{locationNumber}", encodeURIComponent("" + locationNumber));
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationNotification[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationNotification[]>;
        }));
    }

    protected processGetLocationNotifications(response: HttpResponseBase): Observable<LocationNotification[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationNotification.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfString.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationNotification[]>(null as any);
    }

    terminatedEmployeesByStatus(status?: NotificationStatus | undefined, filterText?: string | null | undefined): Observable<TerminatedEmpViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/notifications/site/terminatedemployeesbystatus?";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTerminatedEmployeesByStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTerminatedEmployeesByStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TerminatedEmpViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TerminatedEmpViewModel[]>;
        }));
    }

    protected processTerminatedEmployeesByStatus(response: HttpResponseBase): Observable<TerminatedEmpViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TerminatedEmpViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TerminatedEmpViewModel[]>(null as any);
    }

    getTerminatedEmployeesByStatusExport(status?: NotificationStatus | undefined, filterText?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/notifications/site/exportterminatedemployeesbystatus?";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTerminatedEmployeesByStatusExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTerminatedEmployeesByStatusExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetTerminatedEmployeesByStatusExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getTerminatedEmployees(): Observable<number> {
        let url_ = this.baseUrl + "/client/v1/notifications/site/terminatedemployeescount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTerminatedEmployees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTerminatedEmployees(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTerminatedEmployees(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class NotificationStatusClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getEmailNotificationStatus(id: string): Observable<GetEmailStatusResponse> {
        let url_ = this.baseUrl + "/client/v1/notifications/{id}/emailstatus";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailNotificationStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailNotificationStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmailStatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmailStatusResponse>;
        }));
    }

    protected processGetEmailNotificationStatus(response: HttpResponseBase): Observable<GetEmailStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmailStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmailStatusResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class NotificationsUpdateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    updateNotificationStatus(id: string, status: NotificationStatus): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/notifications/{id}/status/{status}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (status === undefined || status === null)
            throw new globalThis.Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNotificationStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNotificationStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateNotificationStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfString.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MarketingSignageRequestClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    create(request?: CreateRequestViewModel | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/client/v1/marketingsignagerequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    uploadImage(file?: FileParameter | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/client/v1/marketingsignagerequest/upload/image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadImage(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    uploadPdf(file?: FileParameter | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/client/v1/marketingsignagerequest/upload/pdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadPdf(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    retrieveRequests(departmentNumbers?: string[] | null | undefined, status?: string | null | undefined, sortColumn?: string | null | undefined, offset?: number | undefined, limit?: number | undefined, ascending?: boolean | undefined, filterText?: string | null | undefined): Observable<LimitedResultOfMarketingSignageRequestRetrievalViewModel> {
        let url_ = this.baseUrl + "/client/v1/marketingsignagerequest/retrieverequests?";
        if (departmentNumbers !== undefined && departmentNumbers !== null)
            departmentNumbers && departmentNumbers.forEach(item => { url_ += "DepartmentNumbers=" + encodeURIComponent("" + item) + "&"; });
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (ascending === null)
            throw new globalThis.Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "Ascending=" + encodeURIComponent("" + ascending) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfMarketingSignageRequestRetrievalViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfMarketingSignageRequestRetrievalViewModel>;
        }));
    }

    protected processRetrieveRequests(response: HttpResponseBase): Observable<LimitedResultOfMarketingSignageRequestRetrievalViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfMarketingSignageRequestRetrievalViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfMarketingSignageRequestRetrievalViewModel>(null as any);
    }

    exportRequests(departmentNumbers?: string[] | null | undefined, status?: string | null | undefined, sortColumn?: string | null | undefined, offset?: number | undefined, limit?: number | undefined, ascending?: boolean | undefined, filterText?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/marketingsignagerequest/export-requests?";
        if (departmentNumbers !== undefined && departmentNumbers !== null)
            departmentNumbers && departmentNumbers.forEach(item => { url_ += "DepartmentNumbers=" + encodeURIComponent("" + item) + "&"; });
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (ascending === null)
            throw new globalThis.Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "Ascending=" + encodeURIComponent("" + ascending) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportRequests(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    retrieveRequestCountByStatus(): Observable<RequestCountViewModel> {
        let url_ = this.baseUrl + "/client/v1/marketingsignagerequest/retrieverequestcountbystatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveRequestCountByStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveRequestCountByStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestCountViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestCountViewModel>;
        }));
    }

    protected processRetrieveRequestCountByStatus(response: HttpResponseBase): Observable<RequestCountViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestCountViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RequestCountViewModel>(null as any);
    }

    getById(id: string): Observable<RetrievalDetailViewModel> {
        let url_ = this.baseUrl + "/client/v1/marketingsignagerequest/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RetrievalDetailViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RetrievalDetailViewModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<RetrievalDetailViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RetrievalDetailViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RetrievalDetailViewModel>(null as any);
    }

    update(id: string, updateRequest?: UpdateRequestViewModel | null | undefined): Observable<RetrievalDetailViewModel> {
        let url_ = this.baseUrl + "/client/v1/marketingsignagerequest/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RetrievalDetailViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RetrievalDetailViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RetrievalDetailViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RetrievalDetailViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RetrievalDetailViewModel>(null as any);
    }

    getByIdNonVolt(id: string): Observable<RetrievalDetailNonVoltViewModel> {
        let url_ = this.baseUrl + "/client/v1/marketingsignagerequest/non-volt/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByIdNonVolt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByIdNonVolt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RetrievalDetailNonVoltViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RetrievalDetailNonVoltViewModel>;
        }));
    }

    protected processGetByIdNonVolt(response: HttpResponseBase): Observable<RetrievalDetailNonVoltViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RetrievalDetailNonVoltViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RetrievalDetailNonVoltViewModel>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LocationTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getFilteredLocationTypeList(sortColumn?: string | null | undefined, ascending?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, filterText?: string | null | undefined): Observable<LimitedResultOfLocationTypeModel> {
        let url_ = this.baseUrl + "/client/v1/locationtype/getlocationtypelist?";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (ascending === null)
            throw new globalThis.Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "Ascending=" + encodeURIComponent("" + ascending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilteredLocationTypeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilteredLocationTypeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfLocationTypeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfLocationTypeModel>;
        }));
    }

    protected processGetFilteredLocationTypeList(response: HttpResponseBase): Observable<LimitedResultOfLocationTypeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfLocationTypeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfLocationTypeModel>(null as any);
    }

    getList(): Observable<LocationTypeModel[]> {
        let url_ = this.baseUrl + "/client/v1/locationtype/getlist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationTypeModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationTypeModel[]>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LocationTypeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationTypeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationTypeModel[]>(null as any);
    }

    getById(id?: number | undefined): Observable<LocationTypeModel> {
        let url_ = this.baseUrl + "/client/v1/locationtype/getbyid?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationTypeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationTypeModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<LocationTypeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationTypeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationTypeModel>(null as any);
    }

    saveLocationType(locationType?: LocationTypeModel | null | undefined): Observable<LocationTypeModel> {
        let url_ = this.baseUrl + "/client/v1/locationtype/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(locationType);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveLocationType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveLocationType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationTypeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationTypeModel>;
        }));
    }

    protected processSaveLocationType(response: HttpResponseBase): Observable<LocationTypeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationTypeModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationTypeModel>(null as any);
    }

    getAllStatusList(): Observable<DropDownModel[]> {
        let url_ = this.baseUrl + "/client/v1/locationtype/statuslist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStatusList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStatusList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDownModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDownModel[]>;
        }));
    }

    protected processGetAllStatusList(response: HttpResponseBase): Observable<DropDownModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownModel[]>(null as any);
    }

    getLocationTypeDropdown(): Observable<LocationTypeDropdown[]> {
        let url_ = this.baseUrl + "/client/v1/locationtype/getlocationtypedropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationTypeDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationTypeDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationTypeDropdown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationTypeDropdown[]>;
        }));
    }

    protected processGetLocationTypeDropdown(response: HttpResponseBase): Observable<LocationTypeDropdown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationTypeDropdown.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationTypeDropdown[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AllowedLocationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getAllowedLocations(): Observable<LocationDropdown[]> {
        let url_ = this.baseUrl + "/client/v1/locations/allowed";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllowedLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllowedLocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationDropdown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationDropdown[]>;
        }));
    }

    protected processGetAllowedLocations(response: HttpResponseBase): Observable<LocationDropdown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationDropdown.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationDropdown[]>(null as any);
    }

    getAllowedLocationDetails(id: string): Observable<LocationDropdown> {
        let url_ = this.baseUrl + "/client/v1/locations/{id}/allowed";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllowedLocationDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllowedLocationDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationDropdown>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationDropdown>;
        }));
    }

    protected processGetAllowedLocationDetails(response: HttpResponseBase): Observable<LocationDropdown> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationDropdown.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationDropdown>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LocationCountsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getRepsInStoreCount(number: string): Observable<number> {
        let url_ = this.baseUrl + "/client/v1/locations/{number}/reps-instore-count";
        if (number === undefined || number === null)
            throw new globalThis.Error("The parameter 'number' must be defined.");
        url_ = url_.replace("{number}", encodeURIComponent("" + number));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRepsInStoreCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRepsInStoreCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetRepsInStoreCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getUpcomingVisitsTime(number: string, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/client/v1/locations/{number}/upcoming-visits-time?";
        if (number === undefined || number === null)
            throw new globalThis.Error("The parameter 'number' must be defined.");
        url_ = url_.replace("{number}", encodeURIComponent("" + number));
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUpcomingVisitsTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUpcomingVisitsTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetUpcomingVisitsTime(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getCompletedVisitsCount(number: string, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/client/v1/locations/{number}/completed-visits-count?";
        if (number === undefined || number === null)
            throw new globalThis.Error("The parameter 'number' must be defined.");
        url_ = url_.replace("{number}", encodeURIComponent("" + number));
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompletedVisitsCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompletedVisitsCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetCompletedVisitsCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LocationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    isValidLocationNumber(locationNumber?: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/client/v1/locations/is-valid-storenumber?";
        if (locationNumber !== undefined && locationNumber !== null)
            url_ += "locationNumber=" + encodeURIComponent("" + locationNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsValidLocationNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsValidLocationNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsValidLocationNumber(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    get(onlyRepsInStore?: boolean | undefined, storesInEmergencyState?: boolean | undefined, locationIds?: number[] | null | undefined, wattLocationIDs?: string[] | null | undefined, locationTypeDescriptions?: string[] | null | undefined, locationOpenStatusDescriptions?: string[] | null | undefined, groupId?: number | null | undefined, groupValues?: string[] | null | undefined, features?: string[] | null | undefined, sortColumn?: string | null | undefined, ascending?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, filterText?: string | null | undefined): Observable<LimitedResultOfLocationSummary> {
        let url_ = this.baseUrl + "/client/v1/locations/filtered?";
        if (onlyRepsInStore === null)
            throw new globalThis.Error("The parameter 'onlyRepsInStore' cannot be null.");
        else if (onlyRepsInStore !== undefined)
            url_ += "OnlyRepsInStore=" + encodeURIComponent("" + onlyRepsInStore) + "&";
        if (storesInEmergencyState === null)
            throw new globalThis.Error("The parameter 'storesInEmergencyState' cannot be null.");
        else if (storesInEmergencyState !== undefined)
            url_ += "StoresInEmergencyState=" + encodeURIComponent("" + storesInEmergencyState) + "&";
        if (locationIds !== undefined && locationIds !== null)
            locationIds && locationIds.forEach(item => { url_ += "LocationIds=" + encodeURIComponent("" + item) + "&"; });
        if (wattLocationIDs !== undefined && wattLocationIDs !== null)
            wattLocationIDs && wattLocationIDs.forEach(item => { url_ += "WattLocationIDs=" + encodeURIComponent("" + item) + "&"; });
        if (locationTypeDescriptions !== undefined && locationTypeDescriptions !== null)
            locationTypeDescriptions && locationTypeDescriptions.forEach(item => { url_ += "LocationTypeDescriptions=" + encodeURIComponent("" + item) + "&"; });
        if (locationOpenStatusDescriptions !== undefined && locationOpenStatusDescriptions !== null)
            locationOpenStatusDescriptions && locationOpenStatusDescriptions.forEach(item => { url_ += "LocationOpenStatusDescriptions=" + encodeURIComponent("" + item) + "&"; });
        if (groupId !== undefined && groupId !== null)
            url_ += "GroupId=" + encodeURIComponent("" + groupId) + "&";
        if (groupValues !== undefined && groupValues !== null)
            groupValues && groupValues.forEach(item => { url_ += "GroupValues=" + encodeURIComponent("" + item) + "&"; });
        if (features !== undefined && features !== null)
            features && features.forEach(item => { url_ += "Features=" + encodeURIComponent("" + item) + "&"; });
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (ascending === null)
            throw new globalThis.Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "Ascending=" + encodeURIComponent("" + ascending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfLocationSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfLocationSummary>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<LimitedResultOfLocationSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfLocationSummary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfLocationSummary>(null as any);
    }

    getWattLocations(filter_LocationNumbers?: string[] | null | undefined, filter_OpenStatusCodes?: string[] | null | undefined, filter_BannerIds?: string[] | null | undefined, filter_HierarchyLevelId?: string | null | undefined, filter_HierarchyMemberIds?: string[] | null | undefined, offset?: number | undefined, limit?: number | undefined): Observable<LimitedResultOfLocationsFilteredResult> {
        let url_ = this.baseUrl + "/client/v1/locations/watt?";
        if (filter_LocationNumbers !== undefined && filter_LocationNumbers !== null)
            filter_LocationNumbers && filter_LocationNumbers.forEach(item => { url_ += "Filter.LocationNumbers=" + encodeURIComponent("" + item) + "&"; });
        if (filter_OpenStatusCodes !== undefined && filter_OpenStatusCodes !== null)
            filter_OpenStatusCodes && filter_OpenStatusCodes.forEach(item => { url_ += "Filter.OpenStatusCodes=" + encodeURIComponent("" + item) + "&"; });
        if (filter_BannerIds !== undefined && filter_BannerIds !== null)
            filter_BannerIds && filter_BannerIds.forEach(item => { url_ += "Filter.BannerIds=" + encodeURIComponent("" + item) + "&"; });
        if (filter_HierarchyLevelId !== undefined && filter_HierarchyLevelId !== null)
            url_ += "Filter.HierarchyLevelId=" + encodeURIComponent("" + filter_HierarchyLevelId) + "&";
        if (filter_HierarchyMemberIds !== undefined && filter_HierarchyMemberIds !== null)
            filter_HierarchyMemberIds && filter_HierarchyMemberIds.forEach(item => { url_ += "Filter.HierarchyMemberIds=" + encodeURIComponent("" + item) + "&"; });
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWattLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWattLocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfLocationsFilteredResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfLocationsFilteredResult>;
        }));
    }

    protected processGetWattLocations(response: HttpResponseBase): Observable<LimitedResultOfLocationsFilteredResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfLocationsFilteredResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfLocationsFilteredResult>(null as any);
    }

    getLocationSummaryByLocationId(locationId: string): Observable<LocationSummary> {
        let url_ = this.baseUrl + "/client/v1/locations/{locationId}/summary";
        if (locationId === undefined || locationId === null)
            throw new globalThis.Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationSummaryByLocationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationSummaryByLocationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationSummary>;
        }));
    }

    protected processGetLocationSummaryByLocationId(response: HttpResponseBase): Observable<LocationSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationSummary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationSummary>(null as any);
    }

    getLocationByStoreNumber(number?: string | null | undefined): Observable<LocationSummary> {
        let url_ = this.baseUrl + "/client/v1/locations/getlocationbystorenumber?";
        if (number !== undefined && number !== null)
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationByStoreNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationByStoreNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationSummary>;
        }));
    }

    protected processGetLocationByStoreNumber(response: HttpResponseBase): Observable<LocationSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationSummary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationSummary>(null as any);
    }

    getMapLocations(startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined): Observable<MapLocation[]> {
        let url_ = this.baseUrl + "/client/v1/locations/map-location?";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMapLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMapLocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MapLocation[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MapLocation[]>;
        }));
    }

    protected processGetMapLocations(response: HttpResponseBase): Observable<MapLocation[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MapLocation.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MapLocation[]>(null as any);
    }

    getLocationsVisits(number: string, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined): Observable<CheckInSummary[]> {
        let url_ = this.baseUrl + "/client/v1/locations/{number}/visits?";
        if (number === undefined || number === null)
            throw new globalThis.Error("The parameter 'number' must be defined.");
        url_ = url_.replace("{number}", encodeURIComponent("" + number));
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationsVisits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationsVisits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckInSummary[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckInSummary[]>;
        }));
    }

    protected processGetLocationsVisits(response: HttpResponseBase): Observable<CheckInSummary[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckInSummary.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckInSummary[]>(null as any);
    }

    getVisitsByDay(banners?: string[] | null | undefined, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined): Observable<DailyVisitsSummary[]> {
        let url_ = this.baseUrl + "/client/v1/locations/visits-summary?";
        if (banners !== undefined && banners !== null)
            banners && banners.forEach(item => { url_ += "Banners=" + encodeURIComponent("" + item) + "&"; });
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVisitsByDay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVisitsByDay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DailyVisitsSummary[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DailyVisitsSummary[]>;
        }));
    }

    protected processGetVisitsByDay(response: HttpResponseBase): Observable<DailyVisitsSummary[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DailyVisitsSummary.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DailyVisitsSummary[]>(null as any);
    }

    getLocationsTimeSummary(number: string, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined): Observable<LocationTimeSummary> {
        let url_ = this.baseUrl + "/client/v1/locations/{number}/hours-summary?";
        if (number === undefined || number === null)
            throw new globalThis.Error("The parameter 'number' must be defined.");
        url_ = url_.replace("{number}", encodeURIComponent("" + number));
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationsTimeSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationsTimeSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationTimeSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationTimeSummary>;
        }));
    }

    protected processGetLocationsTimeSummary(response: HttpResponseBase): Observable<LocationTimeSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationTimeSummary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationTimeSummary>(null as any);
    }

    getLocationVisitSummary(number: string, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined): Observable<LocationVisitSummary> {
        let url_ = this.baseUrl + "/client/v1/locations/{number}/visits-summary?";
        if (number === undefined || number === null)
            throw new globalThis.Error("The parameter 'number' must be defined.");
        url_ = url_.replace("{number}", encodeURIComponent("" + number));
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationVisitSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationVisitSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationVisitSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationVisitSummary>;
        }));
    }

    protected processGetLocationVisitSummary(response: HttpResponseBase): Observable<LocationVisitSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationVisitSummary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationVisitSummary>(null as any);
    }

    getRecentRepsSummary(number: string, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined): Observable<CheckInSummary[]> {
        let url_ = this.baseUrl + "/client/v1/locations/{number}/recent-reps-summary?";
        if (number === undefined || number === null)
            throw new globalThis.Error("The parameter 'number' must be defined.");
        url_ = url_.replace("{number}", encodeURIComponent("" + number));
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentRepsSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentRepsSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckInSummary[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckInSummary[]>;
        }));
    }

    protected processGetRecentRepsSummary(response: HttpResponseBase): Observable<CheckInSummary[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckInSummary.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckInSummary[]>(null as any);
    }

    getRepsInStoreSummary(number: string): Observable<CheckInSummary[]> {
        let url_ = this.baseUrl + "/client/v1/locations/{number}/reps-instore-summary";
        if (number === undefined || number === null)
            throw new globalThis.Error("The parameter 'number' must be defined.");
        url_ = url_.replace("{number}", encodeURIComponent("" + number));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRepsInStoreSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRepsInStoreSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckInSummary[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckInSummary[]>;
        }));
    }

    protected processGetRepsInStoreSummary(response: HttpResponseBase): Observable<CheckInSummary[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CheckInSummary.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckInSummary[]>(null as any);
    }

    getStoreNumberFilterText(searchFilterText?: string | null | undefined): Observable<DropDownModel[]> {
        let url_ = this.baseUrl + "/client/v1/locations/filterstorenumber?";
        if (searchFilterText !== undefined && searchFilterText !== null)
            url_ += "searchFilterText=" + encodeURIComponent("" + searchFilterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStoreNumberFilterText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStoreNumberFilterText(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDownModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDownModel[]>;
        }));
    }

    protected processGetStoreNumberFilterText(response: HttpResponseBase): Observable<DropDownModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownModel[]>(null as any);
    }

    getLocationsByQuery(query?: string | null | undefined, exact?: boolean | undefined): Observable<LocationDropdown[]> {
        let url_ = this.baseUrl + "/client/v1/locations/getlocationsbyquery?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (exact === null)
            throw new globalThis.Error("The parameter 'exact' cannot be null.");
        else if (exact !== undefined)
            url_ += "exact=" + encodeURIComponent("" + exact) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationsByQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationsByQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationDropdown[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationDropdown[]>;
        }));
    }

    protected processGetLocationsByQuery(response: HttpResponseBase): Observable<LocationDropdown[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationDropdown.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationDropdown[]>(null as any);
    }

    getLocationsForSupplierSignage(): Observable<SupplierSignageLocationViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/locations/getlocationsforsuppliersignage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationsForSupplierSignage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationsForSupplierSignage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplierSignageLocationViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplierSignageLocationViewModel[]>;
        }));
    }

    protected processGetLocationsForSupplierSignage(response: HttpResponseBase): Observable<SupplierSignageLocationViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SupplierSignageLocationViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplierSignageLocationViewModel[]>(null as any);
    }

    downloadAllLocations(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/locations/downloadalllocations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAllLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAllLocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadAllLocations(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    exportFeature(onlyRepsInStore?: boolean | undefined, storesInEmergencyState?: boolean | undefined, locationIds?: number[] | null | undefined, wattLocationIDs?: string[] | null | undefined, locationTypeDescriptions?: string[] | null | undefined, locationOpenStatusDescriptions?: string[] | null | undefined, groupId?: number | null | undefined, groupValues?: string[] | null | undefined, features?: string[] | null | undefined, sortColumn?: string | null | undefined, ascending?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, filterText?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/locations/exportfeature?";
        if (onlyRepsInStore === null)
            throw new globalThis.Error("The parameter 'onlyRepsInStore' cannot be null.");
        else if (onlyRepsInStore !== undefined)
            url_ += "OnlyRepsInStore=" + encodeURIComponent("" + onlyRepsInStore) + "&";
        if (storesInEmergencyState === null)
            throw new globalThis.Error("The parameter 'storesInEmergencyState' cannot be null.");
        else if (storesInEmergencyState !== undefined)
            url_ += "StoresInEmergencyState=" + encodeURIComponent("" + storesInEmergencyState) + "&";
        if (locationIds !== undefined && locationIds !== null)
            locationIds && locationIds.forEach(item => { url_ += "LocationIds=" + encodeURIComponent("" + item) + "&"; });
        if (wattLocationIDs !== undefined && wattLocationIDs !== null)
            wattLocationIDs && wattLocationIDs.forEach(item => { url_ += "WattLocationIDs=" + encodeURIComponent("" + item) + "&"; });
        if (locationTypeDescriptions !== undefined && locationTypeDescriptions !== null)
            locationTypeDescriptions && locationTypeDescriptions.forEach(item => { url_ += "LocationTypeDescriptions=" + encodeURIComponent("" + item) + "&"; });
        if (locationOpenStatusDescriptions !== undefined && locationOpenStatusDescriptions !== null)
            locationOpenStatusDescriptions && locationOpenStatusDescriptions.forEach(item => { url_ += "LocationOpenStatusDescriptions=" + encodeURIComponent("" + item) + "&"; });
        if (groupId !== undefined && groupId !== null)
            url_ += "GroupId=" + encodeURIComponent("" + groupId) + "&";
        if (groupValues !== undefined && groupValues !== null)
            groupValues && groupValues.forEach(item => { url_ += "GroupValues=" + encodeURIComponent("" + item) + "&"; });
        if (features !== undefined && features !== null)
            features && features.forEach(item => { url_ += "Features=" + encodeURIComponent("" + item) + "&"; });
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (ascending === null)
            throw new globalThis.Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "Ascending=" + encodeURIComponent("" + ascending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportFeature(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportFeature(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportFeature(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    importLocationFeatures(pageName?: string | null | undefined, file?: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/locations/importlocationfeatures?";
        if (pageName !== undefined && pageName !== null)
            url_ += "pageName=" + encodeURIComponent("" + pageName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportLocationFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportLocationFeatures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportLocationFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = IncidentException.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    exportWirelessServiceProvider(onlyRepsInStore?: boolean | undefined, storesInEmergencyState?: boolean | undefined, locationIds?: number[] | null | undefined, wattLocationIDs?: string[] | null | undefined, locationTypeDescriptions?: string[] | null | undefined, locationOpenStatusDescriptions?: string[] | null | undefined, groupId?: number | null | undefined, groupValues?: string[] | null | undefined, features?: string[] | null | undefined, sortColumn?: string | null | undefined, ascending?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, filterText?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/locations/exportwirelessserviceprovider?";
        if (onlyRepsInStore === null)
            throw new globalThis.Error("The parameter 'onlyRepsInStore' cannot be null.");
        else if (onlyRepsInStore !== undefined)
            url_ += "OnlyRepsInStore=" + encodeURIComponent("" + onlyRepsInStore) + "&";
        if (storesInEmergencyState === null)
            throw new globalThis.Error("The parameter 'storesInEmergencyState' cannot be null.");
        else if (storesInEmergencyState !== undefined)
            url_ += "StoresInEmergencyState=" + encodeURIComponent("" + storesInEmergencyState) + "&";
        if (locationIds !== undefined && locationIds !== null)
            locationIds && locationIds.forEach(item => { url_ += "LocationIds=" + encodeURIComponent("" + item) + "&"; });
        if (wattLocationIDs !== undefined && wattLocationIDs !== null)
            wattLocationIDs && wattLocationIDs.forEach(item => { url_ += "WattLocationIDs=" + encodeURIComponent("" + item) + "&"; });
        if (locationTypeDescriptions !== undefined && locationTypeDescriptions !== null)
            locationTypeDescriptions && locationTypeDescriptions.forEach(item => { url_ += "LocationTypeDescriptions=" + encodeURIComponent("" + item) + "&"; });
        if (locationOpenStatusDescriptions !== undefined && locationOpenStatusDescriptions !== null)
            locationOpenStatusDescriptions && locationOpenStatusDescriptions.forEach(item => { url_ += "LocationOpenStatusDescriptions=" + encodeURIComponent("" + item) + "&"; });
        if (groupId !== undefined && groupId !== null)
            url_ += "GroupId=" + encodeURIComponent("" + groupId) + "&";
        if (groupValues !== undefined && groupValues !== null)
            groupValues && groupValues.forEach(item => { url_ += "GroupValues=" + encodeURIComponent("" + item) + "&"; });
        if (features !== undefined && features !== null)
            features && features.forEach(item => { url_ += "Features=" + encodeURIComponent("" + item) + "&"; });
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (ascending === null)
            throw new globalThis.Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "Ascending=" + encodeURIComponent("" + ascending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportWirelessServiceProvider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportWirelessServiceProvider(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportWirelessServiceProvider(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    importLocationWirelessServiceProviders(pageName?: string | null | undefined, file?: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/locations/importlocationwirelessserviceproviders?";
        if (pageName !== undefined && pageName !== null)
            url_ += "pageName=" + encodeURIComponent("" + pageName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportLocationWirelessServiceProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportLocationWirelessServiceProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportLocationWirelessServiceProviders(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = IncidentException.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getLocationAddress(number: string): Observable<Address> {
        let url_ = this.baseUrl + "/client/v1/locations/getlocationaddress/{number}";
        if (number === undefined || number === null)
            throw new globalThis.Error("The parameter 'number' must be defined.");
        url_ = url_.replace("{number}", encodeURIComponent("" + number));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Address>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Address>;
        }));
    }

    protected processGetLocationAddress(response: HttpResponseBase): Observable<Address> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Address.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Address>(null as any);
    }

    getGroups(accountId: number): Observable<string[]> {
        let url_ = this.baseUrl + "/client/v1/locations/groups/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetGroups(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    setGroups(accountId: number, groupNames?: string[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/locations/groups/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(groupNames);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetGroups(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    uploadGroupValues(accountId: number, pageName?: string | null | undefined, file?: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/locations/groups/{accountId}/import?";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (pageName !== undefined && pageName !== null)
            url_ += "pageName=" + encodeURIComponent("" + pageName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadGroupValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadGroupValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadGroupValues(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    exportGroupValues(accountId: number, onlyStoresVisitedByAccount?: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/locations/groups/{accountId}/export?";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (onlyStoresVisitedByAccount === null)
            throw new globalThis.Error("The parameter 'onlyStoresVisitedByAccount' cannot be null.");
        else if (onlyStoresVisitedByAccount !== undefined)
            url_ += "onlyStoresVisitedByAccount=" + encodeURIComponent("" + onlyStoresVisitedByAccount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportGroupValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportGroupValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportGroupValues(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getLocationGroupingVoltSystemsHeaders(): Observable<string[]> {
        let url_ = this.baseUrl + "/client/v1/locations/groups/volt-header-names";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationGroupingVoltSystemsHeaders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationGroupingVoltSystemsHeaders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetLocationGroupingVoltSystemsHeaders(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    getGroupNamesForEachAccount(): Observable<{ [key: string]: AccountLocationGroupNameDropdown[]; }> {
        let url_ = this.baseUrl + "/client/v1/locations/groups/by-account";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupNamesForEachAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupNamesForEachAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: AccountLocationGroupNameDropdown[]; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: AccountLocationGroupNameDropdown[]; }>;
        }));
    }

    protected processGetGroupNamesForEachAccount(response: HttpResponseBase): Observable<{ [key: string]: AccountLocationGroupNameDropdown[]; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] ? resultData200[key].map((i: any) => AccountLocationGroupNameDropdown.fromJS(i)) : [];
                }
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{ [key: string]: AccountLocationGroupNameDropdown[]; }>(null as any);
    }

    getGroupValuesForAccount(groupId: number): Observable<string[]> {
        let url_ = this.baseUrl + "/client/v1/locations/groups/{groupId}/values";
        if (groupId === undefined || groupId === null)
            throw new globalThis.Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupValuesForAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupValuesForAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetGroupValuesForAccount(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    getGroupingsForStore(storeNumber: string): Observable<{ [key: string]: { [key: string]: string; }; }> {
        let url_ = this.baseUrl + "/client/v1/locations/groups/by-account/{storeNumber}";
        if (storeNumber === undefined || storeNumber === null)
            throw new globalThis.Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupingsForStore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupingsForStore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: { [key: string]: string; }; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: { [key: string]: string; }; }>;
        }));
    }

    protected processGetGroupingsForStore(response: HttpResponseBase): Observable<{ [key: string]: { [key: string]: string; }; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] !== undefined ? resultData200[key] : {};
                }
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{ [key: string]: { [key: string]: string; }; }>(null as any);
    }

    updateFeatureLocations(storeNumber: string, features?: LocationFeatureParams | null | undefined): Observable<LocationSummary> {
        let url_ = this.baseUrl + "/client/v1/locations/update-features/{storeNumber}";
        if (storeNumber === undefined || storeNumber === null)
            throw new globalThis.Error("The parameter 'storeNumber' must be defined.");
        url_ = url_.replace("{storeNumber}", encodeURIComponent("" + storeNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(features);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFeatureLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFeatureLocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationSummary>;
        }));
    }

    protected processUpdateFeatureLocations(response: HttpResponseBase): Observable<LocationSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationSummary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationSummary>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LocationOpenStatusClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getById(id?: number | undefined): Observable<LocationOpenStatusModel> {
        let url_ = this.baseUrl + "/client/v1/locationopenstatus/getbyid?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationOpenStatusModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationOpenStatusModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<LocationOpenStatusModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationOpenStatusModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationOpenStatusModel>(null as any);
    }

    getFilteredLocationOpenStatusList(sortColumn?: string | null | undefined, ascending?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, filterText?: string | null | undefined): Observable<LimitedResultOfLocationOpenStatusModel> {
        let url_ = this.baseUrl + "/client/v1/locationopenstatus/getlocationopenstatuslist?";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (ascending === null)
            throw new globalThis.Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "Ascending=" + encodeURIComponent("" + ascending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilteredLocationOpenStatusList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilteredLocationOpenStatusList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfLocationOpenStatusModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfLocationOpenStatusModel>;
        }));
    }

    protected processGetFilteredLocationOpenStatusList(response: HttpResponseBase): Observable<LimitedResultOfLocationOpenStatusModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfLocationOpenStatusModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfLocationOpenStatusModel>(null as any);
    }

    getList(): Observable<LocationOpenStatusModel[]> {
        let url_ = this.baseUrl + "/client/v1/locationopenstatus/getlist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationOpenStatusModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationOpenStatusModel[]>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LocationOpenStatusModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationOpenStatusModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationOpenStatusModel[]>(null as any);
    }

    getGroups(): Observable<LocationOpenStatusGroup[]> {
        let url_ = this.baseUrl + "/client/v1/locationopenstatus/getgroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationOpenStatusGroup[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationOpenStatusGroup[]>;
        }));
    }

    protected processGetGroups(response: HttpResponseBase): Observable<LocationOpenStatusGroup[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationOpenStatusGroup.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationOpenStatusGroup[]>(null as any);
    }

    saveLocationOpenStatus(locationOpenStatus?: LocationOpenStatusModel | null | undefined): Observable<LocationOpenStatusModel> {
        let url_ = this.baseUrl + "/client/v1/locationopenstatus/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(locationOpenStatus);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveLocationOpenStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveLocationOpenStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationOpenStatusModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationOpenStatusModel>;
        }));
    }

    protected processSaveLocationOpenStatus(response: HttpResponseBase): Observable<LocationOpenStatusModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationOpenStatusModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationOpenStatusModel>(null as any);
    }

    getAllStatusList(): Observable<DropDownModel[]> {
        let url_ = this.baseUrl + "/client/v1/locationopenstatus/statuslist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStatusList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStatusList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropDownModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropDownModel[]>;
        }));
    }

    protected processGetAllStatusList(response: HttpResponseBase): Observable<DropDownModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropDownModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DropDownModel[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class GlobalSearchClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getGlobalSearchHistory(): Observable<GlobalSearchHistoryViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/globalsearch/history";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGlobalSearchHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGlobalSearchHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlobalSearchHistoryViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlobalSearchHistoryViewModel[]>;
        }));
    }

    protected processGetGlobalSearchHistory(response: HttpResponseBase): Observable<GlobalSearchHistoryViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GlobalSearchHistoryViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GlobalSearchHistoryViewModel[]>(null as any);
    }

    saveSearchHistory(search?: string | null | undefined, route?: string | null | undefined): Observable<GlobalSearchHistoryViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/globalsearch/history?";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (route !== undefined && route !== null)
            url_ += "route=" + encodeURIComponent("" + route) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSearchHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSearchHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlobalSearchHistoryViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlobalSearchHistoryViewModel[]>;
        }));
    }

    protected processSaveSearchHistory(response: HttpResponseBase): Observable<GlobalSearchHistoryViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GlobalSearchHistoryViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GlobalSearchHistoryViewModel[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class GlobalFilterClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    retrieve(userId: string): Observable<GlobalFilterViewModel> {
        let url_ = this.baseUrl + "/client/v1/globalfilter/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieve(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieve(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlobalFilterViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlobalFilterViewModel>;
        }));
    }

    protected processRetrieve(response: HttpResponseBase): Observable<GlobalFilterViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GlobalFilterViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GlobalFilterViewModel>(null as any);
    }

    create(createGlobalFilterViewModel?: CreateGlobalFilterViewModel | null | undefined): Observable<GlobalFilterViewModel> {
        let url_ = this.baseUrl + "/client/v1/globalfilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createGlobalFilterViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlobalFilterViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlobalFilterViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<GlobalFilterViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = GlobalFilterViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GlobalFilterViewModel>(null as any);
    }

    update(updateGlobalFilterViewModel?: UpdateGlobalFilterViewModel | null | undefined): Observable<GlobalFilterViewModel> {
        let url_ = this.baseUrl + "/client/v1/globalfilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateGlobalFilterViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlobalFilterViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlobalFilterViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<GlobalFilterViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GlobalFilterViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GlobalFilterViewModel>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FeedbackClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getFeedbackSummary(storeLocation?: string | null | undefined, component?: string | null | undefined, departments?: string[] | null | undefined, activities?: string[] | null | undefined): Observable<FeedbackTaskSummary[]> {
        let url_ = this.baseUrl + "/client/v1/feedback/summary?";
        if (storeLocation !== undefined && storeLocation !== null)
            url_ += "storeLocation=" + encodeURIComponent("" + storeLocation) + "&";
        if (component !== undefined && component !== null)
            url_ += "component=" + encodeURIComponent("" + component) + "&";
        if (departments !== undefined && departments !== null)
            departments && departments.forEach(item => { url_ += "department=" + encodeURIComponent("" + item) + "&"; });
        if (activities !== undefined && activities !== null)
            activities && activities.forEach(item => { url_ += "activity=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFeedbackSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeedbackSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeedbackTaskSummary[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeedbackTaskSummary[]>;
        }));
    }

    protected processGetFeedbackSummary(response: HttpResponseBase): Observable<FeedbackTaskSummary[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FeedbackTaskSummary.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeedbackTaskSummary[]>(null as any);
    }

    addFeedback(model?: FeedbackModel | null | undefined): Observable<FeedbackModel> {
        let url_ = this.baseUrl + "/client/v1/feedback/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddFeedback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFeedback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeedbackModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeedbackModel>;
        }));
    }

    protected processAddFeedback(response: HttpResponseBase): Observable<FeedbackModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeedbackModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeedbackModel>(null as any);
    }

    addFeedbackV2(model?: FeedbackV2Model | null | undefined): Observable<FeedbackV2Model> {
        let url_ = this.baseUrl + "/client/v1/feedback/add/v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddFeedbackV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFeedbackV2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeedbackV2Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeedbackV2Model>;
        }));
    }

    protected processAddFeedbackV2(response: HttpResponseBase): Observable<FeedbackV2Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeedbackV2Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeedbackV2Model>(null as any);
    }

    getFeedbackResponseCount(reportType?: FeedbackReportType | undefined, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/client/v1/feedback/response-count?";
        if (reportType === null)
            throw new globalThis.Error("The parameter 'reportType' cannot be null.");
        else if (reportType !== undefined)
            url_ += "reportType=" + encodeURIComponent("" + reportType) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFeedbackResponseCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeedbackResponseCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetFeedbackResponseCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    getFeedbackResponseReport(reportType?: FeedbackReportType | undefined, filterText?: string | null | undefined, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined): Observable<FeedbackReportItem[]> {
        let url_ = this.baseUrl + "/client/v1/feedback/response-report?";
        if (reportType === null)
            throw new globalThis.Error("The parameter 'reportType' cannot be null.");
        else if (reportType !== undefined)
            url_ += "reportType=" + encodeURIComponent("" + reportType) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFeedbackResponseReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeedbackResponseReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeedbackReportItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeedbackReportItem[]>;
        }));
    }

    protected processGetFeedbackResponseReport(response: HttpResponseBase): Observable<FeedbackReportItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FeedbackReportItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeedbackReportItem[]>(null as any);
    }

    getStoreFeedbackList(sortColumn?: string | null | undefined, ascending?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, filterText?: string | null | undefined, reportType?: FeedbackReportType | undefined, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined): Observable<FeedbackReportOfFeedbackReportItem> {
        let url_ = this.baseUrl + "/client/v1/feedback/feedbacklist?";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (ascending === null)
            throw new globalThis.Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "Ascending=" + encodeURIComponent("" + ascending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (reportType === null)
            throw new globalThis.Error("The parameter 'reportType' cannot be null.");
        else if (reportType !== undefined)
            url_ += "reportType=" + encodeURIComponent("" + reportType) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStoreFeedbackList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStoreFeedbackList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeedbackReportOfFeedbackReportItem>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeedbackReportOfFeedbackReportItem>;
        }));
    }

    protected processGetStoreFeedbackList(response: HttpResponseBase): Observable<FeedbackReportOfFeedbackReportItem> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeedbackReportOfFeedbackReportItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeedbackReportOfFeedbackReportItem>(null as any);
    }

    getFeedbackReport(offset?: number | undefined, limit?: number | undefined, accountId?: number | null | undefined, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined, activities?: string[] | null | undefined, departments?: string[] | null | undefined, reasons?: string[] | null | undefined, storeNumbers?: string[] | null | undefined, type?: FeedbackReportType | null | undefined, searchTaskName?: string | null | undefined, sortBy?: string | null | undefined, ascending?: boolean | undefined): Observable<FeedbackReportViewModel> {
        let url_ = this.baseUrl + "/client/v1/feedback/feedback-report?";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (accountId !== undefined && accountId !== null)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (activities !== undefined && activities !== null)
            activities && activities.forEach(item => { url_ += "Activities=" + encodeURIComponent("" + item) + "&"; });
        if (departments !== undefined && departments !== null)
            departments && departments.forEach(item => { url_ += "Departments=" + encodeURIComponent("" + item) + "&"; });
        if (reasons !== undefined && reasons !== null)
            reasons && reasons.forEach(item => { url_ += "Reasons=" + encodeURIComponent("" + item) + "&"; });
        if (storeNumbers !== undefined && storeNumbers !== null)
            storeNumbers && storeNumbers.forEach(item => { url_ += "StoreNumbers=" + encodeURIComponent("" + item) + "&"; });
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (searchTaskName !== undefined && searchTaskName !== null)
            url_ += "SearchTaskName=" + encodeURIComponent("" + searchTaskName) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (ascending === null)
            throw new globalThis.Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "Ascending=" + encodeURIComponent("" + ascending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFeedbackReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeedbackReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeedbackReportViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeedbackReportViewModel>;
        }));
    }

    protected processGetFeedbackReport(response: HttpResponseBase): Observable<FeedbackReportViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeedbackReportViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeedbackReportViewModel>(null as any);
    }

    export(accountId?: number | null | undefined, startDate?: moment.Moment | null | undefined, endDate?: moment.Moment | null | undefined, activities?: string[] | null | undefined, departments?: string[] | null | undefined, reasons?: string[] | null | undefined, storeNumbers?: string[] | null | undefined, type?: FeedbackReportType | null | undefined, searchTaskName?: string | null | undefined, sortBy?: string | null | undefined, ascending?: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/feedback/export?";
        if (accountId !== undefined && accountId !== null)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (activities !== undefined && activities !== null)
            activities && activities.forEach(item => { url_ += "Activities=" + encodeURIComponent("" + item) + "&"; });
        if (departments !== undefined && departments !== null)
            departments && departments.forEach(item => { url_ += "Departments=" + encodeURIComponent("" + item) + "&"; });
        if (reasons !== undefined && reasons !== null)
            reasons && reasons.forEach(item => { url_ += "Reasons=" + encodeURIComponent("" + item) + "&"; });
        if (storeNumbers !== undefined && storeNumbers !== null)
            storeNumbers && storeNumbers.forEach(item => { url_ += "StoreNumbers=" + encodeURIComponent("" + item) + "&"; });
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (searchTaskName !== undefined && searchTaskName !== null)
            url_ += "SearchTaskName=" + encodeURIComponent("" + searchTaskName) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (ascending === null)
            throw new globalThis.Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "Ascending=" + encodeURIComponent("" + ascending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FaqClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getFaqByRoleList(banner?: string | null | undefined): Observable<FaqViewModel> {
        let url_ = this.baseUrl + "/client/v1/faq/getfaqbyrolelist?";
        if (banner !== undefined && banner !== null)
            url_ += "banner=" + encodeURIComponent("" + banner) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFaqByRoleList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFaqByRoleList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FaqViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FaqViewModel>;
        }));
    }

    protected processGetFaqByRoleList(response: HttpResponseBase): Observable<FaqViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FaqViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FaqViewModel>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ExceptionReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getExceptionReportTypes(): Observable<ExceptionReportTypes[]> {
        let url_ = this.baseUrl + "/client/v1/reports/exceptions/types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExceptionReportTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExceptionReportTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExceptionReportTypes[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExceptionReportTypes[]>;
        }));
    }

    protected processGetExceptionReportTypes(response: HttpResponseBase): Observable<ExceptionReportTypes[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExceptionReportTypes[]>(null as any);
    }

    getExceptions(filter?: ExceptionReportFilterParams | null | undefined, offset?: number | undefined, limit?: number | undefined): Observable<LimitedResultOfExceptionReportViewModel> {
        let url_ = this.baseUrl + "/client/v1/reports/exceptions?";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExceptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExceptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfExceptionReportViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfExceptionReportViewModel>;
        }));
    }

    protected processGetExceptions(response: HttpResponseBase): Observable<LimitedResultOfExceptionReportViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfExceptionReportViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfExceptionReportViewModel>(null as any);
    }

    export(filter?: ExceptionReportFilterParams | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/reports/exceptions/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EventsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getVendorLogReport(accountIds?: (number | null)[] | null | undefined, logStartDate?: moment.Moment | null | undefined, logEndDate?: moment.Moment | null | undefined, lNumber?: string | null | undefined, tagIds?: number[] | null | undefined, sortColumn?: string | null | undefined, ascending?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, filterText?: string | null | undefined): Observable<LimitedResultOfVendorLogReportViewModel> {
        let url_ = this.baseUrl + "/client/v1/events/vendorlogreport?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (logStartDate !== undefined && logStartDate !== null)
            url_ += "LogStartDate=" + encodeURIComponent(logStartDate ? "" + logStartDate.toISOString() : "") + "&";
        if (logEndDate !== undefined && logEndDate !== null)
            url_ += "LogEndDate=" + encodeURIComponent(logEndDate ? "" + logEndDate.toISOString() : "") + "&";
        if (lNumber !== undefined && lNumber !== null)
            url_ += "LNumber=" + encodeURIComponent("" + lNumber) + "&";
        if (tagIds !== undefined && tagIds !== null)
            tagIds && tagIds.forEach(item => { url_ += "TagIds=" + encodeURIComponent("" + item) + "&"; });
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (ascending === null)
            throw new globalThis.Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "Ascending=" + encodeURIComponent("" + ascending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVendorLogReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorLogReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfVendorLogReportViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfVendorLogReportViewModel>;
        }));
    }

    protected processGetVendorLogReport(response: HttpResponseBase): Observable<LimitedResultOfVendorLogReportViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfVendorLogReportViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfVendorLogReportViewModel>(null as any);
    }

    exportVendorLog(accountIds?: (number | null)[] | null | undefined, logStartDate?: moment.Moment | null | undefined, logEndDate?: moment.Moment | null | undefined, lNumber?: string | null | undefined, tagIds?: number[] | null | undefined, sortColumn?: string | null | undefined, ascending?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, filterText?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/events/vendorlogreportexport?";
        if (accountIds !== undefined && accountIds !== null)
            accountIds && accountIds.forEach(item => { url_ += "AccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (logStartDate !== undefined && logStartDate !== null)
            url_ += "LogStartDate=" + encodeURIComponent(logStartDate ? "" + logStartDate.toISOString() : "") + "&";
        if (logEndDate !== undefined && logEndDate !== null)
            url_ += "LogEndDate=" + encodeURIComponent(logEndDate ? "" + logEndDate.toISOString() : "") + "&";
        if (lNumber !== undefined && lNumber !== null)
            url_ += "LNumber=" + encodeURIComponent("" + lNumber) + "&";
        if (tagIds !== undefined && tagIds !== null)
            tagIds && tagIds.forEach(item => { url_ += "TagIds=" + encodeURIComponent("" + item) + "&"; });
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (ascending === null)
            throw new globalThis.Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "Ascending=" + encodeURIComponent("" + ascending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportVendorLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportVendorLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportVendorLog(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EmergencyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    uploadEmergencies(pageName?: string | null | undefined, file?: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/emergency?";
        if (pageName !== undefined && pageName !== null)
            url_ += "pageName=" + encodeURIComponent("" + pageName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadEmergencies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadEmergencies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadEmergencies(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CommunicationsCategoryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getCategories(): Observable<CommunicationCategoryViewModel[]> {
        let url_ = this.baseUrl + "/communications/categories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommunicationCategoryViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommunicationCategoryViewModel[]>;
        }));
    }

    protected processGetCategories(response: HttpResponseBase): Observable<CommunicationCategoryViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommunicationCategoryViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommunicationCategoryViewModel[]>(null as any);
    }

    getAccountCategories(accountId: number): Observable<CommunicationsAccountCategoryViewModel[]> {
        let url_ = this.baseUrl + "/communications/account/{accountId}/categories";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommunicationsAccountCategoryViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommunicationsAccountCategoryViewModel[]>;
        }));
    }

    protected processGetAccountCategories(response: HttpResponseBase): Observable<CommunicationsAccountCategoryViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommunicationsAccountCategoryViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommunicationsAccountCategoryViewModel[]>(null as any);
    }

    updateAccountCategories(accountId: number, categoryId: number, fieldEmployee?: boolean | undefined, providerAdmin?: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/communications/account/{accountId}/category/{categoryId}?";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (categoryId === undefined || categoryId === null)
            throw new globalThis.Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        if (fieldEmployee === null)
            throw new globalThis.Error("The parameter 'fieldEmployee' cannot be null.");
        else if (fieldEmployee !== undefined)
            url_ += "fieldEmployee=" + encodeURIComponent("" + fieldEmployee) + "&";
        if (providerAdmin === null)
            throw new globalThis.Error("The parameter 'providerAdmin' cannot be null.");
        else if (providerAdmin !== undefined)
            url_ += "providerAdmin=" + encodeURIComponent("" + providerAdmin) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAccountCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAccountCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAccountCategories(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CommunicationsHistoryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    get(offset?: number | undefined, limit?: number | undefined, sortBy?: string | null | undefined, sortAscending?: boolean | undefined): Observable<LimitedResultOfMassCommunicationsLogViewModel> {
        let url_ = this.baseUrl + "/communications/history?";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortAscending === null)
            throw new globalThis.Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfMassCommunicationsLogViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfMassCommunicationsLogViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<LimitedResultOfMassCommunicationsLogViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfMassCommunicationsLogViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfMassCommunicationsLogViewModel>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CommunicationsSendClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    send(sendCommunicationsViewModel?: SendCommunicationsViewModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/communications/send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sendCommunicationsViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSend(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSend(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfException.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getNumberOfRecipients(sendCommunicationsViewModel?: SendCommunicationsViewModel | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/communications/send/count";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sendCommunicationsViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumberOfRecipients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberOfRecipients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetNumberOfRecipients(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    uploadAttachment(file?: FileParameter | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/communications/send/attachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadAttachment(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfFileUploadErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    deleteAttachment(fileName?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/communications/send/attachment?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAttachment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CommunicationsTemplatesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    get(name?: string | null | undefined): Observable<CommunicationsTemplateViewModel> {
        let url_ = this.baseUrl + "/communications/templates?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommunicationsTemplateViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommunicationsTemplateViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CommunicationsTemplateViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommunicationsTemplateViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommunicationsTemplateViewModel>(null as any);
    }

    post(template?: UpdateTemplateViewModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/communications/templates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(template);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    delete(name?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/communications/templates?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getAll(): Observable<CommunicationsTemplateViewModel[]> {
        let url_ = this.baseUrl + "/communications/templates/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommunicationsTemplateViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommunicationsTemplateViewModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CommunicationsTemplateViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommunicationsTemplateViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommunicationsTemplateViewModel[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BadgeTransactionAuditClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getBadgeCountByApprovalStatus(approvalStatusId?: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/client/v1/badge/getbadgecountbyapprovalstatus?";
        if (approvalStatusId === null)
            throw new globalThis.Error("The parameter 'approvalStatusId' cannot be null.");
        else if (approvalStatusId !== undefined)
            url_ += "approvalStatusId=" + encodeURIComponent("" + approvalStatusId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBadgeCountByApprovalStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBadgeCountByApprovalStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetBadgeCountByApprovalStatus(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserAuditClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getUserAuditSources(): Observable<UserAuditChangeSource[]> {
        let url_ = this.baseUrl + "/client/v1/useraudit/getsources";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAuditSources(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAuditSources(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAuditChangeSource[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAuditChangeSource[]>;
        }));
    }

    protected processGetUserAuditSources(response: HttpResponseBase): Observable<UserAuditChangeSource[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserAuditChangeSource[]>(null as any);
    }

    getUserAuditChangeLogs(accountId?: string | null | undefined, dateRange_StartDate?: moment.Moment | null | undefined, dateRange_EndDate?: moment.Moment | null | undefined, changeSource?: UserAuditChangeSource | null | undefined, userId?: string | null | undefined, searchMatches?: (number | null)[] | null | undefined, offset?: number | undefined, limit?: number | undefined): Observable<LimitedResultOfUserAuditLogChangeViewModel> {
        let url_ = this.baseUrl + "/client/v1/useraudit/getchangelogs?";
        if (accountId !== undefined && accountId !== null)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (dateRange_StartDate !== undefined && dateRange_StartDate !== null)
            url_ += "DateRange.StartDate=" + encodeURIComponent(dateRange_StartDate ? "" + dateRange_StartDate.toISOString() : "") + "&";
        if (dateRange_EndDate !== undefined && dateRange_EndDate !== null)
            url_ += "DateRange.EndDate=" + encodeURIComponent(dateRange_EndDate ? "" + dateRange_EndDate.toISOString() : "") + "&";
        if (changeSource !== undefined && changeSource !== null)
            url_ += "ChangeSource=" + encodeURIComponent("" + changeSource) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (searchMatches !== undefined && searchMatches !== null)
            searchMatches && searchMatches.forEach(item => { url_ += "SearchMatches=" + encodeURIComponent("" + item) + "&"; });
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAuditChangeLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAuditChangeLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfUserAuditLogChangeViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfUserAuditLogChangeViewModel>;
        }));
    }

    protected processGetUserAuditChangeLogs(response: HttpResponseBase): Observable<LimitedResultOfUserAuditLogChangeViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfUserAuditLogChangeViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfUserAuditLogChangeViewModel>(null as any);
    }

    export(accountId?: string | null | undefined, dateRange_StartDate?: moment.Moment | null | undefined, dateRange_EndDate?: moment.Moment | null | undefined, changeSource?: UserAuditChangeSource | null | undefined, userId?: string | null | undefined, searchMatches?: (number | null)[] | null | undefined, offset?: number | undefined, limit?: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/useraudit/export?";
        if (accountId !== undefined && accountId !== null)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (dateRange_StartDate !== undefined && dateRange_StartDate !== null)
            url_ += "DateRange.StartDate=" + encodeURIComponent(dateRange_StartDate ? "" + dateRange_StartDate.toISOString() : "") + "&";
        if (dateRange_EndDate !== undefined && dateRange_EndDate !== null)
            url_ += "DateRange.EndDate=" + encodeURIComponent(dateRange_EndDate ? "" + dateRange_EndDate.toISOString() : "") + "&";
        if (changeSource !== undefined && changeSource !== null)
            url_ += "ChangeSource=" + encodeURIComponent("" + changeSource) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (searchMatches !== undefined && searchMatches !== null)
            searchMatches && searchMatches.forEach(item => { url_ += "SearchMatches=" + encodeURIComponent("" + item) + "&"; });
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AssemblerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    upload(pageName?: string | null | undefined, file?: FileParameter | null | undefined): Observable<UploadStatus> {
        let url_ = this.baseUrl + "/client/v1/assembler/upload?";
        if (pageName !== undefined && pageName !== null)
            url_ += "pageName=" + encodeURIComponent("" + pageName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadStatus>;
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<UploadStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadStatus.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UploadStatus>(null as any);
    }

    download(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/assembler/download";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownload(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getAssemblerPriceDetails(storeNumber?: string | null | undefined, assemblerPriorityId?: string | null | undefined): Observable<AssemblerPriorityViewModel> {
        let url_ = this.baseUrl + "/client/v1/assembler/getassemblerpricedetails?";
        if (storeNumber !== undefined && storeNumber !== null)
            url_ += "storeNumber=" + encodeURIComponent("" + storeNumber) + "&";
        if (assemblerPriorityId !== undefined && assemblerPriorityId !== null)
            url_ += "assemblerPriorityId=" + encodeURIComponent("" + assemblerPriorityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssemblerPriceDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssemblerPriceDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssemblerPriorityViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssemblerPriorityViewModel>;
        }));
    }

    protected processGetAssemblerPriceDetails(response: HttpResponseBase): Observable<AssemblerPriorityViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssemblerPriorityViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssemblerPriorityViewModel>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AppLicensingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getAppListByAccountId(id?: string | null | undefined): Observable<AppLicensingModel[]> {
        let url_ = this.baseUrl + "/client/v1/applicensing/getapplistbyaccountid?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppListByAccountId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppListByAccountId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppLicensingModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppLicensingModel[]>;
        }));
    }

    protected processGetAppListByAccountId(response: HttpResponseBase): Observable<AppLicensingModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppLicensingModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppLicensingModel[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AppClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getAppList(): Observable<AppModel[]> {
        let url_ = this.baseUrl + "/client/v1/app/getapplist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppModel[]>;
        }));
    }

    protected processGetAppList(response: HttpResponseBase): Observable<AppModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppModel[]>(null as any);
    }

    getAccountAppList(accountId?: number | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/client/v1/getaccountapplist?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountAppList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountAppList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAccountAppList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    setAccountAppList(accountId?: number | undefined, appIds?: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/setaccountapplist?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        if (appIds !== undefined && appIds !== null)
            appIds && appIds.forEach(item => { url_ += "appIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAccountAppList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAccountAppList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAccountAppList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EventSyncClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    sync(id: string): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/eventsync/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSync(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SurveyPostProcessingResultsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    saveAllResults(): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/survey/reindexresults";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAllResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAllResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveAllResults(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    saveAllResults2(templateId: string): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/survey/reindexresults/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAllResults2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAllResults2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveAllResults2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ActionLogClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    searchByTransactionId(accountId: number, transactionId?: string | null | undefined, start?: moment.Moment | undefined, sortColumn?: string | null | undefined, ascending?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, filterText?: string | null | undefined): Observable<ServiceLogReportOfActionLogsViewModel> {
        let url_ = this.baseUrl + "/client/v1/servicelog/{accountId}/transactions?";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (transactionId !== undefined && transactionId !== null)
            url_ += "transactionId=" + encodeURIComponent("" + transactionId) + "&";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (ascending === null)
            throw new globalThis.Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "Ascending=" + encodeURIComponent("" + ascending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchByTransactionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchByTransactionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceLogReportOfActionLogsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceLogReportOfActionLogsViewModel>;
        }));
    }

    protected processSearchByTransactionId(response: HttpResponseBase): Observable<ServiceLogReportOfActionLogsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceLogReportOfActionLogsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ApiErrorOfRequestTokenErrors.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceLogReportOfActionLogsViewModel>(null as any);
    }

    searchByReferenceNumber(accountId: number, referenceNumber?: string | null | undefined, start?: moment.Moment | undefined, sortColumn?: string | null | undefined, ascending?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, filterText?: string | null | undefined): Observable<ServiceLogReportOfActionLogsViewModel> {
        let url_ = this.baseUrl + "/client/v1/servicelog/{accountId}/references?";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (referenceNumber !== undefined && referenceNumber !== null)
            url_ += "referenceNumber=" + encodeURIComponent("" + referenceNumber) + "&";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (ascending === null)
            throw new globalThis.Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "Ascending=" + encodeURIComponent("" + ascending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchByReferenceNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchByReferenceNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceLogReportOfActionLogsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceLogReportOfActionLogsViewModel>;
        }));
    }

    protected processSearchByReferenceNumber(response: HttpResponseBase): Observable<ServiceLogReportOfActionLogsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceLogReportOfActionLogsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ApiErrorOfRequestTokenErrors.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceLogReportOfActionLogsViewModel>(null as any);
    }

    searchByStatusAndType(accountId: number, status?: ImportStatus | undefined, type?: ActionLogType | undefined, start?: moment.Moment | undefined, sortColumn?: string | null | undefined, ascending?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined, filterText?: string | null | undefined): Observable<ServiceLogReportOfActionLogsViewModel> {
        let url_ = this.baseUrl + "/client/v1/servicelog/{accountId}/statuses?";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (ascending === null)
            throw new globalThis.Error("The parameter 'ascending' cannot be null.");
        else if (ascending !== undefined)
            url_ += "Ascending=" + encodeURIComponent("" + ascending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchByStatusAndType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchByStatusAndType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceLogReportOfActionLogsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceLogReportOfActionLogsViewModel>;
        }));
    }

    protected processSearchByStatusAndType(response: HttpResponseBase): Observable<ServiceLogReportOfActionLogsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceLogReportOfActionLogsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ApiErrorOfRequestTokenErrors.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceLogReportOfActionLogsViewModel>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AccountActivityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://walmart-qa-dashboard-api.azurewebsites.net";
    }

    getList(): Observable<AccountActivityModel[]> {
        let url_ = this.baseUrl + "/client/v1/accountactivity/getlist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountActivityModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountActivityModel[]>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<AccountActivityModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountActivityModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountActivityModel[]>(null as any);
    }

    getListByAccountId(accountId?: number | undefined): Observable<AccountActivityModel[]> {
        let url_ = this.baseUrl + "/client/v1/accountactivity/getlistbyaccountid?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListByAccountId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListByAccountId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountActivityModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountActivityModel[]>;
        }));
    }

    protected processGetListByAccountId(response: HttpResponseBase): Observable<AccountActivityModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountActivityModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountActivityModel[]>(null as any);
    }

    getListByActivityId(activityParams?: AccountActivityFilterParams | null | undefined): Observable<LimitedResultOfAccountActivityModel> {
        let url_ = this.baseUrl + "/client/v1/accountactivity/getlistbyactivityid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activityParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListByActivityId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListByActivityId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LimitedResultOfAccountActivityModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LimitedResultOfAccountActivityModel>;
        }));
    }

    protected processGetListByActivityId(response: HttpResponseBase): Observable<LimitedResultOfAccountActivityModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LimitedResultOfAccountActivityModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LimitedResultOfAccountActivityModel>(null as any);
    }

    hasRetailtainmentActivity(accountId?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/client/v1/accountactivity/hasretailtainmentactivity?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasRetailtainmentActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasRetailtainmentActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processHasRetailtainmentActivity(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    saveAccountActivity(accountActivity?: AccountActivityModel | null | undefined): Observable<AccountActivityModel> {
        let url_ = this.baseUrl + "/client/v1/accountactivity/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accountActivity);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAccountActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAccountActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountActivityModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountActivityModel>;
        }));
    }

    protected processSaveAccountActivity(response: HttpResponseBase): Observable<AccountActivityModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountActivityModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountActivityModel>(null as any);
    }

    deleteByIds(accountId?: number | undefined, activityId?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/client/v1/accountactivity/deletebyids?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        if (activityId === null)
            throw new globalThis.Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteByIds(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    addAllActivities(accountId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/accountactivity/addallactivities?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAllActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAllActivities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddAllActivities(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    removeAllActivities(accountId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/client/v1/accountactivity/removeallactivities?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveAllActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveAllActivities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveAllActivities(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getAccountActivityList(): Observable<AccountActivityViewModel[]> {
        let url_ = this.baseUrl + "/client/v1/accountactivity/getaccountactivitylist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountActivityList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountActivityList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountActivityViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountActivityViewModel[]>;
        }));
    }

    protected processGetAccountActivityList(response: HttpResponseBase): Observable<AccountActivityViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountActivityViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiErrorOfRequestTokenErrors.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountActivityViewModel[]>(null as any);
    }

    exportActivities(activityId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/client/v1/accountactivity/exportactivities/{activityId}";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportActivities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportActivities(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export class ProblemDetails implements IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    extensions?: { [key: string]: any; };

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : null as any;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : null as any;
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (this.extensions as any)![key] = _data["extensions"][key] !== undefined ? _data["extensions"][key] : null as any;
                }
            }
            else {
                this.extensions = null as any;
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["detail"] = this.detail !== undefined ? this.detail : null as any;
        data["instance"] = this.instance !== undefined ? this.instance : null as any;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (data["extensions"] as any)[key] = this.extensions[key] !== undefined ? this.extensions[key] : null as any;
            }
        }
        return data;
    }

    clone(): ProblemDetails {
        const json = this.toJSON();
        let result = new ProblemDetails();
        result.init(json);
        return result;
    }
}

export interface IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    extensions?: { [key: string]: any; };

    [key: string]: any;
}

export class ApiError extends ProblemDetails implements IApiError {
    error?: string | null;
    errorKey?: any | null;

    [key: string]: any;

    constructor(data?: IApiError) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.error = _data["error"] !== undefined ? _data["error"] : null as any;
            this.errorKey = _data["errorKey"] !== undefined ? _data["errorKey"] : null as any;
        }
    }

    static override fromJS(data: any): ApiError {
        data = typeof data === 'object' ? data : {};
        let result = new ApiError();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["error"] = this.error !== undefined ? this.error : null as any;
        data["errorKey"] = this.errorKey !== undefined ? this.errorKey : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): ApiError {
        const json = this.toJSON();
        let result = new ApiError();
        result.init(json);
        return result;
    }
}

export interface IApiError extends IProblemDetails {
    error?: string | null;
    errorKey?: any | null;

    [key: string]: any;
}

export class LimitedResultOfActiveDirectoryTagMappingViewModel implements ILimitedResultOfActiveDirectoryTagMappingViewModel {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: ActiveDirectoryTagMappingViewModel[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfActiveDirectoryTagMappingViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ActiveDirectoryTagMappingViewModel.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfActiveDirectoryTagMappingViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfActiveDirectoryTagMappingViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfActiveDirectoryTagMappingViewModel {
        const json = this.toJSON();
        let result = new LimitedResultOfActiveDirectoryTagMappingViewModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfActiveDirectoryTagMappingViewModel {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: ActiveDirectoryTagMappingViewModel[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class ActiveDirectoryTagMappingViewModel implements IActiveDirectoryTagMappingViewModel {
    adGroup?: string | null;
    tagId?: number;
    tagName?: string | null;
    totalUsers?: number;

    constructor(data?: IActiveDirectoryTagMappingViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adGroup = _data["adGroup"] !== undefined ? _data["adGroup"] : null as any;
            this.tagId = _data["tagId"] !== undefined ? _data["tagId"] : null as any;
            this.tagName = _data["tagName"] !== undefined ? _data["tagName"] : null as any;
            this.totalUsers = _data["totalUsers"] !== undefined ? _data["totalUsers"] : null as any;
        }
    }

    static fromJS(data: any): ActiveDirectoryTagMappingViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveDirectoryTagMappingViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adGroup"] = this.adGroup !== undefined ? this.adGroup : null as any;
        data["tagId"] = this.tagId !== undefined ? this.tagId : null as any;
        data["tagName"] = this.tagName !== undefined ? this.tagName : null as any;
        data["totalUsers"] = this.totalUsers !== undefined ? this.totalUsers : null as any;
        return data;
    }

    clone(): ActiveDirectoryTagMappingViewModel {
        const json = this.toJSON();
        let result = new ActiveDirectoryTagMappingViewModel();
        result.init(json);
        return result;
    }
}

export interface IActiveDirectoryTagMappingViewModel {
    adGroup?: string | null;
    tagId?: number;
    tagName?: string | null;
    totalUsers?: number;
}

export class VoltCulture implements IVoltCulture {
    cultureName?: string | null;
    englishName?: string | null;
    nativeName?: string | null;
    twoLetterLanguageCode?: string | null;

    constructor(data?: IVoltCulture) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cultureName = _data["cultureName"] !== undefined ? _data["cultureName"] : null as any;
            this.englishName = _data["englishName"] !== undefined ? _data["englishName"] : null as any;
            this.nativeName = _data["nativeName"] !== undefined ? _data["nativeName"] : null as any;
            this.twoLetterLanguageCode = _data["twoLetterLanguageCode"] !== undefined ? _data["twoLetterLanguageCode"] : null as any;
        }
    }

    static fromJS(data: any): VoltCulture {
        data = typeof data === 'object' ? data : {};
        let result = new VoltCulture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cultureName"] = this.cultureName !== undefined ? this.cultureName : null as any;
        data["englishName"] = this.englishName !== undefined ? this.englishName : null as any;
        data["nativeName"] = this.nativeName !== undefined ? this.nativeName : null as any;
        data["twoLetterLanguageCode"] = this.twoLetterLanguageCode !== undefined ? this.twoLetterLanguageCode : null as any;
        return data;
    }

    clone(): VoltCulture {
        const json = this.toJSON();
        let result = new VoltCulture();
        result.init(json);
        return result;
    }
}

export interface IVoltCulture {
    cultureName?: string | null;
    englishName?: string | null;
    nativeName?: string | null;
    twoLetterLanguageCode?: string | null;
}

export class ApiErrorOfRequestTokenErrors implements IApiErrorOfRequestTokenErrors {
    errorKey?: RequestTokenErrors;

    constructor(data?: IApiErrorOfRequestTokenErrors) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorKey = _data["errorKey"] !== undefined ? _data["errorKey"] : null as any;
        }
    }

    static fromJS(data: any): ApiErrorOfRequestTokenErrors {
        data = typeof data === 'object' ? data : {};
        let result = new ApiErrorOfRequestTokenErrors();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorKey"] = this.errorKey !== undefined ? this.errorKey : null as any;
        return data;
    }

    clone(): ApiErrorOfRequestTokenErrors {
        const json = this.toJSON();
        let result = new ApiErrorOfRequestTokenErrors();
        result.init(json);
        return result;
    }
}

export interface IApiErrorOfRequestTokenErrors {
    errorKey?: RequestTokenErrors;
}

export enum RequestTokenErrors {
    None = "none",
    InvalidCredentials = "invalidCredentials",
    UserIsNotActive = "userIsNotActive",
}

export class CertificationViewModel implements ICertificationViewModel {
    certificationId?: number | null;
    certificationName?: string | null;
    certificationDescription?: string | null;
    accountId?: number | null;
    personId?: number | null;
    certificationStatus?: CertificationStatus | null;
    invitedDate?: moment.Moment | null;

    constructor(data?: ICertificationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.certificationId = _data["certificationId"] !== undefined ? _data["certificationId"] : null as any;
            this.certificationName = _data["certificationName"] !== undefined ? _data["certificationName"] : null as any;
            this.certificationDescription = _data["certificationDescription"] !== undefined ? _data["certificationDescription"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null as any;
            this.certificationStatus = _data["certificationStatus"] !== undefined ? _data["certificationStatus"] : null as any;
            this.invitedDate = _data["invitedDate"] ? moment(_data["invitedDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): CertificationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CertificationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["certificationId"] = this.certificationId !== undefined ? this.certificationId : null as any;
        data["certificationName"] = this.certificationName !== undefined ? this.certificationName : null as any;
        data["certificationDescription"] = this.certificationDescription !== undefined ? this.certificationDescription : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["personId"] = this.personId !== undefined ? this.personId : null as any;
        data["certificationStatus"] = this.certificationStatus !== undefined ? this.certificationStatus : null as any;
        data["invitedDate"] = this.invitedDate ? this.invitedDate.toISOString() : null as any;
        return data;
    }

    clone(): CertificationViewModel {
        const json = this.toJSON();
        let result = new CertificationViewModel();
        result.init(json);
        return result;
    }
}

export interface ICertificationViewModel {
    certificationId?: number | null;
    certificationName?: string | null;
    certificationDescription?: string | null;
    accountId?: number | null;
    personId?: number | null;
    certificationStatus?: CertificationStatus | null;
    invitedDate?: moment.Moment | null;
}

export enum CertificationStatus {
    Passed = "passed",
    NotStarted = "notStarted",
    NotInvited = "notInvited",
    Incomplete = "incomplete",
    NotCertified = "notCertified",
    Complete = "complete",
}

export class AddRequest implements IAddRequest {
    sourceAccountId?: number;
    targetAccountId?: number;
    relationshipType?: ERelationship;

    constructor(data?: IAddRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceAccountId = _data["sourceAccountId"] !== undefined ? _data["sourceAccountId"] : null as any;
            this.targetAccountId = _data["targetAccountId"] !== undefined ? _data["targetAccountId"] : null as any;
            this.relationshipType = _data["relationshipType"] !== undefined ? _data["relationshipType"] : null as any;
        }
    }

    static fromJS(data: any): AddRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceAccountId"] = this.sourceAccountId !== undefined ? this.sourceAccountId : null as any;
        data["targetAccountId"] = this.targetAccountId !== undefined ? this.targetAccountId : null as any;
        data["relationshipType"] = this.relationshipType !== undefined ? this.relationshipType : null as any;
        return data;
    }

    clone(): AddRequest {
        const json = this.toJSON();
        let result = new AddRequest();
        result.init(json);
        return result;
    }
}

export interface IAddRequest {
    sourceAccountId?: number;
    targetAccountId?: number;
    relationshipType?: ERelationship;
}

export enum ERelationship {
    Child = "child",
    Related = "related",
    Parent = "parent",
}

export class LimitedResultOfGetResponse implements ILimitedResultOfGetResponse {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: GetResponse[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfGetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(GetResponse.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfGetResponse {
        const json = this.toJSON();
        let result = new LimitedResultOfGetResponse();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfGetResponse {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: GetResponse[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class GetResponse implements IGetResponse {
    id?: number;
    relationship?: string | null;
    accountName?: string | null;
    accountNumber?: string | null;
    accountId?: number;
    primaryAdmin?: string | null;
    updatedDate?: moment.Moment;
    updatedBy?: string | null;

    constructor(data?: IGetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.relationship = _data["relationship"] !== undefined ? _data["relationship"] : null as any;
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.primaryAdmin = _data["primaryAdmin"] !== undefined ? _data["primaryAdmin"] : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            this.updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : null as any;
        }
    }

    static fromJS(data: any): GetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["relationship"] = this.relationship !== undefined ? this.relationship : null as any;
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["primaryAdmin"] = this.primaryAdmin !== undefined ? this.primaryAdmin : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : null as any;
        return data;
    }

    clone(): GetResponse {
        const json = this.toJSON();
        let result = new GetResponse();
        result.init(json);
        return result;
    }
}

export interface IGetResponse {
    id?: number;
    relationship?: string | null;
    accountName?: string | null;
    accountNumber?: string | null;
    accountId?: number;
    primaryAdmin?: string | null;
    updatedDate?: moment.Moment;
    updatedBy?: string | null;
}

export class AccountResponse implements IAccountResponse {
    accountId?: number;
    accountName?: string | null;
    primaryAdminEmail?: string | null;

    constructor(data?: IAccountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.primaryAdminEmail = _data["primaryAdminEmail"] !== undefined ? _data["primaryAdminEmail"] : null as any;
        }
    }

    static fromJS(data: any): AccountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["primaryAdminEmail"] = this.primaryAdminEmail !== undefined ? this.primaryAdminEmail : null as any;
        return data;
    }

    clone(): AccountResponse {
        const json = this.toJSON();
        let result = new AccountResponse();
        result.init(json);
        return result;
    }
}

export interface IAccountResponse {
    accountId?: number;
    accountName?: string | null;
    primaryAdminEmail?: string | null;
}

export abstract class BaseEntity implements IBaseEntity {

    constructor(data?: IBaseEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): BaseEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseEntity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): BaseEntity {
        throw new Error("The abstract class 'BaseEntity' cannot be instantiated.");
    }
}

export interface IBaseEntity {
}

export class AccountEula extends BaseEntity implements IAccountEula {
    accountId?: number;
    languageCode?: string | null;
    blobPath?: string | null;

    constructor(data?: IAccountEula) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.languageCode = _data["languageCode"] !== undefined ? _data["languageCode"] : null as any;
            this.blobPath = _data["blobPath"] !== undefined ? _data["blobPath"] : null as any;
        }
    }

    static override fromJS(data: any): AccountEula {
        data = typeof data === 'object' ? data : {};
        let result = new AccountEula();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["languageCode"] = this.languageCode !== undefined ? this.languageCode : null as any;
        data["blobPath"] = this.blobPath !== undefined ? this.blobPath : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AccountEula {
        const json = this.toJSON();
        let result = new AccountEula();
        result.init(json);
        return result;
    }
}

export interface IAccountEula extends IBaseEntity {
    accountId?: number;
    languageCode?: string | null;
    blobPath?: string | null;
}

export class LimitedResultOfAccountsPage implements ILimitedResultOfAccountsPage {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: AccountsPage[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfAccountsPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AccountsPage.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfAccountsPage {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfAccountsPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfAccountsPage {
        const json = this.toJSON();
        let result = new LimitedResultOfAccountsPage();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfAccountsPage {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: AccountsPage[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class AccountsPage implements IAccountsPage {
    logo?: string | null;
    fieldGroupType?: string | null;
    name?: string | null;
    accountId?: number;
    statusType?: StatusTypes;
    createdDate?: moment.Moment | null;
    activeReps?: number;
    primaryAdminName?: string | null;
    primaryAdminEmail?: string | null;
    supplierNumber?: string | null;
    userSpecificEmailsForCommunication?: boolean | null;
    provideBadgeWithPhoto?: boolean | null;
    uDirectlyEmployed?: string | null;
    uMobileEnabled?: string | null;

    constructor(data?: IAccountsPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logo = _data["logo"] !== undefined ? _data["logo"] : null as any;
            this.fieldGroupType = _data["fieldGroupType"] !== undefined ? _data["fieldGroupType"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.statusType = _data["statusType"] !== undefined ? _data["statusType"] : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.activeReps = _data["activeReps"] !== undefined ? _data["activeReps"] : null as any;
            this.primaryAdminName = _data["primaryAdminName"] !== undefined ? _data["primaryAdminName"] : null as any;
            this.primaryAdminEmail = _data["primaryAdminEmail"] !== undefined ? _data["primaryAdminEmail"] : null as any;
            this.supplierNumber = _data["supplierNumber"] !== undefined ? _data["supplierNumber"] : null as any;
            this.userSpecificEmailsForCommunication = _data["userSpecificEmailsForCommunication"] !== undefined ? _data["userSpecificEmailsForCommunication"] : null as any;
            this.provideBadgeWithPhoto = _data["provideBadgeWithPhoto"] !== undefined ? _data["provideBadgeWithPhoto"] : null as any;
            this.uDirectlyEmployed = _data["uDirectlyEmployed"] !== undefined ? _data["uDirectlyEmployed"] : null as any;
            this.uMobileEnabled = _data["uMobileEnabled"] !== undefined ? _data["uMobileEnabled"] : null as any;
        }
    }

    static fromJS(data: any): AccountsPage {
        data = typeof data === 'object' ? data : {};
        let result = new AccountsPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logo"] = this.logo !== undefined ? this.logo : null as any;
        data["fieldGroupType"] = this.fieldGroupType !== undefined ? this.fieldGroupType : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["statusType"] = this.statusType !== undefined ? this.statusType : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["activeReps"] = this.activeReps !== undefined ? this.activeReps : null as any;
        data["primaryAdminName"] = this.primaryAdminName !== undefined ? this.primaryAdminName : null as any;
        data["primaryAdminEmail"] = this.primaryAdminEmail !== undefined ? this.primaryAdminEmail : null as any;
        data["supplierNumber"] = this.supplierNumber !== undefined ? this.supplierNumber : null as any;
        data["userSpecificEmailsForCommunication"] = this.userSpecificEmailsForCommunication !== undefined ? this.userSpecificEmailsForCommunication : null as any;
        data["provideBadgeWithPhoto"] = this.provideBadgeWithPhoto !== undefined ? this.provideBadgeWithPhoto : null as any;
        data["uDirectlyEmployed"] = this.uDirectlyEmployed !== undefined ? this.uDirectlyEmployed : null as any;
        data["uMobileEnabled"] = this.uMobileEnabled !== undefined ? this.uMobileEnabled : null as any;
        return data;
    }

    clone(): AccountsPage {
        const json = this.toJSON();
        let result = new AccountsPage();
        result.init(json);
        return result;
    }
}

export interface IAccountsPage {
    logo?: string | null;
    fieldGroupType?: string | null;
    name?: string | null;
    accountId?: number;
    statusType?: StatusTypes;
    createdDate?: moment.Moment | null;
    activeReps?: number;
    primaryAdminName?: string | null;
    primaryAdminEmail?: string | null;
    supplierNumber?: string | null;
    userSpecificEmailsForCommunication?: boolean | null;
    provideBadgeWithPhoto?: boolean | null;
    uDirectlyEmployed?: string | null;
    uMobileEnabled?: string | null;
}

export enum StatusTypes {
    Active = "active",
    Pending = "pending",
    Inactive = "inactive",
}

export class StoreSupportAccount implements IStoreSupportAccount {
    assemblerPriorityId?: string;
    accountNumber?: string | null;
    accountId?: number;
    name?: string | null;
    imageUrl?: string | null;
    supportEmail?: string | null;
    supportPhone?: string | null;
    assemblerContactName?: string | null;

    constructor(data?: IStoreSupportAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assemblerPriorityId = _data["assemblerPriorityId"] !== undefined ? _data["assemblerPriorityId"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : null as any;
            this.supportEmail = _data["supportEmail"] !== undefined ? _data["supportEmail"] : null as any;
            this.supportPhone = _data["supportPhone"] !== undefined ? _data["supportPhone"] : null as any;
            this.assemblerContactName = _data["assemblerContactName"] !== undefined ? _data["assemblerContactName"] : null as any;
        }
    }

    static fromJS(data: any): StoreSupportAccount {
        data = typeof data === 'object' ? data : {};
        let result = new StoreSupportAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assemblerPriorityId"] = this.assemblerPriorityId !== undefined ? this.assemblerPriorityId : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : null as any;
        data["supportEmail"] = this.supportEmail !== undefined ? this.supportEmail : null as any;
        data["supportPhone"] = this.supportPhone !== undefined ? this.supportPhone : null as any;
        data["assemblerContactName"] = this.assemblerContactName !== undefined ? this.assemblerContactName : null as any;
        return data;
    }

    clone(): StoreSupportAccount {
        const json = this.toJSON();
        let result = new StoreSupportAccount();
        result.init(json);
        return result;
    }
}

export interface IStoreSupportAccount {
    assemblerPriorityId?: string;
    accountNumber?: string | null;
    accountId?: number;
    name?: string | null;
    imageUrl?: string | null;
    supportEmail?: string | null;
    supportPhone?: string | null;
    assemblerContactName?: string | null;
}

export enum EActivityNames {
    Main = "main",
    CashRecyclingMaintenance = "cashRecyclingMaintenance",
    Demo = "demo",
    ProductAssembly = "productAssembly",
    Retailtainment = "retailtainment",
}

export class FieldGroupTypeViewModel implements IFieldGroupTypeViewModel {
    id?: number;
    name?: string | null;
    description?: string | null;
    licenseAgreementUrl?: string | null;
    badgeFooterColor?: string | null;
    badgeFooter?: string | null;
    templateAccount?: TemplateAccountVm | null;

    constructor(data?: IFieldGroupTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.licenseAgreementUrl = _data["licenseAgreementUrl"] !== undefined ? _data["licenseAgreementUrl"] : null as any;
            this.badgeFooterColor = _data["badgeFooterColor"] !== undefined ? _data["badgeFooterColor"] : null as any;
            this.badgeFooter = _data["badgeFooter"] !== undefined ? _data["badgeFooter"] : null as any;
            this.templateAccount = _data["templateAccount"] ? TemplateAccountVm.fromJS(_data["templateAccount"]) : null as any;
        }
    }

    static fromJS(data: any): FieldGroupTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FieldGroupTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["licenseAgreementUrl"] = this.licenseAgreementUrl !== undefined ? this.licenseAgreementUrl : null as any;
        data["badgeFooterColor"] = this.badgeFooterColor !== undefined ? this.badgeFooterColor : null as any;
        data["badgeFooter"] = this.badgeFooter !== undefined ? this.badgeFooter : null as any;
        data["templateAccount"] = this.templateAccount ? this.templateAccount.toJSON() : null as any;
        return data;
    }

    clone(): FieldGroupTypeViewModel {
        const json = this.toJSON();
        let result = new FieldGroupTypeViewModel();
        result.init(json);
        return result;
    }
}

export interface IFieldGroupTypeViewModel {
    id?: number;
    name?: string | null;
    description?: string | null;
    licenseAgreementUrl?: string | null;
    badgeFooterColor?: string | null;
    badgeFooter?: string | null;
    templateAccount?: TemplateAccountVm | null;
}

export class TemplateAccountVm implements ITemplateAccountVm {
    certificationIds?: number[] | null;
    productIds?: number[] | null;
    activityIds?: number[] | null;
    appLicensingIds?: number[] | null;
    printBadge?: EBadgePrint;

    constructor(data?: ITemplateAccountVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["certificationIds"])) {
                this.certificationIds = [] as any;
                for (let item of _data["certificationIds"])
                    this.certificationIds!.push(item);
            }
            else {
                this.certificationIds = null as any;
            }
            if (Array.isArray(_data["productIds"])) {
                this.productIds = [] as any;
                for (let item of _data["productIds"])
                    this.productIds!.push(item);
            }
            else {
                this.productIds = null as any;
            }
            if (Array.isArray(_data["activityIds"])) {
                this.activityIds = [] as any;
                for (let item of _data["activityIds"])
                    this.activityIds!.push(item);
            }
            else {
                this.activityIds = null as any;
            }
            if (Array.isArray(_data["appLicensingIds"])) {
                this.appLicensingIds = [] as any;
                for (let item of _data["appLicensingIds"])
                    this.appLicensingIds!.push(item);
            }
            else {
                this.appLicensingIds = null as any;
            }
            this.printBadge = _data["printBadge"] !== undefined ? _data["printBadge"] : null as any;
        }
    }

    static fromJS(data: any): TemplateAccountVm {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateAccountVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.certificationIds)) {
            data["certificationIds"] = [];
            for (let item of this.certificationIds)
                data["certificationIds"].push(item);
        }
        if (Array.isArray(this.productIds)) {
            data["productIds"] = [];
            for (let item of this.productIds)
                data["productIds"].push(item);
        }
        if (Array.isArray(this.activityIds)) {
            data["activityIds"] = [];
            for (let item of this.activityIds)
                data["activityIds"].push(item);
        }
        if (Array.isArray(this.appLicensingIds)) {
            data["appLicensingIds"] = [];
            for (let item of this.appLicensingIds)
                data["appLicensingIds"].push(item);
        }
        data["printBadge"] = this.printBadge !== undefined ? this.printBadge : null as any;
        return data;
    }

    clone(): TemplateAccountVm {
        const json = this.toJSON();
        let result = new TemplateAccountVm();
        result.init(json);
        return result;
    }
}

export interface ITemplateAccountVm {
    certificationIds?: number[] | null;
    productIds?: number[] | null;
    activityIds?: number[] | null;
    appLicensingIds?: number[] | null;
    printBadge?: EBadgePrint;
}

export enum EBadgePrint {
    Print = "print",
    NoPrint = "noPrint",
}

export class AccountViewModel implements IAccountViewModel {
    accountId?: number | null;
    invitedAccountId?: number;
    accountName?: string | null;
    accountNumber?: string | null;
    certifiedNo?: number;
    activeReps?: number;
    aimageUrl?: string | null;
    totalRep?: number;
    invitedEmail?: string | null;
    invitedName?: string | null;
    status?: string | null;
    statusID?: number | null;
    lastInvitedDate?: moment.Moment | null;
    invitedDate?: moment.Moment | null;
    supplierAdmin?: string | null;
    id?: string | null;
    totalCount?: number;
    rejectReason?: string | null;
    retailerApprovalDate?: moment.Moment | null;
    registrationCompletionDate?: moment.Moment | null;
    shipDirectToRep?: number | null;
    recipientEmail?: string | null;
    recipientPersonId?: number;

    constructor(data?: IAccountViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.invitedAccountId = _data["invitedAccountId"] !== undefined ? _data["invitedAccountId"] : null as any;
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.certifiedNo = _data["certifiedNo"] !== undefined ? _data["certifiedNo"] : null as any;
            this.activeReps = _data["activeReps"] !== undefined ? _data["activeReps"] : null as any;
            this.aimageUrl = _data["aimageUrl"] !== undefined ? _data["aimageUrl"] : null as any;
            this.totalRep = _data["totalRep"] !== undefined ? _data["totalRep"] : null as any;
            this.invitedEmail = _data["invitedEmail"] !== undefined ? _data["invitedEmail"] : null as any;
            this.invitedName = _data["invitedName"] !== undefined ? _data["invitedName"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.statusID = _data["statusID"] !== undefined ? _data["statusID"] : null as any;
            this.lastInvitedDate = _data["lastInvitedDate"] ? moment(_data["lastInvitedDate"].toString()) : null as any;
            this.invitedDate = _data["invitedDate"] ? moment(_data["invitedDate"].toString()) : null as any;
            this.supplierAdmin = _data["supplierAdmin"] !== undefined ? _data["supplierAdmin"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            this.rejectReason = _data["rejectReason"] !== undefined ? _data["rejectReason"] : null as any;
            this.retailerApprovalDate = _data["retailerApprovalDate"] ? moment(_data["retailerApprovalDate"].toString()) : null as any;
            this.registrationCompletionDate = _data["registrationCompletionDate"] ? moment(_data["registrationCompletionDate"].toString()) : null as any;
            this.shipDirectToRep = _data["shipDirectToRep"] !== undefined ? _data["shipDirectToRep"] : null as any;
            this.recipientEmail = _data["recipientEmail"] !== undefined ? _data["recipientEmail"] : null as any;
            this.recipientPersonId = _data["recipientPersonId"] !== undefined ? _data["recipientPersonId"] : null as any;
        }
    }

    static fromJS(data: any): AccountViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["invitedAccountId"] = this.invitedAccountId !== undefined ? this.invitedAccountId : null as any;
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["certifiedNo"] = this.certifiedNo !== undefined ? this.certifiedNo : null as any;
        data["activeReps"] = this.activeReps !== undefined ? this.activeReps : null as any;
        data["aimageUrl"] = this.aimageUrl !== undefined ? this.aimageUrl : null as any;
        data["totalRep"] = this.totalRep !== undefined ? this.totalRep : null as any;
        data["invitedEmail"] = this.invitedEmail !== undefined ? this.invitedEmail : null as any;
        data["invitedName"] = this.invitedName !== undefined ? this.invitedName : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["statusID"] = this.statusID !== undefined ? this.statusID : null as any;
        data["lastInvitedDate"] = this.lastInvitedDate ? this.lastInvitedDate.toISOString() : null as any;
        data["invitedDate"] = this.invitedDate ? this.invitedDate.toISOString() : null as any;
        data["supplierAdmin"] = this.supplierAdmin !== undefined ? this.supplierAdmin : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        data["rejectReason"] = this.rejectReason !== undefined ? this.rejectReason : null as any;
        data["retailerApprovalDate"] = this.retailerApprovalDate ? this.retailerApprovalDate.toISOString() : null as any;
        data["registrationCompletionDate"] = this.registrationCompletionDate ? this.registrationCompletionDate.toISOString() : null as any;
        data["shipDirectToRep"] = this.shipDirectToRep !== undefined ? this.shipDirectToRep : null as any;
        data["recipientEmail"] = this.recipientEmail !== undefined ? this.recipientEmail : null as any;
        data["recipientPersonId"] = this.recipientPersonId !== undefined ? this.recipientPersonId : null as any;
        return data;
    }

    clone(): AccountViewModel {
        const json = this.toJSON();
        let result = new AccountViewModel();
        result.init(json);
        return result;
    }
}

export interface IAccountViewModel {
    accountId?: number | null;
    invitedAccountId?: number;
    accountName?: string | null;
    accountNumber?: string | null;
    certifiedNo?: number;
    activeReps?: number;
    aimageUrl?: string | null;
    totalRep?: number;
    invitedEmail?: string | null;
    invitedName?: string | null;
    status?: string | null;
    statusID?: number | null;
    lastInvitedDate?: moment.Moment | null;
    invitedDate?: moment.Moment | null;
    supplierAdmin?: string | null;
    id?: string | null;
    totalCount?: number;
    rejectReason?: string | null;
    retailerApprovalDate?: moment.Moment | null;
    registrationCompletionDate?: moment.Moment | null;
    shipDirectToRep?: number | null;
    recipientEmail?: string | null;
    recipientPersonId?: number;
}

export class Account extends BaseEntity implements IAccount {
    accountId?: number;
    accountNumber!: string;
    accountTypeId?: number | null;
    aname!: string;
    aabbrev?: string | null;
    aimageUrl?: string | null;
    awebsite?: string | null;
    aaddress1?: string | null;
    aaddress2?: string | null;
    acity?: string | null;
    astate?: string | null;
    azip?: string | null;
    acountry?: string | null;
    baddress1?: string | null;
    baddress2?: string | null;
    bcity?: string | null;
    bstate?: string | null;
    bzip?: string | null;
    bcountry?: string | null;
    bphone?: string | null;
    billingEmail?: string | null;
    saddress1?: string | null;
    saddress2?: string | null;
    scity?: string | null;
    sstate?: string | null;
    szip?: string | null;
    scountry?: string | null;
    shipDirectToRep?: number | null;
    statusId?: number | null;
    wattFieldGroupId?: string;
    wattCompanyId?: string;
    showStoreSupportInfo?: boolean | null;
    storeSupportNumber?: string | null;
    storeSupportEmail?: string | null;
    accessDeniedMessage?: string | null;
    printBadge?: EBadgePrint;
    gpTransId?: string | null;
    gpLastFour?: string | null;
    anote?: string | null;
    asmallImageUrl?: string | null;
    billAttnToFname?: string | null;
    billAttnToLname?: string | null;
    shipAttnTo?: string | null;
    dateCreated?: moment.Moment | null;
    authToken?: string | null;
    supportEmail?: string | null;
    subscriptionType?: string | null;
    supportPhone?: string | null;
    supportNote?: string | null;
    itcontactEmail?: string | null;
    itcontactPhone?: string | null;
    fieldGroupType?: string | null;
    primaryAdminId?: number | null;
    syncId?: string | null;
    eulaUpdatedDate?: moment.Moment | null;
    isUserIdAsLogin?: boolean;
    isSeasonal?: boolean;
    accountAppLinks?: AccountAppLink[] | null;
    accountFieldgroup?: AccountFieldgroup[] | null;
    accountPerson?: AccountPerson[] | null;
    accountRetailerFieldGroupAccount?: AccountRetailer[] | null;
    accountRetailerRetailerAccount?: AccountRetailer[] | null;
    accountBanner?: AccountBanner[] | null;
    accountType?: AccountType | null;
    fieldGroup?: FieldGroupType | null;
    activity?: Activity[] | null;
    departments?: Department[] | null;
    event?: Event[] | null;
    location?: Location[] | null;
    locationOpenStatus?: LocationOpenStatus[] | null;
    locationType?: LocationType[] | null;
    person?: Person[] | null;
    retailerSupplierRetailerAccount?: RetailerSupplier[] | null;
    retailerSupplierSupplierAccount?: RetailerSupplier[] | null;
    accountProduct?: AccountProduct[] | null;
    appLicensing?: AppLicensing[] | null;
    suppliers?: Supplier[] | null;
    supplierAccounts?: Supplier[] | null;
    accountHideTransaction?: AccountHideTransaction | null;
    accountActivity?: AccountActivity[] | null;
    accountTags?: AccountTag[] | null;
    communicationsAccountCategories?: CommunicationsAccountCategory[] | null;
    accountRetailerCertifications?: AccountRetailerCertification[] | null;
    templateFieldGroupType?: FieldGroupType | null;

    constructor(data?: IAccount) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.accountTypeId = _data["accountTypeId"] !== undefined ? _data["accountTypeId"] : null as any;
            this.aname = _data["aname"] !== undefined ? _data["aname"] : null as any;
            this.aabbrev = _data["aabbrev"] !== undefined ? _data["aabbrev"] : null as any;
            this.aimageUrl = _data["aimageUrl"] !== undefined ? _data["aimageUrl"] : null as any;
            this.awebsite = _data["awebsite"] !== undefined ? _data["awebsite"] : null as any;
            this.aaddress1 = _data["aaddress1"] !== undefined ? _data["aaddress1"] : null as any;
            this.aaddress2 = _data["aaddress2"] !== undefined ? _data["aaddress2"] : null as any;
            this.acity = _data["acity"] !== undefined ? _data["acity"] : null as any;
            this.astate = _data["astate"] !== undefined ? _data["astate"] : null as any;
            this.azip = _data["azip"] !== undefined ? _data["azip"] : null as any;
            this.acountry = _data["acountry"] !== undefined ? _data["acountry"] : null as any;
            this.baddress1 = _data["baddress1"] !== undefined ? _data["baddress1"] : null as any;
            this.baddress2 = _data["baddress2"] !== undefined ? _data["baddress2"] : null as any;
            this.bcity = _data["bcity"] !== undefined ? _data["bcity"] : null as any;
            this.bstate = _data["bstate"] !== undefined ? _data["bstate"] : null as any;
            this.bzip = _data["bzip"] !== undefined ? _data["bzip"] : null as any;
            this.bcountry = _data["bcountry"] !== undefined ? _data["bcountry"] : null as any;
            this.bphone = _data["bphone"] !== undefined ? _data["bphone"] : null as any;
            this.billingEmail = _data["billingEmail"] !== undefined ? _data["billingEmail"] : null as any;
            this.saddress1 = _data["saddress1"] !== undefined ? _data["saddress1"] : null as any;
            this.saddress2 = _data["saddress2"] !== undefined ? _data["saddress2"] : null as any;
            this.scity = _data["scity"] !== undefined ? _data["scity"] : null as any;
            this.sstate = _data["sstate"] !== undefined ? _data["sstate"] : null as any;
            this.szip = _data["szip"] !== undefined ? _data["szip"] : null as any;
            this.scountry = _data["scountry"] !== undefined ? _data["scountry"] : null as any;
            this.shipDirectToRep = _data["shipDirectToRep"] !== undefined ? _data["shipDirectToRep"] : null as any;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            this.wattFieldGroupId = _data["wattFieldGroupId"] !== undefined ? _data["wattFieldGroupId"] : null as any;
            this.wattCompanyId = _data["wattCompanyId"] !== undefined ? _data["wattCompanyId"] : null as any;
            this.showStoreSupportInfo = _data["showStoreSupportInfo"] !== undefined ? _data["showStoreSupportInfo"] : null as any;
            this.storeSupportNumber = _data["storeSupportNumber"] !== undefined ? _data["storeSupportNumber"] : null as any;
            this.storeSupportEmail = _data["storeSupportEmail"] !== undefined ? _data["storeSupportEmail"] : null as any;
            this.accessDeniedMessage = _data["accessDeniedMessage"] !== undefined ? _data["accessDeniedMessage"] : null as any;
            this.printBadge = _data["printBadge"] !== undefined ? _data["printBadge"] : null as any;
            this.gpTransId = _data["gpTransId"] !== undefined ? _data["gpTransId"] : null as any;
            this.gpLastFour = _data["gpLastFour"] !== undefined ? _data["gpLastFour"] : null as any;
            this.anote = _data["anote"] !== undefined ? _data["anote"] : null as any;
            this.asmallImageUrl = _data["asmallImageUrl"] !== undefined ? _data["asmallImageUrl"] : null as any;
            this.billAttnToFname = _data["billAttnToFname"] !== undefined ? _data["billAttnToFname"] : null as any;
            this.billAttnToLname = _data["billAttnToLname"] !== undefined ? _data["billAttnToLname"] : null as any;
            this.shipAttnTo = _data["shipAttnTo"] !== undefined ? _data["shipAttnTo"] : null as any;
            this.dateCreated = _data["dateCreated"] ? moment(_data["dateCreated"].toString()) : null as any;
            this.authToken = _data["authToken"] !== undefined ? _data["authToken"] : null as any;
            this.supportEmail = _data["supportEmail"] !== undefined ? _data["supportEmail"] : null as any;
            this.subscriptionType = _data["subscriptionType"] !== undefined ? _data["subscriptionType"] : null as any;
            this.supportPhone = _data["supportPhone"] !== undefined ? _data["supportPhone"] : null as any;
            this.supportNote = _data["supportNote"] !== undefined ? _data["supportNote"] : null as any;
            this.itcontactEmail = _data["itcontactEmail"] !== undefined ? _data["itcontactEmail"] : null as any;
            this.itcontactPhone = _data["itcontactPhone"] !== undefined ? _data["itcontactPhone"] : null as any;
            this.fieldGroupType = _data["fieldGroupType"] !== undefined ? _data["fieldGroupType"] : null as any;
            this.primaryAdminId = _data["primaryAdminId"] !== undefined ? _data["primaryAdminId"] : null as any;
            this.syncId = _data["syncId"] !== undefined ? _data["syncId"] : null as any;
            this.eulaUpdatedDate = _data["eulaUpdatedDate"] ? moment(_data["eulaUpdatedDate"].toString()) : null as any;
            this.isUserIdAsLogin = _data["isUserIdAsLogin"] !== undefined ? _data["isUserIdAsLogin"] : null as any;
            this.isSeasonal = _data["isSeasonal"] !== undefined ? _data["isSeasonal"] : null as any;
            if (Array.isArray(_data["accountAppLinks"])) {
                this.accountAppLinks = [] as any;
                for (let item of _data["accountAppLinks"])
                    this.accountAppLinks!.push(AccountAppLink.fromJS(item));
            }
            else {
                this.accountAppLinks = null as any;
            }
            if (Array.isArray(_data["accountFieldgroup"])) {
                this.accountFieldgroup = [] as any;
                for (let item of _data["accountFieldgroup"])
                    this.accountFieldgroup!.push(AccountFieldgroup.fromJS(item));
            }
            else {
                this.accountFieldgroup = null as any;
            }
            if (Array.isArray(_data["accountPerson"])) {
                this.accountPerson = [] as any;
                for (let item of _data["accountPerson"])
                    this.accountPerson!.push(AccountPerson.fromJS(item));
            }
            else {
                this.accountPerson = null as any;
            }
            if (Array.isArray(_data["accountRetailerFieldGroupAccount"])) {
                this.accountRetailerFieldGroupAccount = [] as any;
                for (let item of _data["accountRetailerFieldGroupAccount"])
                    this.accountRetailerFieldGroupAccount!.push(AccountRetailer.fromJS(item));
            }
            else {
                this.accountRetailerFieldGroupAccount = null as any;
            }
            if (Array.isArray(_data["accountRetailerRetailerAccount"])) {
                this.accountRetailerRetailerAccount = [] as any;
                for (let item of _data["accountRetailerRetailerAccount"])
                    this.accountRetailerRetailerAccount!.push(AccountRetailer.fromJS(item));
            }
            else {
                this.accountRetailerRetailerAccount = null as any;
            }
            if (Array.isArray(_data["accountBanner"])) {
                this.accountBanner = [] as any;
                for (let item of _data["accountBanner"])
                    this.accountBanner!.push(AccountBanner.fromJS(item));
            }
            else {
                this.accountBanner = null as any;
            }
            this.accountType = _data["accountType"] ? AccountType.fromJS(_data["accountType"]) : null as any;
            this.fieldGroup = _data["fieldGroup"] ? FieldGroupType.fromJS(_data["fieldGroup"]) : null as any;
            if (Array.isArray(_data["activity"])) {
                this.activity = [] as any;
                for (let item of _data["activity"])
                    this.activity!.push(Activity.fromJS(item));
            }
            else {
                this.activity = null as any;
            }
            if (Array.isArray(_data["departments"])) {
                this.departments = [] as any;
                for (let item of _data["departments"])
                    this.departments!.push(Department.fromJS(item));
            }
            else {
                this.departments = null as any;
            }
            if (Array.isArray(_data["event"])) {
                this.event = [] as any;
                for (let item of _data["event"])
                    this.event!.push(Event.fromJS(item));
            }
            else {
                this.event = null as any;
            }
            if (Array.isArray(_data["location"])) {
                this.location = [] as any;
                for (let item of _data["location"])
                    this.location!.push(Location.fromJS(item));
            }
            else {
                this.location = null as any;
            }
            if (Array.isArray(_data["locationOpenStatus"])) {
                this.locationOpenStatus = [] as any;
                for (let item of _data["locationOpenStatus"])
                    this.locationOpenStatus!.push(LocationOpenStatus.fromJS(item));
            }
            else {
                this.locationOpenStatus = null as any;
            }
            if (Array.isArray(_data["locationType"])) {
                this.locationType = [] as any;
                for (let item of _data["locationType"])
                    this.locationType!.push(LocationType.fromJS(item));
            }
            else {
                this.locationType = null as any;
            }
            if (Array.isArray(_data["person"])) {
                this.person = [] as any;
                for (let item of _data["person"])
                    this.person!.push(Person.fromJS(item));
            }
            else {
                this.person = null as any;
            }
            if (Array.isArray(_data["retailerSupplierRetailerAccount"])) {
                this.retailerSupplierRetailerAccount = [] as any;
                for (let item of _data["retailerSupplierRetailerAccount"])
                    this.retailerSupplierRetailerAccount!.push(RetailerSupplier.fromJS(item));
            }
            else {
                this.retailerSupplierRetailerAccount = null as any;
            }
            if (Array.isArray(_data["retailerSupplierSupplierAccount"])) {
                this.retailerSupplierSupplierAccount = [] as any;
                for (let item of _data["retailerSupplierSupplierAccount"])
                    this.retailerSupplierSupplierAccount!.push(RetailerSupplier.fromJS(item));
            }
            else {
                this.retailerSupplierSupplierAccount = null as any;
            }
            if (Array.isArray(_data["accountProduct"])) {
                this.accountProduct = [] as any;
                for (let item of _data["accountProduct"])
                    this.accountProduct!.push(AccountProduct.fromJS(item));
            }
            else {
                this.accountProduct = null as any;
            }
            if (Array.isArray(_data["appLicensing"])) {
                this.appLicensing = [] as any;
                for (let item of _data["appLicensing"])
                    this.appLicensing!.push(AppLicensing.fromJS(item));
            }
            else {
                this.appLicensing = null as any;
            }
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [] as any;
                for (let item of _data["suppliers"])
                    this.suppliers!.push(Supplier.fromJS(item));
            }
            else {
                this.suppliers = null as any;
            }
            if (Array.isArray(_data["supplierAccounts"])) {
                this.supplierAccounts = [] as any;
                for (let item of _data["supplierAccounts"])
                    this.supplierAccounts!.push(Supplier.fromJS(item));
            }
            else {
                this.supplierAccounts = null as any;
            }
            this.accountHideTransaction = _data["accountHideTransaction"] ? AccountHideTransaction.fromJS(_data["accountHideTransaction"]) : null as any;
            if (Array.isArray(_data["accountActivity"])) {
                this.accountActivity = [] as any;
                for (let item of _data["accountActivity"])
                    this.accountActivity!.push(AccountActivity.fromJS(item));
            }
            else {
                this.accountActivity = null as any;
            }
            if (Array.isArray(_data["accountTags"])) {
                this.accountTags = [] as any;
                for (let item of _data["accountTags"])
                    this.accountTags!.push(AccountTag.fromJS(item));
            }
            else {
                this.accountTags = null as any;
            }
            if (Array.isArray(_data["communicationsAccountCategories"])) {
                this.communicationsAccountCategories = [] as any;
                for (let item of _data["communicationsAccountCategories"])
                    this.communicationsAccountCategories!.push(CommunicationsAccountCategory.fromJS(item));
            }
            else {
                this.communicationsAccountCategories = null as any;
            }
            if (Array.isArray(_data["accountRetailerCertifications"])) {
                this.accountRetailerCertifications = [] as any;
                for (let item of _data["accountRetailerCertifications"])
                    this.accountRetailerCertifications!.push(AccountRetailerCertification.fromJS(item));
            }
            else {
                this.accountRetailerCertifications = null as any;
            }
            this.templateFieldGroupType = _data["templateFieldGroupType"] ? FieldGroupType.fromJS(_data["templateFieldGroupType"]) : null as any;
        }
    }

    static override fromJS(data: any): Account {
        data = typeof data === 'object' ? data : {};
        let result = new Account();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["accountTypeId"] = this.accountTypeId !== undefined ? this.accountTypeId : null as any;
        data["aname"] = this.aname !== undefined ? this.aname : null as any;
        data["aabbrev"] = this.aabbrev !== undefined ? this.aabbrev : null as any;
        data["aimageUrl"] = this.aimageUrl !== undefined ? this.aimageUrl : null as any;
        data["awebsite"] = this.awebsite !== undefined ? this.awebsite : null as any;
        data["aaddress1"] = this.aaddress1 !== undefined ? this.aaddress1 : null as any;
        data["aaddress2"] = this.aaddress2 !== undefined ? this.aaddress2 : null as any;
        data["acity"] = this.acity !== undefined ? this.acity : null as any;
        data["astate"] = this.astate !== undefined ? this.astate : null as any;
        data["azip"] = this.azip !== undefined ? this.azip : null as any;
        data["acountry"] = this.acountry !== undefined ? this.acountry : null as any;
        data["baddress1"] = this.baddress1 !== undefined ? this.baddress1 : null as any;
        data["baddress2"] = this.baddress2 !== undefined ? this.baddress2 : null as any;
        data["bcity"] = this.bcity !== undefined ? this.bcity : null as any;
        data["bstate"] = this.bstate !== undefined ? this.bstate : null as any;
        data["bzip"] = this.bzip !== undefined ? this.bzip : null as any;
        data["bcountry"] = this.bcountry !== undefined ? this.bcountry : null as any;
        data["bphone"] = this.bphone !== undefined ? this.bphone : null as any;
        data["billingEmail"] = this.billingEmail !== undefined ? this.billingEmail : null as any;
        data["saddress1"] = this.saddress1 !== undefined ? this.saddress1 : null as any;
        data["saddress2"] = this.saddress2 !== undefined ? this.saddress2 : null as any;
        data["scity"] = this.scity !== undefined ? this.scity : null as any;
        data["sstate"] = this.sstate !== undefined ? this.sstate : null as any;
        data["szip"] = this.szip !== undefined ? this.szip : null as any;
        data["scountry"] = this.scountry !== undefined ? this.scountry : null as any;
        data["shipDirectToRep"] = this.shipDirectToRep !== undefined ? this.shipDirectToRep : null as any;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        data["wattFieldGroupId"] = this.wattFieldGroupId !== undefined ? this.wattFieldGroupId : null as any;
        data["wattCompanyId"] = this.wattCompanyId !== undefined ? this.wattCompanyId : null as any;
        data["showStoreSupportInfo"] = this.showStoreSupportInfo !== undefined ? this.showStoreSupportInfo : null as any;
        data["storeSupportNumber"] = this.storeSupportNumber !== undefined ? this.storeSupportNumber : null as any;
        data["storeSupportEmail"] = this.storeSupportEmail !== undefined ? this.storeSupportEmail : null as any;
        data["accessDeniedMessage"] = this.accessDeniedMessage !== undefined ? this.accessDeniedMessage : null as any;
        data["printBadge"] = this.printBadge !== undefined ? this.printBadge : null as any;
        data["gpTransId"] = this.gpTransId !== undefined ? this.gpTransId : null as any;
        data["gpLastFour"] = this.gpLastFour !== undefined ? this.gpLastFour : null as any;
        data["anote"] = this.anote !== undefined ? this.anote : null as any;
        data["asmallImageUrl"] = this.asmallImageUrl !== undefined ? this.asmallImageUrl : null as any;
        data["billAttnToFname"] = this.billAttnToFname !== undefined ? this.billAttnToFname : null as any;
        data["billAttnToLname"] = this.billAttnToLname !== undefined ? this.billAttnToLname : null as any;
        data["shipAttnTo"] = this.shipAttnTo !== undefined ? this.shipAttnTo : null as any;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : null as any;
        data["authToken"] = this.authToken !== undefined ? this.authToken : null as any;
        data["supportEmail"] = this.supportEmail !== undefined ? this.supportEmail : null as any;
        data["subscriptionType"] = this.subscriptionType !== undefined ? this.subscriptionType : null as any;
        data["supportPhone"] = this.supportPhone !== undefined ? this.supportPhone : null as any;
        data["supportNote"] = this.supportNote !== undefined ? this.supportNote : null as any;
        data["itcontactEmail"] = this.itcontactEmail !== undefined ? this.itcontactEmail : null as any;
        data["itcontactPhone"] = this.itcontactPhone !== undefined ? this.itcontactPhone : null as any;
        data["fieldGroupType"] = this.fieldGroupType !== undefined ? this.fieldGroupType : null as any;
        data["primaryAdminId"] = this.primaryAdminId !== undefined ? this.primaryAdminId : null as any;
        data["syncId"] = this.syncId !== undefined ? this.syncId : null as any;
        data["eulaUpdatedDate"] = this.eulaUpdatedDate ? this.eulaUpdatedDate.toISOString() : null as any;
        data["isUserIdAsLogin"] = this.isUserIdAsLogin !== undefined ? this.isUserIdAsLogin : null as any;
        data["isSeasonal"] = this.isSeasonal !== undefined ? this.isSeasonal : null as any;
        if (Array.isArray(this.accountAppLinks)) {
            data["accountAppLinks"] = [];
            for (let item of this.accountAppLinks)
                data["accountAppLinks"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.accountFieldgroup)) {
            data["accountFieldgroup"] = [];
            for (let item of this.accountFieldgroup)
                data["accountFieldgroup"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.accountPerson)) {
            data["accountPerson"] = [];
            for (let item of this.accountPerson)
                data["accountPerson"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.accountRetailerFieldGroupAccount)) {
            data["accountRetailerFieldGroupAccount"] = [];
            for (let item of this.accountRetailerFieldGroupAccount)
                data["accountRetailerFieldGroupAccount"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.accountRetailerRetailerAccount)) {
            data["accountRetailerRetailerAccount"] = [];
            for (let item of this.accountRetailerRetailerAccount)
                data["accountRetailerRetailerAccount"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.accountBanner)) {
            data["accountBanner"] = [];
            for (let item of this.accountBanner)
                data["accountBanner"].push(item ? item.toJSON() : null as any);
        }
        data["accountType"] = this.accountType ? this.accountType.toJSON() : null as any;
        data["fieldGroup"] = this.fieldGroup ? this.fieldGroup.toJSON() : null as any;
        if (Array.isArray(this.activity)) {
            data["activity"] = [];
            for (let item of this.activity)
                data["activity"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.departments)) {
            data["departments"] = [];
            for (let item of this.departments)
                data["departments"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.event)) {
            data["event"] = [];
            for (let item of this.event)
                data["event"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.location)) {
            data["location"] = [];
            for (let item of this.location)
                data["location"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.locationOpenStatus)) {
            data["locationOpenStatus"] = [];
            for (let item of this.locationOpenStatus)
                data["locationOpenStatus"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.locationType)) {
            data["locationType"] = [];
            for (let item of this.locationType)
                data["locationType"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.person)) {
            data["person"] = [];
            for (let item of this.person)
                data["person"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.retailerSupplierRetailerAccount)) {
            data["retailerSupplierRetailerAccount"] = [];
            for (let item of this.retailerSupplierRetailerAccount)
                data["retailerSupplierRetailerAccount"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.retailerSupplierSupplierAccount)) {
            data["retailerSupplierSupplierAccount"] = [];
            for (let item of this.retailerSupplierSupplierAccount)
                data["retailerSupplierSupplierAccount"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.accountProduct)) {
            data["accountProduct"] = [];
            for (let item of this.accountProduct)
                data["accountProduct"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.appLicensing)) {
            data["appLicensing"] = [];
            for (let item of this.appLicensing)
                data["appLicensing"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.supplierAccounts)) {
            data["supplierAccounts"] = [];
            for (let item of this.supplierAccounts)
                data["supplierAccounts"].push(item ? item.toJSON() : null as any);
        }
        data["accountHideTransaction"] = this.accountHideTransaction ? this.accountHideTransaction.toJSON() : null as any;
        if (Array.isArray(this.accountActivity)) {
            data["accountActivity"] = [];
            for (let item of this.accountActivity)
                data["accountActivity"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.accountTags)) {
            data["accountTags"] = [];
            for (let item of this.accountTags)
                data["accountTags"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.communicationsAccountCategories)) {
            data["communicationsAccountCategories"] = [];
            for (let item of this.communicationsAccountCategories)
                data["communicationsAccountCategories"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.accountRetailerCertifications)) {
            data["accountRetailerCertifications"] = [];
            for (let item of this.accountRetailerCertifications)
                data["accountRetailerCertifications"].push(item ? item.toJSON() : null as any);
        }
        data["templateFieldGroupType"] = this.templateFieldGroupType ? this.templateFieldGroupType.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): Account {
        const json = this.toJSON();
        let result = new Account();
        result.init(json);
        return result;
    }
}

export interface IAccount extends IBaseEntity {
    accountId?: number;
    accountNumber: string;
    accountTypeId?: number | null;
    aname: string;
    aabbrev?: string | null;
    aimageUrl?: string | null;
    awebsite?: string | null;
    aaddress1?: string | null;
    aaddress2?: string | null;
    acity?: string | null;
    astate?: string | null;
    azip?: string | null;
    acountry?: string | null;
    baddress1?: string | null;
    baddress2?: string | null;
    bcity?: string | null;
    bstate?: string | null;
    bzip?: string | null;
    bcountry?: string | null;
    bphone?: string | null;
    billingEmail?: string | null;
    saddress1?: string | null;
    saddress2?: string | null;
    scity?: string | null;
    sstate?: string | null;
    szip?: string | null;
    scountry?: string | null;
    shipDirectToRep?: number | null;
    statusId?: number | null;
    wattFieldGroupId?: string;
    wattCompanyId?: string;
    showStoreSupportInfo?: boolean | null;
    storeSupportNumber?: string | null;
    storeSupportEmail?: string | null;
    accessDeniedMessage?: string | null;
    printBadge?: EBadgePrint;
    gpTransId?: string | null;
    gpLastFour?: string | null;
    anote?: string | null;
    asmallImageUrl?: string | null;
    billAttnToFname?: string | null;
    billAttnToLname?: string | null;
    shipAttnTo?: string | null;
    dateCreated?: moment.Moment | null;
    authToken?: string | null;
    supportEmail?: string | null;
    subscriptionType?: string | null;
    supportPhone?: string | null;
    supportNote?: string | null;
    itcontactEmail?: string | null;
    itcontactPhone?: string | null;
    fieldGroupType?: string | null;
    primaryAdminId?: number | null;
    syncId?: string | null;
    eulaUpdatedDate?: moment.Moment | null;
    isUserIdAsLogin?: boolean;
    isSeasonal?: boolean;
    accountAppLinks?: AccountAppLink[] | null;
    accountFieldgroup?: AccountFieldgroup[] | null;
    accountPerson?: AccountPerson[] | null;
    accountRetailerFieldGroupAccount?: AccountRetailer[] | null;
    accountRetailerRetailerAccount?: AccountRetailer[] | null;
    accountBanner?: AccountBanner[] | null;
    accountType?: AccountType | null;
    fieldGroup?: FieldGroupType | null;
    activity?: Activity[] | null;
    departments?: Department[] | null;
    event?: Event[] | null;
    location?: Location[] | null;
    locationOpenStatus?: LocationOpenStatus[] | null;
    locationType?: LocationType[] | null;
    person?: Person[] | null;
    retailerSupplierRetailerAccount?: RetailerSupplier[] | null;
    retailerSupplierSupplierAccount?: RetailerSupplier[] | null;
    accountProduct?: AccountProduct[] | null;
    appLicensing?: AppLicensing[] | null;
    suppliers?: Supplier[] | null;
    supplierAccounts?: Supplier[] | null;
    accountHideTransaction?: AccountHideTransaction | null;
    accountActivity?: AccountActivity[] | null;
    accountTags?: AccountTag[] | null;
    communicationsAccountCategories?: CommunicationsAccountCategory[] | null;
    accountRetailerCertifications?: AccountRetailerCertification[] | null;
    templateFieldGroupType?: FieldGroupType | null;
}

export class AccountAppLink extends BaseEntity implements IAccountAppLink {
    id?: number;
    accountId?: number;
    activity!: string;
    note!: string;
    linkType!: LinkType;
    link!: string;
    account?: Account | null;

    constructor(data?: IAccountAppLink) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.activity = _data["activity"] !== undefined ? _data["activity"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.linkType = _data["linkType"] !== undefined ? _data["linkType"] : null as any;
            this.link = _data["link"] !== undefined ? _data["link"] : null as any;
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : null as any;
        }
    }

    static override fromJS(data: any): AccountAppLink {
        data = typeof data === 'object' ? data : {};
        let result = new AccountAppLink();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["activity"] = this.activity !== undefined ? this.activity : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["linkType"] = this.linkType !== undefined ? this.linkType : null as any;
        data["link"] = this.link !== undefined ? this.link : null as any;
        data["account"] = this.account ? this.account.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AccountAppLink {
        const json = this.toJSON();
        let result = new AccountAppLink();
        result.init(json);
        return result;
    }
}

export interface IAccountAppLink extends IBaseEntity {
    id?: number;
    accountId?: number;
    activity: string;
    note: string;
    linkType: LinkType;
    link: string;
    account?: Account | null;
}

export enum LinkType {
    IOS = "iOS",
    Android = "android",
    Web = "web",
    InApp = "inApp",
}

export class AccountFieldgroup extends BaseEntity implements IAccountFieldgroup {
    accountFieldgroupId?: number;
    accountId?: number;
    fieldgroupId?: number;
    statusId?: number;
    account?: Account | null;
    status?: Status | null;

    constructor(data?: IAccountFieldgroup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accountFieldgroupId = _data["accountFieldgroupId"] !== undefined ? _data["accountFieldgroupId"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.fieldgroupId = _data["fieldgroupId"] !== undefined ? _data["fieldgroupId"] : null as any;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : null as any;
            this.status = _data["status"] ? Status.fromJS(_data["status"]) : null as any;
        }
    }

    static override fromJS(data: any): AccountFieldgroup {
        data = typeof data === 'object' ? data : {};
        let result = new AccountFieldgroup();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountFieldgroupId"] = this.accountFieldgroupId !== undefined ? this.accountFieldgroupId : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["fieldgroupId"] = this.fieldgroupId !== undefined ? this.fieldgroupId : null as any;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        data["account"] = this.account ? this.account.toJSON() : null as any;
        data["status"] = this.status ? this.status.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AccountFieldgroup {
        const json = this.toJSON();
        let result = new AccountFieldgroup();
        result.init(json);
        return result;
    }
}

export interface IAccountFieldgroup extends IBaseEntity {
    accountFieldgroupId?: number;
    accountId?: number;
    fieldgroupId?: number;
    statusId?: number;
    account?: Account | null;
    status?: Status | null;
}

export class Status extends BaseEntity implements IStatus {
    statusId?: number;
    statusName?: string | null;
    accountFieldgroup?: AccountFieldgroup[] | null;
    activity?: Activity[] | null;
    departments?: Department[] | null;
    locations?: Location[] | null;
    locationOpenStatus?: LocationOpenStatus[] | null;
    locationPerson?: LocationPerson[] | null;
    locationType?: LocationType[] | null;
    person?: Person[] | null;
    retailerSuppliers?: RetailerSupplier[] | null;
    roles?: Roles[] | null;
    roleTypes?: RoleType[] | null;
    product?: Product[] | null;
    productType?: ProductType[] | null;
    accountProduct?: AccountProduct[] | null;
    app?: App[] | null;
    suppliers?: Supplier[] | null;
    fieldGroupTypes?: FieldGroupType[] | null;

    constructor(data?: IStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            this.statusName = _data["statusName"] !== undefined ? _data["statusName"] : null as any;
            if (Array.isArray(_data["accountFieldgroup"])) {
                this.accountFieldgroup = [] as any;
                for (let item of _data["accountFieldgroup"])
                    this.accountFieldgroup!.push(AccountFieldgroup.fromJS(item));
            }
            else {
                this.accountFieldgroup = null as any;
            }
            if (Array.isArray(_data["activity"])) {
                this.activity = [] as any;
                for (let item of _data["activity"])
                    this.activity!.push(Activity.fromJS(item));
            }
            else {
                this.activity = null as any;
            }
            if (Array.isArray(_data["departments"])) {
                this.departments = [] as any;
                for (let item of _data["departments"])
                    this.departments!.push(Department.fromJS(item));
            }
            else {
                this.departments = null as any;
            }
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(Location.fromJS(item));
            }
            else {
                this.locations = null as any;
            }
            if (Array.isArray(_data["locationOpenStatus"])) {
                this.locationOpenStatus = [] as any;
                for (let item of _data["locationOpenStatus"])
                    this.locationOpenStatus!.push(LocationOpenStatus.fromJS(item));
            }
            else {
                this.locationOpenStatus = null as any;
            }
            if (Array.isArray(_data["locationPerson"])) {
                this.locationPerson = [] as any;
                for (let item of _data["locationPerson"])
                    this.locationPerson!.push(LocationPerson.fromJS(item));
            }
            else {
                this.locationPerson = null as any;
            }
            if (Array.isArray(_data["locationType"])) {
                this.locationType = [] as any;
                for (let item of _data["locationType"])
                    this.locationType!.push(LocationType.fromJS(item));
            }
            else {
                this.locationType = null as any;
            }
            if (Array.isArray(_data["person"])) {
                this.person = [] as any;
                for (let item of _data["person"])
                    this.person!.push(Person.fromJS(item));
            }
            else {
                this.person = null as any;
            }
            if (Array.isArray(_data["retailerSuppliers"])) {
                this.retailerSuppliers = [] as any;
                for (let item of _data["retailerSuppliers"])
                    this.retailerSuppliers!.push(RetailerSupplier.fromJS(item));
            }
            else {
                this.retailerSuppliers = null as any;
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(Roles.fromJS(item));
            }
            else {
                this.roles = null as any;
            }
            if (Array.isArray(_data["roleTypes"])) {
                this.roleTypes = [] as any;
                for (let item of _data["roleTypes"])
                    this.roleTypes!.push(RoleType.fromJS(item));
            }
            else {
                this.roleTypes = null as any;
            }
            if (Array.isArray(_data["product"])) {
                this.product = [] as any;
                for (let item of _data["product"])
                    this.product!.push(Product.fromJS(item));
            }
            else {
                this.product = null as any;
            }
            if (Array.isArray(_data["productType"])) {
                this.productType = [] as any;
                for (let item of _data["productType"])
                    this.productType!.push(ProductType.fromJS(item));
            }
            else {
                this.productType = null as any;
            }
            if (Array.isArray(_data["accountProduct"])) {
                this.accountProduct = [] as any;
                for (let item of _data["accountProduct"])
                    this.accountProduct!.push(AccountProduct.fromJS(item));
            }
            else {
                this.accountProduct = null as any;
            }
            if (Array.isArray(_data["app"])) {
                this.app = [] as any;
                for (let item of _data["app"])
                    this.app!.push(App.fromJS(item));
            }
            else {
                this.app = null as any;
            }
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [] as any;
                for (let item of _data["suppliers"])
                    this.suppliers!.push(Supplier.fromJS(item));
            }
            else {
                this.suppliers = null as any;
            }
            if (Array.isArray(_data["fieldGroupTypes"])) {
                this.fieldGroupTypes = [] as any;
                for (let item of _data["fieldGroupTypes"])
                    this.fieldGroupTypes!.push(FieldGroupType.fromJS(item));
            }
            else {
                this.fieldGroupTypes = null as any;
            }
        }
    }

    static override fromJS(data: any): Status {
        data = typeof data === 'object' ? data : {};
        let result = new Status();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        data["statusName"] = this.statusName !== undefined ? this.statusName : null as any;
        if (Array.isArray(this.accountFieldgroup)) {
            data["accountFieldgroup"] = [];
            for (let item of this.accountFieldgroup)
                data["accountFieldgroup"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.activity)) {
            data["activity"] = [];
            for (let item of this.activity)
                data["activity"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.departments)) {
            data["departments"] = [];
            for (let item of this.departments)
                data["departments"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.locationOpenStatus)) {
            data["locationOpenStatus"] = [];
            for (let item of this.locationOpenStatus)
                data["locationOpenStatus"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.locationPerson)) {
            data["locationPerson"] = [];
            for (let item of this.locationPerson)
                data["locationPerson"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.locationType)) {
            data["locationType"] = [];
            for (let item of this.locationType)
                data["locationType"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.person)) {
            data["person"] = [];
            for (let item of this.person)
                data["person"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.retailerSuppliers)) {
            data["retailerSuppliers"] = [];
            for (let item of this.retailerSuppliers)
                data["retailerSuppliers"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.roleTypes)) {
            data["roleTypes"] = [];
            for (let item of this.roleTypes)
                data["roleTypes"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.product)) {
            data["product"] = [];
            for (let item of this.product)
                data["product"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.productType)) {
            data["productType"] = [];
            for (let item of this.productType)
                data["productType"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.accountProduct)) {
            data["accountProduct"] = [];
            for (let item of this.accountProduct)
                data["accountProduct"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.app)) {
            data["app"] = [];
            for (let item of this.app)
                data["app"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.fieldGroupTypes)) {
            data["fieldGroupTypes"] = [];
            for (let item of this.fieldGroupTypes)
                data["fieldGroupTypes"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): Status {
        const json = this.toJSON();
        let result = new Status();
        result.init(json);
        return result;
    }
}

export interface IStatus extends IBaseEntity {
    statusId?: number;
    statusName?: string | null;
    accountFieldgroup?: AccountFieldgroup[] | null;
    activity?: Activity[] | null;
    departments?: Department[] | null;
    locations?: Location[] | null;
    locationOpenStatus?: LocationOpenStatus[] | null;
    locationPerson?: LocationPerson[] | null;
    locationType?: LocationType[] | null;
    person?: Person[] | null;
    retailerSuppliers?: RetailerSupplier[] | null;
    roles?: Roles[] | null;
    roleTypes?: RoleType[] | null;
    product?: Product[] | null;
    productType?: ProductType[] | null;
    accountProduct?: AccountProduct[] | null;
    app?: App[] | null;
    suppliers?: Supplier[] | null;
    fieldGroupTypes?: FieldGroupType[] | null;
}

export class Activity extends BaseEntity implements IActivity {
    activityId?: number;
    activityName?: string | null;
    accountId?: number | null;
    statusId?: number | null;
    bannerId?: number;
    note?: string | null;
    isSensitive?: boolean | null;
    dueDatePerformance?: boolean | null;
    colorClass?: string | null;
    commonality?: Commonality;
    scheduleImportant?: ScheduleImportant;
    account?: Account | null;
    status?: Status | null;
    accountActivity?: AccountActivity[] | null;
    banner?: Banner | null;
    activityDashboardComponentVisibility?: ActivityDashboardComponentVisibility[] | null;

    constructor(data?: IActivity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityId = _data["activityId"] !== undefined ? _data["activityId"] : null as any;
            this.activityName = _data["activityName"] !== undefined ? _data["activityName"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            this.bannerId = _data["bannerId"] !== undefined ? _data["bannerId"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.isSensitive = _data["isSensitive"] !== undefined ? _data["isSensitive"] : null as any;
            this.dueDatePerformance = _data["dueDatePerformance"] !== undefined ? _data["dueDatePerformance"] : null as any;
            this.colorClass = _data["colorClass"] !== undefined ? _data["colorClass"] : null as any;
            this.commonality = _data["commonality"] !== undefined ? _data["commonality"] : null as any;
            this.scheduleImportant = _data["scheduleImportant"] !== undefined ? _data["scheduleImportant"] : null as any;
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : null as any;
            this.status = _data["status"] ? Status.fromJS(_data["status"]) : null as any;
            if (Array.isArray(_data["accountActivity"])) {
                this.accountActivity = [] as any;
                for (let item of _data["accountActivity"])
                    this.accountActivity!.push(AccountActivity.fromJS(item));
            }
            else {
                this.accountActivity = null as any;
            }
            this.banner = _data["banner"] ? Banner.fromJS(_data["banner"]) : null as any;
            if (Array.isArray(_data["activityDashboardComponentVisibility"])) {
                this.activityDashboardComponentVisibility = [] as any;
                for (let item of _data["activityDashboardComponentVisibility"])
                    this.activityDashboardComponentVisibility!.push(ActivityDashboardComponentVisibility.fromJS(item));
            }
            else {
                this.activityDashboardComponentVisibility = null as any;
            }
        }
    }

    static override fromJS(data: any): Activity {
        data = typeof data === 'object' ? data : {};
        let result = new Activity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId !== undefined ? this.activityId : null as any;
        data["activityName"] = this.activityName !== undefined ? this.activityName : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        data["bannerId"] = this.bannerId !== undefined ? this.bannerId : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["isSensitive"] = this.isSensitive !== undefined ? this.isSensitive : null as any;
        data["dueDatePerformance"] = this.dueDatePerformance !== undefined ? this.dueDatePerformance : null as any;
        data["colorClass"] = this.colorClass !== undefined ? this.colorClass : null as any;
        data["commonality"] = this.commonality !== undefined ? this.commonality : null as any;
        data["scheduleImportant"] = this.scheduleImportant !== undefined ? this.scheduleImportant : null as any;
        data["account"] = this.account ? this.account.toJSON() : null as any;
        data["status"] = this.status ? this.status.toJSON() : null as any;
        if (Array.isArray(this.accountActivity)) {
            data["accountActivity"] = [];
            for (let item of this.accountActivity)
                data["accountActivity"].push(item ? item.toJSON() : null as any);
        }
        data["banner"] = this.banner ? this.banner.toJSON() : null as any;
        if (Array.isArray(this.activityDashboardComponentVisibility)) {
            data["activityDashboardComponentVisibility"] = [];
            for (let item of this.activityDashboardComponentVisibility)
                data["activityDashboardComponentVisibility"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): Activity {
        const json = this.toJSON();
        let result = new Activity();
        result.init(json);
        return result;
    }
}

export interface IActivity extends IBaseEntity {
    activityId?: number;
    activityName?: string | null;
    accountId?: number | null;
    statusId?: number | null;
    bannerId?: number;
    note?: string | null;
    isSensitive?: boolean | null;
    dueDatePerformance?: boolean | null;
    colorClass?: string | null;
    commonality?: Commonality;
    scheduleImportant?: ScheduleImportant;
    account?: Account | null;
    status?: Status | null;
    accountActivity?: AccountActivity[] | null;
    banner?: Banner | null;
    activityDashboardComponentVisibility?: ActivityDashboardComponentVisibility[] | null;
}

export enum Commonality {
    Common = "common",
    CommonSecondary = "commonSecondary",
    Uncommon = "uncommon",
    Rare = "rare",
}

export enum ScheduleImportant {
    High = "high",
    CashRecyclingHigh = "cashRecyclingHigh",
    Demo = "demo",
    ProductAssembly = "productAssembly",
    Retailtainment = "retailtainment",
    Maintenance = "maintenance",
    Medium = "medium",
}

export class AccountActivity extends BaseEntity implements IAccountActivity {
    id?: number;
    accountId?: number | null;
    activityId?: number | null;
    createdByEmail?: string | null;
    updatedDate?: moment.Moment | null;
    account?: Account | null;
    activity?: Activity | null;

    constructor(data?: IAccountActivity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.activityId = _data["activityId"] !== undefined ? _data["activityId"] : null as any;
            this.createdByEmail = _data["createdByEmail"] !== undefined ? _data["createdByEmail"] : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : null as any;
            this.activity = _data["activity"] ? Activity.fromJS(_data["activity"]) : null as any;
        }
    }

    static override fromJS(data: any): AccountActivity {
        data = typeof data === 'object' ? data : {};
        let result = new AccountActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["activityId"] = this.activityId !== undefined ? this.activityId : null as any;
        data["createdByEmail"] = this.createdByEmail !== undefined ? this.createdByEmail : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        data["account"] = this.account ? this.account.toJSON() : null as any;
        data["activity"] = this.activity ? this.activity.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AccountActivity {
        const json = this.toJSON();
        let result = new AccountActivity();
        result.init(json);
        return result;
    }
}

export interface IAccountActivity extends IBaseEntity {
    id?: number;
    accountId?: number | null;
    activityId?: number | null;
    createdByEmail?: string | null;
    updatedDate?: moment.Moment | null;
    account?: Account | null;
    activity?: Activity | null;
}

export class Banner extends BaseEntity implements IBanner {
    id?: number;
    active?: boolean;
    name?: string | null;
    abbreviation?: string | null;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment;
    accountBanner?: AccountBanner[] | null;
    storeTypes?: LocationType[] | null;

    constructor(data?: IBanner) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.abbreviation = _data["abbreviation"] !== undefined ? _data["abbreviation"] : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            if (Array.isArray(_data["accountBanner"])) {
                this.accountBanner = [] as any;
                for (let item of _data["accountBanner"])
                    this.accountBanner!.push(AccountBanner.fromJS(item));
            }
            else {
                this.accountBanner = null as any;
            }
            if (Array.isArray(_data["storeTypes"])) {
                this.storeTypes = [] as any;
                for (let item of _data["storeTypes"])
                    this.storeTypes!.push(LocationType.fromJS(item));
            }
            else {
                this.storeTypes = null as any;
            }
        }
    }

    static override fromJS(data: any): Banner {
        data = typeof data === 'object' ? data : {};
        let result = new Banner();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["abbreviation"] = this.abbreviation !== undefined ? this.abbreviation : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        if (Array.isArray(this.accountBanner)) {
            data["accountBanner"] = [];
            for (let item of this.accountBanner)
                data["accountBanner"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.storeTypes)) {
            data["storeTypes"] = [];
            for (let item of this.storeTypes)
                data["storeTypes"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): Banner {
        const json = this.toJSON();
        let result = new Banner();
        result.init(json);
        return result;
    }
}

export interface IBanner extends IBaseEntity {
    id?: number;
    active?: boolean;
    name?: string | null;
    abbreviation?: string | null;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment;
    accountBanner?: AccountBanner[] | null;
    storeTypes?: LocationType[] | null;
}

export class AccountBanner extends BaseEntity implements IAccountBanner {
    accountBannerId?: number;
    accountId?: number;
    bannerId?: number;
    account?: Account | null;
    banner?: Banner | null;

    constructor(data?: IAccountBanner) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accountBannerId = _data["accountBannerId"] !== undefined ? _data["accountBannerId"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.bannerId = _data["bannerId"] !== undefined ? _data["bannerId"] : null as any;
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : null as any;
            this.banner = _data["banner"] ? Banner.fromJS(_data["banner"]) : null as any;
        }
    }

    static override fromJS(data: any): AccountBanner {
        data = typeof data === 'object' ? data : {};
        let result = new AccountBanner();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountBannerId"] = this.accountBannerId !== undefined ? this.accountBannerId : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["bannerId"] = this.bannerId !== undefined ? this.bannerId : null as any;
        data["account"] = this.account ? this.account.toJSON() : null as any;
        data["banner"] = this.banner ? this.banner.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AccountBanner {
        const json = this.toJSON();
        let result = new AccountBanner();
        result.init(json);
        return result;
    }
}

export interface IAccountBanner extends IBaseEntity {
    accountBannerId?: number;
    accountId?: number;
    bannerId?: number;
    account?: Account | null;
    banner?: Banner | null;
}

export class LocationType extends BaseEntity implements ILocationType {
    id?: number;
    storeType!: string;
    description!: string;
    statusId?: number;
    accountId?: number;
    storeImage?: string | null;
    skipImport?: boolean;
    banner?: Banner | null;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment | null;
    location?: Location[] | null;
    account?: Account | null;
    status?: Status | null;

    constructor(data?: ILocationType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.storeType = _data["storeType"] !== undefined ? _data["storeType"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.storeImage = _data["storeImage"] !== undefined ? _data["storeImage"] : null as any;
            this.skipImport = _data["skipImport"] !== undefined ? _data["skipImport"] : null as any;
            this.banner = _data["banner"] ? Banner.fromJS(_data["banner"]) : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            if (Array.isArray(_data["location"])) {
                this.location = [] as any;
                for (let item of _data["location"])
                    this.location!.push(Location.fromJS(item));
            }
            else {
                this.location = null as any;
            }
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : null as any;
            this.status = _data["status"] ? Status.fromJS(_data["status"]) : null as any;
        }
    }

    static override fromJS(data: any): LocationType {
        data = typeof data === 'object' ? data : {};
        let result = new LocationType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["storeType"] = this.storeType !== undefined ? this.storeType : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["storeImage"] = this.storeImage !== undefined ? this.storeImage : null as any;
        data["skipImport"] = this.skipImport !== undefined ? this.skipImport : null as any;
        data["banner"] = this.banner ? this.banner.toJSON() : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        if (Array.isArray(this.location)) {
            data["location"] = [];
            for (let item of this.location)
                data["location"].push(item ? item.toJSON() : null as any);
        }
        data["account"] = this.account ? this.account.toJSON() : null as any;
        data["status"] = this.status ? this.status.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): LocationType {
        const json = this.toJSON();
        let result = new LocationType();
        result.init(json);
        return result;
    }
}

export interface ILocationType extends IBaseEntity {
    id?: number;
    storeType: string;
    description: string;
    statusId?: number;
    accountId?: number;
    storeImage?: string | null;
    skipImport?: boolean;
    banner?: Banner | null;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment | null;
    location?: Location[] | null;
    account?: Account | null;
    status?: Status | null;
}

export class Location extends BaseEntity implements ILocation {
    locationId?: number;
    wattLocationId?: string | null;
    accountId?: number;
    number!: string;
    address1!: string;
    address2?: string | null;
    city!: string;
    state!: string;
    zip!: string;
    country?: string | null;
    phone?: string | null;
    qlocationId?: number | null;
    statusId?: number;
    note?: string | null;
    image?: string | null;
    timeZone?: string | null;
    storeHours?: string | null;
    iconUrl?: string | null;
    openStatusId?: number | null;
    storeTypeId?: number | null;
    lat?: number | null;
    long?: number | null;
    retailerLat?: number | null;
    retailerLong?: number | null;
    timeZoneName?: string | null;
    retailerReference?: string | null;
    syncId?: string;
    openDate?: moment.Moment | null;
    closeDate?: moment.Moment | null;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment | null;
    wspAccountId?: number | null;
    event?: Event[] | null;
    locationPerson?: LocationPerson[] | null;
    account?: Account | null;
    openStatus?: LocationOpenStatus | null;
    status?: Status | null;
    storeType?: LocationType | null;
    accountLocationGroupValues?: AccountLocationGroupValue[] | null;
    storeManagers?: StoreManagerLookup[] | null;
    personLocationPermissions?: PersonLocationPermission[] | null;

    constructor(data?: ILocation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : null as any;
            this.wattLocationId = _data["wattLocationId"] !== undefined ? _data["wattLocationId"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.number = _data["number"] !== undefined ? _data["number"] : null as any;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : null as any;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.qlocationId = _data["qlocationId"] !== undefined ? _data["qlocationId"] : null as any;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.image = _data["image"] !== undefined ? _data["image"] : null as any;
            this.timeZone = _data["timeZone"] !== undefined ? _data["timeZone"] : null as any;
            this.storeHours = _data["storeHours"] !== undefined ? _data["storeHours"] : null as any;
            this.iconUrl = _data["iconUrl"] !== undefined ? _data["iconUrl"] : null as any;
            this.openStatusId = _data["openStatusId"] !== undefined ? _data["openStatusId"] : null as any;
            this.storeTypeId = _data["storeTypeId"] !== undefined ? _data["storeTypeId"] : null as any;
            this.lat = _data["lat"] !== undefined ? _data["lat"] : null as any;
            this.long = _data["long"] !== undefined ? _data["long"] : null as any;
            this.retailerLat = _data["retailerLat"] !== undefined ? _data["retailerLat"] : null as any;
            this.retailerLong = _data["retailerLong"] !== undefined ? _data["retailerLong"] : null as any;
            this.timeZoneName = _data["timeZoneName"] !== undefined ? _data["timeZoneName"] : null as any;
            this.retailerReference = _data["retailerReference"] !== undefined ? _data["retailerReference"] : null as any;
            this.syncId = _data["syncId"] !== undefined ? _data["syncId"] : null as any;
            this.openDate = _data["openDate"] ? moment(_data["openDate"].toString()) : null as any;
            this.closeDate = _data["closeDate"] ? moment(_data["closeDate"].toString()) : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            this.wspAccountId = _data["wspAccountId"] !== undefined ? _data["wspAccountId"] : null as any;
            if (Array.isArray(_data["event"])) {
                this.event = [] as any;
                for (let item of _data["event"])
                    this.event!.push(Event.fromJS(item));
            }
            else {
                this.event = null as any;
            }
            if (Array.isArray(_data["locationPerson"])) {
                this.locationPerson = [] as any;
                for (let item of _data["locationPerson"])
                    this.locationPerson!.push(LocationPerson.fromJS(item));
            }
            else {
                this.locationPerson = null as any;
            }
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : null as any;
            this.openStatus = _data["openStatus"] ? LocationOpenStatus.fromJS(_data["openStatus"]) : null as any;
            this.status = _data["status"] ? Status.fromJS(_data["status"]) : null as any;
            this.storeType = _data["storeType"] ? LocationType.fromJS(_data["storeType"]) : null as any;
            if (Array.isArray(_data["accountLocationGroupValues"])) {
                this.accountLocationGroupValues = [] as any;
                for (let item of _data["accountLocationGroupValues"])
                    this.accountLocationGroupValues!.push(AccountLocationGroupValue.fromJS(item));
            }
            else {
                this.accountLocationGroupValues = null as any;
            }
            if (Array.isArray(_data["storeManagers"])) {
                this.storeManagers = [] as any;
                for (let item of _data["storeManagers"])
                    this.storeManagers!.push(StoreManagerLookup.fromJS(item));
            }
            else {
                this.storeManagers = null as any;
            }
            if (Array.isArray(_data["personLocationPermissions"])) {
                this.personLocationPermissions = [] as any;
                for (let item of _data["personLocationPermissions"])
                    this.personLocationPermissions!.push(PersonLocationPermission.fromJS(item));
            }
            else {
                this.personLocationPermissions = null as any;
            }
        }
    }

    static override fromJS(data: any): Location {
        data = typeof data === 'object' ? data : {};
        let result = new Location();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId !== undefined ? this.locationId : null as any;
        data["wattLocationId"] = this.wattLocationId !== undefined ? this.wattLocationId : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["number"] = this.number !== undefined ? this.number : null as any;
        data["address1"] = this.address1 !== undefined ? this.address1 : null as any;
        data["address2"] = this.address2 !== undefined ? this.address2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["qlocationId"] = this.qlocationId !== undefined ? this.qlocationId : null as any;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["image"] = this.image !== undefined ? this.image : null as any;
        data["timeZone"] = this.timeZone !== undefined ? this.timeZone : null as any;
        data["storeHours"] = this.storeHours !== undefined ? this.storeHours : null as any;
        data["iconUrl"] = this.iconUrl !== undefined ? this.iconUrl : null as any;
        data["openStatusId"] = this.openStatusId !== undefined ? this.openStatusId : null as any;
        data["storeTypeId"] = this.storeTypeId !== undefined ? this.storeTypeId : null as any;
        data["lat"] = this.lat !== undefined ? this.lat : null as any;
        data["long"] = this.long !== undefined ? this.long : null as any;
        data["retailerLat"] = this.retailerLat !== undefined ? this.retailerLat : null as any;
        data["retailerLong"] = this.retailerLong !== undefined ? this.retailerLong : null as any;
        data["timeZoneName"] = this.timeZoneName !== undefined ? this.timeZoneName : null as any;
        data["retailerReference"] = this.retailerReference !== undefined ? this.retailerReference : null as any;
        data["syncId"] = this.syncId !== undefined ? this.syncId : null as any;
        data["openDate"] = this.openDate ? this.openDate.toISOString() : null as any;
        data["closeDate"] = this.closeDate ? this.closeDate.toISOString() : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        data["wspAccountId"] = this.wspAccountId !== undefined ? this.wspAccountId : null as any;
        if (Array.isArray(this.event)) {
            data["event"] = [];
            for (let item of this.event)
                data["event"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.locationPerson)) {
            data["locationPerson"] = [];
            for (let item of this.locationPerson)
                data["locationPerson"].push(item ? item.toJSON() : null as any);
        }
        data["account"] = this.account ? this.account.toJSON() : null as any;
        data["openStatus"] = this.openStatus ? this.openStatus.toJSON() : null as any;
        data["status"] = this.status ? this.status.toJSON() : null as any;
        data["storeType"] = this.storeType ? this.storeType.toJSON() : null as any;
        if (Array.isArray(this.accountLocationGroupValues)) {
            data["accountLocationGroupValues"] = [];
            for (let item of this.accountLocationGroupValues)
                data["accountLocationGroupValues"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.storeManagers)) {
            data["storeManagers"] = [];
            for (let item of this.storeManagers)
                data["storeManagers"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.personLocationPermissions)) {
            data["personLocationPermissions"] = [];
            for (let item of this.personLocationPermissions)
                data["personLocationPermissions"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): Location {
        const json = this.toJSON();
        let result = new Location();
        result.init(json);
        return result;
    }
}

export interface ILocation extends IBaseEntity {
    locationId?: number;
    wattLocationId?: string | null;
    accountId?: number;
    number: string;
    address1: string;
    address2?: string | null;
    city: string;
    state: string;
    zip: string;
    country?: string | null;
    phone?: string | null;
    qlocationId?: number | null;
    statusId?: number;
    note?: string | null;
    image?: string | null;
    timeZone?: string | null;
    storeHours?: string | null;
    iconUrl?: string | null;
    openStatusId?: number | null;
    storeTypeId?: number | null;
    lat?: number | null;
    long?: number | null;
    retailerLat?: number | null;
    retailerLong?: number | null;
    timeZoneName?: string | null;
    retailerReference?: string | null;
    syncId?: string;
    openDate?: moment.Moment | null;
    closeDate?: moment.Moment | null;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment | null;
    wspAccountId?: number | null;
    event?: Event[] | null;
    locationPerson?: LocationPerson[] | null;
    account?: Account | null;
    openStatus?: LocationOpenStatus | null;
    status?: Status | null;
    storeType?: LocationType | null;
    accountLocationGroupValues?: AccountLocationGroupValue[] | null;
    storeManagers?: StoreManagerLookup[] | null;
    personLocationPermissions?: PersonLocationPermission[] | null;
}

export class Event extends BaseEntity implements IEvent {
    eventId?: number;
    timeIn?: moment.Moment | null;
    timeInSystem?: moment.Moment | null;
    signInException?: boolean;
    timeOut?: moment.Moment | null;
    timeOutSystem?: moment.Moment | null;
    signOutException?: boolean;
    wattLocationId?: string | null;
    storeNumber?: string | null;
    personId?: number;
    authStatus?: number | null;
    retailerAccountId?: number;
    invoiced?: boolean;
    signInLat?: number | null;
    signInLong?: number | null;
    signOutLat?: number | null;
    signOutLong?: number | null;
    forcedCheckOut?: boolean | null;
    distCheckIn?: number | null;
    distCheckOut?: number | null;
    checkInSource?: EventSource;
    checkOutSource?: EventSource;
    createdDate?: moment.Moment | null;
    updatedDate?: moment.Moment | null;
    localTimeOut?: moment.Moment | null;
    localTimeOutSystem?: moment.Moment | null;
    localTimeIn?: moment.Moment | null;
    localTimeInSystem?: moment.Moment | null;
    isWirelessServiceProvider?: boolean;
    deleted?: boolean;
    wattVisitId?: string | null;
    wattVisitUpdatedDate?: moment.Moment | null;
    syncId?: string;
    location?: Location | null;
    person?: Person | null;
    retailerAccount?: Account | null;
    items?: EventItem[] | null;
    accountId?: number;
    bannerId?: number;

    constructor(data?: IEvent) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.eventId = _data["eventId"] !== undefined ? _data["eventId"] : null as any;
            this.timeIn = _data["timeIn"] ? moment(_data["timeIn"].toString()) : null as any;
            this.timeInSystem = _data["timeInSystem"] ? moment(_data["timeInSystem"].toString()) : null as any;
            this.signInException = _data["signInException"] !== undefined ? _data["signInException"] : null as any;
            this.timeOut = _data["timeOut"] ? moment(_data["timeOut"].toString()) : null as any;
            this.timeOutSystem = _data["timeOutSystem"] ? moment(_data["timeOutSystem"].toString()) : null as any;
            this.signOutException = _data["signOutException"] !== undefined ? _data["signOutException"] : null as any;
            this.wattLocationId = _data["wattLocationId"] !== undefined ? _data["wattLocationId"] : null as any;
            this.storeNumber = _data["storeNumber"] !== undefined ? _data["storeNumber"] : null as any;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null as any;
            this.authStatus = _data["authStatus"] !== undefined ? _data["authStatus"] : null as any;
            this.retailerAccountId = _data["retailerAccountId"] !== undefined ? _data["retailerAccountId"] : null as any;
            this.invoiced = _data["invoiced"] !== undefined ? _data["invoiced"] : null as any;
            this.signInLat = _data["signInLat"] !== undefined ? _data["signInLat"] : null as any;
            this.signInLong = _data["signInLong"] !== undefined ? _data["signInLong"] : null as any;
            this.signOutLat = _data["signOutLat"] !== undefined ? _data["signOutLat"] : null as any;
            this.signOutLong = _data["signOutLong"] !== undefined ? _data["signOutLong"] : null as any;
            this.forcedCheckOut = _data["forcedCheckOut"] !== undefined ? _data["forcedCheckOut"] : null as any;
            this.distCheckIn = _data["distCheckIn"] !== undefined ? _data["distCheckIn"] : null as any;
            this.distCheckOut = _data["distCheckOut"] !== undefined ? _data["distCheckOut"] : null as any;
            this.checkInSource = _data["checkInSource"] !== undefined ? _data["checkInSource"] : null as any;
            this.checkOutSource = _data["checkOutSource"] !== undefined ? _data["checkOutSource"] : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            this.localTimeOut = _data["localTimeOut"] ? moment(_data["localTimeOut"].toString()) : null as any;
            this.localTimeOutSystem = _data["localTimeOutSystem"] ? moment(_data["localTimeOutSystem"].toString()) : null as any;
            this.localTimeIn = _data["localTimeIn"] ? moment(_data["localTimeIn"].toString()) : null as any;
            this.localTimeInSystem = _data["localTimeInSystem"] ? moment(_data["localTimeInSystem"].toString()) : null as any;
            this.isWirelessServiceProvider = _data["isWirelessServiceProvider"] !== undefined ? _data["isWirelessServiceProvider"] : null as any;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : null as any;
            this.wattVisitId = _data["wattVisitId"] !== undefined ? _data["wattVisitId"] : null as any;
            this.wattVisitUpdatedDate = _data["wattVisitUpdatedDate"] ? moment(_data["wattVisitUpdatedDate"].toString()) : null as any;
            this.syncId = _data["syncId"] !== undefined ? _data["syncId"] : null as any;
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : null as any;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : null as any;
            this.retailerAccount = _data["retailerAccount"] ? Account.fromJS(_data["retailerAccount"]) : null as any;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EventItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.bannerId = _data["bannerId"] !== undefined ? _data["bannerId"] : null as any;
        }
    }

    static override fromJS(data: any): Event {
        data = typeof data === 'object' ? data : {};
        let result = new Event();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId !== undefined ? this.eventId : null as any;
        data["timeIn"] = this.timeIn ? this.timeIn.toISOString() : null as any;
        data["timeInSystem"] = this.timeInSystem ? this.timeInSystem.toISOString() : null as any;
        data["signInException"] = this.signInException !== undefined ? this.signInException : null as any;
        data["timeOut"] = this.timeOut ? this.timeOut.toISOString() : null as any;
        data["timeOutSystem"] = this.timeOutSystem ? this.timeOutSystem.toISOString() : null as any;
        data["signOutException"] = this.signOutException !== undefined ? this.signOutException : null as any;
        data["wattLocationId"] = this.wattLocationId !== undefined ? this.wattLocationId : null as any;
        data["storeNumber"] = this.storeNumber !== undefined ? this.storeNumber : null as any;
        data["personId"] = this.personId !== undefined ? this.personId : null as any;
        data["authStatus"] = this.authStatus !== undefined ? this.authStatus : null as any;
        data["retailerAccountId"] = this.retailerAccountId !== undefined ? this.retailerAccountId : null as any;
        data["invoiced"] = this.invoiced !== undefined ? this.invoiced : null as any;
        data["signInLat"] = this.signInLat !== undefined ? this.signInLat : null as any;
        data["signInLong"] = this.signInLong !== undefined ? this.signInLong : null as any;
        data["signOutLat"] = this.signOutLat !== undefined ? this.signOutLat : null as any;
        data["signOutLong"] = this.signOutLong !== undefined ? this.signOutLong : null as any;
        data["forcedCheckOut"] = this.forcedCheckOut !== undefined ? this.forcedCheckOut : null as any;
        data["distCheckIn"] = this.distCheckIn !== undefined ? this.distCheckIn : null as any;
        data["distCheckOut"] = this.distCheckOut !== undefined ? this.distCheckOut : null as any;
        data["checkInSource"] = this.checkInSource !== undefined ? this.checkInSource : null as any;
        data["checkOutSource"] = this.checkOutSource !== undefined ? this.checkOutSource : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        data["localTimeOut"] = this.localTimeOut ? this.localTimeOut.toISOString() : null as any;
        data["localTimeOutSystem"] = this.localTimeOutSystem ? this.localTimeOutSystem.toISOString() : null as any;
        data["localTimeIn"] = this.localTimeIn ? this.localTimeIn.toISOString() : null as any;
        data["localTimeInSystem"] = this.localTimeInSystem ? this.localTimeInSystem.toISOString() : null as any;
        data["isWirelessServiceProvider"] = this.isWirelessServiceProvider !== undefined ? this.isWirelessServiceProvider : null as any;
        data["deleted"] = this.deleted !== undefined ? this.deleted : null as any;
        data["wattVisitId"] = this.wattVisitId !== undefined ? this.wattVisitId : null as any;
        data["wattVisitUpdatedDate"] = this.wattVisitUpdatedDate ? this.wattVisitUpdatedDate.toISOString() : null as any;
        data["syncId"] = this.syncId !== undefined ? this.syncId : null as any;
        data["location"] = this.location ? this.location.toJSON() : null as any;
        data["person"] = this.person ? this.person.toJSON() : null as any;
        data["retailerAccount"] = this.retailerAccount ? this.retailerAccount.toJSON() : null as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["bannerId"] = this.bannerId !== undefined ? this.bannerId : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): Event {
        const json = this.toJSON();
        let result = new Event();
        result.init(json);
        return result;
    }
}

export interface IEvent extends IBaseEntity {
    eventId?: number;
    timeIn?: moment.Moment | null;
    timeInSystem?: moment.Moment | null;
    signInException?: boolean;
    timeOut?: moment.Moment | null;
    timeOutSystem?: moment.Moment | null;
    signOutException?: boolean;
    wattLocationId?: string | null;
    storeNumber?: string | null;
    personId?: number;
    authStatus?: number | null;
    retailerAccountId?: number;
    invoiced?: boolean;
    signInLat?: number | null;
    signInLong?: number | null;
    signOutLat?: number | null;
    signOutLong?: number | null;
    forcedCheckOut?: boolean | null;
    distCheckIn?: number | null;
    distCheckOut?: number | null;
    checkInSource?: EventSource;
    checkOutSource?: EventSource;
    createdDate?: moment.Moment | null;
    updatedDate?: moment.Moment | null;
    localTimeOut?: moment.Moment | null;
    localTimeOutSystem?: moment.Moment | null;
    localTimeIn?: moment.Moment | null;
    localTimeInSystem?: moment.Moment | null;
    isWirelessServiceProvider?: boolean;
    deleted?: boolean;
    wattVisitId?: string | null;
    wattVisitUpdatedDate?: moment.Moment | null;
    syncId?: string;
    location?: Location | null;
    person?: Person | null;
    retailerAccount?: Account | null;
    items?: EventItem[] | null;
    accountId?: number;
    bannerId?: number;
}

export enum EventSource {
    WmtVolt = "wmtVolt",
    InStoreScanner = "inStoreScanner",
    ServiceChannel = "serviceChannel",
    ProviderApi = "providerApi",
    Test = "test",
}

export class Person extends BaseEntity implements IPerson {
    personId?: number;
    number!: string;
    nickName?: string | null;
    operatorName?: string | null;
    firstName?: string | null;
    mi?: string | null;
    lastName?: string | null;
    email!: string;
    loginAttempts?: number | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    phone?: string | null;
    mobile?: string | null;
    imageUrl?: string | null;
    imageUrlOriginal?: string | null;
    dateCreated?: moment.Moment;
    statusId?: number;
    note?: string | null;
    isForgotPwdSend?: boolean | null;
    dateForgotPwdSent?: moment.Moment | null;
    rolesId?: number | null;
    accountId?: number | null;
    managerId?: number | null;
    readEula?: moment.Moment | null;
    approvalStatusId?: number | null;
    photoDenialReason?: string | null;
    letterPrintedDate?: moment.Moment | null;
    badgePrintedDate?: moment.Moment | null;
    awaitingBadge?: boolean;
    badgeNeverReceived?: boolean;
    badgeScanned?: boolean;
    authToken?: string | null;
    syncId?: string;
    identityServerUserId?: string | null;
    department?: string | null;
    wmtVoltFeatures?: WmtVoltFeatures;
    title?: string | null;
    manager?: string | null;
    importBatch?: string | null;
    cultureName?: string | null;
    userName?: string | null;
    anonymized?: boolean;
    ignoreDormant?: boolean;
    wattBadgeId?: string | null;
    ssoLastSync?: number | null;
    accountPerson?: AccountPerson[] | null;
    event?: Event[] | null;
    locationPerson?: LocationPerson[] | null;
    personBadge?: PersonBadge[] | null;
    ssoTokens?: SsoToken[] | null;
    badgeTransactionAudit?: BadgeTransactionAudit[] | null;
    account?: Account | null;
    approvalStatus?: ApprovalStatus | null;
    roles?: Roles | null;
    status?: Status | null;
    personTags?: PersonTag[] | null;
    badgeReplacements?: BadgeReplacement[] | null;
    storeManagerLocations?: StoreManagerLookup[] | null;
    personPermissions?: PersonPermission[] | null;
    personNotifications?: PersonNotification[] | null;
    personLocationPermissions?: PersonLocationPermission[] | null;
    accessReviewStatus?: AccessReviewStatus;
    userCertificationSummary?: UserCertificationSummary | null;

    constructor(data?: IPerson) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null as any;
            this.number = _data["number"] !== undefined ? _data["number"] : null as any;
            this.nickName = _data["nickName"] !== undefined ? _data["nickName"] : null as any;
            this.operatorName = _data["operatorName"] !== undefined ? _data["operatorName"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.mi = _data["mi"] !== undefined ? _data["mi"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.loginAttempts = _data["loginAttempts"] !== undefined ? _data["loginAttempts"] : null as any;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : null as any;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.mobile = _data["mobile"] !== undefined ? _data["mobile"] : null as any;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : null as any;
            this.imageUrlOriginal = _data["imageUrlOriginal"] !== undefined ? _data["imageUrlOriginal"] : null as any;
            this.dateCreated = _data["dateCreated"] ? moment(_data["dateCreated"].toString()) : null as any;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.isForgotPwdSend = _data["isForgotPwdSend"] !== undefined ? _data["isForgotPwdSend"] : null as any;
            this.dateForgotPwdSent = _data["dateForgotPwdSent"] ? moment(_data["dateForgotPwdSent"].toString()) : null as any;
            this.rolesId = _data["rolesId"] !== undefined ? _data["rolesId"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.managerId = _data["managerId"] !== undefined ? _data["managerId"] : null as any;
            this.readEula = _data["readEula"] ? moment(_data["readEula"].toString()) : null as any;
            this.approvalStatusId = _data["approvalStatusId"] !== undefined ? _data["approvalStatusId"] : null as any;
            this.photoDenialReason = _data["photoDenialReason"] !== undefined ? _data["photoDenialReason"] : null as any;
            this.letterPrintedDate = _data["letterPrintedDate"] ? moment(_data["letterPrintedDate"].toString()) : null as any;
            this.badgePrintedDate = _data["badgePrintedDate"] ? moment(_data["badgePrintedDate"].toString()) : null as any;
            this.awaitingBadge = _data["awaitingBadge"] !== undefined ? _data["awaitingBadge"] : null as any;
            this.badgeNeverReceived = _data["badgeNeverReceived"] !== undefined ? _data["badgeNeverReceived"] : null as any;
            this.badgeScanned = _data["badgeScanned"] !== undefined ? _data["badgeScanned"] : null as any;
            this.authToken = _data["authToken"] !== undefined ? _data["authToken"] : null as any;
            this.syncId = _data["syncId"] !== undefined ? _data["syncId"] : null as any;
            this.identityServerUserId = _data["identityServerUserId"] !== undefined ? _data["identityServerUserId"] : null as any;
            this.department = _data["department"] !== undefined ? _data["department"] : null as any;
            this.wmtVoltFeatures = _data["wmtVoltFeatures"] !== undefined ? _data["wmtVoltFeatures"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.manager = _data["manager"] !== undefined ? _data["manager"] : null as any;
            this.importBatch = _data["importBatch"] !== undefined ? _data["importBatch"] : null as any;
            this.cultureName = _data["cultureName"] !== undefined ? _data["cultureName"] : null as any;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null as any;
            this.anonymized = _data["anonymized"] !== undefined ? _data["anonymized"] : null as any;
            this.ignoreDormant = _data["ignoreDormant"] !== undefined ? _data["ignoreDormant"] : null as any;
            this.wattBadgeId = _data["wattBadgeId"] !== undefined ? _data["wattBadgeId"] : null as any;
            this.ssoLastSync = _data["ssoLastSync"] !== undefined ? _data["ssoLastSync"] : null as any;
            if (Array.isArray(_data["accountPerson"])) {
                this.accountPerson = [] as any;
                for (let item of _data["accountPerson"])
                    this.accountPerson!.push(AccountPerson.fromJS(item));
            }
            else {
                this.accountPerson = null as any;
            }
            if (Array.isArray(_data["event"])) {
                this.event = [] as any;
                for (let item of _data["event"])
                    this.event!.push(Event.fromJS(item));
            }
            else {
                this.event = null as any;
            }
            if (Array.isArray(_data["locationPerson"])) {
                this.locationPerson = [] as any;
                for (let item of _data["locationPerson"])
                    this.locationPerson!.push(LocationPerson.fromJS(item));
            }
            else {
                this.locationPerson = null as any;
            }
            if (Array.isArray(_data["personBadge"])) {
                this.personBadge = [] as any;
                for (let item of _data["personBadge"])
                    this.personBadge!.push(PersonBadge.fromJS(item));
            }
            else {
                this.personBadge = null as any;
            }
            if (Array.isArray(_data["ssoTokens"])) {
                this.ssoTokens = [] as any;
                for (let item of _data["ssoTokens"])
                    this.ssoTokens!.push(SsoToken.fromJS(item));
            }
            else {
                this.ssoTokens = null as any;
            }
            if (Array.isArray(_data["badgeTransactionAudit"])) {
                this.badgeTransactionAudit = [] as any;
                for (let item of _data["badgeTransactionAudit"])
                    this.badgeTransactionAudit!.push(BadgeTransactionAudit.fromJS(item));
            }
            else {
                this.badgeTransactionAudit = null as any;
            }
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : null as any;
            this.approvalStatus = _data["approvalStatus"] ? ApprovalStatus.fromJS(_data["approvalStatus"]) : null as any;
            this.roles = _data["roles"] ? Roles.fromJS(_data["roles"]) : null as any;
            this.status = _data["status"] ? Status.fromJS(_data["status"]) : null as any;
            if (Array.isArray(_data["personTags"])) {
                this.personTags = [] as any;
                for (let item of _data["personTags"])
                    this.personTags!.push(PersonTag.fromJS(item));
            }
            else {
                this.personTags = null as any;
            }
            if (Array.isArray(_data["badgeReplacements"])) {
                this.badgeReplacements = [] as any;
                for (let item of _data["badgeReplacements"])
                    this.badgeReplacements!.push(BadgeReplacement.fromJS(item));
            }
            else {
                this.badgeReplacements = null as any;
            }
            if (Array.isArray(_data["storeManagerLocations"])) {
                this.storeManagerLocations = [] as any;
                for (let item of _data["storeManagerLocations"])
                    this.storeManagerLocations!.push(StoreManagerLookup.fromJS(item));
            }
            else {
                this.storeManagerLocations = null as any;
            }
            if (Array.isArray(_data["personPermissions"])) {
                this.personPermissions = [] as any;
                for (let item of _data["personPermissions"])
                    this.personPermissions!.push(PersonPermission.fromJS(item));
            }
            else {
                this.personPermissions = null as any;
            }
            if (Array.isArray(_data["personNotifications"])) {
                this.personNotifications = [] as any;
                for (let item of _data["personNotifications"])
                    this.personNotifications!.push(PersonNotification.fromJS(item));
            }
            else {
                this.personNotifications = null as any;
            }
            if (Array.isArray(_data["personLocationPermissions"])) {
                this.personLocationPermissions = [] as any;
                for (let item of _data["personLocationPermissions"])
                    this.personLocationPermissions!.push(PersonLocationPermission.fromJS(item));
            }
            else {
                this.personLocationPermissions = null as any;
            }
            this.accessReviewStatus = _data["accessReviewStatus"] !== undefined ? _data["accessReviewStatus"] : null as any;
            this.userCertificationSummary = _data["userCertificationSummary"] ? UserCertificationSummary.fromJS(_data["userCertificationSummary"]) : null as any;
        }
    }

    static override fromJS(data: any): Person {
        data = typeof data === 'object' ? data : {};
        let result = new Person();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId !== undefined ? this.personId : null as any;
        data["number"] = this.number !== undefined ? this.number : null as any;
        data["nickName"] = this.nickName !== undefined ? this.nickName : null as any;
        data["operatorName"] = this.operatorName !== undefined ? this.operatorName : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["mi"] = this.mi !== undefined ? this.mi : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["loginAttempts"] = this.loginAttempts !== undefined ? this.loginAttempts : null as any;
        data["address1"] = this.address1 !== undefined ? this.address1 : null as any;
        data["address2"] = this.address2 !== undefined ? this.address2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["mobile"] = this.mobile !== undefined ? this.mobile : null as any;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : null as any;
        data["imageUrlOriginal"] = this.imageUrlOriginal !== undefined ? this.imageUrlOriginal : null as any;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : null as any;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["isForgotPwdSend"] = this.isForgotPwdSend !== undefined ? this.isForgotPwdSend : null as any;
        data["dateForgotPwdSent"] = this.dateForgotPwdSent ? this.dateForgotPwdSent.toISOString() : null as any;
        data["rolesId"] = this.rolesId !== undefined ? this.rolesId : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["managerId"] = this.managerId !== undefined ? this.managerId : null as any;
        data["readEula"] = this.readEula ? this.readEula.toISOString() : null as any;
        data["approvalStatusId"] = this.approvalStatusId !== undefined ? this.approvalStatusId : null as any;
        data["photoDenialReason"] = this.photoDenialReason !== undefined ? this.photoDenialReason : null as any;
        data["letterPrintedDate"] = this.letterPrintedDate ? this.letterPrintedDate.toISOString() : null as any;
        data["badgePrintedDate"] = this.badgePrintedDate ? this.badgePrintedDate.toISOString() : null as any;
        data["awaitingBadge"] = this.awaitingBadge !== undefined ? this.awaitingBadge : null as any;
        data["badgeNeverReceived"] = this.badgeNeverReceived !== undefined ? this.badgeNeverReceived : null as any;
        data["badgeScanned"] = this.badgeScanned !== undefined ? this.badgeScanned : null as any;
        data["authToken"] = this.authToken !== undefined ? this.authToken : null as any;
        data["syncId"] = this.syncId !== undefined ? this.syncId : null as any;
        data["identityServerUserId"] = this.identityServerUserId !== undefined ? this.identityServerUserId : null as any;
        data["department"] = this.department !== undefined ? this.department : null as any;
        data["wmtVoltFeatures"] = this.wmtVoltFeatures !== undefined ? this.wmtVoltFeatures : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["manager"] = this.manager !== undefined ? this.manager : null as any;
        data["importBatch"] = this.importBatch !== undefined ? this.importBatch : null as any;
        data["cultureName"] = this.cultureName !== undefined ? this.cultureName : null as any;
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        data["anonymized"] = this.anonymized !== undefined ? this.anonymized : null as any;
        data["ignoreDormant"] = this.ignoreDormant !== undefined ? this.ignoreDormant : null as any;
        data["wattBadgeId"] = this.wattBadgeId !== undefined ? this.wattBadgeId : null as any;
        data["ssoLastSync"] = this.ssoLastSync !== undefined ? this.ssoLastSync : null as any;
        if (Array.isArray(this.accountPerson)) {
            data["accountPerson"] = [];
            for (let item of this.accountPerson)
                data["accountPerson"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.event)) {
            data["event"] = [];
            for (let item of this.event)
                data["event"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.locationPerson)) {
            data["locationPerson"] = [];
            for (let item of this.locationPerson)
                data["locationPerson"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.personBadge)) {
            data["personBadge"] = [];
            for (let item of this.personBadge)
                data["personBadge"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.ssoTokens)) {
            data["ssoTokens"] = [];
            for (let item of this.ssoTokens)
                data["ssoTokens"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.badgeTransactionAudit)) {
            data["badgeTransactionAudit"] = [];
            for (let item of this.badgeTransactionAudit)
                data["badgeTransactionAudit"].push(item ? item.toJSON() : null as any);
        }
        data["account"] = this.account ? this.account.toJSON() : null as any;
        data["approvalStatus"] = this.approvalStatus ? this.approvalStatus.toJSON() : null as any;
        data["roles"] = this.roles ? this.roles.toJSON() : null as any;
        data["status"] = this.status ? this.status.toJSON() : null as any;
        if (Array.isArray(this.personTags)) {
            data["personTags"] = [];
            for (let item of this.personTags)
                data["personTags"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.badgeReplacements)) {
            data["badgeReplacements"] = [];
            for (let item of this.badgeReplacements)
                data["badgeReplacements"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.storeManagerLocations)) {
            data["storeManagerLocations"] = [];
            for (let item of this.storeManagerLocations)
                data["storeManagerLocations"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.personPermissions)) {
            data["personPermissions"] = [];
            for (let item of this.personPermissions)
                data["personPermissions"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.personNotifications)) {
            data["personNotifications"] = [];
            for (let item of this.personNotifications)
                data["personNotifications"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.personLocationPermissions)) {
            data["personLocationPermissions"] = [];
            for (let item of this.personLocationPermissions)
                data["personLocationPermissions"].push(item ? item.toJSON() : null as any);
        }
        data["accessReviewStatus"] = this.accessReviewStatus !== undefined ? this.accessReviewStatus : null as any;
        data["userCertificationSummary"] = this.userCertificationSummary ? this.userCertificationSummary.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): Person {
        const json = this.toJSON();
        let result = new Person();
        result.init(json);
        return result;
    }
}

export interface IPerson extends IBaseEntity {
    personId?: number;
    number: string;
    nickName?: string | null;
    operatorName?: string | null;
    firstName?: string | null;
    mi?: string | null;
    lastName?: string | null;
    email: string;
    loginAttempts?: number | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    phone?: string | null;
    mobile?: string | null;
    imageUrl?: string | null;
    imageUrlOriginal?: string | null;
    dateCreated?: moment.Moment;
    statusId?: number;
    note?: string | null;
    isForgotPwdSend?: boolean | null;
    dateForgotPwdSent?: moment.Moment | null;
    rolesId?: number | null;
    accountId?: number | null;
    managerId?: number | null;
    readEula?: moment.Moment | null;
    approvalStatusId?: number | null;
    photoDenialReason?: string | null;
    letterPrintedDate?: moment.Moment | null;
    badgePrintedDate?: moment.Moment | null;
    awaitingBadge?: boolean;
    badgeNeverReceived?: boolean;
    badgeScanned?: boolean;
    authToken?: string | null;
    syncId?: string;
    identityServerUserId?: string | null;
    department?: string | null;
    wmtVoltFeatures?: WmtVoltFeatures;
    title?: string | null;
    manager?: string | null;
    importBatch?: string | null;
    cultureName?: string | null;
    userName?: string | null;
    anonymized?: boolean;
    ignoreDormant?: boolean;
    wattBadgeId?: string | null;
    ssoLastSync?: number | null;
    accountPerson?: AccountPerson[] | null;
    event?: Event[] | null;
    locationPerson?: LocationPerson[] | null;
    personBadge?: PersonBadge[] | null;
    ssoTokens?: SsoToken[] | null;
    badgeTransactionAudit?: BadgeTransactionAudit[] | null;
    account?: Account | null;
    approvalStatus?: ApprovalStatus | null;
    roles?: Roles | null;
    status?: Status | null;
    personTags?: PersonTag[] | null;
    badgeReplacements?: BadgeReplacement[] | null;
    storeManagerLocations?: StoreManagerLookup[] | null;
    personPermissions?: PersonPermission[] | null;
    personNotifications?: PersonNotification[] | null;
    personLocationPermissions?: PersonLocationPermission[] | null;
    accessReviewStatus?: AccessReviewStatus;
    userCertificationSummary?: UserCertificationSummary | null;
}

export enum WmtVoltFeatures {
    None = "none",
    Training = "training",
    CheckInCheckOut = "checkInCheckOut",
    Salesfloor = "salesfloor",
    PickList = "pickList",
    All = "default",
    Default = "default",
}

export class AccountPerson extends BaseEntity implements IAccountPerson {
    accountPersonId?: number;
    accountId?: number;
    personId?: number;
    appId?: number | null;
    account?: Account | null;
    person?: Person | null;

    constructor(data?: IAccountPerson) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accountPersonId = _data["accountPersonId"] !== undefined ? _data["accountPersonId"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null as any;
            this.appId = _data["appId"] !== undefined ? _data["appId"] : null as any;
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : null as any;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : null as any;
        }
    }

    static override fromJS(data: any): AccountPerson {
        data = typeof data === 'object' ? data : {};
        let result = new AccountPerson();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountPersonId"] = this.accountPersonId !== undefined ? this.accountPersonId : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["personId"] = this.personId !== undefined ? this.personId : null as any;
        data["appId"] = this.appId !== undefined ? this.appId : null as any;
        data["account"] = this.account ? this.account.toJSON() : null as any;
        data["person"] = this.person ? this.person.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AccountPerson {
        const json = this.toJSON();
        let result = new AccountPerson();
        result.init(json);
        return result;
    }
}

export interface IAccountPerson extends IBaseEntity {
    accountPersonId?: number;
    accountId?: number;
    personId?: number;
    appId?: number | null;
    account?: Account | null;
    person?: Person | null;
}

export class LocationPerson extends BaseEntity implements ILocationPerson {
    locationPersonId?: number;
    personId?: number;
    locationId?: number;
    statusId?: number | null;
    location?: Location | null;
    person?: Person | null;
    status?: Status | null;

    constructor(data?: ILocationPerson) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.locationPersonId = _data["locationPersonId"] !== undefined ? _data["locationPersonId"] : null as any;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null as any;
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : null as any;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : null as any;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : null as any;
            this.status = _data["status"] ? Status.fromJS(_data["status"]) : null as any;
        }
    }

    static override fromJS(data: any): LocationPerson {
        data = typeof data === 'object' ? data : {};
        let result = new LocationPerson();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationPersonId"] = this.locationPersonId !== undefined ? this.locationPersonId : null as any;
        data["personId"] = this.personId !== undefined ? this.personId : null as any;
        data["locationId"] = this.locationId !== undefined ? this.locationId : null as any;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        data["location"] = this.location ? this.location.toJSON() : null as any;
        data["person"] = this.person ? this.person.toJSON() : null as any;
        data["status"] = this.status ? this.status.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): LocationPerson {
        const json = this.toJSON();
        let result = new LocationPerson();
        result.init(json);
        return result;
    }
}

export interface ILocationPerson extends IBaseEntity {
    locationPersonId?: number;
    personId?: number;
    locationId?: number;
    statusId?: number | null;
    location?: Location | null;
    person?: Person | null;
    status?: Status | null;
}

export class PersonBadge extends BaseEntity implements IPersonBadge {
    personBadgeId?: number;
    personId?: number;
    badgeTransactionId?: number;
    photoDenialReason?: string | null;
    paid?: boolean;
    dateCreated?: moment.Moment;
    person?: Person | null;

    constructor(data?: IPersonBadge) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.personBadgeId = _data["personBadgeId"] !== undefined ? _data["personBadgeId"] : null as any;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null as any;
            this.badgeTransactionId = _data["badgeTransactionId"] !== undefined ? _data["badgeTransactionId"] : null as any;
            this.photoDenialReason = _data["photoDenialReason"] !== undefined ? _data["photoDenialReason"] : null as any;
            this.paid = _data["paid"] !== undefined ? _data["paid"] : null as any;
            this.dateCreated = _data["dateCreated"] ? moment(_data["dateCreated"].toString()) : null as any;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : null as any;
        }
    }

    static override fromJS(data: any): PersonBadge {
        data = typeof data === 'object' ? data : {};
        let result = new PersonBadge();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personBadgeId"] = this.personBadgeId !== undefined ? this.personBadgeId : null as any;
        data["personId"] = this.personId !== undefined ? this.personId : null as any;
        data["badgeTransactionId"] = this.badgeTransactionId !== undefined ? this.badgeTransactionId : null as any;
        data["photoDenialReason"] = this.photoDenialReason !== undefined ? this.photoDenialReason : null as any;
        data["paid"] = this.paid !== undefined ? this.paid : null as any;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : null as any;
        data["person"] = this.person ? this.person.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): PersonBadge {
        const json = this.toJSON();
        let result = new PersonBadge();
        result.init(json);
        return result;
    }
}

export interface IPersonBadge extends IBaseEntity {
    personBadgeId?: number;
    personId?: number;
    badgeTransactionId?: number;
    photoDenialReason?: string | null;
    paid?: boolean;
    dateCreated?: moment.Moment;
    person?: Person | null;
}

export class SsoToken extends BaseEntity implements ISsoToken {
    id?: string;
    personId?: number;
    createdDate?: moment.Moment;
    person?: Person | null;

    constructor(data?: ISsoToken) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : null as any;
        }
    }

    static override fromJS(data: any): SsoToken {
        data = typeof data === 'object' ? data : {};
        let result = new SsoToken();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["personId"] = this.personId !== undefined ? this.personId : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["person"] = this.person ? this.person.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): SsoToken {
        const json = this.toJSON();
        let result = new SsoToken();
        result.init(json);
        return result;
    }
}

export interface ISsoToken extends IBaseEntity {
    id?: string;
    personId?: number;
    createdDate?: moment.Moment;
    person?: Person | null;
}

export class BadgeTransactionAudit extends BaseEntity implements IBadgeTransactionAudit {
    badgeTransactionAuditId?: number;
    personId?: number;
    approvalStatusId?: number;
    photDenialReason?: string | null;
    pImageURL?: string | null;
    updateDate?: moment.Moment | null;
    approvedBy?: string | null;
    person?: Person | null;
    approvalStatus?: ApprovalStatus | null;

    constructor(data?: IBadgeTransactionAudit) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.badgeTransactionAuditId = _data["badgeTransactionAuditId"] !== undefined ? _data["badgeTransactionAuditId"] : null as any;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null as any;
            this.approvalStatusId = _data["approvalStatusId"] !== undefined ? _data["approvalStatusId"] : null as any;
            this.photDenialReason = _data["photDenialReason"] !== undefined ? _data["photDenialReason"] : null as any;
            this.pImageURL = _data["pImageURL"] !== undefined ? _data["pImageURL"] : null as any;
            this.updateDate = _data["updateDate"] ? moment(_data["updateDate"].toString()) : null as any;
            this.approvedBy = _data["approvedBy"] !== undefined ? _data["approvedBy"] : null as any;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : null as any;
            this.approvalStatus = _data["approvalStatus"] ? ApprovalStatus.fromJS(_data["approvalStatus"]) : null as any;
        }
    }

    static override fromJS(data: any): BadgeTransactionAudit {
        data = typeof data === 'object' ? data : {};
        let result = new BadgeTransactionAudit();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["badgeTransactionAuditId"] = this.badgeTransactionAuditId !== undefined ? this.badgeTransactionAuditId : null as any;
        data["personId"] = this.personId !== undefined ? this.personId : null as any;
        data["approvalStatusId"] = this.approvalStatusId !== undefined ? this.approvalStatusId : null as any;
        data["photDenialReason"] = this.photDenialReason !== undefined ? this.photDenialReason : null as any;
        data["pImageURL"] = this.pImageURL !== undefined ? this.pImageURL : null as any;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : null as any;
        data["approvedBy"] = this.approvedBy !== undefined ? this.approvedBy : null as any;
        data["person"] = this.person ? this.person.toJSON() : null as any;
        data["approvalStatus"] = this.approvalStatus ? this.approvalStatus.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): BadgeTransactionAudit {
        const json = this.toJSON();
        let result = new BadgeTransactionAudit();
        result.init(json);
        return result;
    }
}

export interface IBadgeTransactionAudit extends IBaseEntity {
    badgeTransactionAuditId?: number;
    personId?: number;
    approvalStatusId?: number;
    photDenialReason?: string | null;
    pImageURL?: string | null;
    updateDate?: moment.Moment | null;
    approvedBy?: string | null;
    person?: Person | null;
    approvalStatus?: ApprovalStatus | null;
}

export class ApprovalStatus extends BaseEntity implements IApprovalStatus {
    approvalStatusId?: number;
    approvalName?: string | null;
    person?: Person[] | null;
    badgeTransactionAudit?: BadgeTransactionAudit[] | null;

    constructor(data?: IApprovalStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.approvalStatusId = _data["approvalStatusId"] !== undefined ? _data["approvalStatusId"] : null as any;
            this.approvalName = _data["approvalName"] !== undefined ? _data["approvalName"] : null as any;
            if (Array.isArray(_data["person"])) {
                this.person = [] as any;
                for (let item of _data["person"])
                    this.person!.push(Person.fromJS(item));
            }
            else {
                this.person = null as any;
            }
            if (Array.isArray(_data["badgeTransactionAudit"])) {
                this.badgeTransactionAudit = [] as any;
                for (let item of _data["badgeTransactionAudit"])
                    this.badgeTransactionAudit!.push(BadgeTransactionAudit.fromJS(item));
            }
            else {
                this.badgeTransactionAudit = null as any;
            }
        }
    }

    static override fromJS(data: any): ApprovalStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approvalStatusId"] = this.approvalStatusId !== undefined ? this.approvalStatusId : null as any;
        data["approvalName"] = this.approvalName !== undefined ? this.approvalName : null as any;
        if (Array.isArray(this.person)) {
            data["person"] = [];
            for (let item of this.person)
                data["person"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.badgeTransactionAudit)) {
            data["badgeTransactionAudit"] = [];
            for (let item of this.badgeTransactionAudit)
                data["badgeTransactionAudit"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): ApprovalStatus {
        const json = this.toJSON();
        let result = new ApprovalStatus();
        result.init(json);
        return result;
    }
}

export interface IApprovalStatus extends IBaseEntity {
    approvalStatusId?: number;
    approvalName?: string | null;
    person?: Person[] | null;
    badgeTransactionAudit?: BadgeTransactionAudit[] | null;
}

export class Roles extends BaseEntity implements IRoles {
    rolesId?: number;
    rolesName?: string | null;
    roleTypeId?: number;
    landingPage?: string | null;
    statusId?: number | null;
    rolesNote?: string | null;
    roleCode?: string | null;
    roleCapability?: RoleCapability | null;
    needsTraining?: boolean;
    isSystem?: boolean;
    person?: Person[] | null;
    roleType?: RoleType | null;
    status?: Status | null;
    rolePermissions?: RolePermission[] | null;
    roleNotifications?: RoleNotification[] | null;

    constructor(data?: IRoles) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rolesId = _data["rolesId"] !== undefined ? _data["rolesId"] : null as any;
            this.rolesName = _data["rolesName"] !== undefined ? _data["rolesName"] : null as any;
            this.roleTypeId = _data["roleTypeId"] !== undefined ? _data["roleTypeId"] : null as any;
            this.landingPage = _data["landingPage"] !== undefined ? _data["landingPage"] : null as any;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            this.rolesNote = _data["rolesNote"] !== undefined ? _data["rolesNote"] : null as any;
            this.roleCode = _data["roleCode"] !== undefined ? _data["roleCode"] : null as any;
            this.roleCapability = _data["roleCapability"] ? RoleCapability.fromJS(_data["roleCapability"]) : null as any;
            this.needsTraining = _data["needsTraining"] !== undefined ? _data["needsTraining"] : null as any;
            this.isSystem = _data["isSystem"] !== undefined ? _data["isSystem"] : null as any;
            if (Array.isArray(_data["person"])) {
                this.person = [] as any;
                for (let item of _data["person"])
                    this.person!.push(Person.fromJS(item));
            }
            else {
                this.person = null as any;
            }
            this.roleType = _data["roleType"] ? RoleType.fromJS(_data["roleType"]) : null as any;
            this.status = _data["status"] ? Status.fromJS(_data["status"]) : null as any;
            if (Array.isArray(_data["rolePermissions"])) {
                this.rolePermissions = [] as any;
                for (let item of _data["rolePermissions"])
                    this.rolePermissions!.push(RolePermission.fromJS(item));
            }
            else {
                this.rolePermissions = null as any;
            }
            if (Array.isArray(_data["roleNotifications"])) {
                this.roleNotifications = [] as any;
                for (let item of _data["roleNotifications"])
                    this.roleNotifications!.push(RoleNotification.fromJS(item));
            }
            else {
                this.roleNotifications = null as any;
            }
        }
    }

    static override fromJS(data: any): Roles {
        data = typeof data === 'object' ? data : {};
        let result = new Roles();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rolesId"] = this.rolesId !== undefined ? this.rolesId : null as any;
        data["rolesName"] = this.rolesName !== undefined ? this.rolesName : null as any;
        data["roleTypeId"] = this.roleTypeId !== undefined ? this.roleTypeId : null as any;
        data["landingPage"] = this.landingPage !== undefined ? this.landingPage : null as any;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        data["rolesNote"] = this.rolesNote !== undefined ? this.rolesNote : null as any;
        data["roleCode"] = this.roleCode !== undefined ? this.roleCode : null as any;
        data["roleCapability"] = this.roleCapability ? this.roleCapability.toJSON() : null as any;
        data["needsTraining"] = this.needsTraining !== undefined ? this.needsTraining : null as any;
        data["isSystem"] = this.isSystem !== undefined ? this.isSystem : null as any;
        if (Array.isArray(this.person)) {
            data["person"] = [];
            for (let item of this.person)
                data["person"].push(item ? item.toJSON() : null as any);
        }
        data["roleType"] = this.roleType ? this.roleType.toJSON() : null as any;
        data["status"] = this.status ? this.status.toJSON() : null as any;
        if (Array.isArray(this.rolePermissions)) {
            data["rolePermissions"] = [];
            for (let item of this.rolePermissions)
                data["rolePermissions"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.roleNotifications)) {
            data["roleNotifications"] = [];
            for (let item of this.roleNotifications)
                data["roleNotifications"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): Roles {
        const json = this.toJSON();
        let result = new Roles();
        result.init(json);
        return result;
    }
}

export interface IRoles extends IBaseEntity {
    rolesId?: number;
    rolesName?: string | null;
    roleTypeId?: number;
    landingPage?: string | null;
    statusId?: number | null;
    rolesNote?: string | null;
    roleCode?: string | null;
    roleCapability?: RoleCapability | null;
    needsTraining?: boolean;
    isSystem?: boolean;
    person?: Person[] | null;
    roleType?: RoleType | null;
    status?: Status | null;
    rolePermissions?: RolePermission[] | null;
    roleNotifications?: RoleNotification[] | null;
}

export class RoleCapability extends BaseEntity implements IRoleCapability {
    id?: number;
    rolesId?: number;
    capabilityId?: number;
    roles?: Roles | null;
    capability?: Capability | null;

    constructor(data?: IRoleCapability) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.rolesId = _data["rolesId"] !== undefined ? _data["rolesId"] : null as any;
            this.capabilityId = _data["capabilityId"] !== undefined ? _data["capabilityId"] : null as any;
            this.roles = _data["roles"] ? Roles.fromJS(_data["roles"]) : null as any;
            this.capability = _data["capability"] ? Capability.fromJS(_data["capability"]) : null as any;
        }
    }

    static override fromJS(data: any): RoleCapability {
        data = typeof data === 'object' ? data : {};
        let result = new RoleCapability();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["rolesId"] = this.rolesId !== undefined ? this.rolesId : null as any;
        data["capabilityId"] = this.capabilityId !== undefined ? this.capabilityId : null as any;
        data["roles"] = this.roles ? this.roles.toJSON() : null as any;
        data["capability"] = this.capability ? this.capability.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): RoleCapability {
        const json = this.toJSON();
        let result = new RoleCapability();
        result.init(json);
        return result;
    }
}

export interface IRoleCapability extends IBaseEntity {
    id?: number;
    rolesId?: number;
    capabilityId?: number;
    roles?: Roles | null;
    capability?: Capability | null;
}

export class Capability extends BaseEntity implements ICapability {
    id?: number;
    name?: string | null;

    constructor(data?: ICapability) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static override fromJS(data: any): Capability {
        data = typeof data === 'object' ? data : {};
        let result = new Capability();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): Capability {
        const json = this.toJSON();
        let result = new Capability();
        result.init(json);
        return result;
    }
}

export interface ICapability extends IBaseEntity {
    id?: number;
    name?: string | null;
}

export class RoleType extends BaseEntity implements IRoleType {
    roleTypeId?: number;
    name?: string | null;
    statusId?: number | null;
    roles?: Roles[] | null;
    status?: Status | null;

    constructor(data?: IRoleType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.roleTypeId = _data["roleTypeId"] !== undefined ? _data["roleTypeId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(Roles.fromJS(item));
            }
            else {
                this.roles = null as any;
            }
            this.status = _data["status"] ? Status.fromJS(_data["status"]) : null as any;
        }
    }

    static override fromJS(data: any): RoleType {
        data = typeof data === 'object' ? data : {};
        let result = new RoleType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleTypeId"] = this.roleTypeId !== undefined ? this.roleTypeId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : null as any);
        }
        data["status"] = this.status ? this.status.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): RoleType {
        const json = this.toJSON();
        let result = new RoleType();
        result.init(json);
        return result;
    }
}

export interface IRoleType extends IBaseEntity {
    roleTypeId?: number;
    name?: string | null;
    statusId?: number | null;
    roles?: Roles[] | null;
    status?: Status | null;
}

export class RolePermission implements IRolePermission {
    id?: number;
    rolesId?: number;
    permissionId?: string | null;
    activity?: ActivityTypes;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment;
    permission?: Permission | null;
    role?: Roles | null;

    constructor(data?: IRolePermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.rolesId = _data["rolesId"] !== undefined ? _data["rolesId"] : null as any;
            this.permissionId = _data["permissionId"] !== undefined ? _data["permissionId"] : null as any;
            this.activity = _data["activity"] !== undefined ? _data["activity"] : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            this.permission = _data["permission"] ? Permission.fromJS(_data["permission"]) : null as any;
            this.role = _data["role"] ? Roles.fromJS(_data["role"]) : null as any;
        }
    }

    static fromJS(data: any): RolePermission {
        data = typeof data === 'object' ? data : {};
        let result = new RolePermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["rolesId"] = this.rolesId !== undefined ? this.rolesId : null as any;
        data["permissionId"] = this.permissionId !== undefined ? this.permissionId : null as any;
        data["activity"] = this.activity !== undefined ? this.activity : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        data["permission"] = this.permission ? this.permission.toJSON() : null as any;
        data["role"] = this.role ? this.role.toJSON() : null as any;
        return data;
    }

    clone(): RolePermission {
        const json = this.toJSON();
        let result = new RolePermission();
        result.init(json);
        return result;
    }
}

export interface IRolePermission {
    id?: number;
    rolesId?: number;
    permissionId?: string | null;
    activity?: ActivityTypes;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment;
    permission?: Permission | null;
    role?: Roles | null;
}

export enum ActivityTypes {
    None = "none",
    Read = "read",
    Create = "create",
    Update = "update",
    Delete = "delete",
}

export class Permission implements IPermission {
    id?: string | null;
    grouping?: string | null;
    resource?: string | null;
    item?: string | null;
    description?: string | null;
    allowedActivities?: ActivityTypes;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment;
    rolePermissions?: RolePermission[] | null;
    personPermissions?: PersonPermission[] | null;
    personLocationPermissions?: PersonLocationPermission[] | null;

    constructor(data?: IPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.grouping = _data["grouping"] !== undefined ? _data["grouping"] : null as any;
            this.resource = _data["resource"] !== undefined ? _data["resource"] : null as any;
            this.item = _data["item"] !== undefined ? _data["item"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.allowedActivities = _data["allowedActivities"] !== undefined ? _data["allowedActivities"] : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            if (Array.isArray(_data["rolePermissions"])) {
                this.rolePermissions = [] as any;
                for (let item of _data["rolePermissions"])
                    this.rolePermissions!.push(RolePermission.fromJS(item));
            }
            else {
                this.rolePermissions = null as any;
            }
            if (Array.isArray(_data["personPermissions"])) {
                this.personPermissions = [] as any;
                for (let item of _data["personPermissions"])
                    this.personPermissions!.push(PersonPermission.fromJS(item));
            }
            else {
                this.personPermissions = null as any;
            }
            if (Array.isArray(_data["personLocationPermissions"])) {
                this.personLocationPermissions = [] as any;
                for (let item of _data["personLocationPermissions"])
                    this.personLocationPermissions!.push(PersonLocationPermission.fromJS(item));
            }
            else {
                this.personLocationPermissions = null as any;
            }
        }
    }

    static fromJS(data: any): Permission {
        data = typeof data === 'object' ? data : {};
        let result = new Permission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["grouping"] = this.grouping !== undefined ? this.grouping : null as any;
        data["resource"] = this.resource !== undefined ? this.resource : null as any;
        data["item"] = this.item !== undefined ? this.item : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["allowedActivities"] = this.allowedActivities !== undefined ? this.allowedActivities : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        if (Array.isArray(this.rolePermissions)) {
            data["rolePermissions"] = [];
            for (let item of this.rolePermissions)
                data["rolePermissions"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.personPermissions)) {
            data["personPermissions"] = [];
            for (let item of this.personPermissions)
                data["personPermissions"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.personLocationPermissions)) {
            data["personLocationPermissions"] = [];
            for (let item of this.personLocationPermissions)
                data["personLocationPermissions"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): Permission {
        const json = this.toJSON();
        let result = new Permission();
        result.init(json);
        return result;
    }
}

export interface IPermission {
    id?: string | null;
    grouping?: string | null;
    resource?: string | null;
    item?: string | null;
    description?: string | null;
    allowedActivities?: ActivityTypes;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment;
    rolePermissions?: RolePermission[] | null;
    personPermissions?: PersonPermission[] | null;
    personLocationPermissions?: PersonLocationPermission[] | null;
}

export class PersonPermission implements IPersonPermission {
    id?: number;
    personId?: number;
    permissionId?: string | null;
    activity?: ActivityTypes;
    activityOverride?: ActivityTypes | null;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment;
    automated?: boolean;
    permission?: Permission | null;
    person?: Person | null;

    constructor(data?: IPersonPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null as any;
            this.permissionId = _data["permissionId"] !== undefined ? _data["permissionId"] : null as any;
            this.activity = _data["activity"] !== undefined ? _data["activity"] : null as any;
            this.activityOverride = _data["activityOverride"] !== undefined ? _data["activityOverride"] : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            this.automated = _data["automated"] !== undefined ? _data["automated"] : null as any;
            this.permission = _data["permission"] ? Permission.fromJS(_data["permission"]) : null as any;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : null as any;
        }
    }

    static fromJS(data: any): PersonPermission {
        data = typeof data === 'object' ? data : {};
        let result = new PersonPermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["personId"] = this.personId !== undefined ? this.personId : null as any;
        data["permissionId"] = this.permissionId !== undefined ? this.permissionId : null as any;
        data["activity"] = this.activity !== undefined ? this.activity : null as any;
        data["activityOverride"] = this.activityOverride !== undefined ? this.activityOverride : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        data["automated"] = this.automated !== undefined ? this.automated : null as any;
        data["permission"] = this.permission ? this.permission.toJSON() : null as any;
        data["person"] = this.person ? this.person.toJSON() : null as any;
        return data;
    }

    clone(): PersonPermission {
        const json = this.toJSON();
        let result = new PersonPermission();
        result.init(json);
        return result;
    }
}

export interface IPersonPermission {
    id?: number;
    personId?: number;
    permissionId?: string | null;
    activity?: ActivityTypes;
    activityOverride?: ActivityTypes | null;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment;
    automated?: boolean;
    permission?: Permission | null;
    person?: Person | null;
}

export class PersonLocationPermission implements IPersonLocationPermission {
    id?: number;
    locationId?: number;
    storeNumber?: string | null;
    personId?: number;
    permissionId?: string | null;
    automated?: boolean;
    activity?: ActivityTypes;
    activityOverride?: ActivityTypes | null;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment;
    permission?: Permission | null;
    person?: Person | null;
    location?: Location | null;

    constructor(data?: IPersonLocationPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : null as any;
            this.storeNumber = _data["storeNumber"] !== undefined ? _data["storeNumber"] : null as any;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null as any;
            this.permissionId = _data["permissionId"] !== undefined ? _data["permissionId"] : null as any;
            this.automated = _data["automated"] !== undefined ? _data["automated"] : null as any;
            this.activity = _data["activity"] !== undefined ? _data["activity"] : null as any;
            this.activityOverride = _data["activityOverride"] !== undefined ? _data["activityOverride"] : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            this.permission = _data["permission"] ? Permission.fromJS(_data["permission"]) : null as any;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : null as any;
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : null as any;
        }
    }

    static fromJS(data: any): PersonLocationPermission {
        data = typeof data === 'object' ? data : {};
        let result = new PersonLocationPermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["locationId"] = this.locationId !== undefined ? this.locationId : null as any;
        data["storeNumber"] = this.storeNumber !== undefined ? this.storeNumber : null as any;
        data["personId"] = this.personId !== undefined ? this.personId : null as any;
        data["permissionId"] = this.permissionId !== undefined ? this.permissionId : null as any;
        data["automated"] = this.automated !== undefined ? this.automated : null as any;
        data["activity"] = this.activity !== undefined ? this.activity : null as any;
        data["activityOverride"] = this.activityOverride !== undefined ? this.activityOverride : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        data["permission"] = this.permission ? this.permission.toJSON() : null as any;
        data["person"] = this.person ? this.person.toJSON() : null as any;
        data["location"] = this.location ? this.location.toJSON() : null as any;
        return data;
    }

    clone(): PersonLocationPermission {
        const json = this.toJSON();
        let result = new PersonLocationPermission();
        result.init(json);
        return result;
    }
}

export interface IPersonLocationPermission {
    id?: number;
    locationId?: number;
    storeNumber?: string | null;
    personId?: number;
    permissionId?: string | null;
    automated?: boolean;
    activity?: ActivityTypes;
    activityOverride?: ActivityTypes | null;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment;
    permission?: Permission | null;
    person?: Person | null;
    location?: Location | null;
}

export class RoleNotification implements IRoleNotification {
    id?: number;
    rolesId?: number;
    notificationId?: string | null;
    locked?: boolean;
    active?: boolean;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment;
    notification?: Notification | null;
    role?: Roles | null;

    constructor(data?: IRoleNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.rolesId = _data["rolesId"] !== undefined ? _data["rolesId"] : null as any;
            this.notificationId = _data["notificationId"] !== undefined ? _data["notificationId"] : null as any;
            this.locked = _data["locked"] !== undefined ? _data["locked"] : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            this.notification = _data["notification"] ? Notification.fromJS(_data["notification"]) : null as any;
            this.role = _data["role"] ? Roles.fromJS(_data["role"]) : null as any;
        }
    }

    static fromJS(data: any): RoleNotification {
        data = typeof data === 'object' ? data : {};
        let result = new RoleNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["rolesId"] = this.rolesId !== undefined ? this.rolesId : null as any;
        data["notificationId"] = this.notificationId !== undefined ? this.notificationId : null as any;
        data["locked"] = this.locked !== undefined ? this.locked : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        data["notification"] = this.notification ? this.notification.toJSON() : null as any;
        data["role"] = this.role ? this.role.toJSON() : null as any;
        return data;
    }

    clone(): RoleNotification {
        const json = this.toJSON();
        let result = new RoleNotification();
        result.init(json);
        return result;
    }
}

export interface IRoleNotification {
    id?: number;
    rolesId?: number;
    notificationId?: string | null;
    locked?: boolean;
    active?: boolean;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment;
    notification?: Notification | null;
    role?: Roles | null;
}

export class Notification implements INotification {
    id?: string | null;
    grouping?: string | null;
    description?: string | null;
    subjectTemplate?: string | null;
    template?: string | null;
    smsTemplate?: string | null;
    pushTitleTemplate?: string | null;
    pushMessageTemplate?: string | null;
    type?: NotificationTypes;
    locked?: boolean;
    active?: boolean;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment;
    roleNotifications?: RoleNotification[] | null;
    personNotifications?: PersonNotification[] | null;

    constructor(data?: INotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.grouping = _data["grouping"] !== undefined ? _data["grouping"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.subjectTemplate = _data["subjectTemplate"] !== undefined ? _data["subjectTemplate"] : null as any;
            this.template = _data["template"] !== undefined ? _data["template"] : null as any;
            this.smsTemplate = _data["smsTemplate"] !== undefined ? _data["smsTemplate"] : null as any;
            this.pushTitleTemplate = _data["pushTitleTemplate"] !== undefined ? _data["pushTitleTemplate"] : null as any;
            this.pushMessageTemplate = _data["pushMessageTemplate"] !== undefined ? _data["pushMessageTemplate"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.locked = _data["locked"] !== undefined ? _data["locked"] : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            if (Array.isArray(_data["roleNotifications"])) {
                this.roleNotifications = [] as any;
                for (let item of _data["roleNotifications"])
                    this.roleNotifications!.push(RoleNotification.fromJS(item));
            }
            else {
                this.roleNotifications = null as any;
            }
            if (Array.isArray(_data["personNotifications"])) {
                this.personNotifications = [] as any;
                for (let item of _data["personNotifications"])
                    this.personNotifications!.push(PersonNotification.fromJS(item));
            }
            else {
                this.personNotifications = null as any;
            }
        }
    }

    static fromJS(data: any): Notification {
        data = typeof data === 'object' ? data : {};
        let result = new Notification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["grouping"] = this.grouping !== undefined ? this.grouping : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["subjectTemplate"] = this.subjectTemplate !== undefined ? this.subjectTemplate : null as any;
        data["template"] = this.template !== undefined ? this.template : null as any;
        data["smsTemplate"] = this.smsTemplate !== undefined ? this.smsTemplate : null as any;
        data["pushTitleTemplate"] = this.pushTitleTemplate !== undefined ? this.pushTitleTemplate : null as any;
        data["pushMessageTemplate"] = this.pushMessageTemplate !== undefined ? this.pushMessageTemplate : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["locked"] = this.locked !== undefined ? this.locked : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        if (Array.isArray(this.roleNotifications)) {
            data["roleNotifications"] = [];
            for (let item of this.roleNotifications)
                data["roleNotifications"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.personNotifications)) {
            data["personNotifications"] = [];
            for (let item of this.personNotifications)
                data["personNotifications"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): Notification {
        const json = this.toJSON();
        let result = new Notification();
        result.init(json);
        return result;
    }
}

export interface INotification {
    id?: string | null;
    grouping?: string | null;
    description?: string | null;
    subjectTemplate?: string | null;
    template?: string | null;
    smsTemplate?: string | null;
    pushTitleTemplate?: string | null;
    pushMessageTemplate?: string | null;
    type?: NotificationTypes;
    locked?: boolean;
    active?: boolean;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment;
    roleNotifications?: RoleNotification[] | null;
    personNotifications?: PersonNotification[] | null;
}

export enum NotificationTypes {
    Invalid = "invalid",
    Email = "email",
    Dashboard = "dashboard",
    Subscription = "subscription",
    Sms = "sms",
    Push = "push",
}

export class PersonNotification implements IPersonNotification {
    id?: number;
    personId?: number;
    notificationId?: string | null;
    active?: boolean;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment;
    automated?: boolean;
    notification?: Notification | null;
    person?: Person | null;

    constructor(data?: IPersonNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null as any;
            this.notificationId = _data["notificationId"] !== undefined ? _data["notificationId"] : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            this.automated = _data["automated"] !== undefined ? _data["automated"] : null as any;
            this.notification = _data["notification"] ? Notification.fromJS(_data["notification"]) : null as any;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : null as any;
        }
    }

    static fromJS(data: any): PersonNotification {
        data = typeof data === 'object' ? data : {};
        let result = new PersonNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["personId"] = this.personId !== undefined ? this.personId : null as any;
        data["notificationId"] = this.notificationId !== undefined ? this.notificationId : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        data["automated"] = this.automated !== undefined ? this.automated : null as any;
        data["notification"] = this.notification ? this.notification.toJSON() : null as any;
        data["person"] = this.person ? this.person.toJSON() : null as any;
        return data;
    }

    clone(): PersonNotification {
        const json = this.toJSON();
        let result = new PersonNotification();
        result.init(json);
        return result;
    }
}

export interface IPersonNotification {
    id?: number;
    personId?: number;
    notificationId?: string | null;
    active?: boolean;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment;
    automated?: boolean;
    notification?: Notification | null;
    person?: Person | null;
}

export class PersonTag extends BaseEntity implements IPersonTag {
    id?: number;
    tagId?: number;
    tag?: Tag | null;
    personId?: number;
    person?: Person | null;

    constructor(data?: IPersonTag) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.tagId = _data["tagId"] !== undefined ? _data["tagId"] : null as any;
            this.tag = _data["tag"] ? Tag.fromJS(_data["tag"]) : null as any;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null as any;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : null as any;
        }
    }

    static override fromJS(data: any): PersonTag {
        data = typeof data === 'object' ? data : {};
        let result = new PersonTag();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["tagId"] = this.tagId !== undefined ? this.tagId : null as any;
        data["tag"] = this.tag ? this.tag.toJSON() : null as any;
        data["personId"] = this.personId !== undefined ? this.personId : null as any;
        data["person"] = this.person ? this.person.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): PersonTag {
        const json = this.toJSON();
        let result = new PersonTag();
        result.init(json);
        return result;
    }
}

export interface IPersonTag extends IBaseEntity {
    id?: number;
    tagId?: number;
    tag?: Tag | null;
    personId?: number;
    person?: Person | null;
}

export class Tag extends BaseEntity implements ITag {
    id?: number;
    name?: string | null;
    nameTranslationKey?: string | null;
    nameTranslation?: Translation | null;
    descriptionTranslationKey?: string | null;
    descriptionTranslation?: Translation | null;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment | null;
    userTags?: PersonTag[] | null;
    skipBadgeScanning?: boolean;
    isReserved?: boolean;
    isSensitive?: boolean;
    exemptFromHourlyCharge?: boolean;
    colorClass?: string | null;
    tagRequirement?: TagRequirement[] | null;

    constructor(data?: ITag) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.nameTranslationKey = _data["nameTranslationKey"] !== undefined ? _data["nameTranslationKey"] : null as any;
            this.nameTranslation = _data["nameTranslation"] ? Translation.fromJS(_data["nameTranslation"]) : null as any;
            this.descriptionTranslationKey = _data["descriptionTranslationKey"] !== undefined ? _data["descriptionTranslationKey"] : null as any;
            this.descriptionTranslation = _data["descriptionTranslation"] ? Translation.fromJS(_data["descriptionTranslation"]) : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            if (Array.isArray(_data["userTags"])) {
                this.userTags = [] as any;
                for (let item of _data["userTags"])
                    this.userTags!.push(PersonTag.fromJS(item));
            }
            else {
                this.userTags = null as any;
            }
            this.skipBadgeScanning = _data["skipBadgeScanning"] !== undefined ? _data["skipBadgeScanning"] : null as any;
            this.isReserved = _data["isReserved"] !== undefined ? _data["isReserved"] : null as any;
            this.isSensitive = _data["isSensitive"] !== undefined ? _data["isSensitive"] : null as any;
            this.exemptFromHourlyCharge = _data["exemptFromHourlyCharge"] !== undefined ? _data["exemptFromHourlyCharge"] : null as any;
            this.colorClass = _data["colorClass"] !== undefined ? _data["colorClass"] : null as any;
            if (Array.isArray(_data["tagRequirement"])) {
                this.tagRequirement = [] as any;
                for (let item of _data["tagRequirement"])
                    this.tagRequirement!.push(TagRequirement.fromJS(item));
            }
            else {
                this.tagRequirement = null as any;
            }
        }
    }

    static override fromJS(data: any): Tag {
        data = typeof data === 'object' ? data : {};
        let result = new Tag();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["nameTranslationKey"] = this.nameTranslationKey !== undefined ? this.nameTranslationKey : null as any;
        data["nameTranslation"] = this.nameTranslation ? this.nameTranslation.toJSON() : null as any;
        data["descriptionTranslationKey"] = this.descriptionTranslationKey !== undefined ? this.descriptionTranslationKey : null as any;
        data["descriptionTranslation"] = this.descriptionTranslation ? this.descriptionTranslation.toJSON() : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        if (Array.isArray(this.userTags)) {
            data["userTags"] = [];
            for (let item of this.userTags)
                data["userTags"].push(item ? item.toJSON() : null as any);
        }
        data["skipBadgeScanning"] = this.skipBadgeScanning !== undefined ? this.skipBadgeScanning : null as any;
        data["isReserved"] = this.isReserved !== undefined ? this.isReserved : null as any;
        data["isSensitive"] = this.isSensitive !== undefined ? this.isSensitive : null as any;
        data["exemptFromHourlyCharge"] = this.exemptFromHourlyCharge !== undefined ? this.exemptFromHourlyCharge : null as any;
        data["colorClass"] = this.colorClass !== undefined ? this.colorClass : null as any;
        if (Array.isArray(this.tagRequirement)) {
            data["tagRequirement"] = [];
            for (let item of this.tagRequirement)
                data["tagRequirement"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): Tag {
        const json = this.toJSON();
        let result = new Tag();
        result.init(json);
        return result;
    }
}

export interface ITag extends IBaseEntity {
    id?: number;
    name?: string | null;
    nameTranslationKey?: string | null;
    nameTranslation?: Translation | null;
    descriptionTranslationKey?: string | null;
    descriptionTranslation?: Translation | null;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment | null;
    userTags?: PersonTag[] | null;
    skipBadgeScanning?: boolean;
    isReserved?: boolean;
    isSensitive?: boolean;
    exemptFromHourlyCharge?: boolean;
    colorClass?: string | null;
    tagRequirement?: TagRequirement[] | null;
}

export class Translation extends BaseEntity implements ITranslation {
    translationKey?: string | null;
    en?: string | null;
    es?: string | null;

    constructor(data?: ITranslation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.translationKey = _data["translationKey"] !== undefined ? _data["translationKey"] : null as any;
            this.en = _data["en"] !== undefined ? _data["en"] : null as any;
            this.es = _data["es"] !== undefined ? _data["es"] : null as any;
        }
    }

    static override fromJS(data: any): Translation {
        data = typeof data === 'object' ? data : {};
        let result = new Translation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["translationKey"] = this.translationKey !== undefined ? this.translationKey : null as any;
        data["en"] = this.en !== undefined ? this.en : null as any;
        data["es"] = this.es !== undefined ? this.es : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): Translation {
        const json = this.toJSON();
        let result = new Translation();
        result.init(json);
        return result;
    }
}

export interface ITranslation extends IBaseEntity {
    translationKey?: string | null;
    en?: string | null;
    es?: string | null;
}

export class TagRequirement extends BaseEntity implements ITagRequirement {
    id?: number;
    tagId?: number;
    numberOfDaysBeforeBlocked?: number | null;
    numberOfDaysBeforeWarned?: number | null;

    constructor(data?: ITagRequirement) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.tagId = _data["tagId"] !== undefined ? _data["tagId"] : null as any;
            this.numberOfDaysBeforeBlocked = _data["numberOfDaysBeforeBlocked"] !== undefined ? _data["numberOfDaysBeforeBlocked"] : null as any;
            this.numberOfDaysBeforeWarned = _data["numberOfDaysBeforeWarned"] !== undefined ? _data["numberOfDaysBeforeWarned"] : null as any;
        }
    }

    static override fromJS(data: any): TagRequirement {
        data = typeof data === 'object' ? data : {};
        let result = new TagRequirement();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["tagId"] = this.tagId !== undefined ? this.tagId : null as any;
        data["numberOfDaysBeforeBlocked"] = this.numberOfDaysBeforeBlocked !== undefined ? this.numberOfDaysBeforeBlocked : null as any;
        data["numberOfDaysBeforeWarned"] = this.numberOfDaysBeforeWarned !== undefined ? this.numberOfDaysBeforeWarned : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): TagRequirement {
        const json = this.toJSON();
        let result = new TagRequirement();
        result.init(json);
        return result;
    }
}

export interface ITagRequirement extends IBaseEntity {
    id?: number;
    tagId?: number;
    numberOfDaysBeforeBlocked?: number | null;
    numberOfDaysBeforeWarned?: number | null;
}

export class BadgeReplacement extends BaseEntity implements IBadgeReplacement {
    badgeReplacementId?: number;
    personId?: number;
    person?: Person | null;
    dateRequested?: moment.Moment;
    updatedBy?: string | null;
    invoiceId?: number | null;
    approvalStatusId?: number;
    requestReason?: string | null;
    denialReason?: string | null;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment | null;
    replaceForFree?: boolean;

    constructor(data?: IBadgeReplacement) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.badgeReplacementId = _data["badgeReplacementId"] !== undefined ? _data["badgeReplacementId"] : null as any;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null as any;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : null as any;
            this.dateRequested = _data["dateRequested"] ? moment(_data["dateRequested"].toString()) : null as any;
            this.updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : null as any;
            this.invoiceId = _data["invoiceId"] !== undefined ? _data["invoiceId"] : null as any;
            this.approvalStatusId = _data["approvalStatusId"] !== undefined ? _data["approvalStatusId"] : null as any;
            this.requestReason = _data["requestReason"] !== undefined ? _data["requestReason"] : null as any;
            this.denialReason = _data["denialReason"] !== undefined ? _data["denialReason"] : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            this.replaceForFree = _data["replaceForFree"] !== undefined ? _data["replaceForFree"] : null as any;
        }
    }

    static override fromJS(data: any): BadgeReplacement {
        data = typeof data === 'object' ? data : {};
        let result = new BadgeReplacement();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["badgeReplacementId"] = this.badgeReplacementId !== undefined ? this.badgeReplacementId : null as any;
        data["personId"] = this.personId !== undefined ? this.personId : null as any;
        data["person"] = this.person ? this.person.toJSON() : null as any;
        data["dateRequested"] = this.dateRequested ? this.dateRequested.toISOString() : null as any;
        data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : null as any;
        data["invoiceId"] = this.invoiceId !== undefined ? this.invoiceId : null as any;
        data["approvalStatusId"] = this.approvalStatusId !== undefined ? this.approvalStatusId : null as any;
        data["requestReason"] = this.requestReason !== undefined ? this.requestReason : null as any;
        data["denialReason"] = this.denialReason !== undefined ? this.denialReason : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        data["replaceForFree"] = this.replaceForFree !== undefined ? this.replaceForFree : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): BadgeReplacement {
        const json = this.toJSON();
        let result = new BadgeReplacement();
        result.init(json);
        return result;
    }
}

export interface IBadgeReplacement extends IBaseEntity {
    badgeReplacementId?: number;
    personId?: number;
    person?: Person | null;
    dateRequested?: moment.Moment;
    updatedBy?: string | null;
    invoiceId?: number | null;
    approvalStatusId?: number;
    requestReason?: string | null;
    denialReason?: string | null;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment | null;
    replaceForFree?: boolean;
}

export class StoreManagerLookup extends BaseEntity implements IStoreManagerLookup {
    id?: number;
    storeNumber?: string | null;
    locationId?: number;
    locationSyncId?: string;
    locationTimeZone?: string | null;
    personId?: number;
    email?: string | null;
    personSyncId?: string;
    managerType?: string | null;
    location?: Location | null;
    person?: Person | null;

    constructor(data?: IStoreManagerLookup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.storeNumber = _data["storeNumber"] !== undefined ? _data["storeNumber"] : null as any;
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : null as any;
            this.locationSyncId = _data["locationSyncId"] !== undefined ? _data["locationSyncId"] : null as any;
            this.locationTimeZone = _data["locationTimeZone"] !== undefined ? _data["locationTimeZone"] : null as any;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.personSyncId = _data["personSyncId"] !== undefined ? _data["personSyncId"] : null as any;
            this.managerType = _data["managerType"] !== undefined ? _data["managerType"] : null as any;
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : null as any;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : null as any;
        }
    }

    static override fromJS(data: any): StoreManagerLookup {
        data = typeof data === 'object' ? data : {};
        let result = new StoreManagerLookup();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["storeNumber"] = this.storeNumber !== undefined ? this.storeNumber : null as any;
        data["locationId"] = this.locationId !== undefined ? this.locationId : null as any;
        data["locationSyncId"] = this.locationSyncId !== undefined ? this.locationSyncId : null as any;
        data["locationTimeZone"] = this.locationTimeZone !== undefined ? this.locationTimeZone : null as any;
        data["personId"] = this.personId !== undefined ? this.personId : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["personSyncId"] = this.personSyncId !== undefined ? this.personSyncId : null as any;
        data["managerType"] = this.managerType !== undefined ? this.managerType : null as any;
        data["location"] = this.location ? this.location.toJSON() : null as any;
        data["person"] = this.person ? this.person.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): StoreManagerLookup {
        const json = this.toJSON();
        let result = new StoreManagerLookup();
        result.init(json);
        return result;
    }
}

export interface IStoreManagerLookup extends IBaseEntity {
    id?: number;
    storeNumber?: string | null;
    locationId?: number;
    locationSyncId?: string;
    locationTimeZone?: string | null;
    personId?: number;
    email?: string | null;
    personSyncId?: string;
    managerType?: string | null;
    location?: Location | null;
    person?: Person | null;
}

export enum AccessReviewStatus {
    Pending = "pending",
    Approved = "approved",
    Deactivated = "deactivated",
    Demoted = "demoted",
}

export class UserCertificationSummary extends BaseEntity implements IUserCertificationSummary {
    id?: number;
    personId?: number;
    completionStatus?: string | null;
    completionDate?: moment.Moment | null;
    person?: Person | null;

    constructor(data?: IUserCertificationSummary) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null as any;
            this.completionStatus = _data["completionStatus"] !== undefined ? _data["completionStatus"] : null as any;
            this.completionDate = _data["completionDate"] ? moment(_data["completionDate"].toString()) : null as any;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : null as any;
        }
    }

    static override fromJS(data: any): UserCertificationSummary {
        data = typeof data === 'object' ? data : {};
        let result = new UserCertificationSummary();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["personId"] = this.personId !== undefined ? this.personId : null as any;
        data["completionStatus"] = this.completionStatus !== undefined ? this.completionStatus : null as any;
        data["completionDate"] = this.completionDate ? this.completionDate.toISOString() : null as any;
        data["person"] = this.person ? this.person.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): UserCertificationSummary {
        const json = this.toJSON();
        let result = new UserCertificationSummary();
        result.init(json);
        return result;
    }
}

export interface IUserCertificationSummary extends IBaseEntity {
    id?: number;
    personId?: number;
    completionStatus?: string | null;
    completionDate?: moment.Moment | null;
    person?: Person | null;
}

export class EventItem extends BaseEntity implements IEventItem {
    id?: number;
    eventId?: number;
    upc?: string | null;
    itemNumber?: string | null;
    action?: string | null;
    quantity?: number;
    createdDate?: moment.Moment | null;
    updatedDate?: moment.Moment | null;
    event?: Event | null;

    constructor(data?: IEventItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.eventId = _data["eventId"] !== undefined ? _data["eventId"] : null as any;
            this.upc = _data["upc"] !== undefined ? _data["upc"] : null as any;
            this.itemNumber = _data["itemNumber"] !== undefined ? _data["itemNumber"] : null as any;
            this.action = _data["action"] !== undefined ? _data["action"] : null as any;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            this.event = _data["event"] ? Event.fromJS(_data["event"]) : null as any;
        }
    }

    static override fromJS(data: any): EventItem {
        data = typeof data === 'object' ? data : {};
        let result = new EventItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["eventId"] = this.eventId !== undefined ? this.eventId : null as any;
        data["upc"] = this.upc !== undefined ? this.upc : null as any;
        data["itemNumber"] = this.itemNumber !== undefined ? this.itemNumber : null as any;
        data["action"] = this.action !== undefined ? this.action : null as any;
        data["quantity"] = this.quantity !== undefined ? this.quantity : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        data["event"] = this.event ? this.event.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): EventItem {
        const json = this.toJSON();
        let result = new EventItem();
        result.init(json);
        return result;
    }
}

export interface IEventItem extends IBaseEntity {
    id?: number;
    eventId?: number;
    upc?: string | null;
    itemNumber?: string | null;
    action?: string | null;
    quantity?: number;
    createdDate?: moment.Moment | null;
    updatedDate?: moment.Moment | null;
    event?: Event | null;
}

export class LocationOpenStatus extends BaseEntity implements ILocationOpenStatus {
    id?: number;
    statusCode?: string | null;
    description!: string;
    statusId?: number;
    accountId?: number;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment | null;
    location?: Location[] | null;
    account?: Account | null;
    status?: Status | null;
    locationOpenStatusGroupId?: number;
    locationOpenStatusGroup?: LocationOpenStatusGroup | null;

    constructor(data?: ILocationOpenStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.statusCode = _data["statusCode"] !== undefined ? _data["statusCode"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            if (Array.isArray(_data["location"])) {
                this.location = [] as any;
                for (let item of _data["location"])
                    this.location!.push(Location.fromJS(item));
            }
            else {
                this.location = null as any;
            }
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : null as any;
            this.status = _data["status"] ? Status.fromJS(_data["status"]) : null as any;
            this.locationOpenStatusGroupId = _data["locationOpenStatusGroupId"] !== undefined ? _data["locationOpenStatusGroupId"] : null as any;
            this.locationOpenStatusGroup = _data["locationOpenStatusGroup"] ? LocationOpenStatusGroup.fromJS(_data["locationOpenStatusGroup"]) : null as any;
        }
    }

    static override fromJS(data: any): LocationOpenStatus {
        data = typeof data === 'object' ? data : {};
        let result = new LocationOpenStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["statusCode"] = this.statusCode !== undefined ? this.statusCode : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        if (Array.isArray(this.location)) {
            data["location"] = [];
            for (let item of this.location)
                data["location"].push(item ? item.toJSON() : null as any);
        }
        data["account"] = this.account ? this.account.toJSON() : null as any;
        data["status"] = this.status ? this.status.toJSON() : null as any;
        data["locationOpenStatusGroupId"] = this.locationOpenStatusGroupId !== undefined ? this.locationOpenStatusGroupId : null as any;
        data["locationOpenStatusGroup"] = this.locationOpenStatusGroup ? this.locationOpenStatusGroup.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): LocationOpenStatus {
        const json = this.toJSON();
        let result = new LocationOpenStatus();
        result.init(json);
        return result;
    }
}

export interface ILocationOpenStatus extends IBaseEntity {
    id?: number;
    statusCode?: string | null;
    description: string;
    statusId?: number;
    accountId?: number;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment | null;
    location?: Location[] | null;
    account?: Account | null;
    status?: Status | null;
    locationOpenStatusGroupId?: number;
    locationOpenStatusGroup?: LocationOpenStatusGroup | null;
}

export class LocationOpenStatusGroup extends BaseEntity implements ILocationOpenStatusGroup {
    id?: number;
    name?: string | null;

    constructor(data?: ILocationOpenStatusGroup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static override fromJS(data: any): LocationOpenStatusGroup {
        data = typeof data === 'object' ? data : {};
        let result = new LocationOpenStatusGroup();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): LocationOpenStatusGroup {
        const json = this.toJSON();
        let result = new LocationOpenStatusGroup();
        result.init(json);
        return result;
    }
}

export interface ILocationOpenStatusGroup extends IBaseEntity {
    id?: number;
    name?: string | null;
}

export class AccountLocationGroupValue implements IAccountLocationGroupValue {
    id?: number;
    groupId!: number;
    groupValue!: string;
    locationId!: number;
    managerFirstName?: string | null;
    managerLastName?: string | null;
    managerFullName?: string | null;
    managerContactPhone?: string | null;
    managerEmail?: string | null;
    managerHomeStoreNumber?: string | null;
    version?: number;
    group?: AccountLocationGroupName | null;
    location?: Location | null;

    constructor(data?: IAccountLocationGroupValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.groupId = _data["groupId"] !== undefined ? _data["groupId"] : null as any;
            this.groupValue = _data["groupValue"] !== undefined ? _data["groupValue"] : null as any;
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : null as any;
            this.managerFirstName = _data["managerFirstName"] !== undefined ? _data["managerFirstName"] : null as any;
            this.managerLastName = _data["managerLastName"] !== undefined ? _data["managerLastName"] : null as any;
            this.managerFullName = _data["managerFullName"] !== undefined ? _data["managerFullName"] : null as any;
            this.managerContactPhone = _data["managerContactPhone"] !== undefined ? _data["managerContactPhone"] : null as any;
            this.managerEmail = _data["managerEmail"] !== undefined ? _data["managerEmail"] : null as any;
            this.managerHomeStoreNumber = _data["managerHomeStoreNumber"] !== undefined ? _data["managerHomeStoreNumber"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.group = _data["group"] ? AccountLocationGroupName.fromJS(_data["group"]) : null as any;
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : null as any;
        }
    }

    static fromJS(data: any): AccountLocationGroupValue {
        data = typeof data === 'object' ? data : {};
        let result = new AccountLocationGroupValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["groupId"] = this.groupId !== undefined ? this.groupId : null as any;
        data["groupValue"] = this.groupValue !== undefined ? this.groupValue : null as any;
        data["locationId"] = this.locationId !== undefined ? this.locationId : null as any;
        data["managerFirstName"] = this.managerFirstName !== undefined ? this.managerFirstName : null as any;
        data["managerLastName"] = this.managerLastName !== undefined ? this.managerLastName : null as any;
        data["managerFullName"] = this.managerFullName !== undefined ? this.managerFullName : null as any;
        data["managerContactPhone"] = this.managerContactPhone !== undefined ? this.managerContactPhone : null as any;
        data["managerEmail"] = this.managerEmail !== undefined ? this.managerEmail : null as any;
        data["managerHomeStoreNumber"] = this.managerHomeStoreNumber !== undefined ? this.managerHomeStoreNumber : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["group"] = this.group ? this.group.toJSON() : null as any;
        data["location"] = this.location ? this.location.toJSON() : null as any;
        return data;
    }

    clone(): AccountLocationGroupValue {
        const json = this.toJSON();
        let result = new AccountLocationGroupValue();
        result.init(json);
        return result;
    }
}

export interface IAccountLocationGroupValue {
    id?: number;
    groupId: number;
    groupValue: string;
    locationId: number;
    managerFirstName?: string | null;
    managerLastName?: string | null;
    managerFullName?: string | null;
    managerContactPhone?: string | null;
    managerEmail?: string | null;
    managerHomeStoreNumber?: string | null;
    version?: number;
    group?: AccountLocationGroupName | null;
    location?: Location | null;
}

export class AccountLocationGroupName implements IAccountLocationGroupName {
    id?: number;
    accountId!: number;
    groupName!: string;
    order?: number | null;
    account?: Account | null;

    constructor(data?: IAccountLocationGroupName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.groupName = _data["groupName"] !== undefined ? _data["groupName"] : null as any;
            this.order = _data["order"] !== undefined ? _data["order"] : null as any;
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : null as any;
        }
    }

    static fromJS(data: any): AccountLocationGroupName {
        data = typeof data === 'object' ? data : {};
        let result = new AccountLocationGroupName();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["groupName"] = this.groupName !== undefined ? this.groupName : null as any;
        data["order"] = this.order !== undefined ? this.order : null as any;
        data["account"] = this.account ? this.account.toJSON() : null as any;
        return data;
    }

    clone(): AccountLocationGroupName {
        const json = this.toJSON();
        let result = new AccountLocationGroupName();
        result.init(json);
        return result;
    }
}

export interface IAccountLocationGroupName {
    id?: number;
    accountId: number;
    groupName: string;
    order?: number | null;
    account?: Account | null;
}

export class ActivityDashboardComponentVisibility extends BaseEntity implements IActivityDashboardComponentVisibility {
    id?: number;
    dashboardComponentId?: number;
    activityId?: number;
    dashboardComponent?: DashboardComponent | null;
    activity?: Activity | null;

    constructor(data?: IActivityDashboardComponentVisibility) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.dashboardComponentId = _data["dashboardComponentId"] !== undefined ? _data["dashboardComponentId"] : null as any;
            this.activityId = _data["activityId"] !== undefined ? _data["activityId"] : null as any;
            this.dashboardComponent = _data["dashboardComponent"] ? DashboardComponent.fromJS(_data["dashboardComponent"]) : null as any;
            this.activity = _data["activity"] ? Activity.fromJS(_data["activity"]) : null as any;
        }
    }

    static override fromJS(data: any): ActivityDashboardComponentVisibility {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityDashboardComponentVisibility();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["dashboardComponentId"] = this.dashboardComponentId !== undefined ? this.dashboardComponentId : null as any;
        data["activityId"] = this.activityId !== undefined ? this.activityId : null as any;
        data["dashboardComponent"] = this.dashboardComponent ? this.dashboardComponent.toJSON() : null as any;
        data["activity"] = this.activity ? this.activity.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): ActivityDashboardComponentVisibility {
        const json = this.toJSON();
        let result = new ActivityDashboardComponentVisibility();
        result.init(json);
        return result;
    }
}

export interface IActivityDashboardComponentVisibility extends IBaseEntity {
    id?: number;
    dashboardComponentId?: number;
    activityId?: number;
    dashboardComponent?: DashboardComponent | null;
    activity?: Activity | null;
}

export class DashboardComponent extends BaseEntity implements IDashboardComponent {
    id?: number;
    name?: string | null;

    constructor(data?: IDashboardComponent) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static override fromJS(data: any): DashboardComponent {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardComponent();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): DashboardComponent {
        const json = this.toJSON();
        let result = new DashboardComponent();
        result.init(json);
        return result;
    }
}

export interface IDashboardComponent extends IBaseEntity {
    id?: number;
    name?: string | null;
}

export class Department extends BaseEntity implements IDepartment {
    departmentId?: number;
    departmentName?: string | null;
    accountId?: number | null;
    statusId?: number | null;
    departmentNumber?: string | null;
    detail?: string | null;
    strategicBusinessUnit?: string | null;
    departmentGroup?: string | null;
    displayDepartmentName?: string | null;
    order?: number;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment;
    account?: Account | null;
    status?: Status | null;

    constructor(data?: IDepartment) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.departmentId = _data["departmentId"] !== undefined ? _data["departmentId"] : null as any;
            this.departmentName = _data["departmentName"] !== undefined ? _data["departmentName"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            this.departmentNumber = _data["departmentNumber"] !== undefined ? _data["departmentNumber"] : null as any;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : null as any;
            this.strategicBusinessUnit = _data["strategicBusinessUnit"] !== undefined ? _data["strategicBusinessUnit"] : null as any;
            this.departmentGroup = _data["departmentGroup"] !== undefined ? _data["departmentGroup"] : null as any;
            this.displayDepartmentName = _data["displayDepartmentName"] !== undefined ? _data["displayDepartmentName"] : null as any;
            this.order = _data["order"] !== undefined ? _data["order"] : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : null as any;
            this.status = _data["status"] ? Status.fromJS(_data["status"]) : null as any;
        }
    }

    static override fromJS(data: any): Department {
        data = typeof data === 'object' ? data : {};
        let result = new Department();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentId"] = this.departmentId !== undefined ? this.departmentId : null as any;
        data["departmentName"] = this.departmentName !== undefined ? this.departmentName : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        data["departmentNumber"] = this.departmentNumber !== undefined ? this.departmentNumber : null as any;
        data["detail"] = this.detail !== undefined ? this.detail : null as any;
        data["strategicBusinessUnit"] = this.strategicBusinessUnit !== undefined ? this.strategicBusinessUnit : null as any;
        data["departmentGroup"] = this.departmentGroup !== undefined ? this.departmentGroup : null as any;
        data["displayDepartmentName"] = this.displayDepartmentName !== undefined ? this.displayDepartmentName : null as any;
        data["order"] = this.order !== undefined ? this.order : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        data["account"] = this.account ? this.account.toJSON() : null as any;
        data["status"] = this.status ? this.status.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): Department {
        const json = this.toJSON();
        let result = new Department();
        result.init(json);
        return result;
    }
}

export interface IDepartment extends IBaseEntity {
    departmentId?: number;
    departmentName?: string | null;
    accountId?: number | null;
    statusId?: number | null;
    departmentNumber?: string | null;
    detail?: string | null;
    strategicBusinessUnit?: string | null;
    departmentGroup?: string | null;
    displayDepartmentName?: string | null;
    order?: number;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment;
    account?: Account | null;
    status?: Status | null;
}

export class RetailerSupplier extends BaseEntity implements IRetailerSupplier {
    retailerSupplierId?: number;
    retailerAccountId?: number;
    supplierAccountId?: number;
    statusId?: number;
    retailerSupplierNote?: string | null;
    retailerAccount?: Account | null;
    status?: Status | null;
    supplierAccount?: Account | null;

    constructor(data?: IRetailerSupplier) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.retailerSupplierId = _data["retailerSupplierId"] !== undefined ? _data["retailerSupplierId"] : null as any;
            this.retailerAccountId = _data["retailerAccountId"] !== undefined ? _data["retailerAccountId"] : null as any;
            this.supplierAccountId = _data["supplierAccountId"] !== undefined ? _data["supplierAccountId"] : null as any;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            this.retailerSupplierNote = _data["retailerSupplierNote"] !== undefined ? _data["retailerSupplierNote"] : null as any;
            this.retailerAccount = _data["retailerAccount"] ? Account.fromJS(_data["retailerAccount"]) : null as any;
            this.status = _data["status"] ? Status.fromJS(_data["status"]) : null as any;
            this.supplierAccount = _data["supplierAccount"] ? Account.fromJS(_data["supplierAccount"]) : null as any;
        }
    }

    static override fromJS(data: any): RetailerSupplier {
        data = typeof data === 'object' ? data : {};
        let result = new RetailerSupplier();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["retailerSupplierId"] = this.retailerSupplierId !== undefined ? this.retailerSupplierId : null as any;
        data["retailerAccountId"] = this.retailerAccountId !== undefined ? this.retailerAccountId : null as any;
        data["supplierAccountId"] = this.supplierAccountId !== undefined ? this.supplierAccountId : null as any;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        data["retailerSupplierNote"] = this.retailerSupplierNote !== undefined ? this.retailerSupplierNote : null as any;
        data["retailerAccount"] = this.retailerAccount ? this.retailerAccount.toJSON() : null as any;
        data["status"] = this.status ? this.status.toJSON() : null as any;
        data["supplierAccount"] = this.supplierAccount ? this.supplierAccount.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): RetailerSupplier {
        const json = this.toJSON();
        let result = new RetailerSupplier();
        result.init(json);
        return result;
    }
}

export interface IRetailerSupplier extends IBaseEntity {
    retailerSupplierId?: number;
    retailerAccountId?: number;
    supplierAccountId?: number;
    statusId?: number;
    retailerSupplierNote?: string | null;
    retailerAccount?: Account | null;
    status?: Status | null;
    supplierAccount?: Account | null;
}

export class Product extends BaseEntity implements IProduct {
    productId?: number;
    productName!: string;
    cost?: number;
    productImageUrl?: string | null;
    statusId?: number | null;
    productTypeId?: number | null;
    accountProduct?: AccountProduct[] | null;
    status?: Status | null;
    productType?: ProductType | null;

    constructor(data?: IProduct) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.productId = _data["productId"] !== undefined ? _data["productId"] : null as any;
            this.productName = _data["productName"] !== undefined ? _data["productName"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
            this.productImageUrl = _data["productImageUrl"] !== undefined ? _data["productImageUrl"] : null as any;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            this.productTypeId = _data["productTypeId"] !== undefined ? _data["productTypeId"] : null as any;
            if (Array.isArray(_data["accountProduct"])) {
                this.accountProduct = [] as any;
                for (let item of _data["accountProduct"])
                    this.accountProduct!.push(AccountProduct.fromJS(item));
            }
            else {
                this.accountProduct = null as any;
            }
            this.status = _data["status"] ? Status.fromJS(_data["status"]) : null as any;
            this.productType = _data["productType"] ? ProductType.fromJS(_data["productType"]) : null as any;
        }
    }

    static override fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId !== undefined ? this.productId : null as any;
        data["productName"] = this.productName !== undefined ? this.productName : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        data["productImageUrl"] = this.productImageUrl !== undefined ? this.productImageUrl : null as any;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        data["productTypeId"] = this.productTypeId !== undefined ? this.productTypeId : null as any;
        if (Array.isArray(this.accountProduct)) {
            data["accountProduct"] = [];
            for (let item of this.accountProduct)
                data["accountProduct"].push(item ? item.toJSON() : null as any);
        }
        data["status"] = this.status ? this.status.toJSON() : null as any;
        data["productType"] = this.productType ? this.productType.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): Product {
        const json = this.toJSON();
        let result = new Product();
        result.init(json);
        return result;
    }
}

export interface IProduct extends IBaseEntity {
    productId?: number;
    productName: string;
    cost?: number;
    productImageUrl?: string | null;
    statusId?: number | null;
    productTypeId?: number | null;
    accountProduct?: AccountProduct[] | null;
    status?: Status | null;
    productType?: ProductType | null;
}

export class AccountProduct extends BaseEntity implements IAccountProduct {
    accountProductId?: number;
    accountId?: number | null;
    productId?: number | null;
    statusId?: number | null;
    account?: Account | null;
    status?: Status | null;
    product?: Product | null;

    constructor(data?: IAccountProduct) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accountProductId = _data["accountProductId"] !== undefined ? _data["accountProductId"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.productId = _data["productId"] !== undefined ? _data["productId"] : null as any;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : null as any;
            this.status = _data["status"] ? Status.fromJS(_data["status"]) : null as any;
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : null as any;
        }
    }

    static override fromJS(data: any): AccountProduct {
        data = typeof data === 'object' ? data : {};
        let result = new AccountProduct();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountProductId"] = this.accountProductId !== undefined ? this.accountProductId : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["productId"] = this.productId !== undefined ? this.productId : null as any;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        data["account"] = this.account ? this.account.toJSON() : null as any;
        data["status"] = this.status ? this.status.toJSON() : null as any;
        data["product"] = this.product ? this.product.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AccountProduct {
        const json = this.toJSON();
        let result = new AccountProduct();
        result.init(json);
        return result;
    }
}

export interface IAccountProduct extends IBaseEntity {
    accountProductId?: number;
    accountId?: number | null;
    productId?: number | null;
    statusId?: number | null;
    account?: Account | null;
    status?: Status | null;
    product?: Product | null;
}

export class ProductType extends BaseEntity implements IProductType {
    productTypeId?: number;
    productTypeName?: string | null;
    statusId?: number | null;
    product?: Product[] | null;
    status?: Status | null;

    constructor(data?: IProductType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.productTypeId = _data["productTypeId"] !== undefined ? _data["productTypeId"] : null as any;
            this.productTypeName = _data["productTypeName"] !== undefined ? _data["productTypeName"] : null as any;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            if (Array.isArray(_data["product"])) {
                this.product = [] as any;
                for (let item of _data["product"])
                    this.product!.push(Product.fromJS(item));
            }
            else {
                this.product = null as any;
            }
            this.status = _data["status"] ? Status.fromJS(_data["status"]) : null as any;
        }
    }

    static override fromJS(data: any): ProductType {
        data = typeof data === 'object' ? data : {};
        let result = new ProductType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productTypeId"] = this.productTypeId !== undefined ? this.productTypeId : null as any;
        data["productTypeName"] = this.productTypeName !== undefined ? this.productTypeName : null as any;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        if (Array.isArray(this.product)) {
            data["product"] = [];
            for (let item of this.product)
                data["product"].push(item ? item.toJSON() : null as any);
        }
        data["status"] = this.status ? this.status.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): ProductType {
        const json = this.toJSON();
        let result = new ProductType();
        result.init(json);
        return result;
    }
}

export interface IProductType extends IBaseEntity {
    productTypeId?: number;
    productTypeName?: string | null;
    statusId?: number | null;
    product?: Product[] | null;
    status?: Status | null;
}

export class App extends BaseEntity implements IApp {
    appID?: number;
    appName!: string;
    appNote?: string | null;
    appImageUrl?: string | null;
    statusId?: number | null;
    appLicensing?: AppLicensing[] | null;
    status?: Status | null;
    appRelationships?: AppRelationship[] | null;

    constructor(data?: IApp) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.appID = _data["appID"] !== undefined ? _data["appID"] : null as any;
            this.appName = _data["appName"] !== undefined ? _data["appName"] : null as any;
            this.appNote = _data["appNote"] !== undefined ? _data["appNote"] : null as any;
            this.appImageUrl = _data["appImageUrl"] !== undefined ? _data["appImageUrl"] : null as any;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            if (Array.isArray(_data["appLicensing"])) {
                this.appLicensing = [] as any;
                for (let item of _data["appLicensing"])
                    this.appLicensing!.push(AppLicensing.fromJS(item));
            }
            else {
                this.appLicensing = null as any;
            }
            this.status = _data["status"] ? Status.fromJS(_data["status"]) : null as any;
            if (Array.isArray(_data["appRelationships"])) {
                this.appRelationships = [] as any;
                for (let item of _data["appRelationships"])
                    this.appRelationships!.push(AppRelationship.fromJS(item));
            }
            else {
                this.appRelationships = null as any;
            }
        }
    }

    static override fromJS(data: any): App {
        data = typeof data === 'object' ? data : {};
        let result = new App();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appID"] = this.appID !== undefined ? this.appID : null as any;
        data["appName"] = this.appName !== undefined ? this.appName : null as any;
        data["appNote"] = this.appNote !== undefined ? this.appNote : null as any;
        data["appImageUrl"] = this.appImageUrl !== undefined ? this.appImageUrl : null as any;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        if (Array.isArray(this.appLicensing)) {
            data["appLicensing"] = [];
            for (let item of this.appLicensing)
                data["appLicensing"].push(item ? item.toJSON() : null as any);
        }
        data["status"] = this.status ? this.status.toJSON() : null as any;
        if (Array.isArray(this.appRelationships)) {
            data["appRelationships"] = [];
            for (let item of this.appRelationships)
                data["appRelationships"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): App {
        const json = this.toJSON();
        let result = new App();
        result.init(json);
        return result;
    }
}

export interface IApp extends IBaseEntity {
    appID?: number;
    appName: string;
    appNote?: string | null;
    appImageUrl?: string | null;
    statusId?: number | null;
    appLicensing?: AppLicensing[] | null;
    status?: Status | null;
    appRelationships?: AppRelationship[] | null;
}

export class AppLicensing extends BaseEntity implements IAppLicensing {
    appLicensingId?: number;
    accountId?: number | null;
    appId?: number | null;
    licenseCount?: number;
    updateDate?: moment.Moment;
    updatedBy?: number | null;
    account?: Account | null;
    app?: App | null;

    constructor(data?: IAppLicensing) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.appLicensingId = _data["appLicensingId"] !== undefined ? _data["appLicensingId"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.appId = _data["appId"] !== undefined ? _data["appId"] : null as any;
            this.licenseCount = _data["licenseCount"] !== undefined ? _data["licenseCount"] : null as any;
            this.updateDate = _data["updateDate"] ? moment(_data["updateDate"].toString()) : null as any;
            this.updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : null as any;
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : null as any;
            this.app = _data["app"] ? App.fromJS(_data["app"]) : null as any;
        }
    }

    static override fromJS(data: any): AppLicensing {
        data = typeof data === 'object' ? data : {};
        let result = new AppLicensing();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appLicensingId"] = this.appLicensingId !== undefined ? this.appLicensingId : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["appId"] = this.appId !== undefined ? this.appId : null as any;
        data["licenseCount"] = this.licenseCount !== undefined ? this.licenseCount : null as any;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : null as any;
        data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : null as any;
        data["account"] = this.account ? this.account.toJSON() : null as any;
        data["app"] = this.app ? this.app.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AppLicensing {
        const json = this.toJSON();
        let result = new AppLicensing();
        result.init(json);
        return result;
    }
}

export interface IAppLicensing extends IBaseEntity {
    appLicensingId?: number;
    accountId?: number | null;
    appId?: number | null;
    licenseCount?: number;
    updateDate?: moment.Moment;
    updatedBy?: number | null;
    account?: Account | null;
    app?: App | null;
}

export class AppRelationship extends BaseEntity implements IAppRelationship {
    id?: number;
    appId?: number;
    parentAppId?: number;
    app?: App | null;
    parentApp?: App | null;

    constructor(data?: IAppRelationship) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.appId = _data["appId"] !== undefined ? _data["appId"] : null as any;
            this.parentAppId = _data["parentAppId"] !== undefined ? _data["parentAppId"] : null as any;
            this.app = _data["app"] ? App.fromJS(_data["app"]) : null as any;
            this.parentApp = _data["parentApp"] ? App.fromJS(_data["parentApp"]) : null as any;
        }
    }

    static override fromJS(data: any): AppRelationship {
        data = typeof data === 'object' ? data : {};
        let result = new AppRelationship();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["appId"] = this.appId !== undefined ? this.appId : null as any;
        data["parentAppId"] = this.parentAppId !== undefined ? this.parentAppId : null as any;
        data["app"] = this.app ? this.app.toJSON() : null as any;
        data["parentApp"] = this.parentApp ? this.parentApp.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AppRelationship {
        const json = this.toJSON();
        let result = new AppRelationship();
        result.init(json);
        return result;
    }
}

export interface IAppRelationship extends IBaseEntity {
    id?: number;
    appId?: number;
    parentAppId?: number;
    app?: App | null;
    parentApp?: App | null;
}

export class Supplier extends BaseEntity implements ISupplier {
    supplierId?: number;
    supplierName?: string | null;
    statusId?: number | null;
    supplierNumber!: string;
    accountId?: number | null;
    supplierAccountId?: number | null;
    resale?: string | null;
    duns?: string | null;
    account?: Account | null;
    supplierAccount?: Account | null;
    status?: Status | null;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment | null;
    note?: string | null;

    constructor(data?: ISupplier) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.supplierId = _data["supplierId"] !== undefined ? _data["supplierId"] : null as any;
            this.supplierName = _data["supplierName"] !== undefined ? _data["supplierName"] : null as any;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            this.supplierNumber = _data["supplierNumber"] !== undefined ? _data["supplierNumber"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.supplierAccountId = _data["supplierAccountId"] !== undefined ? _data["supplierAccountId"] : null as any;
            this.resale = _data["resale"] !== undefined ? _data["resale"] : null as any;
            this.duns = _data["duns"] !== undefined ? _data["duns"] : null as any;
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : null as any;
            this.supplierAccount = _data["supplierAccount"] ? Account.fromJS(_data["supplierAccount"]) : null as any;
            this.status = _data["status"] ? Status.fromJS(_data["status"]) : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
        }
    }

    static override fromJS(data: any): Supplier {
        data = typeof data === 'object' ? data : {};
        let result = new Supplier();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierId"] = this.supplierId !== undefined ? this.supplierId : null as any;
        data["supplierName"] = this.supplierName !== undefined ? this.supplierName : null as any;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        data["supplierNumber"] = this.supplierNumber !== undefined ? this.supplierNumber : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["supplierAccountId"] = this.supplierAccountId !== undefined ? this.supplierAccountId : null as any;
        data["resale"] = this.resale !== undefined ? this.resale : null as any;
        data["duns"] = this.duns !== undefined ? this.duns : null as any;
        data["account"] = this.account ? this.account.toJSON() : null as any;
        data["supplierAccount"] = this.supplierAccount ? this.supplierAccount.toJSON() : null as any;
        data["status"] = this.status ? this.status.toJSON() : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): Supplier {
        const json = this.toJSON();
        let result = new Supplier();
        result.init(json);
        return result;
    }
}

export interface ISupplier extends IBaseEntity {
    supplierId?: number;
    supplierName?: string | null;
    statusId?: number | null;
    supplierNumber: string;
    accountId?: number | null;
    supplierAccountId?: number | null;
    resale?: string | null;
    duns?: string | null;
    account?: Account | null;
    supplierAccount?: Account | null;
    status?: Status | null;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment | null;
    note?: string | null;
}

export class FieldGroupType extends BaseEntity implements IFieldGroupType {
    id?: number;
    name!: string;
    description!: string;
    licenseAgreementUrl!: string;
    badgeFooterColor!: string;
    badgeFooter!: string;
    createdDate!: moment.Moment;
    updatedDate?: moment.Moment | null;
    updatedBy?: string | null;
    statusId?: number;
    templateKey?: string | null;
    wattFieldGroupTypeId?: string | null;
    templateAccount?: Account | null;
    status?: Status | null;
    account?: Account[] | null;
    invitedAccount?: InvitedAccount[] | null;

    constructor(data?: IFieldGroupType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.licenseAgreementUrl = _data["licenseAgreementUrl"] !== undefined ? _data["licenseAgreementUrl"] : null as any;
            this.badgeFooterColor = _data["badgeFooterColor"] !== undefined ? _data["badgeFooterColor"] : null as any;
            this.badgeFooter = _data["badgeFooter"] !== undefined ? _data["badgeFooter"] : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            this.updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : null as any;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            this.templateKey = _data["templateKey"] !== undefined ? _data["templateKey"] : null as any;
            this.wattFieldGroupTypeId = _data["wattFieldGroupTypeId"] !== undefined ? _data["wattFieldGroupTypeId"] : null as any;
            this.templateAccount = _data["templateAccount"] ? Account.fromJS(_data["templateAccount"]) : null as any;
            this.status = _data["status"] ? Status.fromJS(_data["status"]) : null as any;
            if (Array.isArray(_data["account"])) {
                this.account = [] as any;
                for (let item of _data["account"])
                    this.account!.push(Account.fromJS(item));
            }
            else {
                this.account = null as any;
            }
            if (Array.isArray(_data["invitedAccount"])) {
                this.invitedAccount = [] as any;
                for (let item of _data["invitedAccount"])
                    this.invitedAccount!.push(InvitedAccount.fromJS(item));
            }
            else {
                this.invitedAccount = null as any;
            }
        }
    }

    static override fromJS(data: any): FieldGroupType {
        data = typeof data === 'object' ? data : {};
        let result = new FieldGroupType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["licenseAgreementUrl"] = this.licenseAgreementUrl !== undefined ? this.licenseAgreementUrl : null as any;
        data["badgeFooterColor"] = this.badgeFooterColor !== undefined ? this.badgeFooterColor : null as any;
        data["badgeFooter"] = this.badgeFooter !== undefined ? this.badgeFooter : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : null as any;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        data["templateKey"] = this.templateKey !== undefined ? this.templateKey : null as any;
        data["wattFieldGroupTypeId"] = this.wattFieldGroupTypeId !== undefined ? this.wattFieldGroupTypeId : null as any;
        data["templateAccount"] = this.templateAccount ? this.templateAccount.toJSON() : null as any;
        data["status"] = this.status ? this.status.toJSON() : null as any;
        if (Array.isArray(this.account)) {
            data["account"] = [];
            for (let item of this.account)
                data["account"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.invitedAccount)) {
            data["invitedAccount"] = [];
            for (let item of this.invitedAccount)
                data["invitedAccount"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): FieldGroupType {
        const json = this.toJSON();
        let result = new FieldGroupType();
        result.init(json);
        return result;
    }
}

export interface IFieldGroupType extends IBaseEntity {
    id?: number;
    name: string;
    description: string;
    licenseAgreementUrl: string;
    badgeFooterColor: string;
    badgeFooter: string;
    createdDate: moment.Moment;
    updatedDate?: moment.Moment | null;
    updatedBy?: string | null;
    statusId?: number;
    templateKey?: string | null;
    wattFieldGroupTypeId?: string | null;
    templateAccount?: Account | null;
    status?: Status | null;
    account?: Account[] | null;
    invitedAccount?: InvitedAccount[] | null;
}

export class InvitedAccount extends BaseEntity implements IInvitedAccount {
    invitedAccountId?: number;
    invitedCompany!: string;
    invitedName!: string;
    invitedEmail!: string;
    invitedNote?: string | null;
    invitedCourse?: string | null;
    lastInvitedDate?: moment.Moment | null;
    fieldGroupType?: string | null;
    accountNumber?: string | null;
    accountTypeId?: number | null;
    accountId?: number | null;
    printBadge?: EBadgePrint;
    aname?: string | null;
    aabbrev?: string | null;
    aNote?: string | null;
    aimageUrl?: string | null;
    awebsite?: string | null;
    aaddress1?: string | null;
    aaddress2?: string | null;
    acity?: string | null;
    astate?: string | null;
    azip?: string | null;
    acountry?: string | null;
    baddress1?: string | null;
    baddress2?: string | null;
    bcity?: string | null;
    bstate?: string | null;
    bzip?: string | null;
    bcountry?: string | null;
    bphone?: string | null;
    billingEmail?: string | null;
    saddress1?: string | null;
    saddress2?: string | null;
    scity?: string | null;
    sstate?: string | null;
    szip?: string | null;
    scountry?: string | null;
    shipDirectToRep?: number | null;
    retailLink?: boolean;
    statusId?: number | null;
    billAttnToFname?: string | null;
    billAttnToLname?: string | null;
    shipAttnTo?: string | null;
    invitedDate?: moment.Moment | null;
    supportEmail?: string | null;
    supportPhone?: string | null;
    supportNote?: string | null;
    itcontactEmail?: string | null;
    itcontactPhone?: string | null;
    primaryAdminId?: number | null;
    fName?: string | null;
    lName?: string | null;
    email1?: string | null;
    subscriptionType?: string | null;
    password?: string | null;
    userSpecificEmailsForCommunication?: boolean | null;
    provideBadgeWithPhoto?: boolean | null;
    estimatedUsers?: string | null;
    uDirectlyEmployed?: string | null;
    uMobileEnabled?: string | null;
    pPhone?: string | null;
    reject?: string | null;
    retailerApprovalDate?: moment.Moment | null;
    registrationCompletionDate?: moment.Moment | null;
    fieldGroup?: FieldGroupType | null;
    selectedCertifications?: string | null;
    selectedProducts?: string | null;
    selectedApps?: string | null;

    constructor(data?: IInvitedAccount) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.invitedAccountId = _data["invitedAccountId"] !== undefined ? _data["invitedAccountId"] : null as any;
            this.invitedCompany = _data["invitedCompany"] !== undefined ? _data["invitedCompany"] : null as any;
            this.invitedName = _data["invitedName"] !== undefined ? _data["invitedName"] : null as any;
            this.invitedEmail = _data["invitedEmail"] !== undefined ? _data["invitedEmail"] : null as any;
            this.invitedNote = _data["invitedNote"] !== undefined ? _data["invitedNote"] : null as any;
            this.invitedCourse = _data["invitedCourse"] !== undefined ? _data["invitedCourse"] : null as any;
            this.lastInvitedDate = _data["lastInvitedDate"] ? moment(_data["lastInvitedDate"].toString()) : null as any;
            this.fieldGroupType = _data["fieldGroupType"] !== undefined ? _data["fieldGroupType"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.accountTypeId = _data["accountTypeId"] !== undefined ? _data["accountTypeId"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.printBadge = _data["printBadge"] !== undefined ? _data["printBadge"] : null as any;
            this.aname = _data["aname"] !== undefined ? _data["aname"] : null as any;
            this.aabbrev = _data["aabbrev"] !== undefined ? _data["aabbrev"] : null as any;
            this.aNote = _data["aNote"] !== undefined ? _data["aNote"] : null as any;
            this.aimageUrl = _data["aimageUrl"] !== undefined ? _data["aimageUrl"] : null as any;
            this.awebsite = _data["awebsite"] !== undefined ? _data["awebsite"] : null as any;
            this.aaddress1 = _data["aaddress1"] !== undefined ? _data["aaddress1"] : null as any;
            this.aaddress2 = _data["aaddress2"] !== undefined ? _data["aaddress2"] : null as any;
            this.acity = _data["acity"] !== undefined ? _data["acity"] : null as any;
            this.astate = _data["astate"] !== undefined ? _data["astate"] : null as any;
            this.azip = _data["azip"] !== undefined ? _data["azip"] : null as any;
            this.acountry = _data["acountry"] !== undefined ? _data["acountry"] : null as any;
            this.baddress1 = _data["baddress1"] !== undefined ? _data["baddress1"] : null as any;
            this.baddress2 = _data["baddress2"] !== undefined ? _data["baddress2"] : null as any;
            this.bcity = _data["bcity"] !== undefined ? _data["bcity"] : null as any;
            this.bstate = _data["bstate"] !== undefined ? _data["bstate"] : null as any;
            this.bzip = _data["bzip"] !== undefined ? _data["bzip"] : null as any;
            this.bcountry = _data["bcountry"] !== undefined ? _data["bcountry"] : null as any;
            this.bphone = _data["bphone"] !== undefined ? _data["bphone"] : null as any;
            this.billingEmail = _data["billingEmail"] !== undefined ? _data["billingEmail"] : null as any;
            this.saddress1 = _data["saddress1"] !== undefined ? _data["saddress1"] : null as any;
            this.saddress2 = _data["saddress2"] !== undefined ? _data["saddress2"] : null as any;
            this.scity = _data["scity"] !== undefined ? _data["scity"] : null as any;
            this.sstate = _data["sstate"] !== undefined ? _data["sstate"] : null as any;
            this.szip = _data["szip"] !== undefined ? _data["szip"] : null as any;
            this.scountry = _data["scountry"] !== undefined ? _data["scountry"] : null as any;
            this.shipDirectToRep = _data["shipDirectToRep"] !== undefined ? _data["shipDirectToRep"] : null as any;
            this.retailLink = _data["retailLink"] !== undefined ? _data["retailLink"] : null as any;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            this.billAttnToFname = _data["billAttnToFname"] !== undefined ? _data["billAttnToFname"] : null as any;
            this.billAttnToLname = _data["billAttnToLname"] !== undefined ? _data["billAttnToLname"] : null as any;
            this.shipAttnTo = _data["shipAttnTo"] !== undefined ? _data["shipAttnTo"] : null as any;
            this.invitedDate = _data["invitedDate"] ? moment(_data["invitedDate"].toString()) : null as any;
            this.supportEmail = _data["supportEmail"] !== undefined ? _data["supportEmail"] : null as any;
            this.supportPhone = _data["supportPhone"] !== undefined ? _data["supportPhone"] : null as any;
            this.supportNote = _data["supportNote"] !== undefined ? _data["supportNote"] : null as any;
            this.itcontactEmail = _data["itcontactEmail"] !== undefined ? _data["itcontactEmail"] : null as any;
            this.itcontactPhone = _data["itcontactPhone"] !== undefined ? _data["itcontactPhone"] : null as any;
            this.primaryAdminId = _data["primaryAdminId"] !== undefined ? _data["primaryAdminId"] : null as any;
            this.fName = _data["fName"] !== undefined ? _data["fName"] : null as any;
            this.lName = _data["lName"] !== undefined ? _data["lName"] : null as any;
            this.email1 = _data["email1"] !== undefined ? _data["email1"] : null as any;
            this.subscriptionType = _data["subscriptionType"] !== undefined ? _data["subscriptionType"] : null as any;
            this.password = _data["password"] !== undefined ? _data["password"] : null as any;
            this.userSpecificEmailsForCommunication = _data["userSpecificEmailsForCommunication"] !== undefined ? _data["userSpecificEmailsForCommunication"] : null as any;
            this.provideBadgeWithPhoto = _data["provideBadgeWithPhoto"] !== undefined ? _data["provideBadgeWithPhoto"] : null as any;
            this.estimatedUsers = _data["estimatedUsers"] !== undefined ? _data["estimatedUsers"] : null as any;
            this.uDirectlyEmployed = _data["uDirectlyEmployed"] !== undefined ? _data["uDirectlyEmployed"] : null as any;
            this.uMobileEnabled = _data["uMobileEnabled"] !== undefined ? _data["uMobileEnabled"] : null as any;
            this.pPhone = _data["pPhone"] !== undefined ? _data["pPhone"] : null as any;
            this.reject = _data["reject"] !== undefined ? _data["reject"] : null as any;
            this.retailerApprovalDate = _data["retailerApprovalDate"] ? moment(_data["retailerApprovalDate"].toString()) : null as any;
            this.registrationCompletionDate = _data["registrationCompletionDate"] ? moment(_data["registrationCompletionDate"].toString()) : null as any;
            this.fieldGroup = _data["fieldGroup"] ? FieldGroupType.fromJS(_data["fieldGroup"]) : null as any;
            this.selectedCertifications = _data["selectedCertifications"] !== undefined ? _data["selectedCertifications"] : null as any;
            this.selectedProducts = _data["selectedProducts"] !== undefined ? _data["selectedProducts"] : null as any;
            this.selectedApps = _data["selectedApps"] !== undefined ? _data["selectedApps"] : null as any;
        }
    }

    static override fromJS(data: any): InvitedAccount {
        data = typeof data === 'object' ? data : {};
        let result = new InvitedAccount();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invitedAccountId"] = this.invitedAccountId !== undefined ? this.invitedAccountId : null as any;
        data["invitedCompany"] = this.invitedCompany !== undefined ? this.invitedCompany : null as any;
        data["invitedName"] = this.invitedName !== undefined ? this.invitedName : null as any;
        data["invitedEmail"] = this.invitedEmail !== undefined ? this.invitedEmail : null as any;
        data["invitedNote"] = this.invitedNote !== undefined ? this.invitedNote : null as any;
        data["invitedCourse"] = this.invitedCourse !== undefined ? this.invitedCourse : null as any;
        data["lastInvitedDate"] = this.lastInvitedDate ? this.lastInvitedDate.toISOString() : null as any;
        data["fieldGroupType"] = this.fieldGroupType !== undefined ? this.fieldGroupType : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["accountTypeId"] = this.accountTypeId !== undefined ? this.accountTypeId : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["printBadge"] = this.printBadge !== undefined ? this.printBadge : null as any;
        data["aname"] = this.aname !== undefined ? this.aname : null as any;
        data["aabbrev"] = this.aabbrev !== undefined ? this.aabbrev : null as any;
        data["aNote"] = this.aNote !== undefined ? this.aNote : null as any;
        data["aimageUrl"] = this.aimageUrl !== undefined ? this.aimageUrl : null as any;
        data["awebsite"] = this.awebsite !== undefined ? this.awebsite : null as any;
        data["aaddress1"] = this.aaddress1 !== undefined ? this.aaddress1 : null as any;
        data["aaddress2"] = this.aaddress2 !== undefined ? this.aaddress2 : null as any;
        data["acity"] = this.acity !== undefined ? this.acity : null as any;
        data["astate"] = this.astate !== undefined ? this.astate : null as any;
        data["azip"] = this.azip !== undefined ? this.azip : null as any;
        data["acountry"] = this.acountry !== undefined ? this.acountry : null as any;
        data["baddress1"] = this.baddress1 !== undefined ? this.baddress1 : null as any;
        data["baddress2"] = this.baddress2 !== undefined ? this.baddress2 : null as any;
        data["bcity"] = this.bcity !== undefined ? this.bcity : null as any;
        data["bstate"] = this.bstate !== undefined ? this.bstate : null as any;
        data["bzip"] = this.bzip !== undefined ? this.bzip : null as any;
        data["bcountry"] = this.bcountry !== undefined ? this.bcountry : null as any;
        data["bphone"] = this.bphone !== undefined ? this.bphone : null as any;
        data["billingEmail"] = this.billingEmail !== undefined ? this.billingEmail : null as any;
        data["saddress1"] = this.saddress1 !== undefined ? this.saddress1 : null as any;
        data["saddress2"] = this.saddress2 !== undefined ? this.saddress2 : null as any;
        data["scity"] = this.scity !== undefined ? this.scity : null as any;
        data["sstate"] = this.sstate !== undefined ? this.sstate : null as any;
        data["szip"] = this.szip !== undefined ? this.szip : null as any;
        data["scountry"] = this.scountry !== undefined ? this.scountry : null as any;
        data["shipDirectToRep"] = this.shipDirectToRep !== undefined ? this.shipDirectToRep : null as any;
        data["retailLink"] = this.retailLink !== undefined ? this.retailLink : null as any;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        data["billAttnToFname"] = this.billAttnToFname !== undefined ? this.billAttnToFname : null as any;
        data["billAttnToLname"] = this.billAttnToLname !== undefined ? this.billAttnToLname : null as any;
        data["shipAttnTo"] = this.shipAttnTo !== undefined ? this.shipAttnTo : null as any;
        data["invitedDate"] = this.invitedDate ? this.invitedDate.toISOString() : null as any;
        data["supportEmail"] = this.supportEmail !== undefined ? this.supportEmail : null as any;
        data["supportPhone"] = this.supportPhone !== undefined ? this.supportPhone : null as any;
        data["supportNote"] = this.supportNote !== undefined ? this.supportNote : null as any;
        data["itcontactEmail"] = this.itcontactEmail !== undefined ? this.itcontactEmail : null as any;
        data["itcontactPhone"] = this.itcontactPhone !== undefined ? this.itcontactPhone : null as any;
        data["primaryAdminId"] = this.primaryAdminId !== undefined ? this.primaryAdminId : null as any;
        data["fName"] = this.fName !== undefined ? this.fName : null as any;
        data["lName"] = this.lName !== undefined ? this.lName : null as any;
        data["email1"] = this.email1 !== undefined ? this.email1 : null as any;
        data["subscriptionType"] = this.subscriptionType !== undefined ? this.subscriptionType : null as any;
        data["password"] = this.password !== undefined ? this.password : null as any;
        data["userSpecificEmailsForCommunication"] = this.userSpecificEmailsForCommunication !== undefined ? this.userSpecificEmailsForCommunication : null as any;
        data["provideBadgeWithPhoto"] = this.provideBadgeWithPhoto !== undefined ? this.provideBadgeWithPhoto : null as any;
        data["estimatedUsers"] = this.estimatedUsers !== undefined ? this.estimatedUsers : null as any;
        data["uDirectlyEmployed"] = this.uDirectlyEmployed !== undefined ? this.uDirectlyEmployed : null as any;
        data["uMobileEnabled"] = this.uMobileEnabled !== undefined ? this.uMobileEnabled : null as any;
        data["pPhone"] = this.pPhone !== undefined ? this.pPhone : null as any;
        data["reject"] = this.reject !== undefined ? this.reject : null as any;
        data["retailerApprovalDate"] = this.retailerApprovalDate ? this.retailerApprovalDate.toISOString() : null as any;
        data["registrationCompletionDate"] = this.registrationCompletionDate ? this.registrationCompletionDate.toISOString() : null as any;
        data["fieldGroup"] = this.fieldGroup ? this.fieldGroup.toJSON() : null as any;
        data["selectedCertifications"] = this.selectedCertifications !== undefined ? this.selectedCertifications : null as any;
        data["selectedProducts"] = this.selectedProducts !== undefined ? this.selectedProducts : null as any;
        data["selectedApps"] = this.selectedApps !== undefined ? this.selectedApps : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): InvitedAccount {
        const json = this.toJSON();
        let result = new InvitedAccount();
        result.init(json);
        return result;
    }
}

export interface IInvitedAccount extends IBaseEntity {
    invitedAccountId?: number;
    invitedCompany: string;
    invitedName: string;
    invitedEmail: string;
    invitedNote?: string | null;
    invitedCourse?: string | null;
    lastInvitedDate?: moment.Moment | null;
    fieldGroupType?: string | null;
    accountNumber?: string | null;
    accountTypeId?: number | null;
    accountId?: number | null;
    printBadge?: EBadgePrint;
    aname?: string | null;
    aabbrev?: string | null;
    aNote?: string | null;
    aimageUrl?: string | null;
    awebsite?: string | null;
    aaddress1?: string | null;
    aaddress2?: string | null;
    acity?: string | null;
    astate?: string | null;
    azip?: string | null;
    acountry?: string | null;
    baddress1?: string | null;
    baddress2?: string | null;
    bcity?: string | null;
    bstate?: string | null;
    bzip?: string | null;
    bcountry?: string | null;
    bphone?: string | null;
    billingEmail?: string | null;
    saddress1?: string | null;
    saddress2?: string | null;
    scity?: string | null;
    sstate?: string | null;
    szip?: string | null;
    scountry?: string | null;
    shipDirectToRep?: number | null;
    retailLink?: boolean;
    statusId?: number | null;
    billAttnToFname?: string | null;
    billAttnToLname?: string | null;
    shipAttnTo?: string | null;
    invitedDate?: moment.Moment | null;
    supportEmail?: string | null;
    supportPhone?: string | null;
    supportNote?: string | null;
    itcontactEmail?: string | null;
    itcontactPhone?: string | null;
    primaryAdminId?: number | null;
    fName?: string | null;
    lName?: string | null;
    email1?: string | null;
    subscriptionType?: string | null;
    password?: string | null;
    userSpecificEmailsForCommunication?: boolean | null;
    provideBadgeWithPhoto?: boolean | null;
    estimatedUsers?: string | null;
    uDirectlyEmployed?: string | null;
    uMobileEnabled?: string | null;
    pPhone?: string | null;
    reject?: string | null;
    retailerApprovalDate?: moment.Moment | null;
    registrationCompletionDate?: moment.Moment | null;
    fieldGroup?: FieldGroupType | null;
    selectedCertifications?: string | null;
    selectedProducts?: string | null;
    selectedApps?: string | null;
}

export class AccountRetailer extends BaseEntity implements IAccountRetailer {
    accountRetailerId?: number;
    fieldGroupAccountId?: number;
    retailerAccountId?: number;
    statusId?: number;
    accountRetailerNote?: string | null;
    fieldGroupAccount?: Account | null;
    retailerAccount?: Account | null;

    constructor(data?: IAccountRetailer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accountRetailerId = _data["accountRetailerId"] !== undefined ? _data["accountRetailerId"] : null as any;
            this.fieldGroupAccountId = _data["fieldGroupAccountId"] !== undefined ? _data["fieldGroupAccountId"] : null as any;
            this.retailerAccountId = _data["retailerAccountId"] !== undefined ? _data["retailerAccountId"] : null as any;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            this.accountRetailerNote = _data["accountRetailerNote"] !== undefined ? _data["accountRetailerNote"] : null as any;
            this.fieldGroupAccount = _data["fieldGroupAccount"] ? Account.fromJS(_data["fieldGroupAccount"]) : null as any;
            this.retailerAccount = _data["retailerAccount"] ? Account.fromJS(_data["retailerAccount"]) : null as any;
        }
    }

    static override fromJS(data: any): AccountRetailer {
        data = typeof data === 'object' ? data : {};
        let result = new AccountRetailer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountRetailerId"] = this.accountRetailerId !== undefined ? this.accountRetailerId : null as any;
        data["fieldGroupAccountId"] = this.fieldGroupAccountId !== undefined ? this.fieldGroupAccountId : null as any;
        data["retailerAccountId"] = this.retailerAccountId !== undefined ? this.retailerAccountId : null as any;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        data["accountRetailerNote"] = this.accountRetailerNote !== undefined ? this.accountRetailerNote : null as any;
        data["fieldGroupAccount"] = this.fieldGroupAccount ? this.fieldGroupAccount.toJSON() : null as any;
        data["retailerAccount"] = this.retailerAccount ? this.retailerAccount.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AccountRetailer {
        const json = this.toJSON();
        let result = new AccountRetailer();
        result.init(json);
        return result;
    }
}

export interface IAccountRetailer extends IBaseEntity {
    accountRetailerId?: number;
    fieldGroupAccountId?: number;
    retailerAccountId?: number;
    statusId?: number;
    accountRetailerNote?: string | null;
    fieldGroupAccount?: Account | null;
    retailerAccount?: Account | null;
}

export class AccountType extends BaseEntity implements IAccountType {
    accountTypeId?: number;
    accountTypeName?: string | null;
    account?: Account[] | null;

    constructor(data?: IAccountType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accountTypeId = _data["accountTypeId"] !== undefined ? _data["accountTypeId"] : null as any;
            this.accountTypeName = _data["accountTypeName"] !== undefined ? _data["accountTypeName"] : null as any;
            if (Array.isArray(_data["account"])) {
                this.account = [] as any;
                for (let item of _data["account"])
                    this.account!.push(Account.fromJS(item));
            }
            else {
                this.account = null as any;
            }
        }
    }

    static override fromJS(data: any): AccountType {
        data = typeof data === 'object' ? data : {};
        let result = new AccountType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountTypeId"] = this.accountTypeId !== undefined ? this.accountTypeId : null as any;
        data["accountTypeName"] = this.accountTypeName !== undefined ? this.accountTypeName : null as any;
        if (Array.isArray(this.account)) {
            data["account"] = [];
            for (let item of this.account)
                data["account"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): AccountType {
        const json = this.toJSON();
        let result = new AccountType();
        result.init(json);
        return result;
    }
}

export interface IAccountType extends IBaseEntity {
    accountTypeId?: number;
    accountTypeName?: string | null;
    account?: Account[] | null;
}

export class AccountHideTransaction extends BaseEntity implements IAccountHideTransaction {
    accountHideTransactionId?: number;
    accountID?: number;
    hideTransactions?: number;
    account?: Account | null;

    constructor(data?: IAccountHideTransaction) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accountHideTransactionId = _data["accountHideTransactionId"] !== undefined ? _data["accountHideTransactionId"] : null as any;
            this.accountID = _data["accountID"] !== undefined ? _data["accountID"] : null as any;
            this.hideTransactions = _data["hideTransactions"] !== undefined ? _data["hideTransactions"] : null as any;
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : null as any;
        }
    }

    static override fromJS(data: any): AccountHideTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new AccountHideTransaction();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountHideTransactionId"] = this.accountHideTransactionId !== undefined ? this.accountHideTransactionId : null as any;
        data["accountID"] = this.accountID !== undefined ? this.accountID : null as any;
        data["hideTransactions"] = this.hideTransactions !== undefined ? this.hideTransactions : null as any;
        data["account"] = this.account ? this.account.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AccountHideTransaction {
        const json = this.toJSON();
        let result = new AccountHideTransaction();
        result.init(json);
        return result;
    }
}

export interface IAccountHideTransaction extends IBaseEntity {
    accountHideTransactionId?: number;
    accountID?: number;
    hideTransactions?: number;
    account?: Account | null;
}

export class AccountTag extends BaseEntity implements IAccountTag {
    id?: number;
    tagId?: number;
    tag?: Tag | null;
    accountId?: number;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment;

    constructor(data?: IAccountTag) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.tagId = _data["tagId"] !== undefined ? _data["tagId"] : null as any;
            this.tag = _data["tag"] ? Tag.fromJS(_data["tag"]) : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
        }
    }

    static override fromJS(data: any): AccountTag {
        data = typeof data === 'object' ? data : {};
        let result = new AccountTag();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["tagId"] = this.tagId !== undefined ? this.tagId : null as any;
        data["tag"] = this.tag ? this.tag.toJSON() : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AccountTag {
        const json = this.toJSON();
        let result = new AccountTag();
        result.init(json);
        return result;
    }
}

export interface IAccountTag extends IBaseEntity {
    id?: number;
    tagId?: number;
    tag?: Tag | null;
    accountId?: number;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment;
}

export class CommunicationsAccountCategory extends BaseEntity implements ICommunicationsAccountCategory {
    id?: number;
    accountId?: number;
    categoryId?: number;
    providerAdmin?: boolean | null;
    fieldEmployee?: boolean | null;
    communicationCategory?: CommunicationCategories | null;
    account?: Account | null;

    constructor(data?: ICommunicationsAccountCategory) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null as any;
            this.providerAdmin = _data["providerAdmin"] !== undefined ? _data["providerAdmin"] : null as any;
            this.fieldEmployee = _data["fieldEmployee"] !== undefined ? _data["fieldEmployee"] : null as any;
            this.communicationCategory = _data["communicationCategory"] ? CommunicationCategories.fromJS(_data["communicationCategory"]) : null as any;
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : null as any;
        }
    }

    static override fromJS(data: any): CommunicationsAccountCategory {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationsAccountCategory();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null as any;
        data["providerAdmin"] = this.providerAdmin !== undefined ? this.providerAdmin : null as any;
        data["fieldEmployee"] = this.fieldEmployee !== undefined ? this.fieldEmployee : null as any;
        data["communicationCategory"] = this.communicationCategory ? this.communicationCategory.toJSON() : null as any;
        data["account"] = this.account ? this.account.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): CommunicationsAccountCategory {
        const json = this.toJSON();
        let result = new CommunicationsAccountCategory();
        result.init(json);
        return result;
    }
}

export interface ICommunicationsAccountCategory extends IBaseEntity {
    id?: number;
    accountId?: number;
    categoryId?: number;
    providerAdmin?: boolean | null;
    fieldEmployee?: boolean | null;
    communicationCategory?: CommunicationCategories | null;
    account?: Account | null;
}

export class CommunicationCategories extends BaseEntity implements ICommunicationCategories {
    id?: number;
    categoryName?: string | null;

    constructor(data?: ICommunicationCategories) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.categoryName = _data["categoryName"] !== undefined ? _data["categoryName"] : null as any;
        }
    }

    static override fromJS(data: any): CommunicationCategories {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationCategories();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["categoryName"] = this.categoryName !== undefined ? this.categoryName : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): CommunicationCategories {
        const json = this.toJSON();
        let result = new CommunicationCategories();
        result.init(json);
        return result;
    }
}

export interface ICommunicationCategories extends IBaseEntity {
    id?: number;
    categoryName?: string | null;
}

export class AccountRetailerCertification extends BaseEntity implements IAccountRetailerCertification {
    id?: number;
    accountId?: number;
    retailerCertificationId?: number;
    account?: Account | null;
    retailerCertification?: RetailerCertification | null;

    constructor(data?: IAccountRetailerCertification) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.retailerCertificationId = _data["retailerCertificationId"] !== undefined ? _data["retailerCertificationId"] : null as any;
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : null as any;
            this.retailerCertification = _data["retailerCertification"] ? RetailerCertification.fromJS(_data["retailerCertification"]) : null as any;
        }
    }

    static override fromJS(data: any): AccountRetailerCertification {
        data = typeof data === 'object' ? data : {};
        let result = new AccountRetailerCertification();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["retailerCertificationId"] = this.retailerCertificationId !== undefined ? this.retailerCertificationId : null as any;
        data["account"] = this.account ? this.account.toJSON() : null as any;
        data["retailerCertification"] = this.retailerCertification ? this.retailerCertification.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AccountRetailerCertification {
        const json = this.toJSON();
        let result = new AccountRetailerCertification();
        result.init(json);
        return result;
    }
}

export interface IAccountRetailerCertification extends IBaseEntity {
    id?: number;
    accountId?: number;
    retailerCertificationId?: number;
    account?: Account | null;
    retailerCertification?: RetailerCertification | null;
}

export class RetailerCertification extends BaseEntity implements IRetailerCertification {
    id?: number;
    certificationId?: number;
    statusId?: number;
    engageAccess?: boolean;
    requiredToPrintBadge?: boolean;
    status?: Status | null;
    accountRetailerCertifications?: AccountRetailerCertification[] | null;
    fieldGroupTypeCertifications?: FieldGroupTypeCertification[] | null;
    tagCertifications?: TagCertification[] | null;

    constructor(data?: IRetailerCertification) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.certificationId = _data["certificationId"] !== undefined ? _data["certificationId"] : null as any;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            this.engageAccess = _data["engageAccess"] !== undefined ? _data["engageAccess"] : null as any;
            this.requiredToPrintBadge = _data["requiredToPrintBadge"] !== undefined ? _data["requiredToPrintBadge"] : null as any;
            this.status = _data["status"] ? Status.fromJS(_data["status"]) : null as any;
            if (Array.isArray(_data["accountRetailerCertifications"])) {
                this.accountRetailerCertifications = [] as any;
                for (let item of _data["accountRetailerCertifications"])
                    this.accountRetailerCertifications!.push(AccountRetailerCertification.fromJS(item));
            }
            else {
                this.accountRetailerCertifications = null as any;
            }
            if (Array.isArray(_data["fieldGroupTypeCertifications"])) {
                this.fieldGroupTypeCertifications = [] as any;
                for (let item of _data["fieldGroupTypeCertifications"])
                    this.fieldGroupTypeCertifications!.push(FieldGroupTypeCertification.fromJS(item));
            }
            else {
                this.fieldGroupTypeCertifications = null as any;
            }
            if (Array.isArray(_data["tagCertifications"])) {
                this.tagCertifications = [] as any;
                for (let item of _data["tagCertifications"])
                    this.tagCertifications!.push(TagCertification.fromJS(item));
            }
            else {
                this.tagCertifications = null as any;
            }
        }
    }

    static override fromJS(data: any): RetailerCertification {
        data = typeof data === 'object' ? data : {};
        let result = new RetailerCertification();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["certificationId"] = this.certificationId !== undefined ? this.certificationId : null as any;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        data["engageAccess"] = this.engageAccess !== undefined ? this.engageAccess : null as any;
        data["requiredToPrintBadge"] = this.requiredToPrintBadge !== undefined ? this.requiredToPrintBadge : null as any;
        data["status"] = this.status ? this.status.toJSON() : null as any;
        if (Array.isArray(this.accountRetailerCertifications)) {
            data["accountRetailerCertifications"] = [];
            for (let item of this.accountRetailerCertifications)
                data["accountRetailerCertifications"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.fieldGroupTypeCertifications)) {
            data["fieldGroupTypeCertifications"] = [];
            for (let item of this.fieldGroupTypeCertifications)
                data["fieldGroupTypeCertifications"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.tagCertifications)) {
            data["tagCertifications"] = [];
            for (let item of this.tagCertifications)
                data["tagCertifications"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): RetailerCertification {
        const json = this.toJSON();
        let result = new RetailerCertification();
        result.init(json);
        return result;
    }
}

export interface IRetailerCertification extends IBaseEntity {
    id?: number;
    certificationId?: number;
    statusId?: number;
    engageAccess?: boolean;
    requiredToPrintBadge?: boolean;
    status?: Status | null;
    accountRetailerCertifications?: AccountRetailerCertification[] | null;
    fieldGroupTypeCertifications?: FieldGroupTypeCertification[] | null;
    tagCertifications?: TagCertification[] | null;
}

export class FieldGroupTypeCertification implements IFieldGroupTypeCertification {
    id?: number;
    fieldGroupTypeId?: number;
    retailerCertificationId?: number;
    fieldGroupType?: FieldGroupType | null;
    retailerCertification?: RetailerCertification | null;

    constructor(data?: IFieldGroupTypeCertification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.fieldGroupTypeId = _data["fieldGroupTypeId"] !== undefined ? _data["fieldGroupTypeId"] : null as any;
            this.retailerCertificationId = _data["retailerCertificationId"] !== undefined ? _data["retailerCertificationId"] : null as any;
            this.fieldGroupType = _data["fieldGroupType"] ? FieldGroupType.fromJS(_data["fieldGroupType"]) : null as any;
            this.retailerCertification = _data["retailerCertification"] ? RetailerCertification.fromJS(_data["retailerCertification"]) : null as any;
        }
    }

    static fromJS(data: any): FieldGroupTypeCertification {
        data = typeof data === 'object' ? data : {};
        let result = new FieldGroupTypeCertification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["fieldGroupTypeId"] = this.fieldGroupTypeId !== undefined ? this.fieldGroupTypeId : null as any;
        data["retailerCertificationId"] = this.retailerCertificationId !== undefined ? this.retailerCertificationId : null as any;
        data["fieldGroupType"] = this.fieldGroupType ? this.fieldGroupType.toJSON() : null as any;
        data["retailerCertification"] = this.retailerCertification ? this.retailerCertification.toJSON() : null as any;
        return data;
    }

    clone(): FieldGroupTypeCertification {
        const json = this.toJSON();
        let result = new FieldGroupTypeCertification();
        result.init(json);
        return result;
    }
}

export interface IFieldGroupTypeCertification {
    id?: number;
    fieldGroupTypeId?: number;
    retailerCertificationId?: number;
    fieldGroupType?: FieldGroupType | null;
    retailerCertification?: RetailerCertification | null;
}

export class TagCertification implements ITagCertification {
    id?: number;
    tagId?: number;
    retailerCertificationId?: number;
    tag?: Tag | null;
    retailerCertification?: RetailerCertification | null;

    constructor(data?: ITagCertification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.tagId = _data["tagId"] !== undefined ? _data["tagId"] : null as any;
            this.retailerCertificationId = _data["retailerCertificationId"] !== undefined ? _data["retailerCertificationId"] : null as any;
            this.tag = _data["tag"] ? Tag.fromJS(_data["tag"]) : null as any;
            this.retailerCertification = _data["retailerCertification"] ? RetailerCertification.fromJS(_data["retailerCertification"]) : null as any;
        }
    }

    static fromJS(data: any): TagCertification {
        data = typeof data === 'object' ? data : {};
        let result = new TagCertification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["tagId"] = this.tagId !== undefined ? this.tagId : null as any;
        data["retailerCertificationId"] = this.retailerCertificationId !== undefined ? this.retailerCertificationId : null as any;
        data["tag"] = this.tag ? this.tag.toJSON() : null as any;
        data["retailerCertification"] = this.retailerCertification ? this.retailerCertification.toJSON() : null as any;
        return data;
    }

    clone(): TagCertification {
        const json = this.toJSON();
        let result = new TagCertification();
        result.init(json);
        return result;
    }
}

export interface ITagCertification {
    id?: number;
    tagId?: number;
    retailerCertificationId?: number;
    tag?: Tag | null;
    retailerCertification?: RetailerCertification | null;
}

export class DropDownModel implements IDropDownModel {
    label?: string | null;
    value?: string | null;
    styleClass?: string | null;
    icon?: string | null;
    title?: string | null;

    constructor(data?: IDropDownModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"] !== undefined ? _data["label"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
            this.styleClass = _data["styleClass"] !== undefined ? _data["styleClass"] : null as any;
            this.icon = _data["icon"] !== undefined ? _data["icon"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
        }
    }

    static fromJS(data: any): DropDownModel {
        data = typeof data === 'object' ? data : {};
        let result = new DropDownModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label !== undefined ? this.label : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["styleClass"] = this.styleClass !== undefined ? this.styleClass : null as any;
        data["icon"] = this.icon !== undefined ? this.icon : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        return data;
    }

    clone(): DropDownModel {
        const json = this.toJSON();
        let result = new DropDownModel();
        result.init(json);
        return result;
    }
}

export interface IDropDownModel {
    label?: string | null;
    value?: string | null;
    styleClass?: string | null;
    icon?: string | null;
    title?: string | null;
}

export class AccountModel implements IAccountModel {
    accountId?: number;
    accountNumber?: string | null;
    accountTypeId?: number | null;
    aname?: string | null;
    aabbrev?: string | null;
    aimageUrl?: string | null;
    awebsite?: string | null;
    aaddress1?: string | null;
    aaddress2?: string | null;
    acity?: string | null;
    astate?: string | null;
    azip?: string | null;
    acountry?: string | null;
    baddress1?: string | null;
    baddress2?: string | null;
    bcity?: string | null;
    bstate?: string | null;
    bzip?: string | null;
    bcountry?: string | null;
    bphone?: string | null;
    billingEmail?: string | null;
    saddress1?: string | null;
    saddress2?: string | null;
    scity?: string | null;
    sstate?: string | null;
    szip?: string | null;
    scountry?: string | null;
    shipDirectToRep?: number | null;
    statusId?: number | null;
    showStoreSupportInfo?: boolean | null;
    storeSupportNumber?: string | null;
    storeSupportEmail?: string | null;
    anote?: string | null;
    asmallImageUrl?: string | null;
    billAttnToFname?: string | null;
    billAttnToLname?: string | null;
    shipAttnTo?: string | null;
    dateCreated?: moment.Moment | null;
    authToken?: string | null;
    supportEmail?: string | null;
    supportPhone?: string | null;
    supportNote?: string | null;
    itcontactEmail?: string | null;
    itcontactPhone?: string | null;
    fieldGroupType?: string | null;
    primaryAdminId?: number;
    associatedBanners?: string[] | null;

    constructor(data?: IAccountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.accountTypeId = _data["accountTypeId"] !== undefined ? _data["accountTypeId"] : null as any;
            this.aname = _data["aname"] !== undefined ? _data["aname"] : null as any;
            this.aabbrev = _data["aabbrev"] !== undefined ? _data["aabbrev"] : null as any;
            this.aimageUrl = _data["aimageUrl"] !== undefined ? _data["aimageUrl"] : null as any;
            this.awebsite = _data["awebsite"] !== undefined ? _data["awebsite"] : null as any;
            this.aaddress1 = _data["aaddress1"] !== undefined ? _data["aaddress1"] : null as any;
            this.aaddress2 = _data["aaddress2"] !== undefined ? _data["aaddress2"] : null as any;
            this.acity = _data["acity"] !== undefined ? _data["acity"] : null as any;
            this.astate = _data["astate"] !== undefined ? _data["astate"] : null as any;
            this.azip = _data["azip"] !== undefined ? _data["azip"] : null as any;
            this.acountry = _data["acountry"] !== undefined ? _data["acountry"] : null as any;
            this.baddress1 = _data["baddress1"] !== undefined ? _data["baddress1"] : null as any;
            this.baddress2 = _data["baddress2"] !== undefined ? _data["baddress2"] : null as any;
            this.bcity = _data["bcity"] !== undefined ? _data["bcity"] : null as any;
            this.bstate = _data["bstate"] !== undefined ? _data["bstate"] : null as any;
            this.bzip = _data["bzip"] !== undefined ? _data["bzip"] : null as any;
            this.bcountry = _data["bcountry"] !== undefined ? _data["bcountry"] : null as any;
            this.bphone = _data["bphone"] !== undefined ? _data["bphone"] : null as any;
            this.billingEmail = _data["billingEmail"] !== undefined ? _data["billingEmail"] : null as any;
            this.saddress1 = _data["saddress1"] !== undefined ? _data["saddress1"] : null as any;
            this.saddress2 = _data["saddress2"] !== undefined ? _data["saddress2"] : null as any;
            this.scity = _data["scity"] !== undefined ? _data["scity"] : null as any;
            this.sstate = _data["sstate"] !== undefined ? _data["sstate"] : null as any;
            this.szip = _data["szip"] !== undefined ? _data["szip"] : null as any;
            this.scountry = _data["scountry"] !== undefined ? _data["scountry"] : null as any;
            this.shipDirectToRep = _data["shipDirectToRep"] !== undefined ? _data["shipDirectToRep"] : null as any;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            this.showStoreSupportInfo = _data["showStoreSupportInfo"] !== undefined ? _data["showStoreSupportInfo"] : null as any;
            this.storeSupportNumber = _data["storeSupportNumber"] !== undefined ? _data["storeSupportNumber"] : null as any;
            this.storeSupportEmail = _data["storeSupportEmail"] !== undefined ? _data["storeSupportEmail"] : null as any;
            this.anote = _data["anote"] !== undefined ? _data["anote"] : null as any;
            this.asmallImageUrl = _data["asmallImageUrl"] !== undefined ? _data["asmallImageUrl"] : null as any;
            this.billAttnToFname = _data["billAttnToFname"] !== undefined ? _data["billAttnToFname"] : null as any;
            this.billAttnToLname = _data["billAttnToLname"] !== undefined ? _data["billAttnToLname"] : null as any;
            this.shipAttnTo = _data["shipAttnTo"] !== undefined ? _data["shipAttnTo"] : null as any;
            this.dateCreated = _data["dateCreated"] ? moment(_data["dateCreated"].toString()) : null as any;
            this.authToken = _data["authToken"] !== undefined ? _data["authToken"] : null as any;
            this.supportEmail = _data["supportEmail"] !== undefined ? _data["supportEmail"] : null as any;
            this.supportPhone = _data["supportPhone"] !== undefined ? _data["supportPhone"] : null as any;
            this.supportNote = _data["supportNote"] !== undefined ? _data["supportNote"] : null as any;
            this.itcontactEmail = _data["itcontactEmail"] !== undefined ? _data["itcontactEmail"] : null as any;
            this.itcontactPhone = _data["itcontactPhone"] !== undefined ? _data["itcontactPhone"] : null as any;
            this.fieldGroupType = _data["fieldGroupType"] !== undefined ? _data["fieldGroupType"] : null as any;
            this.primaryAdminId = _data["primaryAdminId"] !== undefined ? _data["primaryAdminId"] : null as any;
            if (Array.isArray(_data["associatedBanners"])) {
                this.associatedBanners = [] as any;
                for (let item of _data["associatedBanners"])
                    this.associatedBanners!.push(item);
            }
            else {
                this.associatedBanners = null as any;
            }
        }
    }

    static fromJS(data: any): AccountModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["accountTypeId"] = this.accountTypeId !== undefined ? this.accountTypeId : null as any;
        data["aname"] = this.aname !== undefined ? this.aname : null as any;
        data["aabbrev"] = this.aabbrev !== undefined ? this.aabbrev : null as any;
        data["aimageUrl"] = this.aimageUrl !== undefined ? this.aimageUrl : null as any;
        data["awebsite"] = this.awebsite !== undefined ? this.awebsite : null as any;
        data["aaddress1"] = this.aaddress1 !== undefined ? this.aaddress1 : null as any;
        data["aaddress2"] = this.aaddress2 !== undefined ? this.aaddress2 : null as any;
        data["acity"] = this.acity !== undefined ? this.acity : null as any;
        data["astate"] = this.astate !== undefined ? this.astate : null as any;
        data["azip"] = this.azip !== undefined ? this.azip : null as any;
        data["acountry"] = this.acountry !== undefined ? this.acountry : null as any;
        data["baddress1"] = this.baddress1 !== undefined ? this.baddress1 : null as any;
        data["baddress2"] = this.baddress2 !== undefined ? this.baddress2 : null as any;
        data["bcity"] = this.bcity !== undefined ? this.bcity : null as any;
        data["bstate"] = this.bstate !== undefined ? this.bstate : null as any;
        data["bzip"] = this.bzip !== undefined ? this.bzip : null as any;
        data["bcountry"] = this.bcountry !== undefined ? this.bcountry : null as any;
        data["bphone"] = this.bphone !== undefined ? this.bphone : null as any;
        data["billingEmail"] = this.billingEmail !== undefined ? this.billingEmail : null as any;
        data["saddress1"] = this.saddress1 !== undefined ? this.saddress1 : null as any;
        data["saddress2"] = this.saddress2 !== undefined ? this.saddress2 : null as any;
        data["scity"] = this.scity !== undefined ? this.scity : null as any;
        data["sstate"] = this.sstate !== undefined ? this.sstate : null as any;
        data["szip"] = this.szip !== undefined ? this.szip : null as any;
        data["scountry"] = this.scountry !== undefined ? this.scountry : null as any;
        data["shipDirectToRep"] = this.shipDirectToRep !== undefined ? this.shipDirectToRep : null as any;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        data["showStoreSupportInfo"] = this.showStoreSupportInfo !== undefined ? this.showStoreSupportInfo : null as any;
        data["storeSupportNumber"] = this.storeSupportNumber !== undefined ? this.storeSupportNumber : null as any;
        data["storeSupportEmail"] = this.storeSupportEmail !== undefined ? this.storeSupportEmail : null as any;
        data["anote"] = this.anote !== undefined ? this.anote : null as any;
        data["asmallImageUrl"] = this.asmallImageUrl !== undefined ? this.asmallImageUrl : null as any;
        data["billAttnToFname"] = this.billAttnToFname !== undefined ? this.billAttnToFname : null as any;
        data["billAttnToLname"] = this.billAttnToLname !== undefined ? this.billAttnToLname : null as any;
        data["shipAttnTo"] = this.shipAttnTo !== undefined ? this.shipAttnTo : null as any;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : null as any;
        data["authToken"] = this.authToken !== undefined ? this.authToken : null as any;
        data["supportEmail"] = this.supportEmail !== undefined ? this.supportEmail : null as any;
        data["supportPhone"] = this.supportPhone !== undefined ? this.supportPhone : null as any;
        data["supportNote"] = this.supportNote !== undefined ? this.supportNote : null as any;
        data["itcontactEmail"] = this.itcontactEmail !== undefined ? this.itcontactEmail : null as any;
        data["itcontactPhone"] = this.itcontactPhone !== undefined ? this.itcontactPhone : null as any;
        data["fieldGroupType"] = this.fieldGroupType !== undefined ? this.fieldGroupType : null as any;
        data["primaryAdminId"] = this.primaryAdminId !== undefined ? this.primaryAdminId : null as any;
        if (Array.isArray(this.associatedBanners)) {
            data["associatedBanners"] = [];
            for (let item of this.associatedBanners)
                data["associatedBanners"].push(item);
        }
        return data;
    }

    clone(): AccountModel {
        const json = this.toJSON();
        let result = new AccountModel();
        result.init(json);
        return result;
    }
}

export interface IAccountModel {
    accountId?: number;
    accountNumber?: string | null;
    accountTypeId?: number | null;
    aname?: string | null;
    aabbrev?: string | null;
    aimageUrl?: string | null;
    awebsite?: string | null;
    aaddress1?: string | null;
    aaddress2?: string | null;
    acity?: string | null;
    astate?: string | null;
    azip?: string | null;
    acountry?: string | null;
    baddress1?: string | null;
    baddress2?: string | null;
    bcity?: string | null;
    bstate?: string | null;
    bzip?: string | null;
    bcountry?: string | null;
    bphone?: string | null;
    billingEmail?: string | null;
    saddress1?: string | null;
    saddress2?: string | null;
    scity?: string | null;
    sstate?: string | null;
    szip?: string | null;
    scountry?: string | null;
    shipDirectToRep?: number | null;
    statusId?: number | null;
    showStoreSupportInfo?: boolean | null;
    storeSupportNumber?: string | null;
    storeSupportEmail?: string | null;
    anote?: string | null;
    asmallImageUrl?: string | null;
    billAttnToFname?: string | null;
    billAttnToLname?: string | null;
    shipAttnTo?: string | null;
    dateCreated?: moment.Moment | null;
    authToken?: string | null;
    supportEmail?: string | null;
    supportPhone?: string | null;
    supportNote?: string | null;
    itcontactEmail?: string | null;
    itcontactPhone?: string | null;
    fieldGroupType?: string | null;
    primaryAdminId?: number;
    associatedBanners?: string[] | null;
}

export class PersonListViewModel implements IPersonListViewModel {
    personId?: number;
    number?: string | null;
    nickName?: string | null;
    name?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    approvalStatusId?: number | null;
    trainingStatus?: string | null;
    coursePersonId?: number;
    success?: string | null;
    badge?: string | null;
    accountType?: string | null;
    roleType?: string | null;
    accountName?: string | null;
    roleName?: string | null;

    constructor(data?: IPersonListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null as any;
            this.number = _data["number"] !== undefined ? _data["number"] : null as any;
            this.nickName = _data["nickName"] !== undefined ? _data["nickName"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.approvalStatusId = _data["approvalStatusId"] !== undefined ? _data["approvalStatusId"] : null as any;
            this.trainingStatus = _data["trainingStatus"] !== undefined ? _data["trainingStatus"] : null as any;
            this.coursePersonId = _data["coursePersonId"] !== undefined ? _data["coursePersonId"] : null as any;
            this.success = _data["success"] !== undefined ? _data["success"] : null as any;
            this.badge = _data["badge"] !== undefined ? _data["badge"] : null as any;
            this.accountType = _data["accountType"] !== undefined ? _data["accountType"] : null as any;
            this.roleType = _data["roleType"] !== undefined ? _data["roleType"] : null as any;
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.roleName = _data["roleName"] !== undefined ? _data["roleName"] : null as any;
        }
    }

    static fromJS(data: any): PersonListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PersonListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId !== undefined ? this.personId : null as any;
        data["number"] = this.number !== undefined ? this.number : null as any;
        data["nickName"] = this.nickName !== undefined ? this.nickName : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["approvalStatusId"] = this.approvalStatusId !== undefined ? this.approvalStatusId : null as any;
        data["trainingStatus"] = this.trainingStatus !== undefined ? this.trainingStatus : null as any;
        data["coursePersonId"] = this.coursePersonId !== undefined ? this.coursePersonId : null as any;
        data["success"] = this.success !== undefined ? this.success : null as any;
        data["badge"] = this.badge !== undefined ? this.badge : null as any;
        data["accountType"] = this.accountType !== undefined ? this.accountType : null as any;
        data["roleType"] = this.roleType !== undefined ? this.roleType : null as any;
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["roleName"] = this.roleName !== undefined ? this.roleName : null as any;
        return data;
    }

    clone(): PersonListViewModel {
        const json = this.toJSON();
        let result = new PersonListViewModel();
        result.init(json);
        return result;
    }
}

export interface IPersonListViewModel {
    personId?: number;
    number?: string | null;
    nickName?: string | null;
    name?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    approvalStatusId?: number | null;
    trainingStatus?: string | null;
    coursePersonId?: number;
    success?: string | null;
    badge?: string | null;
    accountType?: string | null;
    roleType?: string | null;
    accountName?: string | null;
    roleName?: string | null;
}

export class AccountAppLinkModel implements IAccountAppLinkModel {
    id?: number | null;
    accountId?: number | null;
    activity?: string | null;
    note?: string | null;
    linkType?: string | null;
    link?: string | null;

    constructor(data?: IAccountAppLinkModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.activity = _data["activity"] !== undefined ? _data["activity"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.linkType = _data["linkType"] !== undefined ? _data["linkType"] : null as any;
            this.link = _data["link"] !== undefined ? _data["link"] : null as any;
        }
    }

    static fromJS(data: any): AccountAppLinkModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountAppLinkModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["activity"] = this.activity !== undefined ? this.activity : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["linkType"] = this.linkType !== undefined ? this.linkType : null as any;
        data["link"] = this.link !== undefined ? this.link : null as any;
        return data;
    }

    clone(): AccountAppLinkModel {
        const json = this.toJSON();
        let result = new AccountAppLinkModel();
        result.init(json);
        return result;
    }
}

export interface IAccountAppLinkModel {
    id?: number | null;
    accountId?: number | null;
    activity?: string | null;
    note?: string | null;
    linkType?: string | null;
    link?: string | null;
}

export class UserAccountViewModel implements IUserAccountViewModel {
    accountId?: number;
    aname?: string | null;
    shipDirectToRep?: number | null;
    fieldGroupType?: string | null;
    isUserIdAsLogin?: boolean;
    associatedBanners?: string[] | null;
    status?: StatusTypes;

    constructor(data?: IUserAccountViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.aname = _data["aname"] !== undefined ? _data["aname"] : null as any;
            this.shipDirectToRep = _data["shipDirectToRep"] !== undefined ? _data["shipDirectToRep"] : null as any;
            this.fieldGroupType = _data["fieldGroupType"] !== undefined ? _data["fieldGroupType"] : null as any;
            this.isUserIdAsLogin = _data["isUserIdAsLogin"] !== undefined ? _data["isUserIdAsLogin"] : null as any;
            if (Array.isArray(_data["associatedBanners"])) {
                this.associatedBanners = [] as any;
                for (let item of _data["associatedBanners"])
                    this.associatedBanners!.push(item);
            }
            else {
                this.associatedBanners = null as any;
            }
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
        }
    }

    static fromJS(data: any): UserAccountViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserAccountViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["aname"] = this.aname !== undefined ? this.aname : null as any;
        data["shipDirectToRep"] = this.shipDirectToRep !== undefined ? this.shipDirectToRep : null as any;
        data["fieldGroupType"] = this.fieldGroupType !== undefined ? this.fieldGroupType : null as any;
        data["isUserIdAsLogin"] = this.isUserIdAsLogin !== undefined ? this.isUserIdAsLogin : null as any;
        if (Array.isArray(this.associatedBanners)) {
            data["associatedBanners"] = [];
            for (let item of this.associatedBanners)
                data["associatedBanners"].push(item);
        }
        data["status"] = this.status !== undefined ? this.status : null as any;
        return data;
    }

    clone(): UserAccountViewModel {
        const json = this.toJSON();
        let result = new UserAccountViewModel();
        result.init(json);
        return result;
    }
}

export interface IUserAccountViewModel {
    accountId?: number;
    aname?: string | null;
    shipDirectToRep?: number | null;
    fieldGroupType?: string | null;
    isUserIdAsLogin?: boolean;
    associatedBanners?: string[] | null;
    status?: StatusTypes;
}

export class OperationBase implements IOperationBase {
    path?: string | null;
    op?: string | null;
    from?: string | null;

    constructor(data?: IOperationBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.path = _data["path"] !== undefined ? _data["path"] : null as any;
            this.op = _data["op"] !== undefined ? _data["op"] : null as any;
            this.from = _data["from"] !== undefined ? _data["from"] : null as any;
        }
    }

    static fromJS(data: any): OperationBase {
        data = typeof data === 'object' ? data : {};
        let result = new OperationBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["path"] = this.path !== undefined ? this.path : null as any;
        data["op"] = this.op !== undefined ? this.op : null as any;
        data["from"] = this.from !== undefined ? this.from : null as any;
        return data;
    }

    clone(): OperationBase {
        const json = this.toJSON();
        let result = new OperationBase();
        result.init(json);
        return result;
    }
}

export interface IOperationBase {
    path?: string | null;
    op?: string | null;
    from?: string | null;
}

export class Operation extends OperationBase implements IOperation {
    value?: any | null;

    constructor(data?: IOperation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
        }
    }

    static override fromJS(data: any): Operation {
        data = typeof data === 'object' ? data : {};
        let result = new Operation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): Operation {
        const json = this.toJSON();
        let result = new Operation();
        result.init(json);
        return result;
    }
}

export interface IOperation extends IOperationBase {
    value?: any | null;
}

export class AccountInfoViewModel implements IAccountInfoViewModel {
    aname?: string | null;
    aabbrev?: string | null;
    accountId?: number | null;
    primaryAdminFirstName?: string | null;
    primaryAdminLastName?: string | null;
    primaryAdminEmail?: string | null;
    primaryAdminId?: number;
    primaryAdminStatus?: EStatus;
    walmartSupplierNumber?: string | null;
    fieldGroupType?: string | null;
    statusId?: number | null;
    companyNotes?: string | null;
    billingContactFirstName?: string | null;
    billingContactLastName?: string | null;
    billingContactEmail?: string | null;
    billingContactPhone?: string | null;
    billingContactAddress1?: string | null;
    billingContactAddress2?: string | null;
    billingContactCity?: string | null;
    billingContactState?: string | null;
    billingContactCountry?: string | null;
    billingContactZipCode?: string | null;
    printBadge?: string | null;
    shippingContactName?: string | null;
    shippingContactAddress1?: string | null;
    shippingContactAddress2?: string | null;
    shippingContactCity?: string | null;
    shippingContactState?: string | null;
    shippingContactCountry?: string | null;
    shippingContactZipCode?: string | null;
    supportContactEmail?: string | null;
    supportContactPhone?: string | null;
    supportContactNote?: string | null;
    displayStoreSupportInfoOnLocationDetailPage?: boolean | null;
    storeSupportNumber?: string | null;
    storeSupportEmail?: string | null;
    technicalContactEmail?: string | null;
    technicalContactPhone?: string | null;
    apiKey?: string | null;
    aImageUrl?: string | null;

    constructor(data?: IAccountInfoViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aname = _data["aname"] !== undefined ? _data["aname"] : null as any;
            this.aabbrev = _data["aabbrev"] !== undefined ? _data["aabbrev"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.primaryAdminFirstName = _data["primaryAdminFirstName"] !== undefined ? _data["primaryAdminFirstName"] : null as any;
            this.primaryAdminLastName = _data["primaryAdminLastName"] !== undefined ? _data["primaryAdminLastName"] : null as any;
            this.primaryAdminEmail = _data["primaryAdminEmail"] !== undefined ? _data["primaryAdminEmail"] : null as any;
            this.primaryAdminId = _data["primaryAdminId"] !== undefined ? _data["primaryAdminId"] : null as any;
            this.primaryAdminStatus = _data["primaryAdminStatus"] !== undefined ? _data["primaryAdminStatus"] : null as any;
            this.walmartSupplierNumber = _data["walmartSupplierNumber"] !== undefined ? _data["walmartSupplierNumber"] : null as any;
            this.fieldGroupType = _data["fieldGroupType"] !== undefined ? _data["fieldGroupType"] : null as any;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            this.companyNotes = _data["companyNotes"] !== undefined ? _data["companyNotes"] : null as any;
            this.billingContactFirstName = _data["billingContactFirstName"] !== undefined ? _data["billingContactFirstName"] : null as any;
            this.billingContactLastName = _data["billingContactLastName"] !== undefined ? _data["billingContactLastName"] : null as any;
            this.billingContactEmail = _data["billingContactEmail"] !== undefined ? _data["billingContactEmail"] : null as any;
            this.billingContactPhone = _data["billingContactPhone"] !== undefined ? _data["billingContactPhone"] : null as any;
            this.billingContactAddress1 = _data["billingContactAddress1"] !== undefined ? _data["billingContactAddress1"] : null as any;
            this.billingContactAddress2 = _data["billingContactAddress2"] !== undefined ? _data["billingContactAddress2"] : null as any;
            this.billingContactCity = _data["billingContactCity"] !== undefined ? _data["billingContactCity"] : null as any;
            this.billingContactState = _data["billingContactState"] !== undefined ? _data["billingContactState"] : null as any;
            this.billingContactCountry = _data["billingContactCountry"] !== undefined ? _data["billingContactCountry"] : null as any;
            this.billingContactZipCode = _data["billingContactZipCode"] !== undefined ? _data["billingContactZipCode"] : null as any;
            this.printBadge = _data["printBadge"] !== undefined ? _data["printBadge"] : null as any;
            this.shippingContactName = _data["shippingContactName"] !== undefined ? _data["shippingContactName"] : null as any;
            this.shippingContactAddress1 = _data["shippingContactAddress1"] !== undefined ? _data["shippingContactAddress1"] : null as any;
            this.shippingContactAddress2 = _data["shippingContactAddress2"] !== undefined ? _data["shippingContactAddress2"] : null as any;
            this.shippingContactCity = _data["shippingContactCity"] !== undefined ? _data["shippingContactCity"] : null as any;
            this.shippingContactState = _data["shippingContactState"] !== undefined ? _data["shippingContactState"] : null as any;
            this.shippingContactCountry = _data["shippingContactCountry"] !== undefined ? _data["shippingContactCountry"] : null as any;
            this.shippingContactZipCode = _data["shippingContactZipCode"] !== undefined ? _data["shippingContactZipCode"] : null as any;
            this.supportContactEmail = _data["supportContactEmail"] !== undefined ? _data["supportContactEmail"] : null as any;
            this.supportContactPhone = _data["supportContactPhone"] !== undefined ? _data["supportContactPhone"] : null as any;
            this.supportContactNote = _data["supportContactNote"] !== undefined ? _data["supportContactNote"] : null as any;
            this.displayStoreSupportInfoOnLocationDetailPage = _data["displayStoreSupportInfoOnLocationDetailPage"] !== undefined ? _data["displayStoreSupportInfoOnLocationDetailPage"] : null as any;
            this.storeSupportNumber = _data["storeSupportNumber"] !== undefined ? _data["storeSupportNumber"] : null as any;
            this.storeSupportEmail = _data["storeSupportEmail"] !== undefined ? _data["storeSupportEmail"] : null as any;
            this.technicalContactEmail = _data["technicalContactEmail"] !== undefined ? _data["technicalContactEmail"] : null as any;
            this.technicalContactPhone = _data["technicalContactPhone"] !== undefined ? _data["technicalContactPhone"] : null as any;
            this.apiKey = _data["apiKey"] !== undefined ? _data["apiKey"] : null as any;
            this.aImageUrl = _data["aImageUrl"] !== undefined ? _data["aImageUrl"] : null as any;
        }
    }

    static fromJS(data: any): AccountInfoViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountInfoViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aname"] = this.aname !== undefined ? this.aname : null as any;
        data["aabbrev"] = this.aabbrev !== undefined ? this.aabbrev : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["primaryAdminFirstName"] = this.primaryAdminFirstName !== undefined ? this.primaryAdminFirstName : null as any;
        data["primaryAdminLastName"] = this.primaryAdminLastName !== undefined ? this.primaryAdminLastName : null as any;
        data["primaryAdminEmail"] = this.primaryAdminEmail !== undefined ? this.primaryAdminEmail : null as any;
        data["primaryAdminId"] = this.primaryAdminId !== undefined ? this.primaryAdminId : null as any;
        data["primaryAdminStatus"] = this.primaryAdminStatus !== undefined ? this.primaryAdminStatus : null as any;
        data["walmartSupplierNumber"] = this.walmartSupplierNumber !== undefined ? this.walmartSupplierNumber : null as any;
        data["fieldGroupType"] = this.fieldGroupType !== undefined ? this.fieldGroupType : null as any;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        data["companyNotes"] = this.companyNotes !== undefined ? this.companyNotes : null as any;
        data["billingContactFirstName"] = this.billingContactFirstName !== undefined ? this.billingContactFirstName : null as any;
        data["billingContactLastName"] = this.billingContactLastName !== undefined ? this.billingContactLastName : null as any;
        data["billingContactEmail"] = this.billingContactEmail !== undefined ? this.billingContactEmail : null as any;
        data["billingContactPhone"] = this.billingContactPhone !== undefined ? this.billingContactPhone : null as any;
        data["billingContactAddress1"] = this.billingContactAddress1 !== undefined ? this.billingContactAddress1 : null as any;
        data["billingContactAddress2"] = this.billingContactAddress2 !== undefined ? this.billingContactAddress2 : null as any;
        data["billingContactCity"] = this.billingContactCity !== undefined ? this.billingContactCity : null as any;
        data["billingContactState"] = this.billingContactState !== undefined ? this.billingContactState : null as any;
        data["billingContactCountry"] = this.billingContactCountry !== undefined ? this.billingContactCountry : null as any;
        data["billingContactZipCode"] = this.billingContactZipCode !== undefined ? this.billingContactZipCode : null as any;
        data["printBadge"] = this.printBadge !== undefined ? this.printBadge : null as any;
        data["shippingContactName"] = this.shippingContactName !== undefined ? this.shippingContactName : null as any;
        data["shippingContactAddress1"] = this.shippingContactAddress1 !== undefined ? this.shippingContactAddress1 : null as any;
        data["shippingContactAddress2"] = this.shippingContactAddress2 !== undefined ? this.shippingContactAddress2 : null as any;
        data["shippingContactCity"] = this.shippingContactCity !== undefined ? this.shippingContactCity : null as any;
        data["shippingContactState"] = this.shippingContactState !== undefined ? this.shippingContactState : null as any;
        data["shippingContactCountry"] = this.shippingContactCountry !== undefined ? this.shippingContactCountry : null as any;
        data["shippingContactZipCode"] = this.shippingContactZipCode !== undefined ? this.shippingContactZipCode : null as any;
        data["supportContactEmail"] = this.supportContactEmail !== undefined ? this.supportContactEmail : null as any;
        data["supportContactPhone"] = this.supportContactPhone !== undefined ? this.supportContactPhone : null as any;
        data["supportContactNote"] = this.supportContactNote !== undefined ? this.supportContactNote : null as any;
        data["displayStoreSupportInfoOnLocationDetailPage"] = this.displayStoreSupportInfoOnLocationDetailPage !== undefined ? this.displayStoreSupportInfoOnLocationDetailPage : null as any;
        data["storeSupportNumber"] = this.storeSupportNumber !== undefined ? this.storeSupportNumber : null as any;
        data["storeSupportEmail"] = this.storeSupportEmail !== undefined ? this.storeSupportEmail : null as any;
        data["technicalContactEmail"] = this.technicalContactEmail !== undefined ? this.technicalContactEmail : null as any;
        data["technicalContactPhone"] = this.technicalContactPhone !== undefined ? this.technicalContactPhone : null as any;
        data["apiKey"] = this.apiKey !== undefined ? this.apiKey : null as any;
        data["aImageUrl"] = this.aImageUrl !== undefined ? this.aImageUrl : null as any;
        return data;
    }

    clone(): AccountInfoViewModel {
        const json = this.toJSON();
        let result = new AccountInfoViewModel();
        result.init(json);
        return result;
    }
}

export interface IAccountInfoViewModel {
    aname?: string | null;
    aabbrev?: string | null;
    accountId?: number | null;
    primaryAdminFirstName?: string | null;
    primaryAdminLastName?: string | null;
    primaryAdminEmail?: string | null;
    primaryAdminId?: number;
    primaryAdminStatus?: EStatus;
    walmartSupplierNumber?: string | null;
    fieldGroupType?: string | null;
    statusId?: number | null;
    companyNotes?: string | null;
    billingContactFirstName?: string | null;
    billingContactLastName?: string | null;
    billingContactEmail?: string | null;
    billingContactPhone?: string | null;
    billingContactAddress1?: string | null;
    billingContactAddress2?: string | null;
    billingContactCity?: string | null;
    billingContactState?: string | null;
    billingContactCountry?: string | null;
    billingContactZipCode?: string | null;
    printBadge?: string | null;
    shippingContactName?: string | null;
    shippingContactAddress1?: string | null;
    shippingContactAddress2?: string | null;
    shippingContactCity?: string | null;
    shippingContactState?: string | null;
    shippingContactCountry?: string | null;
    shippingContactZipCode?: string | null;
    supportContactEmail?: string | null;
    supportContactPhone?: string | null;
    supportContactNote?: string | null;
    displayStoreSupportInfoOnLocationDetailPage?: boolean | null;
    storeSupportNumber?: string | null;
    storeSupportEmail?: string | null;
    technicalContactEmail?: string | null;
    technicalContactPhone?: string | null;
    apiKey?: string | null;
    aImageUrl?: string | null;
}

export enum EStatus {
    Active = "active",
    Pending = "pending",
    Inactive = "inactive",
    Invited = "invited",
}

export class AccountSupport implements IAccountSupport {
    accountId?: number;
    showStoreSupportInfo?: boolean | null;
    supportNote?: string | null;
    storeSupportNumber?: string | null;
    storeSupportEmail?: string | null;
    accessDeniedMessage?: string | null;

    constructor(data?: IAccountSupport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.showStoreSupportInfo = _data["showStoreSupportInfo"] !== undefined ? _data["showStoreSupportInfo"] : null as any;
            this.supportNote = _data["supportNote"] !== undefined ? _data["supportNote"] : null as any;
            this.storeSupportNumber = _data["storeSupportNumber"] !== undefined ? _data["storeSupportNumber"] : null as any;
            this.storeSupportEmail = _data["storeSupportEmail"] !== undefined ? _data["storeSupportEmail"] : null as any;
            this.accessDeniedMessage = _data["accessDeniedMessage"] !== undefined ? _data["accessDeniedMessage"] : null as any;
        }
    }

    static fromJS(data: any): AccountSupport {
        data = typeof data === 'object' ? data : {};
        let result = new AccountSupport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["showStoreSupportInfo"] = this.showStoreSupportInfo !== undefined ? this.showStoreSupportInfo : null as any;
        data["supportNote"] = this.supportNote !== undefined ? this.supportNote : null as any;
        data["storeSupportNumber"] = this.storeSupportNumber !== undefined ? this.storeSupportNumber : null as any;
        data["storeSupportEmail"] = this.storeSupportEmail !== undefined ? this.storeSupportEmail : null as any;
        data["accessDeniedMessage"] = this.accessDeniedMessage !== undefined ? this.accessDeniedMessage : null as any;
        return data;
    }

    clone(): AccountSupport {
        const json = this.toJSON();
        let result = new AccountSupport();
        result.init(json);
        return result;
    }
}

export interface IAccountSupport {
    accountId?: number;
    showStoreSupportInfo?: boolean | null;
    supportNote?: string | null;
    storeSupportNumber?: string | null;
    storeSupportEmail?: string | null;
    accessDeniedMessage?: string | null;
}

export class LimitedResultOfActivityModel implements ILimitedResultOfActivityModel {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: ActivityModel[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfActivityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ActivityModel.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfActivityModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfActivityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfActivityModel {
        const json = this.toJSON();
        let result = new LimitedResultOfActivityModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfActivityModel {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: ActivityModel[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class ActivityModel implements IActivityModel {
    activityId?: number;
    activityName?: string | null;
    accountId?: number;
    accountName?: string | null;
    statusName?: string | null;
    note?: string | null;
    dueDatePerformance?: boolean;
    isActive?: boolean;
    commonality?: Commonality | null;
    scheduleImportant?: ScheduleImportant | null;
    companiesAssociatedCount?: number;
    banner?: string | null;

    constructor(data?: IActivityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data["activityId"] !== undefined ? _data["activityId"] : null as any;
            this.activityName = _data["activityName"] !== undefined ? _data["activityName"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.statusName = _data["statusName"] !== undefined ? _data["statusName"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.dueDatePerformance = _data["dueDatePerformance"] !== undefined ? _data["dueDatePerformance"] : null as any;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null as any;
            this.commonality = _data["commonality"] !== undefined ? _data["commonality"] : null as any;
            this.scheduleImportant = _data["scheduleImportant"] !== undefined ? _data["scheduleImportant"] : null as any;
            this.companiesAssociatedCount = _data["companiesAssociatedCount"] !== undefined ? _data["companiesAssociatedCount"] : null as any;
            this.banner = _data["banner"] !== undefined ? _data["banner"] : null as any;
        }
    }

    static fromJS(data: any): ActivityModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId !== undefined ? this.activityId : null as any;
        data["activityName"] = this.activityName !== undefined ? this.activityName : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["statusName"] = this.statusName !== undefined ? this.statusName : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["dueDatePerformance"] = this.dueDatePerformance !== undefined ? this.dueDatePerformance : null as any;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null as any;
        data["commonality"] = this.commonality !== undefined ? this.commonality : null as any;
        data["scheduleImportant"] = this.scheduleImportant !== undefined ? this.scheduleImportant : null as any;
        data["companiesAssociatedCount"] = this.companiesAssociatedCount !== undefined ? this.companiesAssociatedCount : null as any;
        data["banner"] = this.banner !== undefined ? this.banner : null as any;
        return data;
    }

    clone(): ActivityModel {
        const json = this.toJSON();
        let result = new ActivityModel();
        result.init(json);
        return result;
    }
}

export interface IActivityModel {
    activityId?: number;
    activityName?: string | null;
    accountId?: number;
    accountName?: string | null;
    statusName?: string | null;
    note?: string | null;
    dueDatePerformance?: boolean;
    isActive?: boolean;
    commonality?: Commonality | null;
    scheduleImportant?: ScheduleImportant | null;
    companiesAssociatedCount?: number;
    banner?: string | null;
}

export class PagedFilterOfActivityFilterParams implements IPagedFilterOfActivityFilterParams {
    filter?: ActivityFilterParams | null;
    offset?: number;
    limit?: number;

    constructor(data?: IPagedFilterOfActivityFilterParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"] ? ActivityFilterParams.fromJS(_data["filter"]) : null as any;
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
        }
    }

    static fromJS(data: any): PagedFilterOfActivityFilterParams {
        data = typeof data === 'object' ? data : {};
        let result = new PagedFilterOfActivityFilterParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter ? this.filter.toJSON() : null as any;
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        return data;
    }

    clone(): PagedFilterOfActivityFilterParams {
        const json = this.toJSON();
        let result = new PagedFilterOfActivityFilterParams();
        result.init(json);
        return result;
    }
}

export interface IPagedFilterOfActivityFilterParams {
    filter?: ActivityFilterParams | null;
    offset?: number;
    limit?: number;
}

export class ActivityFilterParams implements IActivityFilterParams {
    accountId?: number | null;
    banners?: string[] | null;
    filterText?: string | null;
    status?: StatusTypes | null;
    dashboardComponent?: string | null;
    sortBy?: string | null;
    sortAscending?: boolean;

    constructor(data?: IActivityFilterParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            if (Array.isArray(_data["banners"])) {
                this.banners = [] as any;
                for (let item of _data["banners"])
                    this.banners!.push(item);
            }
            else {
                this.banners = null as any;
            }
            this.filterText = _data["filterText"] !== undefined ? _data["filterText"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.dashboardComponent = _data["dashboardComponent"] !== undefined ? _data["dashboardComponent"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): ActivityFilterParams {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityFilterParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        if (Array.isArray(this.banners)) {
            data["banners"] = [];
            for (let item of this.banners)
                data["banners"].push(item);
        }
        data["filterText"] = this.filterText !== undefined ? this.filterText : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["dashboardComponent"] = this.dashboardComponent !== undefined ? this.dashboardComponent : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): ActivityFilterParams {
        const json = this.toJSON();
        let result = new ActivityFilterParams();
        result.init(json);
        return result;
    }
}

export interface IActivityFilterParams {
    accountId?: number | null;
    banners?: string[] | null;
    filterText?: string | null;
    status?: StatusTypes | null;
    dashboardComponent?: string | null;
    sortBy?: string | null;
    sortAscending?: boolean;
}

export class ActivityTaskSummaryModel implements IActivityTaskSummaryModel {
    activity?: string | null;
    duration?: number;
    count?: number;

    constructor(data?: IActivityTaskSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activity = _data["activity"] !== undefined ? _data["activity"] : null as any;
            this.duration = _data["duration"] !== undefined ? _data["duration"] : null as any;
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
        }
    }

    static fromJS(data: any): ActivityTaskSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityTaskSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activity"] = this.activity !== undefined ? this.activity : null as any;
        data["duration"] = this.duration !== undefined ? this.duration : null as any;
        data["count"] = this.count !== undefined ? this.count : null as any;
        return data;
    }

    clone(): ActivityTaskSummaryModel {
        const json = this.toJSON();
        let result = new ActivityTaskSummaryModel();
        result.init(json);
        return result;
    }
}

export interface IActivityTaskSummaryModel {
    activity?: string | null;
    duration?: number;
    count?: number;
}

export class ActivityViewModel implements IActivityViewModel {
    id?: number;
    name?: string | null;
    status?: StatusTypes | null;
    isSensitive?: boolean;
    scheduleImportant?: ScheduleImportant;
    dueDatePerformance?: boolean | null;
    banner?: string | null;

    constructor(data?: IActivityViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.isSensitive = _data["isSensitive"] !== undefined ? _data["isSensitive"] : null as any;
            this.scheduleImportant = _data["scheduleImportant"] !== undefined ? _data["scheduleImportant"] : null as any;
            this.dueDatePerformance = _data["dueDatePerformance"] !== undefined ? _data["dueDatePerformance"] : null as any;
            this.banner = _data["banner"] !== undefined ? _data["banner"] : null as any;
        }
    }

    static fromJS(data: any): ActivityViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["isSensitive"] = this.isSensitive !== undefined ? this.isSensitive : null as any;
        data["scheduleImportant"] = this.scheduleImportant !== undefined ? this.scheduleImportant : null as any;
        data["dueDatePerformance"] = this.dueDatePerformance !== undefined ? this.dueDatePerformance : null as any;
        data["banner"] = this.banner !== undefined ? this.banner : null as any;
        return data;
    }

    clone(): ActivityViewModel {
        const json = this.toJSON();
        let result = new ActivityViewModel();
        result.init(json);
        return result;
    }
}

export interface IActivityViewModel {
    id?: number;
    name?: string | null;
    status?: StatusTypes | null;
    isSensitive?: boolean;
    scheduleImportant?: ScheduleImportant;
    dueDatePerformance?: boolean | null;
    banner?: string | null;
}

export class ActivityResponsibility implements IActivityResponsibility {
    department?: string | null;
    category?: string | null;
    fixtureOrder?: string | null;
    baseFixtureInstall?: string | null;
    signageOrder?: string | null;
    signageInstall?: string | null;
    serviced?: string | null;

    constructor(data?: IActivityResponsibility) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.department = _data["department"] !== undefined ? _data["department"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.fixtureOrder = _data["fixtureOrder"] !== undefined ? _data["fixtureOrder"] : null as any;
            this.baseFixtureInstall = _data["baseFixtureInstall"] !== undefined ? _data["baseFixtureInstall"] : null as any;
            this.signageOrder = _data["signageOrder"] !== undefined ? _data["signageOrder"] : null as any;
            this.signageInstall = _data["signageInstall"] !== undefined ? _data["signageInstall"] : null as any;
            this.serviced = _data["serviced"] !== undefined ? _data["serviced"] : null as any;
        }
    }

    static fromJS(data: any): ActivityResponsibility {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityResponsibility();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["department"] = this.department !== undefined ? this.department : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["fixtureOrder"] = this.fixtureOrder !== undefined ? this.fixtureOrder : null as any;
        data["baseFixtureInstall"] = this.baseFixtureInstall !== undefined ? this.baseFixtureInstall : null as any;
        data["signageOrder"] = this.signageOrder !== undefined ? this.signageOrder : null as any;
        data["signageInstall"] = this.signageInstall !== undefined ? this.signageInstall : null as any;
        data["serviced"] = this.serviced !== undefined ? this.serviced : null as any;
        return data;
    }

    clone(): ActivityResponsibility {
        const json = this.toJSON();
        let result = new ActivityResponsibility();
        result.init(json);
        return result;
    }
}

export interface IActivityResponsibility {
    department?: string | null;
    category?: string | null;
    fixtureOrder?: string | null;
    baseFixtureInstall?: string | null;
    signageOrder?: string | null;
    signageInstall?: string | null;
    serviced?: string | null;
}

export class GetAlternativeNumbersResponse implements IGetAlternativeNumbersResponse {
    numbers?: AlternativeNumber[] | null;

    constructor(data?: IGetAlternativeNumbersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["numbers"])) {
                this.numbers = [] as any;
                for (let item of _data["numbers"])
                    this.numbers!.push(AlternativeNumber.fromJS(item));
            }
            else {
                this.numbers = null as any;
            }
        }
    }

    static fromJS(data: any): GetAlternativeNumbersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAlternativeNumbersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.numbers)) {
            data["numbers"] = [];
            for (let item of this.numbers)
                data["numbers"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): GetAlternativeNumbersResponse {
        const json = this.toJSON();
        let result = new GetAlternativeNumbersResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAlternativeNumbersResponse {
    numbers?: AlternativeNumber[] | null;
}

export class AlternativeNumber implements IAlternativeNumber {
    number?: string | null;
    updatedDate?: moment.Moment;
    updatedBy?: string | null;

    constructor(data?: IAlternativeNumber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"] !== undefined ? _data["number"] : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            this.updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : null as any;
        }
    }

    static fromJS(data: any): AlternativeNumber {
        data = typeof data === 'object' ? data : {};
        let result = new AlternativeNumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number !== undefined ? this.number : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : null as any;
        return data;
    }

    clone(): AlternativeNumber {
        const json = this.toJSON();
        let result = new AlternativeNumber();
        result.init(json);
        return result;
    }
}

export interface IAlternativeNumber {
    number?: string | null;
    updatedDate?: moment.Moment;
    updatedBy?: string | null;
}

export class GetSupplierNumberResponse implements IGetSupplierNumberResponse {
    supplierNumber!: string;
    supplier!: string;

    constructor(data?: IGetSupplierNumberResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierNumber = _data["supplierNumber"] !== undefined ? _data["supplierNumber"] : null as any;
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : null as any;
        }
    }

    static fromJS(data: any): GetSupplierNumberResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSupplierNumberResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierNumber"] = this.supplierNumber !== undefined ? this.supplierNumber : null as any;
        data["supplier"] = this.supplier !== undefined ? this.supplier : null as any;
        return data;
    }

    clone(): GetSupplierNumberResponse {
        const json = this.toJSON();
        let result = new GetSupplierNumberResponse();
        result.init(json);
        return result;
    }
}

export interface IGetSupplierNumberResponse {
    supplierNumber: string;
    supplier: string;
}

export class AlternativeNumbersBatch implements IAlternativeNumbersBatch {
    operations?: AlternativeNumbersBatchItem[] | null;

    constructor(data?: IAlternativeNumbersBatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["operations"])) {
                this.operations = [] as any;
                for (let item of _data["operations"])
                    this.operations!.push(AlternativeNumbersBatchItem.fromJS(item));
            }
            else {
                this.operations = null as any;
            }
        }
    }

    static fromJS(data: any): AlternativeNumbersBatch {
        data = typeof data === 'object' ? data : {};
        let result = new AlternativeNumbersBatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.operations)) {
            data["operations"] = [];
            for (let item of this.operations)
                data["operations"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): AlternativeNumbersBatch {
        const json = this.toJSON();
        let result = new AlternativeNumbersBatch();
        result.init(json);
        return result;
    }
}

export interface IAlternativeNumbersBatch {
    operations?: AlternativeNumbersBatchItem[] | null;
}

export class AlternativeNumbersBatchItem implements IAlternativeNumbersBatchItem {
    operationType?: AlternativeNumbersBatchItemOperation;
    number?: string | null;

    constructor(data?: IAlternativeNumbersBatchItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operationType = _data["operationType"] !== undefined ? _data["operationType"] : null as any;
            this.number = _data["number"] !== undefined ? _data["number"] : null as any;
        }
    }

    static fromJS(data: any): AlternativeNumbersBatchItem {
        data = typeof data === 'object' ? data : {};
        let result = new AlternativeNumbersBatchItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operationType"] = this.operationType !== undefined ? this.operationType : null as any;
        data["number"] = this.number !== undefined ? this.number : null as any;
        return data;
    }

    clone(): AlternativeNumbersBatchItem {
        const json = this.toJSON();
        let result = new AlternativeNumbersBatchItem();
        result.init(json);
        return result;
    }
}

export interface IAlternativeNumbersBatchItem {
    operationType?: AlternativeNumbersBatchItemOperation;
    number?: string | null;
}

export enum AlternativeNumbersBatchItemOperation {
    Add = "add",
    Remove = "remove",
}

export class BadgeReplacementModel implements IBadgeReplacementModel {
    badgeReplacementId?: number;
    personId?: number;
    personNumber?: string | null;
    personImageUrl?: string | null;
    accountId?: number;
    accountName?: string | null;
    personLastName?: string | null;
    personFirstName?: string | null;
    dateRequested?: moment.Moment;
    requestReason?: string | null;
    reprintCount?: number;
    updatedDate?: moment.Moment;
    denialReason?: string | null;
    approvalStatus?: string | null;
    replaceForFree?: string | null;

    constructor(data?: IBadgeReplacementModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.badgeReplacementId = _data["badgeReplacementId"] !== undefined ? _data["badgeReplacementId"] : null as any;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null as any;
            this.personNumber = _data["personNumber"] !== undefined ? _data["personNumber"] : null as any;
            this.personImageUrl = _data["personImageUrl"] !== undefined ? _data["personImageUrl"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.personLastName = _data["personLastName"] !== undefined ? _data["personLastName"] : null as any;
            this.personFirstName = _data["personFirstName"] !== undefined ? _data["personFirstName"] : null as any;
            this.dateRequested = _data["dateRequested"] ? moment(_data["dateRequested"].toString()) : null as any;
            this.requestReason = _data["requestReason"] !== undefined ? _data["requestReason"] : null as any;
            this.reprintCount = _data["reprintCount"] !== undefined ? _data["reprintCount"] : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            this.denialReason = _data["denialReason"] !== undefined ? _data["denialReason"] : null as any;
            this.approvalStatus = _data["approvalStatus"] !== undefined ? _data["approvalStatus"] : null as any;
            this.replaceForFree = _data["replaceForFree"] !== undefined ? _data["replaceForFree"] : null as any;
        }
    }

    static fromJS(data: any): BadgeReplacementModel {
        data = typeof data === 'object' ? data : {};
        let result = new BadgeReplacementModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["badgeReplacementId"] = this.badgeReplacementId !== undefined ? this.badgeReplacementId : null as any;
        data["personId"] = this.personId !== undefined ? this.personId : null as any;
        data["personNumber"] = this.personNumber !== undefined ? this.personNumber : null as any;
        data["personImageUrl"] = this.personImageUrl !== undefined ? this.personImageUrl : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["personLastName"] = this.personLastName !== undefined ? this.personLastName : null as any;
        data["personFirstName"] = this.personFirstName !== undefined ? this.personFirstName : null as any;
        data["dateRequested"] = this.dateRequested ? this.dateRequested.toISOString() : null as any;
        data["requestReason"] = this.requestReason !== undefined ? this.requestReason : null as any;
        data["reprintCount"] = this.reprintCount !== undefined ? this.reprintCount : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        data["denialReason"] = this.denialReason !== undefined ? this.denialReason : null as any;
        data["approvalStatus"] = this.approvalStatus !== undefined ? this.approvalStatus : null as any;
        data["replaceForFree"] = this.replaceForFree !== undefined ? this.replaceForFree : null as any;
        return data;
    }

    clone(): BadgeReplacementModel {
        const json = this.toJSON();
        let result = new BadgeReplacementModel();
        result.init(json);
        return result;
    }
}

export interface IBadgeReplacementModel {
    badgeReplacementId?: number;
    personId?: number;
    personNumber?: string | null;
    personImageUrl?: string | null;
    accountId?: number;
    accountName?: string | null;
    personLastName?: string | null;
    personFirstName?: string | null;
    dateRequested?: moment.Moment;
    requestReason?: string | null;
    reprintCount?: number;
    updatedDate?: moment.Moment;
    denialReason?: string | null;
    approvalStatus?: string | null;
    replaceForFree?: string | null;
}

export class CapabilityViewModel implements ICapabilityViewModel {
    id?: number;
    name?: string | null;

    constructor(data?: ICapabilityViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): CapabilityViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CapabilityViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }

    clone(): CapabilityViewModel {
        const json = this.toJSON();
        let result = new CapabilityViewModel();
        result.init(json);
        return result;
    }
}

export interface ICapabilityViewModel {
    id?: number;
    name?: string | null;
}

export class CourseModel implements ICourseModel {
    courseId?: number;
    courseName?: string | null;
    statusId?: number | null;
    courseNote?: string | null;
    accountId?: number | null;
    accountName?: string | null;
    trainingLength?: string | null;
    required?: boolean | null;
    printBadge?: boolean;
    statusName?: string | null;

    constructor(data?: ICourseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"] !== undefined ? _data["courseId"] : null as any;
            this.courseName = _data["courseName"] !== undefined ? _data["courseName"] : null as any;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            this.courseNote = _data["courseNote"] !== undefined ? _data["courseNote"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.trainingLength = _data["trainingLength"] !== undefined ? _data["trainingLength"] : null as any;
            this.required = _data["required"] !== undefined ? _data["required"] : null as any;
            this.printBadge = _data["printBadge"] !== undefined ? _data["printBadge"] : null as any;
            this.statusName = _data["statusName"] !== undefined ? _data["statusName"] : null as any;
        }
    }

    static fromJS(data: any): CourseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CourseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId !== undefined ? this.courseId : null as any;
        data["courseName"] = this.courseName !== undefined ? this.courseName : null as any;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        data["courseNote"] = this.courseNote !== undefined ? this.courseNote : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["trainingLength"] = this.trainingLength !== undefined ? this.trainingLength : null as any;
        data["required"] = this.required !== undefined ? this.required : null as any;
        data["printBadge"] = this.printBadge !== undefined ? this.printBadge : null as any;
        data["statusName"] = this.statusName !== undefined ? this.statusName : null as any;
        return data;
    }

    clone(): CourseModel {
        const json = this.toJSON();
        let result = new CourseModel();
        result.init(json);
        return result;
    }
}

export interface ICourseModel {
    courseId?: number;
    courseName?: string | null;
    statusId?: number | null;
    courseNote?: string | null;
    accountId?: number | null;
    accountName?: string | null;
    trainingLength?: string | null;
    required?: boolean | null;
    printBadge?: boolean;
    statusName?: string | null;
}

export class Certification implements ICertification {
    id?: number;
    name!: string;
    description?: string | null;
    estimatedTrainingLength!: number;
    northpassGroupId?: string | null;
    certificationCourses?: CertificationCourse[] | null;

    constructor(data?: ICertification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.estimatedTrainingLength = _data["estimatedTrainingLength"] !== undefined ? _data["estimatedTrainingLength"] : null as any;
            this.northpassGroupId = _data["northpassGroupId"] !== undefined ? _data["northpassGroupId"] : null as any;
            if (Array.isArray(_data["certificationCourses"])) {
                this.certificationCourses = [] as any;
                for (let item of _data["certificationCourses"])
                    this.certificationCourses!.push(CertificationCourse.fromJS(item));
            }
            else {
                this.certificationCourses = null as any;
            }
        }
    }

    static fromJS(data: any): Certification {
        data = typeof data === 'object' ? data : {};
        let result = new Certification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["estimatedTrainingLength"] = this.estimatedTrainingLength !== undefined ? this.estimatedTrainingLength : null as any;
        data["northpassGroupId"] = this.northpassGroupId !== undefined ? this.northpassGroupId : null as any;
        if (Array.isArray(this.certificationCourses)) {
            data["certificationCourses"] = [];
            for (let item of this.certificationCourses)
                data["certificationCourses"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): Certification {
        const json = this.toJSON();
        let result = new Certification();
        result.init(json);
        return result;
    }
}

export interface ICertification {
    id?: number;
    name: string;
    description?: string | null;
    estimatedTrainingLength: number;
    northpassGroupId?: string | null;
    certificationCourses?: CertificationCourse[] | null;
}

export class CertificationCourse implements ICertificationCourse {
    id?: number;
    certificationId?: number;
    certification?: Certification | null;
    courseId?: number;
    course?: Course | null;
    sequence?: number;
    expiresCertification?: boolean;
    expirationGracePeriodDate?: moment.Moment | null;

    constructor(data?: ICertificationCourse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.certificationId = _data["certificationId"] !== undefined ? _data["certificationId"] : null as any;
            this.certification = _data["certification"] ? Certification.fromJS(_data["certification"]) : null as any;
            this.courseId = _data["courseId"] !== undefined ? _data["courseId"] : null as any;
            this.course = _data["course"] ? Course.fromJS(_data["course"]) : null as any;
            this.sequence = _data["sequence"] !== undefined ? _data["sequence"] : null as any;
            this.expiresCertification = _data["expiresCertification"] !== undefined ? _data["expiresCertification"] : null as any;
            this.expirationGracePeriodDate = _data["expirationGracePeriodDate"] ? moment(_data["expirationGracePeriodDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): CertificationCourse {
        data = typeof data === 'object' ? data : {};
        let result = new CertificationCourse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["certificationId"] = this.certificationId !== undefined ? this.certificationId : null as any;
        data["certification"] = this.certification ? this.certification.toJSON() : null as any;
        data["courseId"] = this.courseId !== undefined ? this.courseId : null as any;
        data["course"] = this.course ? this.course.toJSON() : null as any;
        data["sequence"] = this.sequence !== undefined ? this.sequence : null as any;
        data["expiresCertification"] = this.expiresCertification !== undefined ? this.expiresCertification : null as any;
        data["expirationGracePeriodDate"] = this.expirationGracePeriodDate ? this.expirationGracePeriodDate.toISOString() : null as any;
        return data;
    }

    clone(): CertificationCourse {
        const json = this.toJSON();
        let result = new CertificationCourse();
        result.init(json);
        return result;
    }
}

export interface ICertificationCourse {
    id?: number;
    certificationId?: number;
    certification?: Certification | null;
    courseId?: number;
    course?: Course | null;
    sequence?: number;
    expiresCertification?: boolean;
    expirationGracePeriodDate?: moment.Moment | null;
}

export class Course implements ICourse {
    id?: number;
    name!: string;
    description?: string | null;
    userCourses?: UserCourse[] | null;
    northpassCourseId!: string;

    constructor(data?: ICourse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            if (Array.isArray(_data["userCourses"])) {
                this.userCourses = [] as any;
                for (let item of _data["userCourses"])
                    this.userCourses!.push(UserCourse.fromJS(item));
            }
            else {
                this.userCourses = null as any;
            }
            this.northpassCourseId = _data["northpassCourseId"] !== undefined ? _data["northpassCourseId"] : null as any;
        }
    }

    static fromJS(data: any): Course {
        data = typeof data === 'object' ? data : {};
        let result = new Course();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        if (Array.isArray(this.userCourses)) {
            data["userCourses"] = [];
            for (let item of this.userCourses)
                data["userCourses"].push(item ? item.toJSON() : null as any);
        }
        data["northpassCourseId"] = this.northpassCourseId !== undefined ? this.northpassCourseId : null as any;
        return data;
    }

    clone(): Course {
        const json = this.toJSON();
        let result = new Course();
        result.init(json);
        return result;
    }
}

export interface ICourse {
    id?: number;
    name: string;
    description?: string | null;
    userCourses?: UserCourse[] | null;
    northpassCourseId: string;
}

export class UserCourse implements IUserCourse {
    id?: number;
    userId?: number;
    user?: User | null;
    courseId?: number;
    course?: Course | null;
    completionStatus!: string;
    completionDate?: moment.Moment | null;

    constructor(data?: IUserCourse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : null as any;
            this.courseId = _data["courseId"] !== undefined ? _data["courseId"] : null as any;
            this.course = _data["course"] ? Course.fromJS(_data["course"]) : null as any;
            this.completionStatus = _data["completionStatus"] !== undefined ? _data["completionStatus"] : null as any;
            this.completionDate = _data["completionDate"] ? moment(_data["completionDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): UserCourse {
        data = typeof data === 'object' ? data : {};
        let result = new UserCourse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["user"] = this.user ? this.user.toJSON() : null as any;
        data["courseId"] = this.courseId !== undefined ? this.courseId : null as any;
        data["course"] = this.course ? this.course.toJSON() : null as any;
        data["completionStatus"] = this.completionStatus !== undefined ? this.completionStatus : null as any;
        data["completionDate"] = this.completionDate ? this.completionDate.toISOString() : null as any;
        return data;
    }

    clone(): UserCourse {
        const json = this.toJSON();
        let result = new UserCourse();
        result.init(json);
        return result;
    }
}

export interface IUserCourse {
    id?: number;
    userId?: number;
    user?: User | null;
    courseId?: number;
    course?: Course | null;
    completionStatus: string;
    completionDate?: moment.Moment | null;
}

export class User implements IUser {
    id?: number;
    voltUserId!: string;
    northpassUserId!: string;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.voltUserId = _data["voltUserId"] !== undefined ? _data["voltUserId"] : null as any;
            this.northpassUserId = _data["northpassUserId"] !== undefined ? _data["northpassUserId"] : null as any;
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["voltUserId"] = this.voltUserId !== undefined ? this.voltUserId : null as any;
        data["northpassUserId"] = this.northpassUserId !== undefined ? this.northpassUserId : null as any;
        return data;
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export interface IUser {
    id?: number;
    voltUserId: string;
    northpassUserId: string;
}

export class RetailerCertificationViewModel implements IRetailerCertificationViewModel {
    certificationName?: string | null;
    certificationDescription?: string | null;
    trainingLength?: number;
    statusId?: number;
    engageAccess?: boolean;
    requiredToPrintBadge?: boolean;
    courseIds?: number[] | null;
    associateToCurrentAccount?: boolean;
    certificationExpire?: boolean;
    forceUsersToRetakeCertification?: boolean;

    constructor(data?: IRetailerCertificationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.certificationName = _data["certificationName"] !== undefined ? _data["certificationName"] : null as any;
            this.certificationDescription = _data["certificationDescription"] !== undefined ? _data["certificationDescription"] : null as any;
            this.trainingLength = _data["trainingLength"] !== undefined ? _data["trainingLength"] : null as any;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            this.engageAccess = _data["engageAccess"] !== undefined ? _data["engageAccess"] : null as any;
            this.requiredToPrintBadge = _data["requiredToPrintBadge"] !== undefined ? _data["requiredToPrintBadge"] : null as any;
            if (Array.isArray(_data["courseIds"])) {
                this.courseIds = [] as any;
                for (let item of _data["courseIds"])
                    this.courseIds!.push(item);
            }
            else {
                this.courseIds = null as any;
            }
            this.associateToCurrentAccount = _data["associateToCurrentAccount"] !== undefined ? _data["associateToCurrentAccount"] : null as any;
            this.certificationExpire = _data["certificationExpire"] !== undefined ? _data["certificationExpire"] : null as any;
            this.forceUsersToRetakeCertification = _data["forceUsersToRetakeCertification"] !== undefined ? _data["forceUsersToRetakeCertification"] : null as any;
        }
    }

    static fromJS(data: any): RetailerCertificationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RetailerCertificationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["certificationName"] = this.certificationName !== undefined ? this.certificationName : null as any;
        data["certificationDescription"] = this.certificationDescription !== undefined ? this.certificationDescription : null as any;
        data["trainingLength"] = this.trainingLength !== undefined ? this.trainingLength : null as any;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        data["engageAccess"] = this.engageAccess !== undefined ? this.engageAccess : null as any;
        data["requiredToPrintBadge"] = this.requiredToPrintBadge !== undefined ? this.requiredToPrintBadge : null as any;
        if (Array.isArray(this.courseIds)) {
            data["courseIds"] = [];
            for (let item of this.courseIds)
                data["courseIds"].push(item);
        }
        data["associateToCurrentAccount"] = this.associateToCurrentAccount !== undefined ? this.associateToCurrentAccount : null as any;
        data["certificationExpire"] = this.certificationExpire !== undefined ? this.certificationExpire : null as any;
        data["forceUsersToRetakeCertification"] = this.forceUsersToRetakeCertification !== undefined ? this.forceUsersToRetakeCertification : null as any;
        return data;
    }

    clone(): RetailerCertificationViewModel {
        const json = this.toJSON();
        let result = new RetailerCertificationViewModel();
        result.init(json);
        return result;
    }
}

export interface IRetailerCertificationViewModel {
    certificationName?: string | null;
    certificationDescription?: string | null;
    trainingLength?: number;
    statusId?: number;
    engageAccess?: boolean;
    requiredToPrintBadge?: boolean;
    courseIds?: number[] | null;
    associateToCurrentAccount?: boolean;
    certificationExpire?: boolean;
    forceUsersToRetakeCertification?: boolean;
}

export class CertificationCourseModel implements ICertificationCourseModel {
    courseId?: number;
    courseName?: string | null;
    description?: string | null;
    northpassCourseId?: string | null;

    constructor(data?: ICertificationCourseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"] !== undefined ? _data["courseId"] : null as any;
            this.courseName = _data["courseName"] !== undefined ? _data["courseName"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.northpassCourseId = _data["northpassCourseId"] !== undefined ? _data["northpassCourseId"] : null as any;
        }
    }

    static fromJS(data: any): CertificationCourseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CertificationCourseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId !== undefined ? this.courseId : null as any;
        data["courseName"] = this.courseName !== undefined ? this.courseName : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["northpassCourseId"] = this.northpassCourseId !== undefined ? this.northpassCourseId : null as any;
        return data;
    }

    clone(): CertificationCourseModel {
        const json = this.toJSON();
        let result = new CertificationCourseModel();
        result.init(json);
        return result;
    }
}

export interface ICertificationCourseModel {
    courseId?: number;
    courseName?: string | null;
    description?: string | null;
    northpassCourseId?: string | null;
}

export class LimitedResultOfCheckinByAccountRealtimeViewModel implements ILimitedResultOfCheckinByAccountRealtimeViewModel {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: CheckinByAccountRealtimeViewModel[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfCheckinByAccountRealtimeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CheckinByAccountRealtimeViewModel.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfCheckinByAccountRealtimeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfCheckinByAccountRealtimeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfCheckinByAccountRealtimeViewModel {
        const json = this.toJSON();
        let result = new LimitedResultOfCheckinByAccountRealtimeViewModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfCheckinByAccountRealtimeViewModel {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: CheckinByAccountRealtimeViewModel[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class CheckinByAccountRealtimeViewModel implements ICheckinByAccountRealtimeViewModel {
    accountName?: string | null;
    numberOfCheckins?: number;
    storeNumber?: string | null;
    minTimeInUtc?: moment.Moment;
    storeTimezone?: string | null;
    timeInStoreMilliseconds?: number;

    constructor(data?: ICheckinByAccountRealtimeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.numberOfCheckins = _data["numberOfCheckins"] !== undefined ? _data["numberOfCheckins"] : null as any;
            this.storeNumber = _data["storeNumber"] !== undefined ? _data["storeNumber"] : null as any;
            this.minTimeInUtc = _data["minTimeInUtc"] ? moment(_data["minTimeInUtc"].toString()) : null as any;
            this.storeTimezone = _data["storeTimezone"] !== undefined ? _data["storeTimezone"] : null as any;
            this.timeInStoreMilliseconds = _data["timeInStoreMilliseconds"] !== undefined ? _data["timeInStoreMilliseconds"] : null as any;
        }
    }

    static fromJS(data: any): CheckinByAccountRealtimeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CheckinByAccountRealtimeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["numberOfCheckins"] = this.numberOfCheckins !== undefined ? this.numberOfCheckins : null as any;
        data["storeNumber"] = this.storeNumber !== undefined ? this.storeNumber : null as any;
        data["minTimeInUtc"] = this.minTimeInUtc ? this.minTimeInUtc.toISOString() : null as any;
        data["storeTimezone"] = this.storeTimezone !== undefined ? this.storeTimezone : null as any;
        data["timeInStoreMilliseconds"] = this.timeInStoreMilliseconds !== undefined ? this.timeInStoreMilliseconds : null as any;
        return data;
    }

    clone(): CheckinByAccountRealtimeViewModel {
        const json = this.toJSON();
        let result = new CheckinByAccountRealtimeViewModel();
        result.init(json);
        return result;
    }
}

export interface ICheckinByAccountRealtimeViewModel {
    accountName?: string | null;
    numberOfCheckins?: number;
    storeNumber?: string | null;
    minTimeInUtc?: moment.Moment;
    storeTimezone?: string | null;
    timeInStoreMilliseconds?: number;
}

export class LimitedResultOfCheckinByAccountHistoricalViewModel implements ILimitedResultOfCheckinByAccountHistoricalViewModel {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: CheckinByAccountHistoricalViewModel[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfCheckinByAccountHistoricalViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CheckinByAccountHistoricalViewModel.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfCheckinByAccountHistoricalViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfCheckinByAccountHistoricalViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfCheckinByAccountHistoricalViewModel {
        const json = this.toJSON();
        let result = new LimitedResultOfCheckinByAccountHistoricalViewModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfCheckinByAccountHistoricalViewModel {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: CheckinByAccountHistoricalViewModel[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class CheckinByAccountHistoricalViewModel implements ICheckinByAccountHistoricalViewModel {
    accountName?: string | null;
    storeNumber?: string | null;
    numberOfCheckins?: number;
    minTimeInUtc?: moment.Moment;
    maxTimeOutUtc?: moment.Moment;
    storeTimezone?: string | null;
    timeInStoreMilliseconds?: number;
    locationId?: number;
    wattLocationID?: string | null;
    accountId?: number;

    constructor(data?: ICheckinByAccountHistoricalViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.storeNumber = _data["storeNumber"] !== undefined ? _data["storeNumber"] : null as any;
            this.numberOfCheckins = _data["numberOfCheckins"] !== undefined ? _data["numberOfCheckins"] : null as any;
            this.minTimeInUtc = _data["minTimeInUtc"] ? moment(_data["minTimeInUtc"].toString()) : null as any;
            this.maxTimeOutUtc = _data["maxTimeOutUtc"] ? moment(_data["maxTimeOutUtc"].toString()) : null as any;
            this.storeTimezone = _data["storeTimezone"] !== undefined ? _data["storeTimezone"] : null as any;
            this.timeInStoreMilliseconds = _data["timeInStoreMilliseconds"] !== undefined ? _data["timeInStoreMilliseconds"] : null as any;
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : null as any;
            this.wattLocationID = _data["wattLocationID"] !== undefined ? _data["wattLocationID"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
        }
    }

    static fromJS(data: any): CheckinByAccountHistoricalViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CheckinByAccountHistoricalViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["storeNumber"] = this.storeNumber !== undefined ? this.storeNumber : null as any;
        data["numberOfCheckins"] = this.numberOfCheckins !== undefined ? this.numberOfCheckins : null as any;
        data["minTimeInUtc"] = this.minTimeInUtc ? this.minTimeInUtc.toISOString() : null as any;
        data["maxTimeOutUtc"] = this.maxTimeOutUtc ? this.maxTimeOutUtc.toISOString() : null as any;
        data["storeTimezone"] = this.storeTimezone !== undefined ? this.storeTimezone : null as any;
        data["timeInStoreMilliseconds"] = this.timeInStoreMilliseconds !== undefined ? this.timeInStoreMilliseconds : null as any;
        data["locationId"] = this.locationId !== undefined ? this.locationId : null as any;
        data["wattLocationID"] = this.wattLocationID !== undefined ? this.wattLocationID : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        return data;
    }

    clone(): CheckinByAccountHistoricalViewModel {
        const json = this.toJSON();
        let result = new CheckinByAccountHistoricalViewModel();
        result.init(json);
        return result;
    }
}

export interface ICheckinByAccountHistoricalViewModel {
    accountName?: string | null;
    storeNumber?: string | null;
    numberOfCheckins?: number;
    minTimeInUtc?: moment.Moment;
    maxTimeOutUtc?: moment.Moment;
    storeTimezone?: string | null;
    timeInStoreMilliseconds?: number;
    locationId?: number;
    wattLocationID?: string | null;
    accountId?: number;
}

export class LimitedResultOfCheckinByAccountUserHistoricalViewModel implements ILimitedResultOfCheckinByAccountUserHistoricalViewModel {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: CheckinByAccountUserHistoricalViewModel[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfCheckinByAccountUserHistoricalViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CheckinByAccountUserHistoricalViewModel.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfCheckinByAccountUserHistoricalViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfCheckinByAccountUserHistoricalViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfCheckinByAccountUserHistoricalViewModel {
        const json = this.toJSON();
        let result = new LimitedResultOfCheckinByAccountUserHistoricalViewModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfCheckinByAccountUserHistoricalViewModel {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: CheckinByAccountUserHistoricalViewModel[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class CheckinByAccountUserHistoricalViewModel implements ICheckinByAccountUserHistoricalViewModel {
    accountName?: string | null;
    name?: string | null;
    storeNumber?: string | null;
    numberOfCheckins?: number;
    minTimeInUtc?: moment.Moment;
    maxTimeOutUtc?: moment.Moment;
    storeTimezone?: string | null;
    timeInStoreMilliseconds?: number;

    constructor(data?: ICheckinByAccountUserHistoricalViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.storeNumber = _data["storeNumber"] !== undefined ? _data["storeNumber"] : null as any;
            this.numberOfCheckins = _data["numberOfCheckins"] !== undefined ? _data["numberOfCheckins"] : null as any;
            this.minTimeInUtc = _data["minTimeInUtc"] ? moment(_data["minTimeInUtc"].toString()) : null as any;
            this.maxTimeOutUtc = _data["maxTimeOutUtc"] ? moment(_data["maxTimeOutUtc"].toString()) : null as any;
            this.storeTimezone = _data["storeTimezone"] !== undefined ? _data["storeTimezone"] : null as any;
            this.timeInStoreMilliseconds = _data["timeInStoreMilliseconds"] !== undefined ? _data["timeInStoreMilliseconds"] : null as any;
        }
    }

    static fromJS(data: any): CheckinByAccountUserHistoricalViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CheckinByAccountUserHistoricalViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["storeNumber"] = this.storeNumber !== undefined ? this.storeNumber : null as any;
        data["numberOfCheckins"] = this.numberOfCheckins !== undefined ? this.numberOfCheckins : null as any;
        data["minTimeInUtc"] = this.minTimeInUtc ? this.minTimeInUtc.toISOString() : null as any;
        data["maxTimeOutUtc"] = this.maxTimeOutUtc ? this.maxTimeOutUtc.toISOString() : null as any;
        data["storeTimezone"] = this.storeTimezone !== undefined ? this.storeTimezone : null as any;
        data["timeInStoreMilliseconds"] = this.timeInStoreMilliseconds !== undefined ? this.timeInStoreMilliseconds : null as any;
        return data;
    }

    clone(): CheckinByAccountUserHistoricalViewModel {
        const json = this.toJSON();
        let result = new CheckinByAccountUserHistoricalViewModel();
        result.init(json);
        return result;
    }
}

export interface ICheckinByAccountUserHistoricalViewModel {
    accountName?: string | null;
    name?: string | null;
    storeNumber?: string | null;
    numberOfCheckins?: number;
    minTimeInUtc?: moment.Moment;
    maxTimeOutUtc?: moment.Moment;
    storeTimezone?: string | null;
    timeInStoreMilliseconds?: number;
}

export class LimitedResultOfCheckinByAccountUserRealtimeViewModel implements ILimitedResultOfCheckinByAccountUserRealtimeViewModel {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: CheckinByAccountUserRealtimeViewModel[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfCheckinByAccountUserRealtimeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CheckinByAccountUserRealtimeViewModel.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfCheckinByAccountUserRealtimeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfCheckinByAccountUserRealtimeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfCheckinByAccountUserRealtimeViewModel {
        const json = this.toJSON();
        let result = new LimitedResultOfCheckinByAccountUserRealtimeViewModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfCheckinByAccountUserRealtimeViewModel {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: CheckinByAccountUserRealtimeViewModel[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class CheckinByAccountUserRealtimeViewModel implements ICheckinByAccountUserRealtimeViewModel {
    accountName?: string | null;
    name?: string | null;
    storeNumber?: string | null;
    minTimeInUtc?: moment.Moment;
    storeTimezone?: string | null;
    timeInStoreMilliseconds?: number;

    constructor(data?: ICheckinByAccountUserRealtimeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.storeNumber = _data["storeNumber"] !== undefined ? _data["storeNumber"] : null as any;
            this.minTimeInUtc = _data["minTimeInUtc"] ? moment(_data["minTimeInUtc"].toString()) : null as any;
            this.storeTimezone = _data["storeTimezone"] !== undefined ? _data["storeTimezone"] : null as any;
            this.timeInStoreMilliseconds = _data["timeInStoreMilliseconds"] !== undefined ? _data["timeInStoreMilliseconds"] : null as any;
        }
    }

    static fromJS(data: any): CheckinByAccountUserRealtimeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CheckinByAccountUserRealtimeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["storeNumber"] = this.storeNumber !== undefined ? this.storeNumber : null as any;
        data["minTimeInUtc"] = this.minTimeInUtc ? this.minTimeInUtc.toISOString() : null as any;
        data["storeTimezone"] = this.storeTimezone !== undefined ? this.storeTimezone : null as any;
        data["timeInStoreMilliseconds"] = this.timeInStoreMilliseconds !== undefined ? this.timeInStoreMilliseconds : null as any;
        return data;
    }

    clone(): CheckinByAccountUserRealtimeViewModel {
        const json = this.toJSON();
        let result = new CheckinByAccountUserRealtimeViewModel();
        result.init(json);
        return result;
    }
}

export interface ICheckinByAccountUserRealtimeViewModel {
    accountName?: string | null;
    name?: string | null;
    storeNumber?: string | null;
    minTimeInUtc?: moment.Moment;
    storeTimezone?: string | null;
    timeInStoreMilliseconds?: number;
}

export class CheckinByAccountHistoricalCheckinChartViewModel implements ICheckinByAccountHistoricalCheckinChartViewModel {
    date?: moment.Moment;
    numberOfCheckins?: number;

    constructor(data?: ICheckinByAccountHistoricalCheckinChartViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : null as any;
            this.numberOfCheckins = _data["numberOfCheckins"] !== undefined ? _data["numberOfCheckins"] : null as any;
        }
    }

    static fromJS(data: any): CheckinByAccountHistoricalCheckinChartViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CheckinByAccountHistoricalCheckinChartViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : null as any;
        data["numberOfCheckins"] = this.numberOfCheckins !== undefined ? this.numberOfCheckins : null as any;
        return data;
    }

    clone(): CheckinByAccountHistoricalCheckinChartViewModel {
        const json = this.toJSON();
        let result = new CheckinByAccountHistoricalCheckinChartViewModel();
        result.init(json);
        return result;
    }
}

export interface ICheckinByAccountHistoricalCheckinChartViewModel {
    date?: moment.Moment;
    numberOfCheckins?: number;
}

export class LimitedResultOfCheckInCheckOutLocationReportViewModel implements ILimitedResultOfCheckInCheckOutLocationReportViewModel {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: CheckInCheckOutLocationReportViewModel[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfCheckInCheckOutLocationReportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CheckInCheckOutLocationReportViewModel.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfCheckInCheckOutLocationReportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfCheckInCheckOutLocationReportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfCheckInCheckOutLocationReportViewModel {
        const json = this.toJSON();
        let result = new LimitedResultOfCheckInCheckOutLocationReportViewModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfCheckInCheckOutLocationReportViewModel {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: CheckInCheckOutLocationReportViewModel[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class CheckInCheckOutLocationReportViewModel implements ICheckInCheckOutLocationReportViewModel {
    personId?: number;
    id?: string | null;
    totalVisits?: number;
    employeeNumber?: string | null;
    email?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    checkInPercentage?: number;
    checkOutPercentage?: number;
    banner?: string | null;

    constructor(data?: ICheckInCheckOutLocationReportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.totalVisits = _data["totalVisits"] !== undefined ? _data["totalVisits"] : null as any;
            this.employeeNumber = _data["employeeNumber"] !== undefined ? _data["employeeNumber"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.checkInPercentage = _data["checkInPercentage"] !== undefined ? _data["checkInPercentage"] : null as any;
            this.checkOutPercentage = _data["checkOutPercentage"] !== undefined ? _data["checkOutPercentage"] : null as any;
            this.banner = _data["banner"] !== undefined ? _data["banner"] : null as any;
        }
    }

    static fromJS(data: any): CheckInCheckOutLocationReportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CheckInCheckOutLocationReportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId !== undefined ? this.personId : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["totalVisits"] = this.totalVisits !== undefined ? this.totalVisits : null as any;
        data["employeeNumber"] = this.employeeNumber !== undefined ? this.employeeNumber : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["checkInPercentage"] = this.checkInPercentage !== undefined ? this.checkInPercentage : null as any;
        data["checkOutPercentage"] = this.checkOutPercentage !== undefined ? this.checkOutPercentage : null as any;
        data["banner"] = this.banner !== undefined ? this.banner : null as any;
        return data;
    }

    clone(): CheckInCheckOutLocationReportViewModel {
        const json = this.toJSON();
        let result = new CheckInCheckOutLocationReportViewModel();
        result.init(json);
        return result;
    }
}

export interface ICheckInCheckOutLocationReportViewModel {
    personId?: number;
    id?: string | null;
    totalVisits?: number;
    employeeNumber?: string | null;
    email?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    checkInPercentage?: number;
    checkOutPercentage?: number;
    banner?: string | null;
}

export class NameCount implements INameCount {
    name?: string | null;
    count?: number;

    constructor(data?: INameCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
        }
    }

    static fromJS(data: any): NameCount {
        data = typeof data === 'object' ? data : {};
        let result = new NameCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["count"] = this.count !== undefined ? this.count : null as any;
        return data;
    }

    clone(): NameCount {
        const json = this.toJSON();
        let result = new NameCount();
        result.init(json);
        return result;
    }
}

export interface INameCount {
    name?: string | null;
    count?: number;
}

export class AccountCheckInCount extends NameCount implements IAccountCheckInCount {
    data?: NameCount[] | null;

    constructor(data?: IAccountCheckInCount) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(NameCount.fromJS(item));
            }
            else {
                this.data = null as any;
            }
        }
    }

    static override fromJS(data: any): AccountCheckInCount {
        data = typeof data === 'object' ? data : {};
        let result = new AccountCheckInCount();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): AccountCheckInCount {
        const json = this.toJSON();
        let result = new AccountCheckInCount();
        result.init(json);
        return result;
    }
}

export interface IAccountCheckInCount extends INameCount {
    data?: NameCount[] | null;
}

export class LimitedResultOfCommunicationLogViewModel implements ILimitedResultOfCommunicationLogViewModel {
    results?: CommunicationLogViewModel[] | null;
    totalCount?: number;
    offset?: number;
    limit?: number;

    constructor(data?: ILimitedResultOfCommunicationLogViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CommunicationLogViewModel.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfCommunicationLogViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfCommunicationLogViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        return data;
    }

    clone(): LimitedResultOfCommunicationLogViewModel {
        const json = this.toJSON();
        let result = new LimitedResultOfCommunicationLogViewModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfCommunicationLogViewModel {
    results?: CommunicationLogViewModel[] | null;
    totalCount?: number;
    offset?: number;
    limit?: number;
}

export class CommunicationLogViewModel implements ICommunicationLogViewModel {
    id?: string | null;
    account?: string | null;
    employeeNumber?: string | null;
    name?: string | null;
    email?: string | null;
    from?: string | null;
    source?: string | null;
    category?: string | null;
    subject?: string | null;
    createdDate?: moment.Moment | null;
    createdBy?: string | null;

    constructor(data?: ICommunicationLogViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.account = _data["account"] !== undefined ? _data["account"] : null as any;
            this.employeeNumber = _data["employeeNumber"] !== undefined ? _data["employeeNumber"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.from = _data["from"] !== undefined ? _data["from"] : null as any;
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : null as any;
        }
    }

    static fromJS(data: any): CommunicationLogViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationLogViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["account"] = this.account !== undefined ? this.account : null as any;
        data["employeeNumber"] = this.employeeNumber !== undefined ? this.employeeNumber : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["from"] = this.from !== undefined ? this.from : null as any;
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["subject"] = this.subject !== undefined ? this.subject : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : null as any;
        return data;
    }

    clone(): CommunicationLogViewModel {
        const json = this.toJSON();
        let result = new CommunicationLogViewModel();
        result.init(json);
        return result;
    }
}

export interface ICommunicationLogViewModel {
    id?: string | null;
    account?: string | null;
    employeeNumber?: string | null;
    name?: string | null;
    email?: string | null;
    from?: string | null;
    source?: string | null;
    category?: string | null;
    subject?: string | null;
    createdDate?: moment.Moment | null;
    createdBy?: string | null;
}

export class CommunicationLogDetailsViewModel implements ICommunicationLogDetailsViewModel {
    sender?: string | null;
    email?: string | null;
    dateTimeSent?: moment.Moment | null;
    emailBodyHtml?: string | null;

    constructor(data?: ICommunicationLogDetailsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sender = _data["sender"] !== undefined ? _data["sender"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.dateTimeSent = _data["dateTimeSent"] ? moment(_data["dateTimeSent"].toString()) : null as any;
            this.emailBodyHtml = _data["emailBodyHtml"] !== undefined ? _data["emailBodyHtml"] : null as any;
        }
    }

    static fromJS(data: any): CommunicationLogDetailsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationLogDetailsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sender"] = this.sender !== undefined ? this.sender : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["dateTimeSent"] = this.dateTimeSent ? this.dateTimeSent.toISOString() : null as any;
        data["emailBodyHtml"] = this.emailBodyHtml !== undefined ? this.emailBodyHtml : null as any;
        return data;
    }

    clone(): CommunicationLogDetailsViewModel {
        const json = this.toJSON();
        let result = new CommunicationLogDetailsViewModel();
        result.init(json);
        return result;
    }
}

export interface ICommunicationLogDetailsViewModel {
    sender?: string | null;
    email?: string | null;
    dateTimeSent?: moment.Moment | null;
    emailBodyHtml?: string | null;
}

export class DashboardFilter implements IDashboardFilter {
    locationNumbers?: string[] | null;
    dateRange?: DateRange | null;
    departmentFilter?: DepartmentFilterModel | null;
    limit?: number | null;

    constructor(data?: IDashboardFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["locationNumbers"])) {
                this.locationNumbers = [] as any;
                for (let item of _data["locationNumbers"])
                    this.locationNumbers!.push(item);
            }
            else {
                this.locationNumbers = null as any;
            }
            this.dateRange = _data["dateRange"] ? DateRange.fromJS(_data["dateRange"]) : null as any;
            this.departmentFilter = _data["departmentFilter"] ? DepartmentFilterModel.fromJS(_data["departmentFilter"]) : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
        }
    }

    static fromJS(data: any): DashboardFilter {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.locationNumbers)) {
            data["locationNumbers"] = [];
            for (let item of this.locationNumbers)
                data["locationNumbers"].push(item);
        }
        data["dateRange"] = this.dateRange ? this.dateRange.toJSON() : null as any;
        data["departmentFilter"] = this.departmentFilter ? this.departmentFilter.toJSON() : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        return data;
    }

    clone(): DashboardFilter {
        const json = this.toJSON();
        let result = new DashboardFilter();
        result.init(json);
        return result;
    }
}

export interface IDashboardFilter {
    locationNumbers?: string[] | null;
    dateRange?: DateRange | null;
    departmentFilter?: DepartmentFilterModel | null;
    limit?: number | null;
}

export class DateRange implements IDateRange {
    startDate?: moment.Moment | null;
    endDate?: moment.Moment | null;

    constructor(data?: IDateRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): DateRange {
        data = typeof data === 'object' ? data : {};
        let result = new DateRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        return data;
    }

    clone(): DateRange {
        const json = this.toJSON();
        let result = new DateRange();
        result.init(json);
        return result;
    }
}

export interface IDateRange {
    startDate?: moment.Moment | null;
    endDate?: moment.Moment | null;
}

export class DepartmentFilterModel implements IDepartmentFilterModel {
    sbu?: string | null;
    departmentGroup?: string | null;
    departmentId?: number | null;
    departmentName?: string | null;

    constructor(data?: IDepartmentFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sbu = _data["sbu"] !== undefined ? _data["sbu"] : null as any;
            this.departmentGroup = _data["departmentGroup"] !== undefined ? _data["departmentGroup"] : null as any;
            this.departmentId = _data["departmentId"] !== undefined ? _data["departmentId"] : null as any;
            this.departmentName = _data["departmentName"] !== undefined ? _data["departmentName"] : null as any;
        }
    }

    static fromJS(data: any): DepartmentFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sbu"] = this.sbu !== undefined ? this.sbu : null as any;
        data["departmentGroup"] = this.departmentGroup !== undefined ? this.departmentGroup : null as any;
        data["departmentId"] = this.departmentId !== undefined ? this.departmentId : null as any;
        data["departmentName"] = this.departmentName !== undefined ? this.departmentName : null as any;
        return data;
    }

    clone(): DepartmentFilterModel {
        const json = this.toJSON();
        let result = new DepartmentFilterModel();
        result.init(json);
        return result;
    }
}

export interface IDepartmentFilterModel {
    sbu?: string | null;
    departmentGroup?: string | null;
    departmentId?: number | null;
    departmentName?: string | null;
}

export class CountryViewModel implements ICountryViewModel {
    countryId?: number;
    countryName?: string | null;

    constructor(data?: ICountryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null as any;
            this.countryName = _data["countryName"] !== undefined ? _data["countryName"] : null as any;
        }
    }

    static fromJS(data: any): CountryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CountryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId !== undefined ? this.countryId : null as any;
        data["countryName"] = this.countryName !== undefined ? this.countryName : null as any;
        return data;
    }

    clone(): CountryViewModel {
        const json = this.toJSON();
        let result = new CountryViewModel();
        result.init(json);
        return result;
    }
}

export interface ICountryViewModel {
    countryId?: number;
    countryName?: string | null;
}

export class LimitedResultOfCoverageCheckInExceptionsViewModel implements ILimitedResultOfCoverageCheckInExceptionsViewModel {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: CoverageCheckInExceptionsViewModel[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfCoverageCheckInExceptionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CoverageCheckInExceptionsViewModel.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfCoverageCheckInExceptionsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfCoverageCheckInExceptionsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfCoverageCheckInExceptionsViewModel {
        const json = this.toJSON();
        let result = new LimitedResultOfCoverageCheckInExceptionsViewModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfCoverageCheckInExceptionsViewModel {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: CoverageCheckInExceptionsViewModel[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class CoverageCheckInExceptionsViewModel implements ICoverageCheckInExceptionsViewModel {
    accountName?: string | null;
    storeNumber?: string | null;
    maxTimeInUtc?: moment.Moment | null;
    maxTimeOutUtc?: moment.Moment | null;
    storeTimezone?: string | null;
    timeInStoreMilliseconds?: number;

    constructor(data?: ICoverageCheckInExceptionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.storeNumber = _data["storeNumber"] !== undefined ? _data["storeNumber"] : null as any;
            this.maxTimeInUtc = _data["maxTimeInUtc"] ? moment(_data["maxTimeInUtc"].toString()) : null as any;
            this.maxTimeOutUtc = _data["maxTimeOutUtc"] ? moment(_data["maxTimeOutUtc"].toString()) : null as any;
            this.storeTimezone = _data["storeTimezone"] !== undefined ? _data["storeTimezone"] : null as any;
            this.timeInStoreMilliseconds = _data["timeInStoreMilliseconds"] !== undefined ? _data["timeInStoreMilliseconds"] : null as any;
        }
    }

    static fromJS(data: any): CoverageCheckInExceptionsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CoverageCheckInExceptionsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["storeNumber"] = this.storeNumber !== undefined ? this.storeNumber : null as any;
        data["maxTimeInUtc"] = this.maxTimeInUtc ? this.maxTimeInUtc.toISOString() : null as any;
        data["maxTimeOutUtc"] = this.maxTimeOutUtc ? this.maxTimeOutUtc.toISOString() : null as any;
        data["storeTimezone"] = this.storeTimezone !== undefined ? this.storeTimezone : null as any;
        data["timeInStoreMilliseconds"] = this.timeInStoreMilliseconds !== undefined ? this.timeInStoreMilliseconds : null as any;
        return data;
    }

    clone(): CoverageCheckInExceptionsViewModel {
        const json = this.toJSON();
        let result = new CoverageCheckInExceptionsViewModel();
        result.init(json);
        return result;
    }
}

export interface ICoverageCheckInExceptionsViewModel {
    accountName?: string | null;
    storeNumber?: string | null;
    maxTimeInUtc?: moment.Moment | null;
    maxTimeOutUtc?: moment.Moment | null;
    storeTimezone?: string | null;
    timeInStoreMilliseconds?: number;
}

export class CoverageCheckInExceptionsChart implements ICoverageCheckInExceptionsChart {
    totalVisited?: number;
    totalNonVisited?: number;

    constructor(data?: ICoverageCheckInExceptionsChart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalVisited = _data["totalVisited"] !== undefined ? _data["totalVisited"] : null as any;
            this.totalNonVisited = _data["totalNonVisited"] !== undefined ? _data["totalNonVisited"] : null as any;
        }
    }

    static fromJS(data: any): CoverageCheckInExceptionsChart {
        data = typeof data === 'object' ? data : {};
        let result = new CoverageCheckInExceptionsChart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalVisited"] = this.totalVisited !== undefined ? this.totalVisited : null as any;
        data["totalNonVisited"] = this.totalNonVisited !== undefined ? this.totalNonVisited : null as any;
        return data;
    }

    clone(): CoverageCheckInExceptionsChart {
        const json = this.toJSON();
        let result = new CoverageCheckInExceptionsChart();
        result.init(json);
        return result;
    }
}

export interface ICoverageCheckInExceptionsChart {
    totalVisited?: number;
    totalNonVisited?: number;
}

export class LimitedResultOfSupplier implements ILimitedResultOfSupplier {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: Supplier2[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfSupplier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(Supplier2.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfSupplier {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfSupplier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfSupplier {
        const json = this.toJSON();
        let result = new LimitedResultOfSupplier();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfSupplier {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: Supplier2[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class Supplier2 implements ISupplier2 {
    /** Used to match existing suppliers. Number takes preceident over Name. */
    name?: string | null;
    /** Used to match existing suppliers. Number takes preceident over Name. */
    number?: string | null;
    email?: string | null;
    contactName?: string | null;
    phone?: string | null;

    constructor(data?: ISupplier2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.number = _data["number"] !== undefined ? _data["number"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.contactName = _data["contactName"] !== undefined ? _data["contactName"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
        }
    }

    static fromJS(data: any): Supplier2 {
        data = typeof data === 'object' ? data : {};
        let result = new Supplier2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["number"] = this.number !== undefined ? this.number : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["contactName"] = this.contactName !== undefined ? this.contactName : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        return data;
    }

    clone(): Supplier2 {
        const json = this.toJSON();
        let result = new Supplier2();
        result.init(json);
        return result;
    }
}

export interface ISupplier2 {
    /** Used to match existing suppliers. Number takes preceident over Name. */
    name?: string | null;
    /** Used to match existing suppliers. Number takes preceident over Name. */
    number?: string | null;
    email?: string | null;
    contactName?: string | null;
    phone?: string | null;
}

export class DepartmentModel implements IDepartmentModel {
    departmentId?: number;
    departmentName?: string | null;
    detail?: string | null;
    accountId?: number | null;
    statusId?: number | null;
    departmentNumber?: string | null;
    statusName?: string | null;
    strategicBusinessUnit?: string | null;
    departmentGroup?: string | null;
    updatedDate?: moment.Moment;
    displayDepartmentName?: string | null;
    order?: number;

    constructor(data?: IDepartmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departmentId = _data["departmentId"] !== undefined ? _data["departmentId"] : null as any;
            this.departmentName = _data["departmentName"] !== undefined ? _data["departmentName"] : null as any;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            this.departmentNumber = _data["departmentNumber"] !== undefined ? _data["departmentNumber"] : null as any;
            this.statusName = _data["statusName"] !== undefined ? _data["statusName"] : null as any;
            this.strategicBusinessUnit = _data["strategicBusinessUnit"] !== undefined ? _data["strategicBusinessUnit"] : null as any;
            this.departmentGroup = _data["departmentGroup"] !== undefined ? _data["departmentGroup"] : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            this.displayDepartmentName = _data["displayDepartmentName"] !== undefined ? _data["displayDepartmentName"] : null as any;
            this.order = _data["order"] !== undefined ? _data["order"] : null as any;
        }
    }

    static fromJS(data: any): DepartmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentId"] = this.departmentId !== undefined ? this.departmentId : null as any;
        data["departmentName"] = this.departmentName !== undefined ? this.departmentName : null as any;
        data["detail"] = this.detail !== undefined ? this.detail : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        data["departmentNumber"] = this.departmentNumber !== undefined ? this.departmentNumber : null as any;
        data["statusName"] = this.statusName !== undefined ? this.statusName : null as any;
        data["strategicBusinessUnit"] = this.strategicBusinessUnit !== undefined ? this.strategicBusinessUnit : null as any;
        data["departmentGroup"] = this.departmentGroup !== undefined ? this.departmentGroup : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        data["displayDepartmentName"] = this.displayDepartmentName !== undefined ? this.displayDepartmentName : null as any;
        data["order"] = this.order !== undefined ? this.order : null as any;
        return data;
    }

    clone(): DepartmentModel {
        const json = this.toJSON();
        let result = new DepartmentModel();
        result.init(json);
        return result;
    }
}

export interface IDepartmentModel {
    departmentId?: number;
    departmentName?: string | null;
    detail?: string | null;
    accountId?: number | null;
    statusId?: number | null;
    departmentNumber?: string | null;
    statusName?: string | null;
    strategicBusinessUnit?: string | null;
    departmentGroup?: string | null;
    updatedDate?: moment.Moment;
    displayDepartmentName?: string | null;
    order?: number;
}

export class StrategicBusinessUnitModel implements IStrategicBusinessUnitModel {
    id?: string | null;
    name?: string | null;
    departmentGroups?: DepartmentGroupModel[] | null;

    constructor(data?: IStrategicBusinessUnitModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            if (Array.isArray(_data["departmentGroups"])) {
                this.departmentGroups = [] as any;
                for (let item of _data["departmentGroups"])
                    this.departmentGroups!.push(DepartmentGroupModel.fromJS(item));
            }
            else {
                this.departmentGroups = null as any;
            }
        }
    }

    static fromJS(data: any): StrategicBusinessUnitModel {
        data = typeof data === 'object' ? data : {};
        let result = new StrategicBusinessUnitModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        if (Array.isArray(this.departmentGroups)) {
            data["departmentGroups"] = [];
            for (let item of this.departmentGroups)
                data["departmentGroups"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): StrategicBusinessUnitModel {
        const json = this.toJSON();
        let result = new StrategicBusinessUnitModel();
        result.init(json);
        return result;
    }
}

export interface IStrategicBusinessUnitModel {
    id?: string | null;
    name?: string | null;
    departmentGroups?: DepartmentGroupModel[] | null;
}

export class DepartmentGroupModel implements IDepartmentGroupModel {
    id?: string | null;
    name?: string | null;
    departments?: DepartmentModel[] | null;

    constructor(data?: IDepartmentGroupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            if (Array.isArray(_data["departments"])) {
                this.departments = [] as any;
                for (let item of _data["departments"])
                    this.departments!.push(DepartmentModel.fromJS(item));
            }
            else {
                this.departments = null as any;
            }
        }
    }

    static fromJS(data: any): DepartmentGroupModel {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentGroupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        if (Array.isArray(this.departments)) {
            data["departments"] = [];
            for (let item of this.departments)
                data["departments"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): DepartmentGroupModel {
        const json = this.toJSON();
        let result = new DepartmentGroupModel();
        result.init(json);
        return result;
    }
}

export interface IDepartmentGroupModel {
    id?: string | null;
    name?: string | null;
    departments?: DepartmentModel[] | null;
}

export class SupplierSignageDepartmentViewModel implements ISupplierSignageDepartmentViewModel {
    name?: string | null;
    number?: string | null;

    constructor(data?: ISupplierSignageDepartmentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.number = _data["number"] !== undefined ? _data["number"] : null as any;
        }
    }

    static fromJS(data: any): SupplierSignageDepartmentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierSignageDepartmentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["number"] = this.number !== undefined ? this.number : null as any;
        return data;
    }

    clone(): SupplierSignageDepartmentViewModel {
        const json = this.toJSON();
        let result = new SupplierSignageDepartmentViewModel();
        result.init(json);
        return result;
    }
}

export interface ISupplierSignageDepartmentViewModel {
    name?: string | null;
    number?: string | null;
}

export class DepartmentTaskCountViewModel implements IDepartmentTaskCountViewModel {
    departmentName?: string | null;
    taskCount?: number;
    percent?: number | null;

    constructor(data?: IDepartmentTaskCountViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departmentName = _data["departmentName"] !== undefined ? _data["departmentName"] : null as any;
            this.taskCount = _data["taskCount"] !== undefined ? _data["taskCount"] : null as any;
            this.percent = _data["percent"] !== undefined ? _data["percent"] : null as any;
        }
    }

    static fromJS(data: any): DepartmentTaskCountViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentTaskCountViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentName"] = this.departmentName !== undefined ? this.departmentName : null as any;
        data["taskCount"] = this.taskCount !== undefined ? this.taskCount : null as any;
        data["percent"] = this.percent !== undefined ? this.percent : null as any;
        return data;
    }

    clone(): DepartmentTaskCountViewModel {
        const json = this.toJSON();
        let result = new DepartmentTaskCountViewModel();
        result.init(json);
        return result;
    }
}

export interface IDepartmentTaskCountViewModel {
    departmentName?: string | null;
    taskCount?: number;
    percent?: number | null;
}

export class DiagnosticsViewModel implements IDiagnosticsViewModel {
    name?: string | null;
    description?: string | null;
    status?: DiagnosticsStatus;

    constructor(data?: IDiagnosticsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
        }
    }

    static fromJS(data: any): DiagnosticsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosticsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        return data;
    }

    clone(): DiagnosticsViewModel {
        const json = this.toJSON();
        let result = new DiagnosticsViewModel();
        result.init(json);
        return result;
    }
}

export interface IDiagnosticsViewModel {
    name?: string | null;
    description?: string | null;
    status?: DiagnosticsStatus;
}

export enum DiagnosticsStatus {
    Pass = "pass",
    Fail = "fail",
}

export enum ReportErrors {
    ExpiredReport = "expiredReport",
    UnauthorizedReport = "unauthorizedReport",
    NotFoundReport = "notFoundReport",
}

export class LocationCompletedByProvider implements ILocationCompletedByProvider {
    total?: number;
    accountName?: string | null;
    completedOnDueDate?: number;
    completedAfterDueDate?: number;
    incompleteAfterDueDate?: number;

    constructor(data?: ILocationCompletedByProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.completedOnDueDate = _data["completedOnDueDate"] !== undefined ? _data["completedOnDueDate"] : null as any;
            this.completedAfterDueDate = _data["completedAfterDueDate"] !== undefined ? _data["completedAfterDueDate"] : null as any;
            this.incompleteAfterDueDate = _data["incompleteAfterDueDate"] !== undefined ? _data["incompleteAfterDueDate"] : null as any;
        }
    }

    static fromJS(data: any): LocationCompletedByProvider {
        data = typeof data === 'object' ? data : {};
        let result = new LocationCompletedByProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total !== undefined ? this.total : null as any;
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["completedOnDueDate"] = this.completedOnDueDate !== undefined ? this.completedOnDueDate : null as any;
        data["completedAfterDueDate"] = this.completedAfterDueDate !== undefined ? this.completedAfterDueDate : null as any;
        data["incompleteAfterDueDate"] = this.incompleteAfterDueDate !== undefined ? this.incompleteAfterDueDate : null as any;
        return data;
    }

    clone(): LocationCompletedByProvider {
        const json = this.toJSON();
        let result = new LocationCompletedByProvider();
        result.init(json);
        return result;
    }
}

export interface ILocationCompletedByProvider {
    total?: number;
    accountName?: string | null;
    completedOnDueDate?: number;
    completedAfterDueDate?: number;
    incompleteAfterDueDate?: number;
}

export class LocationCompletedActivity extends LocationCompletedByProvider implements ILocationCompletedActivity {
    activityName?: string | null;

    constructor(data?: ILocationCompletedActivity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityName = _data["activityName"] !== undefined ? _data["activityName"] : null as any;
        }
    }

    static override fromJS(data: any): LocationCompletedActivity {
        data = typeof data === 'object' ? data : {};
        let result = new LocationCompletedActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityName"] = this.activityName !== undefined ? this.activityName : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): LocationCompletedActivity {
        const json = this.toJSON();
        let result = new LocationCompletedActivity();
        result.init(json);
        return result;
    }
}

export interface ILocationCompletedActivity extends ILocationCompletedByProvider {
    activityName?: string | null;
}

export class LocationOnTime extends LocationCompletedByProvider implements ILocationOnTime {
    wmtWeek?: string | null;

    constructor(data?: ILocationOnTime) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.wmtWeek = _data["wmtWeek"] !== undefined ? _data["wmtWeek"] : null as any;
        }
    }

    static override fromJS(data: any): LocationOnTime {
        data = typeof data === 'object' ? data : {};
        let result = new LocationOnTime();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wmtWeek"] = this.wmtWeek !== undefined ? this.wmtWeek : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): LocationOnTime {
        const json = this.toJSON();
        let result = new LocationOnTime();
        result.init(json);
        return result;
    }
}

export interface ILocationOnTime extends ILocationCompletedByProvider {
    wmtWeek?: string | null;
}

export class TaskLocationDue implements ITaskLocationDue {
    accountName?: string | null;
    dueDateCount?: number;

    constructor(data?: ITaskLocationDue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.dueDateCount = _data["dueDateCount"] !== undefined ? _data["dueDateCount"] : null as any;
        }
    }

    static fromJS(data: any): TaskLocationDue {
        data = typeof data === 'object' ? data : {};
        let result = new TaskLocationDue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["dueDateCount"] = this.dueDateCount !== undefined ? this.dueDateCount : null as any;
        return data;
    }

    clone(): TaskLocationDue {
        const json = this.toJSON();
        let result = new TaskLocationDue();
        result.init(json);
        return result;
    }
}

export interface ITaskLocationDue {
    accountName?: string | null;
    dueDateCount?: number;
}

export class TaskLocationPercentageReport implements ITaskLocationPercentageReport {
    accountName?: string | null;
    total?: number;
    percentage?: number;

    constructor(data?: ITaskLocationPercentageReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
            this.percentage = _data["percentage"] !== undefined ? _data["percentage"] : null as any;
        }
    }

    static fromJS(data: any): TaskLocationPercentageReport {
        data = typeof data === 'object' ? data : {};
        let result = new TaskLocationPercentageReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["total"] = this.total !== undefined ? this.total : null as any;
        data["percentage"] = this.percentage !== undefined ? this.percentage : null as any;
        return data;
    }

    clone(): TaskLocationPercentageReport {
        const json = this.toJSON();
        let result = new TaskLocationPercentageReport();
        result.init(json);
        return result;
    }
}

export interface ITaskLocationPercentageReport {
    accountName?: string | null;
    total?: number;
    percentage?: number;
}

export class TaskLocationMovementChangedPercentage implements ITaskLocationMovementChangedPercentage {
    accountName?: string | null;
    total?: number;
    oneWeekPercentage?: number;
    twoWeeksPercentage?: number;

    constructor(data?: ITaskLocationMovementChangedPercentage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
            this.oneWeekPercentage = _data["oneWeekPercentage"] !== undefined ? _data["oneWeekPercentage"] : null as any;
            this.twoWeeksPercentage = _data["twoWeeksPercentage"] !== undefined ? _data["twoWeeksPercentage"] : null as any;
        }
    }

    static fromJS(data: any): TaskLocationMovementChangedPercentage {
        data = typeof data === 'object' ? data : {};
        let result = new TaskLocationMovementChangedPercentage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["total"] = this.total !== undefined ? this.total : null as any;
        data["oneWeekPercentage"] = this.oneWeekPercentage !== undefined ? this.oneWeekPercentage : null as any;
        data["twoWeeksPercentage"] = this.twoWeeksPercentage !== undefined ? this.twoWeeksPercentage : null as any;
        return data;
    }

    clone(): TaskLocationMovementChangedPercentage {
        const json = this.toJSON();
        let result = new TaskLocationMovementChangedPercentage();
        result.init(json);
        return result;
    }
}

export interface ITaskLocationMovementChangedPercentage {
    accountName?: string | null;
    total?: number;
    oneWeekPercentage?: number;
    twoWeeksPercentage?: number;
}

export class DueDatePerformanceFilterParams implements IDueDatePerformanceFilterParams {
    accountIds?: number[] | null;
    locationFormats?: string[] | null;
    hierarchyType?: number | null;
    hierarchyNames?: string[] | null;
    wmtWeeks?: string[] | null;
    activities?: string[] | null;
    serviceModels?: string[] | null;
    departments?: string[] | null;

    constructor(data?: IDueDatePerformanceFilterParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accountIds"])) {
                this.accountIds = [] as any;
                for (let item of _data["accountIds"])
                    this.accountIds!.push(item);
            }
            else {
                this.accountIds = null as any;
            }
            if (Array.isArray(_data["locationFormats"])) {
                this.locationFormats = [] as any;
                for (let item of _data["locationFormats"])
                    this.locationFormats!.push(item);
            }
            else {
                this.locationFormats = null as any;
            }
            this.hierarchyType = _data["hierarchyType"] !== undefined ? _data["hierarchyType"] : null as any;
            if (Array.isArray(_data["hierarchyNames"])) {
                this.hierarchyNames = [] as any;
                for (let item of _data["hierarchyNames"])
                    this.hierarchyNames!.push(item);
            }
            else {
                this.hierarchyNames = null as any;
            }
            if (Array.isArray(_data["wmtWeeks"])) {
                this.wmtWeeks = [] as any;
                for (let item of _data["wmtWeeks"])
                    this.wmtWeeks!.push(item);
            }
            else {
                this.wmtWeeks = null as any;
            }
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(item);
            }
            else {
                this.activities = null as any;
            }
            if (Array.isArray(_data["serviceModels"])) {
                this.serviceModels = [] as any;
                for (let item of _data["serviceModels"])
                    this.serviceModels!.push(item);
            }
            else {
                this.serviceModels = null as any;
            }
            if (Array.isArray(_data["departments"])) {
                this.departments = [] as any;
                for (let item of _data["departments"])
                    this.departments!.push(item);
            }
            else {
                this.departments = null as any;
            }
        }
    }

    static fromJS(data: any): DueDatePerformanceFilterParams {
        data = typeof data === 'object' ? data : {};
        let result = new DueDatePerformanceFilterParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accountIds)) {
            data["accountIds"] = [];
            for (let item of this.accountIds)
                data["accountIds"].push(item);
        }
        if (Array.isArray(this.locationFormats)) {
            data["locationFormats"] = [];
            for (let item of this.locationFormats)
                data["locationFormats"].push(item);
        }
        data["hierarchyType"] = this.hierarchyType !== undefined ? this.hierarchyType : null as any;
        if (Array.isArray(this.hierarchyNames)) {
            data["hierarchyNames"] = [];
            for (let item of this.hierarchyNames)
                data["hierarchyNames"].push(item);
        }
        if (Array.isArray(this.wmtWeeks)) {
            data["wmtWeeks"] = [];
            for (let item of this.wmtWeeks)
                data["wmtWeeks"].push(item);
        }
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item);
        }
        if (Array.isArray(this.serviceModels)) {
            data["serviceModels"] = [];
            for (let item of this.serviceModels)
                data["serviceModels"].push(item);
        }
        if (Array.isArray(this.departments)) {
            data["departments"] = [];
            for (let item of this.departments)
                data["departments"].push(item);
        }
        return data;
    }

    clone(): DueDatePerformanceFilterParams {
        const json = this.toJSON();
        let result = new DueDatePerformanceFilterParams();
        result.init(json);
        return result;
    }
}

export interface IDueDatePerformanceFilterParams {
    accountIds?: number[] | null;
    locationFormats?: string[] | null;
    hierarchyType?: number | null;
    hierarchyNames?: string[] | null;
    wmtWeeks?: string[] | null;
    activities?: string[] | null;
    serviceModels?: string[] | null;
    departments?: string[] | null;
}

export class StoreStatusViewModel implements IStoreStatusViewModel {
    operationalStatus?: string | null;
    powerStatus?: string | null;
    receivingFreight?: string | null;
    reasonforChange?: string | null;
    communicationStatus?: string | null;
    pharmacyStatus?: string | null;
    expectedclosureDateandTime?: moment.Moment | null;
    expectedReopenDateTime?: moment.Moment | null;
    storeExpectedClosureDateandTime?: moment.Moment | null;
    storeExpectedReopenDateTime?: moment.Moment | null;
    storeNumber?: string | null;
    storeTimeZone?: string | null;
    ivrMessage?: string | null;
    eventName?: string | null;
    expectedclosure?: string | null;
    expectedReopen?: string | null;
    storeExpectedclosure?: string | null;
    storeExpectedReopen?: string | null;

    constructor(data?: IStoreStatusViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operationalStatus = _data["operationalStatus"] !== undefined ? _data["operationalStatus"] : null as any;
            this.powerStatus = _data["powerStatus"] !== undefined ? _data["powerStatus"] : null as any;
            this.receivingFreight = _data["receivingFreight"] !== undefined ? _data["receivingFreight"] : null as any;
            this.reasonforChange = _data["reasonforChange"] !== undefined ? _data["reasonforChange"] : null as any;
            this.communicationStatus = _data["communicationStatus"] !== undefined ? _data["communicationStatus"] : null as any;
            this.pharmacyStatus = _data["pharmacyStatus"] !== undefined ? _data["pharmacyStatus"] : null as any;
            this.expectedclosureDateandTime = _data["expectedclosureDateandTime"] ? moment(_data["expectedclosureDateandTime"].toString()) : null as any;
            this.expectedReopenDateTime = _data["expectedReopenDateTime"] ? moment(_data["expectedReopenDateTime"].toString()) : null as any;
            this.storeExpectedClosureDateandTime = _data["storeExpectedClosureDateandTime"] ? moment(_data["storeExpectedClosureDateandTime"].toString()) : null as any;
            this.storeExpectedReopenDateTime = _data["storeExpectedReopenDateTime"] ? moment(_data["storeExpectedReopenDateTime"].toString()) : null as any;
            this.storeNumber = _data["storeNumber"] !== undefined ? _data["storeNumber"] : null as any;
            this.storeTimeZone = _data["storeTimeZone"] !== undefined ? _data["storeTimeZone"] : null as any;
            this.ivrMessage = _data["ivrMessage"] !== undefined ? _data["ivrMessage"] : null as any;
            this.eventName = _data["eventName"] !== undefined ? _data["eventName"] : null as any;
            this.expectedclosure = _data["expectedclosure"] !== undefined ? _data["expectedclosure"] : null as any;
            this.expectedReopen = _data["expectedReopen"] !== undefined ? _data["expectedReopen"] : null as any;
            this.storeExpectedclosure = _data["storeExpectedclosure"] !== undefined ? _data["storeExpectedclosure"] : null as any;
            this.storeExpectedReopen = _data["storeExpectedReopen"] !== undefined ? _data["storeExpectedReopen"] : null as any;
        }
    }

    static fromJS(data: any): StoreStatusViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StoreStatusViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operationalStatus"] = this.operationalStatus !== undefined ? this.operationalStatus : null as any;
        data["powerStatus"] = this.powerStatus !== undefined ? this.powerStatus : null as any;
        data["receivingFreight"] = this.receivingFreight !== undefined ? this.receivingFreight : null as any;
        data["reasonforChange"] = this.reasonforChange !== undefined ? this.reasonforChange : null as any;
        data["communicationStatus"] = this.communicationStatus !== undefined ? this.communicationStatus : null as any;
        data["pharmacyStatus"] = this.pharmacyStatus !== undefined ? this.pharmacyStatus : null as any;
        data["expectedclosureDateandTime"] = this.expectedclosureDateandTime ? this.expectedclosureDateandTime.toISOString() : null as any;
        data["expectedReopenDateTime"] = this.expectedReopenDateTime ? this.expectedReopenDateTime.toISOString() : null as any;
        data["storeExpectedClosureDateandTime"] = this.storeExpectedClosureDateandTime ? this.storeExpectedClosureDateandTime.toISOString() : null as any;
        data["storeExpectedReopenDateTime"] = this.storeExpectedReopenDateTime ? this.storeExpectedReopenDateTime.toISOString() : null as any;
        data["storeNumber"] = this.storeNumber !== undefined ? this.storeNumber : null as any;
        data["storeTimeZone"] = this.storeTimeZone !== undefined ? this.storeTimeZone : null as any;
        data["ivrMessage"] = this.ivrMessage !== undefined ? this.ivrMessage : null as any;
        data["eventName"] = this.eventName !== undefined ? this.eventName : null as any;
        data["expectedclosure"] = this.expectedclosure !== undefined ? this.expectedclosure : null as any;
        data["expectedReopen"] = this.expectedReopen !== undefined ? this.expectedReopen : null as any;
        data["storeExpectedclosure"] = this.storeExpectedclosure !== undefined ? this.storeExpectedclosure : null as any;
        data["storeExpectedReopen"] = this.storeExpectedReopen !== undefined ? this.storeExpectedReopen : null as any;
        return data;
    }

    clone(): StoreStatusViewModel {
        const json = this.toJSON();
        let result = new StoreStatusViewModel();
        result.init(json);
        return result;
    }
}

export interface IStoreStatusViewModel {
    operationalStatus?: string | null;
    powerStatus?: string | null;
    receivingFreight?: string | null;
    reasonforChange?: string | null;
    communicationStatus?: string | null;
    pharmacyStatus?: string | null;
    expectedclosureDateandTime?: moment.Moment | null;
    expectedReopenDateTime?: moment.Moment | null;
    storeExpectedClosureDateandTime?: moment.Moment | null;
    storeExpectedReopenDateTime?: moment.Moment | null;
    storeNumber?: string | null;
    storeTimeZone?: string | null;
    ivrMessage?: string | null;
    eventName?: string | null;
    expectedclosure?: string | null;
    expectedReopen?: string | null;
    storeExpectedclosure?: string | null;
    storeExpectedReopen?: string | null;
}

export class FeatureViewModel implements IFeatureViewModel {
    name?: string | null;
    enabled?: boolean;
    subFeatures?: SubFeatureViewModel[] | null;
    accounts?: number[] | null;

    constructor(data?: IFeatureViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : null as any;
            if (Array.isArray(_data["subFeatures"])) {
                this.subFeatures = [] as any;
                for (let item of _data["subFeatures"])
                    this.subFeatures!.push(SubFeatureViewModel.fromJS(item));
            }
            else {
                this.subFeatures = null as any;
            }
            if (Array.isArray(_data["accounts"])) {
                this.accounts = [] as any;
                for (let item of _data["accounts"])
                    this.accounts!.push(item);
            }
            else {
                this.accounts = null as any;
            }
        }
    }

    static fromJS(data: any): FeatureViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["enabled"] = this.enabled !== undefined ? this.enabled : null as any;
        if (Array.isArray(this.subFeatures)) {
            data["subFeatures"] = [];
            for (let item of this.subFeatures)
                data["subFeatures"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.accounts)) {
            data["accounts"] = [];
            for (let item of this.accounts)
                data["accounts"].push(item);
        }
        return data;
    }

    clone(): FeatureViewModel {
        const json = this.toJSON();
        let result = new FeatureViewModel();
        result.init(json);
        return result;
    }
}

export interface IFeatureViewModel {
    name?: string | null;
    enabled?: boolean;
    subFeatures?: SubFeatureViewModel[] | null;
    accounts?: number[] | null;
}

export class SubFeatureViewModel implements ISubFeatureViewModel {
    name?: string | null;
    enabled?: boolean;

    constructor(data?: ISubFeatureViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : null as any;
        }
    }

    static fromJS(data: any): SubFeatureViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubFeatureViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["enabled"] = this.enabled !== undefined ? this.enabled : null as any;
        return data;
    }

    clone(): SubFeatureViewModel {
        const json = this.toJSON();
        let result = new SubFeatureViewModel();
        result.init(json);
        return result;
    }
}

export interface ISubFeatureViewModel {
    name?: string | null;
    enabled?: boolean;
}

export class UserMetadata implements IUserMetadata {
    checkedInUserMetaData?: CheckedInUserMetaData | null;
    nonCheckedInUserMetaData?: NonCheckedInUserMetaData | null;

    constructor(data?: IUserMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checkedInUserMetaData = _data["checkedInUserMetaData"] ? CheckedInUserMetaData.fromJS(_data["checkedInUserMetaData"]) : null as any;
            this.nonCheckedInUserMetaData = _data["nonCheckedInUserMetaData"] ? NonCheckedInUserMetaData.fromJS(_data["nonCheckedInUserMetaData"]) : null as any;
        }
    }

    static fromJS(data: any): UserMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new UserMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkedInUserMetaData"] = this.checkedInUserMetaData ? this.checkedInUserMetaData.toJSON() : null as any;
        data["nonCheckedInUserMetaData"] = this.nonCheckedInUserMetaData ? this.nonCheckedInUserMetaData.toJSON() : null as any;
        return data;
    }

    clone(): UserMetadata {
        const json = this.toJSON();
        let result = new UserMetadata();
        result.init(json);
        return result;
    }
}

export interface IUserMetadata {
    checkedInUserMetaData?: CheckedInUserMetaData | null;
    nonCheckedInUserMetaData?: NonCheckedInUserMetaData | null;
}

export class CheckedInUserMetaData implements ICheckedInUserMetaData {
    accountId?: number | null;
    accountName?: string | null;
    checkedInStoreNumber?: string | null;
    checkedInLocationBanner?: string | null;
    employeeNumber?: string | null;
    lastname?: string | null;
    firstName?: string | null;
    personId?: number;

    constructor(data?: ICheckedInUserMetaData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.checkedInStoreNumber = _data["checkedInStoreNumber"] !== undefined ? _data["checkedInStoreNumber"] : null as any;
            this.checkedInLocationBanner = _data["checkedInLocationBanner"] !== undefined ? _data["checkedInLocationBanner"] : null as any;
            this.employeeNumber = _data["employeeNumber"] !== undefined ? _data["employeeNumber"] : null as any;
            this.lastname = _data["lastname"] !== undefined ? _data["lastname"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null as any;
        }
    }

    static fromJS(data: any): CheckedInUserMetaData {
        data = typeof data === 'object' ? data : {};
        let result = new CheckedInUserMetaData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["checkedInStoreNumber"] = this.checkedInStoreNumber !== undefined ? this.checkedInStoreNumber : null as any;
        data["checkedInLocationBanner"] = this.checkedInLocationBanner !== undefined ? this.checkedInLocationBanner : null as any;
        data["employeeNumber"] = this.employeeNumber !== undefined ? this.employeeNumber : null as any;
        data["lastname"] = this.lastname !== undefined ? this.lastname : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["personId"] = this.personId !== undefined ? this.personId : null as any;
        return data;
    }

    clone(): CheckedInUserMetaData {
        const json = this.toJSON();
        let result = new CheckedInUserMetaData();
        result.init(json);
        return result;
    }
}

export interface ICheckedInUserMetaData {
    accountId?: number | null;
    accountName?: string | null;
    checkedInStoreNumber?: string | null;
    checkedInLocationBanner?: string | null;
    employeeNumber?: string | null;
    lastname?: string | null;
    firstName?: string | null;
    personId?: number;
}

export class NonCheckedInUserMetaData implements INonCheckedInUserMetaData {
    personDetails?: PersonDetails[] | null;

    constructor(data?: INonCheckedInUserMetaData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["personDetails"])) {
                this.personDetails = [] as any;
                for (let item of _data["personDetails"])
                    this.personDetails!.push(PersonDetails.fromJS(item));
            }
            else {
                this.personDetails = null as any;
            }
        }
    }

    static fromJS(data: any): NonCheckedInUserMetaData {
        data = typeof data === 'object' ? data : {};
        let result = new NonCheckedInUserMetaData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.personDetails)) {
            data["personDetails"] = [];
            for (let item of this.personDetails)
                data["personDetails"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): NonCheckedInUserMetaData {
        const json = this.toJSON();
        let result = new NonCheckedInUserMetaData();
        result.init(json);
        return result;
    }
}

export interface INonCheckedInUserMetaData {
    personDetails?: PersonDetails[] | null;
}

export class PersonDetails implements IPersonDetails {
    accountName?: string | null;
    accountId?: number | null;
    employeeNumber?: string | null;
    lastname?: string | null;
    firstName?: string | null;
    personId?: number;

    constructor(data?: IPersonDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.employeeNumber = _data["employeeNumber"] !== undefined ? _data["employeeNumber"] : null as any;
            this.lastname = _data["lastname"] !== undefined ? _data["lastname"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null as any;
        }
    }

    static fromJS(data: any): PersonDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PersonDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["employeeNumber"] = this.employeeNumber !== undefined ? this.employeeNumber : null as any;
        data["lastname"] = this.lastname !== undefined ? this.lastname : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["personId"] = this.personId !== undefined ? this.personId : null as any;
        return data;
    }

    clone(): PersonDetails {
        const json = this.toJSON();
        let result = new PersonDetails();
        result.init(json);
        return result;
    }
}

export interface IPersonDetails {
    accountName?: string | null;
    accountId?: number | null;
    employeeNumber?: string | null;
    lastname?: string | null;
    firstName?: string | null;
    personId?: number;
}

export class RetailerLocation implements IRetailerLocation {
    retailerAbbrev?: string | null;
    storeNumber?: string | null;

    constructor(data?: IRetailerLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.retailerAbbrev = _data["retailerAbbrev"] !== undefined ? _data["retailerAbbrev"] : null as any;
            this.storeNumber = _data["storeNumber"] !== undefined ? _data["storeNumber"] : null as any;
        }
    }

    static fromJS(data: any): RetailerLocation {
        data = typeof data === 'object' ? data : {};
        let result = new RetailerLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["retailerAbbrev"] = this.retailerAbbrev !== undefined ? this.retailerAbbrev : null as any;
        data["storeNumber"] = this.storeNumber !== undefined ? this.storeNumber : null as any;
        return data;
    }

    clone(): RetailerLocation {
        const json = this.toJSON();
        let result = new RetailerLocation();
        result.init(json);
        return result;
    }
}

export interface IRetailerLocation {
    retailerAbbrev?: string | null;
    storeNumber?: string | null;
}

export class FieldGroupTypeSummaryViewModel implements IFieldGroupTypeSummaryViewModel {
    name?: string | null;
    description?: string | null;
    licenseAgreementUrl?: string | null;
    licenseAgreementFileName?: string | null;
    badgeFooterColor?: string | null;
    updatedDate?: moment.Moment;
    status?: string | null;
    numberOfAccounts?: number;
    numberOfActiveUsers?: number;

    constructor(data?: IFieldGroupTypeSummaryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.licenseAgreementUrl = _data["licenseAgreementUrl"] !== undefined ? _data["licenseAgreementUrl"] : null as any;
            this.licenseAgreementFileName = _data["licenseAgreementFileName"] !== undefined ? _data["licenseAgreementFileName"] : null as any;
            this.badgeFooterColor = _data["badgeFooterColor"] !== undefined ? _data["badgeFooterColor"] : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.numberOfAccounts = _data["numberOfAccounts"] !== undefined ? _data["numberOfAccounts"] : null as any;
            this.numberOfActiveUsers = _data["numberOfActiveUsers"] !== undefined ? _data["numberOfActiveUsers"] : null as any;
        }
    }

    static fromJS(data: any): FieldGroupTypeSummaryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FieldGroupTypeSummaryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["licenseAgreementUrl"] = this.licenseAgreementUrl !== undefined ? this.licenseAgreementUrl : null as any;
        data["licenseAgreementFileName"] = this.licenseAgreementFileName !== undefined ? this.licenseAgreementFileName : null as any;
        data["badgeFooterColor"] = this.badgeFooterColor !== undefined ? this.badgeFooterColor : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["numberOfAccounts"] = this.numberOfAccounts !== undefined ? this.numberOfAccounts : null as any;
        data["numberOfActiveUsers"] = this.numberOfActiveUsers !== undefined ? this.numberOfActiveUsers : null as any;
        return data;
    }

    clone(): FieldGroupTypeSummaryViewModel {
        const json = this.toJSON();
        let result = new FieldGroupTypeSummaryViewModel();
        result.init(json);
        return result;
    }
}

export interface IFieldGroupTypeSummaryViewModel {
    name?: string | null;
    description?: string | null;
    licenseAgreementUrl?: string | null;
    licenseAgreementFileName?: string | null;
    badgeFooterColor?: string | null;
    updatedDate?: moment.Moment;
    status?: string | null;
    numberOfAccounts?: number;
    numberOfActiveUsers?: number;
}

export class LimitedResultOfInvoiceViewModel implements ILimitedResultOfInvoiceViewModel {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: InvoiceViewModel[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfInvoiceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(InvoiceViewModel.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfInvoiceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfInvoiceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfInvoiceViewModel {
        const json = this.toJSON();
        let result = new LimitedResultOfInvoiceViewModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfInvoiceViewModel {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: InvoiceViewModel[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class InvoiceViewModel implements IInvoiceViewModel {
    aname?: string | null;
    invoiceNumber?: string | null;
    hashedInvoiceId?: string | null;
    invoiceAmt?: number;
    invoiceDate?: moment.Moment;
    invoiceDueDate?: moment.Moment;
    poNumber?: string | null;
    account?: InvoiceAccount | null;

    constructor(data?: IInvoiceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aname = _data["aname"] !== undefined ? _data["aname"] : null as any;
            this.invoiceNumber = _data["invoiceNumber"] !== undefined ? _data["invoiceNumber"] : null as any;
            this.hashedInvoiceId = _data["hashedInvoiceId"] !== undefined ? _data["hashedInvoiceId"] : null as any;
            this.invoiceAmt = _data["invoiceAmt"] !== undefined ? _data["invoiceAmt"] : null as any;
            this.invoiceDate = _data["invoiceDate"] ? moment(_data["invoiceDate"].toString()) : null as any;
            this.invoiceDueDate = _data["invoiceDueDate"] ? moment(_data["invoiceDueDate"].toString()) : null as any;
            this.poNumber = _data["poNumber"] !== undefined ? _data["poNumber"] : null as any;
            this.account = _data["account"] ? InvoiceAccount.fromJS(_data["account"]) : null as any;
        }
    }

    static fromJS(data: any): InvoiceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aname"] = this.aname !== undefined ? this.aname : null as any;
        data["invoiceNumber"] = this.invoiceNumber !== undefined ? this.invoiceNumber : null as any;
        data["hashedInvoiceId"] = this.hashedInvoiceId !== undefined ? this.hashedInvoiceId : null as any;
        data["invoiceAmt"] = this.invoiceAmt !== undefined ? this.invoiceAmt : null as any;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : null as any;
        data["invoiceDueDate"] = this.invoiceDueDate ? this.invoiceDueDate.toISOString() : null as any;
        data["poNumber"] = this.poNumber !== undefined ? this.poNumber : null as any;
        data["account"] = this.account ? this.account.toJSON() : null as any;
        return data;
    }

    clone(): InvoiceViewModel {
        const json = this.toJSON();
        let result = new InvoiceViewModel();
        result.init(json);
        return result;
    }
}

export interface IInvoiceViewModel {
    aname?: string | null;
    invoiceNumber?: string | null;
    hashedInvoiceId?: string | null;
    invoiceAmt?: number;
    invoiceDate?: moment.Moment;
    invoiceDueDate?: moment.Moment;
    poNumber?: string | null;
    account?: InvoiceAccount | null;
}

export class InvoiceAccount implements IInvoiceAccount {
    aname?: string | null;
    accountNumber?: string | null;
    baddress1?: string | null;
    baddress2?: string | null;
    bcity?: string | null;
    bstate?: string | null;
    bzip?: string | null;
    bcountry?: string | null;
    bphone?: string | null;
    billingEmail?: string | null;
    billingName?: string | null;

    constructor(data?: IInvoiceAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aname = _data["aname"] !== undefined ? _data["aname"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.baddress1 = _data["baddress1"] !== undefined ? _data["baddress1"] : null as any;
            this.baddress2 = _data["baddress2"] !== undefined ? _data["baddress2"] : null as any;
            this.bcity = _data["bcity"] !== undefined ? _data["bcity"] : null as any;
            this.bstate = _data["bstate"] !== undefined ? _data["bstate"] : null as any;
            this.bzip = _data["bzip"] !== undefined ? _data["bzip"] : null as any;
            this.bcountry = _data["bcountry"] !== undefined ? _data["bcountry"] : null as any;
            this.bphone = _data["bphone"] !== undefined ? _data["bphone"] : null as any;
            this.billingEmail = _data["billingEmail"] !== undefined ? _data["billingEmail"] : null as any;
            this.billingName = _data["billingName"] !== undefined ? _data["billingName"] : null as any;
        }
    }

    static fromJS(data: any): InvoiceAccount {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aname"] = this.aname !== undefined ? this.aname : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["baddress1"] = this.baddress1 !== undefined ? this.baddress1 : null as any;
        data["baddress2"] = this.baddress2 !== undefined ? this.baddress2 : null as any;
        data["bcity"] = this.bcity !== undefined ? this.bcity : null as any;
        data["bstate"] = this.bstate !== undefined ? this.bstate : null as any;
        data["bzip"] = this.bzip !== undefined ? this.bzip : null as any;
        data["bcountry"] = this.bcountry !== undefined ? this.bcountry : null as any;
        data["bphone"] = this.bphone !== undefined ? this.bphone : null as any;
        data["billingEmail"] = this.billingEmail !== undefined ? this.billingEmail : null as any;
        data["billingName"] = this.billingName !== undefined ? this.billingName : null as any;
        return data;
    }

    clone(): InvoiceAccount {
        const json = this.toJSON();
        let result = new InvoiceAccount();
        result.init(json);
        return result;
    }
}

export interface IInvoiceAccount {
    aname?: string | null;
    accountNumber?: string | null;
    baddress1?: string | null;
    baddress2?: string | null;
    bcity?: string | null;
    bstate?: string | null;
    bzip?: string | null;
    bcountry?: string | null;
    bphone?: string | null;
    billingEmail?: string | null;
    billingName?: string | null;
}

export class InvoiceSummaryViewModel extends InvoiceViewModel implements IInvoiceSummaryViewModel {
    invoiceSummaryDetails?: InvoiceSummaryDetailViewModel[] | null;

    constructor(data?: IInvoiceSummaryViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["invoiceSummaryDetails"])) {
                this.invoiceSummaryDetails = [] as any;
                for (let item of _data["invoiceSummaryDetails"])
                    this.invoiceSummaryDetails!.push(InvoiceSummaryDetailViewModel.fromJS(item));
            }
            else {
                this.invoiceSummaryDetails = null as any;
            }
        }
    }

    static override fromJS(data: any): InvoiceSummaryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceSummaryViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.invoiceSummaryDetails)) {
            data["invoiceSummaryDetails"] = [];
            for (let item of this.invoiceSummaryDetails)
                data["invoiceSummaryDetails"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): InvoiceSummaryViewModel {
        const json = this.toJSON();
        let result = new InvoiceSummaryViewModel();
        result.init(json);
        return result;
    }
}

export interface IInvoiceSummaryViewModel extends IInvoiceViewModel {
    invoiceSummaryDetails?: InvoiceSummaryDetailViewModel[] | null;
}

export class InvoiceSummaryDetailViewModel implements IInvoiceSummaryDetailViewModel {
    item?: string | null;
    qty?: number;
    rate?: number;
    total?: number;

    constructor(data?: IInvoiceSummaryDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item = _data["item"] !== undefined ? _data["item"] : null as any;
            this.qty = _data["qty"] !== undefined ? _data["qty"] : null as any;
            this.rate = _data["rate"] !== undefined ? _data["rate"] : null as any;
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static fromJS(data: any): InvoiceSummaryDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceSummaryDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item"] = this.item !== undefined ? this.item : null as any;
        data["qty"] = this.qty !== undefined ? this.qty : null as any;
        data["rate"] = this.rate !== undefined ? this.rate : null as any;
        data["total"] = this.total !== undefined ? this.total : null as any;
        return data;
    }

    clone(): InvoiceSummaryDetailViewModel {
        const json = this.toJSON();
        let result = new InvoiceSummaryDetailViewModel();
        result.init(json);
        return result;
    }
}

export interface IInvoiceSummaryDetailViewModel {
    item?: string | null;
    qty?: number;
    rate?: number;
    total?: number;
}

export class LicenseDetailsViewModel implements ILicenseDetailsViewModel {
    accountRequiresAnnualLicense?: boolean;
    accountId?: number;
    numberOfActiveUsers?: number;
    numberOfPurchasedLicenses?: number;
    billingPeriod?: DateRange | null;
    dueDate?: moment.Moment;
    numberOfNewLicenses?: number;
    totalCost?: number;

    constructor(data?: ILicenseDetailsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountRequiresAnnualLicense = _data["accountRequiresAnnualLicense"] !== undefined ? _data["accountRequiresAnnualLicense"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.numberOfActiveUsers = _data["numberOfActiveUsers"] !== undefined ? _data["numberOfActiveUsers"] : null as any;
            this.numberOfPurchasedLicenses = _data["numberOfPurchasedLicenses"] !== undefined ? _data["numberOfPurchasedLicenses"] : null as any;
            this.billingPeriod = _data["billingPeriod"] ? DateRange.fromJS(_data["billingPeriod"]) : null as any;
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : null as any;
            this.numberOfNewLicenses = _data["numberOfNewLicenses"] !== undefined ? _data["numberOfNewLicenses"] : null as any;
            this.totalCost = _data["totalCost"] !== undefined ? _data["totalCost"] : null as any;
        }
    }

    static fromJS(data: any): LicenseDetailsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseDetailsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountRequiresAnnualLicense"] = this.accountRequiresAnnualLicense !== undefined ? this.accountRequiresAnnualLicense : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["numberOfActiveUsers"] = this.numberOfActiveUsers !== undefined ? this.numberOfActiveUsers : null as any;
        data["numberOfPurchasedLicenses"] = this.numberOfPurchasedLicenses !== undefined ? this.numberOfPurchasedLicenses : null as any;
        data["billingPeriod"] = this.billingPeriod ? this.billingPeriod.toJSON() : null as any;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : null as any;
        data["numberOfNewLicenses"] = this.numberOfNewLicenses !== undefined ? this.numberOfNewLicenses : null as any;
        data["totalCost"] = this.totalCost !== undefined ? this.totalCost : null as any;
        return data;
    }

    clone(): LicenseDetailsViewModel {
        const json = this.toJSON();
        let result = new LicenseDetailsViewModel();
        result.init(json);
        return result;
    }
}

export interface ILicenseDetailsViewModel {
    accountRequiresAnnualLicense?: boolean;
    accountId?: number;
    numberOfActiveUsers?: number;
    numberOfPurchasedLicenses?: number;
    billingPeriod?: DateRange | null;
    dueDate?: moment.Moment;
    numberOfNewLicenses?: number;
    totalCost?: number;
}

export class LimitedAccountOverviewViewModel implements ILimitedAccountOverviewViewModel {
    imageUrl?: string | null;
    accountName?: string | null;
    accountNumber?: string | null;
    status?: number | null;
    fieldGroupType?: string | null;
    badgeFooterColor?: string | null;
    numberOfActiveReps?: number;
    supportEmail?: string | null;
    supportPhone?: string | null;
    primaryAdminName?: string | null;
    primaryAdminEmail?: string | null;
    certifications?: Certification2[] | null;
    tags?: Tag2[] | null;
    dontPrintBadge?: boolean;
    activities?: Activity2[] | null;

    constructor(data?: ILimitedAccountOverviewViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : null as any;
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.fieldGroupType = _data["fieldGroupType"] !== undefined ? _data["fieldGroupType"] : null as any;
            this.badgeFooterColor = _data["badgeFooterColor"] !== undefined ? _data["badgeFooterColor"] : null as any;
            this.numberOfActiveReps = _data["numberOfActiveReps"] !== undefined ? _data["numberOfActiveReps"] : null as any;
            this.supportEmail = _data["supportEmail"] !== undefined ? _data["supportEmail"] : null as any;
            this.supportPhone = _data["supportPhone"] !== undefined ? _data["supportPhone"] : null as any;
            this.primaryAdminName = _data["primaryAdminName"] !== undefined ? _data["primaryAdminName"] : null as any;
            this.primaryAdminEmail = _data["primaryAdminEmail"] !== undefined ? _data["primaryAdminEmail"] : null as any;
            if (Array.isArray(_data["certifications"])) {
                this.certifications = [] as any;
                for (let item of _data["certifications"])
                    this.certifications!.push(Certification2.fromJS(item));
            }
            else {
                this.certifications = null as any;
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(Tag2.fromJS(item));
            }
            else {
                this.tags = null as any;
            }
            this.dontPrintBadge = _data["dontPrintBadge"] !== undefined ? _data["dontPrintBadge"] : null as any;
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(Activity2.fromJS(item));
            }
            else {
                this.activities = null as any;
            }
        }
    }

    static fromJS(data: any): LimitedAccountOverviewViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedAccountOverviewViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : null as any;
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["fieldGroupType"] = this.fieldGroupType !== undefined ? this.fieldGroupType : null as any;
        data["badgeFooterColor"] = this.badgeFooterColor !== undefined ? this.badgeFooterColor : null as any;
        data["numberOfActiveReps"] = this.numberOfActiveReps !== undefined ? this.numberOfActiveReps : null as any;
        data["supportEmail"] = this.supportEmail !== undefined ? this.supportEmail : null as any;
        data["supportPhone"] = this.supportPhone !== undefined ? this.supportPhone : null as any;
        data["primaryAdminName"] = this.primaryAdminName !== undefined ? this.primaryAdminName : null as any;
        data["primaryAdminEmail"] = this.primaryAdminEmail !== undefined ? this.primaryAdminEmail : null as any;
        if (Array.isArray(this.certifications)) {
            data["certifications"] = [];
            for (let item of this.certifications)
                data["certifications"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : null as any);
        }
        data["dontPrintBadge"] = this.dontPrintBadge !== undefined ? this.dontPrintBadge : null as any;
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): LimitedAccountOverviewViewModel {
        const json = this.toJSON();
        let result = new LimitedAccountOverviewViewModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedAccountOverviewViewModel {
    imageUrl?: string | null;
    accountName?: string | null;
    accountNumber?: string | null;
    status?: number | null;
    fieldGroupType?: string | null;
    badgeFooterColor?: string | null;
    numberOfActiveReps?: number;
    supportEmail?: string | null;
    supportPhone?: string | null;
    primaryAdminName?: string | null;
    primaryAdminEmail?: string | null;
    certifications?: Certification2[] | null;
    tags?: Tag2[] | null;
    dontPrintBadge?: boolean;
    activities?: Activity2[] | null;
}

export class Certification2 implements ICertification2 {
    name?: string | null;
    description?: string | null;

    constructor(data?: ICertification2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
        }
    }

    static fromJS(data: any): Certification2 {
        data = typeof data === 'object' ? data : {};
        let result = new Certification2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        return data;
    }

    clone(): Certification2 {
        const json = this.toJSON();
        let result = new Certification2();
        result.init(json);
        return result;
    }
}

export interface ICertification2 {
    name?: string | null;
    description?: string | null;
}

export class Tag2 implements ITag2 {
    name?: string | null;
    colorClass?: string | null;
    description?: string | null;

    constructor(data?: ITag2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.colorClass = _data["colorClass"] !== undefined ? _data["colorClass"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
        }
    }

    static fromJS(data: any): Tag2 {
        data = typeof data === 'object' ? data : {};
        let result = new Tag2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["colorClass"] = this.colorClass !== undefined ? this.colorClass : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        return data;
    }

    clone(): Tag2 {
        const json = this.toJSON();
        let result = new Tag2();
        result.init(json);
        return result;
    }
}

export interface ITag2 {
    name?: string | null;
    colorClass?: string | null;
    description?: string | null;
}

export class Activity2 implements IActivity2 {
    name?: string | null;
    description?: string | null;

    constructor(data?: IActivity2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
        }
    }

    static fromJS(data: any): Activity2 {
        data = typeof data === 'object' ? data : {};
        let result = new Activity2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        return data;
    }

    clone(): Activity2 {
        const json = this.toJSON();
        let result = new Activity2();
        result.init(json);
        return result;
    }
}

export interface IActivity2 {
    name?: string | null;
    description?: string | null;
}

export class ApiErrorOfRequestTokenParameters implements IApiErrorOfRequestTokenParameters {
    errorKey?: RequestTokenParameters | null;

    constructor(data?: IApiErrorOfRequestTokenParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorKey = _data["errorKey"] ? RequestTokenParameters.fromJS(_data["errorKey"]) : null as any;
        }
    }

    static fromJS(data: any): ApiErrorOfRequestTokenParameters {
        data = typeof data === 'object' ? data : {};
        let result = new ApiErrorOfRequestTokenParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorKey"] = this.errorKey ? this.errorKey.toJSON() : null as any;
        return data;
    }

    clone(): ApiErrorOfRequestTokenParameters {
        const json = this.toJSON();
        let result = new ApiErrorOfRequestTokenParameters();
        result.init(json);
        return result;
    }
}

export interface IApiErrorOfRequestTokenParameters {
    errorKey?: RequestTokenParameters | null;
}

export class RequestTokenParameters implements IRequestTokenParameters {
    emailOrMobile?: string | null;
    password?: string | null;

    constructor(data?: IRequestTokenParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailOrMobile = _data["emailOrMobile"] !== undefined ? _data["emailOrMobile"] : null as any;
            this.password = _data["password"] !== undefined ? _data["password"] : null as any;
        }
    }

    static fromJS(data: any): RequestTokenParameters {
        data = typeof data === 'object' ? data : {};
        let result = new RequestTokenParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailOrMobile"] = this.emailOrMobile !== undefined ? this.emailOrMobile : null as any;
        data["password"] = this.password !== undefined ? this.password : null as any;
        return data;
    }

    clone(): RequestTokenParameters {
        const json = this.toJSON();
        let result = new RequestTokenParameters();
        result.init(json);
        return result;
    }
}

export interface IRequestTokenParameters {
    emailOrMobile?: string | null;
    password?: string | null;
}

export class OnBoardingViewModel implements IOnBoardingViewModel {
    isEulaAgreed?: boolean;
    isPhotoUploaded?: boolean;
    isCertificationCompleted?: boolean;
    isPhotoDenied?: boolean;

    constructor(data?: IOnBoardingViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEulaAgreed = _data["isEulaAgreed"] !== undefined ? _data["isEulaAgreed"] : null as any;
            this.isPhotoUploaded = _data["isPhotoUploaded"] !== undefined ? _data["isPhotoUploaded"] : null as any;
            this.isCertificationCompleted = _data["isCertificationCompleted"] !== undefined ? _data["isCertificationCompleted"] : null as any;
            this.isPhotoDenied = _data["isPhotoDenied"] !== undefined ? _data["isPhotoDenied"] : null as any;
        }
    }

    static fromJS(data: any): OnBoardingViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OnBoardingViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEulaAgreed"] = this.isEulaAgreed !== undefined ? this.isEulaAgreed : null as any;
        data["isPhotoUploaded"] = this.isPhotoUploaded !== undefined ? this.isPhotoUploaded : null as any;
        data["isCertificationCompleted"] = this.isCertificationCompleted !== undefined ? this.isCertificationCompleted : null as any;
        data["isPhotoDenied"] = this.isPhotoDenied !== undefined ? this.isPhotoDenied : null as any;
        return data;
    }

    clone(): OnBoardingViewModel {
        const json = this.toJSON();
        let result = new OnBoardingViewModel();
        result.init(json);
        return result;
    }
}

export interface IOnBoardingViewModel {
    isEulaAgreed?: boolean;
    isPhotoUploaded?: boolean;
    isCertificationCompleted?: boolean;
    isPhotoDenied?: boolean;
}

export class PersonBadgeModel implements IPersonBadgeModel {
    accountId?: number;
    accountAbbreviatedName?: string | null;
    accountName?: string | null;
    personId?: number;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    approvalStatus?: number | null;
    pImageUrl?: string | null;
    pImageUrlOriginal?: string | null;
    badgePrintedDate?: moment.Moment | null;
    letterPrintedDate?: moment.Moment | null;

    constructor(data?: IPersonBadgeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.accountAbbreviatedName = _data["accountAbbreviatedName"] !== undefined ? _data["accountAbbreviatedName"] : null as any;
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.approvalStatus = _data["approvalStatus"] !== undefined ? _data["approvalStatus"] : null as any;
            this.pImageUrl = _data["pImageUrl"] !== undefined ? _data["pImageUrl"] : null as any;
            this.pImageUrlOriginal = _data["pImageUrlOriginal"] !== undefined ? _data["pImageUrlOriginal"] : null as any;
            this.badgePrintedDate = _data["badgePrintedDate"] ? moment(_data["badgePrintedDate"].toString()) : null as any;
            this.letterPrintedDate = _data["letterPrintedDate"] ? moment(_data["letterPrintedDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): PersonBadgeModel {
        data = typeof data === 'object' ? data : {};
        let result = new PersonBadgeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["accountAbbreviatedName"] = this.accountAbbreviatedName !== undefined ? this.accountAbbreviatedName : null as any;
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["personId"] = this.personId !== undefined ? this.personId : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["approvalStatus"] = this.approvalStatus !== undefined ? this.approvalStatus : null as any;
        data["pImageUrl"] = this.pImageUrl !== undefined ? this.pImageUrl : null as any;
        data["pImageUrlOriginal"] = this.pImageUrlOriginal !== undefined ? this.pImageUrlOriginal : null as any;
        data["badgePrintedDate"] = this.badgePrintedDate ? this.badgePrintedDate.toISOString() : null as any;
        data["letterPrintedDate"] = this.letterPrintedDate ? this.letterPrintedDate.toISOString() : null as any;
        return data;
    }

    clone(): PersonBadgeModel {
        const json = this.toJSON();
        let result = new PersonBadgeModel();
        result.init(json);
        return result;
    }
}

export interface IPersonBadgeModel {
    accountId?: number;
    accountAbbreviatedName?: string | null;
    accountName?: string | null;
    personId?: number;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    approvalStatus?: number | null;
    pImageUrl?: string | null;
    pImageUrlOriginal?: string | null;
    badgePrintedDate?: moment.Moment | null;
    letterPrintedDate?: moment.Moment | null;
}

export class AccountBadgeCountModel implements IAccountBadgeCountModel {
    accountId?: number;
    name?: string | null;
    count?: number;

    constructor(data?: IAccountBadgeCountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
        }
    }

    static fromJS(data: any): AccountBadgeCountModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountBadgeCountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["count"] = this.count !== undefined ? this.count : null as any;
        return data;
    }

    clone(): AccountBadgeCountModel {
        const json = this.toJSON();
        let result = new AccountBadgeCountModel();
        result.init(json);
        return result;
    }
}

export interface IAccountBadgeCountModel {
    accountId?: number;
    name?: string | null;
    count?: number;
}

export class DenyBadgeRequest implements IDenyBadgeRequest {
    personId?: number;
    photoDenialReasonIds?: number[] | null;

    constructor(data?: IDenyBadgeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null as any;
            if (Array.isArray(_data["photoDenialReasonIds"])) {
                this.photoDenialReasonIds = [] as any;
                for (let item of _data["photoDenialReasonIds"])
                    this.photoDenialReasonIds!.push(item);
            }
            else {
                this.photoDenialReasonIds = null as any;
            }
        }
    }

    static fromJS(data: any): DenyBadgeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DenyBadgeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId !== undefined ? this.personId : null as any;
        if (Array.isArray(this.photoDenialReasonIds)) {
            data["photoDenialReasonIds"] = [];
            for (let item of this.photoDenialReasonIds)
                data["photoDenialReasonIds"].push(item);
        }
        return data;
    }

    clone(): DenyBadgeRequest {
        const json = this.toJSON();
        let result = new DenyBadgeRequest();
        result.init(json);
        return result;
    }
}

export interface IDenyBadgeRequest {
    personId?: number;
    photoDenialReasonIds?: number[] | null;
}

export class ApiErrorOfString implements IApiErrorOfString {
    errorKey?: string | null;

    constructor(data?: IApiErrorOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorKey = _data["errorKey"] !== undefined ? _data["errorKey"] : null as any;
        }
    }

    static fromJS(data: any): ApiErrorOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ApiErrorOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorKey"] = this.errorKey !== undefined ? this.errorKey : null as any;
        return data;
    }

    clone(): ApiErrorOfString {
        const json = this.toJSON();
        let result = new ApiErrorOfString();
        result.init(json);
        return result;
    }
}

export interface IApiErrorOfString {
    errorKey?: string | null;
}

export class UpsertUserResponse implements IUpsertUserResponse {
    personId?: number;
    firstName?: string | null;
    lastName?: string | null;
    errors?: string[] | null;

    constructor(data?: IUpsertUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            else {
                this.errors = null as any;
            }
        }
    }

    static fromJS(data: any): UpsertUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId !== undefined ? this.personId : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }

    clone(): UpsertUserResponse {
        const json = this.toJSON();
        let result = new UpsertUserResponse();
        result.init(json);
        return result;
    }
}

export interface IUpsertUserResponse {
    personId?: number;
    firstName?: string | null;
    lastName?: string | null;
    errors?: string[] | null;
}

export class SavePersonModel implements ISavePersonModel {
    personId?: number | null;
    status?: StatusTypes;
    role?: number;
    accountId?: number;
    employeeNumber?: string | null;
    nickname?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    phone?: string | null;
    mobile?: string | null;
    title?: string | null;
    department?: string | null;
    tags?: string[] | null;
    certifications?: string[] | null;
    userAuditSource?: UserAuditChangeSource;
    userName?: string | null;

    constructor(data?: ISavePersonModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.role = _data["role"] !== undefined ? _data["role"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.employeeNumber = _data["employeeNumber"] !== undefined ? _data["employeeNumber"] : null as any;
            this.nickname = _data["nickname"] !== undefined ? _data["nickname"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : null as any;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.mobile = _data["mobile"] !== undefined ? _data["mobile"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.department = _data["department"] !== undefined ? _data["department"] : null as any;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            else {
                this.tags = null as any;
            }
            if (Array.isArray(_data["certifications"])) {
                this.certifications = [] as any;
                for (let item of _data["certifications"])
                    this.certifications!.push(item);
            }
            else {
                this.certifications = null as any;
            }
            this.userAuditSource = _data["userAuditSource"] !== undefined ? _data["userAuditSource"] : null as any;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null as any;
        }
    }

    static fromJS(data: any): SavePersonModel {
        data = typeof data === 'object' ? data : {};
        let result = new SavePersonModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId !== undefined ? this.personId : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["role"] = this.role !== undefined ? this.role : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["employeeNumber"] = this.employeeNumber !== undefined ? this.employeeNumber : null as any;
        data["nickname"] = this.nickname !== undefined ? this.nickname : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["address1"] = this.address1 !== undefined ? this.address1 : null as any;
        data["address2"] = this.address2 !== undefined ? this.address2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["mobile"] = this.mobile !== undefined ? this.mobile : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["department"] = this.department !== undefined ? this.department : null as any;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (Array.isArray(this.certifications)) {
            data["certifications"] = [];
            for (let item of this.certifications)
                data["certifications"].push(item);
        }
        data["userAuditSource"] = this.userAuditSource !== undefined ? this.userAuditSource : null as any;
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        return data;
    }

    clone(): SavePersonModel {
        const json = this.toJSON();
        let result = new SavePersonModel();
        result.init(json);
        return result;
    }
}

export interface ISavePersonModel {
    personId?: number | null;
    status?: StatusTypes;
    role?: number;
    accountId?: number;
    employeeNumber?: string | null;
    nickname?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    phone?: string | null;
    mobile?: string | null;
    title?: string | null;
    department?: string | null;
    tags?: string[] | null;
    certifications?: string[] | null;
    userAuditSource?: UserAuditChangeSource;
    userName?: string | null;
}

export enum UserAuditChangeSource {
    Other = "other",
    CreateUser = "createUser",
    UserDetail = "userDetail",
    BulkImport = "bulkImport",
    ProviderApiImportUser = "providerApiImportUser",
    ProviderApiUpdateUser = "providerApiUpdateUser",
    UserAccountTransfer = "userAccountTransfer",
    SSOLogin = "ssoLogin",
    POSAccess = "posAccess",
    UserAccessReview = "userAccessReview",
    Lms = "lms",
}

export class UserListItem implements IUserListItem {
    id?: string | null;
    number?: string | null;
    badgeNumber?: string | null;
    firstName?: string | null;
    nickName?: string | null;
    lastName?: string | null;
    email?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    phone?: string | null;
    mobile?: string | null;
    accountName?: string | null;
    accountId?: number;
    roleName?: string | null;
    rolesId?: number;
    imageUrl?: string | null;
    status?: StatusTypes;
    certificationStatus?: CertificationStatus;
    badgeStatus?: BadgeApprovalStatus;
    title?: string | null;
    personId?: number;
    userName?: string | null;

    constructor(data?: IUserListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.number = _data["number"] !== undefined ? _data["number"] : null as any;
            this.badgeNumber = _data["badgeNumber"] !== undefined ? _data["badgeNumber"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.nickName = _data["nickName"] !== undefined ? _data["nickName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : null as any;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.mobile = _data["mobile"] !== undefined ? _data["mobile"] : null as any;
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.roleName = _data["roleName"] !== undefined ? _data["roleName"] : null as any;
            this.rolesId = _data["rolesId"] !== undefined ? _data["rolesId"] : null as any;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.certificationStatus = _data["certificationStatus"] !== undefined ? _data["certificationStatus"] : null as any;
            this.badgeStatus = _data["badgeStatus"] !== undefined ? _data["badgeStatus"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null as any;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null as any;
        }
    }

    static fromJS(data: any): UserListItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["number"] = this.number !== undefined ? this.number : null as any;
        data["badgeNumber"] = this.badgeNumber !== undefined ? this.badgeNumber : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["nickName"] = this.nickName !== undefined ? this.nickName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["address1"] = this.address1 !== undefined ? this.address1 : null as any;
        data["address2"] = this.address2 !== undefined ? this.address2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["mobile"] = this.mobile !== undefined ? this.mobile : null as any;
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["roleName"] = this.roleName !== undefined ? this.roleName : null as any;
        data["rolesId"] = this.rolesId !== undefined ? this.rolesId : null as any;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["certificationStatus"] = this.certificationStatus !== undefined ? this.certificationStatus : null as any;
        data["badgeStatus"] = this.badgeStatus !== undefined ? this.badgeStatus : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["personId"] = this.personId !== undefined ? this.personId : null as any;
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        return data;
    }

    clone(): UserListItem {
        const json = this.toJSON();
        let result = new UserListItem();
        result.init(json);
        return result;
    }
}

export interface IUserListItem {
    id?: string | null;
    number?: string | null;
    badgeNumber?: string | null;
    firstName?: string | null;
    nickName?: string | null;
    lastName?: string | null;
    email?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    phone?: string | null;
    mobile?: string | null;
    accountName?: string | null;
    accountId?: number;
    roleName?: string | null;
    rolesId?: number;
    imageUrl?: string | null;
    status?: StatusTypes;
    certificationStatus?: CertificationStatus;
    badgeStatus?: BadgeApprovalStatus;
    title?: string | null;
    personId?: number;
    userName?: string | null;
}

export class UserDetail extends UserListItem implements IUserDetail {
    storeVisits?: StoreVisited[] | null;
    lastVisit?: moment.Moment | null;
    timeInStore?: number;
    courses?: Course2[] | null;
    accountLogoUrl?: string | null;
    department?: string | null;
    operatorName?: string | null;
    isBlocked?: boolean;
    blockedReason?: string | null;
    howToResolveBlockedUser?: string | null;
    tags?: Tag3[] | null;
    reservedTagsAssociatedToAccount?: Tag3[] | null;
    dateCreated?: moment.Moment;
    coursesCompleted?: number;
    readEula?: moment.Moment | null;
    shipDirectToRep?: boolean;
    imageUrlOriginal?: string | null;
    syncId?: string;
    letterPrintedDate?: moment.Moment | null;
    badgePrintedDate?: moment.Moment | null;
    isNoPrint?: boolean;
    badgeShippingAddress?: BadgeShipping | null;
    manager?: ManagerModel | null;
    isTwoFactorAuthEnabledForUser?: boolean;

    constructor(data?: IUserDetail) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["storeVisits"])) {
                this.storeVisits = [] as any;
                for (let item of _data["storeVisits"])
                    this.storeVisits!.push(StoreVisited.fromJS(item));
            }
            else {
                this.storeVisits = null as any;
            }
            this.lastVisit = _data["lastVisit"] ? moment(_data["lastVisit"].toString()) : null as any;
            this.timeInStore = _data["timeInStore"] !== undefined ? _data["timeInStore"] : null as any;
            if (Array.isArray(_data["courses"])) {
                this.courses = [] as any;
                for (let item of _data["courses"])
                    this.courses!.push(Course2.fromJS(item));
            }
            else {
                this.courses = null as any;
            }
            this.accountLogoUrl = _data["accountLogoUrl"] !== undefined ? _data["accountLogoUrl"] : null as any;
            this.department = _data["department"] !== undefined ? _data["department"] : null as any;
            this.operatorName = _data["operatorName"] !== undefined ? _data["operatorName"] : null as any;
            this.isBlocked = _data["isBlocked"] !== undefined ? _data["isBlocked"] : null as any;
            this.blockedReason = _data["blockedReason"] !== undefined ? _data["blockedReason"] : null as any;
            this.howToResolveBlockedUser = _data["howToResolveBlockedUser"] !== undefined ? _data["howToResolveBlockedUser"] : null as any;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(Tag3.fromJS(item));
            }
            else {
                this.tags = null as any;
            }
            if (Array.isArray(_data["reservedTagsAssociatedToAccount"])) {
                this.reservedTagsAssociatedToAccount = [] as any;
                for (let item of _data["reservedTagsAssociatedToAccount"])
                    this.reservedTagsAssociatedToAccount!.push(Tag3.fromJS(item));
            }
            else {
                this.reservedTagsAssociatedToAccount = null as any;
            }
            this.dateCreated = _data["dateCreated"] ? moment(_data["dateCreated"].toString()) : null as any;
            this.coursesCompleted = _data["coursesCompleted"] !== undefined ? _data["coursesCompleted"] : null as any;
            this.readEula = _data["readEula"] ? moment(_data["readEula"].toString()) : null as any;
            this.shipDirectToRep = _data["shipDirectToRep"] !== undefined ? _data["shipDirectToRep"] : null as any;
            this.imageUrlOriginal = _data["imageUrlOriginal"] !== undefined ? _data["imageUrlOriginal"] : null as any;
            this.syncId = _data["syncId"] !== undefined ? _data["syncId"] : null as any;
            this.letterPrintedDate = _data["letterPrintedDate"] ? moment(_data["letterPrintedDate"].toString()) : null as any;
            this.badgePrintedDate = _data["badgePrintedDate"] ? moment(_data["badgePrintedDate"].toString()) : null as any;
            this.isNoPrint = _data["isNoPrint"] !== undefined ? _data["isNoPrint"] : null as any;
            this.badgeShippingAddress = _data["badgeShippingAddress"] ? BadgeShipping.fromJS(_data["badgeShippingAddress"]) : null as any;
            this.manager = _data["manager"] ? ManagerModel.fromJS(_data["manager"]) : null as any;
            this.isTwoFactorAuthEnabledForUser = _data["isTwoFactorAuthEnabledForUser"] !== undefined ? _data["isTwoFactorAuthEnabledForUser"] : null as any;
        }
    }

    static override fromJS(data: any): UserDetail {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetail();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.storeVisits)) {
            data["storeVisits"] = [];
            for (let item of this.storeVisits)
                data["storeVisits"].push(item ? item.toJSON() : null as any);
        }
        data["lastVisit"] = this.lastVisit ? this.lastVisit.toISOString() : null as any;
        data["timeInStore"] = this.timeInStore !== undefined ? this.timeInStore : null as any;
        if (Array.isArray(this.courses)) {
            data["courses"] = [];
            for (let item of this.courses)
                data["courses"].push(item ? item.toJSON() : null as any);
        }
        data["accountLogoUrl"] = this.accountLogoUrl !== undefined ? this.accountLogoUrl : null as any;
        data["department"] = this.department !== undefined ? this.department : null as any;
        data["operatorName"] = this.operatorName !== undefined ? this.operatorName : null as any;
        data["isBlocked"] = this.isBlocked !== undefined ? this.isBlocked : null as any;
        data["blockedReason"] = this.blockedReason !== undefined ? this.blockedReason : null as any;
        data["howToResolveBlockedUser"] = this.howToResolveBlockedUser !== undefined ? this.howToResolveBlockedUser : null as any;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.reservedTagsAssociatedToAccount)) {
            data["reservedTagsAssociatedToAccount"] = [];
            for (let item of this.reservedTagsAssociatedToAccount)
                data["reservedTagsAssociatedToAccount"].push(item ? item.toJSON() : null as any);
        }
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : null as any;
        data["coursesCompleted"] = this.coursesCompleted !== undefined ? this.coursesCompleted : null as any;
        data["readEula"] = this.readEula ? this.readEula.toISOString() : null as any;
        data["shipDirectToRep"] = this.shipDirectToRep !== undefined ? this.shipDirectToRep : null as any;
        data["imageUrlOriginal"] = this.imageUrlOriginal !== undefined ? this.imageUrlOriginal : null as any;
        data["syncId"] = this.syncId !== undefined ? this.syncId : null as any;
        data["letterPrintedDate"] = this.letterPrintedDate ? this.letterPrintedDate.toISOString() : null as any;
        data["badgePrintedDate"] = this.badgePrintedDate ? this.badgePrintedDate.toISOString() : null as any;
        data["isNoPrint"] = this.isNoPrint !== undefined ? this.isNoPrint : null as any;
        data["badgeShippingAddress"] = this.badgeShippingAddress ? this.badgeShippingAddress.toJSON() : null as any;
        data["manager"] = this.manager ? this.manager.toJSON() : null as any;
        data["isTwoFactorAuthEnabledForUser"] = this.isTwoFactorAuthEnabledForUser !== undefined ? this.isTwoFactorAuthEnabledForUser : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): UserDetail {
        const json = this.toJSON();
        let result = new UserDetail();
        result.init(json);
        return result;
    }
}

export interface IUserDetail extends IUserListItem {
    storeVisits?: StoreVisited[] | null;
    lastVisit?: moment.Moment | null;
    timeInStore?: number;
    courses?: Course2[] | null;
    accountLogoUrl?: string | null;
    department?: string | null;
    operatorName?: string | null;
    isBlocked?: boolean;
    blockedReason?: string | null;
    howToResolveBlockedUser?: string | null;
    tags?: Tag3[] | null;
    reservedTagsAssociatedToAccount?: Tag3[] | null;
    dateCreated?: moment.Moment;
    coursesCompleted?: number;
    readEula?: moment.Moment | null;
    shipDirectToRep?: boolean;
    imageUrlOriginal?: string | null;
    syncId?: string;
    letterPrintedDate?: moment.Moment | null;
    badgePrintedDate?: moment.Moment | null;
    isNoPrint?: boolean;
    badgeShippingAddress?: BadgeShipping | null;
    manager?: ManagerModel | null;
    isTwoFactorAuthEnabledForUser?: boolean;
}

export class StoreVisited implements IStoreVisited {
    locationNumber?: string | null;
    minutesSpent?: number;
    timeIn?: moment.Moment | null;
    timeOut?: moment.Moment | null;
    signInLat?: number | null;
    signInLong?: number | null;
    signOutLat?: number | null;
    signOutLong?: number | null;
    storeLat?: number | null;
    storeLong?: number | null;
    distCheckIn?: number | null;
    distCheckOut?: number | null;

    constructor(data?: IStoreVisited) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationNumber = _data["locationNumber"] !== undefined ? _data["locationNumber"] : null as any;
            this.minutesSpent = _data["minutesSpent"] !== undefined ? _data["minutesSpent"] : null as any;
            this.timeIn = _data["timeIn"] ? moment(_data["timeIn"].toString()) : null as any;
            this.timeOut = _data["timeOut"] ? moment(_data["timeOut"].toString()) : null as any;
            this.signInLat = _data["signInLat"] !== undefined ? _data["signInLat"] : null as any;
            this.signInLong = _data["signInLong"] !== undefined ? _data["signInLong"] : null as any;
            this.signOutLat = _data["signOutLat"] !== undefined ? _data["signOutLat"] : null as any;
            this.signOutLong = _data["signOutLong"] !== undefined ? _data["signOutLong"] : null as any;
            this.storeLat = _data["storeLat"] !== undefined ? _data["storeLat"] : null as any;
            this.storeLong = _data["storeLong"] !== undefined ? _data["storeLong"] : null as any;
            this.distCheckIn = _data["distCheckIn"] !== undefined ? _data["distCheckIn"] : null as any;
            this.distCheckOut = _data["distCheckOut"] !== undefined ? _data["distCheckOut"] : null as any;
        }
    }

    static fromJS(data: any): StoreVisited {
        data = typeof data === 'object' ? data : {};
        let result = new StoreVisited();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationNumber"] = this.locationNumber !== undefined ? this.locationNumber : null as any;
        data["minutesSpent"] = this.minutesSpent !== undefined ? this.minutesSpent : null as any;
        data["timeIn"] = this.timeIn ? this.timeIn.toISOString() : null as any;
        data["timeOut"] = this.timeOut ? this.timeOut.toISOString() : null as any;
        data["signInLat"] = this.signInLat !== undefined ? this.signInLat : null as any;
        data["signInLong"] = this.signInLong !== undefined ? this.signInLong : null as any;
        data["signOutLat"] = this.signOutLat !== undefined ? this.signOutLat : null as any;
        data["signOutLong"] = this.signOutLong !== undefined ? this.signOutLong : null as any;
        data["storeLat"] = this.storeLat !== undefined ? this.storeLat : null as any;
        data["storeLong"] = this.storeLong !== undefined ? this.storeLong : null as any;
        data["distCheckIn"] = this.distCheckIn !== undefined ? this.distCheckIn : null as any;
        data["distCheckOut"] = this.distCheckOut !== undefined ? this.distCheckOut : null as any;
        return data;
    }

    clone(): StoreVisited {
        const json = this.toJSON();
        let result = new StoreVisited();
        result.init(json);
        return result;
    }
}

export interface IStoreVisited {
    locationNumber?: string | null;
    minutesSpent?: number;
    timeIn?: moment.Moment | null;
    timeOut?: moment.Moment | null;
    signInLat?: number | null;
    signInLong?: number | null;
    signOutLat?: number | null;
    signOutLong?: number | null;
    storeLat?: number | null;
    storeLong?: number | null;
    distCheckIn?: number | null;
    distCheckOut?: number | null;
}

export class Course2 implements ICourse2 {
    courseId?: number;
    courseName?: string | null;
    courseNote?: string | null;
    trainingLength?: string | null;
    success?: string | null;
    dateCreated?: moment.Moment | null;

    constructor(data?: ICourse2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"] !== undefined ? _data["courseId"] : null as any;
            this.courseName = _data["courseName"] !== undefined ? _data["courseName"] : null as any;
            this.courseNote = _data["courseNote"] !== undefined ? _data["courseNote"] : null as any;
            this.trainingLength = _data["trainingLength"] !== undefined ? _data["trainingLength"] : null as any;
            this.success = _data["success"] !== undefined ? _data["success"] : null as any;
            this.dateCreated = _data["dateCreated"] ? moment(_data["dateCreated"].toString()) : null as any;
        }
    }

    static fromJS(data: any): Course2 {
        data = typeof data === 'object' ? data : {};
        let result = new Course2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId !== undefined ? this.courseId : null as any;
        data["courseName"] = this.courseName !== undefined ? this.courseName : null as any;
        data["courseNote"] = this.courseNote !== undefined ? this.courseNote : null as any;
        data["trainingLength"] = this.trainingLength !== undefined ? this.trainingLength : null as any;
        data["success"] = this.success !== undefined ? this.success : null as any;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : null as any;
        return data;
    }

    clone(): Course2 {
        const json = this.toJSON();
        let result = new Course2();
        result.init(json);
        return result;
    }
}

export interface ICourse2 {
    courseId?: number;
    courseName?: string | null;
    courseNote?: string | null;
    trainingLength?: string | null;
    success?: string | null;
    dateCreated?: moment.Moment | null;
}

export class Tag3 implements ITag3 {
    id?: number;
    name?: string | null;
    nameTranslationKey?: string | null;
    descriptionTranslationKey?: string | null;
    skipBadgeScanning?: boolean;
    isSensitive?: boolean;
    exemptFromHourlyCharge?: boolean;
    colorClass?: string | null;
    isReserved?: boolean;

    constructor(data?: ITag3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.nameTranslationKey = _data["nameTranslationKey"] !== undefined ? _data["nameTranslationKey"] : null as any;
            this.descriptionTranslationKey = _data["descriptionTranslationKey"] !== undefined ? _data["descriptionTranslationKey"] : null as any;
            this.skipBadgeScanning = _data["skipBadgeScanning"] !== undefined ? _data["skipBadgeScanning"] : null as any;
            this.isSensitive = _data["isSensitive"] !== undefined ? _data["isSensitive"] : null as any;
            this.exemptFromHourlyCharge = _data["exemptFromHourlyCharge"] !== undefined ? _data["exemptFromHourlyCharge"] : null as any;
            this.colorClass = _data["colorClass"] !== undefined ? _data["colorClass"] : null as any;
            this.isReserved = _data["isReserved"] !== undefined ? _data["isReserved"] : null as any;
        }
    }

    static fromJS(data: any): Tag3 {
        data = typeof data === 'object' ? data : {};
        let result = new Tag3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["nameTranslationKey"] = this.nameTranslationKey !== undefined ? this.nameTranslationKey : null as any;
        data["descriptionTranslationKey"] = this.descriptionTranslationKey !== undefined ? this.descriptionTranslationKey : null as any;
        data["skipBadgeScanning"] = this.skipBadgeScanning !== undefined ? this.skipBadgeScanning : null as any;
        data["isSensitive"] = this.isSensitive !== undefined ? this.isSensitive : null as any;
        data["exemptFromHourlyCharge"] = this.exemptFromHourlyCharge !== undefined ? this.exemptFromHourlyCharge : null as any;
        data["colorClass"] = this.colorClass !== undefined ? this.colorClass : null as any;
        data["isReserved"] = this.isReserved !== undefined ? this.isReserved : null as any;
        return data;
    }

    clone(): Tag3 {
        const json = this.toJSON();
        let result = new Tag3();
        result.init(json);
        return result;
    }
}

export interface ITag3 {
    id?: number;
    name?: string | null;
    nameTranslationKey?: string | null;
    descriptionTranslationKey?: string | null;
    skipBadgeScanning?: boolean;
    isSensitive?: boolean;
    exemptFromHourlyCharge?: boolean;
    colorClass?: string | null;
    isReserved?: boolean;
}

export class BadgeShipping implements IBadgeShipping {
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;

    constructor(data?: IBadgeShipping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : null as any;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
        }
    }

    static fromJS(data: any): BadgeShipping {
        data = typeof data === 'object' ? data : {};
        let result = new BadgeShipping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address1"] = this.address1 !== undefined ? this.address1 : null as any;
        data["address2"] = this.address2 !== undefined ? this.address2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        return data;
    }

    clone(): BadgeShipping {
        const json = this.toJSON();
        let result = new BadgeShipping();
        result.init(json);
        return result;
    }
}

export interface IBadgeShipping {
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
}

export class ManagerModel implements IManagerModel {
    name?: string | null;
    employeeNumber?: string | null;
    phone?: string | null;
    email?: string | null;
    manager?: ManagerModel | null;

    constructor(data?: IManagerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.employeeNumber = _data["employeeNumber"] !== undefined ? _data["employeeNumber"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.manager = _data["manager"] ? ManagerModel.fromJS(_data["manager"]) : null as any;
        }
    }

    static fromJS(data: any): ManagerModel {
        data = typeof data === 'object' ? data : {};
        let result = new ManagerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["employeeNumber"] = this.employeeNumber !== undefined ? this.employeeNumber : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["manager"] = this.manager ? this.manager.toJSON() : null as any;
        return data;
    }

    clone(): ManagerModel {
        const json = this.toJSON();
        let result = new ManagerModel();
        result.init(json);
        return result;
    }
}

export interface IManagerModel {
    name?: string | null;
    employeeNumber?: string | null;
    phone?: string | null;
    email?: string | null;
    manager?: ManagerModel | null;
}

export enum BadgeApprovalStatus {
    NotUploaded = "notUploaded",
    Approved = "approved",
    Pending = "pending",
    Denied = "denied",
}

export class PrimaryAdminsViewModel implements IPrimaryAdminsViewModel {
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    personId?: number;

    constructor(data?: IPrimaryAdminsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null as any;
        }
    }

    static fromJS(data: any): PrimaryAdminsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PrimaryAdminsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["personId"] = this.personId !== undefined ? this.personId : null as any;
        return data;
    }

    clone(): PrimaryAdminsViewModel {
        const json = this.toJSON();
        let result = new PrimaryAdminsViewModel();
        result.init(json);
        return result;
    }
}

export interface IPrimaryAdminsViewModel {
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    personId?: number;
}

export class IncidentException implements IIncidentException {
    type?: string | null;
    title?: string | null;
    status?: number;
    detail?: string | null;
    instance?: string | null;
    o_errorCode?: string | null;

    constructor(data?: IIncidentException) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : null as any;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : null as any;
            this.o_errorCode = _data["o:errorCode"] !== undefined ? _data["o:errorCode"] : null as any;
        }
    }

    static fromJS(data: any): IncidentException {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentException();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["detail"] = this.detail !== undefined ? this.detail : null as any;
        data["instance"] = this.instance !== undefined ? this.instance : null as any;
        data["o:errorCode"] = this.o_errorCode !== undefined ? this.o_errorCode : null as any;
        return data;
    }

    clone(): IncidentException {
        const json = this.toJSON();
        let result = new IncidentException();
        result.init(json);
        return result;
    }
}

export interface IIncidentException {
    type?: string | null;
    title?: string | null;
    status?: number;
    detail?: string | null;
    instance?: string | null;
    o_errorCode?: string | null;
}

export class CropRectangle implements ICropRectangle {
    width?: number;
    height?: number;
    left?: number;
    top?: number;
    createDate?: moment.Moment | null;
    source?: string | null;

    constructor(data?: ICropRectangle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.width = _data["width"] !== undefined ? _data["width"] : null as any;
            this.height = _data["height"] !== undefined ? _data["height"] : null as any;
            this.left = _data["left"] !== undefined ? _data["left"] : null as any;
            this.top = _data["top"] !== undefined ? _data["top"] : null as any;
            this.createDate = _data["createDate"] ? moment(_data["createDate"].toString()) : null as any;
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
        }
    }

    static fromJS(data: any): CropRectangle {
        data = typeof data === 'object' ? data : {};
        let result = new CropRectangle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["width"] = this.width !== undefined ? this.width : null as any;
        data["height"] = this.height !== undefined ? this.height : null as any;
        data["left"] = this.left !== undefined ? this.left : null as any;
        data["top"] = this.top !== undefined ? this.top : null as any;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : null as any;
        data["source"] = this.source !== undefined ? this.source : null as any;
        return data;
    }

    clone(): CropRectangle {
        const json = this.toJSON();
        let result = new CropRectangle();
        result.init(json);
        return result;
    }
}

export interface ICropRectangle {
    width?: number;
    height?: number;
    left?: number;
    top?: number;
    createDate?: moment.Moment | null;
    source?: string | null;
}

export class BadgeImageMetadata implements IBadgeImageMetadata {
    name?: string | null;
    createDate?: moment.Moment | null;
    detectedFaces?: DetectedFace[] | null;
    cropRectangles?: CropRectangle[] | null;

    constructor(data?: IBadgeImageMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.createDate = _data["createDate"] ? moment(_data["createDate"].toString()) : null as any;
            if (Array.isArray(_data["detectedFaces"])) {
                this.detectedFaces = [] as any;
                for (let item of _data["detectedFaces"])
                    this.detectedFaces!.push(DetectedFace.fromJS(item));
            }
            else {
                this.detectedFaces = null as any;
            }
            if (Array.isArray(_data["cropRectangles"])) {
                this.cropRectangles = [] as any;
                for (let item of _data["cropRectangles"])
                    this.cropRectangles!.push(CropRectangle.fromJS(item));
            }
            else {
                this.cropRectangles = null as any;
            }
        }
    }

    static fromJS(data: any): BadgeImageMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new BadgeImageMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : null as any;
        if (Array.isArray(this.detectedFaces)) {
            data["detectedFaces"] = [];
            for (let item of this.detectedFaces)
                data["detectedFaces"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.cropRectangles)) {
            data["cropRectangles"] = [];
            for (let item of this.cropRectangles)
                data["cropRectangles"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): BadgeImageMetadata {
        const json = this.toJSON();
        let result = new BadgeImageMetadata();
        result.init(json);
        return result;
    }
}

export interface IBadgeImageMetadata {
    name?: string | null;
    createDate?: moment.Moment | null;
    detectedFaces?: DetectedFace[] | null;
    cropRectangles?: CropRectangle[] | null;
}

export class DetectedFace implements IDetectedFace {
    faceRectangle?: FaceRectangle | null;
    faceAttributes?: FaceAttributes | null;

    constructor(data?: IDetectedFace) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.faceRectangle = _data["faceRectangle"] ? FaceRectangle.fromJS(_data["faceRectangle"]) : null as any;
            this.faceAttributes = _data["faceAttributes"] ? FaceAttributes.fromJS(_data["faceAttributes"]) : null as any;
        }
    }

    static fromJS(data: any): DetectedFace {
        data = typeof data === 'object' ? data : {};
        let result = new DetectedFace();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["faceRectangle"] = this.faceRectangle ? this.faceRectangle.toJSON() : null as any;
        data["faceAttributes"] = this.faceAttributes ? this.faceAttributes.toJSON() : null as any;
        return data;
    }

    clone(): DetectedFace {
        const json = this.toJSON();
        let result = new DetectedFace();
        result.init(json);
        return result;
    }
}

export interface IDetectedFace {
    faceRectangle?: FaceRectangle | null;
    faceAttributes?: FaceAttributes | null;
}

export class FaceRectangle implements IFaceRectangle {
    width?: number | null;
    height?: number | null;
    left?: number | null;
    top?: number | null;

    constructor(data?: IFaceRectangle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.width = _data["width"] !== undefined ? _data["width"] : null as any;
            this.height = _data["height"] !== undefined ? _data["height"] : null as any;
            this.left = _data["left"] !== undefined ? _data["left"] : null as any;
            this.top = _data["top"] !== undefined ? _data["top"] : null as any;
        }
    }

    static fromJS(data: any): FaceRectangle {
        data = typeof data === 'object' ? data : {};
        let result = new FaceRectangle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["width"] = this.width !== undefined ? this.width : null as any;
        data["height"] = this.height !== undefined ? this.height : null as any;
        data["left"] = this.left !== undefined ? this.left : null as any;
        data["top"] = this.top !== undefined ? this.top : null as any;
        return data;
    }

    clone(): FaceRectangle {
        const json = this.toJSON();
        let result = new FaceRectangle();
        result.init(json);
        return result;
    }
}

export interface IFaceRectangle {
    width?: number | null;
    height?: number | null;
    left?: number | null;
    top?: number | null;
}

export class FaceAttributes implements IFaceAttributes {
    glasses?: string | null;
    accessories?: Accessory[] | null;
    blur?: Blur | null;
    exposure?: Exposure | null;

    constructor(data?: IFaceAttributes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.glasses = _data["glasses"] !== undefined ? _data["glasses"] : null as any;
            if (Array.isArray(_data["accessories"])) {
                this.accessories = [] as any;
                for (let item of _data["accessories"])
                    this.accessories!.push(Accessory.fromJS(item));
            }
            else {
                this.accessories = null as any;
            }
            this.blur = _data["blur"] ? Blur.fromJS(_data["blur"]) : null as any;
            this.exposure = _data["exposure"] ? Exposure.fromJS(_data["exposure"]) : null as any;
        }
    }

    static fromJS(data: any): FaceAttributes {
        data = typeof data === 'object' ? data : {};
        let result = new FaceAttributes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["glasses"] = this.glasses !== undefined ? this.glasses : null as any;
        if (Array.isArray(this.accessories)) {
            data["accessories"] = [];
            for (let item of this.accessories)
                data["accessories"].push(item ? item.toJSON() : null as any);
        }
        data["blur"] = this.blur ? this.blur.toJSON() : null as any;
        data["exposure"] = this.exposure ? this.exposure.toJSON() : null as any;
        return data;
    }

    clone(): FaceAttributes {
        const json = this.toJSON();
        let result = new FaceAttributes();
        result.init(json);
        return result;
    }
}

export interface IFaceAttributes {
    glasses?: string | null;
    accessories?: Accessory[] | null;
    blur?: Blur | null;
    exposure?: Exposure | null;
}

export class Accessory implements IAccessory {
    type?: string | null;
    confidence?: number | null;

    constructor(data?: IAccessory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.confidence = _data["confidence"] !== undefined ? _data["confidence"] : null as any;
        }
    }

    static fromJS(data: any): Accessory {
        data = typeof data === 'object' ? data : {};
        let result = new Accessory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["confidence"] = this.confidence !== undefined ? this.confidence : null as any;
        return data;
    }

    clone(): Accessory {
        const json = this.toJSON();
        let result = new Accessory();
        result.init(json);
        return result;
    }
}

export interface IAccessory {
    type?: string | null;
    confidence?: number | null;
}

export class Blur implements IBlur {
    blurLevel?: string | null;
    value?: number | null;

    constructor(data?: IBlur) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blurLevel = _data["blurLevel"] !== undefined ? _data["blurLevel"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
        }
    }

    static fromJS(data: any): Blur {
        data = typeof data === 'object' ? data : {};
        let result = new Blur();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blurLevel"] = this.blurLevel !== undefined ? this.blurLevel : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        return data;
    }

    clone(): Blur {
        const json = this.toJSON();
        let result = new Blur();
        result.init(json);
        return result;
    }
}

export interface IBlur {
    blurLevel?: string | null;
    value?: number | null;
}

export class Exposure implements IExposure {
    exposureLevel?: string | null;
    value?: number | null;

    constructor(data?: IExposure) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exposureLevel = _data["exposureLevel"] !== undefined ? _data["exposureLevel"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
        }
    }

    static fromJS(data: any): Exposure {
        data = typeof data === 'object' ? data : {};
        let result = new Exposure();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exposureLevel"] = this.exposureLevel !== undefined ? this.exposureLevel : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        return data;
    }

    clone(): Exposure {
        const json = this.toJSON();
        let result = new Exposure();
        result.init(json);
        return result;
    }
}

export interface IExposure {
    exposureLevel?: string | null;
    value?: number | null;
}

export class PhotoDenialReasonModel implements IPhotoDenialReasonModel {
    photoDenialReasonId?: number;
    note?: string | null;

    constructor(data?: IPhotoDenialReasonModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.photoDenialReasonId = _data["photoDenialReasonId"] !== undefined ? _data["photoDenialReasonId"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
        }
    }

    static fromJS(data: any): PhotoDenialReasonModel {
        data = typeof data === 'object' ? data : {};
        let result = new PhotoDenialReasonModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["photoDenialReasonId"] = this.photoDenialReasonId !== undefined ? this.photoDenialReasonId : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        return data;
    }

    clone(): PhotoDenialReasonModel {
        const json = this.toJSON();
        let result = new PhotoDenialReasonModel();
        result.init(json);
        return result;
    }
}

export interface IPhotoDenialReasonModel {
    photoDenialReasonId?: number;
    note?: string | null;
}

export class PosAccessReport implements IPosAccessReport {
    userData?: LimitedResultOfPosAccessUserReportData | null;
    posAccessUserCounts?: PosAccessUserCounts | null;

    constructor(data?: IPosAccessReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userData = _data["userData"] ? LimitedResultOfPosAccessUserReportData.fromJS(_data["userData"]) : null as any;
            this.posAccessUserCounts = _data["posAccessUserCounts"] ? PosAccessUserCounts.fromJS(_data["posAccessUserCounts"]) : null as any;
        }
    }

    static fromJS(data: any): PosAccessReport {
        data = typeof data === 'object' ? data : {};
        let result = new PosAccessReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userData"] = this.userData ? this.userData.toJSON() : null as any;
        data["posAccessUserCounts"] = this.posAccessUserCounts ? this.posAccessUserCounts.toJSON() : null as any;
        return data;
    }

    clone(): PosAccessReport {
        const json = this.toJSON();
        let result = new PosAccessReport();
        result.init(json);
        return result;
    }
}

export interface IPosAccessReport {
    userData?: LimitedResultOfPosAccessUserReportData | null;
    posAccessUserCounts?: PosAccessUserCounts | null;
}

export class LimitedResultOfPosAccessUserReportData implements ILimitedResultOfPosAccessUserReportData {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: PosAccessUserReportData[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfPosAccessUserReportData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PosAccessUserReportData.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfPosAccessUserReportData {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfPosAccessUserReportData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfPosAccessUserReportData {
        const json = this.toJSON();
        let result = new LimitedResultOfPosAccessUserReportData();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfPosAccessUserReportData {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: PosAccessUserReportData[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class PosAccessUserReportData implements IPosAccessUserReportData {
    accountName?: string | null;
    accountId?: number;
    employeeNumber?: string | null;
    userId?: string | null;
    name?: string | null;
    email?: string | null;
    operatorName?: string | null;
    localStoreTimeIn?: moment.Moment | null;
    timeInUtc?: moment.Moment | null;
    store?: string | null;
    dateCreated?: moment.Moment | null;
    badgeImageUrl?: string | null;

    constructor(data?: IPosAccessUserReportData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.employeeNumber = _data["employeeNumber"] !== undefined ? _data["employeeNumber"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.operatorName = _data["operatorName"] !== undefined ? _data["operatorName"] : null as any;
            this.localStoreTimeIn = _data["localStoreTimeIn"] ? moment(_data["localStoreTimeIn"].toString()) : null as any;
            this.timeInUtc = _data["timeInUtc"] ? moment(_data["timeInUtc"].toString()) : null as any;
            this.store = _data["store"] !== undefined ? _data["store"] : null as any;
            this.dateCreated = _data["dateCreated"] ? moment(_data["dateCreated"].toString()) : null as any;
            this.badgeImageUrl = _data["badgeImageUrl"] !== undefined ? _data["badgeImageUrl"] : null as any;
        }
    }

    static fromJS(data: any): PosAccessUserReportData {
        data = typeof data === 'object' ? data : {};
        let result = new PosAccessUserReportData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["employeeNumber"] = this.employeeNumber !== undefined ? this.employeeNumber : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["operatorName"] = this.operatorName !== undefined ? this.operatorName : null as any;
        data["localStoreTimeIn"] = this.localStoreTimeIn ? this.localStoreTimeIn.toISOString() : null as any;
        data["timeInUtc"] = this.timeInUtc ? this.timeInUtc.toISOString() : null as any;
        data["store"] = this.store !== undefined ? this.store : null as any;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : null as any;
        data["badgeImageUrl"] = this.badgeImageUrl !== undefined ? this.badgeImageUrl : null as any;
        return data;
    }

    clone(): PosAccessUserReportData {
        const json = this.toJSON();
        let result = new PosAccessUserReportData();
        result.init(json);
        return result;
    }
}

export interface IPosAccessUserReportData {
    accountName?: string | null;
    accountId?: number;
    employeeNumber?: string | null;
    userId?: string | null;
    name?: string | null;
    email?: string | null;
    operatorName?: string | null;
    localStoreTimeIn?: moment.Moment | null;
    timeInUtc?: moment.Moment | null;
    store?: string | null;
    dateCreated?: moment.Moment | null;
    badgeImageUrl?: string | null;
}

export class PosAccessUserCounts implements IPosAccessUserCounts {
    numberOfActiveUsers?: number;
    numberOfActiveUsersNotCheckedInSinceDate?: number;

    constructor(data?: IPosAccessUserCounts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfActiveUsers = _data["numberOfActiveUsers"] !== undefined ? _data["numberOfActiveUsers"] : null as any;
            this.numberOfActiveUsersNotCheckedInSinceDate = _data["numberOfActiveUsersNotCheckedInSinceDate"] !== undefined ? _data["numberOfActiveUsersNotCheckedInSinceDate"] : null as any;
        }
    }

    static fromJS(data: any): PosAccessUserCounts {
        data = typeof data === 'object' ? data : {};
        let result = new PosAccessUserCounts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfActiveUsers"] = this.numberOfActiveUsers !== undefined ? this.numberOfActiveUsers : null as any;
        data["numberOfActiveUsersNotCheckedInSinceDate"] = this.numberOfActiveUsersNotCheckedInSinceDate !== undefined ? this.numberOfActiveUsersNotCheckedInSinceDate : null as any;
        return data;
    }

    clone(): PosAccessUserCounts {
        const json = this.toJSON();
        let result = new PosAccessUserCounts();
        result.init(json);
        return result;
    }
}

export interface IPosAccessUserCounts {
    numberOfActiveUsers?: number;
    numberOfActiveUsersNotCheckedInSinceDate?: number;
}

export class RepsInStoreDetailsViewModel implements IRepsInStoreDetailsViewModel {
    retailerAccountName?: string | null;
    locationNumber?: string | null;
    fullName?: string | null;
    checkinLocal?: moment.Moment | null;
    personId?: number;

    constructor(data?: IRepsInStoreDetailsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.retailerAccountName = _data["retailerAccountName"] !== undefined ? _data["retailerAccountName"] : null as any;
            this.locationNumber = _data["locationNumber"] !== undefined ? _data["locationNumber"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.checkinLocal = _data["checkinLocal"] ? moment(_data["checkinLocal"].toString()) : null as any;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null as any;
        }
    }

    static fromJS(data: any): RepsInStoreDetailsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RepsInStoreDetailsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["retailerAccountName"] = this.retailerAccountName !== undefined ? this.retailerAccountName : null as any;
        data["locationNumber"] = this.locationNumber !== undefined ? this.locationNumber : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["checkinLocal"] = this.checkinLocal ? this.checkinLocal.toISOString() : null as any;
        data["personId"] = this.personId !== undefined ? this.personId : null as any;
        return data;
    }

    clone(): RepsInStoreDetailsViewModel {
        const json = this.toJSON();
        let result = new RepsInStoreDetailsViewModel();
        result.init(json);
        return result;
    }
}

export interface IRepsInStoreDetailsViewModel {
    retailerAccountName?: string | null;
    locationNumber?: string | null;
    fullName?: string | null;
    checkinLocal?: moment.Moment | null;
    personId?: number;
}

export class DailyVisitsSummary implements IDailyVisitsSummary {
    summaryDate?: moment.Moment;
    visitCount?: number;

    constructor(data?: IDailyVisitsSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summaryDate = _data["summaryDate"] ? moment(_data["summaryDate"].toString()) : null as any;
            this.visitCount = _data["visitCount"] !== undefined ? _data["visitCount"] : null as any;
        }
    }

    static fromJS(data: any): DailyVisitsSummary {
        data = typeof data === 'object' ? data : {};
        let result = new DailyVisitsSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summaryDate"] = this.summaryDate ? this.summaryDate.toISOString() : null as any;
        data["visitCount"] = this.visitCount !== undefined ? this.visitCount : null as any;
        return data;
    }

    clone(): DailyVisitsSummary {
        const json = this.toJSON();
        let result = new DailyVisitsSummary();
        result.init(json);
        return result;
    }
}

export interface IDailyVisitsSummary {
    summaryDate?: moment.Moment;
    visitCount?: number;
}

export class LimitedResultOfRealTimeCheckinReportItemViewModel implements ILimitedResultOfRealTimeCheckinReportItemViewModel {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: RealTimeCheckinReportItemViewModel[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfRealTimeCheckinReportItemViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(RealTimeCheckinReportItemViewModel.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfRealTimeCheckinReportItemViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfRealTimeCheckinReportItemViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfRealTimeCheckinReportItemViewModel {
        const json = this.toJSON();
        let result = new LimitedResultOfRealTimeCheckinReportItemViewModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfRealTimeCheckinReportItemViewModel {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: RealTimeCheckinReportItemViewModel[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class RealTimeCheckinReportLimitedResultsOfRealTimeCheckinReportItemViewModel extends LimitedResultOfRealTimeCheckinReportItemViewModel implements IRealTimeCheckinReportLimitedResultsOfRealTimeCheckinReportItemViewModel {
    reportSummary?: RealTimeCheckinReportSummaryViewModel | null;

    constructor(data?: IRealTimeCheckinReportLimitedResultsOfRealTimeCheckinReportItemViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.reportSummary = _data["reportSummary"] ? RealTimeCheckinReportSummaryViewModel.fromJS(_data["reportSummary"]) : null as any;
        }
    }

    static override fromJS(data: any): RealTimeCheckinReportLimitedResultsOfRealTimeCheckinReportItemViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RealTimeCheckinReportLimitedResultsOfRealTimeCheckinReportItemViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportSummary"] = this.reportSummary ? this.reportSummary.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): RealTimeCheckinReportLimitedResultsOfRealTimeCheckinReportItemViewModel {
        const json = this.toJSON();
        let result = new RealTimeCheckinReportLimitedResultsOfRealTimeCheckinReportItemViewModel();
        result.init(json);
        return result;
    }
}

export interface IRealTimeCheckinReportLimitedResultsOfRealTimeCheckinReportItemViewModel extends ILimitedResultOfRealTimeCheckinReportItemViewModel {
    reportSummary?: RealTimeCheckinReportSummaryViewModel | null;
}

export class RealTimeCheckinReportSummaryViewModel implements IRealTimeCheckinReportSummaryViewModel {
    users?: number;
    accounts?: number;
    locations?: number;
    totalTimeInStore?: number;

    constructor(data?: IRealTimeCheckinReportSummaryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.users = _data["users"] !== undefined ? _data["users"] : null as any;
            this.accounts = _data["accounts"] !== undefined ? _data["accounts"] : null as any;
            this.locations = _data["locations"] !== undefined ? _data["locations"] : null as any;
            this.totalTimeInStore = _data["totalTimeInStore"] !== undefined ? _data["totalTimeInStore"] : null as any;
        }
    }

    static fromJS(data: any): RealTimeCheckinReportSummaryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RealTimeCheckinReportSummaryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["users"] = this.users !== undefined ? this.users : null as any;
        data["accounts"] = this.accounts !== undefined ? this.accounts : null as any;
        data["locations"] = this.locations !== undefined ? this.locations : null as any;
        data["totalTimeInStore"] = this.totalTimeInStore !== undefined ? this.totalTimeInStore : null as any;
        return data;
    }

    clone(): RealTimeCheckinReportSummaryViewModel {
        const json = this.toJSON();
        let result = new RealTimeCheckinReportSummaryViewModel();
        result.init(json);
        return result;
    }
}

export interface IRealTimeCheckinReportSummaryViewModel {
    users?: number;
    accounts?: number;
    locations?: number;
    totalTimeInStore?: number;
}

export class RealTimeCheckinReportItemViewModel implements IRealTimeCheckinReportItemViewModel {
    accountName?: string | null;
    accountId?: number;
    banner?: string | null;
    storeNumber?: string | null;
    locationId?: number;
    country?: string | null;
    employeeName?: string | null;
    encryptedPersonId?: string | null;
    personId?: number;
    employeeNumber?: string | null;
    timeIn?: moment.Moment | null;
    timeOut?: moment.Moment | null;
    imageUrl?: string | null;
    timeInStoreAsMinutes?: number;
    operatorName?: string | null;
    totalRows?: number;
    storeTimeIn?: moment.Moment | null;
    storeTimeOut?: moment.Moment | null;
    timeZone?: string | null;
    groups?: { [key: string]: string; } | null;

    constructor(data?: IRealTimeCheckinReportItemViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.banner = _data["banner"] !== undefined ? _data["banner"] : null as any;
            this.storeNumber = _data["storeNumber"] !== undefined ? _data["storeNumber"] : null as any;
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.employeeName = _data["employeeName"] !== undefined ? _data["employeeName"] : null as any;
            this.encryptedPersonId = _data["encryptedPersonId"] !== undefined ? _data["encryptedPersonId"] : null as any;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null as any;
            this.employeeNumber = _data["employeeNumber"] !== undefined ? _data["employeeNumber"] : null as any;
            this.timeIn = _data["timeIn"] ? moment(_data["timeIn"].toString()) : null as any;
            this.timeOut = _data["timeOut"] ? moment(_data["timeOut"].toString()) : null as any;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : null as any;
            this.timeInStoreAsMinutes = _data["timeInStoreAsMinutes"] !== undefined ? _data["timeInStoreAsMinutes"] : null as any;
            this.operatorName = _data["operatorName"] !== undefined ? _data["operatorName"] : null as any;
            this.totalRows = _data["totalRows"] !== undefined ? _data["totalRows"] : null as any;
            this.storeTimeIn = _data["storeTimeIn"] ? moment(_data["storeTimeIn"].toString()) : null as any;
            this.storeTimeOut = _data["storeTimeOut"] ? moment(_data["storeTimeOut"].toString()) : null as any;
            this.timeZone = _data["timeZone"] !== undefined ? _data["timeZone"] : null as any;
            if (_data["groups"]) {
                this.groups = {} as any;
                for (let key in _data["groups"]) {
                    if (_data["groups"].hasOwnProperty(key))
                        (this.groups as any)![key] = _data["groups"][key] !== undefined ? _data["groups"][key] : null as any;
                }
            }
            else {
                this.groups = null as any;
            }
        }
    }

    static fromJS(data: any): RealTimeCheckinReportItemViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RealTimeCheckinReportItemViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["banner"] = this.banner !== undefined ? this.banner : null as any;
        data["storeNumber"] = this.storeNumber !== undefined ? this.storeNumber : null as any;
        data["locationId"] = this.locationId !== undefined ? this.locationId : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["employeeName"] = this.employeeName !== undefined ? this.employeeName : null as any;
        data["encryptedPersonId"] = this.encryptedPersonId !== undefined ? this.encryptedPersonId : null as any;
        data["personId"] = this.personId !== undefined ? this.personId : null as any;
        data["employeeNumber"] = this.employeeNumber !== undefined ? this.employeeNumber : null as any;
        data["timeIn"] = this.timeIn ? this.timeIn.toISOString() : null as any;
        data["timeOut"] = this.timeOut ? this.timeOut.toISOString() : null as any;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : null as any;
        data["timeInStoreAsMinutes"] = this.timeInStoreAsMinutes !== undefined ? this.timeInStoreAsMinutes : null as any;
        data["operatorName"] = this.operatorName !== undefined ? this.operatorName : null as any;
        data["totalRows"] = this.totalRows !== undefined ? this.totalRows : null as any;
        data["storeTimeIn"] = this.storeTimeIn ? this.storeTimeIn.toISOString() : null as any;
        data["storeTimeOut"] = this.storeTimeOut ? this.storeTimeOut.toISOString() : null as any;
        data["timeZone"] = this.timeZone !== undefined ? this.timeZone : null as any;
        if (this.groups) {
            data["groups"] = {};
            for (let key in this.groups) {
                if (this.groups.hasOwnProperty(key))
                    (data["groups"] as any)[key] = this.groups[key] !== undefined ? this.groups[key] : null as any;
            }
        }
        return data;
    }

    clone(): RealTimeCheckinReportItemViewModel {
        const json = this.toJSON();
        let result = new RealTimeCheckinReportItemViewModel();
        result.init(json);
        return result;
    }
}

export interface IRealTimeCheckinReportItemViewModel {
    accountName?: string | null;
    accountId?: number;
    banner?: string | null;
    storeNumber?: string | null;
    locationId?: number;
    country?: string | null;
    employeeName?: string | null;
    encryptedPersonId?: string | null;
    personId?: number;
    employeeNumber?: string | null;
    timeIn?: moment.Moment | null;
    timeOut?: moment.Moment | null;
    imageUrl?: string | null;
    timeInStoreAsMinutes?: number;
    operatorName?: string | null;
    totalRows?: number;
    storeTimeIn?: moment.Moment | null;
    storeTimeOut?: moment.Moment | null;
    timeZone?: string | null;
    groups?: { [key: string]: string; } | null;
}

export enum RealTimeCheckinFilterReportType {
    Historical = "historical",
    InStoreNow = "inStoreNow",
}

export class RedirectConfirmation implements IRedirectConfirmation {
    userId?: string;
    personId?: number;
    requestedUrl?: string | null;

    constructor(data?: IRedirectConfirmation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null as any;
            this.requestedUrl = _data["requestedUrl"] !== undefined ? _data["requestedUrl"] : null as any;
        }
    }

    static fromJS(data: any): RedirectConfirmation {
        data = typeof data === 'object' ? data : {};
        let result = new RedirectConfirmation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["personId"] = this.personId !== undefined ? this.personId : null as any;
        data["requestedUrl"] = this.requestedUrl !== undefined ? this.requestedUrl : null as any;
        return data;
    }

    clone(): RedirectConfirmation {
        const json = this.toJSON();
        let result = new RedirectConfirmation();
        result.init(json);
        return result;
    }
}

export interface IRedirectConfirmation {
    userId?: string;
    personId?: number;
    requestedUrl?: string | null;
}

export class LimitedResultOfReportOverview implements ILimitedResultOfReportOverview {
    totalCount?: number;
    results?: ReportOverview[] | null;
    offset?: number;
    limit?: number;

    constructor(data?: ILimitedResultOfReportOverview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ReportOverview.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfReportOverview {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfReportOverview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        return data;
    }

    clone(): LimitedResultOfReportOverview {
        const json = this.toJSON();
        let result = new LimitedResultOfReportOverview();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfReportOverview {
    totalCount?: number;
    results?: ReportOverview[] | null;
    offset?: number;
    limit?: number;
}

export abstract class BaseDocumentOfObjectId implements IBaseDocumentOfObjectId {
    createdDate?: moment.Moment | null;
    updatedDate?: moment.Moment | null;
    extraElements?: { [key: string]: any; } | null;

    constructor(data?: IBaseDocumentOfObjectId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            if (_data["extraElements"]) {
                this.extraElements = {} as any;
                for (let key in _data["extraElements"]) {
                    if (_data["extraElements"].hasOwnProperty(key))
                        (this.extraElements as any)![key] = _data["extraElements"][key] !== undefined ? _data["extraElements"][key] : null as any;
                }
            }
            else {
                this.extraElements = null as any;
            }
        }
    }

    static fromJS(data: any): BaseDocumentOfObjectId {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseDocumentOfObjectId' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        if (this.extraElements) {
            data["extraElements"] = {};
            for (let key in this.extraElements) {
                if (this.extraElements.hasOwnProperty(key))
                    (data["extraElements"] as any)[key] = this.extraElements[key] !== undefined ? this.extraElements[key] : null as any;
            }
        }
        return data;
    }

    clone(): BaseDocumentOfObjectId {
        throw new Error("The abstract class 'BaseDocumentOfObjectId' cannot be instantiated.");
    }
}

export interface IBaseDocumentOfObjectId {
    createdDate?: moment.Moment | null;
    updatedDate?: moment.Moment | null;
    extraElements?: { [key: string]: any; } | null;
}

export abstract class ObjectIdBaseDocument extends BaseDocumentOfObjectId implements IObjectIdBaseDocument {
    id?: string;

    constructor(data?: IObjectIdBaseDocument) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): ObjectIdBaseDocument {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ObjectIdBaseDocument' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): ObjectIdBaseDocument {
        throw new Error("The abstract class 'ObjectIdBaseDocument' cannot be instantiated.");
    }
}

export interface IObjectIdBaseDocument extends IBaseDocumentOfObjectId {
    id?: string;
}

export class ReportOverview extends ObjectIdBaseDocument implements IReportOverview {
    reportPermissionKey?: string | null;
    route?: string | null;
    title?: string | null;
    titleTranslationKey?: string | null;
    iconClass?: string | null;
    description?: string | null;
    requiredPermissionActivity?: number;
    allowedBanners?: string[] | null;
    allowedTags?: string[] | null;

    constructor(data?: IReportOverview) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.reportPermissionKey = _data["reportPermissionKey"] !== undefined ? _data["reportPermissionKey"] : null as any;
            this.route = _data["route"] !== undefined ? _data["route"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.titleTranslationKey = _data["titleTranslationKey"] !== undefined ? _data["titleTranslationKey"] : null as any;
            this.iconClass = _data["iconClass"] !== undefined ? _data["iconClass"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.requiredPermissionActivity = _data["requiredPermissionActivity"] !== undefined ? _data["requiredPermissionActivity"] : null as any;
            if (Array.isArray(_data["allowedBanners"])) {
                this.allowedBanners = [] as any;
                for (let item of _data["allowedBanners"])
                    this.allowedBanners!.push(item);
            }
            else {
                this.allowedBanners = null as any;
            }
            if (Array.isArray(_data["allowedTags"])) {
                this.allowedTags = [] as any;
                for (let item of _data["allowedTags"])
                    this.allowedTags!.push(item);
            }
            else {
                this.allowedTags = null as any;
            }
        }
    }

    static override fromJS(data: any): ReportOverview {
        data = typeof data === 'object' ? data : {};
        let result = new ReportOverview();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportPermissionKey"] = this.reportPermissionKey !== undefined ? this.reportPermissionKey : null as any;
        data["route"] = this.route !== undefined ? this.route : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["titleTranslationKey"] = this.titleTranslationKey !== undefined ? this.titleTranslationKey : null as any;
        data["iconClass"] = this.iconClass !== undefined ? this.iconClass : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["requiredPermissionActivity"] = this.requiredPermissionActivity !== undefined ? this.requiredPermissionActivity : null as any;
        if (Array.isArray(this.allowedBanners)) {
            data["allowedBanners"] = [];
            for (let item of this.allowedBanners)
                data["allowedBanners"].push(item);
        }
        if (Array.isArray(this.allowedTags)) {
            data["allowedTags"] = [];
            for (let item of this.allowedTags)
                data["allowedTags"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): ReportOverview {
        const json = this.toJSON();
        let result = new ReportOverview();
        result.init(json);
        return result;
    }
}

export interface IReportOverview extends IObjectIdBaseDocument {
    reportPermissionKey?: string | null;
    route?: string | null;
    title?: string | null;
    titleTranslationKey?: string | null;
    iconClass?: string | null;
    description?: string | null;
    requiredPermissionActivity?: number;
    allowedBanners?: string[] | null;
    allowedTags?: string[] | null;
}

export class PowerBiToken implements IPowerBiToken {
    token_type?: string | null;
    scope?: string | null;
    expires_in?: string | null;
    ext_expires_in?: string | null;
    expires_on?: string | null;
    not_before?: string | null;
    resource?: string | null;
    access_token?: string | null;
    refresh_token?: string | null;

    constructor(data?: IPowerBiToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token_type = _data["token_type"] !== undefined ? _data["token_type"] : null as any;
            this.scope = _data["scope"] !== undefined ? _data["scope"] : null as any;
            this.expires_in = _data["expires_in"] !== undefined ? _data["expires_in"] : null as any;
            this.ext_expires_in = _data["ext_expires_in"] !== undefined ? _data["ext_expires_in"] : null as any;
            this.expires_on = _data["expires_on"] !== undefined ? _data["expires_on"] : null as any;
            this.not_before = _data["not_before"] !== undefined ? _data["not_before"] : null as any;
            this.resource = _data["resource"] !== undefined ? _data["resource"] : null as any;
            this.access_token = _data["access_token"] !== undefined ? _data["access_token"] : null as any;
            this.refresh_token = _data["refresh_token"] !== undefined ? _data["refresh_token"] : null as any;
        }
    }

    static fromJS(data: any): PowerBiToken {
        data = typeof data === 'object' ? data : {};
        let result = new PowerBiToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token_type"] = this.token_type !== undefined ? this.token_type : null as any;
        data["scope"] = this.scope !== undefined ? this.scope : null as any;
        data["expires_in"] = this.expires_in !== undefined ? this.expires_in : null as any;
        data["ext_expires_in"] = this.ext_expires_in !== undefined ? this.ext_expires_in : null as any;
        data["expires_on"] = this.expires_on !== undefined ? this.expires_on : null as any;
        data["not_before"] = this.not_before !== undefined ? this.not_before : null as any;
        data["resource"] = this.resource !== undefined ? this.resource : null as any;
        data["access_token"] = this.access_token !== undefined ? this.access_token : null as any;
        data["refresh_token"] = this.refresh_token !== undefined ? this.refresh_token : null as any;
        return data;
    }

    clone(): PowerBiToken {
        const json = this.toJSON();
        let result = new PowerBiToken();
        result.init(json);
        return result;
    }
}

export interface IPowerBiToken {
    token_type?: string | null;
    scope?: string | null;
    expires_in?: string | null;
    ext_expires_in?: string | null;
    expires_on?: string | null;
    not_before?: string | null;
    resource?: string | null;
    access_token?: string | null;
    refresh_token?: string | null;
}

export class ActivityVisitCount implements IActivityVisitCount {
    name?: string | null;
    count?: number;

    constructor(data?: IActivityVisitCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
        }
    }

    static fromJS(data: any): ActivityVisitCount {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityVisitCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["count"] = this.count !== undefined ? this.count : null as any;
        return data;
    }

    clone(): ActivityVisitCount {
        const json = this.toJSON();
        let result = new ActivityVisitCount();
        result.init(json);
        return result;
    }
}

export interface IActivityVisitCount {
    name?: string | null;
    count?: number;
}

export class LimitedResultOfServiceDeploymentViewModel implements ILimitedResultOfServiceDeploymentViewModel {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: ServiceDeploymentViewModel[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfServiceDeploymentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ServiceDeploymentViewModel.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfServiceDeploymentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfServiceDeploymentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfServiceDeploymentViewModel {
        const json = this.toJSON();
        let result = new LimitedResultOfServiceDeploymentViewModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfServiceDeploymentViewModel {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: ServiceDeploymentViewModel[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class GenericTableReportOfServiceDeploymentViewModel extends LimitedResultOfServiceDeploymentViewModel implements IGenericTableReportOfServiceDeploymentViewModel {
    /** Columns in the data-grid */
    columnList!: GenericTableReportColumns[];

    constructor(data?: IGenericTableReportOfServiceDeploymentViewModel) {
        super(data);
        if (!data) {
            this.columnList = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["columnList"])) {
                this.columnList = [] as any;
                for (let item of _data["columnList"])
                    this.columnList!.push(GenericTableReportColumns.fromJS(item));
            }
            else {
                this.columnList = null as any;
            }
        }
    }

    static override fromJS(data: any): GenericTableReportOfServiceDeploymentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GenericTableReportOfServiceDeploymentViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columnList)) {
            data["columnList"] = [];
            for (let item of this.columnList)
                data["columnList"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): GenericTableReportOfServiceDeploymentViewModel {
        const json = this.toJSON();
        let result = new GenericTableReportOfServiceDeploymentViewModel();
        result.init(json);
        return result;
    }
}

export interface IGenericTableReportOfServiceDeploymentViewModel extends ILimitedResultOfServiceDeploymentViewModel {
    /** Columns in the data-grid */
    columnList: GenericTableReportColumns[];
}

export class GenericTableReportColumns implements IGenericTableReportColumns {
    field?: string | null;
    header?: string | null;

    constructor(data?: IGenericTableReportColumns) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"] !== undefined ? _data["field"] : null as any;
            this.header = _data["header"] !== undefined ? _data["header"] : null as any;
        }
    }

    static fromJS(data: any): GenericTableReportColumns {
        data = typeof data === 'object' ? data : {};
        let result = new GenericTableReportColumns();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field !== undefined ? this.field : null as any;
        data["header"] = this.header !== undefined ? this.header : null as any;
        return data;
    }

    clone(): GenericTableReportColumns {
        const json = this.toJSON();
        let result = new GenericTableReportColumns();
        result.init(json);
        return result;
    }
}

export interface IGenericTableReportColumns {
    field?: string | null;
    header?: string | null;
}

export class ServiceDeploymentViewModel implements IServiceDeploymentViewModel {
    id?: string | null;
    referenceNumber!: string;
    name!: string;
    accountId?: number;
    createdDate!: moment.Moment;
    updatedDate?: moment.Moment | null;
    note?: string | null;
    visitOverview?: string | null;
    status!: StatusTypes;
    serviceStart!: moment.Moment;
    serviceEnd!: moment.Moment;
    serviceDeploymentTaskCount?: number;
    aname?: string | null;

    constructor(data?: IServiceDeploymentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.referenceNumber = _data["referenceNumber"] !== undefined ? _data["referenceNumber"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.visitOverview = _data["visitOverview"] !== undefined ? _data["visitOverview"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.serviceStart = _data["serviceStart"] ? moment(_data["serviceStart"].toString()) : null as any;
            this.serviceEnd = _data["serviceEnd"] ? moment(_data["serviceEnd"].toString()) : null as any;
            this.serviceDeploymentTaskCount = _data["serviceDeploymentTaskCount"] !== undefined ? _data["serviceDeploymentTaskCount"] : null as any;
            this.aname = _data["aname"] !== undefined ? _data["aname"] : null as any;
        }
    }

    static fromJS(data: any): ServiceDeploymentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDeploymentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["referenceNumber"] = this.referenceNumber !== undefined ? this.referenceNumber : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["visitOverview"] = this.visitOverview !== undefined ? this.visitOverview : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["serviceStart"] = this.serviceStart ? this.serviceStart.toISOString() : null as any;
        data["serviceEnd"] = this.serviceEnd ? this.serviceEnd.toISOString() : null as any;
        data["serviceDeploymentTaskCount"] = this.serviceDeploymentTaskCount !== undefined ? this.serviceDeploymentTaskCount : null as any;
        data["aname"] = this.aname !== undefined ? this.aname : null as any;
        return data;
    }

    clone(): ServiceDeploymentViewModel {
        const json = this.toJSON();
        let result = new ServiceDeploymentViewModel();
        result.init(json);
        return result;
    }
}

export interface IServiceDeploymentViewModel {
    id?: string | null;
    referenceNumber: string;
    name: string;
    accountId?: number;
    createdDate: moment.Moment;
    updatedDate?: moment.Moment | null;
    note?: string | null;
    visitOverview?: string | null;
    status: StatusTypes;
    serviceStart: moment.Moment;
    serviceEnd: moment.Moment;
    serviceDeploymentTaskCount?: number;
    aname?: string | null;
}

export class Log implements ILog {
    transactionId!: string;
    count!: number;
    statusSummary!: StatusSummary;
    statusDetail!: StatusDetail;
    endpoint?: ActionLogType | null;
    createdDate?: moment.Moment;

    constructor(data?: ILog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.statusSummary = new StatusSummary();
            this.statusDetail = new StatusDetail();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"] !== undefined ? _data["transactionId"] : null as any;
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.statusSummary = _data["statusSummary"] ? StatusSummary.fromJS(_data["statusSummary"]) : new StatusSummary();
            this.statusDetail = _data["statusDetail"] ? StatusDetail.fromJS(_data["statusDetail"]) : new StatusDetail();
            this.endpoint = _data["endpoint"] !== undefined ? _data["endpoint"] : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): Log {
        data = typeof data === 'object' ? data : {};
        let result = new Log();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId !== undefined ? this.transactionId : null as any;
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["statusSummary"] = this.statusSummary ? this.statusSummary.toJSON() : null as any;
        data["statusDetail"] = this.statusDetail ? this.statusDetail.toJSON() : null as any;
        data["endpoint"] = this.endpoint !== undefined ? this.endpoint : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        return data;
    }

    clone(): Log {
        const json = this.toJSON();
        let result = new Log();
        result.init(json);
        return result;
    }
}

export interface ILog {
    transactionId: string;
    count: number;
    statusSummary: StatusSummary;
    statusDetail: StatusDetail;
    endpoint?: ActionLogType | null;
    createdDate?: moment.Moment;
}

export class StatusSummary implements IStatusSummary {
    success?: number | null;
    failed?: number | null;
    pending?: number | null;

    constructor(data?: IStatusSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"] !== undefined ? _data["success"] : null as any;
            this.failed = _data["failed"] !== undefined ? _data["failed"] : null as any;
            this.pending = _data["pending"] !== undefined ? _data["pending"] : null as any;
        }
    }

    static fromJS(data: any): StatusSummary {
        data = typeof data === 'object' ? data : {};
        let result = new StatusSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : null as any;
        data["failed"] = this.failed !== undefined ? this.failed : null as any;
        data["pending"] = this.pending !== undefined ? this.pending : null as any;
        return data;
    }

    clone(): StatusSummary {
        const json = this.toJSON();
        let result = new StatusSummary();
        result.init(json);
        return result;
    }
}

export interface IStatusSummary {
    success?: number | null;
    failed?: number | null;
    pending?: number | null;
}

export class StatusDetail implements IStatusDetail {
    serviceDeployment?: StatusSummary | null;
    serviceTask?: StatusSummary | null;
    taskLocation?: StatusSummary | null;
    questions?: StatusSummary | null;
    taskResults?: StatusSummary | null;
    questionResults?: StatusSummary | null;

    constructor(data?: IStatusDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceDeployment = _data["serviceDeployment"] ? StatusSummary.fromJS(_data["serviceDeployment"]) : null as any;
            this.serviceTask = _data["serviceTask"] ? StatusSummary.fromJS(_data["serviceTask"]) : null as any;
            this.taskLocation = _data["taskLocation"] ? StatusSummary.fromJS(_data["taskLocation"]) : null as any;
            this.questions = _data["questions"] ? StatusSummary.fromJS(_data["questions"]) : null as any;
            this.taskResults = _data["taskResults"] ? StatusSummary.fromJS(_data["taskResults"]) : null as any;
            this.questionResults = _data["questionResults"] ? StatusSummary.fromJS(_data["questionResults"]) : null as any;
        }
    }

    static fromJS(data: any): StatusDetail {
        data = typeof data === 'object' ? data : {};
        let result = new StatusDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceDeployment"] = this.serviceDeployment ? this.serviceDeployment.toJSON() : null as any;
        data["serviceTask"] = this.serviceTask ? this.serviceTask.toJSON() : null as any;
        data["taskLocation"] = this.taskLocation ? this.taskLocation.toJSON() : null as any;
        data["questions"] = this.questions ? this.questions.toJSON() : null as any;
        data["taskResults"] = this.taskResults ? this.taskResults.toJSON() : null as any;
        data["questionResults"] = this.questionResults ? this.questionResults.toJSON() : null as any;
        return data;
    }

    clone(): StatusDetail {
        const json = this.toJSON();
        let result = new StatusDetail();
        result.init(json);
        return result;
    }
}

export interface IStatusDetail {
    serviceDeployment?: StatusSummary | null;
    serviceTask?: StatusSummary | null;
    taskLocation?: StatusSummary | null;
    questions?: StatusSummary | null;
    taskResults?: StatusSummary | null;
    questionResults?: StatusSummary | null;
}

export enum ActionLogType {
    None = "none",
    ServiceDeployment = "serviceDeployment",
    ServiceTask = "serviceTask",
    TaskLocation = "taskLocation",
    Question = "question",
    TaskResult = "taskResult",
    QuestionResult = "questionResult",
}

export class ServiceDeploymentInput implements IServiceDeploymentInput {
    banner?: string | null;
    referenceNumber!: string;
    name!: string;
    /** ['Walmart'] */
    retailer!: string;
    note?: string | null;
    visitOverview?: string | null;
    /** ['Active', 'Inactive'] */
    status?: string | null;
    serviceStart!: moment.Moment;
    serviceEnd!: moment.Moment;
    tasks?: ServiceTaskInput[] | null;

    constructor(data?: IServiceDeploymentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.banner = _data["banner"] !== undefined ? _data["banner"] : null as any;
            this.referenceNumber = _data["referenceNumber"] !== undefined ? _data["referenceNumber"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.retailer = _data["retailer"] !== undefined ? _data["retailer"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.visitOverview = _data["visitOverview"] !== undefined ? _data["visitOverview"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.serviceStart = _data["serviceStart"] ? moment(_data["serviceStart"].toString()) : null as any;
            this.serviceEnd = _data["serviceEnd"] ? moment(_data["serviceEnd"].toString()) : null as any;
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(ServiceTaskInput.fromJS(item));
            }
            else {
                this.tasks = null as any;
            }
        }
    }

    static fromJS(data: any): ServiceDeploymentInput {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDeploymentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["banner"] = this.banner !== undefined ? this.banner : null as any;
        data["referenceNumber"] = this.referenceNumber !== undefined ? this.referenceNumber : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["retailer"] = this.retailer !== undefined ? this.retailer : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["visitOverview"] = this.visitOverview !== undefined ? this.visitOverview : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["serviceStart"] = this.serviceStart ? this.serviceStart.toISOString() : null as any;
        data["serviceEnd"] = this.serviceEnd ? this.serviceEnd.toISOString() : null as any;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): ServiceDeploymentInput {
        const json = this.toJSON();
        let result = new ServiceDeploymentInput();
        result.init(json);
        return result;
    }
}

export interface IServiceDeploymentInput {
    banner?: string | null;
    referenceNumber: string;
    name: string;
    /** ['Walmart'] */
    retailer: string;
    note?: string | null;
    visitOverview?: string | null;
    /** ['Active', 'Inactive'] */
    status?: string | null;
    serviceStart: moment.Moment;
    serviceEnd: moment.Moment;
    tasks?: ServiceTaskInput[] | null;
}

export class ServiceTaskInput implements IServiceTaskInput {
    name!: string;
    categories?: string[] | null;
    departments!: string[];
    activity!: string;
    note?: string | null;
    estimate!: number;
    instructionUrls?: Link[] | null;
    referenceNumber!: string;
    /** ['Project', 'Coordinated', 'Continuity'] */
    serviceModel?: string | null;
    /** ['Active', 'Inactive'] */
    status!: string;
    suppliers!: Supplier2[];
    shipping?: Shipping | null;
    locations?: TaskLocationInput[] | null;
    items?: Item[] | null;
    shouldSendNotifications?: boolean;

    constructor(data?: IServiceTaskInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.departments = [];
            this.suppliers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(item);
            }
            else {
                this.categories = null as any;
            }
            if (Array.isArray(_data["departments"])) {
                this.departments = [] as any;
                for (let item of _data["departments"])
                    this.departments!.push(item);
            }
            else {
                this.departments = null as any;
            }
            this.activity = _data["activity"] !== undefined ? _data["activity"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.estimate = _data["estimate"] !== undefined ? _data["estimate"] : null as any;
            if (Array.isArray(_data["instructionUrls"])) {
                this.instructionUrls = [] as any;
                for (let item of _data["instructionUrls"])
                    this.instructionUrls!.push(Link.fromJS(item));
            }
            else {
                this.instructionUrls = null as any;
            }
            this.referenceNumber = _data["referenceNumber"] !== undefined ? _data["referenceNumber"] : null as any;
            this.serviceModel = _data["serviceModel"] !== undefined ? _data["serviceModel"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [] as any;
                for (let item of _data["suppliers"])
                    this.suppliers!.push(Supplier2.fromJS(item));
            }
            else {
                this.suppliers = null as any;
            }
            this.shipping = _data["shipping"] ? Shipping.fromJS(_data["shipping"]) : null as any;
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(TaskLocationInput.fromJS(item));
            }
            else {
                this.locations = null as any;
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Item.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.shouldSendNotifications = _data["shouldSendNotifications"] !== undefined ? _data["shouldSendNotifications"] : null as any;
        }
    }

    static fromJS(data: any): ServiceTaskInput {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTaskInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        if (Array.isArray(this.departments)) {
            data["departments"] = [];
            for (let item of this.departments)
                data["departments"].push(item);
        }
        data["activity"] = this.activity !== undefined ? this.activity : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["estimate"] = this.estimate !== undefined ? this.estimate : null as any;
        if (Array.isArray(this.instructionUrls)) {
            data["instructionUrls"] = [];
            for (let item of this.instructionUrls)
                data["instructionUrls"].push(item ? item.toJSON() : null as any);
        }
        data["referenceNumber"] = this.referenceNumber !== undefined ? this.referenceNumber : null as any;
        data["serviceModel"] = this.serviceModel !== undefined ? this.serviceModel : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item ? item.toJSON() : null as any);
        }
        data["shipping"] = this.shipping ? this.shipping.toJSON() : null as any;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["shouldSendNotifications"] = this.shouldSendNotifications !== undefined ? this.shouldSendNotifications : null as any;
        return data;
    }

    clone(): ServiceTaskInput {
        const json = this.toJSON();
        let result = new ServiceTaskInput();
        result.init(json);
        return result;
    }
}

export interface IServiceTaskInput {
    name: string;
    categories?: string[] | null;
    departments: string[];
    activity: string;
    note?: string | null;
    estimate: number;
    instructionUrls?: Link[] | null;
    referenceNumber: string;
    /** ['Project', 'Coordinated', 'Continuity'] */
    serviceModel?: string | null;
    /** ['Active', 'Inactive'] */
    status: string;
    suppliers: Supplier2[];
    shipping?: Shipping | null;
    locations?: TaskLocationInput[] | null;
    items?: Item[] | null;
    shouldSendNotifications?: boolean;
}

export class Link implements ILink {
    url!: string;
    name!: string;

    constructor(data?: ILink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): Link {
        data = typeof data === 'object' ? data : {};
        let result = new Link();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url !== undefined ? this.url : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }

    clone(): Link {
        const json = this.toJSON();
        let result = new Link();
        result.init(json);
        return result;
    }
}

export interface ILink {
    url: string;
    name: string;
}

export class Shipping implements IShipping {
    carrierName?: string | null;
    shipEarliest?: moment.Moment | null;
    shipLatest?: moment.Moment | null;
    contact?: string | null;
    note?: string | null;

    constructor(data?: IShipping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.carrierName = _data["carrierName"] !== undefined ? _data["carrierName"] : null as any;
            this.shipEarliest = _data["shipEarliest"] ? moment(_data["shipEarliest"].toString()) : null as any;
            this.shipLatest = _data["shipLatest"] ? moment(_data["shipLatest"].toString()) : null as any;
            this.contact = _data["contact"] !== undefined ? _data["contact"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
        }
    }

    static fromJS(data: any): Shipping {
        data = typeof data === 'object' ? data : {};
        let result = new Shipping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["carrierName"] = this.carrierName !== undefined ? this.carrierName : null as any;
        data["shipEarliest"] = this.shipEarliest ? this.shipEarliest.toISOString() : null as any;
        data["shipLatest"] = this.shipLatest ? this.shipLatest.toISOString() : null as any;
        data["contact"] = this.contact !== undefined ? this.contact : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        return data;
    }

    clone(): Shipping {
        const json = this.toJSON();
        let result = new Shipping();
        result.init(json);
        return result;
    }
}

export interface IShipping {
    carrierName?: string | null;
    shipEarliest?: moment.Moment | null;
    shipLatest?: moment.Moment | null;
    contact?: string | null;
    note?: string | null;
}

export class TaskLocationInput implements ITaskLocationInput {
    number!: string;
    referenceNumber!: string;
    employeeNumbers?: string[] | null;
    start?: moment.Moment | null;
    end?: moment.Moment | null;
    dueDate?: moment.Moment | null;
    /** ['Active', 'Inactive'] */
    status!: string;
    items?: Item[] | null;

    constructor(data?: ITaskLocationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"] !== undefined ? _data["number"] : null as any;
            this.referenceNumber = _data["referenceNumber"] !== undefined ? _data["referenceNumber"] : null as any;
            if (Array.isArray(_data["employeeNumbers"])) {
                this.employeeNumbers = [] as any;
                for (let item of _data["employeeNumbers"])
                    this.employeeNumbers!.push(item);
            }
            else {
                this.employeeNumbers = null as any;
            }
            this.start = _data["start"] ? moment(_data["start"].toString()) : null as any;
            this.end = _data["end"] ? moment(_data["end"].toString()) : null as any;
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Item.fromJS(item));
            }
            else {
                this.items = null as any;
            }
        }
    }

    static fromJS(data: any): TaskLocationInput {
        data = typeof data === 'object' ? data : {};
        let result = new TaskLocationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number !== undefined ? this.number : null as any;
        data["referenceNumber"] = this.referenceNumber !== undefined ? this.referenceNumber : null as any;
        if (Array.isArray(this.employeeNumbers)) {
            data["employeeNumbers"] = [];
            for (let item of this.employeeNumbers)
                data["employeeNumbers"].push(item);
        }
        data["start"] = this.start ? this.start.toISOString() : null as any;
        data["end"] = this.end ? this.end.toISOString() : null as any;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): TaskLocationInput {
        const json = this.toJSON();
        let result = new TaskLocationInput();
        result.init(json);
        return result;
    }
}

export interface ITaskLocationInput {
    number: string;
    referenceNumber: string;
    employeeNumbers?: string[] | null;
    start?: moment.Moment | null;
    end?: moment.Moment | null;
    dueDate?: moment.Moment | null;
    /** ['Active', 'Inactive'] */
    status: string;
    items?: Item[] | null;
}

export class Item implements IItem {
    upc?: string | null;
    quantity?: number;
    action?: string | null;
    itemNumber?: string | null;

    constructor(data?: IItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.upc = _data["upc"] !== undefined ? _data["upc"] : null as any;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : null as any;
            this.action = _data["action"] !== undefined ? _data["action"] : null as any;
            this.itemNumber = _data["itemNumber"] !== undefined ? _data["itemNumber"] : null as any;
        }
    }

    static fromJS(data: any): Item {
        data = typeof data === 'object' ? data : {};
        let result = new Item();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["upc"] = this.upc !== undefined ? this.upc : null as any;
        data["quantity"] = this.quantity !== undefined ? this.quantity : null as any;
        data["action"] = this.action !== undefined ? this.action : null as any;
        data["itemNumber"] = this.itemNumber !== undefined ? this.itemNumber : null as any;
        return data;
    }

    clone(): Item {
        const json = this.toJSON();
        let result = new Item();
        result.init(json);
        return result;
    }
}

export interface IItem {
    upc?: string | null;
    quantity?: number;
    action?: string | null;
    itemNumber?: string | null;
}

export class ServiceDeploymentApiLog implements IServiceDeploymentApiLog {
    transactionId!: string;
    count!: number;
    statusSummary!: StatusSummary;
    statusDetail!: ServiceDeploymentStatusDetail;
    endpoint?: ActionLogType | null;
    createdDate!: moment.Moment;

    constructor(data?: IServiceDeploymentApiLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.statusSummary = new StatusSummary();
            this.statusDetail = new ServiceDeploymentStatusDetail();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"] !== undefined ? _data["transactionId"] : null as any;
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.statusSummary = _data["statusSummary"] ? StatusSummary.fromJS(_data["statusSummary"]) : new StatusSummary();
            this.statusDetail = _data["statusDetail"] ? ServiceDeploymentStatusDetail.fromJS(_data["statusDetail"]) : new ServiceDeploymentStatusDetail();
            this.endpoint = _data["endpoint"] !== undefined ? _data["endpoint"] : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ServiceDeploymentApiLog {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDeploymentApiLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId !== undefined ? this.transactionId : null as any;
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["statusSummary"] = this.statusSummary ? this.statusSummary.toJSON() : null as any;
        data["statusDetail"] = this.statusDetail ? this.statusDetail.toJSON() : null as any;
        data["endpoint"] = this.endpoint !== undefined ? this.endpoint : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        return data;
    }

    clone(): ServiceDeploymentApiLog {
        const json = this.toJSON();
        let result = new ServiceDeploymentApiLog();
        result.init(json);
        return result;
    }
}

export interface IServiceDeploymentApiLog {
    transactionId: string;
    count: number;
    statusSummary: StatusSummary;
    statusDetail: ServiceDeploymentStatusDetail;
    endpoint?: ActionLogType | null;
    createdDate: moment.Moment;
}

export class ServiceDeploymentStatusDetail implements IServiceDeploymentStatusDetail {
    serviceDeployment?: StatusSummary | null;
    serviceTask?: StatusSummary | null;
    taskLocation?: StatusSummary | null;

    constructor(data?: IServiceDeploymentStatusDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceDeployment = _data["serviceDeployment"] ? StatusSummary.fromJS(_data["serviceDeployment"]) : null as any;
            this.serviceTask = _data["serviceTask"] ? StatusSummary.fromJS(_data["serviceTask"]) : null as any;
            this.taskLocation = _data["taskLocation"] ? StatusSummary.fromJS(_data["taskLocation"]) : null as any;
        }
    }

    static fromJS(data: any): ServiceDeploymentStatusDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDeploymentStatusDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceDeployment"] = this.serviceDeployment ? this.serviceDeployment.toJSON() : null as any;
        data["serviceTask"] = this.serviceTask ? this.serviceTask.toJSON() : null as any;
        data["taskLocation"] = this.taskLocation ? this.taskLocation.toJSON() : null as any;
        return data;
    }

    clone(): ServiceDeploymentStatusDetail {
        const json = this.toJSON();
        let result = new ServiceDeploymentStatusDetail();
        result.init(json);
        return result;
    }
}

export interface IServiceDeploymentStatusDetail {
    serviceDeployment?: StatusSummary | null;
    serviceTask?: StatusSummary | null;
    taskLocation?: StatusSummary | null;
}

export class LimitedResultOflog implements ILimitedResultOflog {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: Log2[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOflog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(Log2.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOflog {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOflog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOflog {
        const json = this.toJSON();
        let result = new LimitedResultOflog();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOflog {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: Log2[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class Log2 implements ILog2 {
    referenceNumber!: string;
    status!: ImportStatus;
    type!: string;
    message?: string | null;

    constructor(data?: ILog2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceNumber = _data["referenceNumber"] !== undefined ? _data["referenceNumber"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
        }
    }

    static fromJS(data: any): Log2 {
        data = typeof data === 'object' ? data : {};
        let result = new Log2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceNumber"] = this.referenceNumber !== undefined ? this.referenceNumber : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        return data;
    }

    clone(): Log2 {
        const json = this.toJSON();
        let result = new Log2();
        result.init(json);
        return result;
    }
}

export interface ILog2 {
    referenceNumber: string;
    status: ImportStatus;
    type: string;
    message?: string | null;
}

export enum ImportStatus {
    Failed = "failed",
    Success = "success",
}

export enum ImportStatusFilter {
    Failed = "failed",
    Success = "success",
    All = "all",
}

export class ServiceTaskEventTypeValueBase implements IServiceTaskEventTypeValueBase {
    name?: string | null;

    constructor(data?: IServiceTaskEventTypeValueBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): ServiceTaskEventTypeValueBase {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTaskEventTypeValueBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }

    clone(): ServiceTaskEventTypeValueBase {
        const json = this.toJSON();
        let result = new ServiceTaskEventTypeValueBase();
        result.init(json);
        return result;
    }
}

export interface IServiceTaskEventTypeValueBase {
    name?: string | null;
}

export class UploadResponse implements IUploadResponse {
    data?: string | null;

    constructor(data?: IUploadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
        }
    }

    static fromJS(data: any): UploadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data !== undefined ? this.data : null as any;
        return data;
    }

    clone(): UploadResponse {
        const json = this.toJSON();
        let result = new UploadResponse();
        result.init(json);
        return result;
    }
}

export interface IUploadResponse {
    data?: string | null;
}

export class CreateServiceTaskEventDto implements ICreateServiceTaskEventDto {
    accountId?: number;
    serviceDeploymentReferenceNumber?: string | null;
    status?: StatusTypes;
    eventType?: string | null;
    fundingStatus?: string | null;
    eventLocation?: string | null;
    strategicBusinessUnit?: string | null;
    buyersName?: string | null;
    buyerApproved?: DocumentationVm | null;
    foodSampled?: DocumentationVm | null;
    talentReleaseRequired?: DocumentationVm | null;
    indemnityAgreementChanges?: DocumentationVm | null;
    storeManagerResponsibilities?: StoreManagerResponsibilitiesDto | null;
    agencyContact?: AgencyContactDto | null;
    upcs?: Item[] | null;
    eventReferenceNumber?: string | null;
    eventName?: string | null;
    suppliers?: Supplier2[] | null;
    supplierEmail?: string | null;
    estimateInMinutes?: number;
    overview?: OverviewDto | null;

    constructor(data?: ICreateServiceTaskEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.serviceDeploymentReferenceNumber = _data["serviceDeploymentReferenceNumber"] !== undefined ? _data["serviceDeploymentReferenceNumber"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.eventType = _data["eventType"] !== undefined ? _data["eventType"] : null as any;
            this.fundingStatus = _data["fundingStatus"] !== undefined ? _data["fundingStatus"] : null as any;
            this.eventLocation = _data["eventLocation"] !== undefined ? _data["eventLocation"] : null as any;
            this.strategicBusinessUnit = _data["strategicBusinessUnit"] !== undefined ? _data["strategicBusinessUnit"] : null as any;
            this.buyersName = _data["buyersName"] !== undefined ? _data["buyersName"] : null as any;
            this.buyerApproved = _data["buyerApproved"] ? DocumentationVm.fromJS(_data["buyerApproved"]) : null as any;
            this.foodSampled = _data["foodSampled"] ? DocumentationVm.fromJS(_data["foodSampled"]) : null as any;
            this.talentReleaseRequired = _data["talentReleaseRequired"] ? DocumentationVm.fromJS(_data["talentReleaseRequired"]) : null as any;
            this.indemnityAgreementChanges = _data["indemnityAgreementChanges"] ? DocumentationVm.fromJS(_data["indemnityAgreementChanges"]) : null as any;
            this.storeManagerResponsibilities = _data["storeManagerResponsibilities"] ? StoreManagerResponsibilitiesDto.fromJS(_data["storeManagerResponsibilities"]) : null as any;
            this.agencyContact = _data["agencyContact"] ? AgencyContactDto.fromJS(_data["agencyContact"]) : null as any;
            if (Array.isArray(_data["upcs"])) {
                this.upcs = [] as any;
                for (let item of _data["upcs"])
                    this.upcs!.push(Item.fromJS(item));
            }
            else {
                this.upcs = null as any;
            }
            this.eventReferenceNumber = _data["eventReferenceNumber"] !== undefined ? _data["eventReferenceNumber"] : null as any;
            this.eventName = _data["eventName"] !== undefined ? _data["eventName"] : null as any;
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [] as any;
                for (let item of _data["suppliers"])
                    this.suppliers!.push(Supplier2.fromJS(item));
            }
            else {
                this.suppliers = null as any;
            }
            this.supplierEmail = _data["supplierEmail"] !== undefined ? _data["supplierEmail"] : null as any;
            this.estimateInMinutes = _data["estimateInMinutes"] !== undefined ? _data["estimateInMinutes"] : null as any;
            this.overview = _data["overview"] ? OverviewDto.fromJS(_data["overview"]) : null as any;
        }
    }

    static fromJS(data: any): CreateServiceTaskEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceTaskEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["serviceDeploymentReferenceNumber"] = this.serviceDeploymentReferenceNumber !== undefined ? this.serviceDeploymentReferenceNumber : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["eventType"] = this.eventType !== undefined ? this.eventType : null as any;
        data["fundingStatus"] = this.fundingStatus !== undefined ? this.fundingStatus : null as any;
        data["eventLocation"] = this.eventLocation !== undefined ? this.eventLocation : null as any;
        data["strategicBusinessUnit"] = this.strategicBusinessUnit !== undefined ? this.strategicBusinessUnit : null as any;
        data["buyersName"] = this.buyersName !== undefined ? this.buyersName : null as any;
        data["buyerApproved"] = this.buyerApproved ? this.buyerApproved.toJSON() : null as any;
        data["foodSampled"] = this.foodSampled ? this.foodSampled.toJSON() : null as any;
        data["talentReleaseRequired"] = this.talentReleaseRequired ? this.talentReleaseRequired.toJSON() : null as any;
        data["indemnityAgreementChanges"] = this.indemnityAgreementChanges ? this.indemnityAgreementChanges.toJSON() : null as any;
        data["storeManagerResponsibilities"] = this.storeManagerResponsibilities ? this.storeManagerResponsibilities.toJSON() : null as any;
        data["agencyContact"] = this.agencyContact ? this.agencyContact.toJSON() : null as any;
        if (Array.isArray(this.upcs)) {
            data["upcs"] = [];
            for (let item of this.upcs)
                data["upcs"].push(item ? item.toJSON() : null as any);
        }
        data["eventReferenceNumber"] = this.eventReferenceNumber !== undefined ? this.eventReferenceNumber : null as any;
        data["eventName"] = this.eventName !== undefined ? this.eventName : null as any;
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item ? item.toJSON() : null as any);
        }
        data["supplierEmail"] = this.supplierEmail !== undefined ? this.supplierEmail : null as any;
        data["estimateInMinutes"] = this.estimateInMinutes !== undefined ? this.estimateInMinutes : null as any;
        data["overview"] = this.overview ? this.overview.toJSON() : null as any;
        return data;
    }

    clone(): CreateServiceTaskEventDto {
        const json = this.toJSON();
        let result = new CreateServiceTaskEventDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceTaskEventDto {
    accountId?: number;
    serviceDeploymentReferenceNumber?: string | null;
    status?: StatusTypes;
    eventType?: string | null;
    fundingStatus?: string | null;
    eventLocation?: string | null;
    strategicBusinessUnit?: string | null;
    buyersName?: string | null;
    buyerApproved?: DocumentationVm | null;
    foodSampled?: DocumentationVm | null;
    talentReleaseRequired?: DocumentationVm | null;
    indemnityAgreementChanges?: DocumentationVm | null;
    storeManagerResponsibilities?: StoreManagerResponsibilitiesDto | null;
    agencyContact?: AgencyContactDto | null;
    upcs?: Item[] | null;
    eventReferenceNumber?: string | null;
    eventName?: string | null;
    suppliers?: Supplier2[] | null;
    supplierEmail?: string | null;
    estimateInMinutes?: number;
    overview?: OverviewDto | null;
}

export class DocumentationVm implements IDocumentationVm {
    hasDocumentation?: HasDocumentationEnum;
    fileLocation?: string | null;

    constructor(data?: IDocumentationVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasDocumentation = _data["hasDocumentation"] !== undefined ? _data["hasDocumentation"] : null as any;
            this.fileLocation = _data["fileLocation"] !== undefined ? _data["fileLocation"] : null as any;
        }
    }

    static fromJS(data: any): DocumentationVm {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentationVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasDocumentation"] = this.hasDocumentation !== undefined ? this.hasDocumentation : null as any;
        data["fileLocation"] = this.fileLocation !== undefined ? this.fileLocation : null as any;
        return data;
    }

    clone(): DocumentationVm {
        const json = this.toJSON();
        let result = new DocumentationVm();
        result.init(json);
        return result;
    }
}

export interface IDocumentationVm {
    hasDocumentation?: HasDocumentationEnum;
    fileLocation?: string | null;
}

export enum HasDocumentationEnum {
    No = "no",
    Yes = "yes",
}

export class StoreManagerResponsibilitiesDto implements IStoreManagerResponsibilitiesDto {
    fileLocation?: string | null;
    instructions?: string | null;

    constructor(data?: IStoreManagerResponsibilitiesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileLocation = _data["fileLocation"] !== undefined ? _data["fileLocation"] : null as any;
            this.instructions = _data["instructions"] !== undefined ? _data["instructions"] : null as any;
        }
    }

    static fromJS(data: any): StoreManagerResponsibilitiesDto {
        data = typeof data === 'object' ? data : {};
        let result = new StoreManagerResponsibilitiesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileLocation"] = this.fileLocation !== undefined ? this.fileLocation : null as any;
        data["instructions"] = this.instructions !== undefined ? this.instructions : null as any;
        return data;
    }

    clone(): StoreManagerResponsibilitiesDto {
        const json = this.toJSON();
        let result = new StoreManagerResponsibilitiesDto();
        result.init(json);
        return result;
    }
}

export interface IStoreManagerResponsibilitiesDto {
    fileLocation?: string | null;
    instructions?: string | null;
}

export class AgencyContactDto implements IAgencyContactDto {
    name?: string | null;
    email?: string | null;
    phoneNumber?: string | null;

    constructor(data?: IAgencyContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : null as any;
        }
    }

    static fromJS(data: any): AgencyContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null as any;
        return data;
    }

    clone(): AgencyContactDto {
        const json = this.toJSON();
        let result = new AgencyContactDto();
        result.init(json);
        return result;
    }
}

export interface IAgencyContactDto {
    name?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
}

export class OverviewDto implements IOverviewDto {
    fileLocation?: string | null;
    note?: string | null;

    constructor(data?: IOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileLocation = _data["fileLocation"] !== undefined ? _data["fileLocation"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
        }
    }

    static fromJS(data: any): OverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new OverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileLocation"] = this.fileLocation !== undefined ? this.fileLocation : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        return data;
    }

    clone(): OverviewDto {
        const json = this.toJSON();
        let result = new OverviewDto();
        result.init(json);
        return result;
    }
}

export interface IOverviewDto {
    fileLocation?: string | null;
    note?: string | null;
}

export class ApproveDenyServiceTaskEventDto implements IApproveDenyServiceTaskEventDto {
    serviceTaskReferenceNumber?: string | null;
    serviceDeploymentReferenceNumber?: string | null;
    accountId?: number;
    reason?: string | null;

    constructor(data?: IApproveDenyServiceTaskEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceTaskReferenceNumber = _data["serviceTaskReferenceNumber"] !== undefined ? _data["serviceTaskReferenceNumber"] : null as any;
            this.serviceDeploymentReferenceNumber = _data["serviceDeploymentReferenceNumber"] !== undefined ? _data["serviceDeploymentReferenceNumber"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
        }
    }

    static fromJS(data: any): ApproveDenyServiceTaskEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveDenyServiceTaskEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceTaskReferenceNumber"] = this.serviceTaskReferenceNumber !== undefined ? this.serviceTaskReferenceNumber : null as any;
        data["serviceDeploymentReferenceNumber"] = this.serviceDeploymentReferenceNumber !== undefined ? this.serviceDeploymentReferenceNumber : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        return data;
    }

    clone(): ApproveDenyServiceTaskEventDto {
        const json = this.toJSON();
        let result = new ApproveDenyServiceTaskEventDto();
        result.init(json);
        return result;
    }
}

export interface IApproveDenyServiceTaskEventDto {
    serviceTaskReferenceNumber?: string | null;
    serviceDeploymentReferenceNumber?: string | null;
    accountId?: number;
    reason?: string | null;
}

export class FoodSamplingFeedbackEmailDto implements IFoodSamplingFeedbackEmailDto {
    accountId?: number;
    serviceDeploymentReferenceNumber?: string | null;
    serviceTaskReferenceNumber?: string | null;
    feedbackMessage?: string | null;

    constructor(data?: IFoodSamplingFeedbackEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.serviceDeploymentReferenceNumber = _data["serviceDeploymentReferenceNumber"] !== undefined ? _data["serviceDeploymentReferenceNumber"] : null as any;
            this.serviceTaskReferenceNumber = _data["serviceTaskReferenceNumber"] !== undefined ? _data["serviceTaskReferenceNumber"] : null as any;
            this.feedbackMessage = _data["feedbackMessage"] !== undefined ? _data["feedbackMessage"] : null as any;
        }
    }

    static fromJS(data: any): FoodSamplingFeedbackEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new FoodSamplingFeedbackEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["serviceDeploymentReferenceNumber"] = this.serviceDeploymentReferenceNumber !== undefined ? this.serviceDeploymentReferenceNumber : null as any;
        data["serviceTaskReferenceNumber"] = this.serviceTaskReferenceNumber !== undefined ? this.serviceTaskReferenceNumber : null as any;
        data["feedbackMessage"] = this.feedbackMessage !== undefined ? this.feedbackMessage : null as any;
        return data;
    }

    clone(): FoodSamplingFeedbackEmailDto {
        const json = this.toJSON();
        let result = new FoodSamplingFeedbackEmailDto();
        result.init(json);
        return result;
    }
}

export interface IFoodSamplingFeedbackEmailDto {
    accountId?: number;
    serviceDeploymentReferenceNumber?: string | null;
    serviceTaskReferenceNumber?: string | null;
    feedbackMessage?: string | null;
}

export class UpdateServiceTaskEventDto implements IUpdateServiceTaskEventDto {
    accountId?: number;
    serviceDeploymentReferenceNumber?: string | null;
    status?: StatusTypes;
    eventType?: string | null;
    fundingStatus?: string | null;
    eventLocation?: string | null;
    strategicBusinessUnit?: string | null;
    buyersName?: string | null;
    buyerApproved?: DocumentationVm2 | null;
    foodSampled?: DocumentationVm2 | null;
    talentReleaseRequired?: DocumentationVm2 | null;
    indemnityAgreementChanges?: DocumentationVm2 | null;
    storeManagerResponsibilities?: StoreManagerResponsibilitiesDto2 | null;
    agencyContact?: AgencyContactDto2 | null;
    upcs?: Item[] | null;
    eventReferenceNumber?: string | null;
    eventName?: string | null;
    suppliers?: Supplier2[] | null;
    supplierEmail?: string | null;
    estimateInMinutes?: number;
    overview?: OverviewDto2 | null;

    constructor(data?: IUpdateServiceTaskEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.serviceDeploymentReferenceNumber = _data["serviceDeploymentReferenceNumber"] !== undefined ? _data["serviceDeploymentReferenceNumber"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.eventType = _data["eventType"] !== undefined ? _data["eventType"] : null as any;
            this.fundingStatus = _data["fundingStatus"] !== undefined ? _data["fundingStatus"] : null as any;
            this.eventLocation = _data["eventLocation"] !== undefined ? _data["eventLocation"] : null as any;
            this.strategicBusinessUnit = _data["strategicBusinessUnit"] !== undefined ? _data["strategicBusinessUnit"] : null as any;
            this.buyersName = _data["buyersName"] !== undefined ? _data["buyersName"] : null as any;
            this.buyerApproved = _data["buyerApproved"] ? DocumentationVm2.fromJS(_data["buyerApproved"]) : null as any;
            this.foodSampled = _data["foodSampled"] ? DocumentationVm2.fromJS(_data["foodSampled"]) : null as any;
            this.talentReleaseRequired = _data["talentReleaseRequired"] ? DocumentationVm2.fromJS(_data["talentReleaseRequired"]) : null as any;
            this.indemnityAgreementChanges = _data["indemnityAgreementChanges"] ? DocumentationVm2.fromJS(_data["indemnityAgreementChanges"]) : null as any;
            this.storeManagerResponsibilities = _data["storeManagerResponsibilities"] ? StoreManagerResponsibilitiesDto2.fromJS(_data["storeManagerResponsibilities"]) : null as any;
            this.agencyContact = _data["agencyContact"] ? AgencyContactDto2.fromJS(_data["agencyContact"]) : null as any;
            if (Array.isArray(_data["upcs"])) {
                this.upcs = [] as any;
                for (let item of _data["upcs"])
                    this.upcs!.push(Item.fromJS(item));
            }
            else {
                this.upcs = null as any;
            }
            this.eventReferenceNumber = _data["eventReferenceNumber"] !== undefined ? _data["eventReferenceNumber"] : null as any;
            this.eventName = _data["eventName"] !== undefined ? _data["eventName"] : null as any;
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [] as any;
                for (let item of _data["suppliers"])
                    this.suppliers!.push(Supplier2.fromJS(item));
            }
            else {
                this.suppliers = null as any;
            }
            this.supplierEmail = _data["supplierEmail"] !== undefined ? _data["supplierEmail"] : null as any;
            this.estimateInMinutes = _data["estimateInMinutes"] !== undefined ? _data["estimateInMinutes"] : null as any;
            this.overview = _data["overview"] ? OverviewDto2.fromJS(_data["overview"]) : null as any;
        }
    }

    static fromJS(data: any): UpdateServiceTaskEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServiceTaskEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["serviceDeploymentReferenceNumber"] = this.serviceDeploymentReferenceNumber !== undefined ? this.serviceDeploymentReferenceNumber : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["eventType"] = this.eventType !== undefined ? this.eventType : null as any;
        data["fundingStatus"] = this.fundingStatus !== undefined ? this.fundingStatus : null as any;
        data["eventLocation"] = this.eventLocation !== undefined ? this.eventLocation : null as any;
        data["strategicBusinessUnit"] = this.strategicBusinessUnit !== undefined ? this.strategicBusinessUnit : null as any;
        data["buyersName"] = this.buyersName !== undefined ? this.buyersName : null as any;
        data["buyerApproved"] = this.buyerApproved ? this.buyerApproved.toJSON() : null as any;
        data["foodSampled"] = this.foodSampled ? this.foodSampled.toJSON() : null as any;
        data["talentReleaseRequired"] = this.talentReleaseRequired ? this.talentReleaseRequired.toJSON() : null as any;
        data["indemnityAgreementChanges"] = this.indemnityAgreementChanges ? this.indemnityAgreementChanges.toJSON() : null as any;
        data["storeManagerResponsibilities"] = this.storeManagerResponsibilities ? this.storeManagerResponsibilities.toJSON() : null as any;
        data["agencyContact"] = this.agencyContact ? this.agencyContact.toJSON() : null as any;
        if (Array.isArray(this.upcs)) {
            data["upcs"] = [];
            for (let item of this.upcs)
                data["upcs"].push(item ? item.toJSON() : null as any);
        }
        data["eventReferenceNumber"] = this.eventReferenceNumber !== undefined ? this.eventReferenceNumber : null as any;
        data["eventName"] = this.eventName !== undefined ? this.eventName : null as any;
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item ? item.toJSON() : null as any);
        }
        data["supplierEmail"] = this.supplierEmail !== undefined ? this.supplierEmail : null as any;
        data["estimateInMinutes"] = this.estimateInMinutes !== undefined ? this.estimateInMinutes : null as any;
        data["overview"] = this.overview ? this.overview.toJSON() : null as any;
        return data;
    }

    clone(): UpdateServiceTaskEventDto {
        const json = this.toJSON();
        let result = new UpdateServiceTaskEventDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateServiceTaskEventDto {
    accountId?: number;
    serviceDeploymentReferenceNumber?: string | null;
    status?: StatusTypes;
    eventType?: string | null;
    fundingStatus?: string | null;
    eventLocation?: string | null;
    strategicBusinessUnit?: string | null;
    buyersName?: string | null;
    buyerApproved?: DocumentationVm2 | null;
    foodSampled?: DocumentationVm2 | null;
    talentReleaseRequired?: DocumentationVm2 | null;
    indemnityAgreementChanges?: DocumentationVm2 | null;
    storeManagerResponsibilities?: StoreManagerResponsibilitiesDto2 | null;
    agencyContact?: AgencyContactDto2 | null;
    upcs?: Item[] | null;
    eventReferenceNumber?: string | null;
    eventName?: string | null;
    suppliers?: Supplier2[] | null;
    supplierEmail?: string | null;
    estimateInMinutes?: number;
    overview?: OverviewDto2 | null;
}

export class DocumentationVm2 implements IDocumentationVm2 {
    hasDocumentation?: HasDocumentationEnum2;
    fileLocation?: string | null;

    constructor(data?: IDocumentationVm2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasDocumentation = _data["hasDocumentation"] !== undefined ? _data["hasDocumentation"] : null as any;
            this.fileLocation = _data["fileLocation"] !== undefined ? _data["fileLocation"] : null as any;
        }
    }

    static fromJS(data: any): DocumentationVm2 {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentationVm2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasDocumentation"] = this.hasDocumentation !== undefined ? this.hasDocumentation : null as any;
        data["fileLocation"] = this.fileLocation !== undefined ? this.fileLocation : null as any;
        return data;
    }

    clone(): DocumentationVm2 {
        const json = this.toJSON();
        let result = new DocumentationVm2();
        result.init(json);
        return result;
    }
}

export interface IDocumentationVm2 {
    hasDocumentation?: HasDocumentationEnum2;
    fileLocation?: string | null;
}

export enum HasDocumentationEnum2 {
    No = "no",
    Yes = "yes",
}

export class StoreManagerResponsibilitiesDto2 implements IStoreManagerResponsibilitiesDto2 {
    fileLocation?: string | null;
    instructions?: string | null;

    constructor(data?: IStoreManagerResponsibilitiesDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileLocation = _data["fileLocation"] !== undefined ? _data["fileLocation"] : null as any;
            this.instructions = _data["instructions"] !== undefined ? _data["instructions"] : null as any;
        }
    }

    static fromJS(data: any): StoreManagerResponsibilitiesDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new StoreManagerResponsibilitiesDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileLocation"] = this.fileLocation !== undefined ? this.fileLocation : null as any;
        data["instructions"] = this.instructions !== undefined ? this.instructions : null as any;
        return data;
    }

    clone(): StoreManagerResponsibilitiesDto2 {
        const json = this.toJSON();
        let result = new StoreManagerResponsibilitiesDto2();
        result.init(json);
        return result;
    }
}

export interface IStoreManagerResponsibilitiesDto2 {
    fileLocation?: string | null;
    instructions?: string | null;
}

export class AgencyContactDto2 implements IAgencyContactDto2 {
    name?: string | null;
    email?: string | null;
    phoneNumber?: string | null;

    constructor(data?: IAgencyContactDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : null as any;
        }
    }

    static fromJS(data: any): AgencyContactDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyContactDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null as any;
        return data;
    }

    clone(): AgencyContactDto2 {
        const json = this.toJSON();
        let result = new AgencyContactDto2();
        result.init(json);
        return result;
    }
}

export interface IAgencyContactDto2 {
    name?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
}

export class OverviewDto2 implements IOverviewDto2 {
    fileLocation?: string | null;
    note?: string | null;

    constructor(data?: IOverviewDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileLocation = _data["fileLocation"] !== undefined ? _data["fileLocation"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
        }
    }

    static fromJS(data: any): OverviewDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new OverviewDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileLocation"] = this.fileLocation !== undefined ? this.fileLocation : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        return data;
    }

    clone(): OverviewDto2 {
        const json = this.toJSON();
        let result = new OverviewDto2();
        result.init(json);
        return result;
    }
}

export interface IOverviewDto2 {
    fileLocation?: string | null;
    note?: string | null;
}

export class LimitedResultOfServiceEventTaskInfoDto implements ILimitedResultOfServiceEventTaskInfoDto {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: ServiceEventTaskInfoDto[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfServiceEventTaskInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ServiceEventTaskInfoDto.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfServiceEventTaskInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfServiceEventTaskInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfServiceEventTaskInfoDto {
        const json = this.toJSON();
        let result = new LimitedResultOfServiceEventTaskInfoDto();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfServiceEventTaskInfoDto {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: ServiceEventTaskInfoDto[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class ServiceEventTaskInfoDto implements IServiceEventTaskInfoDto {
    id?: string | null;
    serviceDeploymentReferenceNumber?: string | null;
    eventReferenceNumber?: string | null;
    accountId?: number;
    accountName?: string | null;
    eventLocation?: string | null;
    eventName?: string | null;
    createdBy?: string | null;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment;
    activity?: string | null;
    approvalStatus?: ServiceTaskEventStatus;
    hasFoodSampledDocumentation?: boolean;
    isFoodSamplingApproved?: boolean;

    constructor(data?: IServiceEventTaskInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.serviceDeploymentReferenceNumber = _data["serviceDeploymentReferenceNumber"] !== undefined ? _data["serviceDeploymentReferenceNumber"] : null as any;
            this.eventReferenceNumber = _data["eventReferenceNumber"] !== undefined ? _data["eventReferenceNumber"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.eventLocation = _data["eventLocation"] !== undefined ? _data["eventLocation"] : null as any;
            this.eventName = _data["eventName"] !== undefined ? _data["eventName"] : null as any;
            this.createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            this.activity = _data["activity"] !== undefined ? _data["activity"] : null as any;
            this.approvalStatus = _data["approvalStatus"] !== undefined ? _data["approvalStatus"] : null as any;
            this.hasFoodSampledDocumentation = _data["hasFoodSampledDocumentation"] !== undefined ? _data["hasFoodSampledDocumentation"] : null as any;
            this.isFoodSamplingApproved = _data["isFoodSamplingApproved"] !== undefined ? _data["isFoodSamplingApproved"] : null as any;
        }
    }

    static fromJS(data: any): ServiceEventTaskInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceEventTaskInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["serviceDeploymentReferenceNumber"] = this.serviceDeploymentReferenceNumber !== undefined ? this.serviceDeploymentReferenceNumber : null as any;
        data["eventReferenceNumber"] = this.eventReferenceNumber !== undefined ? this.eventReferenceNumber : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["eventLocation"] = this.eventLocation !== undefined ? this.eventLocation : null as any;
        data["eventName"] = this.eventName !== undefined ? this.eventName : null as any;
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        data["activity"] = this.activity !== undefined ? this.activity : null as any;
        data["approvalStatus"] = this.approvalStatus !== undefined ? this.approvalStatus : null as any;
        data["hasFoodSampledDocumentation"] = this.hasFoodSampledDocumentation !== undefined ? this.hasFoodSampledDocumentation : null as any;
        data["isFoodSamplingApproved"] = this.isFoodSamplingApproved !== undefined ? this.isFoodSamplingApproved : null as any;
        return data;
    }

    clone(): ServiceEventTaskInfoDto {
        const json = this.toJSON();
        let result = new ServiceEventTaskInfoDto();
        result.init(json);
        return result;
    }
}

export interface IServiceEventTaskInfoDto {
    id?: string | null;
    serviceDeploymentReferenceNumber?: string | null;
    eventReferenceNumber?: string | null;
    accountId?: number;
    accountName?: string | null;
    eventLocation?: string | null;
    eventName?: string | null;
    createdBy?: string | null;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment;
    activity?: string | null;
    approvalStatus?: ServiceTaskEventStatus;
    hasFoodSampledDocumentation?: boolean;
    isFoodSamplingApproved?: boolean;
}

export enum ServiceTaskEventStatus {
    Pending = "pending",
    Approved = "approved",
    Denied = "denied",
}

export class RetailtainmentServiceEventTaskDto implements IRetailtainmentServiceEventTaskDto {
    id?: string | null;
    name?: string | null;
    approvalStatus?: ServiceTaskEventStatus;
    eventType?: string | null;
    fundingStatus?: string | null;
    eventLocation?: string | null;
    strategicBusinessUnit?: string | null;
    buyersName?: string | null;
    buyerApproved?: Documentation | null;
    foodSampled?: Documentation | null;
    talentReleaseRequired?: Documentation | null;
    indemnityAgreementChanges?: Documentation | null;
    storeManagerResponsibilities?: StoreManagerResponsibilitiesModel | null;
    agencyContact?: AgencyContactModel | null;
    upcs?: Item[] | null;
    supplierEmail?: string | null;
    serviceModel?: ServiceModelTypes;
    categories?: string[] | null;
    departments?: string[] | null;
    activity?: string | null;
    note?: string | null;
    estimate?: number;
    instructionUrls?: Link[] | null;
    referenceNumber?: string | null;
    status?: StatusTypes;
    suppliers?: Supplier2[] | null;
    serviceTask?: ServiceTaskDto | null;
    createdBy?: UserInfo | null;
    fieldGroup?: AccountInfo | null;
    statusHistories?: StatusHistory[] | null;
    serviceDeployment?: ServiceDeployment | null;
    isFoodSamplingApproved?: boolean;

    constructor(data?: IRetailtainmentServiceEventTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.approvalStatus = _data["approvalStatus"] !== undefined ? _data["approvalStatus"] : null as any;
            this.eventType = _data["eventType"] !== undefined ? _data["eventType"] : null as any;
            this.fundingStatus = _data["fundingStatus"] !== undefined ? _data["fundingStatus"] : null as any;
            this.eventLocation = _data["eventLocation"] !== undefined ? _data["eventLocation"] : null as any;
            this.strategicBusinessUnit = _data["strategicBusinessUnit"] !== undefined ? _data["strategicBusinessUnit"] : null as any;
            this.buyersName = _data["buyersName"] !== undefined ? _data["buyersName"] : null as any;
            this.buyerApproved = _data["buyerApproved"] ? Documentation.fromJS(_data["buyerApproved"]) : null as any;
            this.foodSampled = _data["foodSampled"] ? Documentation.fromJS(_data["foodSampled"]) : null as any;
            this.talentReleaseRequired = _data["talentReleaseRequired"] ? Documentation.fromJS(_data["talentReleaseRequired"]) : null as any;
            this.indemnityAgreementChanges = _data["indemnityAgreementChanges"] ? Documentation.fromJS(_data["indemnityAgreementChanges"]) : null as any;
            this.storeManagerResponsibilities = _data["storeManagerResponsibilities"] ? StoreManagerResponsibilitiesModel.fromJS(_data["storeManagerResponsibilities"]) : null as any;
            this.agencyContact = _data["agencyContact"] ? AgencyContactModel.fromJS(_data["agencyContact"]) : null as any;
            if (Array.isArray(_data["upcs"])) {
                this.upcs = [] as any;
                for (let item of _data["upcs"])
                    this.upcs!.push(Item.fromJS(item));
            }
            else {
                this.upcs = null as any;
            }
            this.supplierEmail = _data["supplierEmail"] !== undefined ? _data["supplierEmail"] : null as any;
            this.serviceModel = _data["serviceModel"] !== undefined ? _data["serviceModel"] : null as any;
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(item);
            }
            else {
                this.categories = null as any;
            }
            if (Array.isArray(_data["departments"])) {
                this.departments = [] as any;
                for (let item of _data["departments"])
                    this.departments!.push(item);
            }
            else {
                this.departments = null as any;
            }
            this.activity = _data["activity"] !== undefined ? _data["activity"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.estimate = _data["estimate"] !== undefined ? _data["estimate"] : null as any;
            if (Array.isArray(_data["instructionUrls"])) {
                this.instructionUrls = [] as any;
                for (let item of _data["instructionUrls"])
                    this.instructionUrls!.push(Link.fromJS(item));
            }
            else {
                this.instructionUrls = null as any;
            }
            this.referenceNumber = _data["referenceNumber"] !== undefined ? _data["referenceNumber"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [] as any;
                for (let item of _data["suppliers"])
                    this.suppliers!.push(Supplier2.fromJS(item));
            }
            else {
                this.suppliers = null as any;
            }
            this.serviceTask = _data["serviceTask"] ? ServiceTaskDto.fromJS(_data["serviceTask"]) : null as any;
            this.createdBy = _data["createdBy"] ? UserInfo.fromJS(_data["createdBy"]) : null as any;
            this.fieldGroup = _data["fieldGroup"] ? AccountInfo.fromJS(_data["fieldGroup"]) : null as any;
            if (Array.isArray(_data["statusHistories"])) {
                this.statusHistories = [] as any;
                for (let item of _data["statusHistories"])
                    this.statusHistories!.push(StatusHistory.fromJS(item));
            }
            else {
                this.statusHistories = null as any;
            }
            this.serviceDeployment = _data["serviceDeployment"] ? ServiceDeployment.fromJS(_data["serviceDeployment"]) : null as any;
            this.isFoodSamplingApproved = _data["isFoodSamplingApproved"] !== undefined ? _data["isFoodSamplingApproved"] : null as any;
        }
    }

    static fromJS(data: any): RetailtainmentServiceEventTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new RetailtainmentServiceEventTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["approvalStatus"] = this.approvalStatus !== undefined ? this.approvalStatus : null as any;
        data["eventType"] = this.eventType !== undefined ? this.eventType : null as any;
        data["fundingStatus"] = this.fundingStatus !== undefined ? this.fundingStatus : null as any;
        data["eventLocation"] = this.eventLocation !== undefined ? this.eventLocation : null as any;
        data["strategicBusinessUnit"] = this.strategicBusinessUnit !== undefined ? this.strategicBusinessUnit : null as any;
        data["buyersName"] = this.buyersName !== undefined ? this.buyersName : null as any;
        data["buyerApproved"] = this.buyerApproved ? this.buyerApproved.toJSON() : null as any;
        data["foodSampled"] = this.foodSampled ? this.foodSampled.toJSON() : null as any;
        data["talentReleaseRequired"] = this.talentReleaseRequired ? this.talentReleaseRequired.toJSON() : null as any;
        data["indemnityAgreementChanges"] = this.indemnityAgreementChanges ? this.indemnityAgreementChanges.toJSON() : null as any;
        data["storeManagerResponsibilities"] = this.storeManagerResponsibilities ? this.storeManagerResponsibilities.toJSON() : null as any;
        data["agencyContact"] = this.agencyContact ? this.agencyContact.toJSON() : null as any;
        if (Array.isArray(this.upcs)) {
            data["upcs"] = [];
            for (let item of this.upcs)
                data["upcs"].push(item ? item.toJSON() : null as any);
        }
        data["supplierEmail"] = this.supplierEmail !== undefined ? this.supplierEmail : null as any;
        data["serviceModel"] = this.serviceModel !== undefined ? this.serviceModel : null as any;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        if (Array.isArray(this.departments)) {
            data["departments"] = [];
            for (let item of this.departments)
                data["departments"].push(item);
        }
        data["activity"] = this.activity !== undefined ? this.activity : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["estimate"] = this.estimate !== undefined ? this.estimate : null as any;
        if (Array.isArray(this.instructionUrls)) {
            data["instructionUrls"] = [];
            for (let item of this.instructionUrls)
                data["instructionUrls"].push(item ? item.toJSON() : null as any);
        }
        data["referenceNumber"] = this.referenceNumber !== undefined ? this.referenceNumber : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item ? item.toJSON() : null as any);
        }
        data["serviceTask"] = this.serviceTask ? this.serviceTask.toJSON() : null as any;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : null as any;
        data["fieldGroup"] = this.fieldGroup ? this.fieldGroup.toJSON() : null as any;
        if (Array.isArray(this.statusHistories)) {
            data["statusHistories"] = [];
            for (let item of this.statusHistories)
                data["statusHistories"].push(item ? item.toJSON() : null as any);
        }
        data["serviceDeployment"] = this.serviceDeployment ? this.serviceDeployment.toJSON() : null as any;
        data["isFoodSamplingApproved"] = this.isFoodSamplingApproved !== undefined ? this.isFoodSamplingApproved : null as any;
        return data;
    }

    clone(): RetailtainmentServiceEventTaskDto {
        const json = this.toJSON();
        let result = new RetailtainmentServiceEventTaskDto();
        result.init(json);
        return result;
    }
}

export interface IRetailtainmentServiceEventTaskDto {
    id?: string | null;
    name?: string | null;
    approvalStatus?: ServiceTaskEventStatus;
    eventType?: string | null;
    fundingStatus?: string | null;
    eventLocation?: string | null;
    strategicBusinessUnit?: string | null;
    buyersName?: string | null;
    buyerApproved?: Documentation | null;
    foodSampled?: Documentation | null;
    talentReleaseRequired?: Documentation | null;
    indemnityAgreementChanges?: Documentation | null;
    storeManagerResponsibilities?: StoreManagerResponsibilitiesModel | null;
    agencyContact?: AgencyContactModel | null;
    upcs?: Item[] | null;
    supplierEmail?: string | null;
    serviceModel?: ServiceModelTypes;
    categories?: string[] | null;
    departments?: string[] | null;
    activity?: string | null;
    note?: string | null;
    estimate?: number;
    instructionUrls?: Link[] | null;
    referenceNumber?: string | null;
    status?: StatusTypes;
    suppliers?: Supplier2[] | null;
    serviceTask?: ServiceTaskDto | null;
    createdBy?: UserInfo | null;
    fieldGroup?: AccountInfo | null;
    statusHistories?: StatusHistory[] | null;
    serviceDeployment?: ServiceDeployment | null;
    isFoodSamplingApproved?: boolean;
}

export class Documentation implements IDocumentation {
    hasDocumentation?: HasDocumentationEnum3;
    fileLocation?: string | null;

    constructor(data?: IDocumentation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasDocumentation = _data["hasDocumentation"] !== undefined ? _data["hasDocumentation"] : null as any;
            this.fileLocation = _data["fileLocation"] !== undefined ? _data["fileLocation"] : null as any;
        }
    }

    static fromJS(data: any): Documentation {
        data = typeof data === 'object' ? data : {};
        let result = new Documentation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasDocumentation"] = this.hasDocumentation !== undefined ? this.hasDocumentation : null as any;
        data["fileLocation"] = this.fileLocation !== undefined ? this.fileLocation : null as any;
        return data;
    }

    clone(): Documentation {
        const json = this.toJSON();
        let result = new Documentation();
        result.init(json);
        return result;
    }
}

export interface IDocumentation {
    hasDocumentation?: HasDocumentationEnum3;
    fileLocation?: string | null;
}

export enum HasDocumentationEnum3 {
    No = "no",
    Yes = "yes",
}

export class StoreManagerResponsibilitiesModel implements IStoreManagerResponsibilitiesModel {
    fileLocation?: string | null;
    instructions?: string | null;

    constructor(data?: IStoreManagerResponsibilitiesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileLocation = _data["fileLocation"] !== undefined ? _data["fileLocation"] : null as any;
            this.instructions = _data["instructions"] !== undefined ? _data["instructions"] : null as any;
        }
    }

    static fromJS(data: any): StoreManagerResponsibilitiesModel {
        data = typeof data === 'object' ? data : {};
        let result = new StoreManagerResponsibilitiesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileLocation"] = this.fileLocation !== undefined ? this.fileLocation : null as any;
        data["instructions"] = this.instructions !== undefined ? this.instructions : null as any;
        return data;
    }

    clone(): StoreManagerResponsibilitiesModel {
        const json = this.toJSON();
        let result = new StoreManagerResponsibilitiesModel();
        result.init(json);
        return result;
    }
}

export interface IStoreManagerResponsibilitiesModel {
    fileLocation?: string | null;
    instructions?: string | null;
}

export class AgencyContactModel implements IAgencyContactModel {
    name?: string | null;
    email?: string | null;
    phoneNumber?: string | null;

    constructor(data?: IAgencyContactModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : null as any;
        }
    }

    static fromJS(data: any): AgencyContactModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyContactModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null as any;
        return data;
    }

    clone(): AgencyContactModel {
        const json = this.toJSON();
        let result = new AgencyContactModel();
        result.init(json);
        return result;
    }
}

export interface IAgencyContactModel {
    name?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
}

export enum ServiceModelTypes {
    Empty = "empty",
    Project = "project",
    Coordinated = "coordinated",
    Continuity = "continuity",
    Maintenance = "maintenance",
}

export class ServiceTaskDto implements IServiceTaskDto {
    id?: string;
    name?: string | null;
    serviceModel?: ServiceModelTypes;
    categories?: string[] | null;
    departments?: string[] | null;
    activity?: string | null;
    note?: string | null;
    estimate?: number;
    instructionUrls?: Link[] | null;
    referenceNumber?: string | null;
    status?: StatusTypes;
    suppliers?: Supplier2[] | null;
    shipping?: Shipping | null;
    serviceDeployment?: ServiceDeploymentDto | null;

    constructor(data?: IServiceTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.serviceModel = _data["serviceModel"] !== undefined ? _data["serviceModel"] : null as any;
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(item);
            }
            else {
                this.categories = null as any;
            }
            if (Array.isArray(_data["departments"])) {
                this.departments = [] as any;
                for (let item of _data["departments"])
                    this.departments!.push(item);
            }
            else {
                this.departments = null as any;
            }
            this.activity = _data["activity"] !== undefined ? _data["activity"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.estimate = _data["estimate"] !== undefined ? _data["estimate"] : null as any;
            if (Array.isArray(_data["instructionUrls"])) {
                this.instructionUrls = [] as any;
                for (let item of _data["instructionUrls"])
                    this.instructionUrls!.push(Link.fromJS(item));
            }
            else {
                this.instructionUrls = null as any;
            }
            this.referenceNumber = _data["referenceNumber"] !== undefined ? _data["referenceNumber"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [] as any;
                for (let item of _data["suppliers"])
                    this.suppliers!.push(Supplier2.fromJS(item));
            }
            else {
                this.suppliers = null as any;
            }
            this.shipping = _data["shipping"] ? Shipping.fromJS(_data["shipping"]) : null as any;
            this.serviceDeployment = _data["serviceDeployment"] ? ServiceDeploymentDto.fromJS(_data["serviceDeployment"]) : null as any;
        }
    }

    static fromJS(data: any): ServiceTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["serviceModel"] = this.serviceModel !== undefined ? this.serviceModel : null as any;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        if (Array.isArray(this.departments)) {
            data["departments"] = [];
            for (let item of this.departments)
                data["departments"].push(item);
        }
        data["activity"] = this.activity !== undefined ? this.activity : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["estimate"] = this.estimate !== undefined ? this.estimate : null as any;
        if (Array.isArray(this.instructionUrls)) {
            data["instructionUrls"] = [];
            for (let item of this.instructionUrls)
                data["instructionUrls"].push(item ? item.toJSON() : null as any);
        }
        data["referenceNumber"] = this.referenceNumber !== undefined ? this.referenceNumber : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item ? item.toJSON() : null as any);
        }
        data["shipping"] = this.shipping ? this.shipping.toJSON() : null as any;
        data["serviceDeployment"] = this.serviceDeployment ? this.serviceDeployment.toJSON() : null as any;
        return data;
    }

    clone(): ServiceTaskDto {
        const json = this.toJSON();
        let result = new ServiceTaskDto();
        result.init(json);
        return result;
    }
}

export interface IServiceTaskDto {
    id?: string;
    name?: string | null;
    serviceModel?: ServiceModelTypes;
    categories?: string[] | null;
    departments?: string[] | null;
    activity?: string | null;
    note?: string | null;
    estimate?: number;
    instructionUrls?: Link[] | null;
    referenceNumber?: string | null;
    status?: StatusTypes;
    suppliers?: Supplier2[] | null;
    shipping?: Shipping | null;
    serviceDeployment?: ServiceDeploymentDto | null;
}

export class ServiceDeploymentDto implements IServiceDeploymentDto {
    id?: string;
    referenceNumber?: string | null;
    name?: string | null;
    retailer?: RetailerNames;
    note?: string | null;
    visitOverview?: string | null;
    status?: StatusTypes;
    serviceStart?: moment.Moment;
    serviceEnd?: moment.Moment;

    constructor(data?: IServiceDeploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.referenceNumber = _data["referenceNumber"] !== undefined ? _data["referenceNumber"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.retailer = _data["retailer"] !== undefined ? _data["retailer"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.visitOverview = _data["visitOverview"] !== undefined ? _data["visitOverview"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.serviceStart = _data["serviceStart"] ? moment(_data["serviceStart"].toString()) : null as any;
            this.serviceEnd = _data["serviceEnd"] ? moment(_data["serviceEnd"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ServiceDeploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDeploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["referenceNumber"] = this.referenceNumber !== undefined ? this.referenceNumber : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["retailer"] = this.retailer !== undefined ? this.retailer : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["visitOverview"] = this.visitOverview !== undefined ? this.visitOverview : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["serviceStart"] = this.serviceStart ? this.serviceStart.toISOString() : null as any;
        data["serviceEnd"] = this.serviceEnd ? this.serviceEnd.toISOString() : null as any;
        return data;
    }

    clone(): ServiceDeploymentDto {
        const json = this.toJSON();
        let result = new ServiceDeploymentDto();
        result.init(json);
        return result;
    }
}

export interface IServiceDeploymentDto {
    id?: string;
    referenceNumber?: string | null;
    name?: string | null;
    retailer?: RetailerNames;
    note?: string | null;
    visitOverview?: string | null;
    status?: StatusTypes;
    serviceStart?: moment.Moment;
    serviceEnd?: moment.Moment;
}

export enum RetailerNames {
    Walmart = "walmart",
}

export class UserInfo implements IUserInfo {
    id?: string;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;

    constructor(data?: IUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
        }
    }

    static fromJS(data: any): UserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        return data;
    }

    clone(): UserInfo {
        const json = this.toJSON();
        let result = new UserInfo();
        result.init(json);
        return result;
    }
}

export interface IUserInfo {
    id?: string;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
}

export class AccountInfo implements IAccountInfo {
    accountName?: string | null;
    accountId?: number;

    constructor(data?: IAccountInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
        }
    }

    static fromJS(data: any): AccountInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AccountInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        return data;
    }

    clone(): AccountInfo {
        const json = this.toJSON();
        let result = new AccountInfo();
        result.init(json);
        return result;
    }
}

export interface IAccountInfo {
    accountName?: string | null;
    accountId?: number;
}

export class StatusHistory implements IStatusHistory {
    status?: ServiceTaskEventStatus;
    updateDate?: moment.Moment;
    updatedBy?: UserInfo | null;
    reason?: string | null;

    constructor(data?: IStatusHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.updateDate = _data["updateDate"] ? moment(_data["updateDate"].toString()) : null as any;
            this.updatedBy = _data["updatedBy"] ? UserInfo.fromJS(_data["updatedBy"]) : null as any;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
        }
    }

    static fromJS(data: any): StatusHistory {
        data = typeof data === 'object' ? data : {};
        let result = new StatusHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : null as any;
        data["updatedBy"] = this.updatedBy ? this.updatedBy.toJSON() : null as any;
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        return data;
    }

    clone(): StatusHistory {
        const json = this.toJSON();
        let result = new StatusHistory();
        result.init(json);
        return result;
    }
}

export interface IStatusHistory {
    status?: ServiceTaskEventStatus;
    updateDate?: moment.Moment;
    updatedBy?: UserInfo | null;
    reason?: string | null;
}

export class ServiceDeployment implements IServiceDeployment {
    referenceNumber!: string;
    name!: string;
    created!: moment.Moment;
    lastUpdated?: moment.Moment | null;
    retailer!: RetailerNames;
    note?: string | null;
    approvalStatus!: ApprovalStatus2;
    visitOverview?: string | null;
    status!: StatusTypes;
    serviceStart!: moment.Moment;
    serviceEnd!: moment.Moment;

    constructor(data?: IServiceDeployment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceNumber = _data["referenceNumber"] !== undefined ? _data["referenceNumber"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.created = _data["created"] ? moment(_data["created"].toString()) : null as any;
            this.lastUpdated = _data["lastUpdated"] ? moment(_data["lastUpdated"].toString()) : null as any;
            this.retailer = _data["retailer"] !== undefined ? _data["retailer"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.approvalStatus = _data["approvalStatus"] !== undefined ? _data["approvalStatus"] : null as any;
            this.visitOverview = _data["visitOverview"] !== undefined ? _data["visitOverview"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.serviceStart = _data["serviceStart"] ? moment(_data["serviceStart"].toString()) : null as any;
            this.serviceEnd = _data["serviceEnd"] ? moment(_data["serviceEnd"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ServiceDeployment {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDeployment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceNumber"] = this.referenceNumber !== undefined ? this.referenceNumber : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["created"] = this.created ? this.created.toISOString() : null as any;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : null as any;
        data["retailer"] = this.retailer !== undefined ? this.retailer : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["approvalStatus"] = this.approvalStatus !== undefined ? this.approvalStatus : null as any;
        data["visitOverview"] = this.visitOverview !== undefined ? this.visitOverview : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["serviceStart"] = this.serviceStart ? this.serviceStart.toISOString() : null as any;
        data["serviceEnd"] = this.serviceEnd ? this.serviceEnd.toISOString() : null as any;
        return data;
    }

    clone(): ServiceDeployment {
        const json = this.toJSON();
        let result = new ServiceDeployment();
        result.init(json);
        return result;
    }
}

export interface IServiceDeployment {
    referenceNumber: string;
    name: string;
    created: moment.Moment;
    lastUpdated?: moment.Moment | null;
    retailer: RetailerNames;
    note?: string | null;
    approvalStatus: ApprovalStatus2;
    visitOverview?: string | null;
    status: StatusTypes;
    serviceStart: moment.Moment;
    serviceEnd: moment.Moment;
}

export enum ApprovalStatus2 {
    Approved = "approved",
    Pending = "pending",
    Denied = "denied",
}

export class LimitedResultOfServiceDeploymentTaskLocationViewModel implements ILimitedResultOfServiceDeploymentTaskLocationViewModel {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: ServiceDeploymentTaskLocationViewModel[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfServiceDeploymentTaskLocationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ServiceDeploymentTaskLocationViewModel.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfServiceDeploymentTaskLocationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfServiceDeploymentTaskLocationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfServiceDeploymentTaskLocationViewModel {
        const json = this.toJSON();
        let result = new LimitedResultOfServiceDeploymentTaskLocationViewModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfServiceDeploymentTaskLocationViewModel {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: ServiceDeploymentTaskLocationViewModel[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class GenericTableReportOfServiceDeploymentTaskLocationViewModel extends LimitedResultOfServiceDeploymentTaskLocationViewModel implements IGenericTableReportOfServiceDeploymentTaskLocationViewModel {
    /** Columns in the data-grid */
    columnList!: GenericTableReportColumns[];

    constructor(data?: IGenericTableReportOfServiceDeploymentTaskLocationViewModel) {
        super(data);
        if (!data) {
            this.columnList = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["columnList"])) {
                this.columnList = [] as any;
                for (let item of _data["columnList"])
                    this.columnList!.push(GenericTableReportColumns.fromJS(item));
            }
            else {
                this.columnList = null as any;
            }
        }
    }

    static override fromJS(data: any): GenericTableReportOfServiceDeploymentTaskLocationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GenericTableReportOfServiceDeploymentTaskLocationViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columnList)) {
            data["columnList"] = [];
            for (let item of this.columnList)
                data["columnList"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): GenericTableReportOfServiceDeploymentTaskLocationViewModel {
        const json = this.toJSON();
        let result = new GenericTableReportOfServiceDeploymentTaskLocationViewModel();
        result.init(json);
        return result;
    }
}

export interface IGenericTableReportOfServiceDeploymentTaskLocationViewModel extends ILimitedResultOfServiceDeploymentTaskLocationViewModel {
    /** Columns in the data-grid */
    columnList: GenericTableReportColumns[];
}

export class ServiceDeploymentTaskLocationViewModel implements IServiceDeploymentTaskLocationViewModel {
    id?: string | null;
    number!: string;
    referenceNumber!: string;
    employeeNumbers?: string[] | null;
    start?: moment.Moment | null;
    end?: moment.Moment | null;
    localStart?: moment.Moment | null;
    localEnd?: moment.Moment | null;
    timeZone?: string | null;
    status!: StatusTypes;
    dueDate?: moment.Moment | null;
    completionDate?: moment.Moment | null;

    constructor(data?: IServiceDeploymentTaskLocationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.number = _data["number"] !== undefined ? _data["number"] : null as any;
            this.referenceNumber = _data["referenceNumber"] !== undefined ? _data["referenceNumber"] : null as any;
            if (Array.isArray(_data["employeeNumbers"])) {
                this.employeeNumbers = [] as any;
                for (let item of _data["employeeNumbers"])
                    this.employeeNumbers!.push(item);
            }
            else {
                this.employeeNumbers = null as any;
            }
            this.start = _data["start"] ? moment(_data["start"].toString()) : null as any;
            this.end = _data["end"] ? moment(_data["end"].toString()) : null as any;
            this.localStart = _data["localStart"] ? moment(_data["localStart"].toString()) : null as any;
            this.localEnd = _data["localEnd"] ? moment(_data["localEnd"].toString()) : null as any;
            this.timeZone = _data["timeZone"] !== undefined ? _data["timeZone"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : null as any;
            this.completionDate = _data["completionDate"] ? moment(_data["completionDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ServiceDeploymentTaskLocationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDeploymentTaskLocationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["number"] = this.number !== undefined ? this.number : null as any;
        data["referenceNumber"] = this.referenceNumber !== undefined ? this.referenceNumber : null as any;
        if (Array.isArray(this.employeeNumbers)) {
            data["employeeNumbers"] = [];
            for (let item of this.employeeNumbers)
                data["employeeNumbers"].push(item);
        }
        data["start"] = this.start ? this.start.toISOString() : null as any;
        data["end"] = this.end ? this.end.toISOString() : null as any;
        data["localStart"] = this.localStart ? this.localStart.toISOString() : null as any;
        data["localEnd"] = this.localEnd ? this.localEnd.toISOString() : null as any;
        data["timeZone"] = this.timeZone !== undefined ? this.timeZone : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : null as any;
        data["completionDate"] = this.completionDate ? this.completionDate.toISOString() : null as any;
        return data;
    }

    clone(): ServiceDeploymentTaskLocationViewModel {
        const json = this.toJSON();
        let result = new ServiceDeploymentTaskLocationViewModel();
        result.init(json);
        return result;
    }
}

export interface IServiceDeploymentTaskLocationViewModel {
    id?: string | null;
    number: string;
    referenceNumber: string;
    employeeNumbers?: string[] | null;
    start?: moment.Moment | null;
    end?: moment.Moment | null;
    localStart?: moment.Moment | null;
    localEnd?: moment.Moment | null;
    timeZone?: string | null;
    status: StatusTypes;
    dueDate?: moment.Moment | null;
    completionDate?: moment.Moment | null;
}

export class LimitedResultOfServiceDeploymentTasksViewModel implements ILimitedResultOfServiceDeploymentTasksViewModel {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: ServiceDeploymentTasksViewModel[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfServiceDeploymentTasksViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ServiceDeploymentTasksViewModel.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfServiceDeploymentTasksViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfServiceDeploymentTasksViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfServiceDeploymentTasksViewModel {
        const json = this.toJSON();
        let result = new LimitedResultOfServiceDeploymentTasksViewModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfServiceDeploymentTasksViewModel {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: ServiceDeploymentTasksViewModel[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class GenericTableReportOfServiceDeploymentTasksViewModel extends LimitedResultOfServiceDeploymentTasksViewModel implements IGenericTableReportOfServiceDeploymentTasksViewModel {
    /** Columns in the data-grid */
    columnList!: GenericTableReportColumns[];

    constructor(data?: IGenericTableReportOfServiceDeploymentTasksViewModel) {
        super(data);
        if (!data) {
            this.columnList = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["columnList"])) {
                this.columnList = [] as any;
                for (let item of _data["columnList"])
                    this.columnList!.push(GenericTableReportColumns.fromJS(item));
            }
            else {
                this.columnList = null as any;
            }
        }
    }

    static override fromJS(data: any): GenericTableReportOfServiceDeploymentTasksViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GenericTableReportOfServiceDeploymentTasksViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columnList)) {
            data["columnList"] = [];
            for (let item of this.columnList)
                data["columnList"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): GenericTableReportOfServiceDeploymentTasksViewModel {
        const json = this.toJSON();
        let result = new GenericTableReportOfServiceDeploymentTasksViewModel();
        result.init(json);
        return result;
    }
}

export interface IGenericTableReportOfServiceDeploymentTasksViewModel extends ILimitedResultOfServiceDeploymentTasksViewModel {
    /** Columns in the data-grid */
    columnList: GenericTableReportColumns[];
}

export class ServiceDeploymentTasksViewModel implements IServiceDeploymentTasksViewModel {
    name!: string;
    serviceModel?: ServiceModelTypes;
    categories?: string[] | null;
    departments!: string[];
    activity!: string;
    note?: string | null;
    estimate!: number;
    instructionUrls?: Link[] | null;
    referenceNumber!: string;
    id?: string;
    status!: StatusTypes;
    suppliers!: Supplier2[];
    shipping?: Shipping | null;
    serviceDeploymentTaskLocationCount?: number;
    created!: moment.Moment;
    lastUpdated?: moment.Moment | null;
    serviceDeployment?: ServiceDeployment | null;

    constructor(data?: IServiceDeploymentTasksViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.departments = [];
            this.suppliers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.serviceModel = _data["serviceModel"] !== undefined ? _data["serviceModel"] : null as any;
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(item);
            }
            else {
                this.categories = null as any;
            }
            if (Array.isArray(_data["departments"])) {
                this.departments = [] as any;
                for (let item of _data["departments"])
                    this.departments!.push(item);
            }
            else {
                this.departments = null as any;
            }
            this.activity = _data["activity"] !== undefined ? _data["activity"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.estimate = _data["estimate"] !== undefined ? _data["estimate"] : null as any;
            if (Array.isArray(_data["instructionUrls"])) {
                this.instructionUrls = [] as any;
                for (let item of _data["instructionUrls"])
                    this.instructionUrls!.push(Link.fromJS(item));
            }
            else {
                this.instructionUrls = null as any;
            }
            this.referenceNumber = _data["referenceNumber"] !== undefined ? _data["referenceNumber"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [] as any;
                for (let item of _data["suppliers"])
                    this.suppliers!.push(Supplier2.fromJS(item));
            }
            else {
                this.suppliers = null as any;
            }
            this.shipping = _data["shipping"] ? Shipping.fromJS(_data["shipping"]) : null as any;
            this.serviceDeploymentTaskLocationCount = _data["serviceDeploymentTaskLocationCount"] !== undefined ? _data["serviceDeploymentTaskLocationCount"] : null as any;
            this.created = _data["created"] ? moment(_data["created"].toString()) : null as any;
            this.lastUpdated = _data["lastUpdated"] ? moment(_data["lastUpdated"].toString()) : null as any;
            this.serviceDeployment = _data["serviceDeployment"] ? ServiceDeployment.fromJS(_data["serviceDeployment"]) : null as any;
        }
    }

    static fromJS(data: any): ServiceDeploymentTasksViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDeploymentTasksViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["serviceModel"] = this.serviceModel !== undefined ? this.serviceModel : null as any;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        if (Array.isArray(this.departments)) {
            data["departments"] = [];
            for (let item of this.departments)
                data["departments"].push(item);
        }
        data["activity"] = this.activity !== undefined ? this.activity : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["estimate"] = this.estimate !== undefined ? this.estimate : null as any;
        if (Array.isArray(this.instructionUrls)) {
            data["instructionUrls"] = [];
            for (let item of this.instructionUrls)
                data["instructionUrls"].push(item ? item.toJSON() : null as any);
        }
        data["referenceNumber"] = this.referenceNumber !== undefined ? this.referenceNumber : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item ? item.toJSON() : null as any);
        }
        data["shipping"] = this.shipping ? this.shipping.toJSON() : null as any;
        data["serviceDeploymentTaskLocationCount"] = this.serviceDeploymentTaskLocationCount !== undefined ? this.serviceDeploymentTaskLocationCount : null as any;
        data["created"] = this.created ? this.created.toISOString() : null as any;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : null as any;
        data["serviceDeployment"] = this.serviceDeployment ? this.serviceDeployment.toJSON() : null as any;
        return data;
    }

    clone(): ServiceDeploymentTasksViewModel {
        const json = this.toJSON();
        let result = new ServiceDeploymentTasksViewModel();
        result.init(json);
        return result;
    }
}

export interface IServiceDeploymentTasksViewModel {
    name: string;
    serviceModel?: ServiceModelTypes;
    categories?: string[] | null;
    departments: string[];
    activity: string;
    note?: string | null;
    estimate: number;
    instructionUrls?: Link[] | null;
    referenceNumber: string;
    id?: string;
    status: StatusTypes;
    suppliers: Supplier2[];
    shipping?: Shipping | null;
    serviceDeploymentTaskLocationCount?: number;
    created: moment.Moment;
    lastUpdated?: moment.Moment | null;
    serviceDeployment?: ServiceDeployment | null;
}

export class ServiceTaskModel implements IServiceTaskModel {
    id?: string;
    name?: string | null;
    accountId?: number | null;
    accountName?: string | null;
    accountImageUrl?: string | null;
    accountFieldGroup?: string | null;
    accountStoreSupportNumber?: string | null;
    serviceModel?: string | null;
    categories?: string[] | null;
    departments?: Department2[] | null;
    activity?: string | null;
    note?: string | null;
    estimate?: number;
    instructionUrls?: Link[] | null;
    referenceNumber?: string | null;
    locationRefNumber?: string | null;
    locationNumbers?: string[] | null;
    isActive?: boolean;
    suppliers?: string[] | null;
    serviceStart?: moment.Moment;
    serviceEnd?: moment.Moment;
    serviceDepoymentId?: string;
    flag?: boolean;
    employeeNumbers?: string[] | null;
    locationNumber?: string | null;
    visitOverview?: string | null;
    completed?: boolean;
    taskResult?: TaskResultModel | null;
    showSuppliers?: boolean;
    tasksCompleteCount?: number;
    serviceDeploymentName?: string | null;
    serviceDeploymentRefNumber?: string | null;
    rating?: boolean;
    comments?: string | null;
    photoValues?: string[] | null;
    reason?: string | null;
    upcs?: UpcViewModel[] | null;

    constructor(data?: IServiceTaskModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.accountImageUrl = _data["accountImageUrl"] !== undefined ? _data["accountImageUrl"] : null as any;
            this.accountFieldGroup = _data["accountFieldGroup"] !== undefined ? _data["accountFieldGroup"] : null as any;
            this.accountStoreSupportNumber = _data["accountStoreSupportNumber"] !== undefined ? _data["accountStoreSupportNumber"] : null as any;
            this.serviceModel = _data["serviceModel"] !== undefined ? _data["serviceModel"] : null as any;
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(item);
            }
            else {
                this.categories = null as any;
            }
            if (Array.isArray(_data["departments"])) {
                this.departments = [] as any;
                for (let item of _data["departments"])
                    this.departments!.push(Department2.fromJS(item));
            }
            else {
                this.departments = null as any;
            }
            this.activity = _data["activity"] !== undefined ? _data["activity"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.estimate = _data["estimate"] !== undefined ? _data["estimate"] : null as any;
            if (Array.isArray(_data["instructionUrls"])) {
                this.instructionUrls = [] as any;
                for (let item of _data["instructionUrls"])
                    this.instructionUrls!.push(Link.fromJS(item));
            }
            else {
                this.instructionUrls = null as any;
            }
            this.referenceNumber = _data["referenceNumber"] !== undefined ? _data["referenceNumber"] : null as any;
            this.locationRefNumber = _data["locationRefNumber"] !== undefined ? _data["locationRefNumber"] : null as any;
            if (Array.isArray(_data["locationNumbers"])) {
                this.locationNumbers = [] as any;
                for (let item of _data["locationNumbers"])
                    this.locationNumbers!.push(item);
            }
            else {
                this.locationNumbers = null as any;
            }
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null as any;
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [] as any;
                for (let item of _data["suppliers"])
                    this.suppliers!.push(item);
            }
            else {
                this.suppliers = null as any;
            }
            this.serviceStart = _data["serviceStart"] ? moment(_data["serviceStart"].toString()) : null as any;
            this.serviceEnd = _data["serviceEnd"] ? moment(_data["serviceEnd"].toString()) : null as any;
            this.serviceDepoymentId = _data["serviceDepoymentId"] !== undefined ? _data["serviceDepoymentId"] : null as any;
            this.flag = _data["flag"] !== undefined ? _data["flag"] : null as any;
            if (Array.isArray(_data["employeeNumbers"])) {
                this.employeeNumbers = [] as any;
                for (let item of _data["employeeNumbers"])
                    this.employeeNumbers!.push(item);
            }
            else {
                this.employeeNumbers = null as any;
            }
            this.locationNumber = _data["locationNumber"] !== undefined ? _data["locationNumber"] : null as any;
            this.visitOverview = _data["visitOverview"] !== undefined ? _data["visitOverview"] : null as any;
            this.completed = _data["completed"] !== undefined ? _data["completed"] : null as any;
            this.taskResult = _data["taskResult"] ? TaskResultModel.fromJS(_data["taskResult"]) : null as any;
            this.showSuppliers = _data["showSuppliers"] !== undefined ? _data["showSuppliers"] : null as any;
            this.tasksCompleteCount = _data["tasksCompleteCount"] !== undefined ? _data["tasksCompleteCount"] : null as any;
            this.serviceDeploymentName = _data["serviceDeploymentName"] !== undefined ? _data["serviceDeploymentName"] : null as any;
            this.serviceDeploymentRefNumber = _data["serviceDeploymentRefNumber"] !== undefined ? _data["serviceDeploymentRefNumber"] : null as any;
            this.rating = _data["rating"] !== undefined ? _data["rating"] : null as any;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : null as any;
            if (Array.isArray(_data["photoValues"])) {
                this.photoValues = [] as any;
                for (let item of _data["photoValues"])
                    this.photoValues!.push(item);
            }
            else {
                this.photoValues = null as any;
            }
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
            if (Array.isArray(_data["upcs"])) {
                this.upcs = [] as any;
                for (let item of _data["upcs"])
                    this.upcs!.push(UpcViewModel.fromJS(item));
            }
            else {
                this.upcs = null as any;
            }
        }
    }

    static fromJS(data: any): ServiceTaskModel {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTaskModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["accountImageUrl"] = this.accountImageUrl !== undefined ? this.accountImageUrl : null as any;
        data["accountFieldGroup"] = this.accountFieldGroup !== undefined ? this.accountFieldGroup : null as any;
        data["accountStoreSupportNumber"] = this.accountStoreSupportNumber !== undefined ? this.accountStoreSupportNumber : null as any;
        data["serviceModel"] = this.serviceModel !== undefined ? this.serviceModel : null as any;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        if (Array.isArray(this.departments)) {
            data["departments"] = [];
            for (let item of this.departments)
                data["departments"].push(item ? item.toJSON() : null as any);
        }
        data["activity"] = this.activity !== undefined ? this.activity : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["estimate"] = this.estimate !== undefined ? this.estimate : null as any;
        if (Array.isArray(this.instructionUrls)) {
            data["instructionUrls"] = [];
            for (let item of this.instructionUrls)
                data["instructionUrls"].push(item ? item.toJSON() : null as any);
        }
        data["referenceNumber"] = this.referenceNumber !== undefined ? this.referenceNumber : null as any;
        data["locationRefNumber"] = this.locationRefNumber !== undefined ? this.locationRefNumber : null as any;
        if (Array.isArray(this.locationNumbers)) {
            data["locationNumbers"] = [];
            for (let item of this.locationNumbers)
                data["locationNumbers"].push(item);
        }
        data["isActive"] = this.isActive !== undefined ? this.isActive : null as any;
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item);
        }
        data["serviceStart"] = this.serviceStart ? this.serviceStart.toISOString() : null as any;
        data["serviceEnd"] = this.serviceEnd ? this.serviceEnd.toISOString() : null as any;
        data["serviceDepoymentId"] = this.serviceDepoymentId !== undefined ? this.serviceDepoymentId : null as any;
        data["flag"] = this.flag !== undefined ? this.flag : null as any;
        if (Array.isArray(this.employeeNumbers)) {
            data["employeeNumbers"] = [];
            for (let item of this.employeeNumbers)
                data["employeeNumbers"].push(item);
        }
        data["locationNumber"] = this.locationNumber !== undefined ? this.locationNumber : null as any;
        data["visitOverview"] = this.visitOverview !== undefined ? this.visitOverview : null as any;
        data["completed"] = this.completed !== undefined ? this.completed : null as any;
        data["taskResult"] = this.taskResult ? this.taskResult.toJSON() : null as any;
        data["showSuppliers"] = this.showSuppliers !== undefined ? this.showSuppliers : null as any;
        data["tasksCompleteCount"] = this.tasksCompleteCount !== undefined ? this.tasksCompleteCount : null as any;
        data["serviceDeploymentName"] = this.serviceDeploymentName !== undefined ? this.serviceDeploymentName : null as any;
        data["serviceDeploymentRefNumber"] = this.serviceDeploymentRefNumber !== undefined ? this.serviceDeploymentRefNumber : null as any;
        data["rating"] = this.rating !== undefined ? this.rating : null as any;
        data["comments"] = this.comments !== undefined ? this.comments : null as any;
        if (Array.isArray(this.photoValues)) {
            data["photoValues"] = [];
            for (let item of this.photoValues)
                data["photoValues"].push(item);
        }
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        if (Array.isArray(this.upcs)) {
            data["upcs"] = [];
            for (let item of this.upcs)
                data["upcs"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): ServiceTaskModel {
        const json = this.toJSON();
        let result = new ServiceTaskModel();
        result.init(json);
        return result;
    }
}

export interface IServiceTaskModel {
    id?: string;
    name?: string | null;
    accountId?: number | null;
    accountName?: string | null;
    accountImageUrl?: string | null;
    accountFieldGroup?: string | null;
    accountStoreSupportNumber?: string | null;
    serviceModel?: string | null;
    categories?: string[] | null;
    departments?: Department2[] | null;
    activity?: string | null;
    note?: string | null;
    estimate?: number;
    instructionUrls?: Link[] | null;
    referenceNumber?: string | null;
    locationRefNumber?: string | null;
    locationNumbers?: string[] | null;
    isActive?: boolean;
    suppliers?: string[] | null;
    serviceStart?: moment.Moment;
    serviceEnd?: moment.Moment;
    serviceDepoymentId?: string;
    flag?: boolean;
    employeeNumbers?: string[] | null;
    locationNumber?: string | null;
    visitOverview?: string | null;
    completed?: boolean;
    taskResult?: TaskResultModel | null;
    showSuppliers?: boolean;
    tasksCompleteCount?: number;
    serviceDeploymentName?: string | null;
    serviceDeploymentRefNumber?: string | null;
    rating?: boolean;
    comments?: string | null;
    photoValues?: string[] | null;
    reason?: string | null;
    upcs?: UpcViewModel[] | null;
}

export class Department2 implements IDepartment2 {
    id?: number;
    name?: string | null;
    number?: string | null;

    constructor(data?: IDepartment2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.number = _data["number"] !== undefined ? _data["number"] : null as any;
        }
    }

    static fromJS(data: any): Department2 {
        data = typeof data === 'object' ? data : {};
        let result = new Department2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["number"] = this.number !== undefined ? this.number : null as any;
        return data;
    }

    clone(): Department2 {
        const json = this.toJSON();
        let result = new Department2();
        result.init(json);
        return result;
    }
}

export interface IDepartment2 {
    id?: number;
    name?: string | null;
    number?: string | null;
}

export class TaskResultModel implements ITaskResultModel {
    serviceTask?: ServiceTaskModel | null;
    completedReason?: string | null;
    completionDate?: moment.Moment | null;
    repInfo?: FieldRepInformation | null;
    actualMinutes?: number | null;
    updatedDate?: moment.Moment | null;

    constructor(data?: ITaskResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceTask = _data["serviceTask"] ? ServiceTaskModel.fromJS(_data["serviceTask"]) : null as any;
            this.completedReason = _data["completedReason"] !== undefined ? _data["completedReason"] : null as any;
            this.completionDate = _data["completionDate"] ? moment(_data["completionDate"].toString()) : null as any;
            this.repInfo = _data["repInfo"] ? FieldRepInformation.fromJS(_data["repInfo"]) : null as any;
            this.actualMinutes = _data["actualMinutes"] !== undefined ? _data["actualMinutes"] : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): TaskResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceTask"] = this.serviceTask ? this.serviceTask.toJSON() : null as any;
        data["completedReason"] = this.completedReason !== undefined ? this.completedReason : null as any;
        data["completionDate"] = this.completionDate ? this.completionDate.toISOString() : null as any;
        data["repInfo"] = this.repInfo ? this.repInfo.toJSON() : null as any;
        data["actualMinutes"] = this.actualMinutes !== undefined ? this.actualMinutes : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        return data;
    }

    clone(): TaskResultModel {
        const json = this.toJSON();
        let result = new TaskResultModel();
        result.init(json);
        return result;
    }
}

export interface ITaskResultModel {
    serviceTask?: ServiceTaskModel | null;
    completedReason?: string | null;
    completionDate?: moment.Moment | null;
    repInfo?: FieldRepInformation | null;
    actualMinutes?: number | null;
    updatedDate?: moment.Moment | null;
}

export class FieldRepInformation implements IFieldRepInformation {
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    imageUrl?: string | null;
    accountId?: string | null;
    accountName?: string | null;
    accountAbbreviation?: string | null;
    accountImageUrl?: string | null;
    fieldGroup?: string | null;

    constructor(data?: IFieldRepInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.accountAbbreviation = _data["accountAbbreviation"] !== undefined ? _data["accountAbbreviation"] : null as any;
            this.accountImageUrl = _data["accountImageUrl"] !== undefined ? _data["accountImageUrl"] : null as any;
            this.fieldGroup = _data["fieldGroup"] !== undefined ? _data["fieldGroup"] : null as any;
        }
    }

    static fromJS(data: any): FieldRepInformation {
        data = typeof data === 'object' ? data : {};
        let result = new FieldRepInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["accountAbbreviation"] = this.accountAbbreviation !== undefined ? this.accountAbbreviation : null as any;
        data["accountImageUrl"] = this.accountImageUrl !== undefined ? this.accountImageUrl : null as any;
        data["fieldGroup"] = this.fieldGroup !== undefined ? this.fieldGroup : null as any;
        return data;
    }

    clone(): FieldRepInformation {
        const json = this.toJSON();
        let result = new FieldRepInformation();
        result.init(json);
        return result;
    }
}

export interface IFieldRepInformation {
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    imageUrl?: string | null;
    accountId?: string | null;
    accountName?: string | null;
    accountAbbreviation?: string | null;
    accountImageUrl?: string | null;
    fieldGroup?: string | null;
}

export class UpcViewModel implements IUpcViewModel {
    action?: string | null;
    upcs?: string[] | null;

    constructor(data?: IUpcViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"] !== undefined ? _data["action"] : null as any;
            if (Array.isArray(_data["upcs"])) {
                this.upcs = [] as any;
                for (let item of _data["upcs"])
                    this.upcs!.push(item);
            }
            else {
                this.upcs = null as any;
            }
        }
    }

    static fromJS(data: any): UpcViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpcViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action !== undefined ? this.action : null as any;
        if (Array.isArray(this.upcs)) {
            data["upcs"] = [];
            for (let item of this.upcs)
                data["upcs"].push(item);
        }
        return data;
    }

    clone(): UpcViewModel {
        const json = this.toJSON();
        let result = new UpcViewModel();
        result.init(json);
        return result;
    }
}

export interface IUpcViewModel {
    action?: string | null;
    upcs?: string[] | null;
}

export class TaskLocationSummary implements ITaskLocationSummary {
    id?: string;
    activity?: string | null;
    taskName?: string | null;
    departments?: Department2[] | null;
    accountName?: string | null;
    accountStoreSupportNumber?: string | null;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    completed?: boolean;
    flagged?: boolean;
    estimate?: number;
    scheduleImportant?: number | null;
    storeNumber?: string | null;
    tags?: string[] | null;

    constructor(data?: ITaskLocationSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.activity = _data["activity"] !== undefined ? _data["activity"] : null as any;
            this.taskName = _data["taskName"] !== undefined ? _data["taskName"] : null as any;
            if (Array.isArray(_data["departments"])) {
                this.departments = [] as any;
                for (let item of _data["departments"])
                    this.departments!.push(Department2.fromJS(item));
            }
            else {
                this.departments = null as any;
            }
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.accountStoreSupportNumber = _data["accountStoreSupportNumber"] !== undefined ? _data["accountStoreSupportNumber"] : null as any;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : null as any;
            this.completed = _data["completed"] !== undefined ? _data["completed"] : null as any;
            this.flagged = _data["flagged"] !== undefined ? _data["flagged"] : null as any;
            this.estimate = _data["estimate"] !== undefined ? _data["estimate"] : null as any;
            this.scheduleImportant = _data["scheduleImportant"] !== undefined ? _data["scheduleImportant"] : null as any;
            this.storeNumber = _data["storeNumber"] !== undefined ? _data["storeNumber"] : null as any;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            else {
                this.tags = null as any;
            }
        }
    }

    static fromJS(data: any): TaskLocationSummary {
        data = typeof data === 'object' ? data : {};
        let result = new TaskLocationSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["activity"] = this.activity !== undefined ? this.activity : null as any;
        data["taskName"] = this.taskName !== undefined ? this.taskName : null as any;
        if (Array.isArray(this.departments)) {
            data["departments"] = [];
            for (let item of this.departments)
                data["departments"].push(item ? item.toJSON() : null as any);
        }
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["accountStoreSupportNumber"] = this.accountStoreSupportNumber !== undefined ? this.accountStoreSupportNumber : null as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        data["completed"] = this.completed !== undefined ? this.completed : null as any;
        data["flagged"] = this.flagged !== undefined ? this.flagged : null as any;
        data["estimate"] = this.estimate !== undefined ? this.estimate : null as any;
        data["scheduleImportant"] = this.scheduleImportant !== undefined ? this.scheduleImportant : null as any;
        data["storeNumber"] = this.storeNumber !== undefined ? this.storeNumber : null as any;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }

    clone(): TaskLocationSummary {
        const json = this.toJSON();
        let result = new TaskLocationSummary();
        result.init(json);
        return result;
    }
}

export interface ITaskLocationSummary {
    id?: string;
    activity?: string | null;
    taskName?: string | null;
    departments?: Department2[] | null;
    accountName?: string | null;
    accountStoreSupportNumber?: string | null;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    completed?: boolean;
    flagged?: boolean;
    estimate?: number;
    scheduleImportant?: number | null;
    storeNumber?: string | null;
    tags?: string[] | null;
}

export class ServiceTaskSummary implements IServiceTaskSummary {
    id?: string;
    activity?: string | null;
    taskName?: string | null;
    departments?: Department2[] | null;
    accountName?: string | null;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    completed?: boolean;
    flagged?: boolean;
    scheduleImportant?: number;
    estimate?: number;

    constructor(data?: IServiceTaskSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.activity = _data["activity"] !== undefined ? _data["activity"] : null as any;
            this.taskName = _data["taskName"] !== undefined ? _data["taskName"] : null as any;
            if (Array.isArray(_data["departments"])) {
                this.departments = [] as any;
                for (let item of _data["departments"])
                    this.departments!.push(Department2.fromJS(item));
            }
            else {
                this.departments = null as any;
            }
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : null as any;
            this.completed = _data["completed"] !== undefined ? _data["completed"] : null as any;
            this.flagged = _data["flagged"] !== undefined ? _data["flagged"] : null as any;
            this.scheduleImportant = _data["scheduleImportant"] !== undefined ? _data["scheduleImportant"] : null as any;
            this.estimate = _data["estimate"] !== undefined ? _data["estimate"] : null as any;
        }
    }

    static fromJS(data: any): ServiceTaskSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTaskSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["activity"] = this.activity !== undefined ? this.activity : null as any;
        data["taskName"] = this.taskName !== undefined ? this.taskName : null as any;
        if (Array.isArray(this.departments)) {
            data["departments"] = [];
            for (let item of this.departments)
                data["departments"].push(item ? item.toJSON() : null as any);
        }
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        data["completed"] = this.completed !== undefined ? this.completed : null as any;
        data["flagged"] = this.flagged !== undefined ? this.flagged : null as any;
        data["scheduleImportant"] = this.scheduleImportant !== undefined ? this.scheduleImportant : null as any;
        data["estimate"] = this.estimate !== undefined ? this.estimate : null as any;
        return data;
    }

    clone(): ServiceTaskSummary {
        const json = this.toJSON();
        let result = new ServiceTaskSummary();
        result.init(json);
        return result;
    }
}

export interface IServiceTaskSummary {
    id?: string;
    activity?: string | null;
    taskName?: string | null;
    departments?: Department2[] | null;
    accountName?: string | null;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    completed?: boolean;
    flagged?: boolean;
    scheduleImportant?: number;
    estimate?: number;
}

export class ServiceTaskDashboardFilter implements IServiceTaskDashboardFilter {
    departmentFilter?: DepartmentFilterModel | null;
    includeComplete?: boolean;
    includeContinutity?: boolean;
    showAll?: boolean;
    dateRange?: DateRange | null;
    accountId?: number | null;

    constructor(data?: IServiceTaskDashboardFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departmentFilter = _data["departmentFilter"] ? DepartmentFilterModel.fromJS(_data["departmentFilter"]) : null as any;
            this.includeComplete = _data["includeComplete"] !== undefined ? _data["includeComplete"] : null as any;
            this.includeContinutity = _data["includeContinutity"] !== undefined ? _data["includeContinutity"] : null as any;
            this.showAll = _data["showAll"] !== undefined ? _data["showAll"] : null as any;
            this.dateRange = _data["dateRange"] ? DateRange.fromJS(_data["dateRange"]) : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
        }
    }

    static fromJS(data: any): ServiceTaskDashboardFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTaskDashboardFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentFilter"] = this.departmentFilter ? this.departmentFilter.toJSON() : null as any;
        data["includeComplete"] = this.includeComplete !== undefined ? this.includeComplete : null as any;
        data["includeContinutity"] = this.includeContinutity !== undefined ? this.includeContinutity : null as any;
        data["showAll"] = this.showAll !== undefined ? this.showAll : null as any;
        data["dateRange"] = this.dateRange ? this.dateRange.toJSON() : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        return data;
    }

    clone(): ServiceTaskDashboardFilter {
        const json = this.toJSON();
        let result = new ServiceTaskDashboardFilter();
        result.init(json);
        return result;
    }
}

export interface IServiceTaskDashboardFilter {
    departmentFilter?: DepartmentFilterModel | null;
    includeComplete?: boolean;
    includeContinutity?: boolean;
    showAll?: boolean;
    dateRange?: DateRange | null;
    accountId?: number | null;
}

export class ServiceTaskByPspModel implements IServiceTaskByPspModel {
    accountId?: number;
    name?: string | null;
    tasksTotal?: number;
    estimateTotal?: number;

    constructor(data?: IServiceTaskByPspModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.tasksTotal = _data["tasksTotal"] !== undefined ? _data["tasksTotal"] : null as any;
            this.estimateTotal = _data["estimateTotal"] !== undefined ? _data["estimateTotal"] : null as any;
        }
    }

    static fromJS(data: any): ServiceTaskByPspModel {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTaskByPspModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["tasksTotal"] = this.tasksTotal !== undefined ? this.tasksTotal : null as any;
        data["estimateTotal"] = this.estimateTotal !== undefined ? this.estimateTotal : null as any;
        return data;
    }

    clone(): ServiceTaskByPspModel {
        const json = this.toJSON();
        let result = new ServiceTaskByPspModel();
        result.init(json);
        return result;
    }
}

export interface IServiceTaskByPspModel {
    accountId?: number;
    name?: string | null;
    tasksTotal?: number;
    estimateTotal?: number;
}

export class ServiceTaskPspBreakdown implements IServiceTaskPspBreakdown {
    activity?: string | null;
    estimate?: number;
    count?: number;

    constructor(data?: IServiceTaskPspBreakdown) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activity = _data["activity"] !== undefined ? _data["activity"] : null as any;
            this.estimate = _data["estimate"] !== undefined ? _data["estimate"] : null as any;
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
        }
    }

    static fromJS(data: any): ServiceTaskPspBreakdown {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTaskPspBreakdown();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activity"] = this.activity !== undefined ? this.activity : null as any;
        data["estimate"] = this.estimate !== undefined ? this.estimate : null as any;
        data["count"] = this.count !== undefined ? this.count : null as any;
        return data;
    }

    clone(): ServiceTaskPspBreakdown {
        const json = this.toJSON();
        let result = new ServiceTaskPspBreakdown();
        result.init(json);
        return result;
    }
}

export interface IServiceTaskPspBreakdown {
    activity?: string | null;
    estimate?: number;
    count?: number;
}

export class SupplierTaskTime implements ISupplierTaskTime {
    averageEstimatedMinutes?: number;
    averageActualMinutes?: number;
    totalEstimatedMinutes?: number;
    totalActualMinutes?: number;

    constructor(data?: ISupplierTaskTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.averageEstimatedMinutes = _data["averageEstimatedMinutes"] !== undefined ? _data["averageEstimatedMinutes"] : null as any;
            this.averageActualMinutes = _data["averageActualMinutes"] !== undefined ? _data["averageActualMinutes"] : null as any;
            this.totalEstimatedMinutes = _data["totalEstimatedMinutes"] !== undefined ? _data["totalEstimatedMinutes"] : null as any;
            this.totalActualMinutes = _data["totalActualMinutes"] !== undefined ? _data["totalActualMinutes"] : null as any;
        }
    }

    static fromJS(data: any): SupplierTaskTime {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierTaskTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["averageEstimatedMinutes"] = this.averageEstimatedMinutes !== undefined ? this.averageEstimatedMinutes : null as any;
        data["averageActualMinutes"] = this.averageActualMinutes !== undefined ? this.averageActualMinutes : null as any;
        data["totalEstimatedMinutes"] = this.totalEstimatedMinutes !== undefined ? this.totalEstimatedMinutes : null as any;
        data["totalActualMinutes"] = this.totalActualMinutes !== undefined ? this.totalActualMinutes : null as any;
        return data;
    }

    clone(): SupplierTaskTime {
        const json = this.toJSON();
        let result = new SupplierTaskTime();
        result.init(json);
        return result;
    }
}

export interface ISupplierTaskTime {
    averageEstimatedMinutes?: number;
    averageActualMinutes?: number;
    totalEstimatedMinutes?: number;
    totalActualMinutes?: number;
}

export class SupplierTasksTimeByActivity extends SupplierTaskTime implements ISupplierTasksTimeByActivity {
    activity?: string | null;
    completedDate?: moment.Moment;

    constructor(data?: ISupplierTasksTimeByActivity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activity = _data["activity"] !== undefined ? _data["activity"] : null as any;
            this.completedDate = _data["completedDate"] ? moment(_data["completedDate"].toString()) : null as any;
        }
    }

    static override fromJS(data: any): SupplierTasksTimeByActivity {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierTasksTimeByActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activity"] = this.activity !== undefined ? this.activity : null as any;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): SupplierTasksTimeByActivity {
        const json = this.toJSON();
        let result = new SupplierTasksTimeByActivity();
        result.init(json);
        return result;
    }
}

export interface ISupplierTasksTimeByActivity extends ISupplierTaskTime {
    activity?: string | null;
    completedDate?: moment.Moment;
}

export class ServiceTask implements IServiceTask {
    id?: string;
    name?: string | null;
    serviceModel?: string | null;
    categories?: string[] | null;
    departments?: Department2[] | null;
    activity?: string | null;
    note?: string | null;
    estimate?: number;
    actualMinutes?: number | null;
    instructionUrls?: Link[] | null;
    referenceNumber?: string | null;
    isActive?: boolean;
    suppliers?: string[] | null;
    serviceStart?: moment.Moment;
    serviceEnd?: moment.Moment;
    serviceDepoymentId?: string;
    flag?: boolean;
    visitOverview?: string | null;
    completed?: boolean;
    completedReason?: string | null;
    completedByEmployeeNumber?: string | null;
    showSuppliers?: boolean;

    constructor(data?: IServiceTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.serviceModel = _data["serviceModel"] !== undefined ? _data["serviceModel"] : null as any;
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(item);
            }
            else {
                this.categories = null as any;
            }
            if (Array.isArray(_data["departments"])) {
                this.departments = [] as any;
                for (let item of _data["departments"])
                    this.departments!.push(Department2.fromJS(item));
            }
            else {
                this.departments = null as any;
            }
            this.activity = _data["activity"] !== undefined ? _data["activity"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.estimate = _data["estimate"] !== undefined ? _data["estimate"] : null as any;
            this.actualMinutes = _data["actualMinutes"] !== undefined ? _data["actualMinutes"] : null as any;
            if (Array.isArray(_data["instructionUrls"])) {
                this.instructionUrls = [] as any;
                for (let item of _data["instructionUrls"])
                    this.instructionUrls!.push(Link.fromJS(item));
            }
            else {
                this.instructionUrls = null as any;
            }
            this.referenceNumber = _data["referenceNumber"] !== undefined ? _data["referenceNumber"] : null as any;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null as any;
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [] as any;
                for (let item of _data["suppliers"])
                    this.suppliers!.push(item);
            }
            else {
                this.suppliers = null as any;
            }
            this.serviceStart = _data["serviceStart"] ? moment(_data["serviceStart"].toString()) : null as any;
            this.serviceEnd = _data["serviceEnd"] ? moment(_data["serviceEnd"].toString()) : null as any;
            this.serviceDepoymentId = _data["serviceDepoymentId"] !== undefined ? _data["serviceDepoymentId"] : null as any;
            this.flag = _data["flag"] !== undefined ? _data["flag"] : null as any;
            this.visitOverview = _data["visitOverview"] !== undefined ? _data["visitOverview"] : null as any;
            this.completed = _data["completed"] !== undefined ? _data["completed"] : null as any;
            this.completedReason = _data["completedReason"] !== undefined ? _data["completedReason"] : null as any;
            this.completedByEmployeeNumber = _data["completedByEmployeeNumber"] !== undefined ? _data["completedByEmployeeNumber"] : null as any;
            this.showSuppliers = _data["showSuppliers"] !== undefined ? _data["showSuppliers"] : null as any;
        }
    }

    static fromJS(data: any): ServiceTask {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["serviceModel"] = this.serviceModel !== undefined ? this.serviceModel : null as any;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        if (Array.isArray(this.departments)) {
            data["departments"] = [];
            for (let item of this.departments)
                data["departments"].push(item ? item.toJSON() : null as any);
        }
        data["activity"] = this.activity !== undefined ? this.activity : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["estimate"] = this.estimate !== undefined ? this.estimate : null as any;
        data["actualMinutes"] = this.actualMinutes !== undefined ? this.actualMinutes : null as any;
        if (Array.isArray(this.instructionUrls)) {
            data["instructionUrls"] = [];
            for (let item of this.instructionUrls)
                data["instructionUrls"].push(item ? item.toJSON() : null as any);
        }
        data["referenceNumber"] = this.referenceNumber !== undefined ? this.referenceNumber : null as any;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null as any;
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item);
        }
        data["serviceStart"] = this.serviceStart ? this.serviceStart.toISOString() : null as any;
        data["serviceEnd"] = this.serviceEnd ? this.serviceEnd.toISOString() : null as any;
        data["serviceDepoymentId"] = this.serviceDepoymentId !== undefined ? this.serviceDepoymentId : null as any;
        data["flag"] = this.flag !== undefined ? this.flag : null as any;
        data["visitOverview"] = this.visitOverview !== undefined ? this.visitOverview : null as any;
        data["completed"] = this.completed !== undefined ? this.completed : null as any;
        data["completedReason"] = this.completedReason !== undefined ? this.completedReason : null as any;
        data["completedByEmployeeNumber"] = this.completedByEmployeeNumber !== undefined ? this.completedByEmployeeNumber : null as any;
        data["showSuppliers"] = this.showSuppliers !== undefined ? this.showSuppliers : null as any;
        return data;
    }

    clone(): ServiceTask {
        const json = this.toJSON();
        let result = new ServiceTask();
        result.init(json);
        return result;
    }
}

export interface IServiceTask {
    id?: string;
    name?: string | null;
    serviceModel?: string | null;
    categories?: string[] | null;
    departments?: Department2[] | null;
    activity?: string | null;
    note?: string | null;
    estimate?: number;
    actualMinutes?: number | null;
    instructionUrls?: Link[] | null;
    referenceNumber?: string | null;
    isActive?: boolean;
    suppliers?: string[] | null;
    serviceStart?: moment.Moment;
    serviceEnd?: moment.Moment;
    serviceDepoymentId?: string;
    flag?: boolean;
    visitOverview?: string | null;
    completed?: boolean;
    completedReason?: string | null;
    completedByEmployeeNumber?: string | null;
    showSuppliers?: boolean;
}

export class RetailtainmentServiceTaskViewModel implements IRetailtainmentServiceTaskViewModel {
    id?: string;
    eventName?: string | null;
    eventType?: string | null;
    eventLocation?: string | null;
    activity?: string | null;
    strategicBusinessUnit?: string | null;
    serviceStart?: moment.Moment;
    serviceEnd?: moment.Moment;
    buyersName?: string | null;
    agency?: string | null;
    agencyContactViewModel?: AgencyContactViewModel | null;
    suppliers?: string[] | null;
    storeManagerResponsibilitiesViewModel?: StoreManagerResponsibilitiesViewModel | null;
    supplierContactEmail?: string | null;
    eventEstimatedMinutesPerStore?: number;
    overviewPdf?: string | null;
    overviewNote?: string | null;
    locationNumbers?: string[] | null;
    eventReferenceNumber?: string | null;
    upcs?: UpcViewModel[] | null;
    taskCompleteCount?: number;
    accountName?: string | null;
    accountStoreSupportNumber?: string | null;
    accountImageUrl?: string | null;
    accountFieldGroup?: string | null;

    constructor(data?: IRetailtainmentServiceTaskViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.eventName = _data["eventName"] !== undefined ? _data["eventName"] : null as any;
            this.eventType = _data["eventType"] !== undefined ? _data["eventType"] : null as any;
            this.eventLocation = _data["eventLocation"] !== undefined ? _data["eventLocation"] : null as any;
            this.activity = _data["activity"] !== undefined ? _data["activity"] : null as any;
            this.strategicBusinessUnit = _data["strategicBusinessUnit"] !== undefined ? _data["strategicBusinessUnit"] : null as any;
            this.serviceStart = _data["serviceStart"] ? moment(_data["serviceStart"].toString()) : null as any;
            this.serviceEnd = _data["serviceEnd"] ? moment(_data["serviceEnd"].toString()) : null as any;
            this.buyersName = _data["buyersName"] !== undefined ? _data["buyersName"] : null as any;
            this.agency = _data["agency"] !== undefined ? _data["agency"] : null as any;
            this.agencyContactViewModel = _data["agencyContactViewModel"] ? AgencyContactViewModel.fromJS(_data["agencyContactViewModel"]) : null as any;
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [] as any;
                for (let item of _data["suppliers"])
                    this.suppliers!.push(item);
            }
            else {
                this.suppliers = null as any;
            }
            this.storeManagerResponsibilitiesViewModel = _data["storeManagerResponsibilitiesViewModel"] ? StoreManagerResponsibilitiesViewModel.fromJS(_data["storeManagerResponsibilitiesViewModel"]) : null as any;
            this.supplierContactEmail = _data["supplierContactEmail"] !== undefined ? _data["supplierContactEmail"] : null as any;
            this.eventEstimatedMinutesPerStore = _data["eventEstimatedMinutesPerStore"] !== undefined ? _data["eventEstimatedMinutesPerStore"] : null as any;
            this.overviewPdf = _data["overviewPdf"] !== undefined ? _data["overviewPdf"] : null as any;
            this.overviewNote = _data["overviewNote"] !== undefined ? _data["overviewNote"] : null as any;
            if (Array.isArray(_data["locationNumbers"])) {
                this.locationNumbers = [] as any;
                for (let item of _data["locationNumbers"])
                    this.locationNumbers!.push(item);
            }
            else {
                this.locationNumbers = null as any;
            }
            this.eventReferenceNumber = _data["eventReferenceNumber"] !== undefined ? _data["eventReferenceNumber"] : null as any;
            if (Array.isArray(_data["upcs"])) {
                this.upcs = [] as any;
                for (let item of _data["upcs"])
                    this.upcs!.push(UpcViewModel.fromJS(item));
            }
            else {
                this.upcs = null as any;
            }
            this.taskCompleteCount = _data["taskCompleteCount"] !== undefined ? _data["taskCompleteCount"] : null as any;
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.accountStoreSupportNumber = _data["accountStoreSupportNumber"] !== undefined ? _data["accountStoreSupportNumber"] : null as any;
            this.accountImageUrl = _data["accountImageUrl"] !== undefined ? _data["accountImageUrl"] : null as any;
            this.accountFieldGroup = _data["accountFieldGroup"] !== undefined ? _data["accountFieldGroup"] : null as any;
        }
    }

    static fromJS(data: any): RetailtainmentServiceTaskViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RetailtainmentServiceTaskViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["eventName"] = this.eventName !== undefined ? this.eventName : null as any;
        data["eventType"] = this.eventType !== undefined ? this.eventType : null as any;
        data["eventLocation"] = this.eventLocation !== undefined ? this.eventLocation : null as any;
        data["activity"] = this.activity !== undefined ? this.activity : null as any;
        data["strategicBusinessUnit"] = this.strategicBusinessUnit !== undefined ? this.strategicBusinessUnit : null as any;
        data["serviceStart"] = this.serviceStart ? this.serviceStart.toISOString() : null as any;
        data["serviceEnd"] = this.serviceEnd ? this.serviceEnd.toISOString() : null as any;
        data["buyersName"] = this.buyersName !== undefined ? this.buyersName : null as any;
        data["agency"] = this.agency !== undefined ? this.agency : null as any;
        data["agencyContactViewModel"] = this.agencyContactViewModel ? this.agencyContactViewModel.toJSON() : null as any;
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item);
        }
        data["storeManagerResponsibilitiesViewModel"] = this.storeManagerResponsibilitiesViewModel ? this.storeManagerResponsibilitiesViewModel.toJSON() : null as any;
        data["supplierContactEmail"] = this.supplierContactEmail !== undefined ? this.supplierContactEmail : null as any;
        data["eventEstimatedMinutesPerStore"] = this.eventEstimatedMinutesPerStore !== undefined ? this.eventEstimatedMinutesPerStore : null as any;
        data["overviewPdf"] = this.overviewPdf !== undefined ? this.overviewPdf : null as any;
        data["overviewNote"] = this.overviewNote !== undefined ? this.overviewNote : null as any;
        if (Array.isArray(this.locationNumbers)) {
            data["locationNumbers"] = [];
            for (let item of this.locationNumbers)
                data["locationNumbers"].push(item);
        }
        data["eventReferenceNumber"] = this.eventReferenceNumber !== undefined ? this.eventReferenceNumber : null as any;
        if (Array.isArray(this.upcs)) {
            data["upcs"] = [];
            for (let item of this.upcs)
                data["upcs"].push(item ? item.toJSON() : null as any);
        }
        data["taskCompleteCount"] = this.taskCompleteCount !== undefined ? this.taskCompleteCount : null as any;
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["accountStoreSupportNumber"] = this.accountStoreSupportNumber !== undefined ? this.accountStoreSupportNumber : null as any;
        data["accountImageUrl"] = this.accountImageUrl !== undefined ? this.accountImageUrl : null as any;
        data["accountFieldGroup"] = this.accountFieldGroup !== undefined ? this.accountFieldGroup : null as any;
        return data;
    }

    clone(): RetailtainmentServiceTaskViewModel {
        const json = this.toJSON();
        let result = new RetailtainmentServiceTaskViewModel();
        result.init(json);
        return result;
    }
}

export interface IRetailtainmentServiceTaskViewModel {
    id?: string;
    eventName?: string | null;
    eventType?: string | null;
    eventLocation?: string | null;
    activity?: string | null;
    strategicBusinessUnit?: string | null;
    serviceStart?: moment.Moment;
    serviceEnd?: moment.Moment;
    buyersName?: string | null;
    agency?: string | null;
    agencyContactViewModel?: AgencyContactViewModel | null;
    suppliers?: string[] | null;
    storeManagerResponsibilitiesViewModel?: StoreManagerResponsibilitiesViewModel | null;
    supplierContactEmail?: string | null;
    eventEstimatedMinutesPerStore?: number;
    overviewPdf?: string | null;
    overviewNote?: string | null;
    locationNumbers?: string[] | null;
    eventReferenceNumber?: string | null;
    upcs?: UpcViewModel[] | null;
    taskCompleteCount?: number;
    accountName?: string | null;
    accountStoreSupportNumber?: string | null;
    accountImageUrl?: string | null;
    accountFieldGroup?: string | null;
}

export class AgencyContactViewModel implements IAgencyContactViewModel {
    name?: string | null;
    email?: string | null;
    phoneNumber?: string | null;

    constructor(data?: IAgencyContactViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : null as any;
        }
    }

    static fromJS(data: any): AgencyContactViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyContactViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null as any;
        return data;
    }

    clone(): AgencyContactViewModel {
        const json = this.toJSON();
        let result = new AgencyContactViewModel();
        result.init(json);
        return result;
    }
}

export interface IAgencyContactViewModel {
    name?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
}

export class StoreManagerResponsibilitiesViewModel implements IStoreManagerResponsibilitiesViewModel {
    fileLocation?: string | null;
    instructions?: string | null;

    constructor(data?: IStoreManagerResponsibilitiesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileLocation = _data["fileLocation"] !== undefined ? _data["fileLocation"] : null as any;
            this.instructions = _data["instructions"] !== undefined ? _data["instructions"] : null as any;
        }
    }

    static fromJS(data: any): StoreManagerResponsibilitiesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StoreManagerResponsibilitiesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileLocation"] = this.fileLocation !== undefined ? this.fileLocation : null as any;
        data["instructions"] = this.instructions !== undefined ? this.instructions : null as any;
        return data;
    }

    clone(): StoreManagerResponsibilitiesViewModel {
        const json = this.toJSON();
        let result = new StoreManagerResponsibilitiesViewModel();
        result.init(json);
        return result;
    }
}

export interface IStoreManagerResponsibilitiesViewModel {
    fileLocation?: string | null;
    instructions?: string | null;
}

export class SsrByCompanyPage implements ISsrByCompanyPage {
    companySsrUsage?: LimitedResultOfCompanySsrUsageViewModel | null;
    averageCompanySsrUsageByDate?: SsrByCompanyTrendLineViewModel[] | null;
    averageSsrUsagePercentage?: number | null;

    constructor(data?: ISsrByCompanyPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companySsrUsage = _data["companySsrUsage"] ? LimitedResultOfCompanySsrUsageViewModel.fromJS(_data["companySsrUsage"]) : null as any;
            if (Array.isArray(_data["averageCompanySsrUsageByDate"])) {
                this.averageCompanySsrUsageByDate = [] as any;
                for (let item of _data["averageCompanySsrUsageByDate"])
                    this.averageCompanySsrUsageByDate!.push(SsrByCompanyTrendLineViewModel.fromJS(item));
            }
            else {
                this.averageCompanySsrUsageByDate = null as any;
            }
            this.averageSsrUsagePercentage = _data["averageSsrUsagePercentage"] !== undefined ? _data["averageSsrUsagePercentage"] : null as any;
        }
    }

    static fromJS(data: any): SsrByCompanyPage {
        data = typeof data === 'object' ? data : {};
        let result = new SsrByCompanyPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companySsrUsage"] = this.companySsrUsage ? this.companySsrUsage.toJSON() : null as any;
        if (Array.isArray(this.averageCompanySsrUsageByDate)) {
            data["averageCompanySsrUsageByDate"] = [];
            for (let item of this.averageCompanySsrUsageByDate)
                data["averageCompanySsrUsageByDate"].push(item ? item.toJSON() : null as any);
        }
        data["averageSsrUsagePercentage"] = this.averageSsrUsagePercentage !== undefined ? this.averageSsrUsagePercentage : null as any;
        return data;
    }

    clone(): SsrByCompanyPage {
        const json = this.toJSON();
        let result = new SsrByCompanyPage();
        result.init(json);
        return result;
    }
}

export interface ISsrByCompanyPage {
    companySsrUsage?: LimitedResultOfCompanySsrUsageViewModel | null;
    averageCompanySsrUsageByDate?: SsrByCompanyTrendLineViewModel[] | null;
    averageSsrUsagePercentage?: number | null;
}

export class LimitedResultOfCompanySsrUsageViewModel implements ILimitedResultOfCompanySsrUsageViewModel {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: CompanySsrUsageViewModel[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfCompanySsrUsageViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CompanySsrUsageViewModel.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfCompanySsrUsageViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfCompanySsrUsageViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfCompanySsrUsageViewModel {
        const json = this.toJSON();
        let result = new LimitedResultOfCompanySsrUsageViewModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfCompanySsrUsageViewModel {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: CompanySsrUsageViewModel[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class CompanySsrUsageViewModel implements ICompanySsrUsageViewModel {
    accountName?: string | null;
    numberOfStoreVisits?: number;
    ssrUsage?: number;

    constructor(data?: ICompanySsrUsageViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.numberOfStoreVisits = _data["numberOfStoreVisits"] !== undefined ? _data["numberOfStoreVisits"] : null as any;
            this.ssrUsage = _data["ssrUsage"] !== undefined ? _data["ssrUsage"] : null as any;
        }
    }

    static fromJS(data: any): CompanySsrUsageViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanySsrUsageViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["numberOfStoreVisits"] = this.numberOfStoreVisits !== undefined ? this.numberOfStoreVisits : null as any;
        data["ssrUsage"] = this.ssrUsage !== undefined ? this.ssrUsage : null as any;
        return data;
    }

    clone(): CompanySsrUsageViewModel {
        const json = this.toJSON();
        let result = new CompanySsrUsageViewModel();
        result.init(json);
        return result;
    }
}

export interface ICompanySsrUsageViewModel {
    accountName?: string | null;
    numberOfStoreVisits?: number;
    ssrUsage?: number;
}

export class SsrByCompanyTrendLineViewModel implements ISsrByCompanyTrendLineViewModel {
    totalSsrUtilizationPercentage?: number | null;
    date?: moment.Moment;

    constructor(data?: ISsrByCompanyTrendLineViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalSsrUtilizationPercentage = _data["totalSsrUtilizationPercentage"] !== undefined ? _data["totalSsrUtilizationPercentage"] : null as any;
            this.date = _data["date"] ? moment(_data["date"].toString()) : null as any;
        }
    }

    static fromJS(data: any): SsrByCompanyTrendLineViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SsrByCompanyTrendLineViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalSsrUtilizationPercentage"] = this.totalSsrUtilizationPercentage !== undefined ? this.totalSsrUtilizationPercentage : null as any;
        data["date"] = this.date ? this.date.toISOString() : null as any;
        return data;
    }

    clone(): SsrByCompanyTrendLineViewModel {
        const json = this.toJSON();
        let result = new SsrByCompanyTrendLineViewModel();
        result.init(json);
        return result;
    }
}

export interface ISsrByCompanyTrendLineViewModel {
    totalSsrUtilizationPercentage?: number | null;
    date?: moment.Moment;
}

export class SsrByStorePage implements ISsrByStorePage {
    storeSsrUsage?: LimitedResultOfStoreSsrUsageViewModel | null;

    constructor(data?: ISsrByStorePage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeSsrUsage = _data["storeSsrUsage"] ? LimitedResultOfStoreSsrUsageViewModel.fromJS(_data["storeSsrUsage"]) : null as any;
        }
    }

    static fromJS(data: any): SsrByStorePage {
        data = typeof data === 'object' ? data : {};
        let result = new SsrByStorePage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeSsrUsage"] = this.storeSsrUsage ? this.storeSsrUsage.toJSON() : null as any;
        return data;
    }

    clone(): SsrByStorePage {
        const json = this.toJSON();
        let result = new SsrByStorePage();
        result.init(json);
        return result;
    }
}

export interface ISsrByStorePage {
    storeSsrUsage?: LimitedResultOfStoreSsrUsageViewModel | null;
}

export class LimitedResultOfStoreSsrUsageViewModel implements ILimitedResultOfStoreSsrUsageViewModel {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: StoreSsrUsageViewModel[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfStoreSsrUsageViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(StoreSsrUsageViewModel.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfStoreSsrUsageViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfStoreSsrUsageViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfStoreSsrUsageViewModel {
        const json = this.toJSON();
        let result = new LimitedResultOfStoreSsrUsageViewModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfStoreSsrUsageViewModel {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: StoreSsrUsageViewModel[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class StoreSsrUsageViewModel implements IStoreSsrUsageViewModel {
    accountName?: string | null;
    accountId?: number;
    storeNumber?: string | null;
    locationId?: number;
    locationTimeZone?: string | null;
    numberOfStoreVisits?: number;
    ssrUsage?: number | null;

    constructor(data?: IStoreSsrUsageViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.storeNumber = _data["storeNumber"] !== undefined ? _data["storeNumber"] : null as any;
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : null as any;
            this.locationTimeZone = _data["locationTimeZone"] !== undefined ? _data["locationTimeZone"] : null as any;
            this.numberOfStoreVisits = _data["numberOfStoreVisits"] !== undefined ? _data["numberOfStoreVisits"] : null as any;
            this.ssrUsage = _data["ssrUsage"] !== undefined ? _data["ssrUsage"] : null as any;
        }
    }

    static fromJS(data: any): StoreSsrUsageViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StoreSsrUsageViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["storeNumber"] = this.storeNumber !== undefined ? this.storeNumber : null as any;
        data["locationId"] = this.locationId !== undefined ? this.locationId : null as any;
        data["locationTimeZone"] = this.locationTimeZone !== undefined ? this.locationTimeZone : null as any;
        data["numberOfStoreVisits"] = this.numberOfStoreVisits !== undefined ? this.numberOfStoreVisits : null as any;
        data["ssrUsage"] = this.ssrUsage !== undefined ? this.ssrUsage : null as any;
        return data;
    }

    clone(): StoreSsrUsageViewModel {
        const json = this.toJSON();
        let result = new StoreSsrUsageViewModel();
        result.init(json);
        return result;
    }
}

export interface IStoreSsrUsageViewModel {
    accountName?: string | null;
    accountId?: number;
    storeNumber?: string | null;
    locationId?: number;
    locationTimeZone?: string | null;
    numberOfStoreVisits?: number;
    ssrUsage?: number | null;
}

export class LimitedResultOfStoreSsrUsageDetailsViewModel implements ILimitedResultOfStoreSsrUsageDetailsViewModel {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: StoreSsrUsageDetailsViewModel[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfStoreSsrUsageDetailsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(StoreSsrUsageDetailsViewModel.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfStoreSsrUsageDetailsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfStoreSsrUsageDetailsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfStoreSsrUsageDetailsViewModel {
        const json = this.toJSON();
        let result = new LimitedResultOfStoreSsrUsageDetailsViewModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfStoreSsrUsageDetailsViewModel {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: StoreSsrUsageDetailsViewModel[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class StoreSsrUsageDetailsViewModel implements IStoreSsrUsageDetailsViewModel {
    employeeNumber?: string | null;
    timeIn?: moment.Moment;
    timeOut?: moment.Moment;
    timeInStoreMs?: number;
    storeTimezone?: string | null;

    constructor(data?: IStoreSsrUsageDetailsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeNumber = _data["employeeNumber"] !== undefined ? _data["employeeNumber"] : null as any;
            this.timeIn = _data["timeIn"] ? moment(_data["timeIn"].toString()) : null as any;
            this.timeOut = _data["timeOut"] ? moment(_data["timeOut"].toString()) : null as any;
            this.timeInStoreMs = _data["timeInStoreMs"] !== undefined ? _data["timeInStoreMs"] : null as any;
            this.storeTimezone = _data["storeTimezone"] !== undefined ? _data["storeTimezone"] : null as any;
        }
    }

    static fromJS(data: any): StoreSsrUsageDetailsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StoreSsrUsageDetailsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeNumber"] = this.employeeNumber !== undefined ? this.employeeNumber : null as any;
        data["timeIn"] = this.timeIn ? this.timeIn.toISOString() : null as any;
        data["timeOut"] = this.timeOut ? this.timeOut.toISOString() : null as any;
        data["timeInStoreMs"] = this.timeInStoreMs !== undefined ? this.timeInStoreMs : null as any;
        data["storeTimezone"] = this.storeTimezone !== undefined ? this.storeTimezone : null as any;
        return data;
    }

    clone(): StoreSsrUsageDetailsViewModel {
        const json = this.toJSON();
        let result = new StoreSsrUsageDetailsViewModel();
        result.init(json);
        return result;
    }
}

export interface IStoreSsrUsageDetailsViewModel {
    employeeNumber?: string | null;
    timeIn?: moment.Moment;
    timeOut?: moment.Moment;
    timeInStoreMs?: number;
    storeTimezone?: string | null;
}

export class SsrByUserPage implements ISsrByUserPage {
    userSsrUsage?: LimitedResultOfSsrUsageByUserViewModel | null;

    constructor(data?: ISsrByUserPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userSsrUsage = _data["userSsrUsage"] ? LimitedResultOfSsrUsageByUserViewModel.fromJS(_data["userSsrUsage"]) : null as any;
        }
    }

    static fromJS(data: any): SsrByUserPage {
        data = typeof data === 'object' ? data : {};
        let result = new SsrByUserPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userSsrUsage"] = this.userSsrUsage ? this.userSsrUsage.toJSON() : null as any;
        return data;
    }

    clone(): SsrByUserPage {
        const json = this.toJSON();
        let result = new SsrByUserPage();
        result.init(json);
        return result;
    }
}

export interface ISsrByUserPage {
    userSsrUsage?: LimitedResultOfSsrUsageByUserViewModel | null;
}

export class LimitedResultOfSsrUsageByUserViewModel implements ILimitedResultOfSsrUsageByUserViewModel {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: SsrUsageByUserViewModel[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfSsrUsageByUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SsrUsageByUserViewModel.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfSsrUsageByUserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfSsrUsageByUserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfSsrUsageByUserViewModel {
        const json = this.toJSON();
        let result = new LimitedResultOfSsrUsageByUserViewModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfSsrUsageByUserViewModel {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: SsrUsageByUserViewModel[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class SsrUsageByUserViewModel implements ISsrUsageByUserViewModel {
    personId?: number;
    accountName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    employeeNumber?: string | null;
    numberOfStoreVisits?: number;
    ssrUsage?: number | null;

    constructor(data?: ISsrUsageByUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null as any;
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.employeeNumber = _data["employeeNumber"] !== undefined ? _data["employeeNumber"] : null as any;
            this.numberOfStoreVisits = _data["numberOfStoreVisits"] !== undefined ? _data["numberOfStoreVisits"] : null as any;
            this.ssrUsage = _data["ssrUsage"] !== undefined ? _data["ssrUsage"] : null as any;
        }
    }

    static fromJS(data: any): SsrUsageByUserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SsrUsageByUserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId !== undefined ? this.personId : null as any;
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["employeeNumber"] = this.employeeNumber !== undefined ? this.employeeNumber : null as any;
        data["numberOfStoreVisits"] = this.numberOfStoreVisits !== undefined ? this.numberOfStoreVisits : null as any;
        data["ssrUsage"] = this.ssrUsage !== undefined ? this.ssrUsage : null as any;
        return data;
    }

    clone(): SsrUsageByUserViewModel {
        const json = this.toJSON();
        let result = new SsrUsageByUserViewModel();
        result.init(json);
        return result;
    }
}

export interface ISsrUsageByUserViewModel {
    personId?: number;
    accountName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    employeeNumber?: string | null;
    numberOfStoreVisits?: number;
    ssrUsage?: number | null;
}

export class LimitedResultOfSsrUsageByUserDetailsViewModel implements ILimitedResultOfSsrUsageByUserDetailsViewModel {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: SsrUsageByUserDetailsViewModel[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfSsrUsageByUserDetailsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SsrUsageByUserDetailsViewModel.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfSsrUsageByUserDetailsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfSsrUsageByUserDetailsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfSsrUsageByUserDetailsViewModel {
        const json = this.toJSON();
        let result = new LimitedResultOfSsrUsageByUserDetailsViewModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfSsrUsageByUserDetailsViewModel {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: SsrUsageByUserDetailsViewModel[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class SsrUsageByUserDetailsViewModel implements ISsrUsageByUserDetailsViewModel {
    employeeNumber?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    storeNumber?: string | null;
    timeIn?: moment.Moment;
    timeOut?: moment.Moment;
    timeInStoreMs?: number;
    storeTimezone?: string | null;

    constructor(data?: ISsrUsageByUserDetailsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeNumber = _data["employeeNumber"] !== undefined ? _data["employeeNumber"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.storeNumber = _data["storeNumber"] !== undefined ? _data["storeNumber"] : null as any;
            this.timeIn = _data["timeIn"] ? moment(_data["timeIn"].toString()) : null as any;
            this.timeOut = _data["timeOut"] ? moment(_data["timeOut"].toString()) : null as any;
            this.timeInStoreMs = _data["timeInStoreMs"] !== undefined ? _data["timeInStoreMs"] : null as any;
            this.storeTimezone = _data["storeTimezone"] !== undefined ? _data["storeTimezone"] : null as any;
        }
    }

    static fromJS(data: any): SsrUsageByUserDetailsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SsrUsageByUserDetailsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeNumber"] = this.employeeNumber !== undefined ? this.employeeNumber : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["storeNumber"] = this.storeNumber !== undefined ? this.storeNumber : null as any;
        data["timeIn"] = this.timeIn ? this.timeIn.toISOString() : null as any;
        data["timeOut"] = this.timeOut ? this.timeOut.toISOString() : null as any;
        data["timeInStoreMs"] = this.timeInStoreMs !== undefined ? this.timeInStoreMs : null as any;
        data["storeTimezone"] = this.storeTimezone !== undefined ? this.storeTimezone : null as any;
        return data;
    }

    clone(): SsrUsageByUserDetailsViewModel {
        const json = this.toJSON();
        let result = new SsrUsageByUserDetailsViewModel();
        result.init(json);
        return result;
    }
}

export interface ISsrUsageByUserDetailsViewModel {
    employeeNumber?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    storeNumber?: string | null;
    timeIn?: moment.Moment;
    timeOut?: moment.Moment;
    timeInStoreMs?: number;
    storeTimezone?: string | null;
}

export class StatesTableViewModel implements IStatesTableViewModel {
    stateId?: number;
    stateCode?: string | null;
    stateDesc?: string | null;
    country?: string | null;

    constructor(data?: IStatesTableViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stateId = _data["stateId"] !== undefined ? _data["stateId"] : null as any;
            this.stateCode = _data["stateCode"] !== undefined ? _data["stateCode"] : null as any;
            this.stateDesc = _data["stateDesc"] !== undefined ? _data["stateDesc"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
        }
    }

    static fromJS(data: any): StatesTableViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StatesTableViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stateId"] = this.stateId !== undefined ? this.stateId : null as any;
        data["stateCode"] = this.stateCode !== undefined ? this.stateCode : null as any;
        data["stateDesc"] = this.stateDesc !== undefined ? this.stateDesc : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        return data;
    }

    clone(): StatesTableViewModel {
        const json = this.toJSON();
        let result = new StatesTableViewModel();
        result.init(json);
        return result;
    }
}

export interface IStatesTableViewModel {
    stateId?: number;
    stateCode?: string | null;
    stateDesc?: string | null;
    country?: string | null;
}

export class Status2 implements IStatus2 {
    id?: number;
    statusType?: string | null;

    constructor(data?: IStatus2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.statusType = _data["statusType"] !== undefined ? _data["statusType"] : null as any;
        }
    }

    static fromJS(data: any): Status2 {
        data = typeof data === 'object' ? data : {};
        let result = new Status2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["statusType"] = this.statusType !== undefined ? this.statusType : null as any;
        return data;
    }

    clone(): Status2 {
        const json = this.toJSON();
        let result = new Status2();
        result.init(json);
        return result;
    }
}

export interface IStatus2 {
    id?: number;
    statusType?: string | null;
}

export class StatusViewModel implements IStatusViewModel {
    statusId?: number;
    statusName?: string | null;

    constructor(data?: IStatusViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            this.statusName = _data["statusName"] !== undefined ? _data["statusName"] : null as any;
        }
    }

    static fromJS(data: any): StatusViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StatusViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        data["statusName"] = this.statusName !== undefined ? this.statusName : null as any;
        return data;
    }

    clone(): StatusViewModel {
        const json = this.toJSON();
        let result = new StatusViewModel();
        result.init(json);
        return result;
    }
}

export interface IStatusViewModel {
    statusId?: number;
    statusName?: string | null;
}

export class StoreClosureViewModel implements IStoreClosureViewModel {
    id?: string | null;
    storeNumber?: string | null;
    banner?: string | null;
    address?: string | null;
    startDate?: moment.Moment;
    endDate?: moment.Moment | null;
    closureReason?: string | null;
    message?: string | null;

    constructor(data?: IStoreClosureViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.storeNumber = _data["storeNumber"] !== undefined ? _data["storeNumber"] : null as any;
            this.banner = _data["banner"] !== undefined ? _data["banner"] : null as any;
            this.address = _data["address"] !== undefined ? _data["address"] : null as any;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : null as any;
            this.closureReason = _data["closureReason"] !== undefined ? _data["closureReason"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
        }
    }

    static fromJS(data: any): StoreClosureViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StoreClosureViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["storeNumber"] = this.storeNumber !== undefined ? this.storeNumber : null as any;
        data["banner"] = this.banner !== undefined ? this.banner : null as any;
        data["address"] = this.address !== undefined ? this.address : null as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        data["closureReason"] = this.closureReason !== undefined ? this.closureReason : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        return data;
    }

    clone(): StoreClosureViewModel {
        const json = this.toJSON();
        let result = new StoreClosureViewModel();
        result.init(json);
        return result;
    }
}

export interface IStoreClosureViewModel {
    id?: string | null;
    storeNumber?: string | null;
    banner?: string | null;
    address?: string | null;
    startDate?: moment.Moment;
    endDate?: moment.Moment | null;
    closureReason?: string | null;
    message?: string | null;
}

export class LimitedResultOfStoreClosureViewModel implements ILimitedResultOfStoreClosureViewModel {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: StoreClosureViewModel[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfStoreClosureViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(StoreClosureViewModel.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfStoreClosureViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfStoreClosureViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfStoreClosureViewModel {
        const json = this.toJSON();
        let result = new LimitedResultOfStoreClosureViewModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfStoreClosureViewModel {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: StoreClosureViewModel[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class SupplierPage implements ISupplierPage {
    suppliers?: LimitedResultOfSupplierModel | null;
    stats?: SupplierStats | null;

    constructor(data?: ISupplierPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.suppliers = _data["suppliers"] ? LimitedResultOfSupplierModel.fromJS(_data["suppliers"]) : null as any;
            this.stats = _data["stats"] ? SupplierStats.fromJS(_data["stats"]) : null as any;
        }
    }

    static fromJS(data: any): SupplierPage {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["suppliers"] = this.suppliers ? this.suppliers.toJSON() : null as any;
        data["stats"] = this.stats ? this.stats.toJSON() : null as any;
        return data;
    }

    clone(): SupplierPage {
        const json = this.toJSON();
        let result = new SupplierPage();
        result.init(json);
        return result;
    }
}

export interface ISupplierPage {
    suppliers?: LimitedResultOfSupplierModel | null;
    stats?: SupplierStats | null;
}

export class LimitedResultOfSupplierModel implements ILimitedResultOfSupplierModel {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: SupplierModel[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfSupplierModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SupplierModel.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfSupplierModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfSupplierModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfSupplierModel {
        const json = this.toJSON();
        let result = new LimitedResultOfSupplierModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfSupplierModel {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: SupplierModel[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class SupplierModel implements ISupplierModel {
    supplierId?: number;
    supplierName?: string | null;
    statusId?: number | null;
    duns?: string | null;
    supplierNumber?: string | null;
    accountId?: number | null;
    statusName?: string | null;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment | null;
    resale?: string | null;
    note?: string | null;

    constructor(data?: ISupplierModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierId = _data["supplierId"] !== undefined ? _data["supplierId"] : null as any;
            this.supplierName = _data["supplierName"] !== undefined ? _data["supplierName"] : null as any;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            this.duns = _data["duns"] !== undefined ? _data["duns"] : null as any;
            this.supplierNumber = _data["supplierNumber"] !== undefined ? _data["supplierNumber"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.statusName = _data["statusName"] !== undefined ? _data["statusName"] : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            this.resale = _data["resale"] !== undefined ? _data["resale"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
        }
    }

    static fromJS(data: any): SupplierModel {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierId"] = this.supplierId !== undefined ? this.supplierId : null as any;
        data["supplierName"] = this.supplierName !== undefined ? this.supplierName : null as any;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        data["duns"] = this.duns !== undefined ? this.duns : null as any;
        data["supplierNumber"] = this.supplierNumber !== undefined ? this.supplierNumber : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["statusName"] = this.statusName !== undefined ? this.statusName : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        data["resale"] = this.resale !== undefined ? this.resale : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        return data;
    }

    clone(): SupplierModel {
        const json = this.toJSON();
        let result = new SupplierModel();
        result.init(json);
        return result;
    }
}

export interface ISupplierModel {
    supplierId?: number;
    supplierName?: string | null;
    statusId?: number | null;
    duns?: string | null;
    supplierNumber?: string | null;
    accountId?: number | null;
    statusName?: string | null;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment | null;
    resale?: string | null;
    note?: string | null;
}

export class SupplierStats implements ISupplierStats {
    numberActive?: number;
    numberAssociatedToATask?: number;
    numberModifiedLast30Days?: number;

    constructor(data?: ISupplierStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberActive = _data["numberActive"] !== undefined ? _data["numberActive"] : null as any;
            this.numberAssociatedToATask = _data["numberAssociatedToATask"] !== undefined ? _data["numberAssociatedToATask"] : null as any;
            this.numberModifiedLast30Days = _data["numberModifiedLast30Days"] !== undefined ? _data["numberModifiedLast30Days"] : null as any;
        }
    }

    static fromJS(data: any): SupplierStats {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberActive"] = this.numberActive !== undefined ? this.numberActive : null as any;
        data["numberAssociatedToATask"] = this.numberAssociatedToATask !== undefined ? this.numberAssociatedToATask : null as any;
        data["numberModifiedLast30Days"] = this.numberModifiedLast30Days !== undefined ? this.numberModifiedLast30Days : null as any;
        return data;
    }

    clone(): SupplierStats {
        const json = this.toJSON();
        let result = new SupplierStats();
        result.init(json);
        return result;
    }
}

export interface ISupplierStats {
    numberActive?: number;
    numberAssociatedToATask?: number;
    numberModifiedLast30Days?: number;
}

export enum ResaleOptions {
    GFR = "gfr",
    GNFR = "gnfr",
}

export class SupplierViewModel implements ISupplierViewModel {
    name?: string | null;
    abbrev?: string | null;
    imageUrl?: string | null;
    smallImageUrl?: string | null;
    website?: string | null;
    address?: Address | null;

    constructor(data?: ISupplierViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.abbrev = _data["abbrev"] !== undefined ? _data["abbrev"] : null as any;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : null as any;
            this.smallImageUrl = _data["smallImageUrl"] !== undefined ? _data["smallImageUrl"] : null as any;
            this.website = _data["website"] !== undefined ? _data["website"] : null as any;
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : null as any;
        }
    }

    static fromJS(data: any): SupplierViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["abbrev"] = this.abbrev !== undefined ? this.abbrev : null as any;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : null as any;
        data["smallImageUrl"] = this.smallImageUrl !== undefined ? this.smallImageUrl : null as any;
        data["website"] = this.website !== undefined ? this.website : null as any;
        data["address"] = this.address ? this.address.toJSON() : null as any;
        return data;
    }

    clone(): SupplierViewModel {
        const json = this.toJSON();
        let result = new SupplierViewModel();
        result.init(json);
        return result;
    }
}

export interface ISupplierViewModel {
    name?: string | null;
    abbrev?: string | null;
    imageUrl?: string | null;
    smallImageUrl?: string | null;
    website?: string | null;
    address?: Address | null;
}

export class Address implements IAddress {
    streetAddress?: string | null;
    streetAddress2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    country?: string | null;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.streetAddress = _data["streetAddress"] !== undefined ? _data["streetAddress"] : null as any;
            this.streetAddress2 = _data["streetAddress2"] !== undefined ? _data["streetAddress2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streetAddress"] = this.streetAddress !== undefined ? this.streetAddress : null as any;
        data["streetAddress2"] = this.streetAddress2 !== undefined ? this.streetAddress2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        return data;
    }

    clone(): Address {
        const json = this.toJSON();
        let result = new Address();
        result.init(json);
        return result;
    }
}

export interface IAddress {
    streetAddress?: string | null;
    streetAddress2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    country?: string | null;
}

export class TopSupplierModel implements ITopSupplierModel {
    supplierId?: string | null;
    supplierName?: string | null;
    count?: number;

    constructor(data?: ITopSupplierModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierId = _data["supplierId"] !== undefined ? _data["supplierId"] : null as any;
            this.supplierName = _data["supplierName"] !== undefined ? _data["supplierName"] : null as any;
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
        }
    }

    static fromJS(data: any): TopSupplierModel {
        data = typeof data === 'object' ? data : {};
        let result = new TopSupplierModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierId"] = this.supplierId !== undefined ? this.supplierId : null as any;
        data["supplierName"] = this.supplierName !== undefined ? this.supplierName : null as any;
        data["count"] = this.count !== undefined ? this.count : null as any;
        return data;
    }

    clone(): TopSupplierModel {
        const json = this.toJSON();
        let result = new TopSupplierModel();
        result.init(json);
        return result;
    }
}

export interface ITopSupplierModel {
    supplierId?: string | null;
    supplierName?: string | null;
    count?: number;
}

export class SupplierListPhotoGallery implements ISupplierListPhotoGallery {
    id?: number;
    name?: string | null;
    number?: string | null;

    constructor(data?: ISupplierListPhotoGallery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.number = _data["number"] !== undefined ? _data["number"] : null as any;
        }
    }

    static fromJS(data: any): SupplierListPhotoGallery {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierListPhotoGallery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["number"] = this.number !== undefined ? this.number : null as any;
        return data;
    }

    clone(): SupplierListPhotoGallery {
        const json = this.toJSON();
        let result = new SupplierListPhotoGallery();
        result.init(json);
        return result;
    }
}

export interface ISupplierListPhotoGallery {
    id?: number;
    name?: string | null;
    number?: string | null;
}

export class TopSupplierHoursModel implements ITopSupplierHoursModel {
    supplierId?: number;
    supplierName?: string | null;
    duration?: number;

    constructor(data?: ITopSupplierHoursModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierId = _data["supplierId"] !== undefined ? _data["supplierId"] : null as any;
            this.supplierName = _data["supplierName"] !== undefined ? _data["supplierName"] : null as any;
            this.duration = _data["duration"] !== undefined ? _data["duration"] : null as any;
        }
    }

    static fromJS(data: any): TopSupplierHoursModel {
        data = typeof data === 'object' ? data : {};
        let result = new TopSupplierHoursModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierId"] = this.supplierId !== undefined ? this.supplierId : null as any;
        data["supplierName"] = this.supplierName !== undefined ? this.supplierName : null as any;
        data["duration"] = this.duration !== undefined ? this.duration : null as any;
        return data;
    }

    clone(): TopSupplierHoursModel {
        const json = this.toJSON();
        let result = new TopSupplierHoursModel();
        result.init(json);
        return result;
    }
}

export interface ITopSupplierHoursModel {
    supplierId?: number;
    supplierName?: string | null;
    duration?: number;
}

export class ApiErrorOfCurrentUserErrors implements IApiErrorOfCurrentUserErrors {
    errorKey?: CurrentUserErrors;

    constructor(data?: IApiErrorOfCurrentUserErrors) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorKey = _data["errorKey"] !== undefined ? _data["errorKey"] : null as any;
        }
    }

    static fromJS(data: any): ApiErrorOfCurrentUserErrors {
        data = typeof data === 'object' ? data : {};
        let result = new ApiErrorOfCurrentUserErrors();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorKey"] = this.errorKey !== undefined ? this.errorKey : null as any;
        return data;
    }

    clone(): ApiErrorOfCurrentUserErrors {
        const json = this.toJSON();
        let result = new ApiErrorOfCurrentUserErrors();
        result.init(json);
        return result;
    }
}

export interface IApiErrorOfCurrentUserErrors {
    errorKey?: CurrentUserErrors;
}

export enum CurrentUserErrors {
    None = "none",
    InvalidUser = "invalidUser",
    UserIsNotActive = "userIsNotActive",
}

export class SurveyResponseCount implements ISurveyResponseCount {
    key?: string | null;
    count?: number;

    constructor(data?: ISurveyResponseCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
        }
    }

    static fromJS(data: any): SurveyResponseCount {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResponseCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["count"] = this.count !== undefined ? this.count : null as any;
        return data;
    }

    clone(): SurveyResponseCount {
        const json = this.toJSON();
        let result = new SurveyResponseCount();
        result.init(json);
        return result;
    }
}

export interface ISurveyResponseCount {
    key?: string | null;
    count?: number;
}

export enum EFieldGroupType {
    DSD = "dsd",
    PSP = "psp",
}

export enum SurveyStatus {
    All = "all",
    Complete = "complete",
    Incomplete = "incomplete",
}

export class QuestionAnswerCount implements IQuestionAnswerCount {
    key?: string | null;
    value?: string | null;
    friendlyValue?: string | null;
    count?: number;
    totalCount?: number;
    percentage?: number;

    constructor(data?: IQuestionAnswerCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
            this.friendlyValue = _data["friendlyValue"] !== undefined ? _data["friendlyValue"] : null as any;
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            this.percentage = _data["percentage"] !== undefined ? _data["percentage"] : null as any;
        }
    }

    static fromJS(data: any): QuestionAnswerCount {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionAnswerCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["friendlyValue"] = this.friendlyValue !== undefined ? this.friendlyValue : null as any;
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        data["percentage"] = this.percentage !== undefined ? this.percentage : null as any;
        return data;
    }

    clone(): QuestionAnswerCount {
        const json = this.toJSON();
        let result = new QuestionAnswerCount();
        result.init(json);
        return result;
    }
}

export interface IQuestionAnswerCount {
    key?: string | null;
    value?: string | null;
    friendlyValue?: string | null;
    count?: number;
    totalCount?: number;
    percentage?: number;
}

export class CardTemplate implements ICardTemplate {
    queries?: Query[] | null;
    type?: CardTemplateType;
    helpText?: string | null;
    title?: string | null;
    header?: string | null;
    cssClass?: string | null;
    leftColumnCssClass?: string | null;
    rightColumnCssClass?: string | null;
    groupColor?: string | null;
    chartOptions?: ChartOptions | null;
    tableColumns?: TableColumn[] | null;
    staticTableRows?: ValueExpression[][] | null;
    valueBoxesWithText?: ValueBoxWithText[] | null;
    children?: CardTemplate[] | null;
    tableFooterText?: string | null;

    constructor(data?: ICardTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["queries"])) {
                this.queries = [] as any;
                for (let item of _data["queries"])
                    this.queries!.push(Query.fromJS(item));
            }
            else {
                this.queries = null as any;
            }
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.helpText = _data["helpText"] !== undefined ? _data["helpText"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.header = _data["header"] !== undefined ? _data["header"] : null as any;
            this.cssClass = _data["cssClass"] !== undefined ? _data["cssClass"] : null as any;
            this.leftColumnCssClass = _data["leftColumnCssClass"] !== undefined ? _data["leftColumnCssClass"] : null as any;
            this.rightColumnCssClass = _data["rightColumnCssClass"] !== undefined ? _data["rightColumnCssClass"] : null as any;
            this.groupColor = _data["groupColor"] !== undefined ? _data["groupColor"] : null as any;
            this.chartOptions = _data["chartOptions"] ? ChartOptions.fromJS(_data["chartOptions"]) : null as any;
            if (Array.isArray(_data["tableColumns"])) {
                this.tableColumns = [] as any;
                for (let item of _data["tableColumns"])
                    this.tableColumns!.push(TableColumn.fromJS(item));
            }
            else {
                this.tableColumns = null as any;
            }
            if (Array.isArray(_data["staticTableRows"])) {
                this.staticTableRows = [] as any;
                for (let item of _data["staticTableRows"])
                    this.staticTableRows!.push(item);
            }
            else {
                this.staticTableRows = null as any;
            }
            if (Array.isArray(_data["valueBoxesWithText"])) {
                this.valueBoxesWithText = [] as any;
                for (let item of _data["valueBoxesWithText"])
                    this.valueBoxesWithText!.push(ValueBoxWithText.fromJS(item));
            }
            else {
                this.valueBoxesWithText = null as any;
            }
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(CardTemplate.fromJS(item));
            }
            else {
                this.children = null as any;
            }
            this.tableFooterText = _data["tableFooterText"] !== undefined ? _data["tableFooterText"] : null as any;
        }
    }

    static fromJS(data: any): CardTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new CardTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.queries)) {
            data["queries"] = [];
            for (let item of this.queries)
                data["queries"].push(item ? item.toJSON() : null as any);
        }
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["helpText"] = this.helpText !== undefined ? this.helpText : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["header"] = this.header !== undefined ? this.header : null as any;
        data["cssClass"] = this.cssClass !== undefined ? this.cssClass : null as any;
        data["leftColumnCssClass"] = this.leftColumnCssClass !== undefined ? this.leftColumnCssClass : null as any;
        data["rightColumnCssClass"] = this.rightColumnCssClass !== undefined ? this.rightColumnCssClass : null as any;
        data["groupColor"] = this.groupColor !== undefined ? this.groupColor : null as any;
        data["chartOptions"] = this.chartOptions ? this.chartOptions.toJSON() : null as any;
        if (Array.isArray(this.tableColumns)) {
            data["tableColumns"] = [];
            for (let item of this.tableColumns)
                data["tableColumns"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.staticTableRows)) {
            data["staticTableRows"] = [];
            for (let item of this.staticTableRows)
                data["staticTableRows"].push(item);
        }
        if (Array.isArray(this.valueBoxesWithText)) {
            data["valueBoxesWithText"] = [];
            for (let item of this.valueBoxesWithText)
                data["valueBoxesWithText"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : null as any);
        }
        data["tableFooterText"] = this.tableFooterText !== undefined ? this.tableFooterText : null as any;
        return data;
    }

    clone(): CardTemplate {
        const json = this.toJSON();
        let result = new CardTemplate();
        result.init(json);
        return result;
    }
}

export interface ICardTemplate {
    queries?: Query[] | null;
    type?: CardTemplateType;
    helpText?: string | null;
    title?: string | null;
    header?: string | null;
    cssClass?: string | null;
    leftColumnCssClass?: string | null;
    rightColumnCssClass?: string | null;
    groupColor?: string | null;
    chartOptions?: ChartOptions | null;
    tableColumns?: TableColumn[] | null;
    staticTableRows?: ValueExpression[][] | null;
    valueBoxesWithText?: ValueBoxWithText[] | null;
    children?: CardTemplate[] | null;
    tableFooterText?: string | null;
}

export class Query implements IQuery {
    questionKey?: string | null;
    type?: QueryType;
    limit?: number | null;
    numberOfBuckets?: number | null;
    buckets?: number[] | null;

    constructor(data?: IQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionKey = _data["questionKey"] !== undefined ? _data["questionKey"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.numberOfBuckets = _data["numberOfBuckets"] !== undefined ? _data["numberOfBuckets"] : null as any;
            if (Array.isArray(_data["buckets"])) {
                this.buckets = [] as any;
                for (let item of _data["buckets"])
                    this.buckets!.push(item);
            }
            else {
                this.buckets = null as any;
            }
        }
    }

    static fromJS(data: any): Query {
        data = typeof data === 'object' ? data : {};
        let result = new Query();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionKey"] = this.questionKey !== undefined ? this.questionKey : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["numberOfBuckets"] = this.numberOfBuckets !== undefined ? this.numberOfBuckets : null as any;
        if (Array.isArray(this.buckets)) {
            data["buckets"] = [];
            for (let item of this.buckets)
                data["buckets"].push(item);
        }
        return data;
    }

    clone(): Query {
        const json = this.toJSON();
        let result = new Query();
        result.init(json);
        return result;
    }
}

export interface IQuery {
    questionKey?: string | null;
    type?: QueryType;
    limit?: number | null;
    numberOfBuckets?: number | null;
    buckets?: number[] | null;
}

export enum QueryType {
    SurveyCompletionStatus = "surveyCompletionStatus",
    StoreCountByLocationFormat = "storeCountByLocationFormat",
    AnswerCount = "answerCount",
    AnswerAverage = "answerAverage",
    AnswerSum = "answerSum",
    AnswerSumGroupedByUniqueParent = "answerSumGroupedByUniqueParent",
    QuestionExistenceCount = "questionExistenceCount",
    TodoListStatistics = "todoListStatistics",
    AnswersAsBuckets = "answersAsBuckets",
}

export enum CardTemplateType {
    TableWithChart = "tableWithChart",
    TableWithValueBoxes = "tableWithValueBoxes",
    TableWithChartAndValueBoxes = "tableWithChartAndValueBoxes",
    ValueBoxes = "valueBoxes",
}

export class ChartOptions implements IChartOptions {
    chartType?: string | null;
    yValue?: string | null;
    title?: string | null;
    yName?: string | null;
    options?: any | null;

    constructor(data?: IChartOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chartType = _data["chartType"] !== undefined ? _data["chartType"] : null as any;
            this.yValue = _data["yValue"] !== undefined ? _data["yValue"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.yName = _data["yName"] !== undefined ? _data["yName"] : null as any;
            this.options = _data["options"] !== undefined ? _data["options"] : null as any;
        }
    }

    static fromJS(data: any): ChartOptions {
        data = typeof data === 'object' ? data : {};
        let result = new ChartOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chartType"] = this.chartType !== undefined ? this.chartType : null as any;
        data["yValue"] = this.yValue !== undefined ? this.yValue : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["yName"] = this.yName !== undefined ? this.yName : null as any;
        data["options"] = this.options !== undefined ? this.options : null as any;
        return data;
    }

    clone(): ChartOptions {
        const json = this.toJSON();
        let result = new ChartOptions();
        result.init(json);
        return result;
    }
}

export interface IChartOptions {
    chartType?: string | null;
    yValue?: string | null;
    title?: string | null;
    yName?: string | null;
    options?: any | null;
}

export class TableColumn implements ITableColumn {
    headerText?: string | null;
    headerCssClass?: string | null;
    fieldName?: string | null;
    cssClass?: string | null;
    type?: string | null;
    width?: string | null;

    constructor(data?: ITableColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.headerText = _data["headerText"] !== undefined ? _data["headerText"] : null as any;
            this.headerCssClass = _data["headerCssClass"] !== undefined ? _data["headerCssClass"] : null as any;
            this.fieldName = _data["fieldName"] !== undefined ? _data["fieldName"] : null as any;
            this.cssClass = _data["cssClass"] !== undefined ? _data["cssClass"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.width = _data["width"] !== undefined ? _data["width"] : null as any;
        }
    }

    static fromJS(data: any): TableColumn {
        data = typeof data === 'object' ? data : {};
        let result = new TableColumn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["headerText"] = this.headerText !== undefined ? this.headerText : null as any;
        data["headerCssClass"] = this.headerCssClass !== undefined ? this.headerCssClass : null as any;
        data["fieldName"] = this.fieldName !== undefined ? this.fieldName : null as any;
        data["cssClass"] = this.cssClass !== undefined ? this.cssClass : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["width"] = this.width !== undefined ? this.width : null as any;
        return data;
    }

    clone(): TableColumn {
        const json = this.toJSON();
        let result = new TableColumn();
        result.init(json);
        return result;
    }
}

export interface ITableColumn {
    headerText?: string | null;
    headerCssClass?: string | null;
    fieldName?: string | null;
    cssClass?: string | null;
    type?: string | null;
    width?: string | null;
}

export class ValueExpression implements IValueExpression {
    expression?: string | null;
    defaultExpressionValue?: string | null;
    pipeArgs?: string[] | null;
    pipeType?: PipeType | null;

    constructor(data?: IValueExpression) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] !== undefined ? _data["expression"] : null as any;
            this.defaultExpressionValue = _data["defaultExpressionValue"] !== undefined ? _data["defaultExpressionValue"] : null as any;
            if (Array.isArray(_data["pipeArgs"])) {
                this.pipeArgs = [] as any;
                for (let item of _data["pipeArgs"])
                    this.pipeArgs!.push(item);
            }
            else {
                this.pipeArgs = null as any;
            }
            this.pipeType = _data["pipeType"] !== undefined ? _data["pipeType"] : null as any;
        }
    }

    static fromJS(data: any): ValueExpression {
        data = typeof data === 'object' ? data : {};
        let result = new ValueExpression();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression !== undefined ? this.expression : null as any;
        data["defaultExpressionValue"] = this.defaultExpressionValue !== undefined ? this.defaultExpressionValue : null as any;
        if (Array.isArray(this.pipeArgs)) {
            data["pipeArgs"] = [];
            for (let item of this.pipeArgs)
                data["pipeArgs"].push(item);
        }
        data["pipeType"] = this.pipeType !== undefined ? this.pipeType : null as any;
        return data;
    }

    clone(): ValueExpression {
        const json = this.toJSON();
        let result = new ValueExpression();
        result.init(json);
        return result;
    }
}

export interface IValueExpression {
    expression?: string | null;
    defaultExpressionValue?: string | null;
    pipeArgs?: string[] | null;
    pipeType?: PipeType | null;
}

export enum PipeType {
    Decimal = "decimal",
    Percent = "percent",
    DisplayTime = "displayTime",
}

export class ValueBoxWithText implements IValueBoxWithText {
    valueBox?: ValueExpression | null;
    valueBoxCssClass?: string | null;
    bottomText?: string | null;
    bottomTextCssClass?: string | null;

    constructor(data?: IValueBoxWithText) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valueBox = _data["valueBox"] ? ValueExpression.fromJS(_data["valueBox"]) : null as any;
            this.valueBoxCssClass = _data["valueBoxCssClass"] !== undefined ? _data["valueBoxCssClass"] : null as any;
            this.bottomText = _data["bottomText"] !== undefined ? _data["bottomText"] : null as any;
            this.bottomTextCssClass = _data["bottomTextCssClass"] !== undefined ? _data["bottomTextCssClass"] : null as any;
        }
    }

    static fromJS(data: any): ValueBoxWithText {
        data = typeof data === 'object' ? data : {};
        let result = new ValueBoxWithText();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valueBox"] = this.valueBox ? this.valueBox.toJSON() : null as any;
        data["valueBoxCssClass"] = this.valueBoxCssClass !== undefined ? this.valueBoxCssClass : null as any;
        data["bottomText"] = this.bottomText !== undefined ? this.bottomText : null as any;
        data["bottomTextCssClass"] = this.bottomTextCssClass !== undefined ? this.bottomTextCssClass : null as any;
        return data;
    }

    clone(): ValueBoxWithText {
        const json = this.toJSON();
        let result = new ValueBoxWithText();
        result.init(json);
        return result;
    }
}

export interface IValueBoxWithText {
    valueBox?: ValueExpression | null;
    valueBoxCssClass?: string | null;
    bottomText?: string | null;
    bottomTextCssClass?: string | null;
}

export class QuestionAverage implements IQuestionAverage {
    key?: string | null;
    average?: number;

    constructor(data?: IQuestionAverage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
            this.average = _data["average"] !== undefined ? _data["average"] : null as any;
        }
    }

    static fromJS(data: any): QuestionAverage {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionAverage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["average"] = this.average !== undefined ? this.average : null as any;
        return data;
    }

    clone(): QuestionAverage {
        const json = this.toJSON();
        let result = new QuestionAverage();
        result.init(json);
        return result;
    }
}

export interface IQuestionAverage {
    key?: string | null;
    average?: number;
}

export class QuestionAnswerSum implements IQuestionAnswerSum {
    key?: string | null;
    uniqueParentKey?: string | null;
    parentValue?: string | null;
    parentKey?: string | null;
    count?: number;
    totalCount?: number;

    constructor(data?: IQuestionAnswerSum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
            this.uniqueParentKey = _data["uniqueParentKey"] !== undefined ? _data["uniqueParentKey"] : null as any;
            this.parentValue = _data["parentValue"] !== undefined ? _data["parentValue"] : null as any;
            this.parentKey = _data["parentKey"] !== undefined ? _data["parentKey"] : null as any;
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): QuestionAnswerSum {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionAnswerSum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["uniqueParentKey"] = this.uniqueParentKey !== undefined ? this.uniqueParentKey : null as any;
        data["parentValue"] = this.parentValue !== undefined ? this.parentValue : null as any;
        data["parentKey"] = this.parentKey !== undefined ? this.parentKey : null as any;
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }

    clone(): QuestionAnswerSum {
        const json = this.toJSON();
        let result = new QuestionAnswerSum();
        result.init(json);
        return result;
    }
}

export interface IQuestionAnswerSum {
    key?: string | null;
    uniqueParentKey?: string | null;
    parentValue?: string | null;
    parentKey?: string | null;
    count?: number;
    totalCount?: number;
}

export class SurveyResultQuestionParams implements ISurveyResultQuestionParams {
    questionKey?: string | null;
    groupByUniqueParent?: boolean | null;
    limit?: number | null;
    numberOfBuckets?: number | null;
    buckets?: number[] | null;
    filter?: SurveyResultFilterParams | null;

    constructor(data?: ISurveyResultQuestionParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionKey = _data["questionKey"] !== undefined ? _data["questionKey"] : null as any;
            this.groupByUniqueParent = _data["groupByUniqueParent"] !== undefined ? _data["groupByUniqueParent"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.numberOfBuckets = _data["numberOfBuckets"] !== undefined ? _data["numberOfBuckets"] : null as any;
            if (Array.isArray(_data["buckets"])) {
                this.buckets = [] as any;
                for (let item of _data["buckets"])
                    this.buckets!.push(item);
            }
            else {
                this.buckets = null as any;
            }
            this.filter = _data["filter"] ? SurveyResultFilterParams.fromJS(_data["filter"]) : null as any;
        }
    }

    static fromJS(data: any): SurveyResultQuestionParams {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResultQuestionParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionKey"] = this.questionKey !== undefined ? this.questionKey : null as any;
        data["groupByUniqueParent"] = this.groupByUniqueParent !== undefined ? this.groupByUniqueParent : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["numberOfBuckets"] = this.numberOfBuckets !== undefined ? this.numberOfBuckets : null as any;
        if (Array.isArray(this.buckets)) {
            data["buckets"] = [];
            for (let item of this.buckets)
                data["buckets"].push(item);
        }
        data["filter"] = this.filter ? this.filter.toJSON() : null as any;
        return data;
    }

    clone(): SurveyResultQuestionParams {
        const json = this.toJSON();
        let result = new SurveyResultQuestionParams();
        result.init(json);
        return result;
    }
}

export interface ISurveyResultQuestionParams {
    questionKey?: string | null;
    groupByUniqueParent?: boolean | null;
    limit?: number | null;
    numberOfBuckets?: number | null;
    buckets?: number[] | null;
    filter?: SurveyResultFilterParams | null;
}

export class SurveyResultFilterParams implements ISurveyResultFilterParams {
    templateId?: string | null;
    accountIds?: number[] | null;
    dateRange?: DateRange | null;
    regionType?: number | null;
    regionNames?: string[] | null;
    locationTypes?: string[] | null;
    fieldGroupType?: EFieldGroupType | null;
    surveyStatus?: SurveyStatus | null;
    locationNumbers?: string[] | null;
    allowedInvalidStatistics?: string[] | null;

    constructor(data?: ISurveyResultFilterParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateId = _data["templateId"] !== undefined ? _data["templateId"] : null as any;
            if (Array.isArray(_data["accountIds"])) {
                this.accountIds = [] as any;
                for (let item of _data["accountIds"])
                    this.accountIds!.push(item);
            }
            else {
                this.accountIds = null as any;
            }
            this.dateRange = _data["dateRange"] ? DateRange.fromJS(_data["dateRange"]) : null as any;
            this.regionType = _data["regionType"] !== undefined ? _data["regionType"] : null as any;
            if (Array.isArray(_data["regionNames"])) {
                this.regionNames = [] as any;
                for (let item of _data["regionNames"])
                    this.regionNames!.push(item);
            }
            else {
                this.regionNames = null as any;
            }
            if (Array.isArray(_data["locationTypes"])) {
                this.locationTypes = [] as any;
                for (let item of _data["locationTypes"])
                    this.locationTypes!.push(item);
            }
            else {
                this.locationTypes = null as any;
            }
            this.fieldGroupType = _data["fieldGroupType"] !== undefined ? _data["fieldGroupType"] : null as any;
            this.surveyStatus = _data["surveyStatus"] !== undefined ? _data["surveyStatus"] : null as any;
            if (Array.isArray(_data["locationNumbers"])) {
                this.locationNumbers = [] as any;
                for (let item of _data["locationNumbers"])
                    this.locationNumbers!.push(item);
            }
            else {
                this.locationNumbers = null as any;
            }
            if (Array.isArray(_data["allowedInvalidStatistics"])) {
                this.allowedInvalidStatistics = [] as any;
                for (let item of _data["allowedInvalidStatistics"])
                    this.allowedInvalidStatistics!.push(item);
            }
            else {
                this.allowedInvalidStatistics = null as any;
            }
        }
    }

    static fromJS(data: any): SurveyResultFilterParams {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResultFilterParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId !== undefined ? this.templateId : null as any;
        if (Array.isArray(this.accountIds)) {
            data["accountIds"] = [];
            for (let item of this.accountIds)
                data["accountIds"].push(item);
        }
        data["dateRange"] = this.dateRange ? this.dateRange.toJSON() : null as any;
        data["regionType"] = this.regionType !== undefined ? this.regionType : null as any;
        if (Array.isArray(this.regionNames)) {
            data["regionNames"] = [];
            for (let item of this.regionNames)
                data["regionNames"].push(item);
        }
        if (Array.isArray(this.locationTypes)) {
            data["locationTypes"] = [];
            for (let item of this.locationTypes)
                data["locationTypes"].push(item);
        }
        data["fieldGroupType"] = this.fieldGroupType !== undefined ? this.fieldGroupType : null as any;
        data["surveyStatus"] = this.surveyStatus !== undefined ? this.surveyStatus : null as any;
        if (Array.isArray(this.locationNumbers)) {
            data["locationNumbers"] = [];
            for (let item of this.locationNumbers)
                data["locationNumbers"].push(item);
        }
        if (Array.isArray(this.allowedInvalidStatistics)) {
            data["allowedInvalidStatistics"] = [];
            for (let item of this.allowedInvalidStatistics)
                data["allowedInvalidStatistics"].push(item);
        }
        return data;
    }

    clone(): SurveyResultFilterParams {
        const json = this.toJSON();
        let result = new SurveyResultFilterParams();
        result.init(json);
        return result;
    }
}

export interface ISurveyResultFilterParams {
    templateId?: string | null;
    accountIds?: number[] | null;
    dateRange?: DateRange | null;
    regionType?: number | null;
    regionNames?: string[] | null;
    locationTypes?: string[] | null;
    fieldGroupType?: EFieldGroupType | null;
    surveyStatus?: SurveyStatus | null;
    locationNumbers?: string[] | null;
    allowedInvalidStatistics?: string[] | null;
}

export class NumericQuestionBucket implements INumericQuestionBucket {
    min?: number;
    max?: number;
    frequency?: number;
    friendlyValue?: string | null;
    count?: number;
    totalCount?: number;

    constructor(data?: INumericQuestionBucket) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.min = _data["min"] !== undefined ? _data["min"] : null as any;
            this.max = _data["max"] !== undefined ? _data["max"] : null as any;
            this.frequency = _data["frequency"] !== undefined ? _data["frequency"] : null as any;
            this.friendlyValue = _data["friendlyValue"] !== undefined ? _data["friendlyValue"] : null as any;
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): NumericQuestionBucket {
        data = typeof data === 'object' ? data : {};
        let result = new NumericQuestionBucket();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min !== undefined ? this.min : null as any;
        data["max"] = this.max !== undefined ? this.max : null as any;
        data["frequency"] = this.frequency !== undefined ? this.frequency : null as any;
        data["friendlyValue"] = this.friendlyValue !== undefined ? this.friendlyValue : null as any;
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }

    clone(): NumericQuestionBucket {
        const json = this.toJSON();
        let result = new NumericQuestionBucket();
        result.init(json);
        return result;
    }
}

export interface INumericQuestionBucket {
    min?: number;
    max?: number;
    frequency?: number;
    friendlyValue?: string | null;
    count?: number;
    totalCount?: number;
}

export class TodoListStatistics implements ITodoListStatistics {
    key?: string | null;
    qtyComplete?: number;
    qtyTotal?: number;

    constructor(data?: ITodoListStatistics) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
            this.qtyComplete = _data["qtyComplete"] !== undefined ? _data["qtyComplete"] : null as any;
            this.qtyTotal = _data["qtyTotal"] !== undefined ? _data["qtyTotal"] : null as any;
        }
    }

    static fromJS(data: any): TodoListStatistics {
        data = typeof data === 'object' ? data : {};
        let result = new TodoListStatistics();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["qtyComplete"] = this.qtyComplete !== undefined ? this.qtyComplete : null as any;
        data["qtyTotal"] = this.qtyTotal !== undefined ? this.qtyTotal : null as any;
        return data;
    }

    clone(): TodoListStatistics {
        const json = this.toJSON();
        let result = new TodoListStatistics();
        result.init(json);
        return result;
    }
}

export interface ITodoListStatistics {
    key?: string | null;
    qtyComplete?: number;
    qtyTotal?: number;
}

export class QuestionExistenceCount implements IQuestionExistenceCount {
    key?: string | null;
    questionCount?: number;
    missingQuestionCount?: number;
    totalCount?: number;

    constructor(data?: IQuestionExistenceCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
            this.questionCount = _data["questionCount"] !== undefined ? _data["questionCount"] : null as any;
            this.missingQuestionCount = _data["missingQuestionCount"] !== undefined ? _data["missingQuestionCount"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): QuestionExistenceCount {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionExistenceCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["questionCount"] = this.questionCount !== undefined ? this.questionCount : null as any;
        data["missingQuestionCount"] = this.missingQuestionCount !== undefined ? this.missingQuestionCount : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }

    clone(): QuestionExistenceCount {
        const json = this.toJSON();
        let result = new QuestionExistenceCount();
        result.init(json);
        return result;
    }
}

export interface IQuestionExistenceCount {
    key?: string | null;
    questionCount?: number;
    missingQuestionCount?: number;
    totalCount?: number;
}

export class SurveyTemplate implements ISurveyTemplate {
    surveyTemplateId?: string | null;
    key?: string | null;
    name?: string | null;
    questions?: SurveyTemplateQuestion[] | null;

    constructor(data?: ISurveyTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyTemplateId = _data["surveyTemplateId"] !== undefined ? _data["surveyTemplateId"] : null as any;
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(SurveyTemplateQuestion.fromJS(item));
            }
            else {
                this.questions = null as any;
            }
        }
    }

    static fromJS(data: any): SurveyTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyTemplateId"] = this.surveyTemplateId !== undefined ? this.surveyTemplateId : null as any;
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): SurveyTemplate {
        const json = this.toJSON();
        let result = new SurveyTemplate();
        result.init(json);
        return result;
    }
}

export interface ISurveyTemplate {
    surveyTemplateId?: string | null;
    key?: string | null;
    name?: string | null;
    questions?: SurveyTemplateQuestion[] | null;
}

export class SurveyTemplateQuestion implements ISurveyTemplateQuestion {
    key?: string | null;
    text?: string | null;
    sequence?: number;
    required?: boolean;
    help?: string | null;

    constructor(data?: ISurveyTemplateQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
            this.text = _data["text"] !== undefined ? _data["text"] : null as any;
            this.sequence = _data["sequence"] !== undefined ? _data["sequence"] : null as any;
            this.required = _data["required"] !== undefined ? _data["required"] : null as any;
            this.help = _data["help"] !== undefined ? _data["help"] : null as any;
        }
    }

    static fromJS(data: any): SurveyTemplateQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyTemplateQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["text"] = this.text !== undefined ? this.text : null as any;
        data["sequence"] = this.sequence !== undefined ? this.sequence : null as any;
        data["required"] = this.required !== undefined ? this.required : null as any;
        data["help"] = this.help !== undefined ? this.help : null as any;
        return data;
    }

    clone(): SurveyTemplateQuestion {
        const json = this.toJSON();
        let result = new SurveyTemplateQuestion();
        result.init(json);
        return result;
    }
}

export interface ISurveyTemplateQuestion {
    key?: string | null;
    text?: string | null;
    sequence?: number;
    required?: boolean;
    help?: string | null;
}

export class LimitedResultOfTag implements ILimitedResultOfTag {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: Tag3[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(Tag3.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfTag {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfTag {
        const json = this.toJSON();
        let result = new LimitedResultOfTag();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfTag {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: Tag3[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class ServiceTaskDropdownItem implements IServiceTaskDropdownItem {
    id?: string | null;
    serviceDeploymentId?: string | null;
    referenceNumber?: string | null;
    name?: string | null;

    constructor(data?: IServiceTaskDropdownItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.serviceDeploymentId = _data["serviceDeploymentId"] !== undefined ? _data["serviceDeploymentId"] : null as any;
            this.referenceNumber = _data["referenceNumber"] !== undefined ? _data["referenceNumber"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): ServiceTaskDropdownItem {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTaskDropdownItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["serviceDeploymentId"] = this.serviceDeploymentId !== undefined ? this.serviceDeploymentId : null as any;
        data["referenceNumber"] = this.referenceNumber !== undefined ? this.referenceNumber : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }

    clone(): ServiceTaskDropdownItem {
        const json = this.toJSON();
        let result = new ServiceTaskDropdownItem();
        result.init(json);
        return result;
    }
}

export interface IServiceTaskDropdownItem {
    id?: string | null;
    serviceDeploymentId?: string | null;
    referenceNumber?: string | null;
    name?: string | null;
}

export class LimitedResultOfTaskDetailViewModel implements ILimitedResultOfTaskDetailViewModel {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: TaskDetailViewModel[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfTaskDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TaskDetailViewModel.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfTaskDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfTaskDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfTaskDetailViewModel {
        const json = this.toJSON();
        let result = new LimitedResultOfTaskDetailViewModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfTaskDetailViewModel {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: TaskDetailViewModel[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class TaskDetailViewModel implements ITaskDetailViewModel {
    serviceTaskId?: string | null;
    accountName?: string | null;
    serviceTaskName?: string | null;
    serviceModel?: string | null;
    activity?: string | null;
    completedStores?: number;
    plannedStores?: number;
    pastDueStores?: number;
    totalStores?: number;
    earliestStartDate?: moment.Moment;
    latestEndDate?: moment.Moment;
    department?: string | null;

    constructor(data?: ITaskDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceTaskId = _data["serviceTaskId"] !== undefined ? _data["serviceTaskId"] : null as any;
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.serviceTaskName = _data["serviceTaskName"] !== undefined ? _data["serviceTaskName"] : null as any;
            this.serviceModel = _data["serviceModel"] !== undefined ? _data["serviceModel"] : null as any;
            this.activity = _data["activity"] !== undefined ? _data["activity"] : null as any;
            this.completedStores = _data["completedStores"] !== undefined ? _data["completedStores"] : null as any;
            this.plannedStores = _data["plannedStores"] !== undefined ? _data["plannedStores"] : null as any;
            this.pastDueStores = _data["pastDueStores"] !== undefined ? _data["pastDueStores"] : null as any;
            this.totalStores = _data["totalStores"] !== undefined ? _data["totalStores"] : null as any;
            this.earliestStartDate = _data["earliestStartDate"] ? moment(_data["earliestStartDate"].toString()) : null as any;
            this.latestEndDate = _data["latestEndDate"] ? moment(_data["latestEndDate"].toString()) : null as any;
            this.department = _data["department"] !== undefined ? _data["department"] : null as any;
        }
    }

    static fromJS(data: any): TaskDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceTaskId"] = this.serviceTaskId !== undefined ? this.serviceTaskId : null as any;
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["serviceTaskName"] = this.serviceTaskName !== undefined ? this.serviceTaskName : null as any;
        data["serviceModel"] = this.serviceModel !== undefined ? this.serviceModel : null as any;
        data["activity"] = this.activity !== undefined ? this.activity : null as any;
        data["completedStores"] = this.completedStores !== undefined ? this.completedStores : null as any;
        data["plannedStores"] = this.plannedStores !== undefined ? this.plannedStores : null as any;
        data["pastDueStores"] = this.pastDueStores !== undefined ? this.pastDueStores : null as any;
        data["totalStores"] = this.totalStores !== undefined ? this.totalStores : null as any;
        data["earliestStartDate"] = this.earliestStartDate ? this.earliestStartDate.toISOString() : null as any;
        data["latestEndDate"] = this.latestEndDate ? this.latestEndDate.toISOString() : null as any;
        data["department"] = this.department !== undefined ? this.department : null as any;
        return data;
    }

    clone(): TaskDetailViewModel {
        const json = this.toJSON();
        let result = new TaskDetailViewModel();
        result.init(json);
        return result;
    }
}

export interface ITaskDetailViewModel {
    serviceTaskId?: string | null;
    accountName?: string | null;
    serviceTaskName?: string | null;
    serviceModel?: string | null;
    activity?: string | null;
    completedStores?: number;
    plannedStores?: number;
    pastDueStores?: number;
    totalStores?: number;
    earliestStartDate?: moment.Moment;
    latestEndDate?: moment.Moment;
    department?: string | null;
}

export class TaskDetailsCompareChartsViewModel implements ITaskDetailsCompareChartsViewModel {
    taskDetailsBarChartViewModel?: TaskDetailsBarChartViewModel | null;
    taskDetailStackedChartViewModel?: TaskDetailStackedChartViewModel | null;

    constructor(data?: ITaskDetailsCompareChartsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskDetailsBarChartViewModel = _data["taskDetailsBarChartViewModel"] ? TaskDetailsBarChartViewModel.fromJS(_data["taskDetailsBarChartViewModel"]) : null as any;
            this.taskDetailStackedChartViewModel = _data["taskDetailStackedChartViewModel"] ? TaskDetailStackedChartViewModel.fromJS(_data["taskDetailStackedChartViewModel"]) : null as any;
        }
    }

    static fromJS(data: any): TaskDetailsCompareChartsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDetailsCompareChartsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskDetailsBarChartViewModel"] = this.taskDetailsBarChartViewModel ? this.taskDetailsBarChartViewModel.toJSON() : null as any;
        data["taskDetailStackedChartViewModel"] = this.taskDetailStackedChartViewModel ? this.taskDetailStackedChartViewModel.toJSON() : null as any;
        return data;
    }

    clone(): TaskDetailsCompareChartsViewModel {
        const json = this.toJSON();
        let result = new TaskDetailsCompareChartsViewModel();
        result.init(json);
        return result;
    }
}

export interface ITaskDetailsCompareChartsViewModel {
    taskDetailsBarChartViewModel?: TaskDetailsBarChartViewModel | null;
    taskDetailStackedChartViewModel?: TaskDetailStackedChartViewModel | null;
}

export class TaskDetailsBarChartViewModel implements ITaskDetailsBarChartViewModel {
    dateRange?: string[] | null;
    completedTasks?: TaskDetailChartData[] | null;
    remainingTasks?: TaskDetailBarChartRemainingTasks[] | null;
    plannedTasks?: TaskDetailBarChartPlannedTasks[] | null;

    constructor(data?: ITaskDetailsBarChartViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dateRange"])) {
                this.dateRange = [] as any;
                for (let item of _data["dateRange"])
                    this.dateRange!.push(item);
            }
            else {
                this.dateRange = null as any;
            }
            if (Array.isArray(_data["completedTasks"])) {
                this.completedTasks = [] as any;
                for (let item of _data["completedTasks"])
                    this.completedTasks!.push(TaskDetailChartData.fromJS(item));
            }
            else {
                this.completedTasks = null as any;
            }
            if (Array.isArray(_data["remainingTasks"])) {
                this.remainingTasks = [] as any;
                for (let item of _data["remainingTasks"])
                    this.remainingTasks!.push(TaskDetailBarChartRemainingTasks.fromJS(item));
            }
            else {
                this.remainingTasks = null as any;
            }
            if (Array.isArray(_data["plannedTasks"])) {
                this.plannedTasks = [] as any;
                for (let item of _data["plannedTasks"])
                    this.plannedTasks!.push(TaskDetailBarChartPlannedTasks.fromJS(item));
            }
            else {
                this.plannedTasks = null as any;
            }
        }
    }

    static fromJS(data: any): TaskDetailsBarChartViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDetailsBarChartViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dateRange)) {
            data["dateRange"] = [];
            for (let item of this.dateRange)
                data["dateRange"].push(item);
        }
        if (Array.isArray(this.completedTasks)) {
            data["completedTasks"] = [];
            for (let item of this.completedTasks)
                data["completedTasks"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.remainingTasks)) {
            data["remainingTasks"] = [];
            for (let item of this.remainingTasks)
                data["remainingTasks"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.plannedTasks)) {
            data["plannedTasks"] = [];
            for (let item of this.plannedTasks)
                data["plannedTasks"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): TaskDetailsBarChartViewModel {
        const json = this.toJSON();
        let result = new TaskDetailsBarChartViewModel();
        result.init(json);
        return result;
    }
}

export interface ITaskDetailsBarChartViewModel {
    dateRange?: string[] | null;
    completedTasks?: TaskDetailChartData[] | null;
    remainingTasks?: TaskDetailBarChartRemainingTasks[] | null;
    plannedTasks?: TaskDetailBarChartPlannedTasks[] | null;
}

export class TaskDetailChartData implements ITaskDetailChartData {
    name?: string | null;
    data?: number[] | null;

    constructor(data?: ITaskDetailChartData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(item);
            }
            else {
                this.data = null as any;
            }
        }
    }

    static fromJS(data: any): TaskDetailChartData {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDetailChartData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        return data;
    }

    clone(): TaskDetailChartData {
        const json = this.toJSON();
        let result = new TaskDetailChartData();
        result.init(json);
        return result;
    }
}

export interface ITaskDetailChartData {
    name?: string | null;
    data?: number[] | null;
}

export class TaskDetailBarChartRemainingTasks extends TaskDetailChartData implements ITaskDetailBarChartRemainingTasks {
    data?: (number | null)[] | null;

    constructor(data?: ITaskDetailBarChartRemainingTasks) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(item);
            }
            else {
                this.data = null as any;
            }
        }
    }

    static override fromJS(data: any): TaskDetailBarChartRemainingTasks {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDetailBarChartRemainingTasks();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): TaskDetailBarChartRemainingTasks {
        const json = this.toJSON();
        let result = new TaskDetailBarChartRemainingTasks();
        result.init(json);
        return result;
    }
}

export interface ITaskDetailBarChartRemainingTasks extends ITaskDetailChartData {
    data?: (number | null)[] | null;
}

export class TaskDetailBarChartPlannedTasks extends TaskDetailChartData implements ITaskDetailBarChartPlannedTasks {
    data?: number[] | null;

    constructor(data?: ITaskDetailBarChartPlannedTasks) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(item);
            }
            else {
                this.data = null as any;
            }
        }
    }

    static override fromJS(data: any): TaskDetailBarChartPlannedTasks {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDetailBarChartPlannedTasks();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): TaskDetailBarChartPlannedTasks {
        const json = this.toJSON();
        let result = new TaskDetailBarChartPlannedTasks();
        result.init(json);
        return result;
    }
}

export interface ITaskDetailBarChartPlannedTasks extends ITaskDetailChartData {
    data?: number[] | null;
}

export class TaskDetailStackedChartViewModel implements ITaskDetailStackedChartViewModel {
    serviceTaskNames?: string[] | null;
    stackedChartData?: TaskDetailChartData[] | null;

    constructor(data?: ITaskDetailStackedChartViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["serviceTaskNames"])) {
                this.serviceTaskNames = [] as any;
                for (let item of _data["serviceTaskNames"])
                    this.serviceTaskNames!.push(item);
            }
            else {
                this.serviceTaskNames = null as any;
            }
            if (Array.isArray(_data["stackedChartData"])) {
                this.stackedChartData = [] as any;
                for (let item of _data["stackedChartData"])
                    this.stackedChartData!.push(TaskDetailChartData.fromJS(item));
            }
            else {
                this.stackedChartData = null as any;
            }
        }
    }

    static fromJS(data: any): TaskDetailStackedChartViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDetailStackedChartViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.serviceTaskNames)) {
            data["serviceTaskNames"] = [];
            for (let item of this.serviceTaskNames)
                data["serviceTaskNames"].push(item);
        }
        if (Array.isArray(this.stackedChartData)) {
            data["stackedChartData"] = [];
            for (let item of this.stackedChartData)
                data["stackedChartData"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): TaskDetailStackedChartViewModel {
        const json = this.toJSON();
        let result = new TaskDetailStackedChartViewModel();
        result.init(json);
        return result;
    }
}

export interface ITaskDetailStackedChartViewModel {
    serviceTaskNames?: string[] | null;
    stackedChartData?: TaskDetailChartData[] | null;
}

export class TaskDetailsCombineChartsViewModel implements ITaskDetailsCombineChartsViewModel {
    barChart?: TaskDetailCombineBarViewModel | null;
    pieChart?: TaskDetailPieChartViewModel | null;
    accountTasks?: string[] | null;

    constructor(data?: ITaskDetailsCombineChartsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.barChart = _data["barChart"] ? TaskDetailCombineBarViewModel.fromJS(_data["barChart"]) : null as any;
            this.pieChart = _data["pieChart"] ? TaskDetailPieChartViewModel.fromJS(_data["pieChart"]) : null as any;
            if (Array.isArray(_data["accountTasks"])) {
                this.accountTasks = [] as any;
                for (let item of _data["accountTasks"])
                    this.accountTasks!.push(item);
            }
            else {
                this.accountTasks = null as any;
            }
        }
    }

    static fromJS(data: any): TaskDetailsCombineChartsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDetailsCombineChartsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barChart"] = this.barChart ? this.barChart.toJSON() : null as any;
        data["pieChart"] = this.pieChart ? this.pieChart.toJSON() : null as any;
        if (Array.isArray(this.accountTasks)) {
            data["accountTasks"] = [];
            for (let item of this.accountTasks)
                data["accountTasks"].push(item);
        }
        return data;
    }

    clone(): TaskDetailsCombineChartsViewModel {
        const json = this.toJSON();
        let result = new TaskDetailsCombineChartsViewModel();
        result.init(json);
        return result;
    }
}

export interface ITaskDetailsCombineChartsViewModel {
    barChart?: TaskDetailCombineBarViewModel | null;
    pieChart?: TaskDetailPieChartViewModel | null;
    accountTasks?: string[] | null;
}

export class TaskDetailCombineBarViewModel implements ITaskDetailCombineBarViewModel {
    dateRange?: string[] | null;
    completedTasks?: number[] | null;
    remainingTasks?: number[] | null;
    plannedTasks?: number[] | null;

    constructor(data?: ITaskDetailCombineBarViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dateRange"])) {
                this.dateRange = [] as any;
                for (let item of _data["dateRange"])
                    this.dateRange!.push(item);
            }
            else {
                this.dateRange = null as any;
            }
            if (Array.isArray(_data["completedTasks"])) {
                this.completedTasks = [] as any;
                for (let item of _data["completedTasks"])
                    this.completedTasks!.push(item);
            }
            else {
                this.completedTasks = null as any;
            }
            if (Array.isArray(_data["remainingTasks"])) {
                this.remainingTasks = [] as any;
                for (let item of _data["remainingTasks"])
                    this.remainingTasks!.push(item);
            }
            else {
                this.remainingTasks = null as any;
            }
            if (Array.isArray(_data["plannedTasks"])) {
                this.plannedTasks = [] as any;
                for (let item of _data["plannedTasks"])
                    this.plannedTasks!.push(item);
            }
            else {
                this.plannedTasks = null as any;
            }
        }
    }

    static fromJS(data: any): TaskDetailCombineBarViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDetailCombineBarViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dateRange)) {
            data["dateRange"] = [];
            for (let item of this.dateRange)
                data["dateRange"].push(item);
        }
        if (Array.isArray(this.completedTasks)) {
            data["completedTasks"] = [];
            for (let item of this.completedTasks)
                data["completedTasks"].push(item);
        }
        if (Array.isArray(this.remainingTasks)) {
            data["remainingTasks"] = [];
            for (let item of this.remainingTasks)
                data["remainingTasks"].push(item);
        }
        if (Array.isArray(this.plannedTasks)) {
            data["plannedTasks"] = [];
            for (let item of this.plannedTasks)
                data["plannedTasks"].push(item);
        }
        return data;
    }

    clone(): TaskDetailCombineBarViewModel {
        const json = this.toJSON();
        let result = new TaskDetailCombineBarViewModel();
        result.init(json);
        return result;
    }
}

export interface ITaskDetailCombineBarViewModel {
    dateRange?: string[] | null;
    completedTasks?: number[] | null;
    remainingTasks?: number[] | null;
    plannedTasks?: number[] | null;
}

export class TaskDetailPieChartViewModel implements ITaskDetailPieChartViewModel {
    completedStores?: number;
    scheduledStores?: number;
    pastScheduledStores?: number;

    constructor(data?: ITaskDetailPieChartViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.completedStores = _data["completedStores"] !== undefined ? _data["completedStores"] : null as any;
            this.scheduledStores = _data["scheduledStores"] !== undefined ? _data["scheduledStores"] : null as any;
            this.pastScheduledStores = _data["pastScheduledStores"] !== undefined ? _data["pastScheduledStores"] : null as any;
        }
    }

    static fromJS(data: any): TaskDetailPieChartViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDetailPieChartViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completedStores"] = this.completedStores !== undefined ? this.completedStores : null as any;
        data["scheduledStores"] = this.scheduledStores !== undefined ? this.scheduledStores : null as any;
        data["pastScheduledStores"] = this.pastScheduledStores !== undefined ? this.pastScheduledStores : null as any;
        return data;
    }

    clone(): TaskDetailPieChartViewModel {
        const json = this.toJSON();
        let result = new TaskDetailPieChartViewModel();
        result.init(json);
        return result;
    }
}

export interface ITaskDetailPieChartViewModel {
    completedStores?: number;
    scheduledStores?: number;
    pastScheduledStores?: number;
}

export class TaskReportParameters implements ITaskReportParameters {
    accountIds?: number[] | null;
    serviceTaskStatuses?: StatusTypes[] | null;
    taskLocationStatuses?: StatusTypes[] | null;
    modelTypes?: ServiceModelTypes[] | null;
    activities?: string[] | null;
    supplierId?: number | null;
    departmentNumbers?: string[] | null;
    storeNumber?: string | null;
    fromDate?: moment.Moment;
    toDate?: moment.Moment;

    constructor(data?: ITaskReportParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accountIds"])) {
                this.accountIds = [] as any;
                for (let item of _data["accountIds"])
                    this.accountIds!.push(item);
            }
            else {
                this.accountIds = null as any;
            }
            if (Array.isArray(_data["serviceTaskStatuses"])) {
                this.serviceTaskStatuses = [] as any;
                for (let item of _data["serviceTaskStatuses"])
                    this.serviceTaskStatuses!.push(item);
            }
            else {
                this.serviceTaskStatuses = null as any;
            }
            if (Array.isArray(_data["taskLocationStatuses"])) {
                this.taskLocationStatuses = [] as any;
                for (let item of _data["taskLocationStatuses"])
                    this.taskLocationStatuses!.push(item);
            }
            else {
                this.taskLocationStatuses = null as any;
            }
            if (Array.isArray(_data["modelTypes"])) {
                this.modelTypes = [] as any;
                for (let item of _data["modelTypes"])
                    this.modelTypes!.push(item);
            }
            else {
                this.modelTypes = null as any;
            }
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(item);
            }
            else {
                this.activities = null as any;
            }
            this.supplierId = _data["supplierId"] !== undefined ? _data["supplierId"] : null as any;
            if (Array.isArray(_data["departmentNumbers"])) {
                this.departmentNumbers = [] as any;
                for (let item of _data["departmentNumbers"])
                    this.departmentNumbers!.push(item);
            }
            else {
                this.departmentNumbers = null as any;
            }
            this.storeNumber = _data["storeNumber"] !== undefined ? _data["storeNumber"] : null as any;
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : null as any;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): TaskReportParameters {
        data = typeof data === 'object' ? data : {};
        let result = new TaskReportParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accountIds)) {
            data["accountIds"] = [];
            for (let item of this.accountIds)
                data["accountIds"].push(item);
        }
        if (Array.isArray(this.serviceTaskStatuses)) {
            data["serviceTaskStatuses"] = [];
            for (let item of this.serviceTaskStatuses)
                data["serviceTaskStatuses"].push(item);
        }
        if (Array.isArray(this.taskLocationStatuses)) {
            data["taskLocationStatuses"] = [];
            for (let item of this.taskLocationStatuses)
                data["taskLocationStatuses"].push(item);
        }
        if (Array.isArray(this.modelTypes)) {
            data["modelTypes"] = [];
            for (let item of this.modelTypes)
                data["modelTypes"].push(item);
        }
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item);
        }
        data["supplierId"] = this.supplierId !== undefined ? this.supplierId : null as any;
        if (Array.isArray(this.departmentNumbers)) {
            data["departmentNumbers"] = [];
            for (let item of this.departmentNumbers)
                data["departmentNumbers"].push(item);
        }
        data["storeNumber"] = this.storeNumber !== undefined ? this.storeNumber : null as any;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : null as any;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : null as any;
        return data;
    }

    clone(): TaskReportParameters {
        const json = this.toJSON();
        let result = new TaskReportParameters();
        result.init(json);
        return result;
    }
}

export interface ITaskReportParameters {
    accountIds?: number[] | null;
    serviceTaskStatuses?: StatusTypes[] | null;
    taskLocationStatuses?: StatusTypes[] | null;
    modelTypes?: ServiceModelTypes[] | null;
    activities?: string[] | null;
    supplierId?: number | null;
    departmentNumbers?: string[] | null;
    storeNumber?: string | null;
    fromDate?: moment.Moment;
    toDate?: moment.Moment;
}

export class TaskLocationImportViewModel implements ITaskLocationImportViewModel {
    errorList?: string[] | null;
    transactionId?: string | null;

    constructor(data?: ITaskLocationImportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errorList"])) {
                this.errorList = [] as any;
                for (let item of _data["errorList"])
                    this.errorList!.push(item);
            }
            else {
                this.errorList = null as any;
            }
            this.transactionId = _data["transactionId"] !== undefined ? _data["transactionId"] : null as any;
        }
    }

    static fromJS(data: any): TaskLocationImportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskLocationImportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errorList)) {
            data["errorList"] = [];
            for (let item of this.errorList)
                data["errorList"].push(item);
        }
        data["transactionId"] = this.transactionId !== undefined ? this.transactionId : null as any;
        return data;
    }

    clone(): TaskLocationImportViewModel {
        const json = this.toJSON();
        let result = new TaskLocationImportViewModel();
        result.init(json);
        return result;
    }
}

export interface ITaskLocationImportViewModel {
    errorList?: string[] | null;
    transactionId?: string | null;
}

export class TaskResult implements ITaskResult {
    taskLocationReferenceNumber!: string;
    taskLocation?: TaskLocation | null;
    referenceNumber!: string;
    /** Actual minutes for the task reported by the rep */
    actualMinutes?: number | null;
    /** Employee number of the rep who performmed the work */
    employeeNumber?: string | null;
    completionDate?: moment.Moment | null;
    reason?: TaskCompletionReason;
    otherReason?: string | null;
    createdDate?: moment.Moment | null;
    items?: Item[] | null;

    constructor(data?: ITaskResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskLocationReferenceNumber = _data["taskLocationReferenceNumber"] !== undefined ? _data["taskLocationReferenceNumber"] : null as any;
            this.taskLocation = _data["taskLocation"] ? TaskLocation.fromJS(_data["taskLocation"]) : null as any;
            this.referenceNumber = _data["referenceNumber"] !== undefined ? _data["referenceNumber"] : null as any;
            this.actualMinutes = _data["actualMinutes"] !== undefined ? _data["actualMinutes"] : null as any;
            this.employeeNumber = _data["employeeNumber"] !== undefined ? _data["employeeNumber"] : null as any;
            this.completionDate = _data["completionDate"] ? moment(_data["completionDate"].toString()) : null as any;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
            this.otherReason = _data["otherReason"] !== undefined ? _data["otherReason"] : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Item.fromJS(item));
            }
            else {
                this.items = null as any;
            }
        }
    }

    static fromJS(data: any): TaskResult {
        data = typeof data === 'object' ? data : {};
        let result = new TaskResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskLocationReferenceNumber"] = this.taskLocationReferenceNumber !== undefined ? this.taskLocationReferenceNumber : null as any;
        data["taskLocation"] = this.taskLocation ? this.taskLocation.toJSON() : null as any;
        data["referenceNumber"] = this.referenceNumber !== undefined ? this.referenceNumber : null as any;
        data["actualMinutes"] = this.actualMinutes !== undefined ? this.actualMinutes : null as any;
        data["employeeNumber"] = this.employeeNumber !== undefined ? this.employeeNumber : null as any;
        data["completionDate"] = this.completionDate ? this.completionDate.toISOString() : null as any;
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        data["otherReason"] = this.otherReason !== undefined ? this.otherReason : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): TaskResult {
        const json = this.toJSON();
        let result = new TaskResult();
        result.init(json);
        return result;
    }
}

export interface ITaskResult {
    taskLocationReferenceNumber: string;
    taskLocation?: TaskLocation | null;
    referenceNumber: string;
    /** Actual minutes for the task reported by the rep */
    actualMinutes?: number | null;
    /** Employee number of the rep who performmed the work */
    employeeNumber?: string | null;
    completionDate?: moment.Moment | null;
    reason?: TaskCompletionReason;
    otherReason?: string | null;
    createdDate?: moment.Moment | null;
    items?: Item[] | null;
}

export class TaskLocation implements ITaskLocation {
    number!: string;
    referenceNumber!: string;
    employeeNumbers?: string[] | null;
    start?: moment.Moment | null;
    end?: moment.Moment | null;
    dueDate?: moment.Moment | null;
    localStart?: moment.Moment | null;
    localEnd?: moment.Moment | null;
    status!: StatusTypes;
    items?: Item[] | null;

    constructor(data?: ITaskLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"] !== undefined ? _data["number"] : null as any;
            this.referenceNumber = _data["referenceNumber"] !== undefined ? _data["referenceNumber"] : null as any;
            if (Array.isArray(_data["employeeNumbers"])) {
                this.employeeNumbers = [] as any;
                for (let item of _data["employeeNumbers"])
                    this.employeeNumbers!.push(item);
            }
            else {
                this.employeeNumbers = null as any;
            }
            this.start = _data["start"] ? moment(_data["start"].toString()) : null as any;
            this.end = _data["end"] ? moment(_data["end"].toString()) : null as any;
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : null as any;
            this.localStart = _data["localStart"] ? moment(_data["localStart"].toString()) : null as any;
            this.localEnd = _data["localEnd"] ? moment(_data["localEnd"].toString()) : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Item.fromJS(item));
            }
            else {
                this.items = null as any;
            }
        }
    }

    static fromJS(data: any): TaskLocation {
        data = typeof data === 'object' ? data : {};
        let result = new TaskLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number !== undefined ? this.number : null as any;
        data["referenceNumber"] = this.referenceNumber !== undefined ? this.referenceNumber : null as any;
        if (Array.isArray(this.employeeNumbers)) {
            data["employeeNumbers"] = [];
            for (let item of this.employeeNumbers)
                data["employeeNumbers"].push(item);
        }
        data["start"] = this.start ? this.start.toISOString() : null as any;
        data["end"] = this.end ? this.end.toISOString() : null as any;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : null as any;
        data["localStart"] = this.localStart ? this.localStart.toISOString() : null as any;
        data["localEnd"] = this.localEnd ? this.localEnd.toISOString() : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): TaskLocation {
        const json = this.toJSON();
        let result = new TaskLocation();
        result.init(json);
        return result;
    }
}

export interface ITaskLocation {
    number: string;
    referenceNumber: string;
    employeeNumbers?: string[] | null;
    start?: moment.Moment | null;
    end?: moment.Moment | null;
    dueDate?: moment.Moment | null;
    localStart?: moment.Moment | null;
    localEnd?: moment.Moment | null;
    status: StatusTypes;
    items?: Item[] | null;
}

export enum TaskCompletionReason {
    Completed = "completed",
    NotEnoughTime = "notEnoughTime",
    Other = "other",
}

export class LimitedResultOfToDoList implements ILimitedResultOfToDoList {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: ToDoList[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfToDoList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ToDoList.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfToDoList {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfToDoList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfToDoList {
        const json = this.toJSON();
        let result = new LimitedResultOfToDoList();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfToDoList {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: ToDoList[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class ToDoList implements IToDoList {
    storeNumber?: string | null;
    itemNumber?: string | null;
    quantity?: number;
    status?: string | null;
    helpUrl?: string | null;

    constructor(data?: IToDoList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeNumber = _data["storeNumber"] !== undefined ? _data["storeNumber"] : null as any;
            this.itemNumber = _data["itemNumber"] !== undefined ? _data["itemNumber"] : null as any;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.helpUrl = _data["helpUrl"] !== undefined ? _data["helpUrl"] : null as any;
        }
    }

    static fromJS(data: any): ToDoList {
        data = typeof data === 'object' ? data : {};
        let result = new ToDoList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeNumber"] = this.storeNumber !== undefined ? this.storeNumber : null as any;
        data["itemNumber"] = this.itemNumber !== undefined ? this.itemNumber : null as any;
        data["quantity"] = this.quantity !== undefined ? this.quantity : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["helpUrl"] = this.helpUrl !== undefined ? this.helpUrl : null as any;
        return data;
    }

    clone(): ToDoList {
        const json = this.toJSON();
        let result = new ToDoList();
        result.init(json);
        return result;
    }
}

export interface IToDoList {
    storeNumber?: string | null;
    itemNumber?: string | null;
    quantity?: number;
    status?: string | null;
    helpUrl?: string | null;
}

export class UploadStatus implements IUploadStatus {
    warnings?: string[] | null;
    errors?: string[] | null;

    constructor(data?: IUploadStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(item);
            }
            else {
                this.warnings = null as any;
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            else {
                this.errors = null as any;
            }
        }
    }

    static fromJS(data: any): UploadStatus {
        data = typeof data === 'object' ? data : {};
        let result = new UploadStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }

    clone(): UploadStatus {
        const json = this.toJSON();
        let result = new UploadStatus();
        result.init(json);
        return result;
    }
}

export interface IUploadStatus {
    warnings?: string[] | null;
    errors?: string[] | null;
}

export class UserAccessReviewReport implements IUserAccessReviewReport {
    userData?: LimitedResultOfUserAccessReviewReportData | null;
    userAccessReviewUserCounts?: UserAccessReviewUserCounts | null;

    constructor(data?: IUserAccessReviewReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userData = _data["userData"] ? LimitedResultOfUserAccessReviewReportData.fromJS(_data["userData"]) : null as any;
            this.userAccessReviewUserCounts = _data["userAccessReviewUserCounts"] ? UserAccessReviewUserCounts.fromJS(_data["userAccessReviewUserCounts"]) : null as any;
        }
    }

    static fromJS(data: any): UserAccessReviewReport {
        data = typeof data === 'object' ? data : {};
        let result = new UserAccessReviewReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userData"] = this.userData ? this.userData.toJSON() : null as any;
        data["userAccessReviewUserCounts"] = this.userAccessReviewUserCounts ? this.userAccessReviewUserCounts.toJSON() : null as any;
        return data;
    }

    clone(): UserAccessReviewReport {
        const json = this.toJSON();
        let result = new UserAccessReviewReport();
        result.init(json);
        return result;
    }
}

export interface IUserAccessReviewReport {
    userData?: LimitedResultOfUserAccessReviewReportData | null;
    userAccessReviewUserCounts?: UserAccessReviewUserCounts | null;
}

export class LimitedResultOfUserAccessReviewReportData implements ILimitedResultOfUserAccessReviewReportData {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: UserAccessReviewReportData[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfUserAccessReviewReportData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(UserAccessReviewReportData.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfUserAccessReviewReportData {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfUserAccessReviewReportData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfUserAccessReviewReportData {
        const json = this.toJSON();
        let result = new LimitedResultOfUserAccessReviewReportData();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfUserAccessReviewReportData {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: UserAccessReviewReportData[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class UserAccessReviewReportData implements IUserAccessReviewReportData {
    accountName?: string | null;
    accountId?: number | null;
    accessReviewStatus?: string | null;
    employeeNumber?: string | null;
    userId?: string | null;
    name?: string | null;
    email?: string | null;
    rolesId?: number | null;
    role?: string | null;
    roleCapability?: string | null;
    tags?: Tag3[] | null;
    dateCreated?: moment.Moment | null;

    constructor(data?: IUserAccessReviewReportData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.accessReviewStatus = _data["accessReviewStatus"] !== undefined ? _data["accessReviewStatus"] : null as any;
            this.employeeNumber = _data["employeeNumber"] !== undefined ? _data["employeeNumber"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.rolesId = _data["rolesId"] !== undefined ? _data["rolesId"] : null as any;
            this.role = _data["role"] !== undefined ? _data["role"] : null as any;
            this.roleCapability = _data["roleCapability"] !== undefined ? _data["roleCapability"] : null as any;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(Tag3.fromJS(item));
            }
            else {
                this.tags = null as any;
            }
            this.dateCreated = _data["dateCreated"] ? moment(_data["dateCreated"].toString()) : null as any;
        }
    }

    static fromJS(data: any): UserAccessReviewReportData {
        data = typeof data === 'object' ? data : {};
        let result = new UserAccessReviewReportData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["accessReviewStatus"] = this.accessReviewStatus !== undefined ? this.accessReviewStatus : null as any;
        data["employeeNumber"] = this.employeeNumber !== undefined ? this.employeeNumber : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["rolesId"] = this.rolesId !== undefined ? this.rolesId : null as any;
        data["role"] = this.role !== undefined ? this.role : null as any;
        data["roleCapability"] = this.roleCapability !== undefined ? this.roleCapability : null as any;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : null as any);
        }
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : null as any;
        return data;
    }

    clone(): UserAccessReviewReportData {
        const json = this.toJSON();
        let result = new UserAccessReviewReportData();
        result.init(json);
        return result;
    }
}

export interface IUserAccessReviewReportData {
    accountName?: string | null;
    accountId?: number | null;
    accessReviewStatus?: string | null;
    employeeNumber?: string | null;
    userId?: string | null;
    name?: string | null;
    email?: string | null;
    rolesId?: number | null;
    role?: string | null;
    roleCapability?: string | null;
    tags?: Tag3[] | null;
    dateCreated?: moment.Moment | null;
}

export class UserAccessReviewUserCounts implements IUserAccessReviewUserCounts {
    numberOfActiveUsers?: number;
    numberOfDormantUsers?: number;
    numberOfPendingUsers?: number;

    constructor(data?: IUserAccessReviewUserCounts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfActiveUsers = _data["numberOfActiveUsers"] !== undefined ? _data["numberOfActiveUsers"] : null as any;
            this.numberOfDormantUsers = _data["numberOfDormantUsers"] !== undefined ? _data["numberOfDormantUsers"] : null as any;
            this.numberOfPendingUsers = _data["numberOfPendingUsers"] !== undefined ? _data["numberOfPendingUsers"] : null as any;
        }
    }

    static fromJS(data: any): UserAccessReviewUserCounts {
        data = typeof data === 'object' ? data : {};
        let result = new UserAccessReviewUserCounts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfActiveUsers"] = this.numberOfActiveUsers !== undefined ? this.numberOfActiveUsers : null as any;
        data["numberOfDormantUsers"] = this.numberOfDormantUsers !== undefined ? this.numberOfDormantUsers : null as any;
        data["numberOfPendingUsers"] = this.numberOfPendingUsers !== undefined ? this.numberOfPendingUsers : null as any;
        return data;
    }

    clone(): UserAccessReviewUserCounts {
        const json = this.toJSON();
        let result = new UserAccessReviewUserCounts();
        result.init(json);
        return result;
    }
}

export interface IUserAccessReviewUserCounts {
    numberOfActiveUsers?: number;
    numberOfDormantUsers?: number;
    numberOfPendingUsers?: number;
}

export class UserInformation implements IUserInformation {
    id?: string;
    email?: string | null;
    badgeNumber?: string | null;
    firstName?: string | null;
    middleInitial?: string | null;
    lastName?: string | null;
    nickName?: string | null;
    number?: string | null;
    awaitingBadge?: boolean;
    imageUrl?: string | null;
    roles?: string | null;
    roleType?: ERoleType;
    locationNumbers?: string[] | null;
    courses?: Course2[] | null;
    accountId?: number;
    title?: string | null;
    wmtVoltFeatures?: WmtVoltFeatures[] | null;
    qrCodeScanner?: ScannerOptions;
    itemScanner?: ScannerOptions;
    printerScanner?: ScannerOptions;
    account?: AccountInformation | null;
    badgePrintedDate?: moment.Moment | null;
    badgeNeverReceived?: boolean;
    badgeScanned?: boolean;
    lastSignIn?: SignInEvent | null;
    tags?: string[] | null;
    skipBadgeScanning?: boolean;
    needBadgePhoto?: boolean;
    personId?: number;
    banners?: string[] | null;
    retailers?: string[] | null;
    manager?: ManagerModel2 | null;
    cultureName?: string | null;

    constructor(data?: IUserInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.badgeNumber = _data["badgeNumber"] !== undefined ? _data["badgeNumber"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.middleInitial = _data["middleInitial"] !== undefined ? _data["middleInitial"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.nickName = _data["nickName"] !== undefined ? _data["nickName"] : null as any;
            this.number = _data["number"] !== undefined ? _data["number"] : null as any;
            this.awaitingBadge = _data["awaitingBadge"] !== undefined ? _data["awaitingBadge"] : null as any;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : null as any;
            this.roles = _data["roles"] !== undefined ? _data["roles"] : null as any;
            this.roleType = _data["roleType"] !== undefined ? _data["roleType"] : null as any;
            if (Array.isArray(_data["locationNumbers"])) {
                this.locationNumbers = [] as any;
                for (let item of _data["locationNumbers"])
                    this.locationNumbers!.push(item);
            }
            else {
                this.locationNumbers = null as any;
            }
            if (Array.isArray(_data["courses"])) {
                this.courses = [] as any;
                for (let item of _data["courses"])
                    this.courses!.push(Course2.fromJS(item));
            }
            else {
                this.courses = null as any;
            }
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            if (Array.isArray(_data["wmtVoltFeatures"])) {
                this.wmtVoltFeatures = [] as any;
                for (let item of _data["wmtVoltFeatures"])
                    this.wmtVoltFeatures!.push(item);
            }
            else {
                this.wmtVoltFeatures = null as any;
            }
            this.qrCodeScanner = _data["qrCodeScanner"] !== undefined ? _data["qrCodeScanner"] : null as any;
            this.itemScanner = _data["itemScanner"] !== undefined ? _data["itemScanner"] : null as any;
            this.printerScanner = _data["printerScanner"] !== undefined ? _data["printerScanner"] : null as any;
            this.account = _data["account"] ? AccountInformation.fromJS(_data["account"]) : null as any;
            this.badgePrintedDate = _data["badgePrintedDate"] ? moment(_data["badgePrintedDate"].toString()) : null as any;
            this.badgeNeverReceived = _data["badgeNeverReceived"] !== undefined ? _data["badgeNeverReceived"] : null as any;
            this.badgeScanned = _data["badgeScanned"] !== undefined ? _data["badgeScanned"] : null as any;
            this.lastSignIn = _data["lastSignIn"] ? SignInEvent.fromJS(_data["lastSignIn"]) : null as any;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            else {
                this.tags = null as any;
            }
            this.skipBadgeScanning = _data["skipBadgeScanning"] !== undefined ? _data["skipBadgeScanning"] : null as any;
            this.needBadgePhoto = _data["needBadgePhoto"] !== undefined ? _data["needBadgePhoto"] : null as any;
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null as any;
            if (Array.isArray(_data["banners"])) {
                this.banners = [] as any;
                for (let item of _data["banners"])
                    this.banners!.push(item);
            }
            else {
                this.banners = null as any;
            }
            if (Array.isArray(_data["retailers"])) {
                this.retailers = [] as any;
                for (let item of _data["retailers"])
                    this.retailers!.push(item);
            }
            else {
                this.retailers = null as any;
            }
            this.manager = _data["manager"] ? ManagerModel2.fromJS(_data["manager"]) : null as any;
            this.cultureName = _data["cultureName"] !== undefined ? _data["cultureName"] : null as any;
        }
    }

    static fromJS(data: any): UserInformation {
        data = typeof data === 'object' ? data : {};
        let result = new UserInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["badgeNumber"] = this.badgeNumber !== undefined ? this.badgeNumber : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["middleInitial"] = this.middleInitial !== undefined ? this.middleInitial : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["nickName"] = this.nickName !== undefined ? this.nickName : null as any;
        data["number"] = this.number !== undefined ? this.number : null as any;
        data["awaitingBadge"] = this.awaitingBadge !== undefined ? this.awaitingBadge : null as any;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : null as any;
        data["roles"] = this.roles !== undefined ? this.roles : null as any;
        data["roleType"] = this.roleType !== undefined ? this.roleType : null as any;
        if (Array.isArray(this.locationNumbers)) {
            data["locationNumbers"] = [];
            for (let item of this.locationNumbers)
                data["locationNumbers"].push(item);
        }
        if (Array.isArray(this.courses)) {
            data["courses"] = [];
            for (let item of this.courses)
                data["courses"].push(item ? item.toJSON() : null as any);
        }
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        if (Array.isArray(this.wmtVoltFeatures)) {
            data["wmtVoltFeatures"] = [];
            for (let item of this.wmtVoltFeatures)
                data["wmtVoltFeatures"].push(item);
        }
        data["qrCodeScanner"] = this.qrCodeScanner !== undefined ? this.qrCodeScanner : null as any;
        data["itemScanner"] = this.itemScanner !== undefined ? this.itemScanner : null as any;
        data["printerScanner"] = this.printerScanner !== undefined ? this.printerScanner : null as any;
        data["account"] = this.account ? this.account.toJSON() : null as any;
        data["badgePrintedDate"] = this.badgePrintedDate ? this.badgePrintedDate.toISOString() : null as any;
        data["badgeNeverReceived"] = this.badgeNeverReceived !== undefined ? this.badgeNeverReceived : null as any;
        data["badgeScanned"] = this.badgeScanned !== undefined ? this.badgeScanned : null as any;
        data["lastSignIn"] = this.lastSignIn ? this.lastSignIn.toJSON() : null as any;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["skipBadgeScanning"] = this.skipBadgeScanning !== undefined ? this.skipBadgeScanning : null as any;
        data["needBadgePhoto"] = this.needBadgePhoto !== undefined ? this.needBadgePhoto : null as any;
        data["personId"] = this.personId !== undefined ? this.personId : null as any;
        if (Array.isArray(this.banners)) {
            data["banners"] = [];
            for (let item of this.banners)
                data["banners"].push(item);
        }
        if (Array.isArray(this.retailers)) {
            data["retailers"] = [];
            for (let item of this.retailers)
                data["retailers"].push(item);
        }
        data["manager"] = this.manager ? this.manager.toJSON() : null as any;
        data["cultureName"] = this.cultureName !== undefined ? this.cultureName : null as any;
        return data;
    }

    clone(): UserInformation {
        const json = this.toJSON();
        let result = new UserInformation();
        result.init(json);
        return result;
    }
}

export interface IUserInformation {
    id?: string;
    email?: string | null;
    badgeNumber?: string | null;
    firstName?: string | null;
    middleInitial?: string | null;
    lastName?: string | null;
    nickName?: string | null;
    number?: string | null;
    awaitingBadge?: boolean;
    imageUrl?: string | null;
    roles?: string | null;
    roleType?: ERoleType;
    locationNumbers?: string[] | null;
    courses?: Course2[] | null;
    accountId?: number;
    title?: string | null;
    wmtVoltFeatures?: WmtVoltFeatures[] | null;
    qrCodeScanner?: ScannerOptions;
    itemScanner?: ScannerOptions;
    printerScanner?: ScannerOptions;
    account?: AccountInformation | null;
    badgePrintedDate?: moment.Moment | null;
    badgeNeverReceived?: boolean;
    badgeScanned?: boolean;
    lastSignIn?: SignInEvent | null;
    tags?: string[] | null;
    skipBadgeScanning?: boolean;
    needBadgePhoto?: boolean;
    personId?: number;
    banners?: string[] | null;
    retailers?: string[] | null;
    manager?: ManagerModel2 | null;
    cultureName?: string | null;
}

export enum ERoleType {
    Unknown = "unknown",
    SystemAdmin = "systemAdmin",
    Retailer = "retailer",
    Provider = "provider",
    Supplier = "supplier",
    Test = "test",
    None = "none",
}

export enum ScannerOptions {
    Default = "default",
    Zxing = "zxing",
    Scandit = "scandit",
    GoogleScanner = "googleScanner",
}

export class AccountInformation implements IAccountInformation {
    accountId?: number;
    accountNumber?: string | null;
    name?: string | null;
    abbrev?: string | null;
    imageUrl?: string | null;
    fieldGroupType?: string | null;
    badgeFooterColor?: string | null;
    supportEmail?: string | null;
    supportPhone?: string | null;
    supportNote?: string | null;
    applications?: Application[] | null;

    constructor(data?: IAccountInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.abbrev = _data["abbrev"] !== undefined ? _data["abbrev"] : null as any;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : null as any;
            this.fieldGroupType = _data["fieldGroupType"] !== undefined ? _data["fieldGroupType"] : null as any;
            this.badgeFooterColor = _data["badgeFooterColor"] !== undefined ? _data["badgeFooterColor"] : null as any;
            this.supportEmail = _data["supportEmail"] !== undefined ? _data["supportEmail"] : null as any;
            this.supportPhone = _data["supportPhone"] !== undefined ? _data["supportPhone"] : null as any;
            this.supportNote = _data["supportNote"] !== undefined ? _data["supportNote"] : null as any;
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(Application.fromJS(item));
            }
            else {
                this.applications = null as any;
            }
        }
    }

    static fromJS(data: any): AccountInformation {
        data = typeof data === 'object' ? data : {};
        let result = new AccountInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["abbrev"] = this.abbrev !== undefined ? this.abbrev : null as any;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : null as any;
        data["fieldGroupType"] = this.fieldGroupType !== undefined ? this.fieldGroupType : null as any;
        data["badgeFooterColor"] = this.badgeFooterColor !== undefined ? this.badgeFooterColor : null as any;
        data["supportEmail"] = this.supportEmail !== undefined ? this.supportEmail : null as any;
        data["supportPhone"] = this.supportPhone !== undefined ? this.supportPhone : null as any;
        data["supportNote"] = this.supportNote !== undefined ? this.supportNote : null as any;
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): AccountInformation {
        const json = this.toJSON();
        let result = new AccountInformation();
        result.init(json);
        return result;
    }
}

export interface IAccountInformation {
    accountId?: number;
    accountNumber?: string | null;
    name?: string | null;
    abbrev?: string | null;
    imageUrl?: string | null;
    fieldGroupType?: string | null;
    badgeFooterColor?: string | null;
    supportEmail?: string | null;
    supportPhone?: string | null;
    supportNote?: string | null;
    applications?: Application[] | null;
}

export class Application implements IApplication {
    activity?: string | null;
    note?: string | null;
    linkType?: LinkType;
    link?: string | null;

    constructor(data?: IApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activity = _data["activity"] !== undefined ? _data["activity"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.linkType = _data["linkType"] !== undefined ? _data["linkType"] : null as any;
            this.link = _data["link"] !== undefined ? _data["link"] : null as any;
        }
    }

    static fromJS(data: any): Application {
        data = typeof data === 'object' ? data : {};
        let result = new Application();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activity"] = this.activity !== undefined ? this.activity : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["linkType"] = this.linkType !== undefined ? this.linkType : null as any;
        data["link"] = this.link !== undefined ? this.link : null as any;
        return data;
    }

    clone(): Application {
        const json = this.toJSON();
        let result = new Application();
        result.init(json);
        return result;
    }
}

export interface IApplication {
    activity?: string | null;
    note?: string | null;
    linkType?: LinkType;
    link?: string | null;
}

export class SignInEvent implements ISignInEvent {
    id?: string;
    timeIn?: moment.Moment | null;
    timeInSystem?: moment.Moment | null;
    manuallyAlteredTimeIn?: boolean;
    timeOut?: moment.Moment | null;
    timeOutSystem?: moment.Moment | null;
    manuallyAlteredTimeOut?: boolean;
    signInBadgeStatus?: BadgeEventStatus;
    signOutBadgeStatus?: BadgeEventStatus;
    signInLat?: number | null;
    signInLong?: number | null;
    signOutLat?: number | null;
    signOutLong?: number | null;
    forcedCheckOut?: boolean | null;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment | null;
    checkInSource?: EventSource;
    checkOutSource?: EventSource | null;
    location?: Location2 | null;
    user?: UserInformation | null;

    constructor(data?: ISignInEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.timeIn = _data["timeIn"] ? moment(_data["timeIn"].toString()) : null as any;
            this.timeInSystem = _data["timeInSystem"] ? moment(_data["timeInSystem"].toString()) : null as any;
            this.manuallyAlteredTimeIn = _data["manuallyAlteredTimeIn"] !== undefined ? _data["manuallyAlteredTimeIn"] : null as any;
            this.timeOut = _data["timeOut"] ? moment(_data["timeOut"].toString()) : null as any;
            this.timeOutSystem = _data["timeOutSystem"] ? moment(_data["timeOutSystem"].toString()) : null as any;
            this.manuallyAlteredTimeOut = _data["manuallyAlteredTimeOut"] !== undefined ? _data["manuallyAlteredTimeOut"] : null as any;
            this.signInBadgeStatus = _data["signInBadgeStatus"] !== undefined ? _data["signInBadgeStatus"] : null as any;
            this.signOutBadgeStatus = _data["signOutBadgeStatus"] !== undefined ? _data["signOutBadgeStatus"] : null as any;
            this.signInLat = _data["signInLat"] !== undefined ? _data["signInLat"] : null as any;
            this.signInLong = _data["signInLong"] !== undefined ? _data["signInLong"] : null as any;
            this.signOutLat = _data["signOutLat"] !== undefined ? _data["signOutLat"] : null as any;
            this.signOutLong = _data["signOutLong"] !== undefined ? _data["signOutLong"] : null as any;
            this.forcedCheckOut = _data["forcedCheckOut"] !== undefined ? _data["forcedCheckOut"] : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            this.checkInSource = _data["checkInSource"] !== undefined ? _data["checkInSource"] : null as any;
            this.checkOutSource = _data["checkOutSource"] !== undefined ? _data["checkOutSource"] : null as any;
            this.location = _data["location"] ? Location2.fromJS(_data["location"]) : null as any;
            this.user = _data["user"] ? UserInformation.fromJS(_data["user"]) : null as any;
        }
    }

    static fromJS(data: any): SignInEvent {
        data = typeof data === 'object' ? data : {};
        let result = new SignInEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["timeIn"] = this.timeIn ? this.timeIn.toISOString() : null as any;
        data["timeInSystem"] = this.timeInSystem ? this.timeInSystem.toISOString() : null as any;
        data["manuallyAlteredTimeIn"] = this.manuallyAlteredTimeIn !== undefined ? this.manuallyAlteredTimeIn : null as any;
        data["timeOut"] = this.timeOut ? this.timeOut.toISOString() : null as any;
        data["timeOutSystem"] = this.timeOutSystem ? this.timeOutSystem.toISOString() : null as any;
        data["manuallyAlteredTimeOut"] = this.manuallyAlteredTimeOut !== undefined ? this.manuallyAlteredTimeOut : null as any;
        data["signInBadgeStatus"] = this.signInBadgeStatus !== undefined ? this.signInBadgeStatus : null as any;
        data["signOutBadgeStatus"] = this.signOutBadgeStatus !== undefined ? this.signOutBadgeStatus : null as any;
        data["signInLat"] = this.signInLat !== undefined ? this.signInLat : null as any;
        data["signInLong"] = this.signInLong !== undefined ? this.signInLong : null as any;
        data["signOutLat"] = this.signOutLat !== undefined ? this.signOutLat : null as any;
        data["signOutLong"] = this.signOutLong !== undefined ? this.signOutLong : null as any;
        data["forcedCheckOut"] = this.forcedCheckOut !== undefined ? this.forcedCheckOut : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        data["checkInSource"] = this.checkInSource !== undefined ? this.checkInSource : null as any;
        data["checkOutSource"] = this.checkOutSource !== undefined ? this.checkOutSource : null as any;
        data["location"] = this.location ? this.location.toJSON() : null as any;
        data["user"] = this.user ? this.user.toJSON() : null as any;
        return data;
    }

    clone(): SignInEvent {
        const json = this.toJSON();
        let result = new SignInEvent();
        result.init(json);
        return result;
    }
}

export interface ISignInEvent {
    id?: string;
    timeIn?: moment.Moment | null;
    timeInSystem?: moment.Moment | null;
    manuallyAlteredTimeIn?: boolean;
    timeOut?: moment.Moment | null;
    timeOutSystem?: moment.Moment | null;
    manuallyAlteredTimeOut?: boolean;
    signInBadgeStatus?: BadgeEventStatus;
    signOutBadgeStatus?: BadgeEventStatus;
    signInLat?: number | null;
    signInLong?: number | null;
    signOutLat?: number | null;
    signOutLong?: number | null;
    forcedCheckOut?: boolean | null;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment | null;
    checkInSource?: EventSource;
    checkOutSource?: EventSource | null;
    location?: Location2 | null;
    user?: UserInformation | null;
}

export enum BadgeEventStatus {
    QrCode = "qrCode",
    TemporaryNoBadge = "temporaryNoBadge",
    LostBadge = "lostBadge",
    NeverReceived = "neverReceived",
    Skipped = "skipped",
    BadgeScanNotRequired = "badgeScanNotRequired",
}

export class Location2 implements ILocation2 {
    id?: string;
    locationId?: number;
    wattLocationId?: string | null;
    accountId?: number;
    number?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    country?: string | null;
    timeZone?: string | null;
    lat?: number;
    long?: number;
    distance?: number;
    openStatus?: string | null;
    storeType?: string | null;
    bannerName?: string | null;
    account?: AccountInformation | null;
    emergencies?: Emergency[] | null;
    calendarNotifications?: LocationCalendarNotification[] | null;

    constructor(data?: ILocation2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : null as any;
            this.wattLocationId = _data["wattLocationId"] !== undefined ? _data["wattLocationId"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.number = _data["number"] !== undefined ? _data["number"] : null as any;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : null as any;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.timeZone = _data["timeZone"] !== undefined ? _data["timeZone"] : null as any;
            this.lat = _data["lat"] !== undefined ? _data["lat"] : null as any;
            this.long = _data["long"] !== undefined ? _data["long"] : null as any;
            this.distance = _data["distance"] !== undefined ? _data["distance"] : null as any;
            this.openStatus = _data["openStatus"] !== undefined ? _data["openStatus"] : null as any;
            this.storeType = _data["storeType"] !== undefined ? _data["storeType"] : null as any;
            this.bannerName = _data["bannerName"] !== undefined ? _data["bannerName"] : null as any;
            this.account = _data["account"] ? AccountInformation.fromJS(_data["account"]) : null as any;
            if (Array.isArray(_data["emergencies"])) {
                this.emergencies = [] as any;
                for (let item of _data["emergencies"])
                    this.emergencies!.push(Emergency.fromJS(item));
            }
            else {
                this.emergencies = null as any;
            }
            if (Array.isArray(_data["calendarNotifications"])) {
                this.calendarNotifications = [] as any;
                for (let item of _data["calendarNotifications"])
                    this.calendarNotifications!.push(LocationCalendarNotification.fromJS(item));
            }
            else {
                this.calendarNotifications = null as any;
            }
        }
    }

    static fromJS(data: any): Location2 {
        data = typeof data === 'object' ? data : {};
        let result = new Location2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["locationId"] = this.locationId !== undefined ? this.locationId : null as any;
        data["wattLocationId"] = this.wattLocationId !== undefined ? this.wattLocationId : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["number"] = this.number !== undefined ? this.number : null as any;
        data["address1"] = this.address1 !== undefined ? this.address1 : null as any;
        data["address2"] = this.address2 !== undefined ? this.address2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["timeZone"] = this.timeZone !== undefined ? this.timeZone : null as any;
        data["lat"] = this.lat !== undefined ? this.lat : null as any;
        data["long"] = this.long !== undefined ? this.long : null as any;
        data["distance"] = this.distance !== undefined ? this.distance : null as any;
        data["openStatus"] = this.openStatus !== undefined ? this.openStatus : null as any;
        data["storeType"] = this.storeType !== undefined ? this.storeType : null as any;
        data["bannerName"] = this.bannerName !== undefined ? this.bannerName : null as any;
        data["account"] = this.account ? this.account.toJSON() : null as any;
        if (Array.isArray(this.emergencies)) {
            data["emergencies"] = [];
            for (let item of this.emergencies)
                data["emergencies"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.calendarNotifications)) {
            data["calendarNotifications"] = [];
            for (let item of this.calendarNotifications)
                data["calendarNotifications"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): Location2 {
        const json = this.toJSON();
        let result = new Location2();
        result.init(json);
        return result;
    }
}

export interface ILocation2 {
    id?: string;
    locationId?: number;
    wattLocationId?: string | null;
    accountId?: number;
    number?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    country?: string | null;
    timeZone?: string | null;
    lat?: number;
    long?: number;
    distance?: number;
    openStatus?: string | null;
    storeType?: string | null;
    bannerName?: string | null;
    account?: AccountInformation | null;
    emergencies?: Emergency[] | null;
    calendarNotifications?: LocationCalendarNotification[] | null;
}

export class Emergency implements IEmergency {
    name?: string | null;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    emergencyType?: string | null;

    constructor(data?: IEmergency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : null as any;
            this.emergencyType = _data["emergencyType"] !== undefined ? _data["emergencyType"] : null as any;
        }
    }

    static fromJS(data: any): Emergency {
        data = typeof data === 'object' ? data : {};
        let result = new Emergency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        data["emergencyType"] = this.emergencyType !== undefined ? this.emergencyType : null as any;
        return data;
    }

    clone(): Emergency {
        const json = this.toJSON();
        let result = new Emergency();
        result.init(json);
        return result;
    }
}

export interface IEmergency {
    name?: string | null;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    emergencyType?: string | null;
}

export class LocationCalendarNotification implements ILocationCalendarNotification {
    calendarNotificationType?: string | null;
    startDate?: moment.Moment | null;
    endDate?: moment.Moment | null;
    messages?: CalendarNotificationMessage[] | null;
    color?: string | null;
    claimId?: string | null;
    emergencyId?: string | null;

    constructor(data?: ILocationCalendarNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calendarNotificationType = _data["calendarNotificationType"] !== undefined ? _data["calendarNotificationType"] : null as any;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : null as any;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(CalendarNotificationMessage.fromJS(item));
            }
            else {
                this.messages = null as any;
            }
            this.color = _data["color"] !== undefined ? _data["color"] : null as any;
            this.claimId = _data["claimId"] !== undefined ? _data["claimId"] : null as any;
            this.emergencyId = _data["emergencyId"] !== undefined ? _data["emergencyId"] : null as any;
        }
    }

    static fromJS(data: any): LocationCalendarNotification {
        data = typeof data === 'object' ? data : {};
        let result = new LocationCalendarNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calendarNotificationType"] = this.calendarNotificationType !== undefined ? this.calendarNotificationType : null as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item ? item.toJSON() : null as any);
        }
        data["color"] = this.color !== undefined ? this.color : null as any;
        data["claimId"] = this.claimId !== undefined ? this.claimId : null as any;
        data["emergencyId"] = this.emergencyId !== undefined ? this.emergencyId : null as any;
        return data;
    }

    clone(): LocationCalendarNotification {
        const json = this.toJSON();
        let result = new LocationCalendarNotification();
        result.init(json);
        return result;
    }
}

export interface ILocationCalendarNotification {
    calendarNotificationType?: string | null;
    startDate?: moment.Moment | null;
    endDate?: moment.Moment | null;
    messages?: CalendarNotificationMessage[] | null;
    color?: string | null;
    claimId?: string | null;
    emergencyId?: string | null;
}

export class CalendarNotificationMessage implements ICalendarNotificationMessage {
    days?: number;
    message?: string | null;

    constructor(data?: ICalendarNotificationMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.days = _data["days"] !== undefined ? _data["days"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
        }
    }

    static fromJS(data: any): CalendarNotificationMessage {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarNotificationMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["days"] = this.days !== undefined ? this.days : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        return data;
    }

    clone(): CalendarNotificationMessage {
        const json = this.toJSON();
        let result = new CalendarNotificationMessage();
        result.init(json);
        return result;
    }
}

export interface ICalendarNotificationMessage {
    days?: number;
    message?: string | null;
}

export class ManagerModel2 implements IManagerModel2 {
    name?: string | null;
    employeeNumber?: string | null;
    phone?: string | null;
    email?: string | null;
    manager?: ManagerModel2 | null;

    constructor(data?: IManagerModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.employeeNumber = _data["employeeNumber"] !== undefined ? _data["employeeNumber"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.manager = _data["manager"] ? ManagerModel2.fromJS(_data["manager"]) : null as any;
        }
    }

    static fromJS(data: any): ManagerModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new ManagerModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["employeeNumber"] = this.employeeNumber !== undefined ? this.employeeNumber : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["manager"] = this.manager ? this.manager.toJSON() : null as any;
        return data;
    }

    clone(): ManagerModel2 {
        const json = this.toJSON();
        let result = new ManagerModel2();
        result.init(json);
        return result;
    }
}

export interface IManagerModel2 {
    name?: string | null;
    employeeNumber?: string | null;
    phone?: string | null;
    email?: string | null;
    manager?: ManagerModel2 | null;
}

export class LimitedResultOfUserListItem implements ILimitedResultOfUserListItem {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: UserListItem[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfUserListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(UserListItem.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfUserListItem {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfUserListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfUserListItem {
        const json = this.toJSON();
        let result = new LimitedResultOfUserListItem();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfUserListItem {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: UserListItem[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class ActiveFieldEmployeeCount implements IActiveFieldEmployeeCount {
    notCertified?: number;
    badgePhotoDenied?: number;
    badgeReprintAwaiting?: number;

    constructor(data?: IActiveFieldEmployeeCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notCertified = _data["notCertified"] !== undefined ? _data["notCertified"] : null as any;
            this.badgePhotoDenied = _data["badgePhotoDenied"] !== undefined ? _data["badgePhotoDenied"] : null as any;
            this.badgeReprintAwaiting = _data["badgeReprintAwaiting"] !== undefined ? _data["badgeReprintAwaiting"] : null as any;
        }
    }

    static fromJS(data: any): ActiveFieldEmployeeCount {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveFieldEmployeeCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notCertified"] = this.notCertified !== undefined ? this.notCertified : null as any;
        data["badgePhotoDenied"] = this.badgePhotoDenied !== undefined ? this.badgePhotoDenied : null as any;
        data["badgeReprintAwaiting"] = this.badgeReprintAwaiting !== undefined ? this.badgeReprintAwaiting : null as any;
        return data;
    }

    clone(): ActiveFieldEmployeeCount {
        const json = this.toJSON();
        let result = new ActiveFieldEmployeeCount();
        result.init(json);
        return result;
    }
}

export interface IActiveFieldEmployeeCount {
    notCertified?: number;
    badgePhotoDenied?: number;
    badgeReprintAwaiting?: number;
}

export class PersonAccountTransferRequest implements IPersonAccountTransferRequest {
    personId?: number;
    accountId?: number;
    roleId?: number;
    userName?: string | null;
    targetEmail?: string | null;
    targetEmployeeNumber?: string | null;
    generateEmployeeNumber?: boolean;

    constructor(data?: IPersonAccountTransferRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.roleId = _data["roleId"] !== undefined ? _data["roleId"] : null as any;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null as any;
            this.targetEmail = _data["targetEmail"] !== undefined ? _data["targetEmail"] : null as any;
            this.targetEmployeeNumber = _data["targetEmployeeNumber"] !== undefined ? _data["targetEmployeeNumber"] : null as any;
            this.generateEmployeeNumber = _data["generateEmployeeNumber"] !== undefined ? _data["generateEmployeeNumber"] : null as any;
        }
    }

    static fromJS(data: any): PersonAccountTransferRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PersonAccountTransferRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId !== undefined ? this.personId : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["roleId"] = this.roleId !== undefined ? this.roleId : null as any;
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        data["targetEmail"] = this.targetEmail !== undefined ? this.targetEmail : null as any;
        data["targetEmployeeNumber"] = this.targetEmployeeNumber !== undefined ? this.targetEmployeeNumber : null as any;
        data["generateEmployeeNumber"] = this.generateEmployeeNumber !== undefined ? this.generateEmployeeNumber : null as any;
        return data;
    }

    clone(): PersonAccountTransferRequest {
        const json = this.toJSON();
        let result = new PersonAccountTransferRequest();
        result.init(json);
        return result;
    }
}

export interface IPersonAccountTransferRequest {
    personId?: number;
    accountId?: number;
    roleId?: number;
    userName?: string | null;
    targetEmail?: string | null;
    targetEmployeeNumber?: string | null;
    generateEmployeeNumber?: boolean;
}

export class WalmartWeek implements IWalmartWeek {
    year?: number;
    week?: number;

    constructor(data?: IWalmartWeek) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"] !== undefined ? _data["year"] : null as any;
            this.week = _data["week"] !== undefined ? _data["week"] : null as any;
        }
    }

    static fromJS(data: any): WalmartWeek {
        data = typeof data === 'object' ? data : {};
        let result = new WalmartWeek();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year !== undefined ? this.year : null as any;
        data["week"] = this.week !== undefined ? this.week : null as any;
        return data;
    }

    clone(): WalmartWeek {
        const json = this.toJSON();
        let result = new WalmartWeek();
        result.init(json);
        return result;
    }
}

export interface IWalmartWeek {
    year?: number;
    week?: number;
}

export class StoreWithNoWirelessVisitsViewModel implements IStoreWithNoWirelessVisitsViewModel {
    accountName?: string | null;
    accountId?: number;
    numberOfMissedStores?: number;
    numberOfStoreAssignments?: number;
    percentageOfMissedStores?: number;

    constructor(data?: IStoreWithNoWirelessVisitsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.numberOfMissedStores = _data["numberOfMissedStores"] !== undefined ? _data["numberOfMissedStores"] : null as any;
            this.numberOfStoreAssignments = _data["numberOfStoreAssignments"] !== undefined ? _data["numberOfStoreAssignments"] : null as any;
            this.percentageOfMissedStores = _data["percentageOfMissedStores"] !== undefined ? _data["percentageOfMissedStores"] : null as any;
        }
    }

    static fromJS(data: any): StoreWithNoWirelessVisitsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StoreWithNoWirelessVisitsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["numberOfMissedStores"] = this.numberOfMissedStores !== undefined ? this.numberOfMissedStores : null as any;
        data["numberOfStoreAssignments"] = this.numberOfStoreAssignments !== undefined ? this.numberOfStoreAssignments : null as any;
        data["percentageOfMissedStores"] = this.percentageOfMissedStores !== undefined ? this.percentageOfMissedStores : null as any;
        return data;
    }

    clone(): StoreWithNoWirelessVisitsViewModel {
        const json = this.toJSON();
        let result = new StoreWithNoWirelessVisitsViewModel();
        result.init(json);
        return result;
    }
}

export interface IStoreWithNoWirelessVisitsViewModel {
    accountName?: string | null;
    accountId?: number;
    numberOfMissedStores?: number;
    numberOfStoreAssignments?: number;
    percentageOfMissedStores?: number;
}

export class StoresWithLastWirelessRepVisitViewModel implements IStoresWithLastWirelessRepVisitViewModel {
    accountName?: string | null;
    storeNumberWithNoVisit?: string | null;
    lastVisit?: moment.Moment | null;

    constructor(data?: IStoresWithLastWirelessRepVisitViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.storeNumberWithNoVisit = _data["storeNumberWithNoVisit"] !== undefined ? _data["storeNumberWithNoVisit"] : null as any;
            this.lastVisit = _data["lastVisit"] ? moment(_data["lastVisit"].toString()) : null as any;
        }
    }

    static fromJS(data: any): StoresWithLastWirelessRepVisitViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StoresWithLastWirelessRepVisitViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["storeNumberWithNoVisit"] = this.storeNumberWithNoVisit !== undefined ? this.storeNumberWithNoVisit : null as any;
        data["lastVisit"] = this.lastVisit ? this.lastVisit.toISOString() : null as any;
        return data;
    }

    clone(): StoresWithLastWirelessRepVisitViewModel {
        const json = this.toJSON();
        let result = new StoresWithLastWirelessRepVisitViewModel();
        result.init(json);
        return result;
    }
}

export interface IStoresWithLastWirelessRepVisitViewModel {
    accountName?: string | null;
    storeNumberWithNoVisit?: string | null;
    lastVisit?: moment.Moment | null;
}

export class LimitedResultOfStoresWithNoWirelessVisitsViewModel implements ILimitedResultOfStoresWithNoWirelessVisitsViewModel {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: StoresWithNoWirelessVisitsViewModel[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfStoresWithNoWirelessVisitsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(StoresWithNoWirelessVisitsViewModel.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfStoresWithNoWirelessVisitsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfStoresWithNoWirelessVisitsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfStoresWithNoWirelessVisitsViewModel {
        const json = this.toJSON();
        let result = new LimitedResultOfStoresWithNoWirelessVisitsViewModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfStoresWithNoWirelessVisitsViewModel {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: StoresWithNoWirelessVisitsViewModel[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class StoresWithNoWirelessVisitsViewModel implements IStoresWithNoWirelessVisitsViewModel {
    storeNumber?: number;
    accountName?: string | null;
    lastTimeIn?: moment.Moment | null;
    lastTimeOut?: moment.Moment | null;
    timeInStore?: string | null;
    personName?: string | null;
    operatorName?: string | null;

    constructor(data?: IStoresWithNoWirelessVisitsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeNumber = _data["storeNumber"] !== undefined ? _data["storeNumber"] : null as any;
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.lastTimeIn = _data["lastTimeIn"] ? moment(_data["lastTimeIn"].toString()) : null as any;
            this.lastTimeOut = _data["lastTimeOut"] ? moment(_data["lastTimeOut"].toString()) : null as any;
            this.timeInStore = _data["timeInStore"] !== undefined ? _data["timeInStore"] : null as any;
            this.personName = _data["personName"] !== undefined ? _data["personName"] : null as any;
            this.operatorName = _data["operatorName"] !== undefined ? _data["operatorName"] : null as any;
        }
    }

    static fromJS(data: any): StoresWithNoWirelessVisitsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StoresWithNoWirelessVisitsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeNumber"] = this.storeNumber !== undefined ? this.storeNumber : null as any;
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["lastTimeIn"] = this.lastTimeIn ? this.lastTimeIn.toISOString() : null as any;
        data["lastTimeOut"] = this.lastTimeOut ? this.lastTimeOut.toISOString() : null as any;
        data["timeInStore"] = this.timeInStore !== undefined ? this.timeInStore : null as any;
        data["personName"] = this.personName !== undefined ? this.personName : null as any;
        data["operatorName"] = this.operatorName !== undefined ? this.operatorName : null as any;
        return data;
    }

    clone(): StoresWithNoWirelessVisitsViewModel {
        const json = this.toJSON();
        let result = new StoresWithNoWirelessVisitsViewModel();
        result.init(json);
        return result;
    }
}

export interface IStoresWithNoWirelessVisitsViewModel {
    storeNumber?: number;
    accountName?: string | null;
    lastTimeIn?: moment.Moment | null;
    lastTimeOut?: moment.Moment | null;
    timeInStore?: string | null;
    personName?: string | null;
    operatorName?: string | null;
}

export class ImportLog implements IImportLog {
    transactionId!: string;
    count!: number;
    statusSummary!: { [key: string]: number; };
    logs!: Log22[];

    constructor(data?: IImportLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.statusSummary = {};
            this.logs = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"] !== undefined ? _data["transactionId"] : null as any;
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            if (_data["statusSummary"]) {
                this.statusSummary = {} as any;
                for (let key in _data["statusSummary"]) {
                    if (_data["statusSummary"].hasOwnProperty(key))
                        (this.statusSummary as any)![key] = _data["statusSummary"][key] !== undefined ? _data["statusSummary"][key] : null as any;
                }
            }
            else {
                this.statusSummary = null as any;
            }
            if (Array.isArray(_data["logs"])) {
                this.logs = [] as any;
                for (let item of _data["logs"])
                    this.logs!.push(Log22.fromJS(item));
            }
            else {
                this.logs = null as any;
            }
        }
    }

    static fromJS(data: any): ImportLog {
        data = typeof data === 'object' ? data : {};
        let result = new ImportLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId !== undefined ? this.transactionId : null as any;
        data["count"] = this.count !== undefined ? this.count : null as any;
        if (this.statusSummary) {
            data["statusSummary"] = {};
            for (let key in this.statusSummary) {
                if (this.statusSummary.hasOwnProperty(key))
                    (data["statusSummary"] as any)[key] = this.statusSummary[key] !== undefined ? this.statusSummary[key] : null as any;
            }
        }
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): ImportLog {
        const json = this.toJSON();
        let result = new ImportLog();
        result.init(json);
        return result;
    }
}

export interface IImportLog {
    transactionId: string;
    count: number;
    statusSummary: { [key: string]: number; };
    logs: Log22[];
}

export class Log22 implements ILog22 {
    email!: string;
    status!: ImportStatus;
    employeeNumber!: string;
    message?: string | null;

    constructor(data?: ILog22) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.employeeNumber = _data["employeeNumber"] !== undefined ? _data["employeeNumber"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
        }
    }

    static fromJS(data: any): Log22 {
        data = typeof data === 'object' ? data : {};
        let result = new Log22();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["employeeNumber"] = this.employeeNumber !== undefined ? this.employeeNumber : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        return data;
    }

    clone(): Log22 {
        const json = this.toJSON();
        let result = new Log22();
        result.init(json);
        return result;
    }
}

export interface ILog22 {
    email: string;
    status: ImportStatus;
    employeeNumber: string;
    message?: string | null;
}

export class LocationDropdown implements ILocationDropdown {
    id?: number;
    wattLocationId?: string | null;
    locationId?: string;
    number?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    country?: string | null;
    timeZone?: string | null;
    lat?: number | null;
    long?: number | null;
    type?: LocationType2 | null;
    accountLocationGroups?: AccountLocationGroup[] | null;
    permissions?: { [key: string]: number; } | null;

    constructor(data?: ILocationDropdown) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.wattLocationId = _data["wattLocationId"] !== undefined ? _data["wattLocationId"] : null as any;
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : null as any;
            this.number = _data["number"] !== undefined ? _data["number"] : null as any;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : null as any;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.timeZone = _data["timeZone"] !== undefined ? _data["timeZone"] : null as any;
            this.lat = _data["lat"] !== undefined ? _data["lat"] : null as any;
            this.long = _data["long"] !== undefined ? _data["long"] : null as any;
            this.type = _data["type"] ? LocationType2.fromJS(_data["type"]) : null as any;
            if (Array.isArray(_data["accountLocationGroups"])) {
                this.accountLocationGroups = [] as any;
                for (let item of _data["accountLocationGroups"])
                    this.accountLocationGroups!.push(AccountLocationGroup.fromJS(item));
            }
            else {
                this.accountLocationGroups = null as any;
            }
            if (_data["permissions"]) {
                this.permissions = {} as any;
                for (let key in _data["permissions"]) {
                    if (_data["permissions"].hasOwnProperty(key))
                        (this.permissions as any)![key] = _data["permissions"][key] !== undefined ? _data["permissions"][key] : null as any;
                }
            }
            else {
                this.permissions = null as any;
            }
        }
    }

    static fromJS(data: any): LocationDropdown {
        data = typeof data === 'object' ? data : {};
        let result = new LocationDropdown();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["wattLocationId"] = this.wattLocationId !== undefined ? this.wattLocationId : null as any;
        data["locationId"] = this.locationId !== undefined ? this.locationId : null as any;
        data["number"] = this.number !== undefined ? this.number : null as any;
        data["address1"] = this.address1 !== undefined ? this.address1 : null as any;
        data["address2"] = this.address2 !== undefined ? this.address2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["timeZone"] = this.timeZone !== undefined ? this.timeZone : null as any;
        data["lat"] = this.lat !== undefined ? this.lat : null as any;
        data["long"] = this.long !== undefined ? this.long : null as any;
        data["type"] = this.type ? this.type.toJSON() : null as any;
        if (Array.isArray(this.accountLocationGroups)) {
            data["accountLocationGroups"] = [];
            for (let item of this.accountLocationGroups)
                data["accountLocationGroups"].push(item ? item.toJSON() : null as any);
        }
        if (this.permissions) {
            data["permissions"] = {};
            for (let key in this.permissions) {
                if (this.permissions.hasOwnProperty(key))
                    (data["permissions"] as any)[key] = this.permissions[key] !== undefined ? this.permissions[key] : null as any;
            }
        }
        return data;
    }

    clone(): LocationDropdown {
        const json = this.toJSON();
        let result = new LocationDropdown();
        result.init(json);
        return result;
    }
}

export interface ILocationDropdown {
    id?: number;
    wattLocationId?: string | null;
    locationId?: string;
    number?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    country?: string | null;
    timeZone?: string | null;
    lat?: number | null;
    long?: number | null;
    type?: LocationType2 | null;
    accountLocationGroups?: AccountLocationGroup[] | null;
    permissions?: { [key: string]: number; } | null;
}

export class LocationType2 implements ILocationType2 {
    code?: string | null;
    description?: string | null;
    banner?: string | null;

    constructor(data?: ILocationType2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.banner = _data["banner"] !== undefined ? _data["banner"] : null as any;
        }
    }

    static fromJS(data: any): LocationType2 {
        data = typeof data === 'object' ? data : {};
        let result = new LocationType2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["banner"] = this.banner !== undefined ? this.banner : null as any;
        return data;
    }

    clone(): LocationType2 {
        const json = this.toJSON();
        let result = new LocationType2();
        result.init(json);
        return result;
    }
}

export interface ILocationType2 {
    code?: string | null;
    description?: string | null;
    banner?: string | null;
}

export class AccountLocationGroup implements IAccountLocationGroup {
    groupId?: number;
    groupName?: string | null;
    groupValue?: string | null;

    constructor(data?: IAccountLocationGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"] !== undefined ? _data["groupId"] : null as any;
            this.groupName = _data["groupName"] !== undefined ? _data["groupName"] : null as any;
            this.groupValue = _data["groupValue"] !== undefined ? _data["groupValue"] : null as any;
        }
    }

    static fromJS(data: any): AccountLocationGroup {
        data = typeof data === 'object' ? data : {};
        let result = new AccountLocationGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId !== undefined ? this.groupId : null as any;
        data["groupName"] = this.groupName !== undefined ? this.groupName : null as any;
        data["groupValue"] = this.groupValue !== undefined ? this.groupValue : null as any;
        return data;
    }

    clone(): AccountLocationGroup {
        const json = this.toJSON();
        let result = new AccountLocationGroup();
        result.init(json);
        return result;
    }
}

export interface IAccountLocationGroup {
    groupId?: number;
    groupName?: string | null;
    groupValue?: string | null;
}

export class EffectivePermissionViewModel implements IEffectivePermissionViewModel {
    permissionId?: string | null;
    activity?: number;
    grouping?: string | null;
    resource?: string | null;
    item?: string | null;
    storeNumber?: string | null;
    allowedActivities?: number;

    constructor(data?: IEffectivePermissionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.permissionId = _data["permissionId"] !== undefined ? _data["permissionId"] : null as any;
            this.activity = _data["activity"] !== undefined ? _data["activity"] : null as any;
            this.grouping = _data["grouping"] !== undefined ? _data["grouping"] : null as any;
            this.resource = _data["resource"] !== undefined ? _data["resource"] : null as any;
            this.item = _data["item"] !== undefined ? _data["item"] : null as any;
            this.storeNumber = _data["storeNumber"] !== undefined ? _data["storeNumber"] : null as any;
            this.allowedActivities = _data["allowedActivities"] !== undefined ? _data["allowedActivities"] : null as any;
        }
    }

    static fromJS(data: any): EffectivePermissionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EffectivePermissionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["permissionId"] = this.permissionId !== undefined ? this.permissionId : null as any;
        data["activity"] = this.activity !== undefined ? this.activity : null as any;
        data["grouping"] = this.grouping !== undefined ? this.grouping : null as any;
        data["resource"] = this.resource !== undefined ? this.resource : null as any;
        data["item"] = this.item !== undefined ? this.item : null as any;
        data["storeNumber"] = this.storeNumber !== undefined ? this.storeNumber : null as any;
        data["allowedActivities"] = this.allowedActivities !== undefined ? this.allowedActivities : null as any;
        return data;
    }

    clone(): EffectivePermissionViewModel {
        const json = this.toJSON();
        let result = new EffectivePermissionViewModel();
        result.init(json);
        return result;
    }
}

export interface IEffectivePermissionViewModel {
    permissionId?: string | null;
    activity?: number;
    grouping?: string | null;
    resource?: string | null;
    item?: string | null;
    storeNumber?: string | null;
    allowedActivities?: number;
}

export class RolePermissionUpdate implements IRolePermissionUpdate {
    activity?: number;

    constructor(data?: IRolePermissionUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activity = _data["activity"] !== undefined ? _data["activity"] : null as any;
        }
    }

    static fromJS(data: any): RolePermissionUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new RolePermissionUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activity"] = this.activity !== undefined ? this.activity : null as any;
        return data;
    }

    clone(): RolePermissionUpdate {
        const json = this.toJSON();
        let result = new RolePermissionUpdate();
        result.init(json);
        return result;
    }
}

export interface IRolePermissionUpdate {
    activity?: number;
}

export class NestedClass implements INestedClass {
    locationId?: number;
    locationNumber?: string | null;

    constructor(data?: INestedClass) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : null as any;
            this.locationNumber = _data["locationNumber"] !== undefined ? _data["locationNumber"] : null as any;
        }
    }

    static fromJS(data: any): NestedClass {
        data = typeof data === 'object' ? data : {};
        let result = new NestedClass();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId !== undefined ? this.locationId : null as any;
        data["locationNumber"] = this.locationNumber !== undefined ? this.locationNumber : null as any;
        return data;
    }

    clone(): NestedClass {
        const json = this.toJSON();
        let result = new NestedClass();
        result.init(json);
        return result;
    }
}

export interface INestedClass {
    locationId?: number;
    locationNumber?: string | null;
}

export class RoleViewModel implements IRoleViewModel {
    id?: number;
    role?: string | null;
    roleType?: string | null;
    countOfActiveUsers?: number;
    roleTypeId?: number;
    status?: string | null;
    note?: string | null;
    landingPage?: string | null;
    roleCapability?: string | null;

    constructor(data?: IRoleViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.role = _data["role"] !== undefined ? _data["role"] : null as any;
            this.roleType = _data["roleType"] !== undefined ? _data["roleType"] : null as any;
            this.countOfActiveUsers = _data["countOfActiveUsers"] !== undefined ? _data["countOfActiveUsers"] : null as any;
            this.roleTypeId = _data["roleTypeId"] !== undefined ? _data["roleTypeId"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
            this.landingPage = _data["landingPage"] !== undefined ? _data["landingPage"] : null as any;
            this.roleCapability = _data["roleCapability"] !== undefined ? _data["roleCapability"] : null as any;
        }
    }

    static fromJS(data: any): RoleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RoleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["role"] = this.role !== undefined ? this.role : null as any;
        data["roleType"] = this.roleType !== undefined ? this.roleType : null as any;
        data["countOfActiveUsers"] = this.countOfActiveUsers !== undefined ? this.countOfActiveUsers : null as any;
        data["roleTypeId"] = this.roleTypeId !== undefined ? this.roleTypeId : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["landingPage"] = this.landingPage !== undefined ? this.landingPage : null as any;
        data["roleCapability"] = this.roleCapability !== undefined ? this.roleCapability : null as any;
        return data;
    }

    clone(): RoleViewModel {
        const json = this.toJSON();
        let result = new RoleViewModel();
        result.init(json);
        return result;
    }
}

export interface IRoleViewModel {
    id?: number;
    role?: string | null;
    roleType?: string | null;
    countOfActiveUsers?: number;
    roleTypeId?: number;
    status?: string | null;
    note?: string | null;
    landingPage?: string | null;
    roleCapability?: string | null;
}

export class RolesViewModel implements IRolesViewModel {
    rolesId?: number;
    rolesName?: string | null;

    constructor(data?: IRolesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rolesId = _data["rolesId"] !== undefined ? _data["rolesId"] : null as any;
            this.rolesName = _data["rolesName"] !== undefined ? _data["rolesName"] : null as any;
        }
    }

    static fromJS(data: any): RolesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RolesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rolesId"] = this.rolesId !== undefined ? this.rolesId : null as any;
        data["rolesName"] = this.rolesName !== undefined ? this.rolesName : null as any;
        return data;
    }

    clone(): RolesViewModel {
        const json = this.toJSON();
        let result = new RolesViewModel();
        result.init(json);
        return result;
    }
}

export interface IRolesViewModel {
    rolesId?: number;
    rolesName?: string | null;
}

export class ActiveDirectoryRoleMappingViewModel implements IActiveDirectoryRoleMappingViewModel {
    adGroup?: string | null;
    hierarchy?: number;
    rolesName?: string | null;
    capability?: string | null;
    rolesId?: number;
    statusName?: string | null;
    rolesNote?: string | null;
    totalUsers?: number;

    constructor(data?: IActiveDirectoryRoleMappingViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adGroup = _data["adGroup"] !== undefined ? _data["adGroup"] : null as any;
            this.hierarchy = _data["hierarchy"] !== undefined ? _data["hierarchy"] : null as any;
            this.rolesName = _data["rolesName"] !== undefined ? _data["rolesName"] : null as any;
            this.capability = _data["capability"] !== undefined ? _data["capability"] : null as any;
            this.rolesId = _data["rolesId"] !== undefined ? _data["rolesId"] : null as any;
            this.statusName = _data["statusName"] !== undefined ? _data["statusName"] : null as any;
            this.rolesNote = _data["rolesNote"] !== undefined ? _data["rolesNote"] : null as any;
            this.totalUsers = _data["totalUsers"] !== undefined ? _data["totalUsers"] : null as any;
        }
    }

    static fromJS(data: any): ActiveDirectoryRoleMappingViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveDirectoryRoleMappingViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adGroup"] = this.adGroup !== undefined ? this.adGroup : null as any;
        data["hierarchy"] = this.hierarchy !== undefined ? this.hierarchy : null as any;
        data["rolesName"] = this.rolesName !== undefined ? this.rolesName : null as any;
        data["capability"] = this.capability !== undefined ? this.capability : null as any;
        data["rolesId"] = this.rolesId !== undefined ? this.rolesId : null as any;
        data["statusName"] = this.statusName !== undefined ? this.statusName : null as any;
        data["rolesNote"] = this.rolesNote !== undefined ? this.rolesNote : null as any;
        data["totalUsers"] = this.totalUsers !== undefined ? this.totalUsers : null as any;
        return data;
    }

    clone(): ActiveDirectoryRoleMappingViewModel {
        const json = this.toJSON();
        let result = new ActiveDirectoryRoleMappingViewModel();
        result.init(json);
        return result;
    }
}

export interface IActiveDirectoryRoleMappingViewModel {
    adGroup?: string | null;
    hierarchy?: number;
    rolesName?: string | null;
    capability?: string | null;
    rolesId?: number;
    statusName?: string | null;
    rolesNote?: string | null;
    totalUsers?: number;
}

export class PersonNotificationUpdate implements IPersonNotificationUpdate {
    active?: boolean;

    constructor(data?: IPersonNotificationUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
        }
    }

    static fromJS(data: any): PersonNotificationUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new PersonNotificationUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active !== undefined ? this.active : null as any;
        return data;
    }

    clone(): PersonNotificationUpdate {
        const json = this.toJSON();
        let result = new PersonNotificationUpdate();
        result.init(json);
        return result;
    }
}

export interface IPersonNotificationUpdate {
    active?: boolean;
}

export class RoleNotificationUpdate implements IRoleNotificationUpdate {
    locked?: boolean;
    active?: boolean;

    constructor(data?: IRoleNotificationUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locked = _data["locked"] !== undefined ? _data["locked"] : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
        }
    }

    static fromJS(data: any): RoleNotificationUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new RoleNotificationUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locked"] = this.locked !== undefined ? this.locked : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        return data;
    }

    clone(): RoleNotificationUpdate {
        const json = this.toJSON();
        let result = new RoleNotificationUpdate();
        result.init(json);
        return result;
    }
}

export interface IRoleNotificationUpdate {
    locked?: boolean;
    active?: boolean;
}

export class EffectiveNotificationViewModel implements IEffectiveNotificationViewModel {
    notificationId?: string | null;
    active?: boolean;
    locked?: boolean;
    parentActive?: boolean;
    parentLocked?: boolean;
    grouping?: string | null;
    description?: string | null;
    type?: NotificationTypes;

    constructor(data?: IEffectiveNotificationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationId = _data["notificationId"] !== undefined ? _data["notificationId"] : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
            this.locked = _data["locked"] !== undefined ? _data["locked"] : null as any;
            this.parentActive = _data["parentActive"] !== undefined ? _data["parentActive"] : null as any;
            this.parentLocked = _data["parentLocked"] !== undefined ? _data["parentLocked"] : null as any;
            this.grouping = _data["grouping"] !== undefined ? _data["grouping"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
        }
    }

    static fromJS(data: any): EffectiveNotificationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EffectiveNotificationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationId"] = this.notificationId !== undefined ? this.notificationId : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        data["locked"] = this.locked !== undefined ? this.locked : null as any;
        data["parentActive"] = this.parentActive !== undefined ? this.parentActive : null as any;
        data["parentLocked"] = this.parentLocked !== undefined ? this.parentLocked : null as any;
        data["grouping"] = this.grouping !== undefined ? this.grouping : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        return data;
    }

    clone(): EffectiveNotificationViewModel {
        const json = this.toJSON();
        let result = new EffectiveNotificationViewModel();
        result.init(json);
        return result;
    }
}

export interface IEffectiveNotificationViewModel {
    notificationId?: string | null;
    active?: boolean;
    locked?: boolean;
    parentActive?: boolean;
    parentLocked?: boolean;
    grouping?: string | null;
    description?: string | null;
    type?: NotificationTypes;
}

export class RoleTypeViewModel implements IRoleTypeViewModel {
    roleTypeId?: number;
    roleType?: string | null;

    constructor(data?: IRoleTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleTypeId = _data["roleTypeId"] !== undefined ? _data["roleTypeId"] : null as any;
            this.roleType = _data["roleType"] !== undefined ? _data["roleType"] : null as any;
        }
    }

    static fromJS(data: any): RoleTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RoleTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleTypeId"] = this.roleTypeId !== undefined ? this.roleTypeId : null as any;
        data["roleType"] = this.roleType !== undefined ? this.roleType : null as any;
        return data;
    }

    clone(): RoleTypeViewModel {
        const json = this.toJSON();
        let result = new RoleTypeViewModel();
        result.init(json);
        return result;
    }
}

export interface IRoleTypeViewModel {
    roleTypeId?: number;
    roleType?: string | null;
}

export class InvitedAccountModel implements IInvitedAccountModel {
    invitedAccountId?: number;
    registrationToken?: string | null;
    invitedCompany?: string | null;
    invitedName?: string | null;
    invitedEmail?: string | null;
    invitedCourse?: string | null;
    invitedNote?: string | null;
    accountNumber?: string | null;
    printBadge?: EBadgePrint | null;
    badgeShipping?: number | null;
    number?: string | null;
    fName?: string | null;
    lName?: string | null;
    email1?: string | null;
    invitedDate?: moment.Moment | null;
    lastInvitedDate?: moment.Moment | null;
    fieldGroupType?: string | null;
    accountTypeId?: number | null;
    aname?: string | null;
    aabbrev?: string | null;
    aimageUrl?: string | null;
    awebsite?: string | null;
    aaddress1?: string | null;
    aaddress2?: string | null;
    acity?: string | null;
    astate?: string | null;
    azip?: string | null;
    aNote?: string | null;
    acountry?: string | null;
    billAttnToFname?: string | null;
    billAttnToLname?: string | null;
    baddress1?: string | null;
    baddress2?: string | null;
    bcity?: string | null;
    bstate?: string | null;
    bzip?: string | null;
    bcountry?: string | null;
    bphone?: string | null;
    billingEmail?: string | null;
    shipAttnTo?: string | null;
    saddress1?: string | null;
    saddress2?: string | null;
    scity?: string | null;
    sstate?: string | null;
    szip?: string | null;
    scountry?: string | null;
    supportEmail?: string | null;
    supportPhone?: string | null;
    supportNote?: string | null;
    itcontactEmail?: string | null;
    itcontactPhone?: string | null;
    shipDirectToRep?: number | null;
    statusId?: number | null;
    estimatedUsers?: string | null;
    userSpecificEmailsForCommunication?: boolean | null;
    provideBadgeWithPhoto?: boolean | null;
    uDirectlyEmployed?: string | null;
    uMobileEnabled?: string | null;
    wmtVendorId?: string | null;
    checkStatus?: string | null;
    accountId?: number | null;
    primaryAdminId?: number | null;
    pPhone?: string | null;
    reject?: string | null;
    selectedProducts?: string | null;
    selectedRetailers?: string | null;
    selectedCertifications?: string | null;
    selectedApps?: string | null;
    selectedAccountTags?: string | null;
    authToken?: string | null;
    registrationCompletionDate?: moment.Moment | null;
    retailerApprovalDate?: moment.Moment | null;
    retailLink?: boolean;
    dateCreated?: moment.Moment | null;
    showStoreSupportInfo?: boolean | null;
    storeSupportNumber?: string | null;
    subscriptionType?: string | null;
    storeSupportEmail?: string | null;
    selectedActivityUpdates?: UpdateActivities | null;
    isSeasonal?: boolean;

    constructor(data?: IInvitedAccountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invitedAccountId = _data["invitedAccountId"] !== undefined ? _data["invitedAccountId"] : null as any;
            this.registrationToken = _data["registrationToken"] !== undefined ? _data["registrationToken"] : null as any;
            this.invitedCompany = _data["invitedCompany"] !== undefined ? _data["invitedCompany"] : null as any;
            this.invitedName = _data["invitedName"] !== undefined ? _data["invitedName"] : null as any;
            this.invitedEmail = _data["invitedEmail"] !== undefined ? _data["invitedEmail"] : null as any;
            this.invitedCourse = _data["invitedCourse"] !== undefined ? _data["invitedCourse"] : null as any;
            this.invitedNote = _data["invitedNote"] !== undefined ? _data["invitedNote"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.printBadge = _data["printBadge"] !== undefined ? _data["printBadge"] : null as any;
            this.badgeShipping = _data["badgeShipping"] !== undefined ? _data["badgeShipping"] : null as any;
            this.number = _data["number"] !== undefined ? _data["number"] : null as any;
            this.fName = _data["fName"] !== undefined ? _data["fName"] : null as any;
            this.lName = _data["lName"] !== undefined ? _data["lName"] : null as any;
            this.email1 = _data["email1"] !== undefined ? _data["email1"] : null as any;
            this.invitedDate = _data["invitedDate"] ? moment(_data["invitedDate"].toString()) : null as any;
            this.lastInvitedDate = _data["lastInvitedDate"] ? moment(_data["lastInvitedDate"].toString()) : null as any;
            this.fieldGroupType = _data["fieldGroupType"] !== undefined ? _data["fieldGroupType"] : null as any;
            this.accountTypeId = _data["accountTypeId"] !== undefined ? _data["accountTypeId"] : null as any;
            this.aname = _data["aname"] !== undefined ? _data["aname"] : null as any;
            this.aabbrev = _data["aabbrev"] !== undefined ? _data["aabbrev"] : null as any;
            this.aimageUrl = _data["aimageUrl"] !== undefined ? _data["aimageUrl"] : null as any;
            this.awebsite = _data["awebsite"] !== undefined ? _data["awebsite"] : null as any;
            this.aaddress1 = _data["aaddress1"] !== undefined ? _data["aaddress1"] : null as any;
            this.aaddress2 = _data["aaddress2"] !== undefined ? _data["aaddress2"] : null as any;
            this.acity = _data["acity"] !== undefined ? _data["acity"] : null as any;
            this.astate = _data["astate"] !== undefined ? _data["astate"] : null as any;
            this.azip = _data["azip"] !== undefined ? _data["azip"] : null as any;
            this.aNote = _data["aNote"] !== undefined ? _data["aNote"] : null as any;
            this.acountry = _data["acountry"] !== undefined ? _data["acountry"] : null as any;
            this.billAttnToFname = _data["billAttnToFname"] !== undefined ? _data["billAttnToFname"] : null as any;
            this.billAttnToLname = _data["billAttnToLname"] !== undefined ? _data["billAttnToLname"] : null as any;
            this.baddress1 = _data["baddress1"] !== undefined ? _data["baddress1"] : null as any;
            this.baddress2 = _data["baddress2"] !== undefined ? _data["baddress2"] : null as any;
            this.bcity = _data["bcity"] !== undefined ? _data["bcity"] : null as any;
            this.bstate = _data["bstate"] !== undefined ? _data["bstate"] : null as any;
            this.bzip = _data["bzip"] !== undefined ? _data["bzip"] : null as any;
            this.bcountry = _data["bcountry"] !== undefined ? _data["bcountry"] : null as any;
            this.bphone = _data["bphone"] !== undefined ? _data["bphone"] : null as any;
            this.billingEmail = _data["billingEmail"] !== undefined ? _data["billingEmail"] : null as any;
            this.shipAttnTo = _data["shipAttnTo"] !== undefined ? _data["shipAttnTo"] : null as any;
            this.saddress1 = _data["saddress1"] !== undefined ? _data["saddress1"] : null as any;
            this.saddress2 = _data["saddress2"] !== undefined ? _data["saddress2"] : null as any;
            this.scity = _data["scity"] !== undefined ? _data["scity"] : null as any;
            this.sstate = _data["sstate"] !== undefined ? _data["sstate"] : null as any;
            this.szip = _data["szip"] !== undefined ? _data["szip"] : null as any;
            this.scountry = _data["scountry"] !== undefined ? _data["scountry"] : null as any;
            this.supportEmail = _data["supportEmail"] !== undefined ? _data["supportEmail"] : null as any;
            this.supportPhone = _data["supportPhone"] !== undefined ? _data["supportPhone"] : null as any;
            this.supportNote = _data["supportNote"] !== undefined ? _data["supportNote"] : null as any;
            this.itcontactEmail = _data["itcontactEmail"] !== undefined ? _data["itcontactEmail"] : null as any;
            this.itcontactPhone = _data["itcontactPhone"] !== undefined ? _data["itcontactPhone"] : null as any;
            this.shipDirectToRep = _data["shipDirectToRep"] !== undefined ? _data["shipDirectToRep"] : null as any;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            this.estimatedUsers = _data["estimatedUsers"] !== undefined ? _data["estimatedUsers"] : null as any;
            this.userSpecificEmailsForCommunication = _data["userSpecificEmailsForCommunication"] !== undefined ? _data["userSpecificEmailsForCommunication"] : null as any;
            this.provideBadgeWithPhoto = _data["provideBadgeWithPhoto"] !== undefined ? _data["provideBadgeWithPhoto"] : null as any;
            this.uDirectlyEmployed = _data["uDirectlyEmployed"] !== undefined ? _data["uDirectlyEmployed"] : null as any;
            this.uMobileEnabled = _data["uMobileEnabled"] !== undefined ? _data["uMobileEnabled"] : null as any;
            this.wmtVendorId = _data["wmtVendorId"] !== undefined ? _data["wmtVendorId"] : null as any;
            this.checkStatus = _data["checkStatus"] !== undefined ? _data["checkStatus"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.primaryAdminId = _data["primaryAdminId"] !== undefined ? _data["primaryAdminId"] : null as any;
            this.pPhone = _data["pPhone"] !== undefined ? _data["pPhone"] : null as any;
            this.reject = _data["reject"] !== undefined ? _data["reject"] : null as any;
            this.selectedProducts = _data["selectedProducts"] !== undefined ? _data["selectedProducts"] : null as any;
            this.selectedRetailers = _data["selectedRetailers"] !== undefined ? _data["selectedRetailers"] : null as any;
            this.selectedCertifications = _data["selectedCertifications"] !== undefined ? _data["selectedCertifications"] : null as any;
            this.selectedApps = _data["selectedApps"] !== undefined ? _data["selectedApps"] : null as any;
            this.selectedAccountTags = _data["selectedAccountTags"] !== undefined ? _data["selectedAccountTags"] : null as any;
            this.authToken = _data["authToken"] !== undefined ? _data["authToken"] : null as any;
            this.registrationCompletionDate = _data["registrationCompletionDate"] ? moment(_data["registrationCompletionDate"].toString()) : null as any;
            this.retailerApprovalDate = _data["retailerApprovalDate"] ? moment(_data["retailerApprovalDate"].toString()) : null as any;
            this.retailLink = _data["retailLink"] !== undefined ? _data["retailLink"] : null as any;
            this.dateCreated = _data["dateCreated"] ? moment(_data["dateCreated"].toString()) : null as any;
            this.showStoreSupportInfo = _data["showStoreSupportInfo"] !== undefined ? _data["showStoreSupportInfo"] : null as any;
            this.storeSupportNumber = _data["storeSupportNumber"] !== undefined ? _data["storeSupportNumber"] : null as any;
            this.subscriptionType = _data["subscriptionType"] !== undefined ? _data["subscriptionType"] : null as any;
            this.storeSupportEmail = _data["storeSupportEmail"] !== undefined ? _data["storeSupportEmail"] : null as any;
            this.selectedActivityUpdates = _data["selectedActivityUpdates"] ? UpdateActivities.fromJS(_data["selectedActivityUpdates"]) : null as any;
            this.isSeasonal = _data["isSeasonal"] !== undefined ? _data["isSeasonal"] : null as any;
        }
    }

    static fromJS(data: any): InvitedAccountModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvitedAccountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invitedAccountId"] = this.invitedAccountId !== undefined ? this.invitedAccountId : null as any;
        data["registrationToken"] = this.registrationToken !== undefined ? this.registrationToken : null as any;
        data["invitedCompany"] = this.invitedCompany !== undefined ? this.invitedCompany : null as any;
        data["invitedName"] = this.invitedName !== undefined ? this.invitedName : null as any;
        data["invitedEmail"] = this.invitedEmail !== undefined ? this.invitedEmail : null as any;
        data["invitedCourse"] = this.invitedCourse !== undefined ? this.invitedCourse : null as any;
        data["invitedNote"] = this.invitedNote !== undefined ? this.invitedNote : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["printBadge"] = this.printBadge !== undefined ? this.printBadge : null as any;
        data["badgeShipping"] = this.badgeShipping !== undefined ? this.badgeShipping : null as any;
        data["number"] = this.number !== undefined ? this.number : null as any;
        data["fName"] = this.fName !== undefined ? this.fName : null as any;
        data["lName"] = this.lName !== undefined ? this.lName : null as any;
        data["email1"] = this.email1 !== undefined ? this.email1 : null as any;
        data["invitedDate"] = this.invitedDate ? this.invitedDate.toISOString() : null as any;
        data["lastInvitedDate"] = this.lastInvitedDate ? this.lastInvitedDate.toISOString() : null as any;
        data["fieldGroupType"] = this.fieldGroupType !== undefined ? this.fieldGroupType : null as any;
        data["accountTypeId"] = this.accountTypeId !== undefined ? this.accountTypeId : null as any;
        data["aname"] = this.aname !== undefined ? this.aname : null as any;
        data["aabbrev"] = this.aabbrev !== undefined ? this.aabbrev : null as any;
        data["aimageUrl"] = this.aimageUrl !== undefined ? this.aimageUrl : null as any;
        data["awebsite"] = this.awebsite !== undefined ? this.awebsite : null as any;
        data["aaddress1"] = this.aaddress1 !== undefined ? this.aaddress1 : null as any;
        data["aaddress2"] = this.aaddress2 !== undefined ? this.aaddress2 : null as any;
        data["acity"] = this.acity !== undefined ? this.acity : null as any;
        data["astate"] = this.astate !== undefined ? this.astate : null as any;
        data["azip"] = this.azip !== undefined ? this.azip : null as any;
        data["aNote"] = this.aNote !== undefined ? this.aNote : null as any;
        data["acountry"] = this.acountry !== undefined ? this.acountry : null as any;
        data["billAttnToFname"] = this.billAttnToFname !== undefined ? this.billAttnToFname : null as any;
        data["billAttnToLname"] = this.billAttnToLname !== undefined ? this.billAttnToLname : null as any;
        data["baddress1"] = this.baddress1 !== undefined ? this.baddress1 : null as any;
        data["baddress2"] = this.baddress2 !== undefined ? this.baddress2 : null as any;
        data["bcity"] = this.bcity !== undefined ? this.bcity : null as any;
        data["bstate"] = this.bstate !== undefined ? this.bstate : null as any;
        data["bzip"] = this.bzip !== undefined ? this.bzip : null as any;
        data["bcountry"] = this.bcountry !== undefined ? this.bcountry : null as any;
        data["bphone"] = this.bphone !== undefined ? this.bphone : null as any;
        data["billingEmail"] = this.billingEmail !== undefined ? this.billingEmail : null as any;
        data["shipAttnTo"] = this.shipAttnTo !== undefined ? this.shipAttnTo : null as any;
        data["saddress1"] = this.saddress1 !== undefined ? this.saddress1 : null as any;
        data["saddress2"] = this.saddress2 !== undefined ? this.saddress2 : null as any;
        data["scity"] = this.scity !== undefined ? this.scity : null as any;
        data["sstate"] = this.sstate !== undefined ? this.sstate : null as any;
        data["szip"] = this.szip !== undefined ? this.szip : null as any;
        data["scountry"] = this.scountry !== undefined ? this.scountry : null as any;
        data["supportEmail"] = this.supportEmail !== undefined ? this.supportEmail : null as any;
        data["supportPhone"] = this.supportPhone !== undefined ? this.supportPhone : null as any;
        data["supportNote"] = this.supportNote !== undefined ? this.supportNote : null as any;
        data["itcontactEmail"] = this.itcontactEmail !== undefined ? this.itcontactEmail : null as any;
        data["itcontactPhone"] = this.itcontactPhone !== undefined ? this.itcontactPhone : null as any;
        data["shipDirectToRep"] = this.shipDirectToRep !== undefined ? this.shipDirectToRep : null as any;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        data["estimatedUsers"] = this.estimatedUsers !== undefined ? this.estimatedUsers : null as any;
        data["userSpecificEmailsForCommunication"] = this.userSpecificEmailsForCommunication !== undefined ? this.userSpecificEmailsForCommunication : null as any;
        data["provideBadgeWithPhoto"] = this.provideBadgeWithPhoto !== undefined ? this.provideBadgeWithPhoto : null as any;
        data["uDirectlyEmployed"] = this.uDirectlyEmployed !== undefined ? this.uDirectlyEmployed : null as any;
        data["uMobileEnabled"] = this.uMobileEnabled !== undefined ? this.uMobileEnabled : null as any;
        data["wmtVendorId"] = this.wmtVendorId !== undefined ? this.wmtVendorId : null as any;
        data["checkStatus"] = this.checkStatus !== undefined ? this.checkStatus : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["primaryAdminId"] = this.primaryAdminId !== undefined ? this.primaryAdminId : null as any;
        data["pPhone"] = this.pPhone !== undefined ? this.pPhone : null as any;
        data["reject"] = this.reject !== undefined ? this.reject : null as any;
        data["selectedProducts"] = this.selectedProducts !== undefined ? this.selectedProducts : null as any;
        data["selectedRetailers"] = this.selectedRetailers !== undefined ? this.selectedRetailers : null as any;
        data["selectedCertifications"] = this.selectedCertifications !== undefined ? this.selectedCertifications : null as any;
        data["selectedApps"] = this.selectedApps !== undefined ? this.selectedApps : null as any;
        data["selectedAccountTags"] = this.selectedAccountTags !== undefined ? this.selectedAccountTags : null as any;
        data["authToken"] = this.authToken !== undefined ? this.authToken : null as any;
        data["registrationCompletionDate"] = this.registrationCompletionDate ? this.registrationCompletionDate.toISOString() : null as any;
        data["retailerApprovalDate"] = this.retailerApprovalDate ? this.retailerApprovalDate.toISOString() : null as any;
        data["retailLink"] = this.retailLink !== undefined ? this.retailLink : null as any;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : null as any;
        data["showStoreSupportInfo"] = this.showStoreSupportInfo !== undefined ? this.showStoreSupportInfo : null as any;
        data["storeSupportNumber"] = this.storeSupportNumber !== undefined ? this.storeSupportNumber : null as any;
        data["subscriptionType"] = this.subscriptionType !== undefined ? this.subscriptionType : null as any;
        data["storeSupportEmail"] = this.storeSupportEmail !== undefined ? this.storeSupportEmail : null as any;
        data["selectedActivityUpdates"] = this.selectedActivityUpdates ? this.selectedActivityUpdates.toJSON() : null as any;
        data["isSeasonal"] = this.isSeasonal !== undefined ? this.isSeasonal : null as any;
        return data;
    }

    clone(): InvitedAccountModel {
        const json = this.toJSON();
        let result = new InvitedAccountModel();
        result.init(json);
        return result;
    }
}

export interface IInvitedAccountModel {
    invitedAccountId?: number;
    registrationToken?: string | null;
    invitedCompany?: string | null;
    invitedName?: string | null;
    invitedEmail?: string | null;
    invitedCourse?: string | null;
    invitedNote?: string | null;
    accountNumber?: string | null;
    printBadge?: EBadgePrint | null;
    badgeShipping?: number | null;
    number?: string | null;
    fName?: string | null;
    lName?: string | null;
    email1?: string | null;
    invitedDate?: moment.Moment | null;
    lastInvitedDate?: moment.Moment | null;
    fieldGroupType?: string | null;
    accountTypeId?: number | null;
    aname?: string | null;
    aabbrev?: string | null;
    aimageUrl?: string | null;
    awebsite?: string | null;
    aaddress1?: string | null;
    aaddress2?: string | null;
    acity?: string | null;
    astate?: string | null;
    azip?: string | null;
    aNote?: string | null;
    acountry?: string | null;
    billAttnToFname?: string | null;
    billAttnToLname?: string | null;
    baddress1?: string | null;
    baddress2?: string | null;
    bcity?: string | null;
    bstate?: string | null;
    bzip?: string | null;
    bcountry?: string | null;
    bphone?: string | null;
    billingEmail?: string | null;
    shipAttnTo?: string | null;
    saddress1?: string | null;
    saddress2?: string | null;
    scity?: string | null;
    sstate?: string | null;
    szip?: string | null;
    scountry?: string | null;
    supportEmail?: string | null;
    supportPhone?: string | null;
    supportNote?: string | null;
    itcontactEmail?: string | null;
    itcontactPhone?: string | null;
    shipDirectToRep?: number | null;
    statusId?: number | null;
    estimatedUsers?: string | null;
    userSpecificEmailsForCommunication?: boolean | null;
    provideBadgeWithPhoto?: boolean | null;
    uDirectlyEmployed?: string | null;
    uMobileEnabled?: string | null;
    wmtVendorId?: string | null;
    checkStatus?: string | null;
    accountId?: number | null;
    primaryAdminId?: number | null;
    pPhone?: string | null;
    reject?: string | null;
    selectedProducts?: string | null;
    selectedRetailers?: string | null;
    selectedCertifications?: string | null;
    selectedApps?: string | null;
    selectedAccountTags?: string | null;
    authToken?: string | null;
    registrationCompletionDate?: moment.Moment | null;
    retailerApprovalDate?: moment.Moment | null;
    retailLink?: boolean;
    dateCreated?: moment.Moment | null;
    showStoreSupportInfo?: boolean | null;
    storeSupportNumber?: string | null;
    subscriptionType?: string | null;
    storeSupportEmail?: string | null;
    selectedActivityUpdates?: UpdateActivities | null;
    isSeasonal?: boolean;
}

export class UpdateActivities implements IUpdateActivities {
    update?: boolean;
    activityIds?: number[] | null;

    constructor(data?: IUpdateActivities) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.update = _data["update"] !== undefined ? _data["update"] : null as any;
            if (Array.isArray(_data["activityIds"])) {
                this.activityIds = [] as any;
                for (let item of _data["activityIds"])
                    this.activityIds!.push(item);
            }
            else {
                this.activityIds = null as any;
            }
        }
    }

    static fromJS(data: any): UpdateActivities {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateActivities();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["update"] = this.update !== undefined ? this.update : null as any;
        if (Array.isArray(this.activityIds)) {
            data["activityIds"] = [];
            for (let item of this.activityIds)
                data["activityIds"].push(item);
        }
        return data;
    }

    clone(): UpdateActivities {
        const json = this.toJSON();
        let result = new UpdateActivities();
        result.init(json);
        return result;
    }
}

export interface IUpdateActivities {
    update?: boolean;
    activityIds?: number[] | null;
}

export class AccountDetailViewModel implements IAccountDetailViewModel {
    productIds?: string | null;
    courseIds?: string | null;
    retailerIds?: string | null;
    appIds?: string | null;
    accountTags?: AccountTag2[] | null;

    constructor(data?: IAccountDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productIds = _data["productIds"] !== undefined ? _data["productIds"] : null as any;
            this.courseIds = _data["courseIds"] !== undefined ? _data["courseIds"] : null as any;
            this.retailerIds = _data["retailerIds"] !== undefined ? _data["retailerIds"] : null as any;
            this.appIds = _data["appIds"] !== undefined ? _data["appIds"] : null as any;
            if (Array.isArray(_data["accountTags"])) {
                this.accountTags = [] as any;
                for (let item of _data["accountTags"])
                    this.accountTags!.push(AccountTag2.fromJS(item));
            }
            else {
                this.accountTags = null as any;
            }
        }
    }

    static fromJS(data: any): AccountDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productIds"] = this.productIds !== undefined ? this.productIds : null as any;
        data["courseIds"] = this.courseIds !== undefined ? this.courseIds : null as any;
        data["retailerIds"] = this.retailerIds !== undefined ? this.retailerIds : null as any;
        data["appIds"] = this.appIds !== undefined ? this.appIds : null as any;
        if (Array.isArray(this.accountTags)) {
            data["accountTags"] = [];
            for (let item of this.accountTags)
                data["accountTags"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): AccountDetailViewModel {
        const json = this.toJSON();
        let result = new AccountDetailViewModel();
        result.init(json);
        return result;
    }
}

export interface IAccountDetailViewModel {
    productIds?: string | null;
    courseIds?: string | null;
    retailerIds?: string | null;
    appIds?: string | null;
    accountTags?: AccountTag2[] | null;
}

export class AccountTag2 implements IAccountTag2 {
    accountId?: number;
    tagId?: number;

    constructor(data?: IAccountTag2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.tagId = _data["tagId"] !== undefined ? _data["tagId"] : null as any;
        }
    }

    static fromJS(data: any): AccountTag2 {
        data = typeof data === 'object' ? data : {};
        let result = new AccountTag2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["tagId"] = this.tagId !== undefined ? this.tagId : null as any;
        return data;
    }

    clone(): AccountTag2 {
        const json = this.toJSON();
        let result = new AccountTag2();
        result.init(json);
        return result;
    }
}

export interface IAccountTag2 {
    accountId?: number;
    tagId?: number;
}

export class LimitedResultOfInvitedAccountViewModel implements ILimitedResultOfInvitedAccountViewModel {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: InvitedAccountViewModel[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfInvitedAccountViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(InvitedAccountViewModel.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfInvitedAccountViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfInvitedAccountViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfInvitedAccountViewModel {
        const json = this.toJSON();
        let result = new LimitedResultOfInvitedAccountViewModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfInvitedAccountViewModel {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: InvitedAccountViewModel[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class InvitedAccountViewModel implements IInvitedAccountViewModel {
    invitedAccountId?: number;
    invitedCompany?: string | null;
    invitedName?: string | null;
    invitedEmail?: string | null;
    invitedCourse?: string | null;
    invitedNote?: string | null;
    imageUrl?: string | null;
    invitedDate?: moment.Moment | null;
    lastInvitedDate?: moment.Moment | null;
    registrationCompletionDate?: moment.Moment | null;
    retailerApprovalDate?: moment.Moment | null;
    id?: string | null;

    constructor(data?: IInvitedAccountViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invitedAccountId = _data["invitedAccountId"] !== undefined ? _data["invitedAccountId"] : null as any;
            this.invitedCompany = _data["invitedCompany"] !== undefined ? _data["invitedCompany"] : null as any;
            this.invitedName = _data["invitedName"] !== undefined ? _data["invitedName"] : null as any;
            this.invitedEmail = _data["invitedEmail"] !== undefined ? _data["invitedEmail"] : null as any;
            this.invitedCourse = _data["invitedCourse"] !== undefined ? _data["invitedCourse"] : null as any;
            this.invitedNote = _data["invitedNote"] !== undefined ? _data["invitedNote"] : null as any;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : null as any;
            this.invitedDate = _data["invitedDate"] ? moment(_data["invitedDate"].toString()) : null as any;
            this.lastInvitedDate = _data["lastInvitedDate"] ? moment(_data["lastInvitedDate"].toString()) : null as any;
            this.registrationCompletionDate = _data["registrationCompletionDate"] ? moment(_data["registrationCompletionDate"].toString()) : null as any;
            this.retailerApprovalDate = _data["retailerApprovalDate"] ? moment(_data["retailerApprovalDate"].toString()) : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): InvitedAccountViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvitedAccountViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invitedAccountId"] = this.invitedAccountId !== undefined ? this.invitedAccountId : null as any;
        data["invitedCompany"] = this.invitedCompany !== undefined ? this.invitedCompany : null as any;
        data["invitedName"] = this.invitedName !== undefined ? this.invitedName : null as any;
        data["invitedEmail"] = this.invitedEmail !== undefined ? this.invitedEmail : null as any;
        data["invitedCourse"] = this.invitedCourse !== undefined ? this.invitedCourse : null as any;
        data["invitedNote"] = this.invitedNote !== undefined ? this.invitedNote : null as any;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : null as any;
        data["invitedDate"] = this.invitedDate ? this.invitedDate.toISOString() : null as any;
        data["lastInvitedDate"] = this.lastInvitedDate ? this.lastInvitedDate.toISOString() : null as any;
        data["registrationCompletionDate"] = this.registrationCompletionDate ? this.registrationCompletionDate.toISOString() : null as any;
        data["retailerApprovalDate"] = this.retailerApprovalDate ? this.retailerApprovalDate.toISOString() : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }

    clone(): InvitedAccountViewModel {
        const json = this.toJSON();
        let result = new InvitedAccountViewModel();
        result.init(json);
        return result;
    }
}

export interface IInvitedAccountViewModel {
    invitedAccountId?: number;
    invitedCompany?: string | null;
    invitedName?: string | null;
    invitedEmail?: string | null;
    invitedCourse?: string | null;
    invitedNote?: string | null;
    imageUrl?: string | null;
    invitedDate?: moment.Moment | null;
    lastInvitedDate?: moment.Moment | null;
    registrationCompletionDate?: moment.Moment | null;
    retailerApprovalDate?: moment.Moment | null;
    id?: string | null;
}

export class ProductModel implements IProductModel {
    id?: string;
    itemNumber?: string | null;
    name?: string | null;
    category?: string | null;
    createdByName?: string | null;
    createdByEmail?: string | null;
    createdDate?: moment.Moment;
    imageUrl?: string | null;
    isActive?: boolean;
    updatedDate?: moment.Moment;

    constructor(data?: IProductModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.itemNumber = _data["itemNumber"] !== undefined ? _data["itemNumber"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.createdByName = _data["createdByName"] !== undefined ? _data["createdByName"] : null as any;
            this.createdByEmail = _data["createdByEmail"] !== undefined ? _data["createdByEmail"] : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : null as any;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ProductModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["itemNumber"] = this.itemNumber !== undefined ? this.itemNumber : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["createdByName"] = this.createdByName !== undefined ? this.createdByName : null as any;
        data["createdByEmail"] = this.createdByEmail !== undefined ? this.createdByEmail : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : null as any;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        return data;
    }

    clone(): ProductModel {
        const json = this.toJSON();
        let result = new ProductModel();
        result.init(json);
        return result;
    }
}

export interface IProductModel {
    id?: string;
    itemNumber?: string | null;
    name?: string | null;
    category?: string | null;
    createdByName?: string | null;
    createdByEmail?: string | null;
    createdDate?: moment.Moment;
    imageUrl?: string | null;
    isActive?: boolean;
    updatedDate?: moment.Moment;
}

export class ProductInput implements IProductInput {
    itemNumber?: string | null;
    name?: string | null;
    category?: string | null;
    isActive?: boolean;

    constructor(data?: IProductInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemNumber = _data["itemNumber"] !== undefined ? _data["itemNumber"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null as any;
        }
    }

    static fromJS(data: any): ProductInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProductInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemNumber"] = this.itemNumber !== undefined ? this.itemNumber : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null as any;
        return data;
    }

    clone(): ProductInput {
        const json = this.toJSON();
        let result = new ProductInput();
        result.init(json);
        return result;
    }
}

export interface IProductInput {
    itemNumber?: string | null;
    name?: string | null;
    category?: string | null;
    isActive?: boolean;
}

export class ProductsModel implements IProductsModel {
    productId?: number;
    productName?: string | null;
    productImageUrl?: string | null;
    cost?: number;
    statusId?: number;
    productTypeId?: number;
    productTypeName?: string | null;
    statusName?: string | null;

    constructor(data?: IProductsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"] !== undefined ? _data["productId"] : null as any;
            this.productName = _data["productName"] !== undefined ? _data["productName"] : null as any;
            this.productImageUrl = _data["productImageUrl"] !== undefined ? _data["productImageUrl"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            this.productTypeId = _data["productTypeId"] !== undefined ? _data["productTypeId"] : null as any;
            this.productTypeName = _data["productTypeName"] !== undefined ? _data["productTypeName"] : null as any;
            this.statusName = _data["statusName"] !== undefined ? _data["statusName"] : null as any;
        }
    }

    static fromJS(data: any): ProductsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId !== undefined ? this.productId : null as any;
        data["productName"] = this.productName !== undefined ? this.productName : null as any;
        data["productImageUrl"] = this.productImageUrl !== undefined ? this.productImageUrl : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        data["productTypeId"] = this.productTypeId !== undefined ? this.productTypeId : null as any;
        data["productTypeName"] = this.productTypeName !== undefined ? this.productTypeName : null as any;
        data["statusName"] = this.statusName !== undefined ? this.statusName : null as any;
        return data;
    }

    clone(): ProductsModel {
        const json = this.toJSON();
        let result = new ProductsModel();
        result.init(json);
        return result;
    }
}

export interface IProductsModel {
    productId?: number;
    productName?: string | null;
    productImageUrl?: string | null;
    cost?: number;
    statusId?: number;
    productTypeId?: number;
    productTypeName?: string | null;
    statusName?: string | null;
}

export class SiteNotificationBaseOfSiteNotificationData implements ISiteNotificationBaseOfSiteNotificationData {
    id?: string;
    sendType?: SendTypes;
    expiration?: moment.Moment | null;
    dataType?: NotificationDataTypes;
    status?: NotificationStatus;
    data?: SiteNotificationData | null;

    constructor(data?: ISiteNotificationBaseOfSiteNotificationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.sendType = _data["sendType"] !== undefined ? _data["sendType"] : null as any;
            this.expiration = _data["expiration"] ? moment(_data["expiration"].toString()) : null as any;
            this.dataType = _data["dataType"] !== undefined ? _data["dataType"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.data = _data["data"] ? SiteNotificationData.fromJS(_data["data"]) : null as any;
        }
    }

    static fromJS(data: any): SiteNotificationBaseOfSiteNotificationData {
        data = typeof data === 'object' ? data : {};
        let result = new SiteNotificationBaseOfSiteNotificationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["sendType"] = this.sendType !== undefined ? this.sendType : null as any;
        data["expiration"] = this.expiration ? this.expiration.toISOString() : null as any;
        data["dataType"] = this.dataType !== undefined ? this.dataType : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["data"] = this.data ? this.data.toJSON() : null as any;
        return data;
    }

    clone(): SiteNotificationBaseOfSiteNotificationData {
        const json = this.toJSON();
        let result = new SiteNotificationBaseOfSiteNotificationData();
        result.init(json);
        return result;
    }
}

export interface ISiteNotificationBaseOfSiteNotificationData {
    id?: string;
    sendType?: SendTypes;
    expiration?: moment.Moment | null;
    dataType?: NotificationDataTypes;
    status?: NotificationStatus;
    data?: SiteNotificationData | null;
}

export class LocationNotification extends SiteNotificationBaseOfSiteNotificationData implements ILocationNotification {
    location?: string | null;

    constructor(data?: ILocationNotification) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.location = _data["location"] !== undefined ? _data["location"] : null as any;
        }
    }

    static override fromJS(data: any): LocationNotification {
        data = typeof data === 'object' ? data : {};
        let result = new LocationNotification();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location !== undefined ? this.location : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): LocationNotification {
        const json = this.toJSON();
        let result = new LocationNotification();
        result.init(json);
        return result;
    }
}

export interface ILocationNotification extends ISiteNotificationBaseOfSiteNotificationData {
    location?: string | null;
}

export enum SendTypes {
    None = "none",
    Email = "email",
    SiteBanner = "siteBanner",
    AppBanner = "appBanner",
    Toast = "toast",
    AppNotification = "appNotification",
    LocationBanner = "locationBanner",
}

export enum NotificationDataTypes {
    Unknown = "unknown",
    Termination = "termination",
    Emergency = "emergency",
    Claim = "claim",
    Closure = "closure",
}

export enum NotificationStatus {
    New = "new",
    Read = "read",
    All = "all",
}

export class SiteNotificationData implements ISiteNotificationData {
    notifiedUsers?: UserListItem[] | null;
    user?: UserListItem | null;
    location?: string | null;

    constructor(data?: ISiteNotificationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["notifiedUsers"])) {
                this.notifiedUsers = [] as any;
                for (let item of _data["notifiedUsers"])
                    this.notifiedUsers!.push(UserListItem.fromJS(item));
            }
            else {
                this.notifiedUsers = null as any;
            }
            this.user = _data["user"] ? UserListItem.fromJS(_data["user"]) : null as any;
            this.location = _data["location"] !== undefined ? _data["location"] : null as any;
        }
    }

    static fromJS(data: any): SiteNotificationData {
        data = typeof data === 'object' ? data : {};
        let result = new SiteNotificationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.notifiedUsers)) {
            data["notifiedUsers"] = [];
            for (let item of this.notifiedUsers)
                data["notifiedUsers"].push(item ? item.toJSON() : null as any);
        }
        data["user"] = this.user ? this.user.toJSON() : null as any;
        data["location"] = this.location !== undefined ? this.location : null as any;
        return data;
    }

    clone(): SiteNotificationData {
        const json = this.toJSON();
        let result = new SiteNotificationData();
        result.init(json);
        return result;
    }
}

export interface ISiteNotificationData {
    notifiedUsers?: UserListItem[] | null;
    user?: UserListItem | null;
    location?: string | null;
}

export class TerminatedEmpViewModel implements ITerminatedEmpViewModel {
    terminationDate?: moment.Moment | null;
    locationNumber?: string | null;
    empNumber?: string | null;
    fName?: string | null;
    lName?: string | null;
    providerName?: string | null;
    accountName?: string | null;
    imageUrl?: string | null;
    status?: string | null;
    type?: string | null;
    fieldGroupType?: string | null;
    statusName?: string | null;
    updatedBy?: string | null;

    constructor(data?: ITerminatedEmpViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.terminationDate = _data["terminationDate"] ? moment(_data["terminationDate"].toString()) : null as any;
            this.locationNumber = _data["locationNumber"] !== undefined ? _data["locationNumber"] : null as any;
            this.empNumber = _data["empNumber"] !== undefined ? _data["empNumber"] : null as any;
            this.fName = _data["fName"] !== undefined ? _data["fName"] : null as any;
            this.lName = _data["lName"] !== undefined ? _data["lName"] : null as any;
            this.providerName = _data["providerName"] !== undefined ? _data["providerName"] : null as any;
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.fieldGroupType = _data["fieldGroupType"] !== undefined ? _data["fieldGroupType"] : null as any;
            this.statusName = _data["statusName"] !== undefined ? _data["statusName"] : null as any;
            this.updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : null as any;
        }
    }

    static fromJS(data: any): TerminatedEmpViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TerminatedEmpViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["terminationDate"] = this.terminationDate ? this.terminationDate.toISOString() : null as any;
        data["locationNumber"] = this.locationNumber !== undefined ? this.locationNumber : null as any;
        data["empNumber"] = this.empNumber !== undefined ? this.empNumber : null as any;
        data["fName"] = this.fName !== undefined ? this.fName : null as any;
        data["lName"] = this.lName !== undefined ? this.lName : null as any;
        data["providerName"] = this.providerName !== undefined ? this.providerName : null as any;
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["fieldGroupType"] = this.fieldGroupType !== undefined ? this.fieldGroupType : null as any;
        data["statusName"] = this.statusName !== undefined ? this.statusName : null as any;
        data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : null as any;
        return data;
    }

    clone(): TerminatedEmpViewModel {
        const json = this.toJSON();
        let result = new TerminatedEmpViewModel();
        result.init(json);
        return result;
    }
}

export interface ITerminatedEmpViewModel {
    terminationDate?: moment.Moment | null;
    locationNumber?: string | null;
    empNumber?: string | null;
    fName?: string | null;
    lName?: string | null;
    providerName?: string | null;
    accountName?: string | null;
    imageUrl?: string | null;
    status?: string | null;
    type?: string | null;
    fieldGroupType?: string | null;
    statusName?: string | null;
    updatedBy?: string | null;
}

export class GetEmailStatusResponse implements IGetEmailStatusResponse {
    statuses?: EmailStatus[] | null;

    constructor(data?: IGetEmailStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(EmailStatus.fromJS(item));
            }
            else {
                this.statuses = null as any;
            }
        }
    }

    static fromJS(data: any): GetEmailStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmailStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): GetEmailStatusResponse {
        const json = this.toJSON();
        let result = new GetEmailStatusResponse();
        result.init(json);
        return result;
    }
}

export interface IGetEmailStatusResponse {
    statuses?: EmailStatus[] | null;
}

export class EmailStatus implements IEmailStatus {
    email?: string | null;
    state?: string | null;
    timeSent?: moment.Moment | null;
    rawJSON?: any | null;

    constructor(data?: IEmailStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.timeSent = _data["timeSent"] ? moment(_data["timeSent"].toString()) : null as any;
            this.rawJSON = _data["rawJSON"] !== undefined ? _data["rawJSON"] : null as any;
        }
    }

    static fromJS(data: any): EmailStatus {
        data = typeof data === 'object' ? data : {};
        let result = new EmailStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["timeSent"] = this.timeSent ? this.timeSent.toISOString() : null as any;
        data["rawJSON"] = this.rawJSON !== undefined ? this.rawJSON : null as any;
        return data;
    }

    clone(): EmailStatus {
        const json = this.toJSON();
        let result = new EmailStatus();
        result.init(json);
        return result;
    }
}

export interface IEmailStatus {
    email?: string | null;
    state?: string | null;
    timeSent?: moment.Moment | null;
    rawJSON?: any | null;
}

export class CreateRequestViewModel implements ICreateRequestViewModel {
    projectName?: string | null;
    projectReason?: string | null;
    isRetailReadyPackaging?: boolean;
    isMinorProject?: boolean;
    source?: MarketingSignageRequestSource;
    requestor?: RequestorInformationViewModel | null;
    merchant?: MerchantInformationViewModel | null;
    supplier?: SupplierInformationViewModel | null;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    product?: string | null;
    departmentAffected?: string[] | null;
    proposedSignedElement?: string | null;
    signageLocation?: string | null;
    signageInstaller?: string | null;
    isDuplicateOnPackaging?: boolean;
    keywords?: string[] | null;
    imageUrls?: string[] | null;
    approvalEmailPdfUrls?: string[] | null;
    storeNumbers?: string[] | null;

    constructor(data?: ICreateRequestViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectName = _data["projectName"] !== undefined ? _data["projectName"] : null as any;
            this.projectReason = _data["projectReason"] !== undefined ? _data["projectReason"] : null as any;
            this.isRetailReadyPackaging = _data["isRetailReadyPackaging"] !== undefined ? _data["isRetailReadyPackaging"] : null as any;
            this.isMinorProject = _data["isMinorProject"] !== undefined ? _data["isMinorProject"] : null as any;
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.requestor = _data["requestor"] ? RequestorInformationViewModel.fromJS(_data["requestor"]) : null as any;
            this.merchant = _data["merchant"] ? MerchantInformationViewModel.fromJS(_data["merchant"]) : null as any;
            this.supplier = _data["supplier"] ? SupplierInformationViewModel.fromJS(_data["supplier"]) : null as any;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : null as any;
            this.product = _data["product"] !== undefined ? _data["product"] : null as any;
            if (Array.isArray(_data["departmentAffected"])) {
                this.departmentAffected = [] as any;
                for (let item of _data["departmentAffected"])
                    this.departmentAffected!.push(item);
            }
            else {
                this.departmentAffected = null as any;
            }
            this.proposedSignedElement = _data["proposedSignedElement"] !== undefined ? _data["proposedSignedElement"] : null as any;
            this.signageLocation = _data["signageLocation"] !== undefined ? _data["signageLocation"] : null as any;
            this.signageInstaller = _data["signageInstaller"] !== undefined ? _data["signageInstaller"] : null as any;
            this.isDuplicateOnPackaging = _data["isDuplicateOnPackaging"] !== undefined ? _data["isDuplicateOnPackaging"] : null as any;
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(item);
            }
            else {
                this.keywords = null as any;
            }
            if (Array.isArray(_data["imageUrls"])) {
                this.imageUrls = [] as any;
                for (let item of _data["imageUrls"])
                    this.imageUrls!.push(item);
            }
            else {
                this.imageUrls = null as any;
            }
            if (Array.isArray(_data["approvalEmailPdfUrls"])) {
                this.approvalEmailPdfUrls = [] as any;
                for (let item of _data["approvalEmailPdfUrls"])
                    this.approvalEmailPdfUrls!.push(item);
            }
            else {
                this.approvalEmailPdfUrls = null as any;
            }
            if (Array.isArray(_data["storeNumbers"])) {
                this.storeNumbers = [] as any;
                for (let item of _data["storeNumbers"])
                    this.storeNumbers!.push(item);
            }
            else {
                this.storeNumbers = null as any;
            }
        }
    }

    static fromJS(data: any): CreateRequestViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRequestViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName !== undefined ? this.projectName : null as any;
        data["projectReason"] = this.projectReason !== undefined ? this.projectReason : null as any;
        data["isRetailReadyPackaging"] = this.isRetailReadyPackaging !== undefined ? this.isRetailReadyPackaging : null as any;
        data["isMinorProject"] = this.isMinorProject !== undefined ? this.isMinorProject : null as any;
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["requestor"] = this.requestor ? this.requestor.toJSON() : null as any;
        data["merchant"] = this.merchant ? this.merchant.toJSON() : null as any;
        data["supplier"] = this.supplier ? this.supplier.toJSON() : null as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        data["product"] = this.product !== undefined ? this.product : null as any;
        if (Array.isArray(this.departmentAffected)) {
            data["departmentAffected"] = [];
            for (let item of this.departmentAffected)
                data["departmentAffected"].push(item);
        }
        data["proposedSignedElement"] = this.proposedSignedElement !== undefined ? this.proposedSignedElement : null as any;
        data["signageLocation"] = this.signageLocation !== undefined ? this.signageLocation : null as any;
        data["signageInstaller"] = this.signageInstaller !== undefined ? this.signageInstaller : null as any;
        data["isDuplicateOnPackaging"] = this.isDuplicateOnPackaging !== undefined ? this.isDuplicateOnPackaging : null as any;
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item);
        }
        if (Array.isArray(this.imageUrls)) {
            data["imageUrls"] = [];
            for (let item of this.imageUrls)
                data["imageUrls"].push(item);
        }
        if (Array.isArray(this.approvalEmailPdfUrls)) {
            data["approvalEmailPdfUrls"] = [];
            for (let item of this.approvalEmailPdfUrls)
                data["approvalEmailPdfUrls"].push(item);
        }
        if (Array.isArray(this.storeNumbers)) {
            data["storeNumbers"] = [];
            for (let item of this.storeNumbers)
                data["storeNumbers"].push(item);
        }
        return data;
    }

    clone(): CreateRequestViewModel {
        const json = this.toJSON();
        let result = new CreateRequestViewModel();
        result.init(json);
        return result;
    }
}

export interface ICreateRequestViewModel {
    projectName?: string | null;
    projectReason?: string | null;
    isRetailReadyPackaging?: boolean;
    isMinorProject?: boolean;
    source?: MarketingSignageRequestSource;
    requestor?: RequestorInformationViewModel | null;
    merchant?: MerchantInformationViewModel | null;
    supplier?: SupplierInformationViewModel | null;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    product?: string | null;
    departmentAffected?: string[] | null;
    proposedSignedElement?: string | null;
    signageLocation?: string | null;
    signageInstaller?: string | null;
    isDuplicateOnPackaging?: boolean;
    keywords?: string[] | null;
    imageUrls?: string[] | null;
    approvalEmailPdfUrls?: string[] | null;
    storeNumbers?: string[] | null;
}

export enum MarketingSignageRequestSource {
    NonVolt = "nonVolt",
    Volt = "volt",
}

export class RequestorInformationViewModel implements IRequestorInformationViewModel {
    name?: string | null;
    email?: string | null;

    constructor(data?: IRequestorInformationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
        }
    }

    static fromJS(data: any): RequestorInformationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequestorInformationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        return data;
    }

    clone(): RequestorInformationViewModel {
        const json = this.toJSON();
        let result = new RequestorInformationViewModel();
        result.init(json);
        return result;
    }
}

export interface IRequestorInformationViewModel {
    name?: string | null;
    email?: string | null;
}

export class MerchantInformationViewModel implements IMerchantInformationViewModel {
    isMerchantApproved?: boolean;
    name?: string | null;
    email?: string | null;
    department?: string[] | null;

    constructor(data?: IMerchantInformationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isMerchantApproved = _data["isMerchantApproved"] !== undefined ? _data["isMerchantApproved"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            if (Array.isArray(_data["department"])) {
                this.department = [] as any;
                for (let item of _data["department"])
                    this.department!.push(item);
            }
            else {
                this.department = null as any;
            }
        }
    }

    static fromJS(data: any): MerchantInformationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantInformationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isMerchantApproved"] = this.isMerchantApproved !== undefined ? this.isMerchantApproved : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        if (Array.isArray(this.department)) {
            data["department"] = [];
            for (let item of this.department)
                data["department"].push(item);
        }
        return data;
    }

    clone(): MerchantInformationViewModel {
        const json = this.toJSON();
        let result = new MerchantInformationViewModel();
        result.init(json);
        return result;
    }
}

export interface IMerchantInformationViewModel {
    isMerchantApproved?: boolean;
    name?: string | null;
    email?: string | null;
    department?: string[] | null;
}

export class SupplierInformationViewModel implements ISupplierInformationViewModel {
    name?: string | null;
    email?: string | null;
    phone?: string | null;

    constructor(data?: ISupplierInformationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
        }
    }

    static fromJS(data: any): SupplierInformationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierInformationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        return data;
    }

    clone(): SupplierInformationViewModel {
        const json = this.toJSON();
        let result = new SupplierInformationViewModel();
        result.init(json);
        return result;
    }
}

export interface ISupplierInformationViewModel {
    name?: string | null;
    email?: string | null;
    phone?: string | null;
}

export class LimitedResultOfMarketingSignageRequestRetrievalViewModel implements ILimitedResultOfMarketingSignageRequestRetrievalViewModel {
    totalCount!: number;
    results!: MarketingSignageRequestRetrievalViewModel[];
    offset!: number;
    limit!: number;

    constructor(data?: ILimitedResultOfMarketingSignageRequestRetrievalViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(MarketingSignageRequestRetrievalViewModel.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfMarketingSignageRequestRetrievalViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfMarketingSignageRequestRetrievalViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        return data;
    }

    clone(): LimitedResultOfMarketingSignageRequestRetrievalViewModel {
        const json = this.toJSON();
        let result = new LimitedResultOfMarketingSignageRequestRetrievalViewModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfMarketingSignageRequestRetrievalViewModel {
    totalCount: number;
    results: MarketingSignageRequestRetrievalViewModel[];
    offset: number;
    limit: number;
}

export class MarketingSignageRequestRetrievalViewModel implements IMarketingSignageRequestRetrievalViewModel {
    projectId?: string;
    status?: MarketingSignageRequestStatusTypes;
    projectName?: string | null;
    requestNumber?: string | null;
    supplier?: string | null;
    merchant?: string | null;
    updatedBy?: string | null;
    createdDate?: moment.Moment | null;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    department?: string[] | null;
    imageUrls?: string[] | null;

    constructor(data?: IMarketingSignageRequestRetrievalViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.projectName = _data["projectName"] !== undefined ? _data["projectName"] : null as any;
            this.requestNumber = _data["requestNumber"] !== undefined ? _data["requestNumber"] : null as any;
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : null as any;
            this.merchant = _data["merchant"] !== undefined ? _data["merchant"] : null as any;
            this.updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : null as any;
            if (Array.isArray(_data["department"])) {
                this.department = [] as any;
                for (let item of _data["department"])
                    this.department!.push(item);
            }
            else {
                this.department = null as any;
            }
            if (Array.isArray(_data["imageUrls"])) {
                this.imageUrls = [] as any;
                for (let item of _data["imageUrls"])
                    this.imageUrls!.push(item);
            }
            else {
                this.imageUrls = null as any;
            }
        }
    }

    static fromJS(data: any): MarketingSignageRequestRetrievalViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingSignageRequestRetrievalViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId !== undefined ? this.projectId : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["projectName"] = this.projectName !== undefined ? this.projectName : null as any;
        data["requestNumber"] = this.requestNumber !== undefined ? this.requestNumber : null as any;
        data["supplier"] = this.supplier !== undefined ? this.supplier : null as any;
        data["merchant"] = this.merchant !== undefined ? this.merchant : null as any;
        data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        if (Array.isArray(this.department)) {
            data["department"] = [];
            for (let item of this.department)
                data["department"].push(item);
        }
        if (Array.isArray(this.imageUrls)) {
            data["imageUrls"] = [];
            for (let item of this.imageUrls)
                data["imageUrls"].push(item);
        }
        return data;
    }

    clone(): MarketingSignageRequestRetrievalViewModel {
        const json = this.toJSON();
        let result = new MarketingSignageRequestRetrievalViewModel();
        result.init(json);
        return result;
    }
}

export interface IMarketingSignageRequestRetrievalViewModel {
    projectId?: string;
    status?: MarketingSignageRequestStatusTypes;
    projectName?: string | null;
    requestNumber?: string | null;
    supplier?: string | null;
    merchant?: string | null;
    updatedBy?: string | null;
    createdDate?: moment.Moment | null;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    department?: string[] | null;
    imageUrls?: string[] | null;
}

export enum MarketingSignageRequestStatusTypes {
    New = "new",
    InProgress = "inProgress",
    Approved = "approved",
    Denied = "denied",
}

export class RequestCountViewModel implements IRequestCountViewModel {
    new?: number;
    inProgress?: number;
    approved?: number;
    denied?: number;

    constructor(data?: IRequestCountViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.new = _data["new"] !== undefined ? _data["new"] : null as any;
            this.inProgress = _data["inProgress"] !== undefined ? _data["inProgress"] : null as any;
            this.approved = _data["approved"] !== undefined ? _data["approved"] : null as any;
            this.denied = _data["denied"] !== undefined ? _data["denied"] : null as any;
        }
    }

    static fromJS(data: any): RequestCountViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequestCountViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["new"] = this.new !== undefined ? this.new : null as any;
        data["inProgress"] = this.inProgress !== undefined ? this.inProgress : null as any;
        data["approved"] = this.approved !== undefined ? this.approved : null as any;
        data["denied"] = this.denied !== undefined ? this.denied : null as any;
        return data;
    }

    clone(): RequestCountViewModel {
        const json = this.toJSON();
        let result = new RequestCountViewModel();
        result.init(json);
        return result;
    }
}

export interface IRequestCountViewModel {
    new?: number;
    inProgress?: number;
    approved?: number;
    denied?: number;
}

export class RetrievalDetailViewModel implements IRetrievalDetailViewModel {
    projectId?: string | null;
    product?: string | null;
    isMinorProject?: boolean;
    status?: MarketingSignageRequestStatusTypes;
    source?: MarketingSignageRequestSource;
    projectName?: string | null;
    projectReason?: string | null;
    requestorEmail?: string | null;
    requestorName?: string | null;
    supplierName?: string | null;
    supplierEmail?: string | null;
    supplierPhone?: string | null;
    merchantName?: string | null;
    merchantEmail?: string | null;
    updatedBy?: string | null;
    merchantDepartment?: string[] | null;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    proposedSignedElement?: string | null;
    signageLocation?: string | null;
    signageInstaller?: string | null;
    isDuplicateOnPackaging?: boolean;
    keywords?: string[] | null;
    departmentAffected?: string[] | null;
    imageUrls?: string[] | null;
    approvalEmailPdfUrls?: string[] | null;
    storeNumbers?: string[] | null;
    createdDate?: moment.Moment | null;
    updatedDate?: moment.Moment | null;
    sprinkrReferenceNumber?: string | null;
    notes?: string | null;

    constructor(data?: IRetrievalDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : null as any;
            this.product = _data["product"] !== undefined ? _data["product"] : null as any;
            this.isMinorProject = _data["isMinorProject"] !== undefined ? _data["isMinorProject"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.projectName = _data["projectName"] !== undefined ? _data["projectName"] : null as any;
            this.projectReason = _data["projectReason"] !== undefined ? _data["projectReason"] : null as any;
            this.requestorEmail = _data["requestorEmail"] !== undefined ? _data["requestorEmail"] : null as any;
            this.requestorName = _data["requestorName"] !== undefined ? _data["requestorName"] : null as any;
            this.supplierName = _data["supplierName"] !== undefined ? _data["supplierName"] : null as any;
            this.supplierEmail = _data["supplierEmail"] !== undefined ? _data["supplierEmail"] : null as any;
            this.supplierPhone = _data["supplierPhone"] !== undefined ? _data["supplierPhone"] : null as any;
            this.merchantName = _data["merchantName"] !== undefined ? _data["merchantName"] : null as any;
            this.merchantEmail = _data["merchantEmail"] !== undefined ? _data["merchantEmail"] : null as any;
            this.updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : null as any;
            if (Array.isArray(_data["merchantDepartment"])) {
                this.merchantDepartment = [] as any;
                for (let item of _data["merchantDepartment"])
                    this.merchantDepartment!.push(item);
            }
            else {
                this.merchantDepartment = null as any;
            }
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : null as any;
            this.proposedSignedElement = _data["proposedSignedElement"] !== undefined ? _data["proposedSignedElement"] : null as any;
            this.signageLocation = _data["signageLocation"] !== undefined ? _data["signageLocation"] : null as any;
            this.signageInstaller = _data["signageInstaller"] !== undefined ? _data["signageInstaller"] : null as any;
            this.isDuplicateOnPackaging = _data["isDuplicateOnPackaging"] !== undefined ? _data["isDuplicateOnPackaging"] : null as any;
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(item);
            }
            else {
                this.keywords = null as any;
            }
            if (Array.isArray(_data["departmentAffected"])) {
                this.departmentAffected = [] as any;
                for (let item of _data["departmentAffected"])
                    this.departmentAffected!.push(item);
            }
            else {
                this.departmentAffected = null as any;
            }
            if (Array.isArray(_data["imageUrls"])) {
                this.imageUrls = [] as any;
                for (let item of _data["imageUrls"])
                    this.imageUrls!.push(item);
            }
            else {
                this.imageUrls = null as any;
            }
            if (Array.isArray(_data["approvalEmailPdfUrls"])) {
                this.approvalEmailPdfUrls = [] as any;
                for (let item of _data["approvalEmailPdfUrls"])
                    this.approvalEmailPdfUrls!.push(item);
            }
            else {
                this.approvalEmailPdfUrls = null as any;
            }
            if (Array.isArray(_data["storeNumbers"])) {
                this.storeNumbers = [] as any;
                for (let item of _data["storeNumbers"])
                    this.storeNumbers!.push(item);
            }
            else {
                this.storeNumbers = null as any;
            }
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            this.sprinkrReferenceNumber = _data["sprinkrReferenceNumber"] !== undefined ? _data["sprinkrReferenceNumber"] : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
        }
    }

    static fromJS(data: any): RetrievalDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RetrievalDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId !== undefined ? this.projectId : null as any;
        data["product"] = this.product !== undefined ? this.product : null as any;
        data["isMinorProject"] = this.isMinorProject !== undefined ? this.isMinorProject : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["projectName"] = this.projectName !== undefined ? this.projectName : null as any;
        data["projectReason"] = this.projectReason !== undefined ? this.projectReason : null as any;
        data["requestorEmail"] = this.requestorEmail !== undefined ? this.requestorEmail : null as any;
        data["requestorName"] = this.requestorName !== undefined ? this.requestorName : null as any;
        data["supplierName"] = this.supplierName !== undefined ? this.supplierName : null as any;
        data["supplierEmail"] = this.supplierEmail !== undefined ? this.supplierEmail : null as any;
        data["supplierPhone"] = this.supplierPhone !== undefined ? this.supplierPhone : null as any;
        data["merchantName"] = this.merchantName !== undefined ? this.merchantName : null as any;
        data["merchantEmail"] = this.merchantEmail !== undefined ? this.merchantEmail : null as any;
        data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : null as any;
        if (Array.isArray(this.merchantDepartment)) {
            data["merchantDepartment"] = [];
            for (let item of this.merchantDepartment)
                data["merchantDepartment"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        data["proposedSignedElement"] = this.proposedSignedElement !== undefined ? this.proposedSignedElement : null as any;
        data["signageLocation"] = this.signageLocation !== undefined ? this.signageLocation : null as any;
        data["signageInstaller"] = this.signageInstaller !== undefined ? this.signageInstaller : null as any;
        data["isDuplicateOnPackaging"] = this.isDuplicateOnPackaging !== undefined ? this.isDuplicateOnPackaging : null as any;
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item);
        }
        if (Array.isArray(this.departmentAffected)) {
            data["departmentAffected"] = [];
            for (let item of this.departmentAffected)
                data["departmentAffected"].push(item);
        }
        if (Array.isArray(this.imageUrls)) {
            data["imageUrls"] = [];
            for (let item of this.imageUrls)
                data["imageUrls"].push(item);
        }
        if (Array.isArray(this.approvalEmailPdfUrls)) {
            data["approvalEmailPdfUrls"] = [];
            for (let item of this.approvalEmailPdfUrls)
                data["approvalEmailPdfUrls"].push(item);
        }
        if (Array.isArray(this.storeNumbers)) {
            data["storeNumbers"] = [];
            for (let item of this.storeNumbers)
                data["storeNumbers"].push(item);
        }
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        data["sprinkrReferenceNumber"] = this.sprinkrReferenceNumber !== undefined ? this.sprinkrReferenceNumber : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        return data;
    }

    clone(): RetrievalDetailViewModel {
        const json = this.toJSON();
        let result = new RetrievalDetailViewModel();
        result.init(json);
        return result;
    }
}

export interface IRetrievalDetailViewModel {
    projectId?: string | null;
    product?: string | null;
    isMinorProject?: boolean;
    status?: MarketingSignageRequestStatusTypes;
    source?: MarketingSignageRequestSource;
    projectName?: string | null;
    projectReason?: string | null;
    requestorEmail?: string | null;
    requestorName?: string | null;
    supplierName?: string | null;
    supplierEmail?: string | null;
    supplierPhone?: string | null;
    merchantName?: string | null;
    merchantEmail?: string | null;
    updatedBy?: string | null;
    merchantDepartment?: string[] | null;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    proposedSignedElement?: string | null;
    signageLocation?: string | null;
    signageInstaller?: string | null;
    isDuplicateOnPackaging?: boolean;
    keywords?: string[] | null;
    departmentAffected?: string[] | null;
    imageUrls?: string[] | null;
    approvalEmailPdfUrls?: string[] | null;
    storeNumbers?: string[] | null;
    createdDate?: moment.Moment | null;
    updatedDate?: moment.Moment | null;
    sprinkrReferenceNumber?: string | null;
    notes?: string | null;
}

export class RetrievalDetailNonVoltViewModel implements IRetrievalDetailNonVoltViewModel {
    projectId?: string | null;
    status?: MarketingSignageRequestStatusTypes;
    requestorEmail?: string | null;
    requestorName?: string | null;
    projectName?: string | null;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    imageUrls?: string[] | null;
    createdDate?: moment.Moment | null;
    updatedDate?: moment.Moment | null;

    constructor(data?: IRetrievalDetailNonVoltViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.requestorEmail = _data["requestorEmail"] !== undefined ? _data["requestorEmail"] : null as any;
            this.requestorName = _data["requestorName"] !== undefined ? _data["requestorName"] : null as any;
            this.projectName = _data["projectName"] !== undefined ? _data["projectName"] : null as any;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : null as any;
            if (Array.isArray(_data["imageUrls"])) {
                this.imageUrls = [] as any;
                for (let item of _data["imageUrls"])
                    this.imageUrls!.push(item);
            }
            else {
                this.imageUrls = null as any;
            }
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): RetrievalDetailNonVoltViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RetrievalDetailNonVoltViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId !== undefined ? this.projectId : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["requestorEmail"] = this.requestorEmail !== undefined ? this.requestorEmail : null as any;
        data["requestorName"] = this.requestorName !== undefined ? this.requestorName : null as any;
        data["projectName"] = this.projectName !== undefined ? this.projectName : null as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        if (Array.isArray(this.imageUrls)) {
            data["imageUrls"] = [];
            for (let item of this.imageUrls)
                data["imageUrls"].push(item);
        }
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        return data;
    }

    clone(): RetrievalDetailNonVoltViewModel {
        const json = this.toJSON();
        let result = new RetrievalDetailNonVoltViewModel();
        result.init(json);
        return result;
    }
}

export interface IRetrievalDetailNonVoltViewModel {
    projectId?: string | null;
    status?: MarketingSignageRequestStatusTypes;
    requestorEmail?: string | null;
    requestorName?: string | null;
    projectName?: string | null;
    startDate?: moment.Moment;
    endDate?: moment.Moment;
    imageUrls?: string[] | null;
    createdDate?: moment.Moment | null;
    updatedDate?: moment.Moment | null;
}

export class UpdateRequestViewModel implements IUpdateRequestViewModel {
    sprinkrReferenceNumber?: string | null;
    notes?: string | null;
    status?: MarketingSignageRequestStatusTypes;

    constructor(data?: IUpdateRequestViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sprinkrReferenceNumber = _data["sprinkrReferenceNumber"] !== undefined ? _data["sprinkrReferenceNumber"] : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
        }
    }

    static fromJS(data: any): UpdateRequestViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRequestViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sprinkrReferenceNumber"] = this.sprinkrReferenceNumber !== undefined ? this.sprinkrReferenceNumber : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        return data;
    }

    clone(): UpdateRequestViewModel {
        const json = this.toJSON();
        let result = new UpdateRequestViewModel();
        result.init(json);
        return result;
    }
}

export interface IUpdateRequestViewModel {
    sprinkrReferenceNumber?: string | null;
    notes?: string | null;
    status?: MarketingSignageRequestStatusTypes;
}

export class LimitedResultOfLocationTypeModel implements ILimitedResultOfLocationTypeModel {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: LocationTypeModel[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfLocationTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(LocationTypeModel.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfLocationTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfLocationTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfLocationTypeModel {
        const json = this.toJSON();
        let result = new LimitedResultOfLocationTypeModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfLocationTypeModel {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: LocationTypeModel[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class LocationTypeModel implements ILocationTypeModel {
    id?: number;
    storeType?: string | null;
    description?: string | null;
    statusId?: number;
    statusName?: string | null;
    accountId?: number;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment | null;
    bannerName?: string | null;

    constructor(data?: ILocationTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.storeType = _data["storeType"] !== undefined ? _data["storeType"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            this.statusName = _data["statusName"] !== undefined ? _data["statusName"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            this.bannerName = _data["bannerName"] !== undefined ? _data["bannerName"] : null as any;
        }
    }

    static fromJS(data: any): LocationTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["storeType"] = this.storeType !== undefined ? this.storeType : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        data["statusName"] = this.statusName !== undefined ? this.statusName : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        data["bannerName"] = this.bannerName !== undefined ? this.bannerName : null as any;
        return data;
    }

    clone(): LocationTypeModel {
        const json = this.toJSON();
        let result = new LocationTypeModel();
        result.init(json);
        return result;
    }
}

export interface ILocationTypeModel {
    id?: number;
    storeType?: string | null;
    description?: string | null;
    statusId?: number;
    statusName?: string | null;
    accountId?: number;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment | null;
    bannerName?: string | null;
}

export class LocationTypeDropdown implements ILocationTypeDropdown {
    id?: number;
    description?: string | null;
    storeType?: string | null;

    constructor(data?: ILocationTypeDropdown) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.storeType = _data["storeType"] !== undefined ? _data["storeType"] : null as any;
        }
    }

    static fromJS(data: any): LocationTypeDropdown {
        data = typeof data === 'object' ? data : {};
        let result = new LocationTypeDropdown();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["storeType"] = this.storeType !== undefined ? this.storeType : null as any;
        return data;
    }

    clone(): LocationTypeDropdown {
        const json = this.toJSON();
        let result = new LocationTypeDropdown();
        result.init(json);
        return result;
    }
}

export interface ILocationTypeDropdown {
    id?: number;
    description?: string | null;
    storeType?: string | null;
}

export class LimitedResultOfLocationSummary implements ILimitedResultOfLocationSummary {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: LocationSummary[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfLocationSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(LocationSummary.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfLocationSummary {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfLocationSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfLocationSummary {
        const json = this.toJSON();
        let result = new LimitedResultOfLocationSummary();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfLocationSummary {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: LocationSummary[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class WattLocation implements IWattLocation {
    locationId?: string | null;
    number?: string | null;
    banner?: Banner2 | null;
    physicalAddress?: Address2 | null;
    latitude?: number | null;
    longitude?: number | null;
    isActive?: boolean;
    timeZone?: TimeZone | null;
    openStatus?: OpenStatus | null;
    contact?: Contact | null;
    image?: string | null;
    hierarchyMembers?: Hierarchy[] | null;

    constructor(data?: IWattLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : null as any;
            this.number = _data["number"] !== undefined ? _data["number"] : null as any;
            this.banner = _data["banner"] ? Banner2.fromJS(_data["banner"]) : null as any;
            this.physicalAddress = _data["physicalAddress"] ? Address2.fromJS(_data["physicalAddress"]) : null as any;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : null as any;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : null as any;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null as any;
            this.timeZone = _data["timeZone"] ? TimeZone.fromJS(_data["timeZone"]) : null as any;
            this.openStatus = _data["openStatus"] ? OpenStatus.fromJS(_data["openStatus"]) : null as any;
            this.contact = _data["contact"] ? Contact.fromJS(_data["contact"]) : null as any;
            this.image = _data["image"] !== undefined ? _data["image"] : null as any;
            if (Array.isArray(_data["hierarchyMembers"])) {
                this.hierarchyMembers = [] as any;
                for (let item of _data["hierarchyMembers"])
                    this.hierarchyMembers!.push(Hierarchy.fromJS(item));
            }
            else {
                this.hierarchyMembers = null as any;
            }
        }
    }

    static fromJS(data: any): WattLocation {
        data = typeof data === 'object' ? data : {};
        let result = new WattLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId !== undefined ? this.locationId : null as any;
        data["number"] = this.number !== undefined ? this.number : null as any;
        data["banner"] = this.banner ? this.banner.toJSON() : null as any;
        data["physicalAddress"] = this.physicalAddress ? this.physicalAddress.toJSON() : null as any;
        data["latitude"] = this.latitude !== undefined ? this.latitude : null as any;
        data["longitude"] = this.longitude !== undefined ? this.longitude : null as any;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null as any;
        data["timeZone"] = this.timeZone ? this.timeZone.toJSON() : null as any;
        data["openStatus"] = this.openStatus ? this.openStatus.toJSON() : null as any;
        data["contact"] = this.contact ? this.contact.toJSON() : null as any;
        data["image"] = this.image !== undefined ? this.image : null as any;
        if (Array.isArray(this.hierarchyMembers)) {
            data["hierarchyMembers"] = [];
            for (let item of this.hierarchyMembers)
                data["hierarchyMembers"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): WattLocation {
        const json = this.toJSON();
        let result = new WattLocation();
        result.init(json);
        return result;
    }
}

export interface IWattLocation {
    locationId?: string | null;
    number?: string | null;
    banner?: Banner2 | null;
    physicalAddress?: Address2 | null;
    latitude?: number | null;
    longitude?: number | null;
    isActive?: boolean;
    timeZone?: TimeZone | null;
    openStatus?: OpenStatus | null;
    contact?: Contact | null;
    image?: string | null;
    hierarchyMembers?: Hierarchy[] | null;
}

export class LocationSummary extends WattLocation implements ILocationSummary {
    repsInStore?: number;
    inEmergencyState?: boolean;
    emergencyName?: string | null;
    emergencyEndDate?: string | null;
    calendarNotifications?: LocationCalendarNotification[] | null;
    wspAccountId?: number | null;
    locationType?: string | null;
    features?: string | null;

    constructor(data?: ILocationSummary) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.repsInStore = _data["repsInStore"] !== undefined ? _data["repsInStore"] : null as any;
            this.inEmergencyState = _data["inEmergencyState"] !== undefined ? _data["inEmergencyState"] : null as any;
            this.emergencyName = _data["emergencyName"] !== undefined ? _data["emergencyName"] : null as any;
            this.emergencyEndDate = _data["emergencyEndDate"] !== undefined ? _data["emergencyEndDate"] : null as any;
            if (Array.isArray(_data["calendarNotifications"])) {
                this.calendarNotifications = [] as any;
                for (let item of _data["calendarNotifications"])
                    this.calendarNotifications!.push(LocationCalendarNotification.fromJS(item));
            }
            else {
                this.calendarNotifications = null as any;
            }
            this.wspAccountId = _data["wspAccountId"] !== undefined ? _data["wspAccountId"] : null as any;
            this.locationType = _data["locationType"] !== undefined ? _data["locationType"] : null as any;
            this.features = _data["features"] !== undefined ? _data["features"] : null as any;
        }
    }

    static override fromJS(data: any): LocationSummary {
        data = typeof data === 'object' ? data : {};
        let result = new LocationSummary();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["repsInStore"] = this.repsInStore !== undefined ? this.repsInStore : null as any;
        data["inEmergencyState"] = this.inEmergencyState !== undefined ? this.inEmergencyState : null as any;
        data["emergencyName"] = this.emergencyName !== undefined ? this.emergencyName : null as any;
        data["emergencyEndDate"] = this.emergencyEndDate !== undefined ? this.emergencyEndDate : null as any;
        if (Array.isArray(this.calendarNotifications)) {
            data["calendarNotifications"] = [];
            for (let item of this.calendarNotifications)
                data["calendarNotifications"].push(item ? item.toJSON() : null as any);
        }
        data["wspAccountId"] = this.wspAccountId !== undefined ? this.wspAccountId : null as any;
        data["locationType"] = this.locationType !== undefined ? this.locationType : null as any;
        data["features"] = this.features !== undefined ? this.features : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): LocationSummary {
        const json = this.toJSON();
        let result = new LocationSummary();
        result.init(json);
        return result;
    }
}

export interface ILocationSummary extends IWattLocation {
    repsInStore?: number;
    inEmergencyState?: boolean;
    emergencyName?: string | null;
    emergencyEndDate?: string | null;
    calendarNotifications?: LocationCalendarNotification[] | null;
    wspAccountId?: number | null;
    locationType?: string | null;
    features?: string | null;
}

export class Banner2 implements IBanner2 {
    code?: string | null;
    name?: string | null;

    constructor(data?: IBanner2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): Banner2 {
        data = typeof data === 'object' ? data : {};
        let result = new Banner2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }

    clone(): Banner2 {
        const json = this.toJSON();
        let result = new Banner2();
        result.init(json);
        return result;
    }
}

export interface IBanner2 {
    code?: string | null;
    name?: string | null;
}

export class Address2 implements IAddress2 {
    addressLine1?: string | null;
    addressLine2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    country?: Country | null;

    constructor(data?: IAddress2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressLine1 = _data["addressLine1"] !== undefined ? _data["addressLine1"] : null as any;
            this.addressLine2 = _data["addressLine2"] !== undefined ? _data["addressLine2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : null as any;
        }
    }

    static fromJS(data: any): Address2 {
        data = typeof data === 'object' ? data : {};
        let result = new Address2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressLine1"] = this.addressLine1 !== undefined ? this.addressLine1 : null as any;
        data["addressLine2"] = this.addressLine2 !== undefined ? this.addressLine2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["country"] = this.country ? this.country.toJSON() : null as any;
        return data;
    }

    clone(): Address2 {
        const json = this.toJSON();
        let result = new Address2();
        result.init(json);
        return result;
    }
}

export interface IAddress2 {
    addressLine1?: string | null;
    addressLine2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    country?: Country | null;
}

export class Country implements ICountry {
    code?: string | null;
    name?: string | null;

    constructor(data?: ICountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): Country {
        data = typeof data === 'object' ? data : {};
        let result = new Country();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }

    clone(): Country {
        const json = this.toJSON();
        let result = new Country();
        result.init(json);
        return result;
    }
}

export interface ICountry {
    code?: string | null;
    name?: string | null;
}

export class TimeZone implements ITimeZone {
    name?: string | null;
    id?: string | null;
    code?: string | null;

    constructor(data?: ITimeZone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
        }
    }

    static fromJS(data: any): TimeZone {
        data = typeof data === 'object' ? data : {};
        let result = new TimeZone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        return data;
    }

    clone(): TimeZone {
        const json = this.toJSON();
        let result = new TimeZone();
        result.init(json);
        return result;
    }
}

export interface ITimeZone {
    name?: string | null;
    id?: string | null;
    code?: string | null;
}

export class OpenStatus implements IOpenStatus {
    code?: string | null;
    description?: string | null;

    constructor(data?: IOpenStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
        }
    }

    static fromJS(data: any): OpenStatus {
        data = typeof data === 'object' ? data : {};
        let result = new OpenStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        return data;
    }

    clone(): OpenStatus {
        const json = this.toJSON();
        let result = new OpenStatus();
        result.init(json);
        return result;
    }
}

export interface IOpenStatus {
    code?: string | null;
    description?: string | null;
}

export class Contact implements IContact {
    phoneNumber?: string | null;

    constructor(data?: IContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : null as any;
        }
    }

    static fromJS(data: any): Contact {
        data = typeof data === 'object' ? data : {};
        let result = new Contact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null as any;
        return data;
    }

    clone(): Contact {
        const json = this.toJSON();
        let result = new Contact();
        result.init(json);
        return result;
    }
}

export interface IContact {
    phoneNumber?: string | null;
}

export class Hierarchy implements IHierarchy {
    hierarchyLevelId?: string | null;
    hierarchyMemberId?: string | null;
    name?: string | null;
    manager?: Manager | null;

    constructor(data?: IHierarchy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hierarchyLevelId = _data["hierarchyLevelId"] !== undefined ? _data["hierarchyLevelId"] : null as any;
            this.hierarchyMemberId = _data["hierarchyMemberId"] !== undefined ? _data["hierarchyMemberId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.manager = _data["manager"] ? Manager.fromJS(_data["manager"]) : null as any;
        }
    }

    static fromJS(data: any): Hierarchy {
        data = typeof data === 'object' ? data : {};
        let result = new Hierarchy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hierarchyLevelId"] = this.hierarchyLevelId !== undefined ? this.hierarchyLevelId : null as any;
        data["hierarchyMemberId"] = this.hierarchyMemberId !== undefined ? this.hierarchyMemberId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["manager"] = this.manager ? this.manager.toJSON() : null as any;
        return data;
    }

    clone(): Hierarchy {
        const json = this.toJSON();
        let result = new Hierarchy();
        result.init(json);
        return result;
    }
}

export interface IHierarchy {
    hierarchyLevelId?: string | null;
    hierarchyMemberId?: string | null;
    name?: string | null;
    manager?: Manager | null;
}

export class Manager implements IManager {
    name?: Name | null;

    constructor(data?: IManager) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] ? Name.fromJS(_data["name"]) : null as any;
        }
    }

    static fromJS(data: any): Manager {
        data = typeof data === 'object' ? data : {};
        let result = new Manager();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name ? this.name.toJSON() : null as any;
        return data;
    }

    clone(): Manager {
        const json = this.toJSON();
        let result = new Manager();
        result.init(json);
        return result;
    }
}

export interface IManager {
    name?: Name | null;
}

export class Name implements IName {
    fullName?: string | null;

    constructor(data?: IName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
        }
    }

    static fromJS(data: any): Name {
        data = typeof data === 'object' ? data : {};
        let result = new Name();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        return data;
    }

    clone(): Name {
        const json = this.toJSON();
        let result = new Name();
        result.init(json);
        return result;
    }
}

export interface IName {
    fullName?: string | null;
}

export class LimitedResultOfLocationsFilteredResult implements ILimitedResultOfLocationsFilteredResult {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: LocationsFilteredResult[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfLocationsFilteredResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(LocationsFilteredResult.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfLocationsFilteredResult {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfLocationsFilteredResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfLocationsFilteredResult {
        const json = this.toJSON();
        let result = new LimitedResultOfLocationsFilteredResult();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfLocationsFilteredResult {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: LocationsFilteredResult[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class LocationsFilteredResult implements ILocationsFilteredResult {
    locationNumber?: string | null;
    address?: Address | null;
    timeZone?: string | null;
    imageUrl?: string | null;
    banner?: string | null;
    phoneNumber?: string | null;

    constructor(data?: ILocationsFilteredResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationNumber = _data["locationNumber"] !== undefined ? _data["locationNumber"] : null as any;
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : null as any;
            this.timeZone = _data["timeZone"] !== undefined ? _data["timeZone"] : null as any;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : null as any;
            this.banner = _data["banner"] !== undefined ? _data["banner"] : null as any;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : null as any;
        }
    }

    static fromJS(data: any): LocationsFilteredResult {
        data = typeof data === 'object' ? data : {};
        let result = new LocationsFilteredResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationNumber"] = this.locationNumber !== undefined ? this.locationNumber : null as any;
        data["address"] = this.address ? this.address.toJSON() : null as any;
        data["timeZone"] = this.timeZone !== undefined ? this.timeZone : null as any;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : null as any;
        data["banner"] = this.banner !== undefined ? this.banner : null as any;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null as any;
        return data;
    }

    clone(): LocationsFilteredResult {
        const json = this.toJSON();
        let result = new LocationsFilteredResult();
        result.init(json);
        return result;
    }
}

export interface ILocationsFilteredResult {
    locationNumber?: string | null;
    address?: Address | null;
    timeZone?: string | null;
    imageUrl?: string | null;
    banner?: string | null;
    phoneNumber?: string | null;
}

export class MapLocation implements IMapLocation {
    locationId?: string | null;
    wattLocationId?: string | null;
    latitude?: number;
    longitude?: number;
    checkInCount?: number;

    constructor(data?: IMapLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : null as any;
            this.wattLocationId = _data["wattLocationId"] !== undefined ? _data["wattLocationId"] : null as any;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : null as any;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : null as any;
            this.checkInCount = _data["checkInCount"] !== undefined ? _data["checkInCount"] : null as any;
        }
    }

    static fromJS(data: any): MapLocation {
        data = typeof data === 'object' ? data : {};
        let result = new MapLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId !== undefined ? this.locationId : null as any;
        data["wattLocationId"] = this.wattLocationId !== undefined ? this.wattLocationId : null as any;
        data["latitude"] = this.latitude !== undefined ? this.latitude : null as any;
        data["longitude"] = this.longitude !== undefined ? this.longitude : null as any;
        data["checkInCount"] = this.checkInCount !== undefined ? this.checkInCount : null as any;
        return data;
    }

    clone(): MapLocation {
        const json = this.toJSON();
        let result = new MapLocation();
        result.init(json);
        return result;
    }
}

export interface IMapLocation {
    locationId?: string | null;
    wattLocationId?: string | null;
    latitude?: number;
    longitude?: number;
    checkInCount?: number;
}

export class CheckInSummary implements ICheckInSummary {
    repPersonNumber?: string | null;
    repFirstName?: string | null;
    repLastName?: string | null;
    repFieldGroup?: string | null;
    accountNumber?: string | null;
    accountName?: string | null;
    accountAbbreviation?: string | null;
    locationNumber?: string | null;
    repImageUrl?: string | null;
    timeIn?: moment.Moment;
    timeOut?: moment.Moment | null;
    walmartWeek?: WalmartWeek | null;
    tags?: string[] | null;

    constructor(data?: ICheckInSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.repPersonNumber = _data["repPersonNumber"] !== undefined ? _data["repPersonNumber"] : null as any;
            this.repFirstName = _data["repFirstName"] !== undefined ? _data["repFirstName"] : null as any;
            this.repLastName = _data["repLastName"] !== undefined ? _data["repLastName"] : null as any;
            this.repFieldGroup = _data["repFieldGroup"] !== undefined ? _data["repFieldGroup"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.accountAbbreviation = _data["accountAbbreviation"] !== undefined ? _data["accountAbbreviation"] : null as any;
            this.locationNumber = _data["locationNumber"] !== undefined ? _data["locationNumber"] : null as any;
            this.repImageUrl = _data["repImageUrl"] !== undefined ? _data["repImageUrl"] : null as any;
            this.timeIn = _data["timeIn"] ? moment(_data["timeIn"].toString()) : null as any;
            this.timeOut = _data["timeOut"] ? moment(_data["timeOut"].toString()) : null as any;
            this.walmartWeek = _data["walmartWeek"] ? WalmartWeek.fromJS(_data["walmartWeek"]) : null as any;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            else {
                this.tags = null as any;
            }
        }
    }

    static fromJS(data: any): CheckInSummary {
        data = typeof data === 'object' ? data : {};
        let result = new CheckInSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["repPersonNumber"] = this.repPersonNumber !== undefined ? this.repPersonNumber : null as any;
        data["repFirstName"] = this.repFirstName !== undefined ? this.repFirstName : null as any;
        data["repLastName"] = this.repLastName !== undefined ? this.repLastName : null as any;
        data["repFieldGroup"] = this.repFieldGroup !== undefined ? this.repFieldGroup : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["accountAbbreviation"] = this.accountAbbreviation !== undefined ? this.accountAbbreviation : null as any;
        data["locationNumber"] = this.locationNumber !== undefined ? this.locationNumber : null as any;
        data["repImageUrl"] = this.repImageUrl !== undefined ? this.repImageUrl : null as any;
        data["timeIn"] = this.timeIn ? this.timeIn.toISOString() : null as any;
        data["timeOut"] = this.timeOut ? this.timeOut.toISOString() : null as any;
        data["walmartWeek"] = this.walmartWeek ? this.walmartWeek.toJSON() : null as any;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }

    clone(): CheckInSummary {
        const json = this.toJSON();
        let result = new CheckInSummary();
        result.init(json);
        return result;
    }
}

export interface ICheckInSummary {
    repPersonNumber?: string | null;
    repFirstName?: string | null;
    repLastName?: string | null;
    repFieldGroup?: string | null;
    accountNumber?: string | null;
    accountName?: string | null;
    accountAbbreviation?: string | null;
    locationNumber?: string | null;
    repImageUrl?: string | null;
    timeIn?: moment.Moment;
    timeOut?: moment.Moment | null;
    walmartWeek?: WalmartWeek | null;
    tags?: string[] | null;
}

export class LocationTimeSummary implements ILocationTimeSummary {
    locationId?: number;
    locationNumber?: string | null;
    providerTimes?: InStoreTime[] | null;
    serviceDeploymentTimes?: InStoreTime[] | null;

    constructor(data?: ILocationTimeSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : null as any;
            this.locationNumber = _data["locationNumber"] !== undefined ? _data["locationNumber"] : null as any;
            if (Array.isArray(_data["providerTimes"])) {
                this.providerTimes = [] as any;
                for (let item of _data["providerTimes"])
                    this.providerTimes!.push(InStoreTime.fromJS(item));
            }
            else {
                this.providerTimes = null as any;
            }
            if (Array.isArray(_data["serviceDeploymentTimes"])) {
                this.serviceDeploymentTimes = [] as any;
                for (let item of _data["serviceDeploymentTimes"])
                    this.serviceDeploymentTimes!.push(InStoreTime.fromJS(item));
            }
            else {
                this.serviceDeploymentTimes = null as any;
            }
        }
    }

    static fromJS(data: any): LocationTimeSummary {
        data = typeof data === 'object' ? data : {};
        let result = new LocationTimeSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId !== undefined ? this.locationId : null as any;
        data["locationNumber"] = this.locationNumber !== undefined ? this.locationNumber : null as any;
        if (Array.isArray(this.providerTimes)) {
            data["providerTimes"] = [];
            for (let item of this.providerTimes)
                data["providerTimes"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.serviceDeploymentTimes)) {
            data["serviceDeploymentTimes"] = [];
            for (let item of this.serviceDeploymentTimes)
                data["serviceDeploymentTimes"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): LocationTimeSummary {
        const json = this.toJSON();
        let result = new LocationTimeSummary();
        result.init(json);
        return result;
    }
}

export interface ILocationTimeSummary {
    locationId?: number;
    locationNumber?: string | null;
    providerTimes?: InStoreTime[] | null;
    serviceDeploymentTimes?: InStoreTime[] | null;
}

export class InStoreTime implements IInStoreTime {
    id?: number;
    name?: string | null;
    abbreviation?: string | null;
    minutes?: number;

    constructor(data?: IInStoreTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.abbreviation = _data["abbreviation"] !== undefined ? _data["abbreviation"] : null as any;
            this.minutes = _data["minutes"] !== undefined ? _data["minutes"] : null as any;
        }
    }

    static fromJS(data: any): InStoreTime {
        data = typeof data === 'object' ? data : {};
        let result = new InStoreTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["abbreviation"] = this.abbreviation !== undefined ? this.abbreviation : null as any;
        data["minutes"] = this.minutes !== undefined ? this.minutes : null as any;
        return data;
    }

    clone(): InStoreTime {
        const json = this.toJSON();
        let result = new InStoreTime();
        result.init(json);
        return result;
    }
}

export interface IInStoreTime {
    id?: number;
    name?: string | null;
    abbreviation?: string | null;
    minutes?: number;
}

export class LocationVisitSummary implements ILocationVisitSummary {
    locationId?: number;
    locationNumber?: string | null;
    providerVisits?: InStoreVisit[] | null;
    serviceDeploymentVisits?: InStoreVisit[] | null;

    constructor(data?: ILocationVisitSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : null as any;
            this.locationNumber = _data["locationNumber"] !== undefined ? _data["locationNumber"] : null as any;
            if (Array.isArray(_data["providerVisits"])) {
                this.providerVisits = [] as any;
                for (let item of _data["providerVisits"])
                    this.providerVisits!.push(InStoreVisit.fromJS(item));
            }
            else {
                this.providerVisits = null as any;
            }
            if (Array.isArray(_data["serviceDeploymentVisits"])) {
                this.serviceDeploymentVisits = [] as any;
                for (let item of _data["serviceDeploymentVisits"])
                    this.serviceDeploymentVisits!.push(InStoreVisit.fromJS(item));
            }
            else {
                this.serviceDeploymentVisits = null as any;
            }
        }
    }

    static fromJS(data: any): LocationVisitSummary {
        data = typeof data === 'object' ? data : {};
        let result = new LocationVisitSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId !== undefined ? this.locationId : null as any;
        data["locationNumber"] = this.locationNumber !== undefined ? this.locationNumber : null as any;
        if (Array.isArray(this.providerVisits)) {
            data["providerVisits"] = [];
            for (let item of this.providerVisits)
                data["providerVisits"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.serviceDeploymentVisits)) {
            data["serviceDeploymentVisits"] = [];
            for (let item of this.serviceDeploymentVisits)
                data["serviceDeploymentVisits"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): LocationVisitSummary {
        const json = this.toJSON();
        let result = new LocationVisitSummary();
        result.init(json);
        return result;
    }
}

export interface ILocationVisitSummary {
    locationId?: number;
    locationNumber?: string | null;
    providerVisits?: InStoreVisit[] | null;
    serviceDeploymentVisits?: InStoreVisit[] | null;
}

export class InStoreVisit implements IInStoreVisit {
    id?: number;
    name?: string | null;
    abbreviation?: string | null;
    visitCount?: number;

    constructor(data?: IInStoreVisit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.abbreviation = _data["abbreviation"] !== undefined ? _data["abbreviation"] : null as any;
            this.visitCount = _data["visitCount"] !== undefined ? _data["visitCount"] : null as any;
        }
    }

    static fromJS(data: any): InStoreVisit {
        data = typeof data === 'object' ? data : {};
        let result = new InStoreVisit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["abbreviation"] = this.abbreviation !== undefined ? this.abbreviation : null as any;
        data["visitCount"] = this.visitCount !== undefined ? this.visitCount : null as any;
        return data;
    }

    clone(): InStoreVisit {
        const json = this.toJSON();
        let result = new InStoreVisit();
        result.init(json);
        return result;
    }
}

export interface IInStoreVisit {
    id?: number;
    name?: string | null;
    abbreviation?: string | null;
    visitCount?: number;
}

export class SupplierSignageLocationViewModel implements ISupplierSignageLocationViewModel {
    number?: string | null;
    state?: string | null;
    address?: string | null;
    city?: string | null;
    zip?: string | null;

    constructor(data?: ISupplierSignageLocationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"] !== undefined ? _data["number"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.address = _data["address"] !== undefined ? _data["address"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
        }
    }

    static fromJS(data: any): SupplierSignageLocationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierSignageLocationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number !== undefined ? this.number : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["address"] = this.address !== undefined ? this.address : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        return data;
    }

    clone(): SupplierSignageLocationViewModel {
        const json = this.toJSON();
        let result = new SupplierSignageLocationViewModel();
        result.init(json);
        return result;
    }
}

export interface ISupplierSignageLocationViewModel {
    number?: string | null;
    state?: string | null;
    address?: string | null;
    city?: string | null;
    zip?: string | null;
}

export class AccountLocationGroupNameDropdown implements IAccountLocationGroupNameDropdown {
    groupName?: string | null;
    groupId?: number;
    accountId?: number;
    accountImageUrl?: string | null;

    constructor(data?: IAccountLocationGroupNameDropdown) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupName = _data["groupName"] !== undefined ? _data["groupName"] : null as any;
            this.groupId = _data["groupId"] !== undefined ? _data["groupId"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.accountImageUrl = _data["accountImageUrl"] !== undefined ? _data["accountImageUrl"] : null as any;
        }
    }

    static fromJS(data: any): AccountLocationGroupNameDropdown {
        data = typeof data === 'object' ? data : {};
        let result = new AccountLocationGroupNameDropdown();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupName"] = this.groupName !== undefined ? this.groupName : null as any;
        data["groupId"] = this.groupId !== undefined ? this.groupId : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["accountImageUrl"] = this.accountImageUrl !== undefined ? this.accountImageUrl : null as any;
        return data;
    }

    clone(): AccountLocationGroupNameDropdown {
        const json = this.toJSON();
        let result = new AccountLocationGroupNameDropdown();
        result.init(json);
        return result;
    }
}

export interface IAccountLocationGroupNameDropdown {
    groupName?: string | null;
    groupId?: number;
    accountId?: number;
    accountImageUrl?: string | null;
}

export class LocationFeatureParams implements ILocationFeatureParams {
    featureList?: LocationFeature[] | null;
    wirelessServiceProviderAccountId?: number | null;

    constructor(data?: ILocationFeatureParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["featureList"])) {
                this.featureList = [] as any;
                for (let item of _data["featureList"])
                    this.featureList!.push(item);
            }
            else {
                this.featureList = null as any;
            }
            this.wirelessServiceProviderAccountId = _data["wirelessServiceProviderAccountId"] !== undefined ? _data["wirelessServiceProviderAccountId"] : null as any;
        }
    }

    static fromJS(data: any): LocationFeatureParams {
        data = typeof data === 'object' ? data : {};
        let result = new LocationFeatureParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.featureList)) {
            data["featureList"] = [];
            for (let item of this.featureList)
                data["featureList"].push(item);
        }
        data["wirelessServiceProviderAccountId"] = this.wirelessServiceProviderAccountId !== undefined ? this.wirelessServiceProviderAccountId : null as any;
        return data;
    }

    clone(): LocationFeatureParams {
        const json = this.toJSON();
        let result = new LocationFeatureParams();
        result.init(json);
        return result;
    }
}

export interface ILocationFeatureParams {
    featureList?: LocationFeature[] | null;
    wirelessServiceProviderAccountId?: number | null;
}

export enum LocationFeature {
    None = "none",
    PosAccess = "posAccess",
    JewelryPosAccess = "jewelryPosAccess",
    SalesFloorAnywhere = "salesFloorAnywhere",
    InventoryActionCapture = "inventoryActionCapture",
    ShelfScan = "shelfScan",
    ReportOnHandDiscrepancy = "reportOnHandDiscrepancy",
    PriorityPass = "priorityPass",
    Vizpick = "vizpick",
    PriorityPassRolloutPFNA = "priorityPassRolloutPFNA",
    PriorityPassRolloutPBNA = "priorityPassRolloutPBNA",
    RecommendedActions = "recommendedActions",
    FeatureManager = "featureManager",
}

export class LocationOpenStatusModel implements ILocationOpenStatusModel {
    id?: number;
    statusCode?: string | null;
    description?: string | null;
    statusId?: number;
    statusName?: string | null;
    accountId?: number;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment | null;
    groupName?: string | null;

    constructor(data?: ILocationOpenStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.statusCode = _data["statusCode"] !== undefined ? _data["statusCode"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            this.statusName = _data["statusName"] !== undefined ? _data["statusName"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            this.groupName = _data["groupName"] !== undefined ? _data["groupName"] : null as any;
        }
    }

    static fromJS(data: any): LocationOpenStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationOpenStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["statusCode"] = this.statusCode !== undefined ? this.statusCode : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        data["statusName"] = this.statusName !== undefined ? this.statusName : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        data["groupName"] = this.groupName !== undefined ? this.groupName : null as any;
        return data;
    }

    clone(): LocationOpenStatusModel {
        const json = this.toJSON();
        let result = new LocationOpenStatusModel();
        result.init(json);
        return result;
    }
}

export interface ILocationOpenStatusModel {
    id?: number;
    statusCode?: string | null;
    description?: string | null;
    statusId?: number;
    statusName?: string | null;
    accountId?: number;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment | null;
    groupName?: string | null;
}

export class LimitedResultOfLocationOpenStatusModel implements ILimitedResultOfLocationOpenStatusModel {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: LocationOpenStatusModel[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfLocationOpenStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(LocationOpenStatusModel.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfLocationOpenStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfLocationOpenStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfLocationOpenStatusModel {
        const json = this.toJSON();
        let result = new LimitedResultOfLocationOpenStatusModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfLocationOpenStatusModel {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: LocationOpenStatusModel[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class GlobalSearchHistoryViewModel implements IGlobalSearchHistoryViewModel {
    personId?: number;
    search?: string | null;
    route?: string | null;

    constructor(data?: IGlobalSearchHistoryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"] !== undefined ? _data["personId"] : null as any;
            this.search = _data["search"] !== undefined ? _data["search"] : null as any;
            this.route = _data["route"] !== undefined ? _data["route"] : null as any;
        }
    }

    static fromJS(data: any): GlobalSearchHistoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalSearchHistoryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId !== undefined ? this.personId : null as any;
        data["search"] = this.search !== undefined ? this.search : null as any;
        data["route"] = this.route !== undefined ? this.route : null as any;
        return data;
    }

    clone(): GlobalSearchHistoryViewModel {
        const json = this.toJSON();
        let result = new GlobalSearchHistoryViewModel();
        result.init(json);
        return result;
    }
}

export interface IGlobalSearchHistoryViewModel {
    personId?: number;
    search?: string | null;
    route?: string | null;
}

export class GlobalFilterViewModel implements IGlobalFilterViewModel {
    filterDefinitions?: FilterDefinition[] | null;

    constructor(data?: IGlobalFilterViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["filterDefinitions"])) {
                this.filterDefinitions = [] as any;
                for (let item of _data["filterDefinitions"])
                    this.filterDefinitions!.push(FilterDefinition.fromJS(item));
            }
            else {
                this.filterDefinitions = null as any;
            }
        }
    }

    static fromJS(data: any): GlobalFilterViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalFilterViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.filterDefinitions)) {
            data["filterDefinitions"] = [];
            for (let item of this.filterDefinitions)
                data["filterDefinitions"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): GlobalFilterViewModel {
        const json = this.toJSON();
        let result = new GlobalFilterViewModel();
        result.init(json);
        return result;
    }
}

export interface IGlobalFilterViewModel {
    filterDefinitions?: FilterDefinition[] | null;
}

export class FilterDefinition implements IFilterDefinition {
    resource?: GlobalFilterResourceType;
    value?: string | null;
    valueType?: GlobalFilterValueType;

    constructor(data?: IFilterDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resource = _data["resource"] !== undefined ? _data["resource"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
            this.valueType = _data["valueType"] !== undefined ? _data["valueType"] : null as any;
        }
    }

    static fromJS(data: any): FilterDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new FilterDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resource"] = this.resource !== undefined ? this.resource : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["valueType"] = this.valueType !== undefined ? this.valueType : null as any;
        return data;
    }

    clone(): FilterDefinition {
        const json = this.toJSON();
        let result = new FilterDefinition();
        result.init(json);
        return result;
    }
}

export interface IFilterDefinition {
    resource?: GlobalFilterResourceType;
    value?: string | null;
    valueType?: GlobalFilterValueType;
}

export enum GlobalFilterResourceType {
    Activity = "activity",
    Department = "department",
}

export enum GlobalFilterValueType {
    String = "string",
    Number = "number",
    StringList = "stringList",
    NumberList = "numberList",
}

export class CreateGlobalFilterViewModel implements ICreateGlobalFilterViewModel {
    definitions?: FilterDefinition[] | null;

    constructor(data?: ICreateGlobalFilterViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["definitions"])) {
                this.definitions = [] as any;
                for (let item of _data["definitions"])
                    this.definitions!.push(FilterDefinition.fromJS(item));
            }
            else {
                this.definitions = null as any;
            }
        }
    }

    static fromJS(data: any): CreateGlobalFilterViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGlobalFilterViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.definitions)) {
            data["definitions"] = [];
            for (let item of this.definitions)
                data["definitions"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): CreateGlobalFilterViewModel {
        const json = this.toJSON();
        let result = new CreateGlobalFilterViewModel();
        result.init(json);
        return result;
    }
}

export interface ICreateGlobalFilterViewModel {
    definitions?: FilterDefinition[] | null;
}

export class UpdateGlobalFilterViewModel implements IUpdateGlobalFilterViewModel {
    userId?: string;
    definitions?: FilterDefinition[] | null;

    constructor(data?: IUpdateGlobalFilterViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            if (Array.isArray(_data["definitions"])) {
                this.definitions = [] as any;
                for (let item of _data["definitions"])
                    this.definitions!.push(FilterDefinition.fromJS(item));
            }
            else {
                this.definitions = null as any;
            }
        }
    }

    static fromJS(data: any): UpdateGlobalFilterViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGlobalFilterViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        if (Array.isArray(this.definitions)) {
            data["definitions"] = [];
            for (let item of this.definitions)
                data["definitions"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): UpdateGlobalFilterViewModel {
        const json = this.toJSON();
        let result = new UpdateGlobalFilterViewModel();
        result.init(json);
        return result;
    }
}

export interface IUpdateGlobalFilterViewModel {
    userId?: string;
    definitions?: FilterDefinition[] | null;
}

export class FeedbackTaskSummary implements IFeedbackTaskSummary {
    id?: string;
    name?: string | null;
    activity?: string | null;
    departments?: Department2[] | null;
    accountName?: string | null;
    startDate?: moment.Moment | null;
    endDate?: moment.Moment | null;
    isCompleted?: boolean;
    completedDate?: moment.Moment | null;
    completedBy?: string | null;
    feedback?: boolean | null;

    constructor(data?: IFeedbackTaskSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.activity = _data["activity"] !== undefined ? _data["activity"] : null as any;
            if (Array.isArray(_data["departments"])) {
                this.departments = [] as any;
                for (let item of _data["departments"])
                    this.departments!.push(Department2.fromJS(item));
            }
            else {
                this.departments = null as any;
            }
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : null as any;
            this.isCompleted = _data["isCompleted"] !== undefined ? _data["isCompleted"] : null as any;
            this.completedDate = _data["completedDate"] ? moment(_data["completedDate"].toString()) : null as any;
            this.completedBy = _data["completedBy"] !== undefined ? _data["completedBy"] : null as any;
            this.feedback = _data["feedback"] !== undefined ? _data["feedback"] : null as any;
        }
    }

    static fromJS(data: any): FeedbackTaskSummary {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackTaskSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["activity"] = this.activity !== undefined ? this.activity : null as any;
        if (Array.isArray(this.departments)) {
            data["departments"] = [];
            for (let item of this.departments)
                data["departments"].push(item ? item.toJSON() : null as any);
        }
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        data["isCompleted"] = this.isCompleted !== undefined ? this.isCompleted : null as any;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : null as any;
        data["completedBy"] = this.completedBy !== undefined ? this.completedBy : null as any;
        data["feedback"] = this.feedback !== undefined ? this.feedback : null as any;
        return data;
    }

    clone(): FeedbackTaskSummary {
        const json = this.toJSON();
        let result = new FeedbackTaskSummary();
        result.init(json);
        return result;
    }
}

export interface IFeedbackTaskSummary {
    id?: string;
    name?: string | null;
    activity?: string | null;
    departments?: Department2[] | null;
    accountName?: string | null;
    startDate?: moment.Moment | null;
    endDate?: moment.Moment | null;
    isCompleted?: boolean;
    completedDate?: moment.Moment | null;
    completedBy?: string | null;
    feedback?: boolean | null;
}

export class FeedbackModel implements IFeedbackModel {
    id?: string | null;
    taskId!: string;
    rating!: boolean;
    reason?: string | null;
    comments?: string | null;
    photoValues?: string[] | null;
    storeNumber!: string;
    departments?: Department2[] | null;

    constructor(data?: IFeedbackModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.taskId = _data["taskId"] !== undefined ? _data["taskId"] : null as any;
            this.rating = _data["rating"] !== undefined ? _data["rating"] : null as any;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : null as any;
            if (Array.isArray(_data["photoValues"])) {
                this.photoValues = [] as any;
                for (let item of _data["photoValues"])
                    this.photoValues!.push(item);
            }
            else {
                this.photoValues = null as any;
            }
            this.storeNumber = _data["storeNumber"] !== undefined ? _data["storeNumber"] : null as any;
            if (Array.isArray(_data["departments"])) {
                this.departments = [] as any;
                for (let item of _data["departments"])
                    this.departments!.push(Department2.fromJS(item));
            }
            else {
                this.departments = null as any;
            }
        }
    }

    static fromJS(data: any): FeedbackModel {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["taskId"] = this.taskId !== undefined ? this.taskId : null as any;
        data["rating"] = this.rating !== undefined ? this.rating : null as any;
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        data["comments"] = this.comments !== undefined ? this.comments : null as any;
        if (Array.isArray(this.photoValues)) {
            data["photoValues"] = [];
            for (let item of this.photoValues)
                data["photoValues"].push(item);
        }
        data["storeNumber"] = this.storeNumber !== undefined ? this.storeNumber : null as any;
        if (Array.isArray(this.departments)) {
            data["departments"] = [];
            for (let item of this.departments)
                data["departments"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): FeedbackModel {
        const json = this.toJSON();
        let result = new FeedbackModel();
        result.init(json);
        return result;
    }
}

export interface IFeedbackModel {
    id?: string | null;
    taskId: string;
    rating: boolean;
    reason?: string | null;
    comments?: string | null;
    photoValues?: string[] | null;
    storeNumber: string;
    departments?: Department2[] | null;
}

export class FeedbackV2Model implements IFeedbackV2Model {
    id?: string | null;
    activity?: string | null;
    taskName?: string | null;
    taskDate?: string | null;
    accountId?: number;
    rating!: boolean;
    reason?: string | null;
    comments?: string | null;
    photoValues?: string[] | null;
    storeNumber!: string;
    departments?: Department2[] | null;

    constructor(data?: IFeedbackV2Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.activity = _data["activity"] !== undefined ? _data["activity"] : null as any;
            this.taskName = _data["taskName"] !== undefined ? _data["taskName"] : null as any;
            this.taskDate = _data["taskDate"] !== undefined ? _data["taskDate"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.rating = _data["rating"] !== undefined ? _data["rating"] : null as any;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : null as any;
            if (Array.isArray(_data["photoValues"])) {
                this.photoValues = [] as any;
                for (let item of _data["photoValues"])
                    this.photoValues!.push(item);
            }
            else {
                this.photoValues = null as any;
            }
            this.storeNumber = _data["storeNumber"] !== undefined ? _data["storeNumber"] : null as any;
            if (Array.isArray(_data["departments"])) {
                this.departments = [] as any;
                for (let item of _data["departments"])
                    this.departments!.push(Department2.fromJS(item));
            }
            else {
                this.departments = null as any;
            }
        }
    }

    static fromJS(data: any): FeedbackV2Model {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackV2Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["activity"] = this.activity !== undefined ? this.activity : null as any;
        data["taskName"] = this.taskName !== undefined ? this.taskName : null as any;
        data["taskDate"] = this.taskDate !== undefined ? this.taskDate : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["rating"] = this.rating !== undefined ? this.rating : null as any;
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        data["comments"] = this.comments !== undefined ? this.comments : null as any;
        if (Array.isArray(this.photoValues)) {
            data["photoValues"] = [];
            for (let item of this.photoValues)
                data["photoValues"].push(item);
        }
        data["storeNumber"] = this.storeNumber !== undefined ? this.storeNumber : null as any;
        if (Array.isArray(this.departments)) {
            data["departments"] = [];
            for (let item of this.departments)
                data["departments"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): FeedbackV2Model {
        const json = this.toJSON();
        let result = new FeedbackV2Model();
        result.init(json);
        return result;
    }
}

export interface IFeedbackV2Model {
    id?: string | null;
    activity?: string | null;
    taskName?: string | null;
    taskDate?: string | null;
    accountId?: number;
    rating: boolean;
    reason?: string | null;
    comments?: string | null;
    photoValues?: string[] | null;
    storeNumber: string;
    departments?: Department2[] | null;
}

export enum FeedbackReportType {
    Negative = "negative",
    Positive = "positive",
}

export class FeedbackReportItem implements IFeedbackReportItem {
    id?: string | null;
    reportType?: FeedbackReportType;
    storeNumber?: string | null;
    activity?: string | null;
    taskName?: string | null;
    fieldGroup?: string | null;
    scheduledStart?: moment.Moment;
    scheduledEnd?: moment.Moment;
    createdBy?: string | null;
    updatedDate?: moment.Moment;
    photoUrls?: string[] | null;
    reason?: string | null;
    comments?: string | null;
    departments?: Department2[] | null;
    scheduled?: string | null;
    photos?: string[] | null;
    department?: string | null;

    constructor(data?: IFeedbackReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.reportType = _data["reportType"] !== undefined ? _data["reportType"] : null as any;
            this.storeNumber = _data["storeNumber"] !== undefined ? _data["storeNumber"] : null as any;
            this.activity = _data["activity"] !== undefined ? _data["activity"] : null as any;
            this.taskName = _data["taskName"] !== undefined ? _data["taskName"] : null as any;
            this.fieldGroup = _data["fieldGroup"] !== undefined ? _data["fieldGroup"] : null as any;
            this.scheduledStart = _data["scheduledStart"] ? moment(_data["scheduledStart"].toString()) : null as any;
            this.scheduledEnd = _data["scheduledEnd"] ? moment(_data["scheduledEnd"].toString()) : null as any;
            this.createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            if (Array.isArray(_data["photoUrls"])) {
                this.photoUrls = [] as any;
                for (let item of _data["photoUrls"])
                    this.photoUrls!.push(item);
            }
            else {
                this.photoUrls = null as any;
            }
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : null as any;
            if (Array.isArray(_data["departments"])) {
                this.departments = [] as any;
                for (let item of _data["departments"])
                    this.departments!.push(Department2.fromJS(item));
            }
            else {
                this.departments = null as any;
            }
            this.scheduled = _data["scheduled"] !== undefined ? _data["scheduled"] : null as any;
            if (Array.isArray(_data["photos"])) {
                this.photos = [] as any;
                for (let item of _data["photos"])
                    this.photos!.push(item);
            }
            else {
                this.photos = null as any;
            }
            this.department = _data["department"] !== undefined ? _data["department"] : null as any;
        }
    }

    static fromJS(data: any): FeedbackReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["reportType"] = this.reportType !== undefined ? this.reportType : null as any;
        data["storeNumber"] = this.storeNumber !== undefined ? this.storeNumber : null as any;
        data["activity"] = this.activity !== undefined ? this.activity : null as any;
        data["taskName"] = this.taskName !== undefined ? this.taskName : null as any;
        data["fieldGroup"] = this.fieldGroup !== undefined ? this.fieldGroup : null as any;
        data["scheduledStart"] = this.scheduledStart ? this.scheduledStart.toISOString() : null as any;
        data["scheduledEnd"] = this.scheduledEnd ? this.scheduledEnd.toISOString() : null as any;
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        if (Array.isArray(this.photoUrls)) {
            data["photoUrls"] = [];
            for (let item of this.photoUrls)
                data["photoUrls"].push(item);
        }
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        data["comments"] = this.comments !== undefined ? this.comments : null as any;
        if (Array.isArray(this.departments)) {
            data["departments"] = [];
            for (let item of this.departments)
                data["departments"].push(item ? item.toJSON() : null as any);
        }
        data["scheduled"] = this.scheduled !== undefined ? this.scheduled : null as any;
        if (Array.isArray(this.photos)) {
            data["photos"] = [];
            for (let item of this.photos)
                data["photos"].push(item);
        }
        data["department"] = this.department !== undefined ? this.department : null as any;
        return data;
    }

    clone(): FeedbackReportItem {
        const json = this.toJSON();
        let result = new FeedbackReportItem();
        result.init(json);
        return result;
    }
}

export interface IFeedbackReportItem {
    id?: string | null;
    reportType?: FeedbackReportType;
    storeNumber?: string | null;
    activity?: string | null;
    taskName?: string | null;
    fieldGroup?: string | null;
    scheduledStart?: moment.Moment;
    scheduledEnd?: moment.Moment;
    createdBy?: string | null;
    updatedDate?: moment.Moment;
    photoUrls?: string[] | null;
    reason?: string | null;
    comments?: string | null;
    departments?: Department2[] | null;
    scheduled?: string | null;
    photos?: string[] | null;
    department?: string | null;
}

export class LimitedResultOfFeedbackReportItem implements ILimitedResultOfFeedbackReportItem {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: FeedbackReportItem[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfFeedbackReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(FeedbackReportItem.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfFeedbackReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfFeedbackReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfFeedbackReportItem {
        const json = this.toJSON();
        let result = new LimitedResultOfFeedbackReportItem();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfFeedbackReportItem {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: FeedbackReportItem[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class GenericTableReportOfFeedbackReportItem extends LimitedResultOfFeedbackReportItem implements IGenericTableReportOfFeedbackReportItem {
    /** Columns in the data-grid */
    columnList!: GenericTableReportColumns[];

    constructor(data?: IGenericTableReportOfFeedbackReportItem) {
        super(data);
        if (!data) {
            this.columnList = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["columnList"])) {
                this.columnList = [] as any;
                for (let item of _data["columnList"])
                    this.columnList!.push(GenericTableReportColumns.fromJS(item));
            }
            else {
                this.columnList = null as any;
            }
        }
    }

    static override fromJS(data: any): GenericTableReportOfFeedbackReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new GenericTableReportOfFeedbackReportItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columnList)) {
            data["columnList"] = [];
            for (let item of this.columnList)
                data["columnList"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): GenericTableReportOfFeedbackReportItem {
        const json = this.toJSON();
        let result = new GenericTableReportOfFeedbackReportItem();
        result.init(json);
        return result;
    }
}

export interface IGenericTableReportOfFeedbackReportItem extends ILimitedResultOfFeedbackReportItem {
    /** Columns in the data-grid */
    columnList: GenericTableReportColumns[];
}

export class FeedbackReportOfFeedbackReportItem extends GenericTableReportOfFeedbackReportItem implements IFeedbackReportOfFeedbackReportItem {

    constructor(data?: IFeedbackReportOfFeedbackReportItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): FeedbackReportOfFeedbackReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackReportOfFeedbackReportItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): FeedbackReportOfFeedbackReportItem {
        const json = this.toJSON();
        let result = new FeedbackReportOfFeedbackReportItem();
        result.init(json);
        return result;
    }
}

export interface IFeedbackReportOfFeedbackReportItem extends IGenericTableReportOfFeedbackReportItem {
}

export class FeedbackReportViewModel implements IFeedbackReportViewModel {
    totalNumberOfPositiveReports?: number;
    totalNumberOfNegativeReports?: number;
    reports?: LimitedResultOfFeedbackReportItem | null;

    constructor(data?: IFeedbackReportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalNumberOfPositiveReports = _data["totalNumberOfPositiveReports"] !== undefined ? _data["totalNumberOfPositiveReports"] : null as any;
            this.totalNumberOfNegativeReports = _data["totalNumberOfNegativeReports"] !== undefined ? _data["totalNumberOfNegativeReports"] : null as any;
            this.reports = _data["reports"] ? LimitedResultOfFeedbackReportItem.fromJS(_data["reports"]) : null as any;
        }
    }

    static fromJS(data: any): FeedbackReportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackReportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalNumberOfPositiveReports"] = this.totalNumberOfPositiveReports !== undefined ? this.totalNumberOfPositiveReports : null as any;
        data["totalNumberOfNegativeReports"] = this.totalNumberOfNegativeReports !== undefined ? this.totalNumberOfNegativeReports : null as any;
        data["reports"] = this.reports ? this.reports.toJSON() : null as any;
        return data;
    }

    clone(): FeedbackReportViewModel {
        const json = this.toJSON();
        let result = new FeedbackReportViewModel();
        result.init(json);
        return result;
    }
}

export interface IFeedbackReportViewModel {
    totalNumberOfPositiveReports?: number;
    totalNumberOfNegativeReports?: number;
    reports?: LimitedResultOfFeedbackReportItem | null;
}

export class FaqViewModel implements IFaqViewModel {
    faqs?: FaqModel[] | null;
    categories?: string[] | null;

    constructor(data?: IFaqViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["faqs"])) {
                this.faqs = [] as any;
                for (let item of _data["faqs"])
                    this.faqs!.push(FaqModel.fromJS(item));
            }
            else {
                this.faqs = null as any;
            }
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(item);
            }
            else {
                this.categories = null as any;
            }
        }
    }

    static fromJS(data: any): FaqViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FaqViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.faqs)) {
            data["faqs"] = [];
            for (let item of this.faqs)
                data["faqs"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        return data;
    }

    clone(): FaqViewModel {
        const json = this.toJSON();
        let result = new FaqViewModel();
        result.init(json);
        return result;
    }
}

export interface IFaqViewModel {
    faqs?: FaqModel[] | null;
    categories?: string[] | null;
}

export class FaqModel implements IFaqModel {
    faqId?: number;
    question?: string | null;
    answer?: string | null;
    viewInAppFlag?: number | null;
    category?: string | null;
    banners?: string[] | null;

    constructor(data?: IFaqModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.faqId = _data["faqId"] !== undefined ? _data["faqId"] : null as any;
            this.question = _data["question"] !== undefined ? _data["question"] : null as any;
            this.answer = _data["answer"] !== undefined ? _data["answer"] : null as any;
            this.viewInAppFlag = _data["viewInAppFlag"] !== undefined ? _data["viewInAppFlag"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            if (Array.isArray(_data["banners"])) {
                this.banners = [] as any;
                for (let item of _data["banners"])
                    this.banners!.push(item);
            }
            else {
                this.banners = null as any;
            }
        }
    }

    static fromJS(data: any): FaqModel {
        data = typeof data === 'object' ? data : {};
        let result = new FaqModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["faqId"] = this.faqId !== undefined ? this.faqId : null as any;
        data["question"] = this.question !== undefined ? this.question : null as any;
        data["answer"] = this.answer !== undefined ? this.answer : null as any;
        data["viewInAppFlag"] = this.viewInAppFlag !== undefined ? this.viewInAppFlag : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        if (Array.isArray(this.banners)) {
            data["banners"] = [];
            for (let item of this.banners)
                data["banners"].push(item);
        }
        return data;
    }

    clone(): FaqModel {
        const json = this.toJSON();
        let result = new FaqModel();
        result.init(json);
        return result;
    }
}

export interface IFaqModel {
    faqId?: number;
    question?: string | null;
    answer?: string | null;
    viewInAppFlag?: number | null;
    category?: string | null;
    banners?: string[] | null;
}

export enum ExceptionReportTypes {
    CheckIns = "checkIns",
    ForgotToCheckOut = "forgotToCheckOut",
    CheckInGreaterThanQuarterMile = "checkInGreaterThanQuarterMile",
    CheckOutGreaterThanQuarterMile = "checkOutGreaterThanQuarterMile",
    LostOrForgotBadge = "lostOrForgotBadge",
    ActiveReps = "activeReps",
    BadgePhotoNotUploaded = "badgePhotoNotUploaded",
    DeniedBadgePhoto = "deniedBadgePhoto",
    ActiveRepsNotCertified = "activeRepsNotCertified",
    RepsNotCheckedInLastXNumberOfDays = "repsNotCheckedInLastXNumberOfDays",
}

export class LimitedResultOfExceptionReportViewModel implements ILimitedResultOfExceptionReportViewModel {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: ExceptionReportViewModel[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfExceptionReportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ExceptionReportViewModel.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfExceptionReportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfExceptionReportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfExceptionReportViewModel {
        const json = this.toJSON();
        let result = new LimitedResultOfExceptionReportViewModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfExceptionReportViewModel {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: ExceptionReportViewModel[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class ExceptionReportViewModel implements IExceptionReportViewModel {
    firstName?: string | null;
    lastName?: string | null;
    nickName?: string | null;
    employeeNumber?: string | null;
    locationNumber?: string | null;
    distCheckInMiles?: number | null;
    distCheckOutMiles?: number | null;
    timeIn?: moment.Moment | null;
    timeOut?: moment.Moment | null;
    lastTimeOut?: moment.Moment | null;
    badgeStatus?: string | null;
    email?: string | null;
    imageURL?: string | null;
    denialReason?: string | null;
    dateCreated?: moment.Moment | null;
    certificationStatus?: string | null;
    storeTimeZone?: string | null;
    accountName?: string | null;
    bannerName?: string | null;

    constructor(data?: IExceptionReportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.nickName = _data["nickName"] !== undefined ? _data["nickName"] : null as any;
            this.employeeNumber = _data["employeeNumber"] !== undefined ? _data["employeeNumber"] : null as any;
            this.locationNumber = _data["locationNumber"] !== undefined ? _data["locationNumber"] : null as any;
            this.distCheckInMiles = _data["distCheckInMiles"] !== undefined ? _data["distCheckInMiles"] : null as any;
            this.distCheckOutMiles = _data["distCheckOutMiles"] !== undefined ? _data["distCheckOutMiles"] : null as any;
            this.timeIn = _data["timeIn"] ? moment(_data["timeIn"].toString()) : null as any;
            this.timeOut = _data["timeOut"] ? moment(_data["timeOut"].toString()) : null as any;
            this.lastTimeOut = _data["lastTimeOut"] ? moment(_data["lastTimeOut"].toString()) : null as any;
            this.badgeStatus = _data["badgeStatus"] !== undefined ? _data["badgeStatus"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.imageURL = _data["imageURL"] !== undefined ? _data["imageURL"] : null as any;
            this.denialReason = _data["denialReason"] !== undefined ? _data["denialReason"] : null as any;
            this.dateCreated = _data["dateCreated"] ? moment(_data["dateCreated"].toString()) : null as any;
            this.certificationStatus = _data["certificationStatus"] !== undefined ? _data["certificationStatus"] : null as any;
            this.storeTimeZone = _data["storeTimeZone"] !== undefined ? _data["storeTimeZone"] : null as any;
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.bannerName = _data["bannerName"] !== undefined ? _data["bannerName"] : null as any;
        }
    }

    static fromJS(data: any): ExceptionReportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExceptionReportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["nickName"] = this.nickName !== undefined ? this.nickName : null as any;
        data["employeeNumber"] = this.employeeNumber !== undefined ? this.employeeNumber : null as any;
        data["locationNumber"] = this.locationNumber !== undefined ? this.locationNumber : null as any;
        data["distCheckInMiles"] = this.distCheckInMiles !== undefined ? this.distCheckInMiles : null as any;
        data["distCheckOutMiles"] = this.distCheckOutMiles !== undefined ? this.distCheckOutMiles : null as any;
        data["timeIn"] = this.timeIn ? this.timeIn.toISOString() : null as any;
        data["timeOut"] = this.timeOut ? this.timeOut.toISOString() : null as any;
        data["lastTimeOut"] = this.lastTimeOut ? this.lastTimeOut.toISOString() : null as any;
        data["badgeStatus"] = this.badgeStatus !== undefined ? this.badgeStatus : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["imageURL"] = this.imageURL !== undefined ? this.imageURL : null as any;
        data["denialReason"] = this.denialReason !== undefined ? this.denialReason : null as any;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : null as any;
        data["certificationStatus"] = this.certificationStatus !== undefined ? this.certificationStatus : null as any;
        data["storeTimeZone"] = this.storeTimeZone !== undefined ? this.storeTimeZone : null as any;
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["bannerName"] = this.bannerName !== undefined ? this.bannerName : null as any;
        return data;
    }

    clone(): ExceptionReportViewModel {
        const json = this.toJSON();
        let result = new ExceptionReportViewModel();
        result.init(json);
        return result;
    }
}

export interface IExceptionReportViewModel {
    firstName?: string | null;
    lastName?: string | null;
    nickName?: string | null;
    employeeNumber?: string | null;
    locationNumber?: string | null;
    distCheckInMiles?: number | null;
    distCheckOutMiles?: number | null;
    timeIn?: moment.Moment | null;
    timeOut?: moment.Moment | null;
    lastTimeOut?: moment.Moment | null;
    badgeStatus?: string | null;
    email?: string | null;
    imageURL?: string | null;
    denialReason?: string | null;
    dateCreated?: moment.Moment | null;
    certificationStatus?: string | null;
    storeTimeZone?: string | null;
    accountName?: string | null;
    bannerName?: string | null;
}

export class ExceptionReportFilterParams implements IExceptionReportFilterParams {
    reportType?: ExceptionReportTypes;
    bannerNames?: string[] | null;
    accountIds?: number[] | null;
    search?: string | null;
    minDate?: moment.Moment | null;
    sortBy?: string | null;
    sortAscending?: boolean;

    constructor(data?: IExceptionReportFilterParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportType = _data["reportType"] !== undefined ? _data["reportType"] : null as any;
            if (Array.isArray(_data["bannerNames"])) {
                this.bannerNames = [] as any;
                for (let item of _data["bannerNames"])
                    this.bannerNames!.push(item);
            }
            else {
                this.bannerNames = null as any;
            }
            if (Array.isArray(_data["accountIds"])) {
                this.accountIds = [] as any;
                for (let item of _data["accountIds"])
                    this.accountIds!.push(item);
            }
            else {
                this.accountIds = null as any;
            }
            this.search = _data["search"] !== undefined ? _data["search"] : null as any;
            this.minDate = _data["minDate"] ? moment(_data["minDate"].toString()) : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): ExceptionReportFilterParams {
        data = typeof data === 'object' ? data : {};
        let result = new ExceptionReportFilterParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportType"] = this.reportType !== undefined ? this.reportType : null as any;
        if (Array.isArray(this.bannerNames)) {
            data["bannerNames"] = [];
            for (let item of this.bannerNames)
                data["bannerNames"].push(item);
        }
        if (Array.isArray(this.accountIds)) {
            data["accountIds"] = [];
            for (let item of this.accountIds)
                data["accountIds"].push(item);
        }
        data["search"] = this.search !== undefined ? this.search : null as any;
        data["minDate"] = this.minDate ? this.minDate.toISOString() : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): ExceptionReportFilterParams {
        const json = this.toJSON();
        let result = new ExceptionReportFilterParams();
        result.init(json);
        return result;
    }
}

export interface IExceptionReportFilterParams {
    reportType?: ExceptionReportTypes;
    bannerNames?: string[] | null;
    accountIds?: number[] | null;
    search?: string | null;
    minDate?: moment.Moment | null;
    sortBy?: string | null;
    sortAscending?: boolean;
}

export class LimitedResultOfVendorLogReportViewModel implements ILimitedResultOfVendorLogReportViewModel {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: VendorLogReportViewModel[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfVendorLogReportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(VendorLogReportViewModel.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfVendorLogReportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfVendorLogReportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfVendorLogReportViewModel {
        const json = this.toJSON();
        let result = new LimitedResultOfVendorLogReportViewModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfVendorLogReportViewModel {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: VendorLogReportViewModel[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class VendorLogReportViewModel implements IVendorLogReportViewModel {
    storeNumber?: string | null;
    name?: string | null;
    employeeNumber?: string | null;
    userHashId?: string | null;
    timeOut?: moment.Moment | null;
    timeIn?: moment.Moment | null;
    timeOutLocalStoreTime?: moment.Moment | null;
    timeInLocalStoreTime?: moment.Moment | null;
    linktoImage?: string | null;
    forcedCheckOut?: string | null;
    accountName?: string | null;
    accountNumber?: string | null;
    accountId?: number;
    updatedDate?: moment.Moment | null;

    constructor(data?: IVendorLogReportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeNumber = _data["storeNumber"] !== undefined ? _data["storeNumber"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.employeeNumber = _data["employeeNumber"] !== undefined ? _data["employeeNumber"] : null as any;
            this.userHashId = _data["userHashId"] !== undefined ? _data["userHashId"] : null as any;
            this.timeOut = _data["timeOut"] ? moment(_data["timeOut"].toString()) : null as any;
            this.timeIn = _data["timeIn"] ? moment(_data["timeIn"].toString()) : null as any;
            this.timeOutLocalStoreTime = _data["timeOutLocalStoreTime"] ? moment(_data["timeOutLocalStoreTime"].toString()) : null as any;
            this.timeInLocalStoreTime = _data["timeInLocalStoreTime"] ? moment(_data["timeInLocalStoreTime"].toString()) : null as any;
            this.linktoImage = _data["linktoImage"] !== undefined ? _data["linktoImage"] : null as any;
            this.forcedCheckOut = _data["forcedCheckOut"] !== undefined ? _data["forcedCheckOut"] : null as any;
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): VendorLogReportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new VendorLogReportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeNumber"] = this.storeNumber !== undefined ? this.storeNumber : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["employeeNumber"] = this.employeeNumber !== undefined ? this.employeeNumber : null as any;
        data["userHashId"] = this.userHashId !== undefined ? this.userHashId : null as any;
        data["timeOut"] = this.timeOut ? this.timeOut.toISOString() : null as any;
        data["timeIn"] = this.timeIn ? this.timeIn.toISOString() : null as any;
        data["timeOutLocalStoreTime"] = this.timeOutLocalStoreTime ? this.timeOutLocalStoreTime.toISOString() : null as any;
        data["timeInLocalStoreTime"] = this.timeInLocalStoreTime ? this.timeInLocalStoreTime.toISOString() : null as any;
        data["linktoImage"] = this.linktoImage !== undefined ? this.linktoImage : null as any;
        data["forcedCheckOut"] = this.forcedCheckOut !== undefined ? this.forcedCheckOut : null as any;
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        return data;
    }

    clone(): VendorLogReportViewModel {
        const json = this.toJSON();
        let result = new VendorLogReportViewModel();
        result.init(json);
        return result;
    }
}

export interface IVendorLogReportViewModel {
    storeNumber?: string | null;
    name?: string | null;
    employeeNumber?: string | null;
    userHashId?: string | null;
    timeOut?: moment.Moment | null;
    timeIn?: moment.Moment | null;
    timeOutLocalStoreTime?: moment.Moment | null;
    timeInLocalStoreTime?: moment.Moment | null;
    linktoImage?: string | null;
    forcedCheckOut?: string | null;
    accountName?: string | null;
    accountNumber?: string | null;
    accountId?: number;
    updatedDate?: moment.Moment | null;
}

export class CommunicationCategoryViewModel implements ICommunicationCategoryViewModel {
    id?: number;
    categoryName?: string | null;

    constructor(data?: ICommunicationCategoryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.categoryName = _data["categoryName"] !== undefined ? _data["categoryName"] : null as any;
        }
    }

    static fromJS(data: any): CommunicationCategoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationCategoryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["categoryName"] = this.categoryName !== undefined ? this.categoryName : null as any;
        return data;
    }

    clone(): CommunicationCategoryViewModel {
        const json = this.toJSON();
        let result = new CommunicationCategoryViewModel();
        result.init(json);
        return result;
    }
}

export interface ICommunicationCategoryViewModel {
    id?: number;
    categoryName?: string | null;
}

export class CommunicationsAccountCategoryViewModel implements ICommunicationsAccountCategoryViewModel {
    accountId?: number;
    categoryId?: number;
    categoryName?: string | null;
    providerAdmin?: boolean | null;
    fieldEmployee?: boolean | null;

    constructor(data?: ICommunicationsAccountCategoryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null as any;
            this.categoryName = _data["categoryName"] !== undefined ? _data["categoryName"] : null as any;
            this.providerAdmin = _data["providerAdmin"] !== undefined ? _data["providerAdmin"] : null as any;
            this.fieldEmployee = _data["fieldEmployee"] !== undefined ? _data["fieldEmployee"] : null as any;
        }
    }

    static fromJS(data: any): CommunicationsAccountCategoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationsAccountCategoryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null as any;
        data["categoryName"] = this.categoryName !== undefined ? this.categoryName : null as any;
        data["providerAdmin"] = this.providerAdmin !== undefined ? this.providerAdmin : null as any;
        data["fieldEmployee"] = this.fieldEmployee !== undefined ? this.fieldEmployee : null as any;
        return data;
    }

    clone(): CommunicationsAccountCategoryViewModel {
        const json = this.toJSON();
        let result = new CommunicationsAccountCategoryViewModel();
        result.init(json);
        return result;
    }
}

export interface ICommunicationsAccountCategoryViewModel {
    accountId?: number;
    categoryId?: number;
    categoryName?: string | null;
    providerAdmin?: boolean | null;
    fieldEmployee?: boolean | null;
}

export class LimitedResultOfMassCommunicationsLogViewModel implements ILimitedResultOfMassCommunicationsLogViewModel {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: MassCommunicationsLogViewModel[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfMassCommunicationsLogViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(MassCommunicationsLogViewModel.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfMassCommunicationsLogViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfMassCommunicationsLogViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfMassCommunicationsLogViewModel {
        const json = this.toJSON();
        let result = new LimitedResultOfMassCommunicationsLogViewModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfMassCommunicationsLogViewModel {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: MassCommunicationsLogViewModel[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class MassCommunicationsLogViewModel implements IMassCommunicationsLogViewModel {
    subject?: string | null;
    body?: string | null;
    createdDate?: moment.Moment | null;
    sentBy?: string | null;
    category?: string | null;
    attachmentUrls?: string[] | null;
    numberOfRecipients?: number;
    recipientAccounts?: string[] | null;
    recipientFieldGroupTypes?: string[] | null;
    recipientRoles?: string[] | null;
    recipientTags?: string[] | null;
    recipientProducts?: string[] | null;
    includePrimaryProviderAdmins?: boolean;

    constructor(data?: IMassCommunicationsLogViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"] !== undefined ? _data["subject"] : null as any;
            this.body = _data["body"] !== undefined ? _data["body"] : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.sentBy = _data["sentBy"] !== undefined ? _data["sentBy"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            if (Array.isArray(_data["attachmentUrls"])) {
                this.attachmentUrls = [] as any;
                for (let item of _data["attachmentUrls"])
                    this.attachmentUrls!.push(item);
            }
            else {
                this.attachmentUrls = null as any;
            }
            this.numberOfRecipients = _data["numberOfRecipients"] !== undefined ? _data["numberOfRecipients"] : null as any;
            if (Array.isArray(_data["recipientAccounts"])) {
                this.recipientAccounts = [] as any;
                for (let item of _data["recipientAccounts"])
                    this.recipientAccounts!.push(item);
            }
            else {
                this.recipientAccounts = null as any;
            }
            if (Array.isArray(_data["recipientFieldGroupTypes"])) {
                this.recipientFieldGroupTypes = [] as any;
                for (let item of _data["recipientFieldGroupTypes"])
                    this.recipientFieldGroupTypes!.push(item);
            }
            else {
                this.recipientFieldGroupTypes = null as any;
            }
            if (Array.isArray(_data["recipientRoles"])) {
                this.recipientRoles = [] as any;
                for (let item of _data["recipientRoles"])
                    this.recipientRoles!.push(item);
            }
            else {
                this.recipientRoles = null as any;
            }
            if (Array.isArray(_data["recipientTags"])) {
                this.recipientTags = [] as any;
                for (let item of _data["recipientTags"])
                    this.recipientTags!.push(item);
            }
            else {
                this.recipientTags = null as any;
            }
            if (Array.isArray(_data["recipientProducts"])) {
                this.recipientProducts = [] as any;
                for (let item of _data["recipientProducts"])
                    this.recipientProducts!.push(item);
            }
            else {
                this.recipientProducts = null as any;
            }
            this.includePrimaryProviderAdmins = _data["includePrimaryProviderAdmins"] !== undefined ? _data["includePrimaryProviderAdmins"] : null as any;
        }
    }

    static fromJS(data: any): MassCommunicationsLogViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MassCommunicationsLogViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject !== undefined ? this.subject : null as any;
        data["body"] = this.body !== undefined ? this.body : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["sentBy"] = this.sentBy !== undefined ? this.sentBy : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        if (Array.isArray(this.attachmentUrls)) {
            data["attachmentUrls"] = [];
            for (let item of this.attachmentUrls)
                data["attachmentUrls"].push(item);
        }
        data["numberOfRecipients"] = this.numberOfRecipients !== undefined ? this.numberOfRecipients : null as any;
        if (Array.isArray(this.recipientAccounts)) {
            data["recipientAccounts"] = [];
            for (let item of this.recipientAccounts)
                data["recipientAccounts"].push(item);
        }
        if (Array.isArray(this.recipientFieldGroupTypes)) {
            data["recipientFieldGroupTypes"] = [];
            for (let item of this.recipientFieldGroupTypes)
                data["recipientFieldGroupTypes"].push(item);
        }
        if (Array.isArray(this.recipientRoles)) {
            data["recipientRoles"] = [];
            for (let item of this.recipientRoles)
                data["recipientRoles"].push(item);
        }
        if (Array.isArray(this.recipientTags)) {
            data["recipientTags"] = [];
            for (let item of this.recipientTags)
                data["recipientTags"].push(item);
        }
        if (Array.isArray(this.recipientProducts)) {
            data["recipientProducts"] = [];
            for (let item of this.recipientProducts)
                data["recipientProducts"].push(item);
        }
        data["includePrimaryProviderAdmins"] = this.includePrimaryProviderAdmins !== undefined ? this.includePrimaryProviderAdmins : null as any;
        return data;
    }

    clone(): MassCommunicationsLogViewModel {
        const json = this.toJSON();
        let result = new MassCommunicationsLogViewModel();
        result.init(json);
        return result;
    }
}

export interface IMassCommunicationsLogViewModel {
    subject?: string | null;
    body?: string | null;
    createdDate?: moment.Moment | null;
    sentBy?: string | null;
    category?: string | null;
    attachmentUrls?: string[] | null;
    numberOfRecipients?: number;
    recipientAccounts?: string[] | null;
    recipientFieldGroupTypes?: string[] | null;
    recipientRoles?: string[] | null;
    recipientTags?: string[] | null;
    recipientProducts?: string[] | null;
    includePrimaryProviderAdmins?: boolean;
}

export class ApiErrorOfException implements IApiErrorOfException {
    errorKey?: Exception | null;

    constructor(data?: IApiErrorOfException) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorKey = _data["errorKey"] ? Exception.fromJS(_data["errorKey"]) : null as any;
        }
    }

    static fromJS(data: any): ApiErrorOfException {
        data = typeof data === 'object' ? data : {};
        let result = new ApiErrorOfException();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorKey"] = this.errorKey ? this.errorKey.toJSON() : null as any;
        return data;
    }

    clone(): ApiErrorOfException {
        const json = this.toJSON();
        let result = new ApiErrorOfException();
        result.init(json);
        return result;
    }
}

export interface IApiErrorOfException {
    errorKey?: Exception | null;
}

export class Exception implements IException {
    message?: string;
    innerException?: Exception | null;
    source?: string | null;
    stackTrace?: string | null;

    constructor(data?: IException) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["Message"] !== undefined ? _data["Message"] : null as any;
            this.innerException = _data["InnerException"] ? Exception.fromJS(_data["InnerException"]) : null as any;
            this.source = _data["Source"] !== undefined ? _data["Source"] : null as any;
            this.stackTrace = _data["StackTrace"] !== undefined ? _data["StackTrace"] : null as any;
        }
    }

    static fromJS(data: any): Exception {
        data = typeof data === 'object' ? data : {};
        let result = new Exception();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Message"] = this.message !== undefined ? this.message : null as any;
        data["InnerException"] = this.innerException ? this.innerException.toJSON() : null as any;
        data["Source"] = this.source !== undefined ? this.source : null as any;
        data["StackTrace"] = this.stackTrace !== undefined ? this.stackTrace : null as any;
        return data;
    }

    clone(): Exception {
        const json = this.toJSON();
        let result = new Exception();
        result.init(json);
        return result;
    }
}

export interface IException {
    message?: string;
    innerException?: Exception | null;
    source?: string | null;
    stackTrace?: string | null;
}

export class SendCommunicationsViewModel implements ISendCommunicationsViewModel {
    subject?: string | null;
    body?: string | null;
    categoryId?: number | null;
    attachmentUrls?: string[] | null;
    recipientAccountIds?: number[] | null;
    recipientFieldGroupTypeIds?: number[] | null;
    recipientRoleIds?: number[] | null;
    recipientTagIds?: number[] | null;
    recipientProductIds?: number[] | null;
    includePrimaryProviderAdmins?: boolean | null;

    constructor(data?: ISendCommunicationsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"] !== undefined ? _data["subject"] : null as any;
            this.body = _data["body"] !== undefined ? _data["body"] : null as any;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null as any;
            if (Array.isArray(_data["attachmentUrls"])) {
                this.attachmentUrls = [] as any;
                for (let item of _data["attachmentUrls"])
                    this.attachmentUrls!.push(item);
            }
            else {
                this.attachmentUrls = null as any;
            }
            if (Array.isArray(_data["recipientAccountIds"])) {
                this.recipientAccountIds = [] as any;
                for (let item of _data["recipientAccountIds"])
                    this.recipientAccountIds!.push(item);
            }
            else {
                this.recipientAccountIds = null as any;
            }
            if (Array.isArray(_data["recipientFieldGroupTypeIds"])) {
                this.recipientFieldGroupTypeIds = [] as any;
                for (let item of _data["recipientFieldGroupTypeIds"])
                    this.recipientFieldGroupTypeIds!.push(item);
            }
            else {
                this.recipientFieldGroupTypeIds = null as any;
            }
            if (Array.isArray(_data["recipientRoleIds"])) {
                this.recipientRoleIds = [] as any;
                for (let item of _data["recipientRoleIds"])
                    this.recipientRoleIds!.push(item);
            }
            else {
                this.recipientRoleIds = null as any;
            }
            if (Array.isArray(_data["recipientTagIds"])) {
                this.recipientTagIds = [] as any;
                for (let item of _data["recipientTagIds"])
                    this.recipientTagIds!.push(item);
            }
            else {
                this.recipientTagIds = null as any;
            }
            if (Array.isArray(_data["recipientProductIds"])) {
                this.recipientProductIds = [] as any;
                for (let item of _data["recipientProductIds"])
                    this.recipientProductIds!.push(item);
            }
            else {
                this.recipientProductIds = null as any;
            }
            this.includePrimaryProviderAdmins = _data["includePrimaryProviderAdmins"] !== undefined ? _data["includePrimaryProviderAdmins"] : null as any;
        }
    }

    static fromJS(data: any): SendCommunicationsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendCommunicationsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject !== undefined ? this.subject : null as any;
        data["body"] = this.body !== undefined ? this.body : null as any;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null as any;
        if (Array.isArray(this.attachmentUrls)) {
            data["attachmentUrls"] = [];
            for (let item of this.attachmentUrls)
                data["attachmentUrls"].push(item);
        }
        if (Array.isArray(this.recipientAccountIds)) {
            data["recipientAccountIds"] = [];
            for (let item of this.recipientAccountIds)
                data["recipientAccountIds"].push(item);
        }
        if (Array.isArray(this.recipientFieldGroupTypeIds)) {
            data["recipientFieldGroupTypeIds"] = [];
            for (let item of this.recipientFieldGroupTypeIds)
                data["recipientFieldGroupTypeIds"].push(item);
        }
        if (Array.isArray(this.recipientRoleIds)) {
            data["recipientRoleIds"] = [];
            for (let item of this.recipientRoleIds)
                data["recipientRoleIds"].push(item);
        }
        if (Array.isArray(this.recipientTagIds)) {
            data["recipientTagIds"] = [];
            for (let item of this.recipientTagIds)
                data["recipientTagIds"].push(item);
        }
        if (Array.isArray(this.recipientProductIds)) {
            data["recipientProductIds"] = [];
            for (let item of this.recipientProductIds)
                data["recipientProductIds"].push(item);
        }
        data["includePrimaryProviderAdmins"] = this.includePrimaryProviderAdmins !== undefined ? this.includePrimaryProviderAdmins : null as any;
        return data;
    }

    clone(): SendCommunicationsViewModel {
        const json = this.toJSON();
        let result = new SendCommunicationsViewModel();
        result.init(json);
        return result;
    }
}

export interface ISendCommunicationsViewModel {
    subject?: string | null;
    body?: string | null;
    categoryId?: number | null;
    attachmentUrls?: string[] | null;
    recipientAccountIds?: number[] | null;
    recipientFieldGroupTypeIds?: number[] | null;
    recipientRoleIds?: number[] | null;
    recipientTagIds?: number[] | null;
    recipientProductIds?: number[] | null;
    includePrimaryProviderAdmins?: boolean | null;
}

export class ApiErrorOfFileUploadErrors implements IApiErrorOfFileUploadErrors {
    errorKey?: FileUploadErrors;

    constructor(data?: IApiErrorOfFileUploadErrors) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorKey = _data["errorKey"] !== undefined ? _data["errorKey"] : null as any;
        }
    }

    static fromJS(data: any): ApiErrorOfFileUploadErrors {
        data = typeof data === 'object' ? data : {};
        let result = new ApiErrorOfFileUploadErrors();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorKey"] = this.errorKey !== undefined ? this.errorKey : null as any;
        return data;
    }

    clone(): ApiErrorOfFileUploadErrors {
        const json = this.toJSON();
        let result = new ApiErrorOfFileUploadErrors();
        result.init(json);
        return result;
    }
}

export interface IApiErrorOfFileUploadErrors {
    errorKey?: FileUploadErrors;
}

export enum FileUploadErrors {
    FileAlreadyExists = "fileAlreadyExists",
}

export class CommunicationsTemplateViewModel implements ICommunicationsTemplateViewModel {
    name?: string | null;
    subject?: string | null;
    body?: string | null;
    categoryId?: number | null;
    lastEditedDate?: moment.Moment;
    lastEditedBy?: string | null;
    recipientAccountIds?: number[] | null;
    recipientFieldGroupTypeIds?: number[] | null;
    recipientRoleIds?: number[] | null;
    recipientTagIds?: number[] | null;
    recipientProductIds?: number[] | null;

    constructor(data?: ICommunicationsTemplateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : null as any;
            this.body = _data["body"] !== undefined ? _data["body"] : null as any;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null as any;
            this.lastEditedDate = _data["lastEditedDate"] ? moment(_data["lastEditedDate"].toString()) : null as any;
            this.lastEditedBy = _data["lastEditedBy"] !== undefined ? _data["lastEditedBy"] : null as any;
            if (Array.isArray(_data["recipientAccountIds"])) {
                this.recipientAccountIds = [] as any;
                for (let item of _data["recipientAccountIds"])
                    this.recipientAccountIds!.push(item);
            }
            else {
                this.recipientAccountIds = null as any;
            }
            if (Array.isArray(_data["recipientFieldGroupTypeIds"])) {
                this.recipientFieldGroupTypeIds = [] as any;
                for (let item of _data["recipientFieldGroupTypeIds"])
                    this.recipientFieldGroupTypeIds!.push(item);
            }
            else {
                this.recipientFieldGroupTypeIds = null as any;
            }
            if (Array.isArray(_data["recipientRoleIds"])) {
                this.recipientRoleIds = [] as any;
                for (let item of _data["recipientRoleIds"])
                    this.recipientRoleIds!.push(item);
            }
            else {
                this.recipientRoleIds = null as any;
            }
            if (Array.isArray(_data["recipientTagIds"])) {
                this.recipientTagIds = [] as any;
                for (let item of _data["recipientTagIds"])
                    this.recipientTagIds!.push(item);
            }
            else {
                this.recipientTagIds = null as any;
            }
            if (Array.isArray(_data["recipientProductIds"])) {
                this.recipientProductIds = [] as any;
                for (let item of _data["recipientProductIds"])
                    this.recipientProductIds!.push(item);
            }
            else {
                this.recipientProductIds = null as any;
            }
        }
    }

    static fromJS(data: any): CommunicationsTemplateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationsTemplateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["subject"] = this.subject !== undefined ? this.subject : null as any;
        data["body"] = this.body !== undefined ? this.body : null as any;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null as any;
        data["lastEditedDate"] = this.lastEditedDate ? this.lastEditedDate.toISOString() : null as any;
        data["lastEditedBy"] = this.lastEditedBy !== undefined ? this.lastEditedBy : null as any;
        if (Array.isArray(this.recipientAccountIds)) {
            data["recipientAccountIds"] = [];
            for (let item of this.recipientAccountIds)
                data["recipientAccountIds"].push(item);
        }
        if (Array.isArray(this.recipientFieldGroupTypeIds)) {
            data["recipientFieldGroupTypeIds"] = [];
            for (let item of this.recipientFieldGroupTypeIds)
                data["recipientFieldGroupTypeIds"].push(item);
        }
        if (Array.isArray(this.recipientRoleIds)) {
            data["recipientRoleIds"] = [];
            for (let item of this.recipientRoleIds)
                data["recipientRoleIds"].push(item);
        }
        if (Array.isArray(this.recipientTagIds)) {
            data["recipientTagIds"] = [];
            for (let item of this.recipientTagIds)
                data["recipientTagIds"].push(item);
        }
        if (Array.isArray(this.recipientProductIds)) {
            data["recipientProductIds"] = [];
            for (let item of this.recipientProductIds)
                data["recipientProductIds"].push(item);
        }
        return data;
    }

    clone(): CommunicationsTemplateViewModel {
        const json = this.toJSON();
        let result = new CommunicationsTemplateViewModel();
        result.init(json);
        return result;
    }
}

export interface ICommunicationsTemplateViewModel {
    name?: string | null;
    subject?: string | null;
    body?: string | null;
    categoryId?: number | null;
    lastEditedDate?: moment.Moment;
    lastEditedBy?: string | null;
    recipientAccountIds?: number[] | null;
    recipientFieldGroupTypeIds?: number[] | null;
    recipientRoleIds?: number[] | null;
    recipientTagIds?: number[] | null;
    recipientProductIds?: number[] | null;
}

export class UpdateTemplateViewModel implements IUpdateTemplateViewModel {
    name?: string | null;
    subject?: string | null;
    body?: string | null;
    categoryId?: number | null;
    recipientAccountIds?: number[] | null;
    recipientFieldGroupTypeIds?: number[] | null;
    recipientRoleIds?: number[] | null;
    recipientTagIds?: number[] | null;
    recipientProductIds?: number[] | null;

    constructor(data?: IUpdateTemplateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : null as any;
            this.body = _data["body"] !== undefined ? _data["body"] : null as any;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null as any;
            if (Array.isArray(_data["recipientAccountIds"])) {
                this.recipientAccountIds = [] as any;
                for (let item of _data["recipientAccountIds"])
                    this.recipientAccountIds!.push(item);
            }
            else {
                this.recipientAccountIds = null as any;
            }
            if (Array.isArray(_data["recipientFieldGroupTypeIds"])) {
                this.recipientFieldGroupTypeIds = [] as any;
                for (let item of _data["recipientFieldGroupTypeIds"])
                    this.recipientFieldGroupTypeIds!.push(item);
            }
            else {
                this.recipientFieldGroupTypeIds = null as any;
            }
            if (Array.isArray(_data["recipientRoleIds"])) {
                this.recipientRoleIds = [] as any;
                for (let item of _data["recipientRoleIds"])
                    this.recipientRoleIds!.push(item);
            }
            else {
                this.recipientRoleIds = null as any;
            }
            if (Array.isArray(_data["recipientTagIds"])) {
                this.recipientTagIds = [] as any;
                for (let item of _data["recipientTagIds"])
                    this.recipientTagIds!.push(item);
            }
            else {
                this.recipientTagIds = null as any;
            }
            if (Array.isArray(_data["recipientProductIds"])) {
                this.recipientProductIds = [] as any;
                for (let item of _data["recipientProductIds"])
                    this.recipientProductIds!.push(item);
            }
            else {
                this.recipientProductIds = null as any;
            }
        }
    }

    static fromJS(data: any): UpdateTemplateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTemplateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["subject"] = this.subject !== undefined ? this.subject : null as any;
        data["body"] = this.body !== undefined ? this.body : null as any;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null as any;
        if (Array.isArray(this.recipientAccountIds)) {
            data["recipientAccountIds"] = [];
            for (let item of this.recipientAccountIds)
                data["recipientAccountIds"].push(item);
        }
        if (Array.isArray(this.recipientFieldGroupTypeIds)) {
            data["recipientFieldGroupTypeIds"] = [];
            for (let item of this.recipientFieldGroupTypeIds)
                data["recipientFieldGroupTypeIds"].push(item);
        }
        if (Array.isArray(this.recipientRoleIds)) {
            data["recipientRoleIds"] = [];
            for (let item of this.recipientRoleIds)
                data["recipientRoleIds"].push(item);
        }
        if (Array.isArray(this.recipientTagIds)) {
            data["recipientTagIds"] = [];
            for (let item of this.recipientTagIds)
                data["recipientTagIds"].push(item);
        }
        if (Array.isArray(this.recipientProductIds)) {
            data["recipientProductIds"] = [];
            for (let item of this.recipientProductIds)
                data["recipientProductIds"].push(item);
        }
        return data;
    }

    clone(): UpdateTemplateViewModel {
        const json = this.toJSON();
        let result = new UpdateTemplateViewModel();
        result.init(json);
        return result;
    }
}

export interface IUpdateTemplateViewModel {
    name?: string | null;
    subject?: string | null;
    body?: string | null;
    categoryId?: number | null;
    recipientAccountIds?: number[] | null;
    recipientFieldGroupTypeIds?: number[] | null;
    recipientRoleIds?: number[] | null;
    recipientTagIds?: number[] | null;
    recipientProductIds?: number[] | null;
}

export class LimitedResultOfUserAuditLogChangeViewModel implements ILimitedResultOfUserAuditLogChangeViewModel {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: UserAuditLogChangeViewModel[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfUserAuditLogChangeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(UserAuditLogChangeViewModel.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfUserAuditLogChangeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfUserAuditLogChangeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfUserAuditLogChangeViewModel {
        const json = this.toJSON();
        let result = new LimitedResultOfUserAuditLogChangeViewModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfUserAuditLogChangeViewModel {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: UserAuditLogChangeViewModel[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class UserAuditLogChangeViewModel implements IUserAuditLogChangeViewModel {
    employeeNumber?: string | null;
    email?: string | null;
    account?: string | null;
    updatedDate?: moment.Moment | null;
    differences?: Difference[] | null;
    changeSource?: string | null;
    userIpMakingChange?: string | null;
    changeEventNote?: string | null;

    constructor(data?: IUserAuditLogChangeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeNumber = _data["employeeNumber"] !== undefined ? _data["employeeNumber"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.account = _data["account"] !== undefined ? _data["account"] : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
            if (Array.isArray(_data["differences"])) {
                this.differences = [] as any;
                for (let item of _data["differences"])
                    this.differences!.push(Difference.fromJS(item));
            }
            else {
                this.differences = null as any;
            }
            this.changeSource = _data["changeSource"] !== undefined ? _data["changeSource"] : null as any;
            this.userIpMakingChange = _data["userIpMakingChange"] !== undefined ? _data["userIpMakingChange"] : null as any;
            this.changeEventNote = _data["changeEventNote"] !== undefined ? _data["changeEventNote"] : null as any;
        }
    }

    static fromJS(data: any): UserAuditLogChangeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserAuditLogChangeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeNumber"] = this.employeeNumber !== undefined ? this.employeeNumber : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["account"] = this.account !== undefined ? this.account : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        if (Array.isArray(this.differences)) {
            data["differences"] = [];
            for (let item of this.differences)
                data["differences"].push(item ? item.toJSON() : null as any);
        }
        data["changeSource"] = this.changeSource !== undefined ? this.changeSource : null as any;
        data["userIpMakingChange"] = this.userIpMakingChange !== undefined ? this.userIpMakingChange : null as any;
        data["changeEventNote"] = this.changeEventNote !== undefined ? this.changeEventNote : null as any;
        return data;
    }

    clone(): UserAuditLogChangeViewModel {
        const json = this.toJSON();
        let result = new UserAuditLogChangeViewModel();
        result.init(json);
        return result;
    }
}

export interface IUserAuditLogChangeViewModel {
    employeeNumber?: string | null;
    email?: string | null;
    account?: string | null;
    updatedDate?: moment.Moment | null;
    differences?: Difference[] | null;
    changeSource?: string | null;
    userIpMakingChange?: string | null;
    changeEventNote?: string | null;
}

export class Difference implements IDifference {
    field?: string | null;
    oldValue?: string | null;
    newValue?: string | null;

    constructor(data?: IDifference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"] !== undefined ? _data["field"] : null as any;
            this.oldValue = _data["oldValue"] !== undefined ? _data["oldValue"] : null as any;
            this.newValue = _data["newValue"] !== undefined ? _data["newValue"] : null as any;
        }
    }

    static fromJS(data: any): Difference {
        data = typeof data === 'object' ? data : {};
        let result = new Difference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field !== undefined ? this.field : null as any;
        data["oldValue"] = this.oldValue !== undefined ? this.oldValue : null as any;
        data["newValue"] = this.newValue !== undefined ? this.newValue : null as any;
        return data;
    }

    clone(): Difference {
        const json = this.toJSON();
        let result = new Difference();
        result.init(json);
        return result;
    }
}

export interface IDifference {
    field?: string | null;
    oldValue?: string | null;
    newValue?: string | null;
}

export class AssemblerPriorityViewModel implements IAssemblerPriorityViewModel {
    supplierName?: string | null;
    contactName?: string | null;
    contactNumber?: string | null;
    contactEmail?: string | null;
    priority?: number | null;
    prices?: AssemblerPriceViewModel[] | null;
    banner?: AssemblerPriorityViewModelBanner | null;

    constructor(data?: IAssemblerPriorityViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierName = _data["supplierName"] !== undefined ? _data["supplierName"] : null as any;
            this.contactName = _data["contactName"] !== undefined ? _data["contactName"] : null as any;
            this.contactNumber = _data["contactNumber"] !== undefined ? _data["contactNumber"] : null as any;
            this.contactEmail = _data["contactEmail"] !== undefined ? _data["contactEmail"] : null as any;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : null as any;
            if (Array.isArray(_data["prices"])) {
                this.prices = [] as any;
                for (let item of _data["prices"])
                    this.prices!.push(AssemblerPriceViewModel.fromJS(item));
            }
            else {
                this.prices = null as any;
            }
            this.banner = _data["banner"] ? AssemblerPriorityViewModelBanner.fromJS(_data["banner"]) : null as any;
        }
    }

    static fromJS(data: any): AssemblerPriorityViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssemblerPriorityViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierName"] = this.supplierName !== undefined ? this.supplierName : null as any;
        data["contactName"] = this.contactName !== undefined ? this.contactName : null as any;
        data["contactNumber"] = this.contactNumber !== undefined ? this.contactNumber : null as any;
        data["contactEmail"] = this.contactEmail !== undefined ? this.contactEmail : null as any;
        data["priority"] = this.priority !== undefined ? this.priority : null as any;
        if (Array.isArray(this.prices)) {
            data["prices"] = [];
            for (let item of this.prices)
                data["prices"].push(item ? item.toJSON() : null as any);
        }
        data["banner"] = this.banner ? this.banner.toJSON() : null as any;
        return data;
    }

    clone(): AssemblerPriorityViewModel {
        const json = this.toJSON();
        let result = new AssemblerPriorityViewModel();
        result.init(json);
        return result;
    }
}

export interface IAssemblerPriorityViewModel {
    supplierName?: string | null;
    contactName?: string | null;
    contactNumber?: string | null;
    contactEmail?: string | null;
    priority?: number | null;
    prices?: AssemblerPriceViewModel[] | null;
    banner?: AssemblerPriorityViewModelBanner | null;
}

export class AssemblerPriceViewModel implements IAssemblerPriceViewModel {
    name?: string | null;
    price?: number | null;

    constructor(data?: IAssemblerPriceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.price = _data["price"] !== undefined ? _data["price"] : null as any;
        }
    }

    static fromJS(data: any): AssemblerPriceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssemblerPriceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["price"] = this.price !== undefined ? this.price : null as any;
        return data;
    }

    clone(): AssemblerPriceViewModel {
        const json = this.toJSON();
        let result = new AssemblerPriceViewModel();
        result.init(json);
        return result;
    }
}

export interface IAssemblerPriceViewModel {
    name?: string | null;
    price?: number | null;
}

export class AssemblerPriorityViewModelBanner implements IAssemblerPriorityViewModelBanner {
    id?: number;
    name?: string | null;

    constructor(data?: IAssemblerPriorityViewModelBanner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): AssemblerPriorityViewModelBanner {
        data = typeof data === 'object' ? data : {};
        let result = new AssemblerPriorityViewModelBanner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }

    clone(): AssemblerPriorityViewModelBanner {
        const json = this.toJSON();
        let result = new AssemblerPriorityViewModelBanner();
        result.init(json);
        return result;
    }
}

export interface IAssemblerPriorityViewModelBanner {
    id?: number;
    name?: string | null;
}

export class AppLicensingModel implements IAppLicensingModel {
    appLicensingId?: number;
    accountId?: number;
    appId?: number;
    appName?: string | null;
    appNote?: string | null;
    statusId?: number;
    statusName?: string | null;
    licenseCount?: number;
    updateDate?: moment.Moment;
    updatedBy?: number | null;

    constructor(data?: IAppLicensingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appLicensingId = _data["appLicensingId"] !== undefined ? _data["appLicensingId"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.appId = _data["appId"] !== undefined ? _data["appId"] : null as any;
            this.appName = _data["appName"] !== undefined ? _data["appName"] : null as any;
            this.appNote = _data["appNote"] !== undefined ? _data["appNote"] : null as any;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            this.statusName = _data["statusName"] !== undefined ? _data["statusName"] : null as any;
            this.licenseCount = _data["licenseCount"] !== undefined ? _data["licenseCount"] : null as any;
            this.updateDate = _data["updateDate"] ? moment(_data["updateDate"].toString()) : null as any;
            this.updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : null as any;
        }
    }

    static fromJS(data: any): AppLicensingModel {
        data = typeof data === 'object' ? data : {};
        let result = new AppLicensingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appLicensingId"] = this.appLicensingId !== undefined ? this.appLicensingId : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["appId"] = this.appId !== undefined ? this.appId : null as any;
        data["appName"] = this.appName !== undefined ? this.appName : null as any;
        data["appNote"] = this.appNote !== undefined ? this.appNote : null as any;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        data["statusName"] = this.statusName !== undefined ? this.statusName : null as any;
        data["licenseCount"] = this.licenseCount !== undefined ? this.licenseCount : null as any;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : null as any;
        data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : null as any;
        return data;
    }

    clone(): AppLicensingModel {
        const json = this.toJSON();
        let result = new AppLicensingModel();
        result.init(json);
        return result;
    }
}

export interface IAppLicensingModel {
    appLicensingId?: number;
    accountId?: number;
    appId?: number;
    appName?: string | null;
    appNote?: string | null;
    statusId?: number;
    statusName?: string | null;
    licenseCount?: number;
    updateDate?: moment.Moment;
    updatedBy?: number | null;
}

export class AppModel implements IAppModel {
    appId?: number;
    appName?: string | null;
    appNote?: string | null;
    appImageURL?: string | null;
    statusId?: number;
    statusName?: string | null;
    parentAppIds?: number[] | null;

    constructor(data?: IAppModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appId = _data["appId"] !== undefined ? _data["appId"] : null as any;
            this.appName = _data["appName"] !== undefined ? _data["appName"] : null as any;
            this.appNote = _data["appNote"] !== undefined ? _data["appNote"] : null as any;
            this.appImageURL = _data["appImageURL"] !== undefined ? _data["appImageURL"] : null as any;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null as any;
            this.statusName = _data["statusName"] !== undefined ? _data["statusName"] : null as any;
            if (Array.isArray(_data["parentAppIds"])) {
                this.parentAppIds = [] as any;
                for (let item of _data["parentAppIds"])
                    this.parentAppIds!.push(item);
            }
            else {
                this.parentAppIds = null as any;
            }
        }
    }

    static fromJS(data: any): AppModel {
        data = typeof data === 'object' ? data : {};
        let result = new AppModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId !== undefined ? this.appId : null as any;
        data["appName"] = this.appName !== undefined ? this.appName : null as any;
        data["appNote"] = this.appNote !== undefined ? this.appNote : null as any;
        data["appImageURL"] = this.appImageURL !== undefined ? this.appImageURL : null as any;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null as any;
        data["statusName"] = this.statusName !== undefined ? this.statusName : null as any;
        if (Array.isArray(this.parentAppIds)) {
            data["parentAppIds"] = [];
            for (let item of this.parentAppIds)
                data["parentAppIds"].push(item);
        }
        return data;
    }

    clone(): AppModel {
        const json = this.toJSON();
        let result = new AppModel();
        result.init(json);
        return result;
    }
}

export interface IAppModel {
    appId?: number;
    appName?: string | null;
    appNote?: string | null;
    appImageURL?: string | null;
    statusId?: number;
    statusName?: string | null;
    parentAppIds?: number[] | null;
}

export class LimitedResultOfActionLogsViewModel implements ILimitedResultOfActionLogsViewModel {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: ActionLogsViewModel[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfActionLogsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ActionLogsViewModel.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfActionLogsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfActionLogsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfActionLogsViewModel {
        const json = this.toJSON();
        let result = new LimitedResultOfActionLogsViewModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfActionLogsViewModel {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: ActionLogsViewModel[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class GenericTableReportOfActionLogsViewModel extends LimitedResultOfActionLogsViewModel implements IGenericTableReportOfActionLogsViewModel {
    /** Columns in the data-grid */
    columnList!: GenericTableReportColumns[];

    constructor(data?: IGenericTableReportOfActionLogsViewModel) {
        super(data);
        if (!data) {
            this.columnList = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["columnList"])) {
                this.columnList = [] as any;
                for (let item of _data["columnList"])
                    this.columnList!.push(GenericTableReportColumns.fromJS(item));
            }
            else {
                this.columnList = null as any;
            }
        }
    }

    static override fromJS(data: any): GenericTableReportOfActionLogsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GenericTableReportOfActionLogsViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columnList)) {
            data["columnList"] = [];
            for (let item of this.columnList)
                data["columnList"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): GenericTableReportOfActionLogsViewModel {
        const json = this.toJSON();
        let result = new GenericTableReportOfActionLogsViewModel();
        result.init(json);
        return result;
    }
}

export interface IGenericTableReportOfActionLogsViewModel extends ILimitedResultOfActionLogsViewModel {
    /** Columns in the data-grid */
    columnList: GenericTableReportColumns[];
}

export class ServiceLogReportOfActionLogsViewModel extends GenericTableReportOfActionLogsViewModel implements IServiceLogReportOfActionLogsViewModel {

    constructor(data?: IServiceLogReportOfActionLogsViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ServiceLogReportOfActionLogsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceLogReportOfActionLogsViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ServiceLogReportOfActionLogsViewModel {
        const json = this.toJSON();
        let result = new ServiceLogReportOfActionLogsViewModel();
        result.init(json);
        return result;
    }
}

export interface IServiceLogReportOfActionLogsViewModel extends IGenericTableReportOfActionLogsViewModel {
}

export class ActionLogsViewModel implements IActionLogsViewModel {
    accountId?: number;
    aname?: string | null;
    transactionId?: string | null;
    referenceNumber!: string;
    status!: ImportStatus;
    type?: ActionLogType;
    message?: string | null;
    started?: moment.Moment;
    completed?: moment.Moment;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment;

    constructor(data?: IActionLogsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.aname = _data["aname"] !== undefined ? _data["aname"] : null as any;
            this.transactionId = _data["transactionId"] !== undefined ? _data["transactionId"] : null as any;
            this.referenceNumber = _data["referenceNumber"] !== undefined ? _data["referenceNumber"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
            this.started = _data["started"] ? moment(_data["started"].toString()) : null as any;
            this.completed = _data["completed"] ? moment(_data["completed"].toString()) : null as any;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ActionLogsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActionLogsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["aname"] = this.aname !== undefined ? this.aname : null as any;
        data["transactionId"] = this.transactionId !== undefined ? this.transactionId : null as any;
        data["referenceNumber"] = this.referenceNumber !== undefined ? this.referenceNumber : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        data["started"] = this.started ? this.started.toISOString() : null as any;
        data["completed"] = this.completed ? this.completed.toISOString() : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        return data;
    }

    clone(): ActionLogsViewModel {
        const json = this.toJSON();
        let result = new ActionLogsViewModel();
        result.init(json);
        return result;
    }
}

export interface IActionLogsViewModel {
    accountId?: number;
    aname?: string | null;
    transactionId?: string | null;
    referenceNumber: string;
    status: ImportStatus;
    type?: ActionLogType;
    message?: string | null;
    started?: moment.Moment;
    completed?: moment.Moment;
    createdDate?: moment.Moment;
    updatedDate?: moment.Moment;
}

export class AccountActivityModel implements IAccountActivityModel {
    id?: number;
    accountId?: number | null;
    accountName?: string | null;
    activityId?: number | null;
    activityName?: string | null;
    createdByEmail?: string | null;
    dueDatePerformance?: boolean | null;
    activityStatus?: string | null;
    scheduleImportancePriority?: ScheduleImportant | null;
    updatedDate?: moment.Moment | null;

    constructor(data?: IAccountActivityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            this.activityId = _data["activityId"] !== undefined ? _data["activityId"] : null as any;
            this.activityName = _data["activityName"] !== undefined ? _data["activityName"] : null as any;
            this.createdByEmail = _data["createdByEmail"] !== undefined ? _data["createdByEmail"] : null as any;
            this.dueDatePerformance = _data["dueDatePerformance"] !== undefined ? _data["dueDatePerformance"] : null as any;
            this.activityStatus = _data["activityStatus"] !== undefined ? _data["activityStatus"] : null as any;
            this.scheduleImportancePriority = _data["scheduleImportancePriority"] !== undefined ? _data["scheduleImportancePriority"] : null as any;
            this.updatedDate = _data["updatedDate"] ? moment(_data["updatedDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): AccountActivityModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountActivityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["activityId"] = this.activityId !== undefined ? this.activityId : null as any;
        data["activityName"] = this.activityName !== undefined ? this.activityName : null as any;
        data["createdByEmail"] = this.createdByEmail !== undefined ? this.createdByEmail : null as any;
        data["dueDatePerformance"] = this.dueDatePerformance !== undefined ? this.dueDatePerformance : null as any;
        data["activityStatus"] = this.activityStatus !== undefined ? this.activityStatus : null as any;
        data["scheduleImportancePriority"] = this.scheduleImportancePriority !== undefined ? this.scheduleImportancePriority : null as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null as any;
        return data;
    }

    clone(): AccountActivityModel {
        const json = this.toJSON();
        let result = new AccountActivityModel();
        result.init(json);
        return result;
    }
}

export interface IAccountActivityModel {
    id?: number;
    accountId?: number | null;
    accountName?: string | null;
    activityId?: number | null;
    activityName?: string | null;
    createdByEmail?: string | null;
    dueDatePerformance?: boolean | null;
    activityStatus?: string | null;
    scheduleImportancePriority?: ScheduleImportant | null;
    updatedDate?: moment.Moment | null;
}

export class LimitedResultOfAccountActivityModel implements ILimitedResultOfAccountActivityModel {
    /** Total number of records in query */
    totalCount!: number;
    /** Collection of results */
    results!: AccountActivityModel[];
    /** The number of records skipped */
    offset!: number;
    /** Number of records returned */
    limit!: number;
    /** Column name to sort by */
    sortBy!: string;
    /** Ascending or descending sort */
    sortAscending!: boolean;

    constructor(data?: ILimitedResultOfAccountActivityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AccountActivityModel.fromJS(item));
            }
            else {
                this.results = null as any;
            }
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): LimitedResultOfAccountActivityModel {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedResultOfAccountActivityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): LimitedResultOfAccountActivityModel {
        const json = this.toJSON();
        let result = new LimitedResultOfAccountActivityModel();
        result.init(json);
        return result;
    }
}

export interface ILimitedResultOfAccountActivityModel {
    /** Total number of records in query */
    totalCount: number;
    /** Collection of results */
    results: AccountActivityModel[];
    /** The number of records skipped */
    offset: number;
    /** Number of records returned */
    limit: number;
    /** Column name to sort by */
    sortBy: string;
    /** Ascending or descending sort */
    sortAscending: boolean;
}

export class AccountActivityFilterParams implements IAccountActivityFilterParams {
    activityId?: number | null;
    offset?: number | null;
    limit?: number | null;
    sortBy?: string | null;
    sortAscending?: boolean;

    constructor(data?: IAccountActivityFilterParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data["activityId"] !== undefined ? _data["activityId"] : null as any;
            this.offset = _data["offset"] !== undefined ? _data["offset"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
            this.sortBy = _data["sortBy"] !== undefined ? _data["sortBy"] : null as any;
            this.sortAscending = _data["sortAscending"] !== undefined ? _data["sortAscending"] : null as any;
        }
    }

    static fromJS(data: any): AccountActivityFilterParams {
        data = typeof data === 'object' ? data : {};
        let result = new AccountActivityFilterParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId !== undefined ? this.activityId : null as any;
        data["offset"] = this.offset !== undefined ? this.offset : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        data["sortBy"] = this.sortBy !== undefined ? this.sortBy : null as any;
        data["sortAscending"] = this.sortAscending !== undefined ? this.sortAscending : null as any;
        return data;
    }

    clone(): AccountActivityFilterParams {
        const json = this.toJSON();
        let result = new AccountActivityFilterParams();
        result.init(json);
        return result;
    }
}

export interface IAccountActivityFilterParams {
    activityId?: number | null;
    offset?: number | null;
    limit?: number | null;
    sortBy?: string | null;
    sortAscending?: boolean;
}

export class AccountActivityViewModel implements IAccountActivityViewModel {
    accountName?: string | null;
    activity?: string[] | null;

    constructor(data?: IAccountActivityViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : null as any;
            if (Array.isArray(_data["activity"])) {
                this.activity = [] as any;
                for (let item of _data["activity"])
                    this.activity!.push(item);
            }
            else {
                this.activity = null as any;
            }
        }
    }

    static fromJS(data: any): AccountActivityViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountActivityViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        if (Array.isArray(this.activity)) {
            data["activity"] = [];
            for (let item of this.activity)
                data["activity"].push(item);
        }
        return data;
    }

    clone(): AccountActivityViewModel {
        const json = this.toJSON();
        let result = new AccountActivityViewModel();
        result.init(json);
        return result;
    }
}

export interface IAccountActivityViewModel {
    accountName?: string | null;
    activity?: string[] | null;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}